/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 85);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(116);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validateFields */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getImgUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return limitText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return compareDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return shuffle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return geinstagramData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncgetWeather; });
/* unused harmony export getWeather */
/* unused harmony export foundInString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBrowser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isMobile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_detect_browser__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_detect_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_detect_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Validator_Validator__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Axios_Axios__ = __webpack_require__(223);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var validateFields=function validateFields(fields){var errors=[];var v=new __WEBPACK_IMPORTED_MODULE_3__Validator_Validator__["a" /* default */]();for(var i in fields){var currentField=fields[i];var validationType=currentField.validationType;var res=null;if(validationType==="simple"){res=v.simpleValidation({val:currentField.val,err_1:currentField.err_1});}else if(validationType==="email"){res=v.regx_validation({val:currentField.val,err_1:currentField.err_1,err_2:currentField.err_2,expression:/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/});}else if(validationType==="phone"){res=v.regx_validation({val:currentField.val,err_1:currentField.err_1,err_2:currentField.err_2,expression:/^[0-9]{9,11}$/});}else if(validationType==="number"){res=v.regx_validation({val:currentField.val,err_1:currentField.err_1,err_2:currentField.err_2,expression:/^[0-9]+$/});}else if(validationType==="licence"){res=v.regx_validation({val:currentField.val,err_1:currentField.err_1,err_2:currentField.err_2,expression:/^[0-9]+(-?[0-9]+)+$/});}if(res!==true){errors.push("err");currentField.cssClass=currentField.cssClass+" err-border ";}else{currentField.cssClass=currentField.cssClass+"succses-border";}}// check to  see if error acourd
if(errors.length===0){return true;}else{return false;}};var getUrl=function getUrl(){var host=window.location.host;var protocol=window.location.protocol;// const url = protocol + "//" + host   + '/';
var url=protocol+"//"+host;// const url = protocol + "//" + host   + '/go-israel-new/';
// .TwoCitiesOneBreak
// const url = protocol + "//" + host   ;
console.log(url);return url;};var getImgUrl=function getImgUrl(){var url='https://es.goisrael.com/assets/img/';return url;};var limitText=function limitText(string){var length=arguments.length>1&&arguments[1]!==undefined?arguments[1]:40;var trimmedString=string.substring(0,length);var dots="";if(string.length>length){dots="";}return trimmedString+""+dots;};var compareDates=function compareDates(date1,date2){var patt=new RegExp(/[0-9]{1,2}-[0-9]{2}./);var res=patt.test(date2);var enDateFormat=[];if(res===true){var dateToArr=date2.split('.');// console.log(dateToArr);
var days=dateToArr[0];var daysToArr=days.split("-");var lastDay=daysToArr[1];dateToArr.shift();// remove first arr cell
dateToArr.unshift(lastDay);// add first arr cell
enDateFormat[0]=dateToArr[1];enDateFormat[1]=dateToArr[0];enDateFormat[2]=dateToArr[2];var newDate=enDateFormat.join('.');var date2=new Date(newDate);// console.log(' newDate ', newDate);
}else{var dateToArr=date2.split('.');enDateFormat[0]=dateToArr[1];enDateFormat[1]=dateToArr[0];enDateFormat[2]=dateToArr[2];var newDate=enDateFormat.join('.');// console.log(' newDate ', newDate);
var date2=new Date(newDate);}var d1=date1.getTime();var d1FullDate=date1.getDate()+"."+(date1.getMonth()+1)+"."+date1.getFullYear();var d2=date2.getTime();var d2FullDate=date2.getDate()+"."+(date2.getMonth()+1)+"."+date2.getFullYear();var isTodayBigger=d1>d2;if(d1FullDate===d2FullDate){isTodayBigger=false;}return isTodayBigger;};var shuffle=function shuffle(){var o=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];for(var j,x,i=o.length;i;j=parseInt(Math.random()*i),x=o[--i],o[i]=o[j],o[j]=x){}return o;};// Prod
var geinstagramData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(callback){var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_5__Axios_Axios__["a" /* default */].get("https://goisrael.com/assets/insta-images.php");case 2:res=_context.sent;return _context.abrupt('return',res.data);case 4:case'end':return _context.stop();}}},_callee,_this);}));return function geinstagramData(_x3){return _ref.apply(this,arguments);};}();var asyncgetWeather=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var weatherData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_5__Axios_Axios__["a" /* default */].get("https://goisrael.com/weather.php",{params:{method:"get_weather"}});case 2:weatherData=_context2.sent;// console.log('WEATHER:', typeof weatherData); // object
console.log('WEATHER:',_typeof(weatherData.data));// 
// return weatherData.data;
return _context2.abrupt('return',weatherData.data);case 5:case'end':return _context2.stop();}}},_callee2,_this);}));return function asyncgetWeather(){return _ref2.apply(this,arguments);};}();// Local 
// export const geinstagramData=  async callback => {
// 	const res 	= await  Http.get("https://view.activated.co.il/twocities/de/assets/insta-images.php");
// 	console.log('res' , res);
// 	return res.data;
// }
// export const asyncgetWeather = async  () => {
// 	const weatherData 	= await Http.get("https://view.activated.co.il/twocities/de/weather.php" , {params : {method: "get_weather"}});
// 	return weatherData.data;
// } 
// to do make  this async await 
var getWeather=function getWeather(callback){__WEBPACK_IMPORTED_MODULE_5__Axios_Axios__["a" /* default */].get("https://goisrael.com/weather.php",{params:{method:"get_weather",city:"deadsea"}}).then(function(res){var deadSeaWeather=res.data.temperature;__WEBPACK_IMPORTED_MODULE_5__Axios_Axios__["a" /* default */].get("https://goisrael.com/weather.php",{params:{method:"get_weather",city:"jerusalem"}}).then(function(res){var jerusalemWeather=res.data.temperature;var water_temp=res.data.water_temp;__WEBPACK_IMPORTED_MODULE_5__Axios_Axios__["a" /* default */].get("https://goisrael.com/weather.php",{params:{method:"get_weather",city:"Tel Aviv"}}).then(function(res){var telAvivWeather=res.data.temperature;var o={jerusalemWeather:jerusalemWeather,water_temp:water_temp,telAvivWeather:telAvivWeather,deadSeaWeather:deadSeaWeather};callback(o);});});});};// export const geinstagramData= callback => {
// 	Http.get("https://en.citiesbreak.com/assets/insta-images.php")
//     .then(res => {
//     	callback(res);
//     	// return res;        
//     });
// }
var foundInString=function foundInString(text,match){return new RegExp(match).test(text);};var getBrowser=function getBrowser(){var browser=Object(__WEBPACK_IMPORTED_MODULE_2_detect_browser__["detect"])();// handle the case where we don't detect the browser
if(!browser){browser.name='centDetectBrowser';browser.version='0';}return browser;};var isMobile=function isMobile(){var isMobile=false;var windowW=window.innerWidth;if(windowW<1000){isMobile=true;}return isMobile;};

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Input */
/* unused harmony export Select */
/* unused harmony export TopPart */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Img; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return Logo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HomeTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return WeatherIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ResponsiveYouTubeIframe; });
/* unused harmony export VideoSliderItem2 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return VideoSliderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ConcertSliderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PostSliderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return InstagremSliderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GallerSideBarItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ImgAndText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FaqItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CoverSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HomeDeals; });
/* unused harmony export Picture */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HomeSlider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AnimateCallToAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivaImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return TravelAlert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Deals_Deals__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_youtube__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utility_GDPRWrapper__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UI_css__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UI_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__UI_css__);
var Input=function Input(props){var name=props.name;var labelProp=props.label;var cssWrapperClass='form-input-wrapper input-'+name+'-wrapper '+props.inputCssClass;var cssInputClass=' input-'+name+' ';var labelField='';var id="ac-input-"+new Date().getTime();if(labelProp!==undefined){cssWrapperClass+=' inputHasLabel ';labelField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},' ',props.label,' ');}var html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssWrapperClass},labelField,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:id,'data-validation-type':props.validationType,onClick:props.click,onChange:props.change,type:props.type,name:name,className:cssInputClass,placeholder:props.placeholder,value:props.val}));if(props.type==="hidden"){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:props.type,name:name,className:cssInputClass,placeholder:props.placeholder,value:props.val});}return html;};var Select=function Select(props){var name=props.name;var cssWrapperClass='form-input-wrapper input-'+name+'-wrapper select-'+name+'-wrapper'+props.cssClass;var cssInputClass='select-'+name+' ';var labelProp=props.label;var labelField='';var id="ac-input-"+new Date().getTime();if(labelProp!==undefined){cssWrapperClass+=' inputHasLabel ';labelField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},' ',props.label,' ');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssWrapperClass},labelField,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:props.change,name:props.name,className:cssInputClass},props.children,';'));};var TopPart=function TopPart(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'App-header alignCenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'App-title'},props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.text)));};var Img=function Img(props){var windowW=window.innerWidth;var desktopImg=props.desktopImg?Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["e" /* getImgUrl */])()+""+props.desktopImg:"";var mobileImg=props.mobileImg?Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["e" /* getImgUrl */])()+""+props.mobileImg:"";var html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:desktopImg,alt:''}));if(props.mobileImg!=undefined){if(windowW<1000){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'show-on-mobile',src:mobileImg,alt:''}));}}return html;};var Btn=function Btn(props){var cssClass=props.cssClass?'ac-btn '+props.cssClass:props.cssClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:cssClass,onClick:props.onClick},props.children);};var Logo=function Logo(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logoWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"logo.png"}));};var HomeTitle=function HomeTitle(props){var cssClass='home-title-wrapper '+props.cssClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,props.children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-border'}));};var WeatherIcon=function WeatherIcon(props){var p=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.temp,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'o'),'C');var imgPath="WeatherIcon.png";var weatherClass='weather-icon-wrapper';if(props.temp==="5H30"){p=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.temp);imgPath="WeatherIcon2.png";weatherClass='weather-icon-wrapper flight-icon-wrapper';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:weatherClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:imgPath}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.label),p);};var ResponsiveYouTubeIframe=function ResponsiveYouTubeIframe(props){// const videoSrc = 'https://www.youtube.com/embed/'+props.vidId+'/?autoplay=1&mute=1&rel=0&loop=1&playlist=' + props.vidId;
var youTubeOptions={playerVars:{// https://developers.google.com/youtube/player_parameters
autoplay:1,muted:1,controls:1,loopPlaylists:true,loop:1,playlist:props.vidId,// sandbox: "allow-same-origin allow-popups",
origin:window.location.origin// host: "https://www.youtube.com",
}};// console.log('window.location.origin:', window.location.origin);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Utility_GDPRWrapper__["a" /* GDPRWrapper */],{group:'group_2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'responisve-iframe'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_youtube__["a" /* default */],{videoId:props.vidId,opts:youTubeOptions,onReady:function onReady(event){event.target.mute();event.target.playVideo();}})));};var VideoSliderItem2=function VideoSliderItem2(props){var youTubeOptions={playerVars:{// https://developers.google.com/youtube/player_parameters
autoplay:1,muted:1,// host: "https://www.youtube.com",
// sandbox: "allow-same-origin allow-popups",
origin:window.location.origin}};var desc=props.desc!=undefined?props.desc:"";var doBlank=props.doBlank!=undefined?props.doBlank:"";var title=props.title!=undefined?Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* limitText */])(props.title,30):"";var mobileId=props.mobileId!=''?props.mobileId:"";var cssClass='cites-slider video-slider-item '+props.cssClass;// console.log('props.mobileId' , props.mobileId);
// alert(mobileId);
var target='';if(doBlank){target='_blank';}var html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,target:target,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-play-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"Videos/play.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* limitText */])(desc))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrappr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link,target:target},'LEE M\xC1S ','>>'))));if(Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["g" /* isMobile */])()){// console.log('mobileId' , mobileId);
var ht=null;if(mobileId!=""){ht=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-make-vid-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Utility_GDPRWrapper__["a" /* GDPRWrapper */],{group:'group_2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_youtube__["a" /* default */],{videoId:mobileId,opts:youTubeOptions,onReady:function onReady(event){event.target.mute();event.target.playVideo();}})));}else{ht=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-play-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"Videos/play.png"})));}// alert('s');
html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-img-wrapper',onClick:props.clickMobile},ht),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* limitText */])(desc))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrappr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link,target:target},'LEE M\xC1S ','>>'))));}return html;};var VideoSliderItem=function VideoSliderItem(props){var desc=props.desc!=undefined?props.desc:"";var cssClass='cites-slider video-slider-item '+props.cssClass;var doBlank=props.doBlank!=undefined?props.doBlank:"";var target='';if(doBlank){target='_blank';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,target:target,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-play-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"Videos/play.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link,target:target},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* limitText */])(props.title,50)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* limitText */])(desc))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrappr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link,target:target},'LEE M\xC1S ','>>'))));};var ConcertSliderItem=function ConcertSliderItem(props){var desc=props.desc;var cssClass='cites-slider concert-slider-item '+props.cssClass;if(props.isTodayBigger===true){cssClass+=' ac-disabled addOpacity ';}var doBlank=props.doBlank!=undefined?props.doBlank:"";var target='';if(doBlank){target='_blank';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,target:target,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'concert-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* limitText */])(props.desc))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrappr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link},'LEE M\xC1S ','>>')));};var PostSliderItem=function PostSliderItem(props){var desc=props.desc!=undefined?props.desc:"";var cssClass='cites-slider concert-slider-item'+props.cssClass;var doBlank=props.doBlank!=undefined?props.doBlank:"";var target='';if(doBlank){target='_blank';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,target:target,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'concert-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* limitText */])(desc))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrappr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link},'LEE M\xC1S ','>>')));};var InstagremSliderItem=function InstagremSliderItem(props){var desc=props.desc;var cssEClass=props.cssClass!==undefined?props.cssClass:'';var cssClass='cites-slider concert-slider-item '+cssEClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insta-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insta-icon-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"insta-icon.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'@',props.title)));};var GallerSideBarItem=function GallerSideBarItem(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cites-slider gallery-slider-item align-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.title)));};var ImgAndText=function ImgAndText(props){var cssClass='box col col-50 '+props.cssClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{target:'blank',to:props.link,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img,mobileImg:props.img_mob}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.text)))));};var FaqItem=function FaqItem(props){var cssClass="faq-answer close";var cssClass2="icon-wrapper closeIcon";if(props.isOpen===true){cssClass="faq-answer open";cssClass2="icon-wrapper openIcon";}var ht=props.answer;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faq-q-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faq-q',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.q),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"collpase-icon.jpg"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,dangerouslySetInnerHTML:{__html:ht}}));};var CoverSection=function CoverSection(props){var desktopImg=props.desktopImg;var mobileImg=props.mobileImg;var cssClass=props.cssClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:"ac-cover-section ac-cover-section-"+props.cssClass,id:'part-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.desktopImg,mobileImg:props.mobileImg}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'weather-wrapper show-on-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"WATER TEMP",temp:props.waterTemp}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"TEL AVIV",temp:props.telAvivWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"JERUSALEM",temp:props.jerusalemWeather})));};var HomeDeals=function HomeDeals(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'home-section caruasel-wrapper  home-section-padding',id:'deals'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HomeTitle,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/Pages/bestDeals',className:'ac-book-holiday'},'  BOOK YOUR HOLIDAY NOW ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Deals_Deals__["a" /* default */],null)));};var Picture=function Picture(props){var windowW=window.innerWidth;var desktopImg=props.desktopImg?Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["e" /* getImgUrl */])()+""+props.desktopImg:"";var mobileImg=props.mobileImg?Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["e" /* getImgUrl */])()+""+props.mobileImg:"";var webpImg=props.webpImg?Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["e" /* getImgUrl */])()+""+props.webpImg:"";var webpMobileImg=props.webpMobileImg?Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["e" /* getImgUrl */])()+""+props.webpMobileImg:"";var html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('picture',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:desktopImg,alt:''}));if(props.webpImg!=undefined){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('picture',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{type:'image/webp',srcSet:webpImg}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:desktopImg,alt:''}));}if(props.mobileImg!=undefined){if(windowW<1000){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('picture',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:mobileImg,alt:'',className:'show-on-mobile'})));}if(props.webpMobileImg!=undefined){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('picture',{className:'show-on-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{type:'image/webp',srcSet:webpMobileImg}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:mobileImg,alt:''}));}}return html;};var HomeSlider=function HomeSlider(props){var bannerSliderSettings={dots:false,infinite:true,fade:true,cssEase:'linear',autoplay:true,lazyLoad:"ondemand",slidesToShow:1,slidesToScroll:1};var html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:bannerSliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"HomeSlider/3.jpg",mobileImg:"HomeSlider/M/3.jpg"})));var isHomeSlider=props.isHomeSlider!==undefined?props.isHomeSlider:false;if(isHomeSlider===true){if(window.innerWidth<1000){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:bannerSliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Picture,{mobileImg:"HomeSlider/M/3.jpg",webpMobileImg:"HomeSlider/M/webp/3.webp"})));}else{html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:bannerSliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Picture,{desktopImg:"HomeSlider/desktop/1a.jpg",webpImg:"HomeSlider/desktop/webp/1.webp"})));}}else{if(window.innerWidth<1000){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:bannerSliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{mobileImg:"HomeSlider/M/3.jpg"})));}else{html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:bannerSliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Picture,{desktopImg:"HomeSlider/desktop/1a.jpg",webpImg:"HomeSlider/desktop/webp/1.webp"})));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'home-section caruasel-wrapper banners-caruasel-wrapper',id:'part-1'},html,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'weather-wrapper show-on-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"TEMP. DEL AGUA.",temp:props.waterTemp}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"Tel Aviv",temp:props.telAvivWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"Jerusalem",temp:props.jerusalemWeather})));};var AnimateCallToAction=function AnimateCallToAction(props){var cssClass="hide-on-mobile"+props.cssClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link,target:'_blank',className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.src}));};var ActivaImg=function ActivaImg(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.src}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-play-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"Videos/play.png",className:'video-play-ggg'})));};var TravelAlert=function TravelAlert(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'home-section home-section-padding',id:'travel-alert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ac-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-travel-alert-message col-80'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:'/Pages/CoronaVirusPage'},'Alerta de viaje: obtenga las \xFAltimas alertas de viaje que afectan a Israel ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'aqu\xED')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-travel-alert-close-wrapper col-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-travel-alert-close',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'+'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})));};

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Menu_css__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Menu_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var appCountrys=[{langCode:"de",subDomain:"de",countryName:"Deutsch"},// {langCode: "nl", subDomain: "nl", countryName: "Dutch"},
// {langCode: "at", subDomain: "at", countryName: "Österreich"},
// {langCode: "pl", subDomain: "pl", countryName: "Polski"},
// {langCode: "ro", subDomain: "ro", countryName: "Română"},
// {langCode: "se", subDomain: "se", countryName: "Svenska"},
// {langCode: "ch", subDomain: "ch", countryName: "Schwyzerdütsch"},
// {langCode: "cz", subDomain: "cz", countryName: "Cseh"},
// {langCode: "dk", subDomain: "dk", countryName: "Danish"},
// {langCode: "hu", subDomain: "hu", countryName: "Magyar"},
{langCode:"gb",subDomain:"uk",countryName:"English"},{langCode:"ru",subDomain:"ru",countryName:"Русский"},{langCode:"fr",subDomain:"fr",countryName:"Français"},{langCode:"es",subDomain:"es",countryName:"Español"},{langCode:"it",subDomain:"it",countryName:"Italiana"},{langCode:"eu",subDomain:"eu",countryName:"الإمارات العربية المتحدة"},{langCode:"eu-en",subDomain:"eu-en",countryName:"United Arab Emirates"},{langCode:"pt",subDomain:"pt",countryName:"Portuguese"}];var CurrentFlagIcon=function CurrentFlagIcon(props){var lang=props.lang?props.lang:"";var langName=props.langName?props.langName:"";var hideArrow=props.hideArrow===true?true:false;var arrow=null;if(hideArrow==false){arrow=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI__["j" /* Img */],{desktopImg:'/right-arrow-wb.png',cssClass:'bottom-arrow'});}if(Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["g" /* isMobile */])()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"flat-icon-div"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'flat-icon-wrapper flat-icon-'+lang},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:props.setLangState},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI__["j" /* Img */],{desktopImg:'/flags/4x3/'+lang+'.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,langName)),arrow)));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'flat-icon-wrapper flat-icon-'+lang},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:props.setLangState},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI__["j" /* Img */],{desktopImg:'/flags/4x3/'+lang+'.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,langName)),arrow));}};var Menu=function(_Component){_inherits(Menu,_Component);function Menu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Menu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Menu.__proto__||Object.getPrototypeOf(Menu)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpen:false,isLangOpen:false},_this.setMenuState=function(){if(_this.state.isLangOpen){_this.setState({isLangOpen:!_this.state.isLangOpen,isOpen:!_this.state.isOpen});}else{_this.setState({isOpen:!_this.state.isOpen});}},_this.redirect=function(subDomain){if(subDomain==="ru"||subDomain==="at"||subDomain==="ch"||subDomain==="en"||subDomain==="pl"||subDomain==="it"||subDomain==="de"||subDomain==="fr"||subDomain==="es"||subDomain==="eu"||subDomain==="eu-en"){window.location.href='https://new.goisrael.com/'+subDomain;}else if(subDomain==="pt"){window.location.href='https://goisrael.com.br/';}else{window.location.href='https://goisrael.com/?lang='+subDomain;// window.location.href =  'http://localhost:3000/international/?lang=' + subDomain;
}},_this.setLangState=function(){if(Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["g" /* isMobile */])()){_this.setState({isLangOpen:!_this.state.isLangOpen,isOpen:!_this.state.isOpen});}else{_this.setState({isLangOpen:!_this.state.isLangOpen});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Menu,[{key:"render",value:function render(){var _this2=this;var isLangOpen=this.state.isLangOpen;var cssClass="inner";var parentCssClass="";if(this.state.isOpen===true){cssClass+=" open";}var countryContainer=null;var countryCssClass='country-close';if(isLangOpen){countryCssClass='country-open';countryContainer=appCountrys.map(function(o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CurrentFlagIcon,{lang:o.langCode,langName:o.countryName,setLangState:function setLangState(){_this2.redirect(o.subDomain);},hideArrow:true});});}var langName='es';var langCode='es';var CurrentLang='es';if(CurrentLang!=null){// langName = CurrentLang.toUpperCase();
// if ( CurrentLang == "es"){
//   langCode = 'es';
// }else {
//   langCode = CurrentLang;
// }
langName='es';langCode='es';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.state.isLangOpen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"nav-trigger-overlay",onClick:this.setLangState}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"menu-outer-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col col-15 logo-outer-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,className:"first",to:"/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI__["m" /* Logo */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col col-100 menu-inner-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,className:"first",to:"/"},"INICIO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/whereToGo"},"A DONDE IR"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/thingsToDo"},"QU\xC9 HACER"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/Gallery/"},"GALER\xCDA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/Videos"},"V\xCDDEOS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/TouristInfoPage"},"INFORMACI\xD3N TUR\xCDSTICA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CurrentFlagIcon,{lang:langCode,langName:langName,setLangState:this.setLangState,hideArrow:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"open-mobile-menu navbar-toggle",onClick:this.setMenuState},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon-bar"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon-bar"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon-bar"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'container country-container '+countryCssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"country-container-inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"country-container-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Choose your language:")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"country-container-flags-wrapper"},countryContainer))));}}]);return Menu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer_css__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Footer_css__);
var Footer=function Footer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Footer-outer-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col col-100 footer-menu-outer-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"footer-menu-inner-wrapper footer-menu-inner-wrapper-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"first"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:"first",to:"/Pages/whereToGo"},"A DONDE IR")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/TelAvivPage"},"TEL AVIV")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/JerusalemPage"},"JERUSALEM")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/DeadSeaPage"},"EL MAR MUERTO")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:"first",to:"/Pages/thingsToDo"},"QU\xC9 HACER")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/telaviv/Sensational_Beaches"},"PLAYAS SENSACIONALES")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/telaviv/Go_To_Guide"},"GU\xCDA")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/telaviv/Day_IsTrippin"},"EXCURSIONES DE D\xCDA")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:"first",to:"/Pages/Videos"},"V\xCDDEOS")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/Videos/telaviv/TelAviv_On_Wheels"},"AVENTURAS AL AIRE LIBRE")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/Videos/deadsea/Natural_Spa"},"EL MAR MUERTO")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/Videos/telaviv/Port_Pleasures"},"PLACERES PORTUARIOS")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-inner-social-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.instagram.com/visit_israel/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"social/i.png",mobileImg:"social/i.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.youtube.com/@goisraelofficial"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"social/y.png",mobileImg:"social/y.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.flickr.com/photos/israelphotogallery/sets/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"social/fl.png",mobileImg:"social/fl.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.facebook.com/VisitaIsrael"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"social/f.png",mobileImg:"social/f.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.tiktok.com/@visit_israel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"social/tiktok.png",mobileImg:"social/tiktok.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-7"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.linkedin.com/company/israel-ministry-of-tourism/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:"social/linkedin.png",mobileImg:"social/linkedin.png"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cradit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Fot\xF3grafos: Guy Yehieli, Adam Primer, Kfir Boltin, Linnea Andres, Kfir Sivan, Haim Yafim, Dana Fridlander, refael Ben Ari, Itamar Greenberg, Moshik Lindbaum"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Cr\xE9ditos de los videos: Israeli food channel, Tel Aviv Jaffa municipality, UDINI prodactions")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container container-links"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://brochures.goisrael.com/es/",target:"_blank"},"FOLLETO OFICIAL")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null," | ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://goisrael.com/Pages/Contact/",target:"_blank"},"CONTACTO")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null," | ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://israel.travel/terms-of-use/",target:"_blank"},"T\xC9RMINOS DE USO")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null," | ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://goisrael.com/Posts/telaviv/Privacy_Policy",target:"_blank"},"POL\xCDTICA DE PRIVACIDAD")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null," | ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://es.goisrael.com/Pages/Gallery/",target:"_blank"},"FOTOS")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null," | ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://es.goisrael.com/Posts/TouristInfo/Frequently_Asked_Questions",target:"_blank"},"PREGUNTAS FRECUENTES")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null));};/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(125)();
}


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export thingsToDoArr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return newVideos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return showsArr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return faqData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return newPosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TouristInfoPosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Reminders; });
var _ref,_ref2;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var thingsToDoArr=[];// newVideos
var newVideos=[{"title":"Sorprendente Vida Nocturna","sml_desc":"","desc":"","img":"/PostCarousel/TelAviv/amazing-nightlife.jpg","side_img":"/PostCarousel/TelAviv/amazing-nightlife.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Amazing_Nightlife","isVid":true,"forVidPage":true,"ctg":"telaviv","vidId":"ogEN7aRT0SM","id":"Amazing_Nightlife"},{"title":"Jerusalén","sml_desc":"","desc":"","img":"Videos/heart-of-the-world.jpg","img_mob":"/Videos/video_mob/heart-of-the-world.jpg","side_img":"Videos/sidebar/heart-of-the-world.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Heart_Of_The_World","vidId":"nLKWDp5uA-U","ctg":"jerusalem","forVidPage":true,"isVid":true,"id":"Heart_Of_The_World"},{"title":"Aventuras al Aire Libre","sml_desc":"","desc":"","side_img":"PostCarousel/TelAviv/tlv-on-wheels.jpg","img_mob":"/PostCarousel/video_mob/tlv-on-wheels.jpg","img":"PostCarousel/TelAviv/tlv-on-wheels.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=20","css_class":"page-telaviv-adventures","ctg":"telaviv","vidId":"88OV6xU0vPI","isVid":true,"forVidPage":true,"id":"TelAviv_On_Wheels"},{"title":"El Mar Muerto","sml_desc":"","desc":"","img":"/PostCarousel/DeadSea/natural-spa.jpg","img_mob":"/PostCarousel/video_mob/natural-spa.jpg","side_img":"/PostCarousel/DeadSea/natural-spa.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Dead_Sea2","isVid":true,"forVidPage":true,"vidId":"3hxeenS25M0","ctg":"deadsea","id":"Dead_Sea2"},{"title":"JAFFA MÁGICA","sml_desc":"","desc":"","img":"/PostCarousel/TelAviv/joys-of-jaffa.jpg","img_mob":"/PostCarousel/video_mob/joys-of-jaffa.jpg","side_img":"/PostCarousel/TelAviv/joys-of-jaffa.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Joys_Of_Jaffa","isVid":true,"forVidPage":true,"vidId":"uC5KX4MVpC0","ctg":"telaviv","id":"Joys_Of_Jaffa"},{"title":"TEL AVIV JUNTO AL MAR","sml_desc":"","desc":"","img":"Videos/a.jpg","img_mob":"/Videos/video_mob/a.jpg","side_img":"Videos/sidebar/a.jpg","read_more":"READ MORE","link":"/Posts/index.php?postType=video&post=3","css_class":"unic_video-post-4","vidId":"EJAqEcK4Te0","ctg":"telaviv","forVidPage":true,"isVid":true,"id":"TelAviv_By_The_Sea"},{"title":"Sarona Tel Aviv","desc":"","sml_desc":"","img":"Videos/d.jpg","img_mob":"/Videos/video_mob/d.jpg","side_img":"Videos/sidebar/d.jpg","read_more":"READ MORE","link":"/Posts/index.php?postType=video&post=Sarona_TelAviv","vidId":"VubRqT0Z9CM","ctg":"telaviv","forVidPage":true,"isVid":true,"id":"Sarona_TelAviv"},{"title":"2 Ciudades Increibles","sml_desc":"","desc":"","img":"/PostCarousel/Jerusalem/tw-awesome-cities.jpg","side_img":"/PostCarousel/Jerusalem/tw-awesome-cities.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=42","isVid":true,"vidId":"NlOJ-i5hJdI","forVidPage":true,"ctg":"telavivAndJerusalem","id":"2_AWESOME_CITIES"},{"title":"LA CIUDAD VIEJA!","sml_desc":"","desc":"","img":"/PostCarousel/Jerusalem/jerusalem-old-city2.jpg","side_img":"/PostCarousel/Jerusalem/jerusalem-old-city2.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Jerusalem_Old_City","isVid":true,"vidId":"rkjLPq-Zsp8","forVidPage":true,"ctg":"jerusalem","id":"Jerusalem_Old_City"},{"title":"EL MAR MUERTO","sml_desc":"","desc":"","img":"/PostCarousel/DeadSea/natural-spa1.jpg","side_img":"/PostCarousel/DeadSea/natural-spa1.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Natural_Spa","isVid":true,"vidId":"Y2hAOLNcPKU","ctg":"deadsea","forVidPage":true,"id":"Natural_Spa"},{"title":"Jerusalén te está Llamando","sml_desc":"","desc":"","img":"/PostCarousel/4.jpg","side_img":"/PostCarousel/4.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=4","ctg":"jerusalem","isVid":true,"vidId":"1Yx2Uht4rms","forVidPage":true,"id":"Jerusalem_Calling"},{"title":"Las sorpresas de Jerusalén","sml_desc":"","desc":"","img":"/PostCarousel/38.jpg","side_img":"/PostCarousel/38.jpg","read_more":"READ MORE","link":this.url+"/Posts/index.php?post=Cool Jerusalem","ctg":"jerusalem","forVidPage":true,"isVid":true,"vidId":"nLKWDp5uA-U","id":"Cool_Jerusalem"},{"title":"¿buscas la noche más animada?","sml_desc":"","desc":"","img":"Videos/crazy-night.jpg","img_mob":"/Videos/video_mob/crazy-night.jpg","side_img":"Videos/sidebar/crazy-night.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Amazing_Nightlife","vidId":"ogEN7aRT0SM","ctg":"telaviv","isVid":true,"forVidPage":true,"id":"Amazing_Nightlife"},{"title":"Lo Más Destacado de Tel Aviv","sml_desc":"","desc":"","img":"/PostCarousel/17.jpg","side_img":"/PostCarousel/17.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=17","ctg":"telaviv","isVid":true,"vidId":"eRNnLm6R0LI","forVidPage":true,"id":"TelAviv_Highlights"},{"title":"AVENIDA MAMILLA","sml_desc":"","desc":"","img":"/PostCarousel/Jerusalem/mamila-avenue.jpg","side_img":"/PostCarousel/Jerusalem/mamila-avenue.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Mamilla_Avenue","isVid":true,"vidId":"JxSjC2kZfvI","forVidPage":true,"ctg":"jerusalem","id":"Mamilla_Avenue"},{"title":"Nuevo y Antiguo Jerusalén","sml_desc":"","desc":"","img":"/PostCarousel/Jerusalem/jerusalem-old-city.jpg","img_mob":"/PostCarousel/video_mob/jerusalem-old-city.jpg","side_img":"/PostCarousel/Jerusalem/jerusalem-old-city.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Modern_And_Vibrant","css_class":"old-new-jer","isVid":true,"forVidPage":true,"vidId":"JxSjC2kZfvI","ctg":"jerusalem","id":"New_And_OLd_Jerusalem"},(_ref={"title":"Neve Tzedek","sml_desc":"","desc":"","img":"Videos/j.jpg","img_mob":"/Videos/video_mob/j.jpg","side_img":"Videos/sidebar/j.jpg","read_more":"READ MORE","vidId":"eRNnLm6R0LI","link":"/Posts/index.php?postType=video&post=7","css_class":"unic_video-post-13","ctg":"telaviv","isVid":true},_defineProperty(_ref,"vidId","eRNnLm6R0LI"),_defineProperty(_ref,"forVidPage",true),_defineProperty(_ref,"id","Neve_Tzedek"),_ref),{"title":"Placer de Compras","sml_desc":"","desc":"","img":"/PostCarousel/5.jpg","side_img":"/PostCarousel/5.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Shopping_Delights","ctg":"jerusalem","isVid":true,"forVidPage":true,"vidId":"JxSjC2kZfvI","id":"Shopping_Delights"},{"title":"Tel Aviv en bici","sml_desc":"","desc":"","img":"PostCarousel/39.jpg","side_img":"PostCarousel/39.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=38","ctg":"telaviv","isVid":true,"forVidPage":true,"vidId":"Iyziun92P5A","id":"Cycle_TelAviv"},{"title":"Jerusalén “Obligados”","sml_desc":"","desc":"","img":"/PostCarousel/18.jpg","side_img":"/PostCarousel/18.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Jerusalem_Musts","isVid":true,"forVidPage":true,"vidId":"rkjLPq-Zsp8","ctg":"jerusalem","id":"Jerusalem_Musts"},{"title":"Moderna y Vibrante","sml_desc":"","desc":"","img":"/PostCarousel/19.jpg","side_img":"/PostCarousel/19.jpg","read_more":"READ MORE","link":"/Posts/index.php?postType=video&post=8","css_class":"modern-vibrant-jer","isVid":true,"vidId":"1Yx2Uht4rms","forVidPage":true,"ctg":"jerusalem","id":"Modern_And_Vibrant"},//Hadar asked to hide the video in this post on 18.01.2021
// {
//    "title" : "Tiempo de cultura",
//     "sml_desc" : "",
//      "desc" : "",
//     "img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
//     "side_img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=Non_Stop_Culture",
//     "isVid" : true,
//     "vidId":"JxSjC2kZfvI",
//     "forVidPage": true,
//     "ctg": "telaviv",
//     "id": "Non_Stop_Culture"
// },
//End Hadar asked to hide the video in this post on 18.01.2021
{"title":"Placeres Portuarios","sml_desc":"","desc":"","img":"/PostCarousel/3.jpg","img_mob":"/PostCarousel/video_mob/3.jpg","side_img":"/PostCarousel/3.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Port_Pleasures","isVid":true,"forVidPage":true,"vidId":"uC5KX4MVpC0","ctg":"telaviv","id":"Port_Pleasures"},{"title":"PLAYAS SENSACIONALES","sml_desc":"","desc":"","img":"/PostCarousel/TelAviv/sensational-beaches2.jpg","side_img":"/PostCarousel/TelAviv/sensational-beaches2.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=14","isVid":true,"vidId":"EJAqEcK4Te0","ctg":"telaviv","forVidPage":true,"id":"Sensational_Beaches"},{"title":"Emoción Sin Fin","sml_desc":"","desc":"","img":"/PostCarousel/TelAviv/nonstop-excitement2.jpg","side_img":"/PostCarousel/TelAviv/nonstop-excitement2.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Nonstop_Excitement","ctg":"telaviv","isVid":true,"vidId":"Iyziun92P5A","forVidPage":true,"id":"Nonstop_Excitement"},{"title":"EILAT EL VERANO INTERMINABLE","sml_desc":"","desc":"","img":"/PostCarousel/eilat-calling.jpg","side_img":"/PostCarousel/eilat-calling.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Eilat_Calling","css_class":"unic-post-eilat-calling","isVid":true,"vidId":"ZdnNT-GDJv4","forVidPage":true,"ctg":'eilat-negev',"id":'Eilat_Calling'},{"title":"EILAT EL VERANO INTERMINABLE","sml_desc":"","desc":"","img":"/PostCarousel/eilat-calling.jpg","side_img":"/PostCarousel/eilat-calling.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Eilat_Calling","css_class":"unic-post-eilat-calling","isVid":true,"vidId":"ZdnNT-GDJv4","forVidPage":true,"ctg":'eilat-negev',"id":'Eilat_Calling'},{"title":"EL ARRECIFE DE DELFINES DE EILAT","sml_desc":"","desc":"","img":"/PostCarousel/eilat-doolphin-reef.jpg","side_img":"/PostCarousel/eilat-doolphin-reef.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Eilat_Doolphin_Reef","css_class":"unic-post-eilat-doolphin-reef","isVid":true,"vidId":"3Cvz8GoxNzA","forVidPage":true,"ctg":'eilat-negev',"id":'Eilat_Doolphin_Reef'},{"title":"EL MAJESTUOSO DESIERTO DE ISRAEL","sml_desc":"","desc":"","img":"/PostCarousel/majestic-desert.jpg","side_img":"/PostCarousel/majestic-desert.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Majestic_Desert","css_class":"unic-post-majestic-desert","isVid":true,"vidId":"yXzhH92kREg","forVidPage":true,"ctg":'eilat-negev',"id":'Majestic_Desert'},{"title":"UBICACIÓN Y ENFOQUE","sml_desc":"","desc":"","img":"/PostCarousel/location-and-approach.jpg","side_img":"/PostCarousel/location-and-approach.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Location_And_Approach","css_class":"unic-post-location-and-approach","isVid":true,"vidId":"5AAqIhkq_tQ","forVidPage":true,"ctg":'eilat-negev',"id":'Location_And_Approach'},{"title":"EL NEGEV: AVENTURA EN EL DESIERTO","sml_desc":"","desc":"","img":"/PostCarousel/action-fun-in-the-desert.jpg","side_img":"/PostCarousel/action-fun-in-the-desert.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Action_Fun_In_The_Desert","css_class":"unic-post-action-fun-in-the-desert","isVid":true,"vidId":"yXzhH92kREg","forVidPage":true,"ctg":'eilat-negev',"id":'Action_Fun_In_The_Desert'},{"title":"LA RUTA DEL INCIENSO","sml_desc":"","desc":"","img":"/PostCarousel/the-incense-route.jpg","side_img":"/PostCarousel/the-incense-route.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=The_Incense_Route","css_class":"unic-post-the-incense-route","isVid":true,"vidId":"5AAqIhkq_tQ","forVidPage":true,"ctg":'eilat-negev',"id":'The_Incense_Route'},{"title":"EXPLORE MASADA","sml_desc":"","desc":"","img":"/PostCarousel/epic-masada.jpg","side_img":"/PostCarousel/epic-masada.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Epic_Masada","css_class":"unic-post-epic-masada","isVid":true,"vidId":"XxWa_MNm5x8","forVidPage":true,"ctg":'eilat-negev',"id":'Epic_Masada'},{"title":"PARQUE DE TIMNA","sml_desc":"","desc":"","img":"/PostCarousel/timna-treasures.jpg","side_img":"/PostCarousel/timna-treasures.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Timna_Treasures","css_class":"unic-post-timna-treasures","isVid":true,"vidId":"i_4QKtXIeto","forVidPage":true,"ctg":'eilat-negev',"id":'Timna_Treasures'},{"title":"CIUDAD VIEJA DE ACRE","sml_desc":"","desc":"","img":"/PostCarousel/acre.jpg","side_img":"/PostCarousel/acre.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Acre","css_class":"unic-post-acre","isVid":true,"vidId":"KlXXyToCmCM","forVidPage":true,"ctg":'north',"id":'Acre'},{"title":"HAIFA","sml_desc":"","desc":"","img":"/PostCarousel/haifa.jpg","side_img":"/PostCarousel/haifa.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Haifa","css_class":"unic-post-haifa","isVid":true,"vidId":"3ahATaKkhBk","forVidPage":true,"ctg":'north',"id":'Haifa'},{"title":"SAFED","sml_desc":"","desc":"","img":"/PostCarousel/safed.jpg","side_img":"/PostCarousel/safed.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Safed","css_class":"unic-post-safed","isVid":true,"vidId":"i3_ihL51bHo","forVidPage":true,"ctg":'north',"id":'Safed'},{"title":"La puerta de entrada al Norte de Israel","sml_desc":"","desc":"","img":"/PostCarousel/bahai-gardens.jpg","side_img":"/PostCarousel/bahai-gardens.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=The_Bahai_Gardens","css_class":"unic-post-bahai-gardens","isVid":true,"vidId":"3ahATaKkhBk","forVidPage":true,"ctg":'north',"id":'The_Bahai_Gardens'},{"title":"EL MAR DE GALILEE (Kinneret)","sml_desc":"","desc":"","img":"/PostCarousel/sea-of-galilee.jpg","side_img":"/PostCarousel/sea-of-galilee.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=The_Sea_Of_Galilee","css_class":"unic-post-sea-of-galilee","isVid":true,"vidId":"haG-t3wwuMc","forVidPage":true,"ctg":'north',"id":'The_Sea_Of_Galilee'},{"title":"ROSH PINA","sml_desc":"","desc":"","img":"/PostCarousel/rosh-pina.jpg","side_img":"/PostCarousel/rosh-pina.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Rosh_Pina","css_class":"unic-post-rosh-pina","isVid":true,"vidId":"_qKbHL5-qrQ","forVidPage":true,"ctg":'north',"id":'Rosh_Pina'},{"title":"NAZARET","sml_desc":"","desc":"","img":"/PostCarousel/nazareth.jpg","side_img":"/PostCarousel/nazareth.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Nazareth","css_class":"unic-post-nazareth","isVid":true,"vidId":"1M7N5BcmjFM","forVidPage":true,"ctg":'north',"id":'Nazareth'},{"title":"ACCIÓN EN LA GALILEA","sml_desc":"","desc":"","img":"/PostCarousel/galilee-action.jpg","side_img":"/PostCarousel/galilee-action.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Galilee_Action","css_class":"unic-post-galilee-action","isVid":true,"forVidPage":true,"vidId":"5Ep3GgxELag","ctg":'north',"id":'Galilee_Action'},{"title":"LAGO HULA","sml_desc":"","desc":"","img":"/PostCarousel/birdtastic-hula-lake.jpg","side_img":"/PostCarousel/birdtastic-hula-lake.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Birdtastic_Hula_Lake","css_class":"unic-post-birdtastic-hula-lake","isVid":true,"vidId":"ImobrsxsKl8","forVidPage":true,"ctg":'north',"id":'Birdtastic_Hula_Lake'},{"title":"NAZARET","sml_desc":"","desc":"","img":"/PostCarousel/nazareth.jpg","side_img":"/PostCarousel/nazareth.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Nazareth","css_class":"unic-post-nazareth","isVid":true,"vidId":"1M7N5BcmjFM","forVidPage":true,"isDouble":true,"ctg":'north',"id":'Nazareth'},{"title":"La puerta de entrada al Norte de Israel","sml_desc":"","desc":"","img":"/PostCarousel/bahai-gardens.jpg","side_img":"/PostCarousel/bahai-gardens.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=The_Bahai_Gardens","css_class":"unic-post-bahai-gardens","isVid":true,"vidId":"3ahATaKkhBk","forVidPage":true,"isDouble":true,"ctg":'north',"id":'The_Bahai_Gardens'}];// newVideos
// start showsArr
// export const showsArr = [
//       {
//         title: "Pride Week 2020",
//         desc: "",
//         date: "12.06.20",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"",
//         css_class: "unic-singer-Pride_Parade_2020",
//         // id: "Pride_Week_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Nick Cave & Bad Seeds",
//         desc: "",
//         date: "17.06.2020",
//         img: "Concerts/nickcave-badseeds.jpg",
//         side_img: "Concerts/nickcave-badseeds.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Nickcave-Badseeds",
//         // id: "Nickcave_Badseeds",
//         css_class: "unic-singer-nickcave-badseeds",
//         book_now : "READ MORE"
//       },
//       {
//         title: "The Pixies",
//         desc: "",
//         date: "09.2020",
//         img: "Concerts/1.jpg",
//         side_img: "Concerts/1.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=The_Pixies_2020",
//         css_class: "unic-singer-pixies-2020",
//         // id: "The_Pixies_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Celine Dion",
//         desc: "",
//         date: "04.08.20",
//         img: "Concerts/Celine_Dion.jpg",
//         side_img: "Concerts/Celine_Dion.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Celine_Dion",
//         css_class: "unic-singer-Celine_Dion",
//         // id: "Celine_Dion",
//         book_now : "READ MORE"
//       },
//       {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=DGTL_Festival",
//         css_class: "unic-singer-dgtl2020",
//         // id: "DGTL_Festival_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Hutzot Hayotzer Jerusalem",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Hutzot_Hayotzer_Jerusalem_2020",
//         css_class: "unic-singer-hutzot_hayotzer",
//         // id: "Hutzot_Hayotzer_Jerusalem_2020", 
//         book_now : "READ MORE"
//       },
//       {
//         title: "Jerusalem Beer Festival",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Jerusalem_Beer_Festival_2020",
//         css_class: "unic-singer-jbf_2020",
//         // id: "Jerusalem_Beer_Festival_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Jerusalem Wine Festival",
//         desc: "",
//         date: "08.2020",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Jerusalem Wine Festival_2020",
//         css_class: "unic-singer-jwf-2020",
//         // id: "Jerusalem_Wine_Festival_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Open Houses Festival",
//         desc: "",
//         date: "09.2020",
//         img: "Concerts/open-houses-festival.jpg",
//         side_img: "Concerts/open-houses-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
//         css_class: "unic-singer-openhf-2020",
//         // id: "Open_Houses_Festival_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "The Jerusalem March",
//         desc: "",
//         date: "03.09.2020",
//         img: "Concerts/jerusalem-march.jpg",
//         side_img: "Concerts/jerusalem-march.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
//         css_class: "unic-singer-jerusalem-march-2020",
//         // id: "The_Jerusalem_March_2020",
//         book_now : "READ MORE"
//       },
//       // return here
//       {
//         title: "Jerusalem Beer Festival",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Jerusalem_Beer_Festival_2020",
//         css_class: "unic-singer-jbf_2020",
//         "isDouble": true,
//         // id: "Jerusalem_Beer_Festival_2020",
//         book_now : "READ MORE"
//       },
//       {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "08.2020",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=DGTL_Festival",
//         css_class: "unic-singer-dgtl2020",
//         "isDouble": true,
//         // id: "DGTL_Festival_2020",
//         book_now : "READ MORE"
//       },
//       /*----------------OLD SINGERS------------------*/
//       {
//         title: "Natalia Oreiro",
//         desc: "Natalia to Wow Tel Aviv in March",
//         date: "20.03.2018",
//         img: "Concerts/32.jpg",
//         side_img: "Concerts/Sidebar/46.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=44",
//         css_class: "unic-singer-13",
//         id:44,
//         book_now: "Read More"
//       },
//        {
//         title: "Backstreet Boys",
//         desc: "The Backstreet Boys are Back and Larger Than Life",
//         date: "22.04.2018",
//         img: "Concerts/51.jpg",
//         side_img: "Concerts/Sidebar/53.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=51",
//         css_class: "unic-singer-20",
//         id:51,
//         a_star: true,
//         book_now: "Read More"
//       },
//       {
//        title: "Led Zeppelin 2",
//        desc : "Don’t Miss the Zeps in Tel Aviv!" ,
//        date : "07-10.01.2018",
//        img  : "Concerts/20.jpg",
//        side_img  : "Concerts/Sidebar/29.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=29" ,
//        css_class: "unic-singer-3",
//        id:29,
//        book_now : "Read More"
//       },
//       {
//         title: "Chris Rock",
//         desc: "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH",
//         date: "08-09.01.2018",
//         img: "Concerts/6.jpg",
//         side_img: "Concerts/Sidebar/16.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=17",
//         css_class: "unic-singer-4",
//         id:17,
//         book_now: "Read More"
//       },
//       {
//        title: "Jerry Seinfeld",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "30.12.2017",
//        img  : "Concerts/jerry.jpg",
//        side_img  : "Concerts/Sidebar/jerry.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=36" ,
//        css_class: "unic-singer-2",
//        id:36,
//        book_now : "Read More"
//       },
//       {
//        title: "Buena Vista",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "21-26.12.2017",
//        img  : "Concerts/buena.jpg",
//        side_img  : "Concerts/Sidebar/buena.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=35" ,
//        id:35,
//        book_now : "Read More"
//       },
//      {
//        title: "Justin Bieber",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.05.2017",
//        img  : "Concerts/justin.jpg",
//        side_img  : "Concerts/Sidebar/9.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=9" ,
//        a_star  : true,
//        id:9,
//        book_now : "Read More"
//       },
//       {
//        title: "AEROSMITH",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "28.06.2017",
//        img  : "Concerts/aerosmith3.jpg",
//        side_img  : "Concerts/Sidebar/10.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=10" ,
//        a_star  : true,
//        id:10,
//        book_now : "Read More"
//       },
//       {
//        title: "Britney Spears ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.07.2017",
//        img  : "Concerts/britney.jpg",
//        side_img  : "Concerts/Sidebar/2.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=2" ,
//        a_star  : true,
//        id: 2,
//        book_now : "Read More"
//       },
//       {
//        title: "Guns N' Roses",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "15.07.2017",
//        img  : "Concerts/Guns-N-roses.jpg",
//        side_img  : "Concerts/Sidebar/4.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=4" ,
//        a_star  : true,
//        id:4,
//        book_now : "Read More"
//       },
//       {
//        title: "Bryan Adams ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "04-06.12.2017",
//        img  : "Concerts/7.jpg",
//        side_img  : "Concerts/Sidebar/15.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=16" ,
//        a_star  : true,
//        id:16,
//        book_now : "Read More"
//       },
//       {
//        title: "NICK CAVE ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.11.2017",
//        img  : "Concerts/4.jpg",
//        side_img  : "Concerts/Sidebar/8.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=8" ,
//        id:8,
//        book_now : "Read More"
//       },
//       {
//         title: "RADIOHEAD ",
//         desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//         date : "19.07.2017",
//         img  : "Concerts/360x539.jpg",
//         side_img  : "Concerts/Sidebar/5.jpg" ,
//         link :  "/Posts/index.php?postType=concerts&post=5" ,
//         a_star  : true,
//         id:5,
//         book_now : "Read More"
//       },
//       {
//        title: "The Chainsmokers",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "3.08.2017",
//        img  : "Concerts/9.jpg",
//        side_img  : "Concerts/Sidebar/14.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=13" ,
//        id:13,
//        book_now : "Read More"
//       },
//       {
//        title: "Blue Man Group",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "7-23.08.2017",
//        img  : "Concerts/14.jpg",
//        side_img  : "Concerts/Sidebar/22.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=19" ,
//        id:19,
//        book_now : "Read More"
//       },
//       {
//        title: "Regina Spektor",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.08.2017",
//        img  : "Concerts/2.jpg",
//        side_img  : "Concerts/Sidebar/7.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=7" ,
//        id:7,
//        book_now : "Read More"
//       },
//       {
//        title: "Sean Paul",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "22.08.2017",
//        img  : "Concerts/13.jpg",
//        side_img  : "Concerts/Sidebar/21.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=20" ,
//       id:20,
//        a_star  : true,
//        book_now : "Read More"
//       },
//       {
//         title: "Pride Parade 2019",
//         desc: "",
//         date: "14.06.2019",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Pride_Parade_2019",
//         css_class: "unic-singer-Pride_Parade_2019",
//         id: "Pride_Parade_2019",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Daddy Yankee",
//         desc: "",
//         date: "26.06.2019",
//         img: "Concerts/daddyyanke.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-daddyyanke",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Tom Jones",
//         desc: "",
//         date: "03.07.2019",
//         img: "Concerts/tomjones.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-tomjones",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Paul Anka",
//         desc: "",
//         date: "11.07.2019",
//         img: "Concerts/paul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-paul",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Sean Paul",
//         desc: "",
//         date: "13.07.2019",
//         img: "Concerts/seanpaul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-seanpaul",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Ozuna",
//         desc: "",
//         date: "24.07.2019",
//         img: "Concerts/ozuna.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-ozuna",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Jerusalem Film Festival",
//         desc: "36 Years of Cinema Magic!",
//         date: "04.08.2019",
//         img:"Concerts/filmFestive.jpg",
//         side_img:"Concerts/filmFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=68",
//         css_class: "unic-singer-68",
//         id:68,
//         book_now : "READ MORE"
//       },
//       {
//         title: "Bon Jovi",
//         desc: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
//         date: "25.07.2019",
//         img: "Concerts/bon-j.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-76",
//         id: 76,
//         book_now : "READ MORE"
//       },
//       {
//         title: "J Balvin",
//         desc: "",
//         date: "30.07.2019",
//         img: "Concerts/balvin.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "unic-singer-balvin",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Jerusalem Wine Festival",
//         desc: "Wine and dine in the holy city!",
//         date: "30.07.2019",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=69",
//         css_class: "unic-singer-69",
//         id:69,
//         book_now : "READ MORE"
//       },
//       {
//         title: "J.Lo",
//         desc: "",
//         date: "01.08.2019",
//         img:"Concerts/jlo.jpg",
//         side_img:"Concerts/jlo.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jlo",
//         css_class: "unic-singer-jlo",
//         id: "J_Lo",
//         book_now : "READ MORE"
//       },
//       {
//         title: "The International Arts",
//         desc: "",
//         date: "12-24.08.2019",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=94",
//         css_class: "unic-singer-inter-arts",
//         id: "The_International_Arts", 
//         book_now : "READ MORE"
//       },
//       {
//         title: "Jerusalem Beer Festival",
//         desc: "",
//         date: "28-29.08.2019",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=91",
//         css_class: "unic-singer-jbf",
//         id: "Jerusalem_Beer_Festival",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Lionel Richie",
//         desc: "",
//         date: "12.09.2019",
//         img:"Concerts/lionel-richie.jpg",
//         side_img:"Concerts/lionel-richie.jpg",
//         link:"/Posts/index.php?postType=concerts&post=lionelrichie",
//         css_class: "unic-singer-lionel-richie",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Open Houses Festival",
//         desc: "",
//         date: "19-21.09.2019",
//         img: "Concerts/open-houses-festival.jpg",
//         side_img: "Concerts/open-houses-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=96",
//         css_class: "unic-singer-openhf",
//         id: "Open_Houses_Festival",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Open Restaurants TLV",
//         desc: " Feed Your Curiosity!",
//         date: "2019",
//         img: "Concerts/71.jpg",
//         side_img: "Concerts/72.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=70",
//         css_class: "unic-singer-70",
//         book_now : "READ MORE"
//       },
//        {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "14.10.2019",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=93",
//         css_class: "unic-singer-dgtl2019",
//         id: "DGTL_Festival",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Cycle Tel Aviv",
//         desc: "",
//         date: "18.10.2019",
//         img: "Concerts/cycle-tlv-2019.jpg",
//         side_img: "Concerts/cycle-tlv-2019.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=93",
//         css_class: "unic-singer-cycle-tlv-2019",
//         id: "Cycle_Tel_Aviv",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Night Run Tel Aviv",
//         desc: "",
//         date: "30.10.2019",
//         img: "Concerts/night-run-tlv.jpg",
//         side_img: "Concerts/night-run-tlv.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=98",
//         css_class: "unic-singer-tlv-nightrun2019",
//         id: "Night_Run_TelAviv",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Culinary Festival",
//         desc: "Special Edition: Female Chefs",
//         date: "09-23.11.2019",
//         img: "Concerts/72.jpg",
//         side_img: "Concerts/73.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=71",
//         css_class: "unic-singer-71",
//         book_now : "READ MORE"
//       },
//      {
//         title: "Open Restaurants Jerusalem",
//         desc: "",
//         date: "19-23.11.2019",
//         img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         side_img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Open_Restaurants_Jerusalem",
//         css_class: "unic-singer-Open_Restaurants_Jerusalem",
//         id: "Open_Restaurants_Jerusalem",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Louis CK",
//         desc: "",
//         date: "23.11.2019",
//         img: "Concerts/Louis_CK.jpg",
//         side_img: "Concerts/Louis_CK.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Louis_CK",
//         css_class: "unic-singer-Louis_CK",
//         id: "Louis_CK",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Jim Jeffries",
//         desc: "",
//         date: "21.12.2019",
//         img:"Concerts/jim-jeffries.jpg",
//         side_img:"Concerts/jim-jeffries.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jimjeffries",
//         css_class: "unic-singer-jim-jeffries",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Open Restaurants TLV",
//         desc: " Feed Your Curiosity!",
//         date: "2019",
//         img:"Concerts/openRestTlv.jpg",
//         side_img:"Concerts/openRestTlv.jpg",
//         link: "/Posts/index.php?postType=concerts&post=70",
//         css_class: "unic-singer-70",
//         id:70,
//         book_now : "READ MORE"
//       },
//       {
//         title: "Tel Aviv Marathon",
//         desc: "",
//         date: "28.02.20",
//         img: "Concerts/tlv-marathon.jpg",
//         side_img: "Concerts/tlv-marathon.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=97",
//         css_class: "unic-singer-tlv-marathon2020",
//         id: "TelAviv_Marathon",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Purim 2020",
//         desc: "",
//         date: "09-10.03.20",
//         img: "Concerts/purim2019.jpg",
//         side_img: "Concerts/purim2019.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Purim_2020",
//         css_class: "unic-purim2020",
//         id: "Purim_2020",
//         book_now : "READ MORE"
//       },
//        {
//         title: "Jerusalem Marathon",
//         desc: "",
//         date: "20.03.20",
//         img: "Concerts/jer-marathon.jpg",
//         side_img: "Concerts/jer-marathon.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=95",
//         css_class: "unic-singer-jer-marathon2019",
//         id: "Jerusalem_Marathon",
//         book_now : "READ MORE"
//       },
//       {
//         title: "Tel Aviv Fashion Week",
//         desc: "",
//         date: "03.2020",
//         img: "Concerts/fationWeek.jpg",
//         side_img: "Concerts/fationWeek.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=TelAviv_Fashion_Week_2020",
//         css_class: "unic-fashion-week-2020",
//         // id: "TelAviv_Fashion_Week_2020",
//         book_now : "READ MORE"
//       },
//       // THre Events that Hadar asked to hide for the next year, the email from 19-05-2020
//        // {
//       //   title: "The Rubinstein Piano Competition ",
//       //   desc: "",
//       //   date: "05-21.05.2020",
//       //   img:"Concerts/piano-competition-2020.jpg",
//       //   side_img:"Concerts/piano-competition-2020.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=Piano_Competition_2020",
//       //   css_class: "unic-singer-piano-competition-2020",
//       //   id: "Piano_Competition_2020",
//       //   book_now : "READ MORE"
//       // },
//       // {
//       //   title: "Red Hot Chili Peppers",
//       //   desc: "",
//       //   date: "10.06.20",
//       //   img:"Concerts/red-hot-chili-peppers-2020.jpg",
//       //   side_img:"Concerts/red-hot-chili-peppers-2020.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=Red_Hot_Chili_Peppers_2020",
//       //   css_class: "unic-singer-red-hot-chili-peppers-2020",
//       //   id: "Red_Hot_Chili_Peppers_2020",
//       //   book_now : "READ MORE"
//       // },
//       // {
//       //   title: "White Night",
//       //   desc: "",
//       //   date: "06.2020",
//       //   img:"Concerts/53.jpg",
//       //   side_img:"Concerts/53.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=White_Night_2020",
//       //   css_class: "unic-singer-white-night-2020",
//       //   // id: "White_Night_2020",
//       //   book_now : "READ MORE"
//       // },
//       // END THre Events that Hadar asked to hide for the next year, the email from 19-05-2020
// ];
// End showsArr
var showsArr=[];var faqData=[{id:1,q:"Preguntas frecuentes sobre Covid19",answer:"\n      <ol start=\"1\">\n                             \n                <li>\n                  <strong>Soy un turista en Israel y creo que podr\xEDa tener el COVID-19, \xBFA d\xF3nde debo acudir?</strong><br/>\n                  Si tienes 38\xBAC o m\xE1s de fiebre, tos, dificultad para respirar u otros problemas respiratorios, debes auto aislarte inmediatamente y llamar a la l\xEDnea directa de 101 de Servicios de Urgencia de MDA para indicaciones m\xE9dicas.\n                  <strong className=\"ac-pink\">\n                    No acudas a una cl\xEDnica o sala de urgencias.\n                  </strong>\n                </li>\n                <li>\n                  <strong>\xBFCu\xE1ndo volver\xE1 a aceptar Israel a visitantes de fuera</strong><br/>\n                  En este momento no hay fecha conocida en la que Israel volver\xE1 a permitir la entrada a los visitantes extranjeros.\n                </li>\n              </ol>\n                               \n                          \n      ",isOpen:false},{id:2,q:"¿ESTÁN TEL AVIV Y JERUSALÉN MUY LEJOS?",answer:"\n      <p>\n        \xA1Al contrario! Est\xE1n m\xE1s cerca de lo que crees, s\xF3lo son 4-5horas de vuelo y podr\xE1s disfrutar de las soleadas playas de Tel Aviv y los espectaculares lugares de Jerusal\xE9n. Y lo mejor de todo es que de Tel Aviv a Jerusal\xE9n solo hay una hora de coche.\n        </p>\n      ",isOpen:false},{id:3,q:"¿CÓMO MOVERSE POR TEL AVIV Y JERUSALÉN?",answer:"\n      \n      <p>\n       Los m\xE9todos de transporte m\xE1s f\xE1ciles y utilizados son los autobuses, taxis y el tren. Jerusal\xE9n tambi\xE9n tiene un tren ligero muy c\xF3modo que va a los lugares m\xE1s concurridos de la ciudad.\n        </p>\n      <p>\n      Informaci\xF3n acerca de estaciones de tren, rutas y horarios en: <a target=\"_blank\" href=\"//www.rail.co.il\">www.rail.co.il</a>\n      </p>\n      <p>\n      Informaci\xF3n acerca de rutas y horarios de autob\xFAs en: <a target=\"_blank\" href=\"//www.bus.gov.il\">www.bus.gov.il</a>  \n      </p>\n      <p>\n      Atenci\xF3n al cliente de transporte p\xFAblico:  <a href=\"tel:*8787\">*8787</a>  \n      </p>\n      <p>\n       App de transporte p\xFAblico local- \u2018Moovit\u2019\n      </p>\n      <h4>\n      Taxis \n      </h4>\n      <p>\n        Los taxis para viajar por la ciudad y a otras ciudades se pueden coger en la calle o reservar por tel\xE9fono o con apps espec\xEDficas como Gett(GetTaxi)\n      </p>\n\n      <h4>\n     Taxis Sherut\n      </h4>\n      <p>\n         Los Taxis \u201CSherut\u201D son furgonetas de 10-12 asientos que suelen seguir las rutas de los autobuses m\xE1s importantes, dentro y entre las ciudades m\xE1s importantes. El precio de estos taxis sherut es fijo y es similar a las tarifas de los autobuses regulares.\n      </p>\n\n      <h4>\n     Alquiler de coche\n      </h4>\n      <p>\n       La mayor\xEDa de los servicios de alquiler de coches del centro de Tel Aviv se encuentran en la calle Hayarkon, cerca de la playa de Tel Aviv, y en las zonas de hoteles en otras ciudades importantes.\n      </p>\n\n      <h4>\n      Tel-O-Fun \n      </h4>\n      <p>\n        Tel-O-Fun es un servicio de compartir alquiler de bicicletas, proporcionado por la ciudad de Tel Aviv y disponible para residentes y turistas. El service servicio de Tel-O-Fun tiene 2.000 bicicletas en 200 estaciones que te permiten alquilar una bici y circular por 130km de v\xEDas espec\xEDficas para ciclistas. Puedes comprar una tarjeta de acceso diario o semanal con una tarjeta de cr\xE9dito en cualquier terminal de estaci\xF3n de alquiler.\n      </p>\n      .\n      ",isOpen:false},{id:4,q:"¿Y EL DINERO?",answer:"\n      <p>\n       La divisa israel\xED es el Shekel. Se puede sacar dinero en los cajeros de los bancos por toda la ciudad. Tambi\xE9n est\xE1n disponibles cajeros privados en kioscos locales, con una comisi\xF3n de 5,90-7,90 NIS cada vez que retiras dinero. Los servicios La oficinas de cambio privadas est\xE1n en oficinas privadas en \xE1reas tur\xEDsticas y no cobran comisi\xF3n, suelen estar abiertas hasta tarde. Por supuesto, se aceptan las tarjetas de cr\xE9dito en muchos sitios. Western Union funciona en la mayor\xEDa de las oficinas de correos y ofrecen servicios de transferencias.\n      </p>\n      ",isOpen:false},{id:5,q:"MANTENER EL CONTACTO",answer:"\n\n        <h4>\n          Phone Services\n        </h4>\n        <p>\n          Si lo necesitas, puedes comprar una tarjeta SIM local, de en una tienda de telefon\xEDa o un centro de informaci\xF3n tur\xEDstica, y cupones para pagar cargarla seg\xFAn lo vayas utilizando necesitando, en muchas tiendas y cabinas de cambio.\n        </p>\n\n        <h4>\n         Zona Wifi \u2013Wifi Gratuito\n        </h4>\n        <p>\n          Tel Aviv se enorgullece de ser una ciudad moderna y actualizada. Hay Wifi gratis en 80 ubicaciones por toda la ciudad (incluso en la playa, centros de ocio y la mayor\xEDa de las zonas tur\xEDsticas)</p>\n        <p>\n         En Jerusal\xE9n, las zonas de WIFI gratuito est\xE1n en las estaciones de tren, universidades, museos, centros tur\xEDsticos, salas de convenciones, zonas tur\xEDsticas, centros comerciales y tambi\xE9n en el Centro de Informaci\xF3n al Turista.\n\n        </p>\n\n      ",isOpen:false},{id:6,q:"¿CÓMO ES EL TIEMPO?",answer:"\n        <p>\n        El tiempo en Tel Aviv es c\xE1lido y agradable la mayor parte del a\xF1o. Los veranos son largos y perfectos para la playa y para ir de excursi\xF3n, mientras que los inviernos son agradables sin demasiada lluvia. Temperatura media en invierno: 9-17 \xBAC. Temperatura media en verano: 24-30\xBAC.\n        </p>\n        <p>\n          En Jerusal\xE9n los veranos son largos y soleados (mayo-septiembre) y los inviernos (noviembre-marzo) pueden llegar a ser muy fr\xEDos y lluviosos con alguna tormenta de nieve ocasional y las temperaturas bajan a \u2013 de 0\xBAC. Hay informaci\xF3n actualizada en el Servicio Meteorol\xF3gico Israel\xED: <a target=\"_blank\" href=\"//www.ims.gov.il\">www.ims.gov.il</a>\n\n        </p>\n      ",isOpen:false},{id:7,q:"¿SON DISTINTOS LOS DÍAS LABORABLES?",answer:"\n        \n        <p>\n        S\xED, se trabaja de domingo a jueves y el fin de semana es de viernes a s\xE1bado. La mayor\xEDa de los negocios abren el viernes hasta primera hora de la tarde, antes del Shabbat jud\xEDo, que comienza a la puesta de sol el viernes y dura hasta la puesta de sol del s\xE1bado. www.timeanddate.com/worldclock/Israel\n        </p>\n      ",isOpen:false}];// newPosts
var newPosts=[{"title":"Sorprendente Vida Nocturna","sml_desc":"",// "sml_desc": "Sorprendente Vida Nocturna",
"desc":"",// "desc": "¡Es una fiesta sin fin <br>en la ciudad sin descanso!",
"img":"/PostCarousel/TelAviv/amazing-nightlife.jpg","side_img":"/PostCarousel/TelAviv/amazing-nightlife.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Amazing_Nightlife","isVid":false,"forVidPage":true,"ctg":"telaviv","id":"Amazing_Nightlife"},{"title":"Jerusalén",// "sml_desc": "El corazón del mundo",
"sml_desc":"",// "desc": "",
"desc":"","img":"Videos/heart-of-the-world.jpg","img_mob":"/Videos/video_mob/heart-of-the-world.jpg","side_img":"Videos/sidebar/heart-of-the-world.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Heart_Of_The_World","vidId":"nLKWDp5uA-U","ctg":"jerusalem","forVidPage":true,"isVid":true,"id":"Heart_Of_The_World"},{"title":"Aventuras al Aire Libre",// "sml_desc" : "Outdoor Adventures",
// "sml_desc" : "Tel Aviv sobre ruedas",
"sml_desc":"",// "desc" : "Ciudad repleta de acción – perfecta<br> para personas activas",
"desc":"","side_img":"PostCarousel/TelAviv/tlv-on-wheels.jpg","img_mob":"/PostCarousel/video_mob/tlv-on-wheels.jpg","img":"PostCarousel/TelAviv/tlv-on-wheels.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=20","css_class":"page-telaviv-adventures","ctg":"telaviv","vidId":"88OV6xU0vPI","isVid":true,"forVidPage":true,"id":"TelAviv_On_Wheels"},{"title":"El Mar Muerto",// "sml_desc": "Es hora de disfrutar en el<br> espledor de la naturaleza",
"sml_desc":"","desc":"","img":"/PostCarousel/DeadSea/natural-spa.jpg","img_mob":"/PostCarousel/video_mob/natural-spa.jpg","side_img":"/PostCarousel/DeadSea/natural-spa.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Dead_Sea2","isVid":true,"forVidPage":true,"vidId":"3hxeenS25M0","ctg":"deadsea","id":"Dead_Sea2"},{"title":"JAFFA MÁGICA","sml_desc":"",// "sml_desc" : "Una ciudad de encanto multicultural",
"desc":"",// "desc" : "Experimente todas las riquezas que ofrece la hermosa y antigua Jaffa",
"img":"/PostCarousel/TelAviv/joys-of-jaffa.jpg","img_mob":"/PostCarousel/video_mob/joys-of-jaffa.jpg","side_img":"/PostCarousel/TelAviv/joys-of-jaffa.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Joys_Of_Jaffa","isVid":true,"forVidPage":true,"vidId":"uC5KX4MVpC0","ctg":"telaviv","id":"Joys_Of_Jaffa"},{"title":"TEL AVIV JUNTO AL MAR",// "sml_desc": "Porque una playa en Tel Aviv es vida ",
"sml_desc":"",// "desc": "Prepárese para la diversión bajo el sol",
"desc":"","img":"Videos/a.jpg","img_mob":"/Videos/video_mob/a.jpg","side_img":"Videos/sidebar/a.jpg","read_more":"READ MORE","link":"/Posts/index.php?postType=video&post=3","css_class":"unic_video-post-4","vidId":"EJAqEcK4Te0","ctg":"telaviv","forVidPage":true,"isVid":true,"id":"TelAviv_By_The_Sea"},{"title":"Sarona Tel Aviv","desc":"",// "desc": "Una gran selección de atracciones <br/> en una impresionante colonia Templaria renovada",
// "sml_desc": "Un asombroso oasis urbano",
"sml_desc":"","img":"Videos/d.jpg","img_mob":"/Videos/video_mob/d.jpg","side_img":"Videos/sidebar/d.jpg","read_more":"READ MORE","link":"/Posts/index.php?postType=video&post=Sarona_TelAviv","vidId":"VubRqT0Z9CM","ctg":"telaviv","forVidPage":true,"isVid":true,"id":"Sarona_TelAviv"},// {
//    "title": "PLACERES PORTUARIOS",
//     // "sml_desc": "The different charms of<br> Tel Aviv and Jaffa Ports ",
//     "sml_desc" : "",
//     // "desc": "Tel Aviv’s fascinating cultural scene",
//      "desc" : "",
//     "img": "/PostCarousel/TelAviv/jaffa-port.jpg",
//     "side_img": "/PostCarousel/TelAviv/jaffa-port.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=Port_Pleasures",
//     "isVid": false,
//     "ctg": "telaviv",
//     "id": "Port_Pleasures"
// },
{"title":"2 Ciudades Increibles",// "sml_desc": "Una mágica e inolvidable <br>escapada hacia el sol",
"sml_desc":"","desc":"","img":"/PostCarousel/Jerusalem/tw-awesome-cities.jpg","side_img":"/PostCarousel/Jerusalem/tw-awesome-cities.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=42","isVid":false,"forVidPage":true,"ctg":"telavivAndJerusalem","id":"2_AWESOME_CITIES"},// No Translation
// {
//    "title": "JERUSALEM",
//     "sml_desc" : "",
//      "desc" : "",
//     "img": "/PostCarousel/Jerusalem/jerusalem.jpg",
//     "side_img": "/PostCarousel/Jerusalem/jerusalem.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=Jerusalem",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": "Jerusalem"
// },
{"title":"Alegrías del Mar Muerto",// "sml_desc": "Para un buen momento flotante",
"sml_desc":"","desc":"","img":"/PostCarousel/DeadSea/deadsea1.jpg","side_img":"/PostCarousel/DeadSea/deadsea1.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Next_Level_DS","isVid":false,"ctg":"deadsea","id":"Dead_Sea1"},// {
//     "title": "Eurovision Tel Aviv",
//     // "sml_desc": "Todo un clásico en la ciudad que nunca duerme",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/eurovision.jpg",
//     "side_img": "/PostCarousel/eurovision.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=33",
//     "isVid": false,
//     "ctg": "telaviv",
//     "id": "Eurovision"
// },
{"title":"Información turística",// "sml_desc": "Todo lo que necesitas saber",
"sml_desc":"","desc":"","img":"/PostCarousel/touristinfo.jpg","side_img":"/PostCarousel/touristinfo.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=41","isVid":false,"ctg":"telaviv","id":"Tourist_Information"},// {
//     "title": "The Dead Sea",
//     // "sml_desc": "TAKE RELAXATION TO THE NEXT LEVEL",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/DeadSea/next-level.jpg",
//     "side_img": "/PostCarousel/DeadSea/next-level.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=Next_Level_DS",
//     "isVid": false,
//     "ctg": "deadsea",
//     "id": "Next_Level_DS"
// },
// No Translation
// {
//     "title": "Tel Aviv",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/TelAviv/post-telaviv.jpg",
//     "side_img": "/PostCarousel/TelAviv/post-telaviv.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=Tel_Aviv",
//     "isVid": false,
//     "ctg": "telaviv",
//     "id": "Tel_Aviv"
// },
{"title":"LA CIUDAD VIEJA!","sml_desc":"",// "sml_desc": "Sienta cómo la historia cobra vida",
"desc":"",// "desc": "Inspírese con los tesoros de fama mundial de la antigua ciudad de Jerusalén",
"img":"/PostCarousel/Jerusalem/jerusalem-old-city2.jpg","side_img":"/PostCarousel/Jerusalem/jerusalem-old-city2.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Jerusalem_Old_City","isVid":false,"forVidPage":true,"ctg":"jerusalem","id":"Jerusalem_Old_City"},// No Translation
// {
//    "title": "NATURE'S GLORY",
//     // "sml_desc": "THE DEAD SEA",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/DeadSea/natures-glory.jpg",
//     "side_img": "/PostCarousel/DeadSea/natures-glory.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=Natures_Glory",
//     "isVid": false,
//     "ctg": "deadsea",
//     "id": "Natures_Glory"
// },
{"title":"GUÍA",// "sml_desc": "Travel from Tel Aviv and Jerusalem",
"sml_desc":"","desc":"","img":"/PostCarousel/34.jpg","side_img":"/PostCarousel/34.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=35","ctg":"telaviv","isVid":false,// "id": 35
"id":"Go_To_Guide"},// No Translation
// {
//     "title": "ALL SENSORY MARKETS",
//     "sml_desc": "",
//     "desc": "",
//     "img": "thingsToDo/8.jpg",
//     "side_img": "thingsToDo/sidebar/8.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=20",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": false,
//     "id": "All_Sensory_Markets",
//     "showOnHome": false,
//     "ctg": "jerusalem"
// },
{"title":"EL MAR MUERTO","sml_desc":"",// "sml_desc": "THE DEAD SEA",
"desc":"","img":"/PostCarousel/DeadSea/natural-spa1.jpg","side_img":"/PostCarousel/DeadSea/natural-spa1.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Natural_Spa","isVid":false,"ctg":"deadsea","forVidPage":true,"id":"Natural_Spa"},// No Translation
// {
//     "title": "Upscale Jerusalem",
//     // "sml_desc": "Modern luxuries for the pampered traveler",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/Jerusalem/45.jpg",
//     "side_img": "/PostCarousel/Jerusalem/45.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=45",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": 45
// },
{"title":"Jerusalén te está Llamando",// "sml_desc": "La ciudad más mágica y <br>radiante de la Tierra",
"sml_desc":"","desc":"","img":"/PostCarousel/4.jpg","side_img":"/PostCarousel/4.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=4","ctg":"jerusalem","isVid":false,"forVidPage":true,"id":"Jerusalem_Calling"},{"title":"Jerusalén",// "sml_desc": "El corazón del mundo",
"sml_desc":"",// "desc": "",
"desc":"","img":"Videos/heart-of-the-world.jpg","img_mob":"/Videos/video_mob/heart-of-the-world.jpg","side_img":"Videos/sidebar/heart-of-the-world.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Heart_Of_The_World","vidId":"nLKWDp5uA-U","ctg":"jerusalem","forVidPage":true,"isVid":true,"isDouble":true,"id":"Heart_Of_The_World"},// No Translation
// {
//    "title": "NATURAL PHENOMENA",
//     // "sml_desc": "THE DEAD SEA",
//      "sml_desc": "",
//     "desc" : "",
//     "img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
//     "side_img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=Natural_Phenomena",
//     "isVid": false,
//     "ctg": "deadsea",
//     "id": "Natural_Phenomena"
// },
{// "title": "A Foodie’s Paradise‘",
"title":"Tel Aviv – Simplemente delicioso",// "sml_desc": "Un completo paraíso gourmet",
"sml_desc":"","desc":"",// "desc": "Cientos de espectaculares restaurantes, increíbles delicias de mercado y fenomenal comida callejera ",
"img":"/PostCarousel/99.jpg","img_mob":"/PostCarousel/video_mob/99.jpg","side_img":"/PostCarousel/99.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=21","ctg":"culinarytelaviv","vidId":"yFfkbHHWIc4","isVid":true,"forVidPage":true,"id":"Simply_Delicious"},{"title":"Las sorpresas de Jerusalén",// "sml_desc": "Una ciudad más allá de las expectativas",
"sml_desc":"","desc":"","img":"/PostCarousel/38.jpg","side_img":"/PostCarousel/38.jpg","read_more":"READ MORE","link":this.url+"/Posts/index.php?post=Cool Jerusalem","ctg":"jerusalem","forVidPage":true,"isVid":false,"id":"Cool_Jerusalem"},{"title":"EL MAR MUERTO","sml_desc":"","desc":"","img":"/PostCarousel/DeadSea/magical-deadsea1.jpg","side_img":"/PostCarousel/DeadSea/magical-deadsea1.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Magical_Deadsea","isVid":false,"ctg":"deadsea","id":"Magical_Deadsea"},{"title":"Jerusalén “Obligados”",// "sml_desc": "5 mejores cosas para hacer y ver en la impresionante ciudad",
"sml_desc":"","desc":"","img":"/PostCarousel/18.jpg","side_img":"/PostCarousel/18.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Jerusalem_Musts","isVid":false,"forVidPage":true,"vidId":"rkjLPq-Zsp8","ctg":"jerusalem","id":"Jerusalem_Musts"},{"title":"MERCADO DE MAHANE YEHUDA",// "sml_desc": "Una fiesta para los sentidos",
"sml_desc":"",// "desc": "No querrá perderse las vistas, los sonidos, los olores y, <br/> por supuesto, los sabores de este mercado",
"desc":"","img":"Videos/market-madness.jpg","img_mob":"/Videos/video_mob/market-madness.jpg","side_img":"Videos/sidebar/market-madness.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Market_Madness","vidId":"oy9ozIvV7Co","ctg":"culinary","isVid":true,"forVidPage":true,"id":"Market_Madness"},// this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked
{"title":"¿buscas la noche más animada?",// "sml_desc": " Reserva tu viaje a Tel Aviv ahora",
"sml_desc":"",// "desc": "",
"desc":"","img":"Videos/crazy-night.jpg","img_mob":"/Videos/video_mob/crazy-night.jpg","side_img":"Videos/sidebar/crazy-night.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Amazing_Nightlife","vidId":"ogEN7aRT0SM","ctg":"telaviv","isVid":true,"forVidPage":true,"id":"Amazing_Nightlife"},// END this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked
// No Translation
// {
//    "title": "MASADA",
//     "sml_desc" : "",
//     "desc" : "",
//     "img": "/PostCarousel/DeadSea/masada.jpg",
//     "side_img": "/PostCarousel/DeadSea/masada.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=Masada",
//     "isVid": false,
//     "ctg": "deadsea",
//     "id": "Masada"
// },
{"title":"Lo Más Destacado de Tel Aviv",// "sml_desc": "Las 5 mejores cosas para<br> ver y hacer en la ciudad",
"sml_desc":"","desc":"","img":"/PostCarousel/17.jpg","side_img":"/PostCarousel/17.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=17","ctg":"telaviv","isVid":false,"forVidPage":true,"id":"TelAviv_Highlights"},// No Translation
// {
//     "title": "First Time in Jerusalem",
//     // "sml_desc": "The must list for the first time visitor",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
//     "side_img": "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=First_Time_In_Jerusalem",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": "First_Time_In_Jerusalem"
// },
// No Translation
// {
//     "title": "Boutique Hospitality",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
//     "side_img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=Boutique_Hospitality",
//     "isVid": false,
//     "ctg": "telaviv",
//     "id": "Boutique_Hospitality"
// },
{"title":"Qué debe probar en Jerusalén",// "sml_desc": "Must eat dishes to try when visiting the magical city",
"desc":"","sml_desc":"","img":"/PostCarousel/37.jpg","img_mob":"/PostCarousel/video_mob/37.jpg","side_img":"/PostCarousel/37.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=38","ctg":"culinaryjerusalem","vidId":"oy9ozIvV7Co","isVid":true,"forVidPage":true,"id":"A_Taste_Of_Jerusalem"},{"title":"PAUSA PARA UN CAFÉ EN TEL AVIV",// "sml_desc": "Tel Aviv over a fresh coffee",
"sml_desc":"",// "desc": "Coffee shop culture is fundamental",
"desc":" ","img":"Videos/coffee.jpg","img_mob":"/Videos/video_mob/coffee.jpg","side_img":"Videos/sidebar/coffee.jpg","read_more":"READ MORE","link":"/Posts/index.php?postType=video&post=16","vidId":"s6kkkk8_Q2g","ctg":"culinarytelaviv","isVid":true,"forVidPage":true,"id":"Coffee_In_TelAviv"},{"title":"LOS SECRETOS DE JERUSALÉN","sml_desc":"","desc":"","img":"/PostCarousel/Jerusalem/secrets-jer.jpg","side_img":"/PostCarousel/Jerusalem/secrets-jer.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Sectrets_Of_Jewish_Jerusalem","isVid":false,"ctg":"jerusalem","id":"Sectrets_Of_Jewish_Jerusalem"},// No Translation
// {
//     "title": "Non Stop Markets",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/TelAviv/non-stop-markets.jpg",
//     "side_img": "/PostCarousel/TelAviv/non-stop-markets.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=Non_Stop_Markets",
//     "isVid": false,
//     "ctg": "telaviv",
//     "id": "Non_Stop_Markets"
// },
{"title":"AVENIDA MAMILLA","sml_desc":"","desc":"","img":"/PostCarousel/Jerusalem/mamila-avenue.jpg","side_img":"/PostCarousel/Jerusalem/mamila-avenue.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Mamilla_Avenue","isVid":false,"forVidPage":true,"ctg":"jerusalem","id":"Mamilla_Avenue"},// No Translation
// {
//     "title": "TOWER OF DAVID MUSEUM",
//     "sml_desc": "",
//     "img": "thingsToDo/7.jpg",
//     "side_img": "thingsToDo/sidebar/7.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=20",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": false,
//     "id": "Tower_Of_David_Museum",
//     "showOnHome": false,
//     "ctg": "jerusalem"
// },
// No Translation
// {
//    "title": "JERUSALEM’S ART",
//     "sml_desc" : "",
//     "desc" : "",
//     "img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
//     "side_img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=Jerusalem_Arts",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": "Jerusalem_Arts"
// },
{"title":"Nuevo y Antiguo Jerusalén",// "sml_desc": "Tesoros antiguos y lujos modernos",
"sml_desc":"","desc":"",// "desc": "Una aventura inspiradora en Jerusalén,<br> una ciudad increíble",
"img":"/PostCarousel/Jerusalem/jerusalem-old-city.jpg","img_mob":"/PostCarousel/video_mob/jerusalem-old-city.jpg","side_img":"/PostCarousel/Jerusalem/jerusalem-old-city.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Modern_And_Vibrant","css_class":"old-new-jer","isVid":true,"forVidPage":true,"vidId":"JxSjC2kZfvI","ctg":"jerusalem","id":"New_And_OLd_Jerusalem"},{"title":"Neve Tzedek","sml_desc":"",// "sml_desc" : "Chic and Unique  ",
// "desc": "Packed with Lovely Cafe’s, Boutique shops, Art galleries, Elegance and chilled vibes ",
"desc":"","img":"Videos/j.jpg","img_mob":"/Videos/video_mob/j.jpg","side_img":"Videos/sidebar/j.jpg","read_more":"READ MORE","vidId":"eRNnLm6R0LI","link":"/Posts/index.php?postType=video&post=7","css_class":"unic_video-post-13","ctg":"telaviv","isVid":true,"forVidPage":true,"id":"Neve_Tzedek"},{"title":"Hora de Shakshuka",// "sml_desc": "¡Aprende a hacer el mundialmente <br>famoso, Plato Shkshuka!",
// "desc": "¡Aprende a hacer el mundialmente <br>famoso, Plato Shkshuka!",
"sml_desc":"","desc":"","img":"PostCarousel/Culinary/shakshuka-time.jpg","img_mob":"/PostCarousel/video_mob/shakshuka-time.jpg","side_img":"PostCarousel/Culinary/shakshuka-time.jpg","read_more":"READ MORE","vidId":"n4kCnPXEX7g","link":"/Posts/index.php?post=22","ctg":"culinarytelaviv","isVid":true,"forVidPage":true,"id":"Shakshuka_Time"},// Double post - The same as A_Taste_Of_Jerusalem
// {
//    "title": "Qué debe probar en Jerusalén",
//     "sml_desc" : "",
//     "desc" : "",
//     "img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
//     "side_img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=Must_Eat_In_Jerusalem",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": "Must_Eat_In_Jerusalem"
// },
{"title":"TEL AVIV EL MEJOR DESTINO VEGANO DEL MUNDO",// "sml_desc": "Voted # 1 Vegan destination in the world  ",
// "desc": "Enjoy the huge choice of vegan",
"sml_desc":"","desc":"","img":"Videos/h.jpg","img_mob":"/Videos/video_mob/h.jpg","side_img":"Videos/sidebar/h.jpg","vidId":"Gl-YB8qK5WI","read_more":"READ MORE","link":"/Posts/index.php?post=6","ctg":"culinarytelaviv","isVid":true,"forVidPage":true,"id":"Vegan_Friendly_TelAviv"},{"title":"GASTRONOMÍA EN JERUSALÉN","sml_desc":"",// "sml_desc": "Los 5 restaurantes más<br> singulares de Jerusalén",
// "desc": "Jerusalén tiene un sabor ecléctico, desde <br>comida casera a especialidades gastronómicas",
"desk":"","img":"PostCarousel/Culinary/cuisine-jer.jpg","img_mob":"/PostCarousel/video_mob/cuisine-jer.jpg","side_img":"PostCarousel/Culinary/cuisine-jer.jpg","read_more":"READ MORE","vidId":"oy9ozIvV7Co","link":"/Posts/index.php?post=13","ctg":"culinaryjerusalem","isVid":true,"forVidPage":true,"id":"Jerusalem_Cuisine"},{"title":"Cosas geniales que hacer en Tel Aviv",// "sml_desc": "Cosas geniales que hacer en Tel Aviv",
"sml_desc":"","desc":"","img":"/PostCarousel/40.jpg","side_img":"/PostCarousel/40.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=TelAviv_Adventures","ctg":"telaviv","isVid":false,"id":"TelAviv_Adventures"},{"title":"Placer de Compras",// "sml_desc": "De la alta costura a los <br>recuerdos - Jerusalén lo tiene todo",
"sml_desc":"","desc":"","img":"/PostCarousel/5.jpg","side_img":"/PostCarousel/5.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Shopping_Delights","ctg":"jerusalem","isVid":false,"forVidPage":true,"vidId":"JxSjC2kZfvI","id":"Shopping_Delights"},// No Translation
// {
//     "title": "UNFORGETTABLE YAD VASHEM",
//     "sml_desc": "",
//     "img": "thingsToDo/10.jpg",
//     "side_img": "thingsToDo/sidebar/10.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=20",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": false,
//     id: 31,
//     "showOnHome": false,
//     "ctg": "jerusalem"
// },
// No Translation
// {
//    "title": "THE GATES OF JERUSALEM",
//     "sml_desc" : "",
//     "desc" : "",
//     "img": "/PostCarousel/Jerusalem/gates.jpg",
//     "side_img": "/PostCarousel/Jerusalem/gates.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=The_Gates_Of_Jerusalem",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": "The_Gates_Of_Jerusalem"
// },
{"title":"EXCURSIONES DE DÍA","sml_desc":"",// "sml_desc" : "De puerto a puerto",
"desc":"",// "desc" : "Fabulous and fascinating one day in Tel Aviv",
"img":"/PostCarousel/TelAviv/day-is-trippin.jpg","side_img":"/PostCarousel/TelAviv/day-is-trippin.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Day_IsTrippin","isVid":false,"ctg":"telaviv","id":"Day_IsTrippin"},// No Translation
// {
//     "title": "JERUSALEM MAIN SITES",
//     // "sml_desc": "Travel back thousands of years",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/Jerusalem/main-sites-jer.jpg",
//     "side_img": "/PostCarousel/Jerusalem/main-sites-jer.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=9",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": 99
// },
// No Translation
// {
//     "title": "GOURMET TEL AVIV",
//     // "sml_desc": "The perfect place\n to treat yourself",
//     "sml_desc": "",
//     // "desc": "Tel Aviv's huge variety of amazing",
//     "desc": "",
//     "img": "Videos/e.jpg",
//     "img_mob":"/Videos/video_mob/e.jpg",
//     "side_img": "Videos/sidebar/e.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?postType=video&post=33",
//     "vidId": "jfyHxk8ZRrI",
//     "ctg": "culinarytelaviv",
//     "isVid": true,
//     "id": "Gourmet_TelAviv"
// },
// No Translation
// {
//     "title": "WESTERN WALL WONDERS",
//     "sml_desc": "",
//     "img": "thingsToDo/4.jpg",
//     "side_img": "thingsToDo/sidebar/4.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=Western_Wall_Wonders",
//     "css_class": "unic_video-post-Western_Wall_Wonders",
//     "vidId": "88OV6xU0vPI",
//     "isVid": false,
//     "id": "Western_Wall_Wonders",
//     "ctg": "jerusalem",
//     "showOnHome": false,
// },
{"title":"TEL AVIV Y JERUSALÉN",// "sml_desc": "diversión sin parar para toda la familia",
"sml_desc":"","desc":"","img":"/PostCarousel/33.jpg","side_img":"/PostCarousel/33.jpg","read_more":"Weiterlesen","link":"/Posts/index.php?post=25","isVid":false,"ctg":"telavivAndJerusalem","id":41},// No Translation
// {
//     "title": "Travelling on a Budget",
//     // "sml_desc": "Making it count in Tel Aviv and Jerusalem!",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/44.jpg",
//     "side_img": "/PostCarousel/44.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=44",
//     "isVid": false,
//     "ctg": "telavivAndJerusalem",
//     "id": 44
// },
{"title":"COMPRAS EN ISRAEL","sml_desc":"","desc":"","img":"/PostCarousel/Jerusalem/unique.jpg","side_img":"/PostCarousel/Jerusalem/unique.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Purchases_In_Israel","isVid":false,"ctg":"jerusalem","id":"Purchases_In_Israel"},// No Translation
// {
//    "title" : "Tel Aviv street food",
//     // "sml_desc" : "Tel Aviv street food",
//     "sml_desc" : "",
//     // "desc" : "A true world-class foodie destination",
//      "desc" : "",
//     "img": "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
//     "side_img": "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=Tel_Aviv_Street_Food",
//     "isVid": false,
//     "ctg": "telaviv",
//     "id": "Tel_Aviv_Street_Food"
// },
{"title":"Tel Aviv en bici",// "desc": "Get on your bicycle -<br> explore the city in style",
"sml_desc":"","desc":"","img":"PostCarousel/39.jpg","side_img":"PostCarousel/39.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=38","ctg":"telaviv","isVid":false,"forVidPage":true,"vidId":"Iyziun92P5A","id":"Cycle_TelAviv"},// No Translation
// {
//     "title": "ULTIMATE BEACH FUN",
//     "sml_desc": "",
//     // "desc": "Join the ride in the city that doesn't stop \n Get your wheels on and go anywhere they take you in this fabulous city",
//     "desc": "",
//     "img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
//     "img_mob":"/PostCarousel/video_mob/ultimate-beaches.jpg",
//     "side_img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=24",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": true,
//     "id":"Ultimate_Beach_Fun",
//     "ctg": "telaviv",
//     "showOnHome": false,
// },
// End No Translation
{"title":"Moderna y Vibrante",// "sml_desc": "Mucho que ver en el bullicioso centro de la ciudad de Jerusalén",
"sml_desc":"","desc":"","img":"/PostCarousel/19.jpg","side_img":"/PostCarousel/19.jpg","read_more":"READ MORE","link":"/Posts/index.php?postType=video&post=8","css_class":"modern-vibrant-jer","isVid":false,"forVidPage":true,"ctg":"jerusalem","id":"Modern_And_Vibrant"},// No Translation
// {
//     "title": "WHITE CITY SPLENDOR",
//     "sml_desc": "",
//     "desc": "",
//     "img": "thingsToDo/6.jpg",
//     "side_img": "thingsToDo/sidebar/6.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=20",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": false,
//     id: 28,
//     "showOnHome": false,
//     "ctg": "telaviv"
// },
// No Translation
// {
//    "title": "Jerusalem after dark fun",
//     "sml_desc" : "",
//     "desc" : "",
//     "img": "/PostCarousel/Jerusalem/after-dark-fun.jpg",
//     "side_img": "/PostCarousel/Jerusalem/after-dark-fun.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=Jerusalem_After_Dark_Fun",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": "Jerusalem_After_Dark_Fun"
// },
// Hadar asked toi hide this post
// {
//    "title": "EL MEJOR HUMUS DE JERUSALÉN",
//     "sml_desc" : "",
//     "desc" : "",
//     "img": "/PostCarousel/15.jpg",
//     "side_img": "/PostCarousel/15.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=15",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": "Humus_In_Jerusalem"
// },
{"title":"El destino de lujo definitivo",// "sml_desc": "Enjoy and Indulge",
"sml_desc":"",// "desc": "Tel Aviv - The ultimate luxury destination",
"desc":"","img":"/PostCarousel/36.jpg","side_img":"/PostCarousel/36.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=37","ctg":"telaviv","isVid":false,"id":"Enjoy_And_Indulge"},//Hadar asked to hide the video in this post on 18.01.2021
{"title":"Tiempo de cultura",// "sml_desc": "Una variedad de fascinantes<br> museos y galerías únicas",
"sml_desc":"",// "desc": "Una variedad de fascinantes <br>museos y galerías únicas",
"desc":"","img":"/PostCarousel/TelAviv/culture-telaviv.jpg","side_img":"/PostCarousel/TelAviv/culture-telaviv.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Non_Stop_Culture","isVid":false,"vidId":"JxSjC2kZfvI","forVidPage":false,"ctg":"telaviv","id":"Non_Stop_Culture"},//Hadar asked to hide the video in this post on 18.01.2021
// No Translation
// {
//     "title": "ALL SENSORY MARKETS",
//     "sml_desc": "",
//     "img": "thingsToDo/8.jpg",
//     "side_img": "thingsToDo/sidebar/8.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=20",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": false,
//     "id": "All_Sensory_Markets",
//     "showOnHome": false,
//     "ctg": "culinary"
// },
{"title":"PAUSA PARA UN CAFÉ EN TEL AVIV","sml_desc":"","desc":" ","img":"Videos/coffee.jpg","img_mob":"/Videos/video_mob/coffee.jpg","side_img":"Videos/sidebar/coffee.jpg","read_more":"READ MORE","link":"/Posts/index.php?postType=video&post=16","vidId":"s6kkkk8_Q2g","ctg":"culinarytelaviv","isVid":true,"forVidPage":true,"id":"Coffee_In_TelAviv"},(_ref2={"title":"LA OFERTA CULINARIA DE TEL AVIV","sml_desc":"","desc":"","img":"Videos/culinary-offer.jpg","img_mob":"/Videos/video_mob/culinary-offer.jpg","side_img":"Videos/sidebar/culinary-offer.jpg","vidId":"yFfkbHHWIc4","read_more":"READ MORE","link":"/Posts/index.php?post=6","ctg":"culinarytelaviv","isVid":true},_defineProperty(_ref2,"vidId","yFfkbHHWIc4"),_defineProperty(_ref2,"forVidPage",true),_defineProperty(_ref2,"id","TLV_Culinary_Offer"),_ref2),{"title":"Placeres Portuarios",// "sml_desc": "Puertos de Tel Aviv y <br>Jaffa – diferentes y fabulosos",
"sml_desc":"",// "desc": "Puertos de Tel Aviv y <br>Jaffa – diferentes y fabulosos",
"desc":"","img":"/PostCarousel/3.jpg","img_mob":"/PostCarousel/video_mob/3.jpg","side_img":"/PostCarousel/3.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Port_Pleasures","isVid":true,"forVidPage":true,"vidId":"uC5KX4MVpC0","ctg":"telaviv","id":"Port_Pleasures"},{"title":"Jamie Oliver degusta el desayuno de Tel Aviv",// "sml_desc": "Jamie Oliver gets a taste of Tel Aviv's breakfast",
"sml_desc":"","desc":"","img":"Videos/jamie-oliver.jpg","img_mob":"/Videos/video_mob/jamie-oliver.jpg","side_img":"Videos/sidebar/jamie-oliver.jpg","vidId":"gGe4W8WaIiQ","read_more":"READ MORE","link":"/Posts/index.php?post=Jamie_Oliver","ctg":"culinarytelaviv","isVid":true,"forVidPage":true,"id":"Jamie_Oliver"},// No Translation
// {
//     "title": "Party Capital",
//     // "sml_desc": "Epic Nights in the non stop city",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/42.jpg",
//     "side_img": "/PostCarousel/42.jpg",
//     "read_more": "READ MORE",
//     "link": "/Posts/index.php?post=42",
//     "isVid": false,
//     "ctg": "telaviv",
//     "id": "Party_Capital"
// },
{"title":"PLAYAS SENSACIONALES",// "sml_desc": "Come chill by the sunny beaches",
"sml_desc":"","desc":"","img":"/PostCarousel/TelAviv/sensational-beaches2.jpg","side_img":"/PostCarousel/TelAviv/sensational-beaches2.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=14","isVid":false,"ctg":"telaviv","forVidPage":true,//"id": 14
"id":"Sensational_Beaches"},{"title":"Emoción Sin Fin",// "sml_desc": "unforgettable Tel Aviv ",
"sml_desc":"","desc":"","img":"/PostCarousel/TelAviv/nonstop-excitement2.jpg","side_img":"/PostCarousel/TelAviv/nonstop-excitement2.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Nonstop_Excitement","ctg":"telaviv","isVid":false,"forVidPage":true,"id":"Nonstop_Excitement"},{"title":"Placeres Portuarios",// "sml_desc": "Puertos de Tel Aviv y <br>Jaffa – diferentes y fabulosos",
"sml_desc":"",// "desc": "Puertos de Tel Aviv y <br>Jaffa – diferentes y fabulosos",
"desc":"","img":"/PostCarousel/3.jpg","img_mob":"/PostCarousel/video_mob/3.jpg","side_img":"/PostCarousel/3.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Port_Pleasures","isVid":true,"forVidPage":true,"isDouble":true,"vidId":"uC5KX4MVpC0","ctg":"telaviv","id":"Port_Pleasures"},{"title":"El destino de lujo definitivo",// "sml_desc": "Enjoy and Indulge",
"sml_desc":"",// "desc": "Tel Aviv - The ultimate luxury destination",
"desc":"","img":"/PostCarousel/36.jpg","side_img":"/PostCarousel/36.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=37","ctg":"telaviv","isDouble":true,"isVid":false,"id":"Enjoy_And_Indulge"},// Eilat Posts
// No Translation from EXEL SEO
// {
//  "title":"EILAT",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/eilat1.jpg",
//  "side_img":"/PostCarousel/eilat1.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=EILAT1", 
//  "css_class":"unic-post-EILAT1",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'EILAT1'
// },
// {
//  "title":"Welcome to Eilat",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/welcome-to-eilat.jpg",
//  "side_img":"/PostCarousel/welcome-to-eilat.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Welcome_To_Eilat", 
//  "css_class":"unic-post-welcome-to-eilat",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'Welcome_To_Eilat'
// },
{"title":"NEOT SEMADAR","sml_desc":"","desc":"","img":"PostCarousel/Neot_Semadar.jpg","side_img":"PostCarousel/Neot_Semadar.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Neot_Semadar","css_class":"unic-post-Neot-Semadar",'isVid':false,// vidId: "ZdnNT-GDJv4",
// "isVid": false,
"forVidPage":true,"ctg":"eilat-negev","id":"Neot_Semadar"},{"title":"¿POR QUÉ EILAT ES EL MEJOR DESTINO DE VACACIONES?","sml_desc":"","desc":"","img":"/PostCarousel/the-ultimate-holiday.jpg","side_img":"/PostCarousel/the-ultimate-holiday.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=The_Ultimate_Holiday","css_class":"unic-post-the-ultimate-holiday","isVid":false,"ctg":'eilat-negev',"id":'The_Ultimate_Holiday'},{"title":"EILAT EL VERANO INTERMINABLE","sml_desc":"","desc":"","img":"/PostCarousel/eilat-calling.jpg","side_img":"/PostCarousel/eilat-calling.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Eilat_Calling","css_class":"unic-post-eilat-calling","isVid":false,"forVidPage":true,"ctg":'eilat-negev',"id":'Eilat_Calling'},{"title":"EL ARRECIFE DE DELFINES DE EILAT","sml_desc":"","desc":"","img":"/PostCarousel/eilat-doolphin-reef.jpg","side_img":"/PostCarousel/eilat-doolphin-reef.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Eilat_Doolphin_Reef","css_class":"unic-post-eilat-doolphin-reef","isVid":false,"forVidPage":true,"ctg":'eilat-negev',"id":'Eilat_Doolphin_Reef'},// No Translation from EXEL SEO
// {
//  "title":"Action Packed Eilat",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/action-packed-eilat.jpg",
//  "side_img":"/PostCarousel/action-packed-eilat.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Action_Packed_Eilat", 
//  "css_class":"unic-post-action-packed-eilat",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'Action_Packed_Eilat'
// },
// {
//  "title":"EILAT ULTIMATE BEACHSIDE",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/eilat-ultimate-beachside.jpg",
//  "side_img":"/PostCarousel/eilat-ultimate-beachside.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Eilat_Ultimate_Beachside", 
//  "css_class":"unic-post-eilat-ultimate-beachside",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'Eilat_Ultimate_Beachside'
// },
// No Translation from EXEL SEO
// {
//  "title":"One Day in Eilat",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/one-day-in-eilat.jpg",
//  "side_img":"/PostCarousel/one-day-in-eilat.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=One_Day_In_Eilat", 
//  "css_class":"unic-post-one-day-in-eilat",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'One_Day_In_Eilat'
// },
{"title":"EL MAJESTUOSO DESIERTO DE ISRAEL","sml_desc":"","desc":"","img":"/PostCarousel/majestic-desert.jpg","side_img":"/PostCarousel/majestic-desert.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Majestic_Desert","css_class":"unic-post-majestic-desert","isVid":false,"forVidPage":true,"ctg":'eilat-negev',"id":'Majestic_Desert'},// No Translation from EXEL SEO
// {
//  "title":"Negev",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/negev.jpg",
//  "side_img":"/PostCarousel/negev.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Negev1", 
//  "css_class":"unic-post-negev",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'Negev1'
// },
{"title":"ARAVÁ","sml_desc":"","desc":"","img":"/PostCarousel/ha-arava.jpg","side_img":"/PostCarousel/ha-arava.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Ha_Arava","css_class":"unic-post-ha-arava","isVid":false,"ctg":'eilat-negev',"id":'Ha_Arava'},{"title":"UBICACIÓN Y ENFOQUE","sml_desc":"","desc":"","img":"/PostCarousel/location-and-approach.jpg","side_img":"/PostCarousel/location-and-approach.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Location_And_Approach","css_class":"unic-post-location-and-approach","isVid":false,"forVidPage":true,"ctg":'eilat-negev',"id":'Location_And_Approach'},// No Translation from EXEL SEO
// {
//  "title":"STAY IN THE NEGEV",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/stay-in-the-negev.jpg",
//  "side_img":"/PostCarousel/stay-in-the-negev.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Stay_In_The_Negev", 
//  "css_class":"unic-post-stay-in-the-negev",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'Stay_In_The_Negev'
// },
// No Translation from EXEL SEO
// {
//  "title":"Pure Desert Magic",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/pure-desert-magic.jpg",
//  "side_img":"/PostCarousel/pure-desert-magic.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Pure_Desert_Magic", 
//  "css_class":"unic-post-pure-desert-magic",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'Pure_Desert_Magic'
// },
{"title":"EL NEGEV: AVENTURA EN EL DESIERTO","sml_desc":"","desc":"","img":"/PostCarousel/action-fun-in-the-desert.jpg","side_img":"/PostCarousel/action-fun-in-the-desert.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Action_Fun_In_The_Desert","css_class":"unic-post-action-fun-in-the-desert","isVid":false,"forVidPage":true,"ctg":'eilat-negev',"id":'Action_Fun_In_The_Desert'},{"title":"LA RUTA DEL INCIENSO","sml_desc":"","desc":"","img":"/PostCarousel/the-incense-route.jpg","side_img":"/PostCarousel/the-incense-route.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=The_Incense_Route","css_class":"unic-post-the-incense-route","isVid":false,"forVidPage":true,"ctg":'eilat-negev',"id":'The_Incense_Route'},// No Translation from EXEL SEO
// {
//  "title":"Mount Karkom",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/mount-karkom.jpg",
//  "side_img":"/PostCarousel/mount-karkom.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Mount_Karkom", 
//  "css_class":"unic-post-mount-karkom",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'Mount_Karkom'
// },
// No Translation from EXEL SEO
// {
//  "title":"Machtesh Ramon",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/machtes-ramon.jpg",
//  "side_img":"/PostCarousel/machtes-ramon.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Machtesh_Ramon", 
//  "css_class":"unic-post-machtes-ramon",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'Machtesh_Ramon'
// },
{"title":"EXPLORE MASADA","sml_desc":"","desc":"","img":"/PostCarousel/epic-masada.jpg","side_img":"/PostCarousel/epic-masada.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Epic_Masada","css_class":"unic-post-epic-masada","isVid":false,"forVidPage":true,"ctg":'eilat-negev',"id":'Epic_Masada'},// No Translation from EXEL SEO
// {
//  "title":"The Bedouin Experience",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/the-bedouin-experience.jpg",
//  "side_img":"/PostCarousel/the-bedouin-experience.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=The_Bedouin_Experience", 
//  "css_class":"unic-post-the-bedouin-experience",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'The_Bedouin_Experience'
// },
// No Translation from EXEL SEO
// {
//  "title":"The Israel National Trail",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/the-israel-national-trail.jpg",
//  "side_img":"/PostCarousel/the-israel-national-trail.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=The_Israel_National_Trail", 
//  "css_class":"unic-post-the-israel-national-trail",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'The_Israel_National_Trail'
// },
{"title":"PARQUE DE TIMNA","sml_desc":"","desc":"","img":"/PostCarousel/timna-treasures.jpg","side_img":"/PostCarousel/timna-treasures.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Timna_Treasures","css_class":"unic-post-timna-treasures","isVid":false,"forVidPage":true,"ctg":'eilat-negev',"id":'Timna_Treasures'},{"title":"DESIERTO DE NEGEV - NO SE LO PIERDA","sml_desc":"","desc":"","img":"/PostCarousel/negev-desert-dont-miss.jpg","side_img":"/PostCarousel/negev-desert-dont-miss.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Negev_Desert_Dont_Miss","css_class":"unic-post-negev-desert-dont-miss","isVid":false,"ctg":'eilat-negev',"id":'Negev_Desert_Dont_Miss'},{"title":"EL NEGEV: AVENTURA EN EL DESIERTO","sml_desc":"","desc":"","img":"/PostCarousel/action-fun-in-the-desert.jpg","side_img":"/PostCarousel/action-fun-in-the-desert.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Action_Fun_In_The_Desert","css_class":"unic-post-action-fun-in-the-desert","isVid":true,"vidId":"yXzhH92kREg","forVidPage":true,"isDouble":true,"ctg":'eilat-negev',"id":'Action_Fun_In_The_Desert'},// No Translation from EXEL SEO
// {
//  "title":"NEGEV CHARMS",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/negev-charms.jpg",
//  "side_img":"/PostCarousel/negev-charms.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Negev_Charms", 
//  "css_class":"unic-post-negev-charms",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'Negev_Charms'
// },
// End Eilat Posts
// North Posts
// No Translation from EXEL SEO
// {
//  "title":"Galilee",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/galilee.jpg",
//  "side_img":"/PostCarousel/galilee.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Galilee", 
//  "css_class":"unic-post-galilee",
//  "isVid" : true,
//  "ctg"   : 'north',
//   "id"    : 'Galilee'
// },
// No Translation from EXEL SEO
// {
//  "title":"Caesarea",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/caesarea.jpg",
//  "side_img":"/PostCarousel/caesarea.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Caesarea", 
//  "css_class":"unic-post-caesarea",
//  "isVid" : true,
//  "ctg"   : 'north',
//   "id"    : 'Caesarea'
// },
{"title":"CIUDAD VIEJA DE ACRE","sml_desc":"","desc":"","img":"/PostCarousel/acre.jpg","side_img":"/PostCarousel/acre.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Acre","css_class":"unic-post-acre","isVid":false,"forVidPage":true,"ctg":'north',"id":'Acre'},{"title":"HAIFA","sml_desc":"","desc":"","img":"/PostCarousel/haifa.jpg","side_img":"/PostCarousel/haifa.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Haifa","css_class":"unic-post-haifa","isVid":false,"forVidPage":true,"ctg":'north',"id":'Haifa'},{"title":"SAFED","sml_desc":"","desc":"","img":"/PostCarousel/safed.jpg","side_img":"/PostCarousel/safed.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Safed","css_class":"unic-post-safed","isVid":false,"forVidPage":true,"ctg":'north',"id":'Safed'},{"title":"La puerta de entrada al Norte de Israel","sml_desc":"","desc":"","img":"/PostCarousel/bahai-gardens.jpg","side_img":"/PostCarousel/bahai-gardens.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=The_Bahai_Gardens","css_class":"unic-post-bahai-gardens","isVid":false,"forVidPage":true,"ctg":'north',"id":'The_Bahai_Gardens'},{"title":"EL MAR DE GALILEE (Kinneret)","sml_desc":"","desc":"","img":"/PostCarousel/sea-of-galilee.jpg","side_img":"/PostCarousel/sea-of-galilee.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=The_Sea_Of_Galilee","css_class":"unic-post-sea-of-galilee","isVid":false,"forVidPage":true,"ctg":'north',"id":'The_Sea_Of_Galilee'},{"title":"ROSH PINA","sml_desc":"","desc":"","img":"/PostCarousel/rosh-pina.jpg","side_img":"/PostCarousel/rosh-pina.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Rosh_Pina","css_class":"unic-post-rosh-pina","isVid":false,"forVidPage":true,"ctg":'north',"id":'Rosh_Pina'},{"title":"NAZARET","sml_desc":"","desc":"","img":"/PostCarousel/nazareth.jpg","side_img":"/PostCarousel/nazareth.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Nazareth","css_class":"unic-post-nazareth","isVid":false,"forVidPage":true,"ctg":'north',"id":'Nazareth'},{"title":"Salud a israel","sml_desc":"","desc":"","img":"/PostCarousel/cheers-to-israel.jpg","side_img":"/PostCarousel/cheers-to-israel.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Cheers_To_Israel","css_class":"unic-post-cheers-to-israel","isVid":false,"forVidPage":true,"ctg":'culinarynorth',"id":'Cheers_To_Israel'},{"title":"UNAS VACACIONES CULINARIAS EN LA GALILEA","sml_desc":"","desc":"","img":"/PostCarousel/galilean-treat.jpg","side_img":"/PostCarousel/galilean-treat.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=A_Galilean_Treat","css_class":"unic-post-galilean-treat","isVid":false,"forVidPage":true,"ctg":'culinarynorth',"id":'A_Galilean_Treat'},{"title":"ACCIÓN EN LA GALILEA","sml_desc":"","desc":"","img":"/PostCarousel/galilee-action.jpg","side_img":"/PostCarousel/galilee-action.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Galilee_Action","css_class":"unic-post-galilee-action","isVid":false,"forVidPage":true,"ctg":'north',"id":'Galilee_Action'},{"title":"Bet She’an","sml_desc":"","desc":"","img":"/PostCarousel/bet-shean.jpg","side_img":"/PostCarousel/bet-shean.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Bet_Shean","css_class":"unic-post-bet-shean","isVid":false,"ctg":'north',"id":'Bet_Shean'},{"title":"Zichron Ya’akov","sml_desc":"","desc":"","img":"/PostCarousel/zichron-yaakov.jpg","side_img":"/PostCarousel/zichron-yaakov.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Zichron_Yaakov","css_class":"unic-post-zichron-yaakov","isVid":false,"ctg":'north',"id":'Zichron_Yaakov'},// {
//  "title":"Discover the Wine Routes",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/discover-the-wine-routes.jpg",
//  "side_img":"/PostCarousel/discover-the-wine-routes.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Discover_The_Wine_Routes", 
//  "css_class":"unic-post-discover-the-wine-routes",
//  "isVid" : true,
//  "ctg"   : 'north',
//   "id"    : 'Discover_The_Wine_Routes'
// },
{"title":"LAGO HULA","sml_desc":"","desc":"","img":"/PostCarousel/birdtastic-hula-lake.jpg","side_img":"/PostCarousel/birdtastic-hula-lake.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Birdtastic_Hula_Lake","css_class":"unic-post-birdtastic-hula-lake","isVid":false,"forVidPage":true,"ctg":'north',"id":'Birdtastic_Hula_Lake'},{"title":"THE INCOMPARABLE KIBBUTZ EXPERIENCE","sml_desc":"","desc":"","img":"/PostCarousel/kibbutz-experience.jpg","side_img":"/PostCarousel/kibbutz-experience.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=The_Kibbutz_Experience","css_class":"unic-post-kibbutz-experience","isVid":false,"ctg":'north',"id":'The_Kibbutz_Experience'},{"title":"NATIONAL PARKS","sml_desc":"","desc":"","img":"/PostCarousel/national-parks.jpg","side_img":"/PostCarousel/national-parks.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=National_Parks","css_class":"unic-post-national-parks","isVid":false,"ctg":'north',"id":'National_Parks'},{"title":"Tiberias (Tverya)","sml_desc":"","desc":"","img":"/PostCarousel/tiberias.jpg","side_img":"/PostCarousel/tiberias.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Tiberias","css_class":"unic-post-tiberias","isVid":false,"ctg":'north',"id":'Tiberias'},{"title":"DESCUBRA LOS TESOROS OCULTOS DE LA GALILEA","sml_desc":"","desc":"","img":"/PostCarousel/discover-galilei.jpg","side_img":"/PostCarousel/discover-galilei.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=Discover_Galilei","css_class":"unic-post-discover-galilei","isVid":false,"ctg":'north',"id":'Discover_Galilei'},{"title":"EL MAR DE GALILEE (Kinneret)","sml_desc":"","desc":"","img":"/PostCarousel/sea-of-galilee.jpg","side_img":"/PostCarousel/sea-of-galilee.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=The_Sea_Of_Galilee","css_class":"unic-post-sea-of-galilee","isVid":false,"isDouble":true,"forVidPage":true,"ctg":'north',"id":'The_Sea_Of_Galilee'}];// newPosts
var TouristInfoPosts=[{"title":"INMIGRACIÓN Y ADUANAS","sml_desc":"","desc":"","img":"/PostCarousel/immigration-customs.jpg","side_img":"/PostCarousel/immigration-customs.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=20","css_class":"unic-post-immigration-customs","isVid":false,"ctg":'TouristInfo',"id":'Immigration_Customs'},{"title":"QUÉ PONER EN LA MALETA","sml_desc":"","desc":"","img":"/PostCarousel/what-to-pack.jpg","side_img":"/PostCarousel/what-to-pack.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=20","css_class":"unic-post-what-to-pack","isVid":false,"ctg":'TouristInfo',"id":'What_To_Pack'},{"title":"ELECTRICIDAD","sml_desc":"","desc":"","img":"/PostCarousel/electrical-appliances.jpg","side_img":"/PostCarousel/electrical-appliances.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=20","css_class":"unic-post-electrical-appliances","isVid":false,"ctg":'TouristInfo',"id":'Electrical_Appliances'},{"title":"CLIMA","sml_desc":"","desc":"","img":"/PostCarousel/weather.jpg","side_img":"/PostCarousel/weather.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=20","css_class":"unic-post-weather","isVid":false,"ctg":'TouristInfo',"id":'Weather'},{"title":"TRANSPORTE","sml_desc":"","desc":"","img":"/PostCarousel/transportation.jpg","side_img":"/PostCarousel/transportation.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=20","css_class":"unic-post-transportation","isVid":false,"ctg":'TouristInfo',"id":'Transportation'},{"title":"PREGUNTAS MÁS FRECUENTES","sml_desc":"","desc":"","img":"/PostCarousel/faq.jpg","side_img":"/PostCarousel/faq.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=20","css_class":"unic-post-faq","isVid":false,"ctg":'TouristInfo',"id":'Frequently_Asked_Questions'},// No Translation
// {
//  "title":"Israeli Currency",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/israeli-currency.jpg",
//  "side_img":"/PostCarousel/israeli-currency.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=20", 
//  "css_class":"unic-post-israeli-currency",
//  "isVid" : false,
//  "ctg"   : 'TouristInfo',
//   "id"    : 'Israeli_Currency'
// },
{"title":"PASAPORTES Y VISAS","sml_desc":"","desc":"","img":"/PostCarousel/Passports-visa.jpg","side_img":"/PostCarousel/Passports-visa.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=20","css_class":"unic-post-Passports-visa","isVid":false,"ctg":'TouristInfo',"id":'Passports_Visa'},{"title":"UN DESTINO PARA TODOS","sml_desc":"","desc":"","img":"/PostCarousel/PlanYourTrip/destination-for-all.jpg","side_img":"/PostCarousel/PlanYourTrip/destination-for-all.jpg","read_more":"READ MORE","link":"/Posts/index.php?post=20","css_class":"unic-post-Passports-visa","isVid":false,"ctg":'TouristInfo',"id":'Destination_For_All'}];var Reminders=[// Tel Aviv
{"quote":"One of the world's 25 best cities for foodies","site":"Business Insider","img":"/References/1.jpg","ctg":"Tel Aviv"},// Jerusalem
{"quote":"TripAdvisor Traveler's Choice Award 2015","site":"TripAdvisor","img":"/References/9.jpg","ctg":"Jerusalem"},{"quote":"One of the world's leading party cities","site":"Telegraph","img":"/References/2.jpg","ctg":"Tel Aviv"},{"quote":"One of the cities with most beautiful people","site":"Conde Nast","img":"/References/3.jpg","ctg":"Tel Aviv"},{"quote":"One of the 20 must visit destinations in the world  TNS","site":"The National Student","img":"/References/10.jpg","ctg":"Jerusalem"},{"quote":"One of the best beach party spots on the planet","site":"USA Today","img":"/References/4.jpg","ctg":"Tel Aviv"},{"quote":"One of the world's top 10 beach cities","site":"National Geographic","img":"/References/5.jpg","ctg":"Tel Aviv"},{"quote":"3rd Of 6 Top world’s holiest sites","site":"National Geographic","img":"/References/11.jpg","ctg":"Jerusalem"},{"quote":"One of the world's top ten cities","site":"Lonely Planet","img":"/References/6.jpg","ctg":"Tel Aviv"},{"quote":"One of the world's top ten hedonistic city breaks ","site":"Lonely Planet","img":"/References/7.jpg","ctg":"Tel Aviv"},{"quote":"I just thought it was magical… It instantly turned into my favorite trip.","site":"TripAdvisor","img":"/References/12.jpg","ctg":"Jerusalem","job":"CEO, Stephen Kaufer about Jerusalem","cssClass":"make-it-smller"},{"quote":"The World’s New Dining Hotspot","site":"Bloomberg.com","img":"/References/8.jpg","ctg":"Tel Aviv"}];

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(124);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(134);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(68);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(135);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(139);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(141);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(69);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(38);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(143);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(147);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(148);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(77);
var isBuffer = __webpack_require__(161);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var store  = __webpack_require__(94)('wks')
  , uid    = __webpack_require__(30)
  , Symbol = __webpack_require__(12).Symbol;
module.exports = function(name){
  return store[name] || (store[name] =
    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var $          = __webpack_require__(15)
  , createDesc = __webpack_require__(55);
module.exports = __webpack_require__(31) ? function(object, key, value){
  return $.setDesc(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 15 */
/***/ (function(module, exports) {

var $Object = Object;
module.exports = {
  create:     $Object.create,
  getProto:   $Object.getPrototypeOf,
  isEnum:     {}.propertyIsEnumerable,
  getDesc:    $Object.getOwnPropertyDescriptor,
  setDesc:    $Object.defineProperty,
  setDescs:   $Object.defineProperties,
  getKeys:    $Object.keys,
  getNames:   $Object.getOwnPropertyNames,
  getSymbols: $Object.getOwnPropertySymbols,
  each:       [].forEach
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(117);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(133);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 18 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// add fake Function#toString
// for correct work wrapped methods / constructors with methods like LoDash isNative
var global    = __webpack_require__(12)
  , hide      = __webpack_require__(13)
  , SRC       = __webpack_require__(30)('src')
  , TO_STRING = 'toString'
  , $toString = Function[TO_STRING]
  , TPL       = ('' + $toString).split(TO_STRING);

__webpack_require__(20).inspectSource = function(it){
  return $toString.call(it);
};

(module.exports = function(O, key, val, safe){
  if(typeof val == 'function'){
    val.hasOwnProperty(SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
    val.hasOwnProperty('name') || hide(val, 'name', key);
  }
  if(O === global){
    O[key] = val;
  } else {
    if(!safe)delete O[key];
    hide(O, key, val);
  }
})(Function.prototype, TO_STRING, function toString(){
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

/***/ }),
/* 20 */
/***/ (function(module, exports) {

var core = module.exports = {version: '1.2.6'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slick__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SimpleSlider_css__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SimpleSlider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SimpleSlider_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// note 
// npm install react-slick
// npm install slick-carousel
// https://github.com/akiran/react-slick
/**
  use 

  import SimpleSlider from './components/SimpleSlider/SimpleSlider';
  
 <SimpleSlider settings={customSliderSettings}>
      <div><h3>Hey Man 1</h3></div>
      <div><h3>Hey Man 2</h3></div>
      <div><h3>Hey Man 3</h3></div>
      <div><h3>Hey Man 4 </h3></div>
      <div><h3>Hey Man 5 </h3></div>
      <div><h3>Hey Man  6 </h3></div>
       </SimpleSlider>
*/var SimpleSlider=function(_Component){_inherits(SimpleSlider,_Component);function SimpleSlider(props){_classCallCheck(this,SimpleSlider);var _this=_possibleConstructorReturn(this,(SimpleSlider.__proto__||Object.getPrototypeOf(SimpleSlider)).call(this,props));_this.settings=Object.assign({accessibility:false,autoplay:false,dots:true,infinite:true,speed:500,slidesToShow:1,slidesToScroll:1},_this.props.settings);return _this;}_createClass(SimpleSlider,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Slider-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_slick___default.a,this.settings,this.props.children));}}]);return SimpleSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SimpleSlider);

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(25);

var _utils2 = _interopRequireDefault(_utils);

var _animateScroll = __webpack_require__(74);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollEvents = __webpack_require__(44);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

exports.default = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var scrollOffset = _utils2.default.scrollOffset(containerElement, target) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        window.scrollTo(0, scrollOffset);
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2.default.registered['end']) {
        _scrollEvents2.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var pushHash = function pushHash(hash) {
  hash = hash ? hash.indexOf("#") === 0 ? hash : "#" + hash : "";

  if (history.pushState) {
    var loc = window.location;
    history.pushState(null, null, hash ? loc.pathname + loc.search + hash : // remove hash
    loc.pathname + loc.search);
  } else {
    location.hash = hash;
  }
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var scrollOffset = function scrollOffset(c, t) {
  return c === document ? t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) : getComputedStyle(c).position !== "static" ? t.offsetTop : t.offsetTop - c.offsetTop;
};
exports.default = {
  pushHash: pushHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forceCheck = exports.lazyload = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(16);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _event = __webpack_require__(177);

var _scrollParent = __webpack_require__(178);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _debounce = __webpack_require__(179);

var _debounce2 = _interopRequireDefault(_debounce);

var _throttle = __webpack_require__(180);

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = [];

// try to handle passive events
var passiveEventSupported = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveEventSupported = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}
// if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!
var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;

/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */
var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = _reactDom2.default.findDOMNode(component);

  var parentTop = void 0;
  var parentLeft = void 0;
  var parentHeight = void 0;
  var parentWidth = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentLeft = _parent$getBoundingCl.left;
    parentHeight = _parent$getBoundingCl.height;
    parentWidth = _parent$getBoundingCl.width;
  } catch (e) {
    parentTop = defaultBoundingClientRect.top;
    parentLeft = defaultBoundingClientRect.left;
    parentHeight = defaultBoundingClientRect.height;
    parentWidth = defaultBoundingClientRect.width;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowInnerWidth = window.innerWidth || document.documentElement.clientWidth;

  // calculate top and height of the intersection of the element's scrollParent and viewport
  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
  var intersectionLeft = Math.max(parentLeft, 0); // intersection's left relative to viewport
  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
  var intersectionWidth = Math.min(windowInnerWidth, parentLeft + parentWidth) - intersectionLeft; // width

  // check whether the element is visible in the intersection
  var top = void 0;
  var left = void 0;
  var height = void 0;
  var width = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    left = _node$getBoundingClie.left;
    height = _node$getBoundingClie.height;
    width = _node$getBoundingClie.width;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    left = defaultBoundingClientRect.left;
    height = defaultBoundingClientRect.height;
    width = defaultBoundingClientRect.width;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection
  var offsetLeft = left - intersectionLeft; // element's left relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0 && offsetLeft - offsets[0] <= intersectionWidth && offsetLeft + width + offsets[1] >= 0;
};

/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */
var checkNormalVisible = function checkNormalVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);

  // If this element is hidden by css rules somehow, it's definitely invisible
  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;

  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    elementHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};

/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */
var checkVisible = function checkVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);
  if (!(node instanceof HTMLElement)) {
    return;
  }

  var parent = (0, _scrollParent2.default)(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        pending.push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;
    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  pending.forEach(function (component) {
    var index = listeners.indexOf(component);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  });

  pending = [];
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    checkVisible(listener);
  }
  // Remove `once` component in listeners
  purgePending();
};

// Depending on component's props
var delayType = void 0;
var finalLazyLoadHandler = null;

var isString = function isString(string) {
  return typeof string === 'string';
};

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    return _this;
  }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var scrollport = window;
      var scrollContainer = this.props.scrollContainer;

      if (scrollContainer) {
        if (isString(scrollContainer)) {
          scrollport = scrollport.document.querySelector(scrollContainer);
        }
      }
      var needResetFinalLazyLoadHandler = this.props.debounce !== undefined && delayType === 'throttle' || delayType === 'debounce' && this.props.debounce === undefined;

      if (needResetFinalLazyLoadHandler) {
        (0, _event.off)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        finalLazyLoadHandler = null;
      }

      if (!finalLazyLoadHandler) {
        if (this.props.debounce !== undefined) {
          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
          delayType = 'debounce';
        } else if (this.props.throttle !== undefined) {
          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
          delayType = 'throttle';
        } else {
          finalLazyLoadHandler = lazyLoadHandler;
        }
      }

      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
          if (listenerCount === 1) {
            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
          }
          parent.setAttribute(LISTEN_FLAG, listenerCount);
        }
      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;


        if (scroll) {
          (0, _event.on)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        }

        if (resize) {
          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        }
      }

      listeners.push(this);
      checkVisible(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
          if (listenerCount === 0) {
            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
            parent.removeAttribute(LISTEN_FLAG);
          } else {
            parent.setAttribute(LISTEN_FLAG, listenerCount);
          }
        }
      }

      var index = listeners.indexOf(this);
      if (index !== -1) {
        listeners.splice(index, 1);
      }

      if (listeners.length === 0 && typeof window !== 'undefined') {
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
    }
  }]);

  return LazyLoad;
}(_react.Component);

LazyLoad.propTypes = {
  once: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  overflow: _propTypes2.default.bool,
  resize: _propTypes2.default.bool,
  scroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  placeholder: _propTypes2.default.node,
  scrollContainer: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  unmountIfInvisible: _propTypes2.default.bool
};

LazyLoad.defaultProps = {
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var decorator = function decorator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component2) {
      _inherits(LazyLoadDecorated, _Component2);

      function LazyLoadDecorated() {
        _classCallCheck(this, LazyLoadDecorated);

        var _this2 = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this2.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
        return _this2;
      }

      _createClass(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            LazyLoad,
            options,
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return LazyLoadDecorated;
    }(_react.Component);
  };
};

exports.lazyload = decorator;
exports.default = LazyLoad;
exports.forceCheck = lazyLoadHandler;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(16);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = exports.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = exports.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
};

// whether or not we can go next
var canGoNext = exports.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = exports.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = exports.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react2.default.Children.count(spec.children);
  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
  var slideWidth = void 0;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
  lazyLoadedList.concat(slidesToLoad);

  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

var slideHandler = exports.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;

  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide = void 0,
      animationLeft = void 0,
      finalLeft = void 0;
  var state = {},
      nextState = {};
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = { animating: false };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        swipeLeft: null
      };
    }
  }
  return { state: state, nextState: nextState };
};

var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;

  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (targetSlide === options.currentSlide) {
      return null;
    }
    if (infinite) {
      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
    if (targetSlide === options.currentSlide) {
      return null;
    }
  }
  return targetSlide;
};
var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;

  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft = void 0,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return { scrolling: true };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;

  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _extends({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }
  return state;
};
var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount = void 0,
        newSlide = void 0;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = currentSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
  }
  return state;
};
var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide = void 0;
    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth = void 0,
      trackHeight = void 0;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _extends({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = { opacity: 1 };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};
var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);

  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;


  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = _reactDom2.default.findDOMNode(trackRef);
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

var getPreClones = exports.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

var getPostClones = exports.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};

var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};

var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};

var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(56)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(96)
  , $export        = __webpack_require__(59)
  , redefine       = __webpack_require__(19)
  , hide           = __webpack_require__(13)
  , has            = __webpack_require__(35)
  , Iterators      = __webpack_require__(21)
  , $iterCreate    = __webpack_require__(98)
  , setToStringTag = __webpack_require__(36)
  , getProto       = __webpack_require__(15).getProto
  , ITERATOR       = __webpack_require__(9)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , methods, key;
  // Fix native
  if($native){
    var IteratorPrototype = getProto($default.call(new Base));
    // Set @@toStringTag to native iterators
    setToStringTag(IteratorPrototype, TAG, true);
    // FF fix
    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    // fix Array#{values, @@iterator}.name in V8 / FF
    if(DEF_VALUES && $native.name !== VALUES){
      VALUES_BUG = true;
      $default = function values(){ return $native.call(this); };
    }
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES  ? $default : getMethod(VALUES),
      keys:    IS_SET      ? $default : getMethod(KEYS),
      entries: !DEF_VALUES ? $default : getMethod('entries')
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(97);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 35 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(15).setDesc
  , has = __webpack_require__(35)
  , TAG = __webpack_require__(9)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(39);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollSpy = __webpack_require__(42);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _scroller = __webpack_require__(24);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollHash = __webpack_require__(75);

var _scrollHash2 = _interopRequireDefault(_scrollHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes = {
  to: _propTypes2.default.string.isRequired,
  containerId: _propTypes2.default.string,
  container: _propTypes2.default.object,
  activeClass: _propTypes2.default.string,
  spy: _propTypes2.default.bool,
  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  offset: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  isDynamic: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  absolute: _propTypes2.default.bool,
  onSetActive: _propTypes2.default.func,
  onSetInactive: _propTypes2.default.func,
  ignoreCancelEvents: _propTypes2.default.bool,
  hashSpy: _propTypes2.default.bool
};

exports.default = function (Component, customScroller) {

  var scroller = customScroller || _scroller2.default;

  var Link = function (_React$PureComponent) {
    _inherits(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      return _this;
    }

    _createClass(Link, [{
      key: 'getScrollSpyContainer',
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
            _scrollSpy2.default.mount(scrollSpyContainer);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
      }
    }, {
      key: 'render',
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var props = _extends({}, this.props);

        for (var prop in protoTypes) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.onClick = this.handleClick;

        return _react2.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends({}, _this2.state, props));
    };

    this.handleClick = function (event) {

      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (y) {

      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var to = _this2.props.to;
      var element = null;
      var elemTopBound = 0;
      var elemBottomBound = 0;
      var containerTop = 0;

      if (scrollSpyContainer.getBoundingClientRect) {
        var containerCords = scrollSpyContainer.getBoundingClientRect();
        containerTop = containerCords.top;
      }

      if (!element || _this2.props.isDynamic) {
        element = scroller.get(to);
        if (!element) {
          return;
        }

        var cords = element.getBoundingClientRect();
        elemTopBound = cords.top - containerTop + y;
        elemBottomBound = elemTopBound + cords.height;
      }

      var offsetY = y - _this2.props.offset;
      var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
      var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          _scrollHash2.default.changeHash();
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  ;

  Link.propTypes = protoTypes;

  Link.defaultProps = { offset: 0 };

  return Link;
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(154);

var _lodash2 = _interopRequireDefault(_lodash);

var _passiveEventListeners = __webpack_require__(43);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps
var eventThrottler = function eventThrottler(eventHandler) {
  return (0, _lodash2.default)(eventHandler, 66);
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy.scrollHandler(scrollSpyContainer);
      });
      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
    }
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);

    handler(scrollSpy.currentPositionY(scrollSpyContainer));
  },
  updateStates: function updateStates() {
    scrollSpy.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy.spySetState && scrollSpy.spySetState.length) {
      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy.scrollHandler);
  },


  update: function update() {
    return scrollSpy.scrollSpyContainers.forEach(function (c) {
      return scrollSpy.scrollHandler(c);
    });
  }
};

exports.default = scrollSpy;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports.default = Events;

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/*!
 * reactjs-popup v1.5.0
 * (c) 2019-present Youssouf EL AZIZI <youssoufelazizi@gmail.com>
 * Released under the MIT License.
 */


function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/* Algo to calculate position
  1. center position for popup content : the center of the trigger will be the center of the content content
      so the popup content position will be like this :
      top => the y of the center for the trigger element : trigger.top + trigger.height/2
      left => the x of the center for the trigger element : trigger.left + trigger.width/2

  2. translate position according to the first  position attribute  passed  in the function argument
      for example :
        position = 'left top'
        we need to handle the first argument in the position: 'left' => that's mean we need to translate the popup content according to the X axis by - content.width/2

  3.translate position according to the first  position attribute  passed  in the function argument
    for example :
      position = 'left top'
      the second argument 'top' => translate popup content by + content.height*4/5

  4. check if calculated position is going out of bounds of wrapper box or not. If yes repeat 1-3 for next position enum. By default wrapper box is window element
*/
function getCoordinatesForPosition(triggerBounding, ContentBounding, position, arrow, _ref) {
  var offsetX = _ref.offsetX,
      offsetY = _ref.offsetY;
  var margin = arrow ? 8 : 0;
  var args = position.split(' '); // the step N 1 : center the popup content => ok

  var CenterTop = triggerBounding.top + triggerBounding.height / 2;
  var CenterLeft = triggerBounding.left + triggerBounding.width / 2;
  var height = ContentBounding.height,
      width = ContentBounding.width;
  var top = CenterTop - height / 2;
  var left = CenterLeft - width / 2;
  var transform = '';
  var arrowTop = '0%';
  var arrowLeft = '0%'; // the  step N 2 : => ok

  switch (args[0]) {
    case 'top':
      top -= height / 2 + triggerBounding.height / 2 + margin;
      transform = "rotate(45deg)";
      arrowTop = '100%';
      arrowLeft = '50%';
      break;

    case 'bottom':
      top += height / 2 + triggerBounding.height / 2 + margin;
      transform = "rotate(225deg)";
      arrowLeft = '50%';
      break;

    case 'left':
      left -= width / 2 + triggerBounding.width / 2 + margin;
      transform = " rotate(-45deg)";
      arrowLeft = '100%';
      arrowTop = '50%';
      break;

    case 'right':
      left += width / 2 + triggerBounding.width / 2 + margin;
      transform = "rotate(135deg)";
      arrowTop = '50%';
      break;

    default:
  }

  switch (args[1]) {
    case 'top':
      top = triggerBounding.top;
      arrowTop = "".concat(triggerBounding.height / 2, "px");
      break;

    case 'bottom':
      top = triggerBounding.top - height + triggerBounding.height;
      arrowTop = "".concat(height - triggerBounding.height / 2, "px");
      break;

    case 'left':
      left = triggerBounding.left;
      arrowLeft = "".concat(triggerBounding.width / 2, "px");
      break;

    case 'right':
      left = triggerBounding.left - width + triggerBounding.width;
      arrowLeft = "".concat(width - triggerBounding.width / 2, "px");
      break;

    default:
  }

  top = args[0] === 'top' ? top - offsetY : top + offsetY;
  left = args[0] === 'left' ? left - offsetX : left + offsetX;
  return {
    top: top,
    left: left,
    transform: transform,
    arrowLeft: arrowLeft,
    arrowTop: arrowTop
  };
}

function calculatePosition(triggerBounding, ContentBounding, positions, arrow, _ref2, wrapperBox) {
  var offsetX = _ref2.offsetX,
      offsetY = _ref2.offsetY;
  var bestCoords;
  var i = 0;

  while (i < positions.length) {
    bestCoords = getCoordinatesForPosition(triggerBounding, ContentBounding, positions[i], arrow, {
      offsetX: offsetX,
      offsetY: offsetY
    });
    var contentBox = {
      top: bestCoords.top,
      left: bestCoords.left,
      width: ContentBounding.width,
      height: ContentBounding.height
    };

    if (contentBox.top <= wrapperBox.top || contentBox.left <= wrapperBox.left || contentBox.top + contentBox.height >= wrapperBox.top + wrapperBox.height || contentBox.left + contentBox.width >= wrapperBox.left + wrapperBox.width) {
      i++;
    } else {
      break;
    }
  }

  return bestCoords;
}

var styles = {
  popupContent: {
    tooltip: {
      position: 'absolute',
      zIndex: '2',
      width: '200px',
      background: "rgb(255, 255, 255)",
      border: "1px solid rgb(187, 187, 187)",
      boxShadow: "rgba(0, 0, 0, 0.2) 0px 1px 3px",
      padding: '5px'
    },
    modal: {
      position: 'relative',
      background: "rgb(255, 255, 255)",
      width: '50%',
      margin: 'auto',
      border: "1px solid rgb(187, 187, 187)",
      padding: '5px'
    }
  },
  popupArrow: {
    height: '10px',
    width: '10px',
    position: 'absolute',
    background: 'rgb(255, 255, 255)',
    transform: 'rotate(45deg)',
    margin: '-5px',
    zIndex: '-1',
    boxShadow: 'rgba(0, 0, 0, 0.2) 1px 1px 1px'
  },
  overlay: {
    tooltip: {
      position: 'fixed',
      top: '0',
      bottom: '0',
      left: '0',
      right: '0'
    },
    modal: {
      position: 'fixed',
      top: '0',
      bottom: '0',
      left: '0',
      right: '0',
      background: "rgba(0, 0, 0,0.5)",
      display: 'flex',
      zIndex: '999'
    }
  }
};

var POSITION_TYPES = ['top left', 'top center', 'top right', 'right top', 'right center', 'right bottom', 'bottom left', 'bottom center', 'bottom right', 'left top', 'left center', 'left bottom', 'center center'];

var Popup =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Popup, _React$PureComponent);

  function Popup(props) {
    var _this;

    _classCallCheck(this, Popup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popup).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "repositionOnResize", function () {
      _this.setPosition();
    });

    _defineProperty(_assertThisInitialized(_this), "onEscape", function (e) {
      if (e.key === 'Escape') _this.closePopup();
    });

    _defineProperty(_assertThisInitialized(_this), "lockScroll", function () {
      var lockScroll = _this.props.lockScroll;
      var modal = _this.state.modal;
      if (modal && lockScroll)
        /* eslint-disable-next-line no-undef */
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    });

    _defineProperty(_assertThisInitialized(_this), "resetScroll", function () {
      var lockScroll = _this.props.lockScroll;
      var modal = _this.state.modal;
      if (modal && lockScroll)
        /* eslint-disable-next-line no-undef */
        document.getElementsByTagName('body')[0].style.overflow = 'auto';
    });

    _defineProperty(_assertThisInitialized(_this), "togglePopup", function (e) {
      // https://reactjs.org/docs/events.html#event-pooling
      e.persist();
      if (_this.state.isOpen) _this.closePopup(e);else _this.openPopup(e);
    });

    _defineProperty(_assertThisInitialized(_this), "openPopup", function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onOpen = _this$props.onOpen;
      var isOpen = _this.state.isOpen;
      if (isOpen || disabled) return;
      onOpen(e);

      _this.setState({
        isOpen: true
      }, function () {
        _this.setPosition();

        _this.lockScroll();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closePopup", function (e) {
      var onClose = _this.props.onClose;
      var isOpen = _this.state.isOpen;
      if (!isOpen) return;
      onClose(e);

      _this.setState({
        isOpen: false
      }, function () {
        _this.resetScroll();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      clearTimeout(_this.timeOut);
      var mouseEnterDelay = _this.props.mouseEnterDelay;
      _this.timeOut = setTimeout(function () {
        return _this.openPopup();
      }, mouseEnterDelay);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      clearTimeout(_this.timeOut);
      var mouseLeaveDelay = _this.props.mouseLeaveDelay;
      _this.timeOut = setTimeout(function () {
        return _this.closePopup();
      }, mouseLeaveDelay);
    });

    _defineProperty(_assertThisInitialized(_this), "getTooltipBoundary", function () {
      var keepTooltipInside = _this.props.keepTooltipInside;
      var boundingBox = {
        top: 0,
        left: 0,

        /* eslint-disable-next-line no-undef */
        width: window.innerWidth,

        /* eslint-disable-next-line no-undef */
        height: window.innerHeight
      };

      if (typeof keepTooltipInside === 'string') {
        /* eslint-disable-next-line no-undef */
        var selector = document.querySelector(keepTooltipInside);

        if (false) {
          if (selector === null) throw new Error("".concat(keepTooltipInside, " selector is not exist : keepTooltipInside must be a valid html selector 'class' or 'Id'  or a boolean value"));
        }

        boundingBox = selector.getBoundingClientRect();
      }

      return boundingBox;
    });

    _defineProperty(_assertThisInitialized(_this), "setPosition", function () {
      var _this$state = _this.state,
          modal = _this$state.modal,
          isOpen = _this$state.isOpen;
      if (modal || !isOpen) return;
      var _this$props2 = _this.props,
          arrow = _this$props2.arrow,
          position = _this$props2.position,
          offsetX = _this$props2.offsetX,
          offsetY = _this$props2.offsetY,
          keepTooltipInside = _this$props2.keepTooltipInside,
          arrowStyle = _this$props2.arrowStyle,
          className = _this$props2.className;

      var helper = _this.HelperEl.getBoundingClientRect();

      var trigger = _this.TriggerEl.getBoundingClientRect();

      var content = _this.ContentEl.getBoundingClientRect();

      var boundingBox = _this.getTooltipBoundary();

      var positions = Array.isArray(position) ? position : [position]; // keepTooltipInside would be activated if the  keepTooltipInside exist or the position is Array

      if (keepTooltipInside || Array.isArray(position)) positions = [].concat(_toConsumableArray(positions), POSITION_TYPES);
      var cords = calculatePosition(trigger, content, positions, arrow, {
        offsetX: offsetX,
        offsetY: offsetY
      }, boundingBox);
      _this.ContentEl.style.top = "".concat(cords.top - helper.top, "px");
      _this.ContentEl.style.left = "".concat(cords.left - helper.left, "px");

      if (arrow) {
        _this.ArrowEl.style.transform = cords.transform;
        _this.ArrowEl.style['-ms-transform'] = cords.transform;
        _this.ArrowEl.style['-webkit-transform'] = cords.transform;
        _this.ArrowEl.style.top = arrowStyle.top || cords.arrowTop;
        _this.ArrowEl.style.left = arrowStyle.left || cords.arrowLeft;

        _this.ArrowEl.classList.add("popup-arrow");

        if (className !== '') {
          _this.ArrowEl.classList.add("".concat(className, "-arrow"));
        }
      }

      if (
      /* eslint-disable-next-line no-undef */
      window.getComputedStyle(_this.TriggerEl, null).getPropertyValue('position') === 'static' ||
      /* eslint-disable-next-line no-undef */
      window.getComputedStyle(_this.TriggerEl, null).getPropertyValue('position') === '') _this.TriggerEl.style.position = 'relative';
    });

    _defineProperty(_assertThisInitialized(_this), "addWarperAction", function () {
      var _this$props3 = _this.props,
          contentStyle = _this$props3.contentStyle,
          className = _this$props3.className,
          on = _this$props3.on;
      var modal = _this.state.modal;
      var popupContentStyle = modal ? styles.popupContent.modal : styles.popupContent.tooltip;
      var childrenElementProps = {
        className: "popup-content ".concat(className !== '' ? "".concat(className, "-content") : ''),
        style: Object.assign({}, popupContentStyle, contentStyle),
        ref: _this.setContentRef,
        onClick: function onClick(e) {
          e.stopPropagation();
        }
      };

      if (!modal && on.indexOf('hover') >= 0) {
        childrenElementProps.onMouseEnter = _this.onMouseEnter;
        childrenElementProps.onMouseLeave = _this.onMouseLeave;
      }

      return childrenElementProps;
    });

    _defineProperty(_assertThisInitialized(_this), "renderTrigger", function () {
      var triggerProps = {
        key: 'T',
        ref: _this.setTriggerRef
      };
      var _this$props4 = _this.props,
          on = _this$props4.on,
          trigger = _this$props4.trigger;
      var isOpen = _this.state.isOpen;
      var onAsArray = Array.isArray(on) ? on : [on];

      for (var i = 0, len = onAsArray.length; i < len; i++) {
        switch (onAsArray[i]) {
          case 'click':
            triggerProps.onClick = _this.togglePopup;
            break;

          case 'hover':
            triggerProps.onMouseEnter = _this.onMouseEnter;
            triggerProps.onMouseLeave = _this.onMouseLeave;
            break;

          case 'focus':
            triggerProps.onFocus = _this.onMouseEnter;
            break;

          default:
        }
      }

      if (typeof trigger === 'function') return !!trigger && __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(trigger(isOpen), triggerProps);
      return !!trigger && __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(trigger, triggerProps);
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var _this$props5 = _this.props,
          arrow = _this$props5.arrow,
          arrowStyle = _this$props5.arrowStyle,
          children = _this$props5.children;
      var _this$state2 = _this.state,
          modal = _this$state2.modal,
          isOpen = _this$state2.isOpen;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, _this.addWarperAction(), {
        key: "C"
      }), arrow && !modal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        ref: _this.setArrowRef,
        style: Object.assign({}, styles.popupArrow, arrowStyle)
      }), typeof children === 'function' ? children(_this.closePopup, isOpen) : children);
    });

    _this.setTriggerRef = function (r) {
      return _this.TriggerEl = r;
    };

    _this.setContentRef = function (r) {
      return _this.ContentEl = r;
    };

    _this.setArrowRef = function (r) {
      return _this.ArrowEl = r;
    };

    _this.setHelperRef = function (r) {
      return _this.HelperEl = r;
    };

    _this.timeOut = 0;
    var open = props.open,
        _modal = props.modal,
        defaultOpen = props.defaultOpen,
        _trigger = props.trigger;
    _this.state = {
      isOpen: open || defaultOpen,
      modal: _modal ? true : !_trigger // we create this modal state because the popup can't be a tooltip if the trigger prop doesn't exist

    };
    return _this;
  }

  _createClass(Popup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props6 = this.props,
          closeOnEscape = _this$props6.closeOnEscape,
          defaultOpen = _this$props6.defaultOpen,
          repositionOnResize = _this$props6.repositionOnResize;
      if (defaultOpen) this.setPosition();

      if (closeOnEscape) {
        /* eslint-disable-next-line no-undef */
        window.addEventListener('keyup', this.onEscape);
      }

      if (repositionOnResize) {
        /* eslint-disable-next-line no-undef */
        window.addEventListener('resize', this.repositionOnResize);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props7 = this.props,
          open = _this$props7.open,
          disabled = _this$props7.disabled;
      var isOpen = this.state.isOpen;

      if (prevProps.open !== open) {
        if (open) this.openPopup();else this.closePopup(undefined, true);
      }

      if (prevProps.disabled !== disabled && disabled && isOpen) {
        this.closePopup();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // kill any function to execute if the component is unmounted
      clearTimeout(this.timeOut);
      var _this$props8 = this.props,
          closeOnEscape = _this$props8.closeOnEscape,
          repositionOnResize = _this$props8.repositionOnResize; // remove events listeners

      if (closeOnEscape) {
        /* eslint-disable-next-line no-undef */
        window.removeEventListener('keyup', this.onEscape);
      }

      if (repositionOnResize) {
        /* eslint-disable-next-line no-undef */
        window.removeEventListener('resize', this.repositionOnResize);
      }

      this.resetScroll();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          overlayStyle = _this$props9.overlayStyle,
          closeOnDocumentClick = _this$props9.closeOnDocumentClick,
          className = _this$props9.className,
          on = _this$props9.on,
          trigger = _this$props9.trigger;
      var _this$state3 = this.state,
          modal = _this$state3.modal,
          isOpen = _this$state3.isOpen;
      var overlay = isOpen && !(on.indexOf('hover') >= 0);
      var ovStyle = modal ? styles.overlay.modal : styles.overlay.tooltip;
      return [this.renderTrigger(), isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        key: "H",
        style: {
          position: 'absolute',
          top: '0px',
          left: '0px'
        },
        ref: this.setHelperRef
      }), overlay && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        key: "O",
        className: "popup-overlay ".concat(className !== '' ? "".concat(className, "-overlay") : ''),
        style: Object.assign({}, ovStyle, overlayStyle),
        onClick: closeOnDocumentClick ? this.closePopup : undefined
      }, modal && this.renderContent()), isOpen && !modal && this.renderContent()];
    }
  }]);

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

_defineProperty(Popup, "defaultProps", {
  trigger: null,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  defaultOpen: false,
  open: false,
  disabled: false,
  closeOnDocumentClick: true,
  repositionOnResize: true,
  closeOnEscape: true,
  on: ['click'],
  contentStyle: {},
  arrowStyle: {},
  overlayStyle: {},
  className: '',
  position: 'bottom center',
  modal: false,
  lockScroll: false,
  arrow: true,
  offsetX: 0,
  offsetY: 0,
  mouseEnterDelay: 100,
  mouseLeaveDelay: 100,
  keepTooltipInside: false
});

if (false) {
  var PropTypes = require('prop-types');

  var TRIGGER_TYPES = ['hover', 'click', 'focus'];
  Popup.propTypes = {
    arrowStyle: PropTypes.object,
    contentStyle: PropTypes.object,
    overlayStyle: PropTypes.object,
    className: PropTypes.string,
    modal: PropTypes.bool,
    arrow: PropTypes.bool,
    closeOnDocumentClick: PropTypes.bool,
    repositionOnResize: PropTypes.bool,
    disabled: PropTypes.bool,
    closeOnEscape: PropTypes.bool,
    lockScroll: PropTypes.bool,
    offsetX: PropTypes.number,
    offsetY: PropTypes.number,
    mouseEnterDelay: PropTypes.number,
    mouseLeaveDelay: PropTypes.number,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    defaultOpen: PropTypes.bool,
    trigger: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    // for uncontrolled component we don't need the trigger Element
    on: PropTypes.oneOfType([PropTypes.oneOf(TRIGGER_TYPES), PropTypes.arrayOf(PropTypes.oneOf(TRIGGER_TYPES))]),
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.element, PropTypes.string]).isRequired,
    position: PropTypes.oneOfType([PropTypes.oneOf(POSITION_TYPES), PropTypes.arrayOf(PropTypes.oneOf(POSITION_TYPES))]),
    keepTooltipInside: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Popup);


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(160);

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(8);
var normalizeHeaderName = __webpack_require__(163);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(78);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(78);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)))

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShowsPostsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return newPostdata; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utility_Utility__ = __webpack_require__(1);
var _ref,_ref2;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// start live shows
// export const ShowsPostsData = [
// 	{
// 		id:1,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tom Jones \n Tel Aviv ",
//         smltitle: "The one and only Tom Jones returns to Tel Aviv for one live performance",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.tomjones.com/">
// 												www.tomjones.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/1/1.jpg"} class="img-responsive" />
// 						</div>
// 						<p>
// 							At the request of the audience and after the success of his sold-out show in 2013, the legendary performer Tom Jones returns to Israel for one live performance, to be held in Tel Aviv on Wednesday, June 28, 2017.
// 						</p>
// 						<p>
// 							Tom Jones, a world-famous living legend, is known for not allowing the diverse audience that fills his halls to sit quietly for a moment. He is a performer who captures the hearts of men and women of all ages, crosses generations and genres with his infinite inherent talent and his powerful and unique voice.
// 						</p>
// 						<p>
// 							Tom Jones has had an amazing stage career and sold over 100 million records. He has been awarded many titles including the Brit Awards for his immense musical contribution and Lifetime Achievement Award for his many achievements in the world of music and live performances at the Silver Clef (annual British Music Awards). For his contribution to the music industry, he won a star on the Hollywood Walk of Fame. In 1999, Tom Jones was awarded the Order of the British Empire (OBE) and in 2006 His Royal Highness Queen Elizabeth gave him the title of nobility and he became Sir Tom Jones.
// 						</p>
// 						<p>
// 							Jones, recognized across the world as a "hit machine", will be hitting the 24/7 city this June for the second time. As he did in his last sold out show in Tel Aviv to the delight of his audience, will be performing his all-time greatest hits.
// 						</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:2,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Britney Spears \n  Live in Concert",
//         smltitle: "Britney Spears- performing all her greatest hits in the fabulous city of Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											03.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.britneyspears.com">
// 												www.britneyspears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/2/1.jpg"} class="img-responsive" />
// 						</div>
// 						<p>
// 							Pop Icon Britney Spears is coming to Tel Aviv for the first time ever, for one show only, as part of her international tour of Asia. The show will take place in stunning Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>
// 						<p>
// 							Pop Icon Britney Spears will be coming to Israel for the first time ever for one show only as part of her international tour of Asia. The show will take place in Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>
// 						<p>
// 							Multi-platinum, Grammy Award-winning pop icon Britney Spears was born in Mississippi and raised in Louisiana, Spears became a household name as a teenager when she released her first single “…Baby One More Time,” a Billboard Hot 100 No. 1 smash and international hit that broke sales records with more than 20 million copies sold worldwide and is currently 14x Platinum in the U.S.
// 						</p>
// 						<p>
// 							Spears is one of the most successful and celebrated entertainers in pop history with nearly 150 million records worldwide. In the U.S. alone, she has sold more than 70 million albums, singles and songs, according to Nielsen Music.
// 						</p>
// 						<p>
// 							Britney’s live concerts are renowned for their amazing production and nonstop energy. Her first ever show in Tel Aviv is likely to feature some of her most recent songs from her Glory Album, including massive 2016 hit ‘Slumber Party’, and also some of her massive all-time hits such as ‘Baby One More Time’ and ‘Oops I Did It Again’!
// 						</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:3,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tears for Fears",
//         smltitle: "Tear for Fears in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											05.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.tearsforfears.com">
// 												www.tearsforfears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<p>
// 							This summer, the trendy city of Tel Aviv is embracing it’s 80s vibe for one performance only by the incomparable Tears for Fears. The legendary British pop/rock band that is responsible for many unforgettable hits is coming to the rocking city of Tel Aviv for a single awesome performance!
// 						</p>
// 						<p>
// 							Originally from Bath, Avon, Tears for Fears was founded in 1981 and was associated at first with the new wave synthesizer bands but later on became a part of mainstream rock and pop and hit international success. During the 80's the band released 3 albums that were a combination of pop, new wave and rock. Their first album from 1983, "The Hurting", reached number one in the UK albums chart and was a platinum-selling album. It included major hits such as "Pale Shelter", "Change", and "Mad World". Their second album, "Songs from the Big Chair", followed the same path and reached number one on the US Billboard 200, getting multi-platinum status in the UK and the US. It contained unforgettable hits such as "Shout", "Head Over Heels" and "Everybody Wants to Rule the World" which won the Brit Award for best British single in 1986. Their third successful album "The Seeds of Love" that came out in 1989 included the epic songs "The Seeds of Love", "Sowing Woman in Chains" and many more.
// 						</p>
// 						<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans
// 						</p>
// 						<p>
// 						Tears for Fears’ albums and singles were sold in tens of millions of copies and their songs were covered by other artists countless times. Last year the band announced they are working on a new album to be released during 2017. This July they will be gracing the nonstop city of Tel Aviv for the first time with a single performance, guaranteed to be a night to remember.
// 						</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:4,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: " Guns N' Roses  \"Not in this Lifetime\"",
//         smltitle: "Legendary Guns N' Roses is Coming Back to Rock Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											15.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.gunsnroses.com">
// 											www.gunsnroses.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								After their celebrated reunion tour last summer, which became the most profitable musical rock concert in 2016, Guns N' Roses, one of the world's most important and beloved rock bands, is coming to Tel Aviv as part of its successful tour with has already added more than 30 shows in the US and Europe.
// 							</p>
// 							<p>
// 								The concert in Tel Aviv will take place on Saturday, July 15 and, 17 at the Yarkon Park, and will close the European tour.
// 							</p>
// 							<p>
// 								Twenty-three years after standing together on the stage in Tel Aviv for the first time, the three original members of the ensemble will come back again: vocalist Axel Rose, guitarist Slash and bassist Duff McGinn, along with an impressive ensemble of musicians including drummer Frank Ferrer, keyboardist Dizzy Red (who was an integral part of the band in the 1990s) Guitarist Richard Fortus and keyboardist Melissa Reyes.
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/2.jpg"} class="img-responsive" />
// 							</div>
// 							<h3>
// 							"Not in this Lifetime"
// 							</h3>
// 							<p>
// 							Since their first reunion concert at Cochlea Festival last April, the band's tour has become one of the most sought-after shows in America with more than 2 million tickets sold.
// 							</p>
// 							<p>
// 								The success and numbers of the current tour show more than anything else that the audience's love of the band's music and rock music is more relevant and bigger than ever. The historic tour last summer visited 21 cities (25 performances) in North America.
// 							</p>
// 							<p>
// 								The band has recently completed a successful tour in South America, Brazil, Argentina and Mexico. All of band's new tour dates are completely sold out, generating massive interest among audiences. In January, the band will continue to Japan and from there to Australia, Thailand, Singapore, Dubai and will arrive in the “nonstop city” of Tel Aviv in July.
// 							</p>
// 						`
// 			}
// 		}
// 	},
// 	{
//         id:5,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: " RADIOHEAD  \n Tel Aviv",
//         smltitle: "The trailblazing RADIOHEAD bringing their iconic repertoire to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.radiohead.com">
// 											www.radiohead.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/5/1.jpeg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Preforming in Tel Aviv for the second time ever, Radiohead has managed to remain innovative, relevant and especially moving since first visiting here 17 years ago . It is a band blessed with superhuman ability to meld together distant musical influences to create a new identity for themselves and their listeners; A band whose compulsive tendency to experiment with groundbreaking sound echoed the impact of entire generations of artists and shattered it to the walls of superfluous genres; A band that changed the way we listen to music, make music, see music, think music and even buy music. Now, 17 years after they last visited here, Radiohead is coming to a concert in Tel Aviv.
// 							</p>
// 							<p>
// 								Watching Radiohead's show, it becomes clear that first and foremost, they are the authors and performers of a huge amount of unforgettable songs. Their repertoire manages to be on the one hand familiar, classical - most of us know it by heart - and on the other hand revolutionary, developing and surprising. The tight performance of the ensemble, along with the unique energy of the soloist, Tom York, transforms each performance into a one-time live experience that attracts huge audiences, to participate in the celebration of artistic evolution, to see how they grew, evolved and reinvented themselves time and time again.
// 							</p>
// 							<p>
// 								Today's Radiohead is a band with a more contemporary presence than ever before, with a glorious past and a variety that transcends all cataloging: a band that began with the Immortal Grange anthem of Creep; Slapped critics over the head with the alternative masterpiece The Bends and then committed commercial suicide - and reached heaven - twice! - with two of the best albums of all time, OK Computer and Kid A.
// 							</p>
// 							<p>
// 								The new generations who discover Radiohead through their new works - In Rainbows a favorite in Israel or the new and acclaimed album A Moon Shaped Pool - discover a band whose influences have permeated every musical genre today: rock, electronic, world, hip hop. Today's Radiohead is more than just another band, it is a world - with a unique visual language, exceptional imagery, an unreplaceable atmosphere and inner humor. Especially in Israel - a country that has always enjoyed an intimate and warm relationship with the band - Radiohead's performance is a cultural experience of the rarest kind.
// 							</p>
// 							<p>
// 							This concert will not have assigned seats, Golden Ring, VIP, unfair prices or any other division of class. Anyone who wants to sit is welcome to bring a blanket, and anyone who wants to stand close to the stage is welcome to arrive early, the ticket price is equal to all, and as many people as possible will be able to enjoy this momentous musical event.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:6,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											25-26.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<p>
// 								The Israeli summer is always hot, but the Pixies are returning to Tel Aviv after 3 years to make it even hotter!
// 							</p>
// 							<p>
// 								The famous rock band was founded in 1986 in Boston and released its first EP "Come on Pilgrim" in 1987. A year later, when their first album "Surfer Rose" came out, they became a unique voice in the American Rock. 2 years later, they released their second album "Doolittle" that is considered one of the best rock albums of all times. Their third album "Bossanova" came out in 1990 and included unforgettable songs such as "Hang Wire", "Stormy Weather", and "All Over the World".
// 							</p>
// 							<p>
// 							A year later they released their fourth album "Trompe le Monde" that featured songs such as "Planet of Sound", "Distance Equals Rate Times Time" and many more. They fell apart in 1993 but went back to performing together in 2004. After a decade of touring the world, they released their fifth album "Indie Cindy" which included songs like "Another Toe in The Ocean", "Blue Eyed Hexe", and "Jaime Bravo". To this date they released six albums, the last one, "Head Carrier" came out last year. Their biggest hits include "Hey", "Where Is My Mind", "Monkey Gone to Heaven" and "Here Comes Your Man".
// 							</p>
// 							<p>
// 								The band that is known to influence artists such as PJ Harvey and Kurt Kobain will perform this summer in Tel Aviv, giving only 7000 lucky fans the opportunity to see them live and after the rave reviews of their 2014 performance, it’s shaping up to be an unmissable night!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:7,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Regina Spektor – Back in Israel",
//         smltitle: "Regina Spektor – Back in Israel",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											19.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.reginaspektor.com">
// 											www.reginaspektor.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<p>
// 								Beloved pianist, songwriter and singer Regina Spektor is coming back to Tel Aviv for the third time, closing the worldwide tour of her recent 2016 album “Remember Us to Life” that has gotten excellent reviews.
// 							</p>
// 							<p>
// 								Regina Spektor, whose past concerts in Israel were sold out in 2007 and 2013, will perform again for one time only in Ra’anana Amphitheater on Saturday, August 19.
// 							</p>
// 							<p>
// 								Grammy and VMA nominee Regina Spektor was born in Russia, where she started her classical music training at the age of six and immigrated shortly after to the New York, where she began writing her own original songs. Her first Album came out in 2001 and a year later she already released her second album, “songs”, but her real success started after her third album, Soviet Kitsch, was out in 2004 and the fans started pouring in.
// 							</p>
// 							<p>
// 								Her international breakthrough came in 2006 with her album “Begin to Hope” that reached gold status and sold more than 500,000 copies (!!!). The album includes the single “Fidelity” that is very popular in Israel and in the rest of the world to this day and was used as part of the soundtrack of TV shows such as “Grey’s Anatomy”. Her success only became stronger when her fifth album “Far” and her sixth album “What We Saw From The Cheap Seats” got to the third place in Billboard's album chart.
// 							</p>
// 							<p>
// 								In 2013 Spektor created the theme song of the successful Netflix series “Orange Is the New Black”, called “You’ve Got Time” that also became a radio hit and got her her first Grammy Award nomination. The following year, she sang “Love Me or Leave Me” for the HBO historical crime series “Boardwalk Empire”.
// 							</p>
// 							<p>
// 								Regina Spektor is coming to the non-stop city of Tel Aviv after her sold-out tour in the United States and her old and new fans can’t wait for her show, guaranteed to light up the beautiful summer night of Tel Aviv with it’s amazing infectious energy.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:8,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Nick Cave & The Bad Seeds",
//         smltitle: "Rock legend Nick Cave & The Bad Seeds returning to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											19-20.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.nick-cave.com">
// 											www.nick-cave.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<p>
// 								19 years after his last performance in Tel Aviv, the prince of darkness returns once again with his band The Bad Seeds for two shows only to the joy of his fans in what are set to be intimate and unique performances.
// 							</p>
// 							<p>
// 								Australian musician, singer-songwriter, author, screenwriter, composer and film actor Nick Cave is well known as rock musics' "Prince of Darkness" because of his dark, intense tunes. His music is known to be emotionally intense and is characterized by a variety of influences such as death, religion, love and violence. He was called by NME "the grand lord of gothic lushness".
// 							</p>
// 							<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans.
// 							</p>
// 							<p>
// 								Cave started his musical path in the 1970's when he formed "the Boys Next Door" which became a huge success in Melbourne's post-punk scene. Their name was changed to "the Birthday Party" and the band's sound and shows took a rather violent direction and they became known as one of the darkest groups of the 1980's, they fell apart in 1983
// 							</p>
// 							<p>
// 								The end of the Birthday Party was the beginning of Nick Cave and the Bad Seeds in 1983 and they released their debut album the following year. In 1996 the band released its album "Murder Ballads" which featured "Where the Wild Roses Grow", a duet with Kylie Minogue that is also Cave's biggest commercial success to date.
// 							</p>
// 							<p>
// 								Many artists have covered Cave's songs over the years, including Metallica, Johnny Cash, and even the Arctic Monkeys.
// 							</p>
// 							<p>
// 								Nick Cave & The Bad Seeds will perform at the Menora Arena in Tel Aviv on November 19 and an additional date has been added on November 20 due to high demand. For the mere 7,000 fans who will get the chance to look the legendary Nick Cave in the eyes, this is guaranteed to be an unforgettable show!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:9,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Justin Bieber",
//         smltitle: "Justin Bieber, is landing in Tel Aviv for a single breathtaking concert",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											03.05.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.justinbiebermusic.com">
// 											www.justinbiebermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/9/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The artist with the most followers on Twitter 90,149,014
// 								The artist with the most watched official music channel online 13,518,849,954
// 								The artist with the most mentions on Youtube music channel
// 							</p>
// 							<p>
// 							Justin Bieber, the biggest international star of our day, arrives in Israel for just one concert as part of the PURPOSE WORLD TOUR, a tour bearing the name of his last album, which has sold 640,000 copies in just a week and became his bestselling album.
// 							</p>
// 							<p>
// 								Bieber, born in Ontario, Canada, learned to play piano, guitar and drums as a child. At the age of 13, with the help of his mother, he began posting videos on YouTube where he sang covers to artists such as Asher, Stevie Wonder, Chris Brown and others.
// 							</p>
// 							<p>
// 								Scooter Browne, a former marketing director at “So So Def”, was the first to spot Bieber’s talent and invited him and his mother to recordings in Atlanta.
// 							</p>
// 							<p>
// 								In 2008, Bieber was signed by Universal Records, and in 2009, "My World", the first mini-album by Bieber, including "One Time Lonely", "Love Me" and "Favorite Girl" topped the Canadian Billboard charts and the top 40 Billboard Hot 100 hits
// 							</p>
// 							<p>
// 								In 2010, he released his second album, "My World 2.0" with the single "Baby", which became a huge hit and was accompanied by the most watched YouTube video by November 24, 2012.
// 							</p>
// 							<p>
// 								In October 2015, Bieber released the second single from the album "Sorry". The dance clip for the song accumulated over 10 million views in the first 24 hours since its release.
// 							</p>
// 							<p>
// 								In November 2015 he released his fourth album "Purpose", which sold 640,000 copies in the first week and became Bieber’s best-selling album with hits such as "Love Yourself." That same month Bieber made history by placing 17 songs on the American charts and breaking the record held by the Beatles since 1964.
// 							</p>
// 							<p>
// 								In December 2015, Bieber and Skrillex won the Grammy Award for "Where are You Now".
// 							</p>
// 							<p>
// 								Justin Bieber will be performing in Israel on May 3 at Hayarkon Park, with his latest hits "love yourself" and "Sorry" and with the hits "Baby" and "As long as you love me".
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:10,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "AEROSMITH \n \"AERO-VEDERCI BABY\" ",
//         smltitle: " Aerosmith launching its tour in the rocking city of Tel Aviv  ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.aerosmith.com">
// 											www.aerosmith.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Aerosmith’s farewell concerts began several months ago in South America and will continue in 2017 in the United States and Europe. the European leg of the tour will begin in Tel Aviv and the band will go on to perform in Georgia, Russia, Germany, Poland, Denmark, Ireland, Italy, Portugal and Spain, including appearances in some of the world's leading rock festivals.
// 							</p>
// 							<p>
// 								For over 45 years, Aerosmith has been the quintessential Rock & Roll band, becoming one of the most influential and loved groups in the world. An endless list of amazing songs, many of them becoming massive worldwide hits, and their groundbreaking live shows have gained the band mass appeal for nearly half a century. Rock & Roll Hall of Fame inductees, Aerosmith, have sold over 100 million albums and won countless awards (including four Grammy Awards, eight American Music Awards, six Billboard Awards, and 12 MTV Awards).
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/2.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								<strong>Steven Tyler</strong> – "Aerosmith just got done ripping through South America like true ambassadors of rock...The band is unstoppable right now and in Europe, we're going to keep doing what we do best... Let The Music Do The Talking...Living On The Edge, and living to rock another day."
// 							</p>
// 							<p>
// 								<strong>Joe Perry </strong> – “It’s been 3 years since we have been on tour in Europe and I can speak for my brothers that we can’t wait to get over there and take it up a few notches. Last tour in South America we were running on all cylinders and I can see no reason to let up now." ;
// 							</p>
// 							<p>
// 							This May, the city of Tel Aviv will be hosting Steven Tyler, Joe Perry, Joey Kramer, Tom Hamilton and Brad Whitford in the beautiful Ganei Yehoshua Park for what promises to be an unforgettable experience and the concert of a lifetime.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:11,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Frankie Valli & The Four Seasons  ",
//         smltitle: " An American Legend in the heart of Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											4.007.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.frankievallifourseasons.com/">
// 											www.frankievallifourseasons.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/11/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The American legend comes to the rocking city of Tel Aviv for the first time ever for an unforgettable 4th of July celebration with the best timeless classics!
// 							</p>
// 							<p>
// 								The original Jersey boy, musical legend Frankie Valli, comes Tel Aviv for the first time for one single performance. Back in the 50’s, Valli started singing in harmonies with different bands in New Jersey, but the success only struck him when he grabbed the microphone in the early 60’s as the lead singer for The Four Seasons that rocked the music world in the next decades with major hits such as “Big Girls Don’t Cry”, “Sherry”, “Walk Like a Man” and more. Valli scored 29 Top 40 hits with The Four Seasons and nine Top 40 hits as a solo artist. The band sold more than 175 million albums and Valli, Tommy DeVito, Nick Massi and Bob Gaudio – the original members of The Four Seasons – were inducted into the Rock and Roll Hall of Fame in 1990 and the Vocal Group Hall of Fame in 1999.
// 							</p>
// 							<p>
// 								At the same time, Valli also has a successful solo career with songs such as the theme song for Grease, and “Can’t Take My Eyes Off You” that was covered by hundreds of artists, from The Pet Shop Boys to Muse. Younger generations got to know Valli from the remarkable musical “Jersey Boys” that tell the story of the band that is responsible for songs that became a part of our life’s soundtrack for over four decades and was turned into a movie which was directed by Clint Eastwood.
// 							</p>
// 							<p>
// 								Ever since he began, Frankie has been performing all over the world, and soon the magic will come to Tel Aviv for one unforgettable show.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:12,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Unite With Tomorrowland",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											29.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tomorrowland.com/en/unite-israel/en/welcome">
// 											www.tomorrowland.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/12/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous Tomorrowland festival might take place in Belgium, but Tel Aviv is also up for the party! Unite with Tomorrowland brings the party to the hottest city in the Middle East with live connection from the Tomorrowland Mainstage, live local and international DJ’s on the UNITE stage and of course – the magical Tomorrowland atmosphere.
// 							</p>
// 							<p>
// 								The live connection with the Mainstage in Belgium will give the People of Tomorrow the chance to connect with the crowd in Israel and vice versa. 3 mainstage headliners will be broadcasted live on a unique UNITE with Tomorrowland stage and special effects will be synchronized with the show in Belgium, creating a special global connection.
// 							</p>
// 							<p>
// 								The main headliners in Belgium will be Armin Van Buuren who has won best trance DJ at the DJ Awards 9 years in a row, was ranked among the world’s top 4 DJ’s at DJ Magazine 13 years in a row, the known electro-house duo Dimitri Vegas & Like Mike and the house sensation KSHMR. On the UNITE stage in Israel the DJs will be Steve Angello who won the DJ award for best house in 2010, the Israeli trance artist Alien Project, DJ Tomer Maizner, Dor Dekel, Teamworx, and TRIPL.
// 							</p>
// 							<p>
// 								EUnite with Tomorrowland isn’t just a livestream, it’s a one of a kind show that allows you to escape reality and join the magical world of tomorrow.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:13,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Chainsmokers",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											NEAR Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											3.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thechainsmokers.com/">
// 											www.thechainsmokers.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/13/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Tel Aviv is known for its great dance scene, so it makes perfect sense that the hottest DJ/production duo that everyone is talking about to come to get the city on its feet! The duo is responsible for many current hits such as “Don’t let me go”, “Roses”, and their recent collaboration with Coldplay “Something Just Like This”, and they will perform in Israel as part of their international tour “Memories Do Not Open”.
// 							</p>
// 							<p>
// 								The Chainsmokers consists of Andrew Taggart and Alex Pall. The duo performed live for the first time as the opening for Timeflies in 2014, and their single "#Selfie" was re-released at the same year, leading to breakthrough success as "#Selfie" became a worldwide hit and peaked on the Dance/Electronic chart. In 2015 they released their first EP “Bouquet”, featuring “New York City”, “Until You Were Gone, “Good Intentions” and “Roses”, all of which climbed the international charts and became major hits.
// 							</p>
// 							<p>
// 								A year later, the duo released their singles “Don’t Let Me Down” featuring Daya, “Inside Out”, featuring Charlee, and “Closer” featuring Halsey. The latter peaked at number one in the United Kingdom and the United States. Their success didn’t stop there and after releasing “All We Know” featuring Phoebe Ryan, they were ranked 18th in DJ Magazine’s annual list of “Top 100 DJ’s” in 2016. The same year the duo won favorite electronic/dance music artist at the American Music Awards and top dance/electronic artist at the Billboard Music Awards. A year later “Closer” also won top hot 100 songs, top collaboration and top electronic/dance song at the same Awards ceremony.  “Don’t Let Me Down” also won best dance recording in 2017 at the Grammy awards.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:14,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Dire Straits Experience",
//         smltitle: "Get a shiver in the dark in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											14.09.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.direstraitsexperience.com/">
// 											www.direstraitsexperience.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/14/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								25 years have passed since Dire Straits disbanded and we last heard that unmistakable sound of Mark Knopfler’s guitar…
// 							</p>
// 							<p>
// 								Close your eyes and get transported back to an original Dire Straits gig. Beautiful inspiring tracks, quality sound, amazing atmosphere, spine tingling riffs, vocals, instrumentals and an outstanding performance.
// 							</p>
// 							<p>
// 								After selling over 25,000 tickets in Israel within the past three years, and in light of the high demand for yet another show, The Dire Straits Experience are coming to Tel Aviv for only one night.  A single performance on the 14th of September at the Menora Mivtachim Arena.
// 							</p>
// 							<p>
// 							   The Dire Straits Experience was founded by saxophonist Chris White after their successful debut playing for a charity event at the Royal Albert Hall where members of the legendary band got back together on stage. News travelled fast, and an increasing global demand to hear the most dramatic songs in rock history played live eventually led to a worldwide tour.
// 							</p>
// 							<p>
// 							    Chris White, who recorded and performed with the rock legends for over a decade, joined Dire Straits for their record breaking “Brothers in Arms” world tour in 1985. This included their famous performance at Live Aid and later the renowned Nelson Mandela 70th birthday concert. White has played with some of the greatest rock stars the world has known, such as Paul Mccartney, Joe Cocker, Mick Jagger, Robbie Williams and many others. Joining Chris White is a stellar band consisting of some of the finest professional musicians the UK has to offer.
// 							</p>
// 							<p>
// 							   “When I was first approached to put together a band to play Dire Straits songs, I didn’t believe it would be possible to find someone who would be able to stand in Mark’s shoes without sounding like an imposter. I was wrong. In Terence Reis, I think we may have found the only person on the planet that is able to play and sing like Mark but maintain his own integrity and identity.”
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:15,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alan Parsons",
//         smltitle: "The man that said no to Pink Floyd, live in TA",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											11.11.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.alanparsonsmusic.com/">
// 											 www.alanparsonsmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/15/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The musical legend Alan Parsons and his band are coming to Israel for two shows, the first at the Congress Centre in Haifa and the second at the Menorah Mivtachim Arena in Tel Aviv.
// 							</p>
// 							<p>
// 								Parsons has a large following in Israel. In fact, this will be his third visit to the country in order to play on stage. This time they’ll be performing their new “I Robot” tour, commemorating 40 years for the release of the similarly titled mythological album in 1977. You can expect to hear all of their greatest hits of course.
// 							</p>
// 							<p>
// 								Alan Parsons is a renowned musician and one of the most influential musical producers in history. He started out as a sound technician working in the notorious Abbey Road recording studio. Alan became famous after helping to produce Pink Floyd’s masterpiece album “Dark Side of the Moon”. He has worked as a sound technician with others such as The Beatles, Wings, Al Stewart and many more.
// 							</p>
// 							<p>
// 							   In 1975, Pink Floyd invited him to work on their next album “Wish You Were Here”. Alan declined the offer in order to form his progressive rock band “The Alan Parsons Project”. The band succeeded immediately, receiving international acclaim for their huge hits “Eye in the Sky”, “Time” and “Old and Wise” to name a few.
// 							</p>
// 							<p>
// 							   An accomplished vocalist, keyboardist, bassist, guitarist and flautist receiving gold and platinum awards from many nations, Parsons also has ten Grammy Award nominations for engineering and production. Up until today The Alan Parsons Project is one of the most popular events in Europe, with tickets being sold out within hours.
// 							</p>
// 							<p>
// 							   Come indulge your ears and listen firsthand to some of the classics of our time. You can catch the concerts either in Haifa on the 9th of November or in Tel Aviv on the 11th of November.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:16,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Bryan Adams",
//         smltitle: "Bryan Adams to warm our winter with 3 shows",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv & Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											4+5+6.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bryanadams.co.il/">
// 											 www.bryanadams.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/16/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								With the summer days way behind us and the days getting shorter, a little winter comfort is necessary. What better way to warm up from the inside than with some romantic ballads and timeless rock anthems. Treat yourself (and someone you love) to a throwback of nostalgia from our younger days, reminding us those sweet moments of slow dancing, first crushes and innocent youth.
// 							</p>
// 							<p>
// 								The Canadian pop rock icon with hits spanning over four decades is coming to Israel for three consecutive shows! Two will performances in Tel Aviv on the 4th and 5th of December at the Menora Mivtachim Arena and one more concert in Jerusalem on the 6th of December at the Pais Arena.
// 							</p>
// 							<p>
// 								Born in 1959 in Kingston, Ontario, Bryan Adams’ music career took off in the early 80’s with the release of his third album “Cuts Like A Knife” which included the hit “Straight From The Heart”. It was his following album “Reckless” that skyrocketed his career and brought his rise to stardom with the hits “Run To You”, “Heaven” and “Summer of ‘69”. Following these hits Adams later brought us the U.S. Billboard Hot 100 number-one singles "Heaven", "All for Love" and "Have You Ever Really Loved a Woman?".
// 							</p>
// 							<p>
// 							  Besides topping the charts in North America and Europe, his songs were nominated for several Grammy, Golden Globe and Academy Awards. His records have collectively sold over 100 million copies worldwide, making him one of the best-selling music artists of all time.
// 							</p>
// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>
// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>
// 							<p>
// 							   Make sure you don’t miss this time-defying legend.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:17,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Chris Rock",
//         smltitle: "Coming to Tel Aviv to rock your world ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											8+9.01.18
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.chrisrock.com/">
// 											 www.chrisrock.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/17/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Chris Rock, one of the greatest standup comedians of all time and the funniest people in the world is going on a rare, highly awaited tour for the first time in 9 years. One of his few stops will be in Tel Aviv.
// 							</p>
// 							<p>
// 								The hilarious comedian has put on a new live act, after nearly a decade of focusing on television and film. Chris Rock will make his first ever live on stage appearance in Israel as part of his 2017 “Total Blackout” tour.
// 							</p>
// 							<p>
// 								Born in 1965, he made his breakthrough on SNL (Saturday Night Live) starring next to Adam Sandler, David Spade and Chris Farley. Eddie Murphy helped accelerate his stardom by giving him a role in Beverly Hills Cop 2. Since then it’s been a long line of success, from Lethal Weapon 4, Madagascar, Scary Movie, Nurse Betty and the list goes on. He’s hosted the Academy Awards twice and has also written, directed and produced several movies and TV shows. Despite all this, Chris Rock has and always will shine brightest where he truly belongs, on stage with a microphone.
// 							</p>
// 							<p>
// 							  His previous standup acts: Bigger and Blacker, Born Suspect, Bring the Pain and Kill the Messenger all broke records and are considered to be classics, with bits that are still quoted today.
//                               Rock is often compared to the greatest comedians in the field, alongside Jerry Seinfeld, Louis CK and Dave Chappelle (all of which he’s also collaborated with).
// 							</p>
// 							<p>
// 							   He made it to the top 5 in Rolling Stone magazine’s 50 greatest comedians of all time.
// 							</p>
// 							<p>
// 							   When he gets on stage it’s like seeing a boxer, a preacher and a poet all bundled together into one man. Chris delivers powerful, fast paced, side-splitting punches. His views on relationships, race and politics challenge his listeners and make them rethink everything they know. Rock dares to cross boundaries with his material and is not afraid to shock and surprise.
// 							</p>
// 							<p>
// 							   In an interview he recently gave to Rolling Stone magazine, he talked about his divorce after 18 years of marriage and how he decided to devote himself to standup again. According to him, these events gave rise to the world tour in which he will be performing in Tel Aviv.
// 							</p>
// 							<p>
// 							   Catch Chris live on January 8th at the Menorah Mivtachim Arena.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:18,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Patricia Kaas",
//         smltitle: "The great French singer returns to the white city once again",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											28.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.patriciakaas.net/">
// 											  www.patriciakaas.net
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/18/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous French singer and actress Patricia Kaas is coming back to Tel Aviv for the third time after her previous performance three years ago became a huge success and recieved incredible reviews. Kaas is considered one of the all-time most successful French singers and her music is a mix of pop, cabaret, jazz, and chanson. She started her career in the late 80’s and very quickly she climbed the charts in France.
// 							</p>
// 							<p>
// 								Kaas’s first single “Mademoiselle chante le blues” that came out in 1987 became a huge hit and got to the top 10 in the French chart. A year later she released her second single “D’Allemagne”, followed by her first album “Mademoiselle chante…” that was ranked number two at the French chart. The album sold over 100,000 copies within less than two months and became a gold album. It didn’t take long and within less than three months more than 350,000 copies were sold and it became a platinum album. Kaas received a platinum album status in Belgium, Switzerland and Canada as well, and at the same year she won the most important French music award – Victories de la Musique.
// 							</p>
// 							<p>
// 								Since then the French phenomenon sold more than 17 million albums worldwide. Her third album “Je te dis vous” brought her major success in Germany, Belgium, Switzerland, Canada, Russia, Finland, Ukraine and Korea. In 2002 she acted in a movie for the first time, it was “And now… Ladies and Gentlemen” in which she performed with the British actor Jeremy Irons. In 2009 she represented France at the Eurovision contest and got to the 8th place.
// 							</p>
// 							<p>
//                                    Patricia Kaas is responsible for many hits and her songs became a part of our lives. The talented musician is coming back to Tel Aviv to sing her famous repertoire and bring back the nostalgia to the nonstop city.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:19,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blue Man Group",
//         smltitle: "The phenomenal musical group is returning to Tel Aviv once again for a show like no other!  ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											 7-23.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.blueman.com/">
// 											  www.blueman.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/19/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Blue Man Group is coming to Tel Aviv as a part of their 25 years of living in full-color tour! This is a show unlike anything you have ever seen before that combines music, theater, art and technology.
// 							</p>
// 							<p>
// 								Originally Formed in New York in 1988 by three close friends, Chris Wink, Matt Goldman and Phil Stanton, Blue Man Group originated as a celebration of the end of the 1980s. The three men wore blue masks and led a procession that included the burning of a Rambo doll and a piece of the Berlin Wall. They caught the eye of an MTV reporter and gained attention. They started with small acts on the streets of New York, growing into shows at downtown clubs, eventually becoming a full performance at the Astor Place Theatre in 1991.
// 							</p>
// 							<p>
// 								In 1999 the band released its first gold album “Audio” and it was nominated for the Grammy Award for Best Pop Instrumental Performance. Their second album, “The Complex” (2003), features collaborations with various musicians like Gavin Rossdale, Dave Matthews and many others. It charted four songs on the Billboard charts. In 2006 they released “Live at The Venetian – Las Vegas” which was an iTunes exclusive, and their most recent album, “THREE”, came out in 2016 and was also nominated for the Grammy Award.
// 							</p>
// 							<p>
//                                  Currently, the Blue Man Group is performing on a regular basis in five theaters around the world- in Vegas, New York, Boston, Orlando and Berlin. They recently launched their new book “Blue Man World” that tells the story of the blue man from their perspective.  Three blue people that will take you on a crazy adventure full of music, laughter and surprises. More than 35 million people worldwide have already seen them, not it’s your turn!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:20,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Sean Paul",
//         smltitle: "The international mega star is coming to make our summer sizzle!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv Outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											22.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.allseanpaul.com/">
// 											  www.allseanpaul.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/20/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Grammy winner dancehall artist, Sean Paul will return to Tel Aviv for a single hot hot hot hot performance.
// 							</p>
// 							<p>
// 								Sean Paul will arrive in Tel Aviv for the third time as part of his new international tour. The artist is currently storming the international charts with a string of hits that including collaborations with some of the most popular names in music including Sia, Anne-Marie and more.
// 							</p>
// 							<p>
// 							    His extraordinary voice, rhythms, catchy songs and super-polished productions all combine the winning recipe of the Grammy winner and international star - Sean Paul. Originally known as Sean Paul Ryan Francis Henriques, Sean Paul was born in Jamaica in 1973. His musical career soared in 2002 with the tremendous success of his second studio album, "Dutty Rock," mainly for the songs "Gimmie The Light" and "Get Busy" Hot 100 chart toppers). Sean Paul has managed to maintain his relevance in the music industry since breaking into fame in the year 2000 until now with a string hits such as Cheap Thrills, Rockabye, No Lie, and Body.
// 							</p>
// 							<p>
// 							   Sean Paul studied at the University of Technology in Jamaica with aspirations for a career in the hotel industry, but his passion for music took over. The single ‘Baby Girl’ was the first to mark his successful career as a recording artist and led to his debut album ‘Stage One’ at VP Records. To date, he has released six studio albums; the last five were all nominated for the Grammy Award.
// 							</p>
// 							<p>
// 							   The album "Dutty Rock," 2002, earned him the Grammy Best Reggae Album. "The Trinity," 2005, reached platinum status in Europe and the Recording Industry Association in the United States. His albums, "Imperial Blaze" in 2009 "Tomahawk Technique" in 2012, and the last one was released in 2014 - "Recent Full Frequency" – were all warmly received and highly acclaimed.
// 							</p>
// 							<p>
//                                   His hard work, perseverance, and dedication over the years have earned him several nominations for the Grammy and Billboard awards. His most notable accomplishments include An American Music Award, Mobo Awards, Soul Train Awards, MTV Music Awards, ASCAP Rhythm and Soul Music Awards, a Source Award and a BET Award.
// 							</p>
// 							<p>
//                                 Sean Paul maintains a multinational presence thanks to his collaborations with artists in a wide variety of genres such as EDM, Soca, Pop, Afro-Beat and Latin music. His icon status allows him to maintain an immense fan base in Latin America, Japan, Europe and the US and his relationship with the Spanish audience received a serious boost, following his collaboration with the singer Farruko in the single Passion Whine and of course the legendary collaboration with Enrico Iglesias ‘Bailando’ which became no.1 in 33 (!) countries and gained millions of views on YouTube.
// 							</p>
// 							<p>
//                                Sean's collaborations throughout his career include numerous international collaborations with hip-hop stars such as Busta Rhymes, Beyoncé, Rihanna, Keyshia Cole, Kelly Rowland, Juicy J, 2Chainz and Nicki Minaj.
// 							</p>
// 							<p>
//                                Sean Paul performs regularly on the biggest most respectable venues in the world and enjoys a huge following from a worldwide audience of all ages.
// 							</p>
// 							<p>
//                                His last performance in Tel Aviv received fantastic revues from critics and fans alike, and he is back on popular demand, promising to make the hot summer scorch even more with a what is guaranteed to be a party like no other!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:21,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "The Pretenders",
//         smltitle: "The legendary rock band and Chrissie Hynde are coming to rock out Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											23.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thepretenders.com/">
// 											  www.thepretenders.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/21/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								For the past three decades Chrissie Hynde and The Pretenders stayed at the top of the British rock and won the hearts of millions of fans. Hynde took a long break from writing and recording new materials but after the raving reviews the band’s most recent album, “Alone” got, she and The Pretenders are back on a world tour and are now coming for one unforgettable show in Tel Aviv!
// 							</p>
// 							<p>
// 								The band started its way in the music world in England in 1978 and experienced numerous subsequent personnel changes, with Chrissie Hynde being the only consistent member. The original band was active until 1982 and released its first album (Pretenders) that was a success in the United Kingdom and the United States both critically and commercially. The band got to No. 1 in the UK with its single "Brass in Pocket", which was also successful in the US, reaching No. 14 on the Billboard Hot 100.
// 							</p>
// 							<p>
// 								Later on the band released nine more albums - Pretenders II (1981), Learning to Crawl (1984), Get Close (1986), Packed! (1990), Last of the Independents (1994) which was rated gold in the US, Viva el Amor (1999), Loose Screw (2002), Break Up the Concrete (2008) which was among the Top 40 album in the US, and The Pretenders’ most recent album - Alone (2016). During March 2005, the Pretenders were inducted into the Rock and Roll Hall of Fame. Among their most famous song one can remember “Brass in pocket”, “Hymn to her”, “Don’t get me wrong”, “I’ll stand by you”, and many others.
// 							</p>
// 							<p>
//                                   The Pretenders worked carefully on their new show and started their new tour at the Royal Albert Hall in London, which was full with fans that showed how much they missed the incredible band. Hynde and The Pretenders performed in music festivals all over the world, and they’ll start the second part of their tour right here in the rocking city of Tel Aviv, make sure not to miss it!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:22,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Cliff Richard",
//         smltitle: "The incomparable Cliff Richard coming back to Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											10.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.cliffrichard.org/">
// 											  www.cliffrichard.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/22/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Cliff Richard, the beloved British artist who previously performed in the fabulous city of Tel Aviv more than 20 years back, is coming back to the delight of his local fans.
// 							</p>
// 							<p>
// 								Over his long and illustrious career, the 72-year-old Cliff Richard has sold more than 260 million records worldwide and is best known for his tunes "Fallen angel Woman," "We Don't Talk Anymore," "The Young Ones," "Summer Holiday," and "Congrats" .
// 							</p>
// 							<p>
// 								Richard has a long list of hits and is responsible for many worldwide beloved songs. He has sold over 21 million singles in the UK and has become an intrinsic part of the nation’s soundtrack.
// 							</p>
// 							<p>
//                                  Richard has had eight US Top 40 singles, including the million-offering "Demon Woman" and "We Don't Talk Anymore". In Canada, Richard made a real splash during the mid-1960s, and again in the late 1970s and mid-1980s with a few singles and collections achieving gold and platinum status. He has remained a prominent music, film, and TV character in Australia, New Zealand, South Africa, Northern Europe and Asia, and has a strong following.
// 							</p>
// 							<p>
// 							   Throughout his career, spanning over 50 years, Richard has amassed numerous gold and platinum records and awards, including three Brit Awards—winning Best British Male Singer twice and the Brit Award for Outstanding Contribution to Music, as well as two Ivor Novello Awards. He has had more than 130 singles, collections and EPs make the UK Top 20, more than any other artist.
// 							</p>
// 							<p>
// 							   Richard has had 67 UK top ten singles, including one written for the great Elvis Presley.  He has had 14 UK No. 1 singles and is the leading vocalist to have had a No. 1 single in the UK in five back to back decades: the 1950s through to the 1990s.
// 							</p>
// 							<p>
// 							   This October, after much anticipation, Cliff Richard is coming to Tel Aviv to sing his mind-blowing songs live, in his unmatchable performing style. Come watch the living legend himself on-stage in the exciting city of Tel Aviv!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:23,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "DGTL Festival",
//         smltitle: "An awesome digital celebration in the one of the world’s Digital Capitals",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											05.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/?skip_portal=1">
// 											  www.tlv-digital.nl
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/23/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The first ever of its kind in the country, the DGTL festival is a dream come true for the music and nightlife scene of this buzzing metropolis. The DGTL festival is set to be by far the biggest electronic music event held in Tel Aviv, which is considered one of the nightlife capitals of the world.
// 							</p>
// 							<p>
// 								DGTL Festival, making its Tel Aviv debut this October originates in Holland and takes place each year in the most trendy capitals including Amsterdam, Sau Paulo, and Barcelona.
// 							</p>
// 							<p>
// 								The festival is an innovative technology centered event showcasing some of the world’s greatest biggest names in the digital scene alongside new hot up and comers from the industry. Tickets are often sold out in advance, and dozens of DJs and leading artists show off their talents in this a multi-sensory experience of art, music, lighting and uncompromising production standards throughout the:
// 							</p>
// 							<p>
//                                The festival has a unique and electrifying atmosphere, and audiences will also get to enjoy a variety of food stalls, art, and meticulous sound.
// 							</p>
// 							<p>
// 							   The festival will include three stages featuring excellent music at any given moment.
// 							</p>
// 							<p>
// 							   The fantastic international line up is set to include:
// 							</p>
// 							<p>
// 							  Maslow Flux, Marcel Dettman, John Talabot, Red Access, Jennifer Cardini, Avalon Emerson, Young Marko, Yotam Avni, Otarki, Joba Jobsa and many others.
// 							</p>
// 							<p>
// 							  This huge production will be launched for the first time in October 2017. In addition to being an innovative music festival, DGTL is held under the theme of environmental preservation and sustainability and is considered the greenest festival in Europe. Also, DGTL festival promotes vegetarian food only and develops a unique program for recycling materials. Alongside the local audience, the festival will be marketed in 50 countries, and thousands of music fans from all over the world are expected to arrive in Tel Aviv to take part in the party.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:24,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Richard Clayderman",
//         smltitle: "The famous pianist returns to perform in Israel with all his unforgettable hits!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											17.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.clayderman.co.uk/">
// 											  www.clayderman.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/24/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Romance lovers, prepare yourselves – after his last show in Israel three years ago, the famous French pianist Richard Clayderman returns to the holy land as a part of his new tour that marks 40 years of an outstanding career!
// 							</p>
// 							<p>
// 								Clayderman recently turned 63 and he is one of the world’s most successful pianists with a rich and diverse career that started four decades ago. He recorded over 1200 songs and his biggest hit ever is “Ballade Pour Adeline” that was sold in 22 million copies in 38 different countries. Clayderman is considered one of the world’s most successful instrumental artists along with others like Kenny G and more.
// 							</p>
// 							<p>
// 								During his career, Richard Clayderman sold more than 85 million albums and had more than 340 gold and platinum albums. He created a new romantic style through a repertoire that combines his original melodies with classics and pop standards. The phenomenal artist devoted much of his time to performing, going as far as playing 200 shows in 250 days. The Guinness Book of World Records noted him as “the most successful pianist in the world”.
// 							</p>
// 							<p>
//                                His previous visits in Israel were extremely successful with multiple sold out concerts. In his upcoming shows in Israel, Clayderman will play a selection of his best pieces, including the 12 minutes of the “Titanic Symphony”, “Don’t Cry for Me Argentina”, “Love Story”, “Ballade Pour Adeline”, and song from other famous movies such as “West Side Story”, “Harry Potter Melody” and “The Schindler List”. Come listen to the outstanding pianist who has touched the heart of millions around the world!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:25,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Smokie",
//         smltitle: "Smokie, coming to light up the stage this fall in Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv + Jerusalim
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											28+31.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//smokie.co.uk/Band">
// 											  www.smokie.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/25/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Smokie, the iconic British rock band is coming back to Tel Aviv to rock it out in the city this fall.
// 							</p>
// 							<p>
// 								Smokie initially rose to fame in the 1970's and is most know for its chart topping hits 'Living Next Door to Alice', 'Lay Back in the Arms of Someone', and "If You Think You Know How to Love Me.'
// 							</p>
// 							<p>
// 								The band has had 13 top twenty hits during the 1970s and has sold more than 30 million albums.
// 							</p>
// 							<p>
//                               Initially formed in Yorkshire, England, in 1966, Smokie hit the British pop charts a few times amid the late '70s with a fresh pop style.  The quartet recorded many singles amid the late '60s and mid '70s, and in 1975 hit number three in the U.K. with "If You Think You Know How to Love Me."
// 							</p>
// 							<p>
// 							   After another Top Ten hit, "Don't Play Your Rock’n’ Roll to Me,” the band made it big with three Top 20 hits, including "Living Next Door to Alice." Smokie hit number five both in 1977 ("It's Your Life") and 1978 ("Oh Carol(".
// 							</p>
// 							<p>
// 							   The band has performed in Tel Aviv several times and are returning shortly after their last visit to the non stop city with an extremely successful run two years ago. The Tel Aviv concert will be a part of the band’s new tour which includes England and many countries around Europe and which also includes musicians Martin Bullard, Mick McConnell, Mike Craft, Steve Pinnell and Terry Uttley.
// 							</p>
// 							<p>
// 							    Smokie’s songs have gained iconic status over the years and have been covered multiple times due to their catchy style. The band enjoys a strong fan base in the country and regularly fills every seat in the house in each of their performances. The band will be playing its greatest hits to the joy of their fans which will flock to see the rock legends in action in Tel Aviv.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:26,
//         bgImage :"/posts/bank/15/1.jpg",
//         mobBgImage :"/posts/bank/15/M.jpg",
//         title: "Foreigner",
//         smltitle: "The 80's are back to rock Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.foreigneronline.com/">
// 											  www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/26/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The 80's are coming back! The British-American hard rock group is returning once again to the amazing city of Tel Aviv. The band is returning to Israel again after 3 sold out concerts in the past – one in 2014 and two in 2016, which got incredible reviews.
// 							</p>
// 							<p>
// 								Foreigner was founded in New York in 1976 by veteran English musician Mick Jones, ex-King Crimson member Ian McDonald and American vocalist Lou Gramm. The band focused more on commercial rock and is remembered mostly for its soft ballads that topped the charts worldwide.
// 							</p>
// 							<p>
// 								The rock group released its debut album in 1977 which provided one of its most popular hits "Cold As Ice", but the band's real breakthrough happened in the early 1980's when they released the album "4". Their success continued as they released their next album "Agent Provocateur" in 1984, as well as in their last one- "Can't Slow Down", in 2009.
// 							</p>
// 							<p>
//                               The band has sold over 80 million records worldwide in the past 3 decades, out of them 37.5 were sold in the United States alone, making it one of the bestselling bands in the history. Their most memorable hits include "Waiting for a Girl Like You", "I Want to Know What Love Is", "Urgent", "Juke Box Hero", and "That Was Yesterday".
// 							</p>
// 							<p>
// 							  Come rock with the American-British legend and bring the 80's back to life in a one of a kind concert!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:27,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Carcass",
//         smltitle: "The British metal legends are coming <br>to rock the city that never sleeps!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											09.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.facebook.com/OfficialCarcass/">
// 											  facebook.com/OfficialCarcass
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/27/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The British extreme metal band was formed in 1985. They started as a school band by Bill Steer and Ken Owen, and the latter left the band soon after. Steer then joined the D-beat band Disattack and played with drummer Middie, bassist Paul and the lead singer Andrew Pek. The band later changed its name to Carcass as the members changed their musical direction. The band recorder only one album with Pek, who changed his name to Sanjiv, and shortly after "Flesh Ripping Sonic Torment" was released he left the group.
// 							</p>
// 							<p>
// 								The vocal duties were shared between Walker, Steer and Owen, and together they recorded a debut album in only four days.  The band wasn't pleased with the poor production of their album "Reek of Putrefaction" but it became a favorite of Radio 1 DJ John Peel. His interest in them made them participate in his first "Peel Session", in which they released materials for their second album.
// 							</p>
// 							<p>
// 								Carcass are considered to be the pioneers of the grindcore genre, although their early work is considered to be more splatter death metal, hardgore and goregrind. The band also became one of the pioneers of melodic death metal with their album "Heartwork" which was released in 1993. Their lyrics usually focus on animal rights issues, as both Jeff Walker and Bill Steer are vegetarians.
// 							</p>
// 							<p>
//                               In 2013 the band signed with Nuclear Blast, and in Japan they signed with Trooper Entertainment for the release of their new album. They released "Surgical Steel", which received extremely positive reviews and earned Top 50 position on the US Billboard 200 charts. Soon afterward they headlined Damnation Festival in Leeds and then performed at 70000 Tons of Metal in 2014 and headlined the Agglutination Festival the same year.
// 							</p>
// 							<p>
// 							   The band is coming to give only one show in the nonstop city of Tel Aviv, which is guaranteed to be an extraordinary experience for all the metal fans out there, make sure to get your ticket now!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:28,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Kygo",
//         smltitle: "The Norwegian house phenomena for the first time ever in Tal Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.kygomusic.com/">
// 											  www.kygomusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/28/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Kygo, originally a Norwegian pianist, became a tropical house music producer in no time. "Spotify" announced him as the biggest discovery of 2015 after his songs "Firestone" and "Stole the Show" were played over a billion times. Both of these songs also received gold and platinum status in 16 countries.
// 							</p>
// 							<p>
// 								His first album, "Cloud Nine", reached the top of the dance albums chart on "Itunes" and also on the electronic albums chart of Nielsen Soundscan. The house sensation preformed in the most popular TV shows in the United States such as "The Late Late Show" with James Corden, "The Tonight Show", "Good Morning America" with Jimmy Fallon and on Ellen Degeneres. Moreover, he was on the cover of the biggest magazines – "The Billboard", "Haute Living Magazine", "LA Times", "USA Today", "The Wall Street Journal", "The Rolling Stones", "Forbes" and more.
// 							</p>
// 							<p>
// 								Kygo started his musical journey at the age of 6 when he started learning how to play the piano. It took almost a decade for the classical music to step aside and for the new love in his life to take over – Electronic music. He only decided that he wants a career in the music industry a moment before he was about to graduate from his economics and business degree.
// 							</p>
// 							<p>
//                               His first significant breakthrough was with the hit "Firestone" that shortly grabbed the attention of tens of millions of listeners. Aviici played it in his sets and in festivals. Afterwards Coldplay's lead singer, Chris Martin, gave him permission to create a remix of their song "Midnight". Kygo's unique sound led him to incredible achievements, such as the hit "ID" that was featured in Ultra Festival's official trailer and in the playlist of FIFA 2016.
// 							</p>
// 							<p>
// 							  The extraordinary house sensation is coming to rock Tel Aviv for the first time ever, for one show only. His shows in New York and Hollywood were sold out, and the reviews were incredible. This is guaranteed to be a night to remember, you definitely want to be there!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:29,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Led Zeppelin 2",
//         smltitle: "Don’t Miss the Zeps in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv, Haifa and Be'er Sheva
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											07-10.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//zep2.com/">
// 											  www.zep2.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/29/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The tribute band from Chicago Led Zeppelin 2, which was named after the mythological band's second album, is coming to Israel for 4 shows only. Come feel the old Led Zeppelin vibes and kick it with the ultimate Led Zeppelin experience here in rocking Tel Aviv
// 							</p>
// 							<p>
// 								Led Zeppelin 2 have been performing  for over a decade and are considered to be the ultimate Led Zeppelin experience. The band consists of 4 musicians from the indie-rock, jazz and metal scene in Chicago. The lead singer, Bruce Lamont, who took the place of the legendary Robert Plant, is also a part of the avant-garde metal group "Yakuza", and he has collaborated with bands like "Dyslexic Apaches", and "Circle of Animals". His solo album "Feral Songs for The Epic Decline" was recently rated among SPIN magazine's top 20 metal albums.
// 							</p>
// 							<p>
// 								Greg Fundis, the group's drummer, is playing with leading musicians among which one can find the singer and jazz guitarist George Benson, the musician Joey De Francesco, the saxophonist Joe Lovano and more. The bassist Matthew Longbons participates in more than 200 shows a year next to leading international artists such as Alice Cooper and Matt Walker from the "Smashing Pumpkins". Paul Kamp, the group's guitarist, is known mostly from his collaboration with "Busker Soundcheck", a well-known alternative rock band.
// 							</p>
// 							<p>
//                              Led Zeppelin is considered until today to be one of the most revolutionary, influencing and successful bands in the history. They sold more than 300 million albums worldwide, with 'Led Zeppelin IV' alone selling over 37 million copies and being ranked as the third all-time best-selling album in the U.S. All 9 of the band's albums were rated in the top 10 in the U.S. chart, and 6 of them even top over the top 5. Their second album that was recorded during their first tour was a huge success both in the U.S. and in the UK, and it featured the hit 'Whole Lotta Love' that sold over a million copies.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:30,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Oh Wonder",
//         smltitle: "Live in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											16.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//ohwondermusic.com/">
// 											  www.ohwondermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/30/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Oh Wonder consist of Josephine Vander Gucht and Anthony West. In 2014 they started releasing singles every month and then they combined all of them and released a debut album that's named after them and sold over 500 million copies. This year they released their second album, "Ultralife", which had even a bigger success and reached the Top 10 in the UK charts.
// 							</p>
// 							<p>
// 								In 2015 the duo was announced by Billboard as one of the 5 biggest breakthroughs. They come to Israel this year after a long tour and performing in the biggest festivals around the world as part of the promotion of their new album, which includes hits such as "Without You" and "Drive".
// 							</p>
// 							<p>
// 								Gutcht and West played sold out shows in New York, Los Angeles, Paris and London, and now they're coming for one show only to give the people of Tel Aviv a taste of their alt-pop hits. The successful duo is guaranteed to get you dancing and give the ultimate pop experience, this will be one night in Tel Aviv you are sure to remember.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:31,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Ott & The All Seeing I",
//         smltitle: "Electro explosion in the city that never sleeps",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											15.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//ottsonic.com/">
// 											  www.ottsonic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/31/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Ott and the All Seeing I are coming to take Tel Aviv by a storm this December.
// 							</p>
// 							<p>
// 								Ott is considered to be one of the pioneers of calm, groovy electronic music and likes to record the sounds of nature in his mobile studio, with which he tours England. The British record producer and musician has worked with Sinead O'Connor, The Orb, Brian Eno and Embrace, and has achieved recognition since 2002. He's known for psychedelic dub tracks and his collaborations with other artists. He has released two albums on Twisted Records – "Blumenkraft" in 2003 and "Skylon" in 2008, and two other albums on Ottsonic – "Mir" in 2011 and "Fairchildren" in 2015.
// 							</p>
// 							<p>
// 								The electro genius performed at the Glastonbury Festival in 2007, and then in 2011 he performed at Glade Festival, a show that was described as "the perfect opening act" in an article at Virtual Festivals. The same publication also called Ott a "Psy-dub maestro" and ranked his performance 10/10. The Israeli crowd was first exposed to Ott in the early 2000's with the album "Hallucinogen in Dub", the remix album he produced for Simon Posford. All the albums he released later only enhanced the effect he has with his powerful and addictive music.
// 							</p>
// 							<p>
// 							   The All Seeing I are an English electronic music group from Sheffield, consisting of Dean Honer, Jason Buckle and DJ Parrot. Their first single "I Walk" came out in 1997, but it was only in the following year that they gained mainstream commercial success with the song "Beat Goes On". The trio worked with artists such as Tony Christie, Jarvis Cocker, Babybird, Phillip Oakey and many others.
// 							</p>
// 							 <p>
// 							    Ott has performed Tel Aviv twice in the past and his shows received incredible reviews. This is guaranteed to be a one of a kind night that you definitely don't want to miss!
// 							 </p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:32,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Take That",
//         smltitle: "Take That – Taking Tel Aviv By Storm!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											27.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//takethat.com/">
// 											  www.takethat.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/32/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The legendary British pop band is this coming November to rock Tel Aviv for one show only!
// 							</p>
// 							<p>
// 								Take That started in Manchester in 1990 and currently includes Mark Owen, Gary Barlow, and Howard Donald. The original band also featured Robbie Williams and Jason Orange. Barlow is the band's lead singer and songwriter, while Owen and Donald act as backing vocals.
// 							</p>
// 							<p>
// 								Their most memorable songs include "Pray" which won The Guardian Music Award for Best Number 1 Single, "Back For Good" which won BRIT Award for Best British Single, "Everything Changes" and "Could It Be Magic." The band released 28 top 40 singles and 17 top 5 singles in the United Kingdom, out of which 12 reached number one, and they have 7 number one albums. Internationally, the band released 56 number one singles and 37 number one albums. They won 8 Brit Awards, including awards for Best British Live Act and Best British Group.
// 							</p>
// 							<p>
// 							   The British pop sensation set the record in 2011 for the fastest-selling tour of all time in the United Kingdom with "Progress Live", beating their own personal record from 2009 with their "Circus Live Tour". They were named as Amazon's top-selling music artist of all time, and in 2012 Forbes announced them as the fifth highest-earning music stars in the world. During the same year, the Official Charts Company announced the biggest-selling singles artists in the British music chart history with Take That being placed at 15th overall and having four of the best-selling albums of the millennium, which makes them the most successful boy band in the UK chart history.
// 							</p>
// 							 <p>
// 							   The band will come to Israel as a part of its international tour in order to promote its last album "Wonderland". Their previous tours have gotten raving reviews, with "Progress" winning Audio Pro International Awards for Best Live Sound Event and Audio Pro International Awards Grand Prix Award. Their performance in Tel Aviv will for sure be a one to remember, don't miss out!
// 							 </p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:33,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Kooks",
//         smltitle: "Getting it on with the Kooks in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											27-28.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thekooks.com/">
// 											  www.thekooks.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/33/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Kooks – one of the ultimate British rock/pop bands of the century are coming this January to rock Tel Aviv as a part of "The Best of The Kooks" tour that marks a decade to their existence.
// 							</p>
// 							<p>
// 								The band was formed in Brighton, UK, in 2004 by lead singer Luke Pritchard and consists of Hugh Harris the lead guitarist, drummer Alexis Nunez and bassist Peter Denton. The band released its debut album, "Inside In/Inside Out" in 2006, which included hits such as "Ooh La" and "She Moves in Her Own Way" and achieved quadruple platinum status in the UK within a year and also abroad in the form of a platinum certification in Australia and two times platinum in Ireland.
// 							</p>
// 							<p>
// 								The group released its second album "Konk" in 2008 which debuted at number one on the UK Albums Chart and recorded first week sales of 65000, achieving gold status in both the UK and Ireland, which continued to establish their reputation as one of the world's most beloved brit-pop and post-punk bands. In 2011 their third album "Junk of the Heart" came out, followed by "Listen" in 2014 which debuted at No. 16 on the UK Albums Chart. Besides the fact that they quickly signed with "Virgin Records" only 3 months after forming, they also won several awards, such as MTV's best band of 2006 award, Best UK & Ireland Act at the MTV Europe Music Awards 2006 and even a nomination for the famous Brits award.
// 							</p>
// 							<p>
// 							  The band's music is primarily influenced by the 1960s British Invasion movement and post-punk revival of the new millennium. The Kooks have experimented in genres such as pop, reggae, ska, Britpop, rock, funk and hip-hop, and released songs that were describes as "catchy as hell".
// 							</p>
// 							 <p>
// 							  The Kooks are known for their amazing sold out shows and this one is due to be no different, so make sure to get your ticket now!
// 							 </p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:34,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Willy William and Farruko",
//         smltitle: "The reggaetón superstars coming to get you movin’ in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											  Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											28.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.reggaetontelaviv.co.il/indexEN.php">
// 											  www.reggaetontelaviv.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/34/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The reggaetón superstars coming to get you movin’ in Tel Aviv!
// 							</p>
// 							<p>
// 								Willy William and Farruko, the reggaeton megastars are coming this fall to perform as a part of the "Reggaeton Tel Aviv" festival and get the people of Tel Aviv on their feet in one extraordinary show only!
// 							</p>
// 							<p>
// 								Farruko , the 26-year-old world famous reggaton singer comes from Puerto Rico. He started his professional career in 2009 through Myspace. Since then, he released six albums and collaborated with Sean Paul, Daddy Yankee, Maluma, Don Omar, Shaggy, Nicky Jam, Ky-Many Marley, Chino&Nacho, J Balvin, Ozuna and many other successful reggaeton legends, and he was nominated for the Latin Grammy awards in 2012. His hits got millions of views on Youtube, and among them, one can find the famous "6 AM", "Passion Wine", "Me Voy Enamorando", "Krippy Kush", "Sunset" and "Chillax".
// 							</p>
// 							<p>
// 							  The 36-year-old singer, producer and DJ, Willy William is coming to Tel Aviv all the way from France. He's known for his remixes and collaborations with dance artists. His big breakthrough was in 2003 when he collaborated with DJ Flex and released his hit "B Boyz Shake da Body" and right afterwards his next song "Tragedie" and the name "Lord William". His most famous hits are "EGO" and "Mi Gente" which topped the charts in many radio stations worldwide, including Israel.
// 							</p>
// 							 <p>
// 							  Come get the addictive reggaetón vibes in you and dance the night away in the city that just won't quit!
// 							 </p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:35,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Buena Vista",
//         smltitle: "The ultimate Cuban experience in Tel Aviv & Jerusalem!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											21-26.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pasion-de-buena-vista.com/">
// 											  www.pasion-de-buena-vista.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/35/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   The ultimate Cuban experience in Tel Aviv & Jerusalem!
// 							</p>
// 							<p>
// 								After 600 shows worldwide -  the extraordinary Buena Vista Cuban sensation is coming for first time to give Tel Aviv and Jerusalem a taste of Cuba!
// 							</p>
// 							<p>
// 								The show is a one-of-a-kind experience that expresses love to the Cuban culture with all the known Cuban hits such as La Vida es un Carnaval. The Buena Vista Band includes 11 talented musicians, working together with a group of unbelievable dancers to provide an experience you never had before.
// 							</p>
// 							<p>
// 								The show will be held in two separate dates in Tel Aviv and Jerusalem, both awesome choices offering a huge host of activities and experiences in a unique unrivaled atmosphere. Jerusalem is known for its rich history, interesting architecture and incredible cultural diversity, while Tel Aviv is known for its fast tempo, warm exotic weather, amazing beaches and non-stop nightlife! Whatever city you'll choose- you visit is bound to be exciting and packed with unforgettable experiences!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:36,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Jerry Seinfeld",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											30.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jerryseinfeld.com/">
// 											  www.jerryseinfeld.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/36/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Comedy King Closing 2017 in Tel Aviv!
// 							</p>
// 							<p>
// 								Jerry Seinfeld, the undisputed king of American comedy is returning to Tel Aviv for two performances which will be held on the same night in Tel Aviv.
// 							</p>
// 							<p>
// 								Home to incredible comedy venues a sought-after location for many international comedians such as Eddie Izzard, Jim Jeffries, Chris Rock and many others, Tel Aviv has a hedonistic vibe, incredible vibrancy and energy and a liberal loose spirit making in a comedy heaven.
// 							</p>
// 							<p>
// 								Seinfeld, hailed as one of the top comedians of his generation has without a doubt shaped the way we watch television and sitcoms, with his iconic show “Seinfeld” which ran from 1990-1998 and reigned over primetime TV for nearly a decade.
// 							</p>
// 							<p>
// 							   However, Seinfeld is a man loyal to his roots and has often declared that performing live is one of his favorites and he’s coming to Tel Aviv to do Just that.
// 							</p>
// 							<p>
// 							  This December, Seinfeld will strut his stuff onstage live in his hilarious laugh- a – second style, performing two consecutive shows in the nonstop city of Tel Aviv, and what better city is there to close the 2017 with a smile?
// 							</p>
// 							<p>
// 							   For visitors coming to check out Seinfeld’s show, the city of Tel Aviv, with its winter sunshine and world-famous nightlife is without a doubt THE place to spend a fantastic and absolutely unforgettable Tel Aviv Style New Year’s Eve.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:37,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alt-J",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											29.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.altjband.com/">
// 											  www.altjband.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/37/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  The British indie band is returning to Tel Aviv once again after their last successful sold-out show in Israel two years ago. The band was formed in 2007 in England, and their debut album “An Awesome Wave” was released in 2012 and won the Mercury award the same year. The band is a combination of electro-pop, psychedelic folk, African beats, post-dubstep and rock n’ roll. The band members met through their mutual love for Radiohead while they were in college, and their sound was affected by the fact that they weren’t allowed to use a bass guitar and drums when they were students.
// 							</p>
// 							<p>
// 								The band comes to rock Tel Aviv this spring and invites fans from all over the world to come and enjoy the wonderful alternative music scene that the city that never sleeps can offer. From extraordinary art galleries to unique theatre shows to live music concerts – the cultural scene in Tel Aviv is one of a kind. It’s a home for many musicians and artists, and now it welcomes every culture lover.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:38,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ozzy Osbourne",
//         smltitle: "Ozzy O -  coming to say goodbye to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											08.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.ozzy.com/">
// 											  www.ozzy.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/38/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Ozzy O -  coming to say goodbye to Tel Aviv!
// 							</p>
// 							<p>
// 								Ozzy Osbourne, the world-famous metal legend returns to Tel Aviv for the last time as part of his farewell tour. While known to younger audiences mainly from the reality show “The Osbournes”, Ozzy was already a musical icon and a huge star since way before – from his role as the lead singer for Black Sabbath, to being the headliner in the international metal festival that was named after him, the “Ozzfest”.
// 							</p>
// 							<p>
// 							   After 2500 shows all around the world, the star comes to say goodbye to his fans in Tel Aviv, a city known around the world for its rich rock and metal scene. Being the most liberal city in Israel, Tel Aviv is always full of action and attracts both younger and older visitors who craving a taste of the underground culture. The rocking city is full of bars with rock themes, alternative clubs, live music venues and is known to attract music lovers from every country.
// 							</p>
// 							<p>
// 							   Don’t miss your chance to see the metal star for the very last time, make sure to get your ticket now and come rock it with ozzy in rockin’ Tel Aviv!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:39,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jim Jefferies",
//         smltitle: "Jim Jefferies Kicks Off 2018 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											16.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//jimjefferies.com/">
// 											  www.jimjefferies.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/39/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Jim Jefferies Kicks Off 2018 in Tel Aviv!
// 							</p>
// 							<p>
// 								One of the most popular comedians worldwide, Jim Jefferies, is returning to Tel Aviv after only a year. He will be kicking off 2018 and unleashing his famous humor with new material in a new show, “The Unusual Punishment Tour”.
// 							</p>
// 							<p>
// 							  The show will take place on a special 360-degree platform at the Menorah Mivtachim Hall in Tel Aviv, the perfect location for a comedian of his stature. Catching the show with the hilarious Australian performer is just the right excuse to come visit Tel Aviv, renowned for its exciting atmosphere and diverse nightlife scene.
// 							</p>
// 							<p>
// 							  Take the opportunity to visit one of the exciting bars or clubs which attract top International DJs, or visit one of the smaller neighborhood bars or cafes with its atmospheres to suit all tastes. Whether it’s food, drink or dancing you are after, Tel Aviv has it all.
// 							</p>
// 							<p>
// 							    After creating, writing, producing and starring in the critically acclaimed FX series, Legit, Jefferies and his material have gained a cult following. His voice has become well-known in late-night entertainment, making his show a must-see in Tel Aviv. Those coming to the Tel Aviv for Jefferies’ show will enjoy some good laughs, set on a background of stunning warm winters and an exciting night vibe.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:40,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Gerard Depardieu & Isabelle Adjani",
//         smltitle: "“Love Letters” Coming to Tel Aviv from France!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											05.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/40/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 “Love Letters” Coming to Tel Aviv from France!
// 							</p>
// 							<p>
// 								From France with love! French actors, Gerard Depardieu and Isabelle Adjani, will be performing “Love Letters” in March in Tel Aviv. Written by the late A.R. Gurney, the show has been performed on and off-Broadway by actors and actresses around the world.
// 							</p>
// 							<p>
// 							 The Pulitzer Prize-nominated show is now coming to Israel and will be performed by Gerard Depardieu and Isabelle Adjani in French, with Hebrew and Russian subtitles. With the performance taking place in Tel Aviv, visitors to the city will have the chance to enjoy some of the exotic and exciting nightlife that makes Tel Aviv so popular.
// 							</p>
// 							<p>
// 							  With restaurants to suit all palettes, dinner is just the thing for before the show, and with a nightlife that just starts to come alive around midnight, those who are looking for some adventure after the show will have plenty of options open to them. Anyone visiting the city especially for the show is sure to come away dazzled, both by the liveliness of the atmosphere and from the two well-known French stars.
// 							</p>
// 							<p>
// 							   While this is Adjani’s first trip to Israel, Depardieu has been here a number of times, and this occasion is sure to be memorable.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:41,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "A-HA",
//         smltitle: "An Electric Summer with A-HA!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											21.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://a-ha.com/">
// 											  www.a-ha.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/41/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 An Electric Summer with A-HA!
// 							</p>
// 							<p>
// 								Israel will be treated to an exciting performance from Norwegian band, A-HA, in June, 2018. Coming to Israel as part of their Electric Summer Tour 2018, the band will perform in Tel Aviv at the Exhibition Grounds in a show that promises to be a hit.
// 							</p>
// 							<p>
// 							 Formed in Oslo in 1982, A-HA has been talked about for more than three decades, and since their hit “Take On Me” in 1985, they have grown to be one of the most popular Scandinavian bands in the world. While they originally split up in 2010, they have come back together again for a number of tours and Tel Aviv is honored to be among their stops this time around.
// 							</p>
// 							<p>
// 							 Fans of the band will be treated to an exciting performance by the well-known group, while having the chance to enjoy some of the best entertainment venues in the country. From museums to theatres, restaurants to clubs, there is something to suit everyone in the bustling city of Tel Aviv.
// 							</p>
// 							<p>
// 							  Take the opportunity to enjoy a walk along the brilliant beachfront as the city’s locals get ready for the summer sun, and enjoy the vibe as diverse cultures come together for the band’s latest show.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:42,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ringo Starr",
//         smltitle: "Ringo’s All Starr Band Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											23-24.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.ringostarr.com/">
// 											 www.ringostarr.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/42/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Ringo’s All Starr Band Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								It’s been a year of stars in Tel Aviv and the latest concert to come to the dynamic city, has everyone talking! Ringo Starr will be coming to Israel as part of his European Tour and will be performing two concerts with his All Starrs Band at the Menorah Mivtachim Arena in June 2018.
// 							</p>
// 							<p>
// 							Starr, an English songwriter, singer and actor, first became famous as the drummer for the Beatles; however, since 1989, he has toured with his All Starr Band. The 77-year old released his 19th studio album in September, known as “Give More Love.”
// 							</p>
// 							<p>
// 							Tel Aviv is the ideal location for a concert with such a big name. Known as the New York City of Israel, Tel Aviv is the center of excitement, fun and initiatives in the country. As the city that attracts over a million tourists each year, whether for business or pleasure, Tel Aviv offers a beautiful beach, unique restaurants, theatres, museums and pulsing bars.
// 							</p>
// 							<p>
// 							  If you are joining the many fans who are coming to Tel Aviv to hear Ringo and his All Starrs Band perform, make sure not to miss out on the rest of what Tel Aviv has to offer and come away with an experience to remember.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:43,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Scorpions",
//         smltitle: "Tel Aviv to Go Crazy in July with The Scorpions!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.the-scorpions.com/">
// 											 www.the-scorpions.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/43/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Go Crazy in July with The Scorpions!
// 							</p>
// 							<p>
// 								One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>
// 							<p>
// 							One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>
// 							<p>
// 							Those looking to make a day of it in Tel Aviv, will have their pick of food and entertainment venues. The spirited city has become a melting pot of cultures and this is reflected in the museums, restaurants and street stalls that can be found all around the city. Enjoy cuisine to suit every palate, stroll around the interesting streets or pop into one of the many unique exhibitions that can be found around the city.
// 							</p>
// 							<p>
// 							  With the show scheduled for the beginning of the summer, it will be daylight until late and the locals will be out enjoying the sunshine. Soak up the vibe before you go on to rock the night away with The Scorpions!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:44,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Natalia Oreiro",
//         smltitle: "Natalia to Wow Tel Aviv in March",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											20.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.nataliaoreiro.com/">
// 											 www.nataliaoreiro.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/44/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							Natalia to Wow Tel Aviv in March
// 							</p>
// 							<p>
// 								South American singer and actress, Natalia Oreiro, is headed to Israel in March, where she will be performing a live concert at Menora Mivtachim Arena in Tel Aviv. Coming back to Tel Aviv, straight from Argentina, fans are looking forward to seeing the Latin star once again.
// 							</p>
// 							<p>
// 							Having performed in numerous daily series, including telenovelas and movies, and after producing 3 CDs, she will bring some of her biggest hits to the show, such as Cambio dolor, Corazon Valiente, Me Muero de Amor and Rio de la Plata y más, as she opens her new World Tour.
// 							</p>
// 							<p>
// 							Tel Aviv, which attracts celebrity singers, actors and performers from around the world, is the perfect location for the Grammy-nominated singer from Uruguay. The pumping city offers entertainment beyond the walls of the Menora Mivtachim Arena, with its trendy restaurants, upscale bars, and clubs.
// 							</p>
// 							<p>
// 							 Natalia, who has performed in Israel many times in the last 20 years, already has a following here. The show is sure to attract a large audience. Join the excitement before the performance by satisfying your taste buds in one of the many highly-acclaimed restaurants in the area or continue the celebration after the curtains have closed with a drink at a pub. Whatever your tastes, Tel Aviv is a great complement to Natalia Oreiro.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:45,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "André Rieu",
//         smltitle: "Tel Aviv to Be Treated to Rieu in 2018",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											04-05.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.andrerieu.com/">
// 											 www.andrerieu.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/45/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Be Treated to Rieu in 2018
// 							</p>
// 							<p>
// 								World-class Dutch composer and violinist, André Rieu, is coming to Tel Aviv with his Johann Strauss Orchestra for a performance that promises to be unforgettable. The two events, which are Rieu’s first in Israel, will be held at the Menora Mivtachim Arena in Tel Aviv.
// 							</p>
// 							<p>
// 							Rieu will be conducting his 60-piece orchestra while playing his famous Stradivarius violin, treating the audience to their repertoire of renowned ballads and waltzes. The event will be particularly captivating as Rieu will be presenting his new album, “Amore,” which includes a unique interpretation of Naomi Shemer’s “Jerusalem of Gold.”
// 							</p>
// 							<p>
// 							Tel Aviv, with its many facets, is just the right location for the range of musical pieces that Rieu and the Johann Strauss Orchestra will be performing. From the beach to the theater, classy restaurants to lively pubs, Tel Aviv has it all. Sit down to a posh dinner, visit a charming cafe, or enjoy a drink at a chic bar, before you end off your evening with a concert that promises no shortage of exquisite music.
// 							</p>
// 							<p>
// 							  André Rieu has become one of the most popular live acts around the world and Tel Aviv is about to find out why! Make sure you don’t miss out on the experience!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:46,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Foreigner",
//         smltitle: "Foreigner Returning to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											05.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.foreigneronline.com/">
// 											 www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/46/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Foreigner Returning to Israel in May!
// 							</p>
// 							<p>
// 								Popular British hard rock band, Foreigner, is returning to Tel Aviv in May 2018. After recently playing 2 concerts in Caesarea, the band will now be performing in the entertainment capital of the country, Tel Aviv.
// 							</p>
// 							<p>
// 							Since being founded in 1976 by Mick Jones, Foreigner has sold nearly 80 million albums across the globe. It reached the height of its popularity in the 1980s, with some of its most well-known hits including “I Want to Know What Love Is,” “I Don’t Want to Live Without You,” “That Was Yesterday” and “Waiting for a Girl Like You.”
// 							</p>
// 							<p>
// 							With the band performing at the Menora Mivtachim Arena in Tel Aviv, fans and visitors will be able to make the most of the concert and enjoy the vibe and energy of the city. Soak up the rays on the beach as the summer sun starts to make an appearance or spend the day in one of the many museums or exhibitions of the city.
// 							</p>
// 							<p>
// 							 You will be transported back to the 80’s with this popular band, while enjoying the best that Tel Aviv has to offer. Don’t miss out on the great nightlife of the clubs and pubs after the show, as you complete your evening with style!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:47,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Don Mclean",
//         smltitle: "Enjoy a Piece of “American Pie” in June!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											16.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://don-mclean.com/">
// 											 www.don-mclean.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/47/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Enjoy a Piece of “American Pie” in June!
// 							</p>
// 							<p>
// 								Famous American songwriter, Don McLean, will perform in the outskirts of Tel Aviv in June, 2018. After almost 60 years of career, McLean remains most famous for his hit song, American Pie, which came out in 1972 and is still covered by big names in the industry, such as Madonna.
// 							</p>
// 							<p>
// 							   McLean has released 40 gold and platinum records, but it is his attachment to Israel that makes him so popular here. This is particularly clear with his song, Jerusalem, which he wrote in support of the country. This time, he will be performing closer to the entertainment capital of Israel, Tel Aviv.
// 							</p>
// 							<p>
// 							    With the show taking place only 10 minutes from the hustle and bustle of the lively city, there are plenty of options for fans to make a full day of the concert. Visit one of a number of world-class museums or take in one of the many temporary exhibitions that come to the city. If you’re looking for food, there is certainly no shortage in Tel Aviv with a range of styles and tastes to suit all visitors. Soak up the sun as summer begins to arrive or enjoy the sounds and scenes of the nightlife that Tel Aviv is famous for.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:48,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Enrique Iglesias",
//         smltitle: "Tel Aviv to Host Spanish Pop Legend!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											28.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://enriqueiglesias.com/">
// 											 www.enriqueiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/48/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Tel Aviv to Host Spanish Pop Legend!
// 							</p>
// 							<p>
// 								Spanish pop legend, Enrique Iglesias, will be returning to Israel for his fourth visit, this time to perform at the Yarkon Park in Tel Aviv. While this won’t be his first time in the entertainment capital of the country, it is expected to be his largest performance to date.
// 							</p>
// 							<p>
// 							  This visit comes close on the heels of the Hebrew remix of his popular piece, “Subleme La Radio,” together with Israeli singer, Rotem Cohen. Concert-goers can look forward to hearing some of Iglesias’ hit songs which may include “Bailamos,” “Hero,” “Be With You” and “I Like It.” He is expected to perform together with his long-time guitarist, Israeli Sean Hurwitz.
// 							</p>
// 							<p>
// 							   Iglesias is predicted to be one of the most popular concerts of the year judging by the fact that it will be held in the Yarkon Park venue which can accommodate up to 100,000 people. Those looking to make a whole evening of the event will find plenty to keep them entertained in Tel Aviv before the concert starts.
// 							</p>
// 							<p>
// 							    With a wide range of eateries and pubs, there is something to suit all tastes. Enjoy the limitless choices when it comes to restaurants and pick up the vibe of the city before heading off to the main event.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:49,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blood Sweat and Tears",
//         smltitle: "Blood, Sweat & Tears Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											22.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//bloodsweatandtears.com/">
// 											 www.bloodsweatandtears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/49/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Blood, Sweat & Tears Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								Legendary rock band, Blood, Sweat & Tears, is heading to Israel for one concert to be held in Hangar 11 in Tel Aviv. The band was last in Israel 10 years ago when they played in Tel Aviv and Caesarea.
// 							</p>
// 							<p>
// 							  Established in 1967 in New York City, their best-known hits include “I Love You More than You’ll Ever Know,” “I Cannot Quit Her,” “When I Die” and “You’ve Made Me So Very Happy.” There are no original members of the band left, but seven current members will take to the stage when they perform in March. These include lead vocalist and popular runner-up to American Idol in 2005, Bo Bice.
// 							</p>
// 							<p>
// 							   Tel Aviv promises a full day of excitement for concert-goers with the opportunity to enjoy the beautiful beaches, parklands and entertainment options that the city offers before the concert even begins. Make sure to eat in one of the many restaurants scattered around the city and immerse yourself in the character of Tel Aviv by visiting one of the popular pubs or clubs that make up its charming nightlife.
// 							</p>
//                             <p>
//                                 Create the perfect night out as you combine the atmosphere of Tel Aviv with jazz and rock in a unique concert from Blood, Sweat & Tears.
//                             </p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:50,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jamiroquai",
//         smltitle: "Jamiroquai Heads to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											02.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jamiroquai.com/">
// 											 www.jamiroquai.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/50/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jamiroquai Heads to Israel in May!
// 							</p>
// 							<p>
// 								British band, Jamiroquai, is heading to Israel in May 2018, where they will perform in the outskirts of the bustling city of Tel Aviv. With only one performance in Israel, the popular band from the 90s is expected to attract a large crowd.
// 							</p>
// 							<p>
// 							  The band has published 8 studio albums, with “Automaton” being their latest from 2017. The hip city of Tel Aviv is the ideal location for a concert that promises an exciting performance by the group that introduced “future funk” and took the world by storm. Founded in 1992 by Jay Kay, Jamiroquai holds the Guinness Book of World Records listing for “Best Selling Funk Album” of all time.
// 							</p>
// 							<p>
// 							   Anyone looking for a lively night out will do well to head to this concert. Being held a short drive from the center of Tel Aviv, concert-goers will be able to begin the party early at one of the city’s top-notch restaurants, clubs or pubs. Start your evening with a quality dinner at any one of dozens of stylish restaurants and then move onto one of Tel Aviv’s famous clubs before making your way to the concert for an unforgettable night out.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:51,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Backstreet Boys",
//         smltitle: "The Backstreet Boys are Back and Larger Than Life",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											22.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.backstreetboys.com/">
// 												www.backstreetboys.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/51/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    The Backstreet Boys are Back and Larger Than Life
// 							</p>
// 							<p>
// 									The Backstreet Boys will be back in Israel this year for a concert. To be held in the outskirts of Tel Aviv in April, concert-goers will be able to enjoy the incredible vibe of the city together with some of the greatest hits in history.
// 							</p>
// 							<p>
// 									Tel Aviv is one of the most sought-after locations for big names in the entertainment industry, with its energy, vitality and spirit. There is no shortage of eateries, pubs and coffee shops for those looking for a culinary experience. Or, if you prefer to make a full day of it, you can visit some of the world-class museums, theaters or galleries around the city.
// 							</p>
// 							<p>
// 									Formed almost 20 years ago, the Backstreet Boys have produced 7 multi-platinum albums and sold more than 130 million records worldwide, with some of their most popular hits such as “I Want It That Way,” “As Long as You Love Me” and “Larger Than Life”.
// 							</p>
// 							<p>
// 									Visitors heading to the concert will be able to enjoy Tel Aviv at its best with beautiful Spring weather enticing locals and guests to the beach, before making their way to hear the best-selling boy band of all times!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:52,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alice in Chains",
//         smltitle: "Alice in Chains Announces Debut Show in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											17.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.aliceinchains.com/">
// 												www.aliceinchains.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/52/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Alice in Chains Announces Debut Show in Tel Aviv
// 							</p>
// 							<p>
// 									Making their debut appearance in Israel, rock band and grunge pioneer, Alice in Chains, will perform in July, north of Tel Aviv, in what promises to be an electrifying concert.
// 							</p>
// 							<p>
// 									Having come together in the late 80’s, Alice in Chains is one of four major groups that led the grunge revolution, and they became one of the most influential bands of all time. With music that combines rock, alternative rock and metal, the band was nominated for 9 Grammy awards and sold more than 20 million albums.
// 							</p>
// 							<p>
// 									Taking place in the middle of summer, Tel Aviv is the perfect location to start the day’s activities. If you’re looking for some indoor entertainment, visit one of the city’s world-class museums or galleries, or head over to one of the many restaurants around the city. For something a bit different, soak up the rays walking along the promenade of a beautiful beach or pop into a club or pub in the area before heading north for the concert.
// 							</p>
// 							<p>
// 									This show is part of the first European tour the band has been on in four years, and being its first appearance ever in Israel, it promises to be a night full of excitement.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:53,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Hardwell",
//         smltitle: "Hardwell Headed to Israel in April",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											06.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.djhardwell.com/">
// 												www.djhardwell.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/53/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Hardwell Headed to Israel in April
// 							</p>
// 							<p>
// 									Number 1 ranking DJ, Hardwell, is coming to Israel in April where he will thrill crowds just outside Tel Aviv. This will be his third concert in the country, after performing to sell-out audiences in 2013 and 2017.
// 							</p>
// 							<p>
// 									Robbert van de Corput, better known as DJ Hardwell, first made a name for himself at the young age of 14, but it was at age 25 when he truly became famous, named World’s #1 DJ by the 2013 DJ Mag. Hardwell has become an International name, hosting his own radio show which is broadcast around the world, and producing a consistently top 10 iTunes podcast. He is also well known for his remix of The Wanted’s “Chasing the Sun”.
// 							</p>
// 							<p>
// 									Tel Aviv is the ideal location for a concert of this type with the natural vibe and energy of the city adding to the excitement that will be in the air. Tel Aviv in Spring is full of blue skies and warm weather, attracting crowds to the beach and the outdoor cafes and restaurants that can be found throughout the city. Enjoy a full day out or join the gathering of people at one of the city’s world-class restaurants before heading to the concert.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:54,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jethro Tull",
//         smltitle: "Jethro Tull’s 50th Anniversary Tour Heads to Israel",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											27-28.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jethrotull.com/">
// 												jethrotull.com/
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/54/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jethro Tull’s 50th Anniversary Tour Heads to Israel
// 							</p>
// 							<p>
// 									Ian Anderson, vocalist, flutist, and guitarist of the popular British rock band, Jethro Tull, is coming to Israel for the band’s 50th anniversary tour. Performances will take place at Heichal Hatarbut in Tel Aviv on October 27, followed by the International Convention Center in Jerusalem on October 28.
// 							</p>
// 							<p>
// 									Formed in 1967, the band initially played blues rock, but later evolved and developed elements of hard rock. Their greatest success came in the 1970s with hit songs such as “Bungle In The Jungle,” “Living In The Past,” and “The Witch’s Promise.” The band has performed in Israel numerous times in the past, and Anderson who is the only remaining member of the band who is coming on tour, is expected to receive a warm welcome.
// 							</p>
// 							<p>
// 									Performing in both Tel Aviv and Jerusalem will appeal to a wide audience. Join the energy and vibe of the lively city of Tel Aviv with its nightlife, culinary experiences and beautiful beaches, or enjoy the concert in the cultural and historic center of the country, which is Jerusalem. No matter which flavor of the region you prefer, there are plenty of restaurants, cafes, museums or galleries to visit in each of the cities before the venues open their doors.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:55,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Israel Calling",
//         smltitle: "Good Evening Europe, This is Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											08-10.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<!--	<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->
// 							<h2>
// 							   Good Evening Europe,<br class="show-on-mobile"> This is Tel Aviv!
// 							</h2>
// 							<p>
// 								Eurovision fever is sweeping over Tel Aviv as it confirms hosting the star and glitter studded event - “Israel Calling”, for the 3rd consecutive year!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/55/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								About 30 delegates from Eurovision participating countries worldwide will be gathering at the beginning of April in the nonstop city of Tel Aviv, for the largest Eurovision promo-event to ever take place in front of a crowd of thousands from Israel and around Europe.
// 							</p>
// 							<p>
// 								This unique and exciting event, held only in Tel Aviv, will give Eurovision fans from far and wide an amazing and completely free of charge opportunity to take part in the glamour of the Eurovision right here in the beautiful city of Tel Aviv.
// 						</p>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/2.jpg"} class="img-responsive" />
// 						</div>
// 						<p>
// 						The event will be held for three days starting on the 8th of April. The main stage will be set in Rabin Square, Tel Aviv’s main square and one of the city’s favorite outdoor venues, located at the heart of the buzzing city.
// 						</p>
// 						<p>
// 						The main event will take place on Tuesday and will include a mini Eurovision show in front of a live audience, featuring performances by the various Eurovision contenders performing the songs they will be competing with on the main event in May.
// 						</p>
// 						<p>
// 						This much anticipated pre-Eurovision event is set to take place just a few minutes’ walk from the stunning Tel Aviv beach. Fans and music lovers coming to see the show will get to take in all the city has to offer, including the excellent bars, restaurants and the awesome nightlife in this world-famous ultimate vacation destination called Tel Aviv.
// 						</p>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/3.jpg"} class="img-responsive" />
// 						</div>
// 						`
// 			}
// 		}
//     },
//     {
//       id:56,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Clean Bandit",
//         smltitle: "Clean Bandit Announces First Visit to Israel",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											26.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//cleanbandit.co.uk/">
// 												cleanbandit.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/56/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Clean Bandit Announces First Visit to Israel
// 							</p>
// 							<p>
// 									British electro-pop group, Clean Bandit, which has become one of the leading dance acts around the world, has announced their debut performance in Israel. Visiting as part of their European tour, the band will play on the outskirts of Tel Aviv on June 26.
// 							</p>
// 							<p>
// 									Formed in 2008, they became well-known for merging classical instruments and pop with a unique and masterful outcome and they became a sensation with their smash hits “Rather Be,” “Real Love,” “Rockabye,” and “Symphony.” Since its release in 2016, “Rockabye” has been viewed almost 2 billion times on YouTube, while they won a Grammy for “Rather Be” in 2015.
// 							</p>
// 							<p>
// 									The band has been together for ten years and has seen incredible success in the that time. Join the throngs of people heading to Tel Aviv for the group’s first visit.
// 						    </p>
// 						    <p>
// 									Tel Aviv is just the venue for the unforgettable night that this concert offers. With cafes, bars, clubs, and pubs throughout the city, there is no shortage of activities in Tel Aviv. Known as “the city that doesn’t stop”, you can take advantage of the buzz of the nightlife and enjoy the vibe of the bustling beachfront at any hour before or after the concert.
// 						    </p>
// 						`
// 			}
// 		}
//     },
//     {
//        id:57,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alanis Morissette",
//         smltitle: "Alanis Morissette to Turn Up The Heat with Summer Performance in Israel",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											30.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//alanis.com/">
// 												alanis.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/57/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Alanis Morissette to Turn Up The Heat with Summer Performance in Israel
// 							</p>
// 							<p>
// 									Canadian singer and songwriter, Alanis Morissette, will return to Israel in the summer for one show which will take place on the outskirts of the lively city of Tel Aviv. Morissette has performed in Israel a number of times, including in 2000 and 2012, since she released her first album, “Jagged Little Pill” in 1995.
// 							</p>
// 							<p>
// 									The popular alternative rock singer is expected to rock Tel Aviv with some of her top hits, including “All I Really Want,” “Hand in My Pocket,” “Head Over Feet,” “Ironic,” “You Learn,” and “You Ought to Know.” Having taken home seven Grammy Awards and with eight albums having sold more than 60 million copies across the globe, her upcoming visit is already causing much excitement.
// 							</p>
// 							<p>
// 									The Tel Aviv area is the perfect location for a concert of this calibre, with visitors to the city given an exceptional choice of wining, dining and entertainment options. Begin your night at one of the many world-class restaurants or head out to one of the quaint coffee shops or bustling bars to end off your evening. The music scene will be hotter than ever with Alanis Morissette this July!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//        id:58,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Marc Almond",
//         smltitle: "Marc Almond’s Amazing Summer Concert",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											14.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.marcalmond.co.uk/news/index.html">
// 												marcalmond.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/58/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Marc Almond’s Amazing Summer Concert
// 							</p>
// 							<p>
// 									English musician, Marc Almond, will be heading to Israel in the summer for a much-awaited concert. The singer, who is most famous for his part in the new wave duo Soft Cell, will be playing north of Just north of the nonstop city of Tel Aviv in August.
// 							</p>
// 							<p>
// 									Soft Cell became famous for its 80’s hits “Tainted Love,” “Torch,” “Say Hello, Wave Goodbye,” and others, while Almond’s solo career took off when the duo split in the mid-80’s with hits including “Jacky” and “Something’s Gotten Hold of My Heart.” In another tribute to the decade, the Israeli rock group, Tattoo, which broke up in 1989, will open the concert in a historic reunion.
// 							</p>
// 							<p>
// 									Fans have been waiting for this performance since 2011, when his planned concert was canceled due to technical reasons. The 2018 concert promises to be an experience to remember.
// 							</p>
// 						    <p>
// 									From music to art, culture to fun, Tel Aviv has something for everyone. Spend the day wandering the vibrant streets of the city or pop into one of the many museums, theatres or galleries downtown. Make sure to stop off for a bite to eat at any of the city’s many world-class restaurants so you’ll be energized for what is sure to be an awesome concert.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:59,
//         bgImage:"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title : "Shakira",
//         smlTitle : "Shakira to heat up the summer in sizzling Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											09.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.shakira.com/">
// 												shakira.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/59/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Shakira to heat up the summer in sizzling Tel Aviv
// 							</p>
// 							<p>
// 									The worldwide sensation Shakira is set to perform for the first time on the big stage in Tel Aviv this coming July and the city’s a buzz. The 41-year-old Colombian superstar who has sold close to 200 million albums and has won over 250 awards including three Grammys is just the perfect fit for a summertime concert in Tel Aviv.
// 							</p>
// 							<p>
// 									With a long and illustrious list of hit songs, including “Waka-Waka”, “Chantage” and “Whenever, whenever” Shakira is one of the most celebrated artists in the world today and nearly every song she records tops the international charts and receives hundreds of millions of Youtube views.
// 							</p>
// 							<p>
// 									Shakira’s concert is due to be held on July 9th in Yarkon Park, Tel Aviv’s massive park also dubbed the city’s “Green Lung”, which boasts, in addition to beautiful greenery, a stunning lake and excellent bike trails, a huge outdoor live music venue.
// 							</p>
// 							<p>
// 							        The party atmosphere of the nonstop city in July, the beautiful beaches and amazing nightlife and cool street vibe, all set the scene for perfectly Shakira’s show-stopping style and what is guaranteed to be an explosive musical celebration in the heart of cool city of Tel Aviv.
// 							</p>
// 	                    `
// 			}
// 		}
//       },
//   //     {
//   //     id: 60,
//   //     bgImage:"/posts/bank/16/1.jpg",
//   //     mobBgImage:"/posts/bank/16/M.jpg",
//   //     title: "White Night TLV",
//   //     smlTitle: "A “White Night” Rager In the Non-Stop City!",
//   //     html: function(){
// 		// 	return {
// 		// 		__html: `
// 		// 					<h2 class="align-center">
// 		// 					   16.05.2019
// 		// 					</h2>
// 		// 					<h1 class="align-center">
// 		// 					   A “White Night” Rager In the<br class="show-on-mobile"/> Non-Stop City!
// 		// 					</h1>
// 		// 					<div class="responisve-iframe">
// 		// 						<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 		// 					</div>
// 		// 					<p>
// 		// 						When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat. “White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open and everything is happening across the city at the same time…
// 		// 					</p>
// 		// 					<p>
// 		// 						From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Adam Primer
// 		// 					</small>
// 		// 					<p>
// 		// 						The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City", Tel Aviv’s largest architectural collection of Bauhaus style buildings a world cultural heritage site, giving it a unique status in the architectural heritage of the modern era.
// 		// 					</p>
// 		// 					<p>
// 		// 						This historic declaration has been celebrated yearly ever since by Tel Aviv-Jaffa in a series of white night events, named after the "White City" and Tel Aviv’s other well-known characteristic: being “The City That Doesn’t Stop”.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Kfir Sivan
// 		// 					</small>
// 		// 					<p>
// 		// 						The White Night is a celebration of numerous events held throughout the city, which seems to expand with every passing year. In recent years, the celebrations  included (to name just a few): a unique midnight public picnic, an epic headphones party in the city’s main square, countless live music concerts, amazing indoor as well as street theatre performances, fascinating nighttime tours, night sports classes , Yoga at sunrise, and of course countless epic parties, all taking place all night across the city at the same time.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by Moshik Lindenbaum
// 		// 					</small>
// 		// 					<p>
// 		// 						So you better get your rest on- you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by: Guy Yechiely‎.
// 		// 					</small>
// 		// 			               `
// 		// 	}
// 		// }
//   //   },
//       {
//       id: 60,
//       bgImage:"/posts/bank/16/1.jpg",
//       mobBgImage:"/posts/bank/16/M.jpg",
//       title: "White Night TLV",
//       smlTitle: "All Night Citywide party in Tel Aviv on Eurovision Semifinal!",
//       html: function(){
// 			return {
// 				__html: `
// 							<h2 class="align-center">
// 							   16.05.2019
// 							</h2>
// 							<h1 class="align-center">
// 							   All Night Citywide party in Tel Aviv on Eurovision Semifinal!
// 							</h1>
// 							<div class="responisve-iframe">
// 								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 							</div>
// 							<p>
// 								When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat, and this year the treat is going to be especially epic!
// 							</p>
// 							<p>
// 								As part of the warm and exciting welcome awaiting visitors during Eurovision week, the powers that be have decided to combine Tel Aviv’s annual “White Night” extravaganza with the Eurovision Semifinal set to be held on 16.05.2019.
// 							</p>
// 							<p>
// 								“White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open, and everything is happening throughout the city simultaneously.
// 							</p>
// 							<p>
// 								The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City as a world cultural heritage site, setting off annual citywide celebration in a series of white night events in the city that (truly) doesn’t sleeps.
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Adam Primer
// 							</small>
// 							<p>
// 								From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Kfir Sivan
// 							</small>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by Moshik Lindenbaum
// 							</small>
// 							<p>
// 								So you better get some rest - you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by: Guy Yechiely‎.
// 							</small>
// 					               `
// 			}
// 		}
//     },
//     {
//         id:61,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Brian Wilson",
// 	    smlTitle: "The legendary Brian Wilson returning to rock Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											07.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.brianwilson.com/">
// 												brianwilson.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/61/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 The legendary Brian Wilson returning to rock Tel Aviv!
// 							</p>
// 							<p>
// 									He returns to the white city with Al Jardine and Blondie Chaplin as a part of his world tour that celebrates his biggest hits from the last 54 years. The Beach Boys is one of the world’s most successful bands, the band has won many Grammy awards, got their own star in Hollywood and entered the Rock N’ Roll hall of fame.
// 							</p>
// 							<p>
// 									The band sold over 100 million records over the years and produced more hits than any other American band. They’re known especially for their hits “God Only Knows”, “Get Around”, “California Girls” and “Good Vibrations”. Wilson’s solo career is also successful, he recorded 11 albums and won 2 Grammy awards.
// 							</p>
// 							<p>
// 									Wilson’s concert will take place in Tel Aviv on August’s 7th. The summertime provides long daylight hours that give visitors the perfect opportunity to see what Tel Aviv has to offer; from an incredible art scene to fantastic theatres, to phenomenal live music shows and world-class restaurants – there are so many options in the spectacular city of Tel Aviv for  everyone will to find their brand of fun and excitement in the nonstop city.
//                             </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 62,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Jason Derulo and Rita Ora",
// 	    smlTitle: "Jason Derulo and Rita Ora to raise it up in Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											The outskirts of Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jasonderulo.com/">
// 												jasonderulo.com
// 											</a><br>
// 											<a target="_blank" href="//ritaora.com/">
// 												ritaora.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/62/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						         	Jason Derulo and Rita Ora to raise it up in Tel Aviv!
// 							</p>
// 							<p>
// 									The two mega pop stars will perform at the “Lollipop” festival that will take place at the outskirts of Tel Aviv on the first of August. Derulo, that made his big breakthrough in 2009 with the hit “Whatcha Say”, became over the last decade one of the biggest stars in the international music industry with his huge hits such as “Wiggle”, “Want to Want Me”, “Swalla”, “Tip Toe” and “Talk Dirty”. The popular British Pop star, Rita Ora, is known especially for her famous hits “I Will Never Let You Down”, “Anywhere”, “R.I.P” and “Hot Right Now”.
// 							</p>
// 							<p>
// 									The festival provides a great opportunity to explore the city that never sleeps and enjoy its famous nightlife scene – from world-class bars, to secret underground clubs, to live music shows and various culinary options and even alternative art galleries, Tel Aviv for sure has something for everyone to enjoy. Whether you’re following a map or letting yourself get lost in the streets, you’re sure to fall in love with Tel Aviv!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 63,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Julio Iglesias",
// 	    smlTitle: "The Latin legend returning to wow Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											06.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.julioiglesias.com/">
// 												julioiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/63/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						             The Latin legend returning to wow Tel Aviv!
// 							</p>
// 							<p>
// 									Tel Aviv can’t wait for the return of the beloved Spanish star! With a great cultural scene, incredible culinary options, amazing beaches, phenomenal museums and galleries and plenty of unique spots to explore – those who come to enjoy Iglesias’s concert have plenty of different ways to spend their time in the cultural capital.
// 							</p>
// 							<p>
// 									The hot climate and long daylight hours just reminiscent of the phenomenal singer’s origin country, Tel Aviv offers a variety of options that suit all ages and therefore attracts a big amount of visitors all around the year.
// 							</p>
// 							<p>
// 							        Iglesias has an ongoing love affair with the nonstop city and his past shows were sold out. He’s one of the most successful singers in the history and during his career became a phenomenal success story all around the world. He has 77 different albums that sold over 300 million copies!
// 							</p>
// 							<p>
// 							         Many of the Spanish phenomenon’s hits have reached the top of the charts and he won numerous awards, such as the Grammy. His fans are incredibly excited about his return and tickets are selling like hot falafels. This is guaranteed to be a show to remember!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 64,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Maluma",
// 	    smlTitle: "The Reggaeton sensation returns to the white city!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fame.malumaofficial.com/">
// 												fame.malumaofficial.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/64/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The Reggaeton sensation returns to the white city!
// 							</p>
// 							<p>
// 									After winning over the crowd’s hearts during his last visit, the Colombian reggaetón singer and songwriter Juan Luis Londoño Arias, better known by his stage name Maluma returns to the city that never stops for one show only!
// 							</p>
// 							<p>
// 									Maluma has several singles that have charted within the top 10 on Billboard Hot Latin Songs, including "Felices los 4", "Borro Cassette", "El Perdedor" and "Corazón". During his career he won several awards, among which there is MTV Europe’s award for best world tour. The phenomenal performer is known among his fans as “the Latin lover” despite being only 24 years old.
// 							</p>
// 							<p>
// 							       His show will be held on June’s 28th in HaYarkon Park, located in the heart of Tel Aviv. Fans from all over the world who come to the show can enjoy the lovely beaches the city has to offer, the variety of restaurants and cafes, the remarkable art scene, the world-class bars and clubs, the various shopping venues spread all across the city – Tel Aviv has something for everyone.
// 						    </p>
// 							<p>
// 							         The Latin superstar is known to be quite a charmer and win everyone over in his shows – don’t miss this fantastic mix of Maluma and Tel Aviv -  come see the legend live in the hot hot city!
// 						    </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 65,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Martin Garrix",
// 	    smlTitle: "The 1# DJ comes to the nonstop city!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											10.09.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.martingarrix.com/">
// 												martingarrix.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/65/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The 1# DJ comes to the nonstop city!
// 							</p>
// 							<p>
// 									Martin Garrix , hailed as “the world’s best DJ” by DJMag is coming to get the party going in the nightlife capital of the middle east! With tons of world known clubs, bars, pubs and a one of a kind atmosphere, Tel Aviv is known for its vibrant vibe and incredible night scene.
// 							</p>
// 							<p>
// 									At 20 years old, the Dutch wonderkid is coming at the height of his career for one unforgettable show in Tel Aviv! The international hits machine became famous when he was only 17 and since then has released many loved tracks and climbed the charts all over the world.
// 							</p>
// 							<p>
// 							       Garrix is considered by many is the undeniable king of the industry. With remarkable hits such as “Animals”, “Tremor”, “In the Name of Love” and “Scared to Be Lonely”, the phenomenal DJ is one of the most popular performers in the world and is a must-have headliner for every well-known festival.
// 							</p>
// 							<p>
// 							        The show will be held in HaYarkon Park, in the heart of the awesome city, on September 10th. The international vibe, gorgeous location and great nightlife scene attract an extraordinary crowd that comes from different corners of the world and is guaranteed to make this show a once in a lifetime experience!
// 						    </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 66,
// 	    bgImage:"/posts/bank/59/1.jpg",
// 	    mobBgImage:"/posts/bank/59/M.jpg",
// 	    title: "Eurovision Tel Aviv",
// 	    smlTitle: "Epic song contest in the Non-Stop City",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											14-18.05.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<!--<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->
// 							<h3>A once in a lifetime opportunity to visit Tel Aviv as it hosts the Eurovision song contest.</h3>
// 							<p>
// 						     Epic song contest in the Non-Stop City
// 							</p>
// 							<p>Semi-final 1: 14 May 2019</p>
//                             <p>Semi-final 2: 16 May 2019</p>
//                             <p>Grand Final: 18 May 2019</p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/67/1.svg"} class="img-responsive" />
// 							</div>
//                             <p>It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city. </p>
//                             <p>Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak.  Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest. </p>
//                             <div class="img-wrapper">
// 							    <img src=${getImgUrl() + "/Concerts/67/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv. </p>
//                             <p>The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all! </p>
// 					               `
// 			}
// 		}
//     },
//    {
//         id: 68,
// 	    bgImage:"/posts/bank/68/1.jpg",
// 	    mobBgImage:"/posts/bank/68/M.jpg",
// 	    title: "",
// 	    smlTitle: "36 Years of Cinema Magic!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											25.07-04.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jff.org.il/en">
// 												www.jff.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Jerusalem Film Festival (JFF)</h2>
// 							<p>Time to start preparing your Summer 2019 checklist: Buy suntan lotion, pick wildflowers, host a barbeque, make plans to attend the 36th Annual Jerusalem Film Festival! It’s 11 days, over 200 films, prizes awarded to the very best, and you’ll be a part of it all! From star-studded international features to independent productions and the best of Israeli cinema, this unique film fest showcases excellence from various genres. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/68/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>Take advantage of the opportunity to meet festival guests, including world-renown stars, writers, directors, cinematographers and other movie-making professionals. Film enthusiasts will enjoy Jerusalem’s many cinema spaces and be delighted by JFF on the Go, which presents films under the stars throughout the festival, and Cinema Park, which includes a 300 square meter pool with rubber boats, a giant LED screen, and a concert stage featuring live musical performances nightly. </p>
//                             <p>As you travel across the city to attend screenings, workshops, master classes, parties, musical shows and other festival events, you’ll experience how ancient cultures give modern spice to the contemporary vibe and personality of this global city. Fill your spare time strolling through neighborhood streets, exploring local shops, and taking your pick of Jerusalem’s wide variety of restaurants and cafes. You may have attended other film fests, but you won’t find one quite like this and, certainly, none other can boast the grandeur of the eternal City of Peace! </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 69,
// 	    bgImage:"/posts/bank/69/1.jpg",
// 	    mobBgImage:"/posts/bank/69/M.jpg",
// 	    title: "",
// 	    smlTitle: "Jerusalem Wine Festival (JWF)",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											01-31.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Jerusalem Wine Festival (JWF)</h2>
// 							<p>
// 								Relaxing summer evenings were made for an exquisite glass of fine wine! And for four days in August, you can enjoy world class selections and award-winning food at the 16th Annual JWF. Hosted in the beauty of the Japanese Art Garden of the Israel Museum, this is considered by many to be Jerusalem’s premiere social event. It’s a wine festival unlike any other, whose ambiance and stunning views of this historic city combine to make the JWF a not-to-be-missed experience.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Hundreds of wines will be served by dozens of well-known and boutique wineries. There’ll be free wine tasting opportunities, along with a culinary oasis of stalls offering cheeses, chocolates, olive oils, exceptional sauces, and tasty jams. And speaking of tasty jams, the festival will get your party started every night with two different live music concerts.
// 							</p>
//                            <p>
// 								Every year, the JWF welcomes a diverse and refined crowd of over 20,000 wine and culture lovers to Jerusalem. Many attend over multiple evenings simply to soak in the atmosphere. You could even build your stay in the city around the festival! Certainly, your days will be filled with sightseeing, shopping, and loads of walking about. The perfect way to unwind after your busy days might well be several fun-filled nights at the Jerusalem Wine Festival!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 70,
// 	    bgImage:"/posts/bank/70/1.jpg",
// 	    mobBgImage:"/posts/bank/70/M.jpg",
// 	    title: "OPEN RESTAURANTS TLV",
// 	    smlTitle: "Feed Your Curiosity!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											2019 y.
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Feed Your Curiosity!</h2>
// 							<p>
// 								Ever wanted to get more than a taste of what gets created in a truly fine restaurant? Have you ever fantasized about what it would be like to be a top chef? Well, now’s your chance!
// 							</p>
// 							<p>
// 								OpenRestaurants is more than a culinary event, it’s a cultural happening that showcases Tel Aviv’s wide array of restaurants, chefs, and local culinary personalities. Guests get to meet with chefs from around the city, wander through open markets, and try their hands at cooking up flagship dishes under the supervision of first-class professionals. It’s your opportunity to experience a day in the life of the sophisticated chefs, line cooks, restaurateurs, food vendors, and others who make gastronomy in Tel Aviv as palate pleasing as it is.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/70/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Beyond peeking behind many kitchen curtains, OpenRestaurants hosts a range of events that include curated dinners, history presentations, and exhibitions of culinary-themed art, design, music, and technology!
// 							</p>
//                            <p>
// 								Many events are available at no charge, including the Culinary Innovation Summit, the Food & Hospitality Hackathon, and various food talks. There are also family-oriented events that focus on cooking activities for children and several market tours.
// 							</p>
//                            <p>
// 								Everyone’s gotta eat and there’s no one who doesn’t enjoy good food that’s well prepared. So, whether you like to understand the process behind the preparation, you like to do the preparing, or you just have a hearty appetite, there’ll be plenty to delight your senses at OpenRestaurants: Tel Aviv!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 71,
// 	    bgImage:"/posts/bank/71/1.jpg",
// 	    mobBgImage:"/posts/bank/71/M.jpg",
// 	    title: "CULINARY FESTIVAL",
// 	    smlTitle: "Round Tables Culinary Festival",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											09-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Round Tables Culinary Festival</h2>
// 							<p>
// 								The 4th edition of this celebrated culinary experience that brings renowned chefs from around the globe and invites them to take over the kitchens of several of Tel Aviv’s most notable restaurants.
// 							</p>
// 							<p>
// 								This year offers a new twist: The eight visiting chefs are all women – hailing from Mexico, South Korea, Italy, Switzerland, Colombia, Slovenia, Spain, and the United States. They’ll work with their local counterparts in the creation of culture crossover chowdowns featuring signature dishes from the guest chefs alongside flavors offered by the local chefs from the host restaurants.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/71/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Everyone involved agrees that creative cooking is always intensely steeped cultural context and a deeply felt sense of place. All of them are passionate about using local ingredients. Of course, each of these chefs has received accolades and awards from international critics and guides.
// 							</p>
//                            <p>
// 								There’s no better way to showcase Tel Aviv’s growing prominence on the global stage of gastronomy than the annual Round Table event. Seats get reserved quickly and must be made in advance. So, don’t miss your chance for a place at these prestigious tables – your taste buds will never forgive you!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 72,
// 	    bgImage:"/posts/bank/72/1.jpg",
// 	    mobBgImage:"/posts/bank/72/M.jpg",
// 	    title: "TEL AVIV FASHION WEEK",
// 	    smlTitle: "Tel Aviv Fashion Week (TAFW)",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Tel Aviv Fashion Week (TAFW)</h2>
// 							<p>
// 								Fashion events are always occasions for the celebration of elegance, imagination, creativity, and style. But the TAFW has been making its mark in the international fashion industry with its recent attention to changing ideals of beauty, featuring models, both male and female, of different ages, sizes, heights, colors, and religions. The 4-day event showcases uncommon displays from around the world and those close to home in and around Tel Aviv’s vibrant design scene.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								TAFW also embraces leading edge fashion concepts by exhibiting innovative uses of technology and textiles. And it’s especially proud of the support it provides to young designers. As in past editions, this 7th annual event will feature an Upcoming Designers show in which new talent will have an opportunity to share their wares with you!
// 							</p>
//                            <p>
// 								In 2019, Tel Aviv Fashion Week will once again take place in the historic Tachana complex. Formerly the final stop of the old Jaffa-to-Jerusalem railway, the station has been transformed into one of Tel Aviv’s coolest and most lively public spaces. Located in a trendy neighborhood of pastel-colored homes, unique boutiques, and numerous cafes, you’ll want to explore the entire area while you’re getting your vogue on at the TAFW!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 73,
// 	    bgImage:"/posts/bank/73/1.jpg",
// 	    mobBgImage:"/posts/bank/73/M.jpg",
// 	    title: "DGTL FESTIVAL",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">
// 												tlv.dgtl.nl/en
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>
//                             <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now Tel Aviv and bringing together the worlds of music, technology and art, as well as the latest discoveries in production and sound. </p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/73/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include three stages which will operate simultaneously at any given moment.</p>
//                             <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for saving electricity, vegetarian food only, a recycling plan and more. </p>
//                             <p>The Festival will be held in the fabulous Yarkon Park in the heart of the buzzing city of Tel Aviv, a hub of innovation, trendiness and exciting nightlife scene, making it the host for DGTL. </p>
//                             <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 74,
// 	    bgImage:"/posts/bank/74/1.jpg",
// 	    mobBgImage:"/posts/bank/74/M.jpg",
// 	    title: "Tel Aviv Marathon",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											22.02.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=5418">
// 												www.tlvmarathon.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2  class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Run and fun in the city that doesn’t stop</h2><br/>
//                             <p>Tel Aviv Marathon is the country’s biggest international sports event and a unique and exciting celebration for runners worldwide. The Marathon is held in the heart of the fabulous city of Tel Aviv, giving participants the opportunity to take in its awesome sites and views and feel their heart beat become one with the pulse of this adrenaline charged metropolis. </p>
//                             <p>The Tel Aviv Marathon is city wide celebration stretching along the stunning beachfront, the amazing sites of the white city - a UNESCO World Heritage Site, and the city’s many buzzing stylish streets, packed with over 150,000 people taking part in the many side events, cheering the runners along the race’s flat and friendly course.   </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/74/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Around 40,000 runners come from far and wide to take part in this multi-course annual even. Allowing runners in all levels and styles, from professional long-distance runners to beginners, to take part.</p>
//                             <p>Much more than just a run, the marathon is in fact a huge festival featuring a host of dedicated lively events before and after the race, full of live music, dancing and many other attractions to the delight of runners and supporters alike.  </p>
//                             <p>Dubbed ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’. Tel Aviv offers a host of fascinating attractions from all walks of life including dazzling stretches of golden beaches, colorful markets, cutting edge culture and entertainment, outstanding nightlife & an exciting culinary scene. </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 75,
// 	    bgImage:"/posts/bank/75/1.jpg",
// 	    mobBgImage:"/posts/bank/75/M.jpg",
// 	    title: "Jerusalem Marathon",
// 	    smlTitle: "The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											15.03.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://jerusalem-marathon.com/Register.aspx">
// 												jerusalem-marathon.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem</h2>
//                             <p>The International Jerusalem Winner Marathon is one of Israel's largest marathons, with 30,000 participants including hundreds of elite runners from Israel and around the world.</p>
//                             <p>The marathon offers a variety of tracks, from professional to family friendly, which pass by fascinating historical sites that illuminate 3,000 years of the history of Jerusalem, Israel's capital guaranteeing a challenging, thrilling and unforgettable experience for all runners. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/75/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>With a series of cultural happenings planned around the central event, the Jerusalem International Marathon provides international runners with the perfect opportunity to visit the ancient city while participating in a truly modern and excitement-filled competitive sporting event. </p>
//                             <p>The Jerusalem marathon allows runners the chance to compete in a setting of unparalleled natural and cultural beauty unlike any other international marathon course. The topography of the city lends itself to a challenging route that will test even the most experienced of runners.</p>
//                             <p>The course takes the runner on a unique path through Jerusalem’s 3,000-year historical narrative, on the cobblestones of the ancient and holy walled city of Jerusalem and through the modern city center of Israel’s capital. The course includes the city’s best known sites including, among others, the Knesset, the Old City, Sultan's Pool, Mount Zion, the German Colony, the Jerusalem Promenade and the Mount of Olives.</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 76,
// 	    bgImage:"/posts/bank/76/1.jpg",
// 	    mobBgImage:"/posts/bank/76/M.jpg",
// 	    title: "Bon Jovi",
// 	    smlTitle: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, TLV
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											25.07.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bonjovi.com/">
// 												bonjovi.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!</h2>
//                             <p>Bon Jovi, all-time favorites in Tel Aviv, are making their way back to the city, famed for its lively music scene once more to appear in the famous Yarkon Park, the beautiful green lung of the city.
//                             <p>Currently touring America to sold out venues, Bon Jovi will arrive here as part of a new European tour in the summer of 2019, entitled "This House is not for Sale". The tour is set will begin on May 31, 2019 in Moscow and will probably end on July 25, 2019 with their show in Tel Aviv.
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/76/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The band, considered e one of the most successful American bands of all times has sold more than 100 million copies, performed in over 2700 concerts in 50 different countries to more than 34 million viewers worldwide.
//                             <p>This is not Bon Jovi's first stint in the city. The band gave a truly memorable performance about three years ago at the Hayarkon Park in Tel Aviv to 50,000 adoring fans, singing along to every lyric .
//                             <p>Those coming to see the band play in Tel Aviv are in for a special treat as they will get to experience Tel Aviv in July, the city’s summer finest,  sunbathe on the fabulous beaches, enjoy the awesome culinary options, take in  the epic hot night life and best of all see Bon Jovi raise it live on stage in the city that doesn’t stop!
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 77,
// 	    bgImage:"/posts/bank/77/1.jpg",
// 	    mobBgImage:"/posts/bank/77/M.jpg",
// 	    title: "TAG 2019",
// 	    smlTitle: "Tel Aviv Games are Back!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											TAG 2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											27-30.3.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bonjovi.com/">
// 												www.telavivgames.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                            <h2>
//                             	Tel Aviv Games are Back!
//                           	 </h2>
//                             <p>
// 								Tel Aviv, declared one of the best gay travel destinations in the world, is joining a list of renowned capitals such as Paris, New York, Berlin and Rome, organizing its own LGBT multinational sports event – Tel Aviv Games – TAG2019. TAG 2019 offering the LGBT+ traveler a unique and exciting sports experience.
//                             </p>
//                             <p>
// 								With over 250 athletes from all over the world already signed up, and an estimated 500 more expected, Tel Aviv Games 2019 is anticipated to become the biggest LGBT+ Sports event in the middle east and one of the biggest in Europe.
//                             </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/77/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>
// 								LGBT+ athletes from more than 17 countries (including France, Germany, UK, US, Australia, Canada, Belgium, Czech Rep., Greece, Netherlands, Norway, Spain, Russia, Surnami and more) will come together for a 3-day multi-national celebration of participation, inclusion and personal best.
//                             </p>
//                             <p>
// 								The tournament will include individual and team events in 7 sporting categories: Swimming, Tennis, Basketball, Soccer, Volleyball, Same Sex Dance, and 5K and 10K Competitive Running.
//                             </p>
//                             <p>
// 								This year Tel Aviv Games will also introduce the city’s first ever “Pride Run - Running for the youth”, supporting Healthy LGBT+ Youth lifestyle in a 5K race along Tel Aviv’s beautiful shore.
// 							 </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 78,
// 	    bgImage:"/posts/bank/100/1.jpg",
// 	    mobBgImage:"/posts/bank/100/M.jpg",
// 	    title: "Purim 2019",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											20-22.03.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tel-aviv.gov.il/en/Pages/MainItemPage.aspx?WebID=9336473c-1537-4ab6-8a69-d299b5db8bcc&ListID=0ac6b290-896c-4fcb-bb36-0c5252101eff&ItemId=123">
// 												Tel Aviv Purim 2019
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                            <p>Every year in March, the people of Tel Aviv & Jerusalem dress up in costumes, the cities are a party and it’s all because of Purim – the most colorful and fun holiday of them all!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>As expected, the party capital doesn’t disappoint, as there are tons of events to choose from – the annual street party is Tel Aviv’s biggest event. Thousands of dressed up people will gather together in “Kikar Hamedina” (State’s Square)  to enjoy performances from top musicians and dance together! The best part? It’s free of charge! If you won’t be too exhausted, you can also participate in Tel Aviv’s Zombie Walk. The name is self-explanatory, as the walk features hundreds of zombies walking through the streets of the city that never sleeps. Other events include Tel Aviv Street Party in Rothschild boulevard and many more.
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/2.jpg"} class="img-responsive" />
// 							</div>
//                             <p>If your prefer to spend the holiday in the city of gold, have no fear as there are plenty of events taking place across Jerusalem – from carnivals to parties there is something for everyone: The official Jerusalem Purim events is at Safra Square, featuring activities and performances for kids. Another option is the event at the Israel Museum that’s meant for the whole family. There’s also a Purim Rave Party at The Tower of David, the traditional parade at Nachlaot street, a party at Downtown Jerusalem building, a Purim party at the Shuka and more events to be confirmed!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/3.jpg"} class="img-responsive" />
// 							</div>
//                             <p>So choose your costume and come celebrate with us!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/4.jpg"} class="img-responsive" />
// 							</div>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: "J_Lo",
// 	    bgImage:"/posts/bank/J_Lo/1.jpg",
// 	    mobBgImage:"/posts/bank/J_Lo/M.jpg",
// 	    title: "J.LO",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Hayarkon Park
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h3>
// 								J.LO HEADING TO TEL AVIV TO SET THE SUMMER ON FIRE!
// 							</h3>
// 							<p>
// 								Yes, it's true! after weeks of rumors flying around it is officially confirmed the J.Lo, AKA Jeniffer Lopes, AKA Jenny from the block, the hottest name worldwide as queen of pop for the past 2 decades, is coming to light up your summer in Tel Aviv!
// 							</p>
//                          <p>
// 								Performing for the first time in this country, J.Lo will be getting loud on the floor on August 1st at the Yarkon Park. The show, part of the maga star’s “It’s My Party” worldwide tour is expected to be one of the summer’s biggest concerts, along with Bon Jovi’s highly anticipated performance on the very same Tel Aviv stage on the 25th July.
// 							</p>
// 							<p>
// 								Hayarkon park is Tel Aviv’s green lung. This is the perfect place to get some respite after spending a wild night in Tel Aviv. Here you can spend the day cycling, walking or relaxing in the beautiful outdoor scenery and even enjoy flying high on a hot air balloon before heading to take your place in the stunning amphitheater. Whatever you choose, make sure to come packed with energy for J.Lo’s once in a lifetime performance in sunny awesome Tel Aviv!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: "Pride_Parade_2019",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Pride Parade 2019",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											14.6.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h3>
// 								The  most fabulous event of the Year
// 							</h3>
// 							<p>
// 								<strong>
// 									Tel Aviv 2019 Pride Celebrations – guaranteed to blow your mind!
// 								</strong>
// 							</p>
// 							<p>
// 								Tel Aviv, one of the most celebrated gay capitals in the world, is famous for its round the clock energy and extravagant nonstop parties. One of the biggest and hottest events, by far in the city is the ‘Gay Pride Week’ parties ending with the awesome Friday Pride Parade.
// 							</p>
//                          <p>
// 								The parade, a tradition which began as early as 1998, draws a huge crowd of the coolest people and thousands of participants from around the world. All them come together to celebrate and support freedom and embrace all lifestyles and genres in an open minded, off the charts, celebration.
// 							</p>
// 							<p>
// 								The parade is the highlight of a week of gay pride events which take place around the city of Tel Aviv and include pride-themed parties, exhibitions, movie festivals, music concerts and so much more.
// 							</p>
// 							<p>
// 								The parade itself takes place along the buzzing main streets of marvelous Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic extravagant floats, live music, dance performances and revelers dressed in a colorful festival dress.
// 							</p>
// 							<p>
// 								The parade stops and rests at the stunning Tel Aviv promenade by the shores of the beautiful coastline, where it turns into an epic adrenaline-charged beach party featuring leading DJs and live performances, lasting well into the small hours of the night.
// 							</p>
// 							<p>
// 								The 2019 parade will take place on June 14th 2019 and participation, as always, will be completely free of charge.
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: "Open_Restaurants_Jerusalem",
// 	    bgImage:"/posts/bank/Open_Restaurants_Jerusalem/1.jpg",
// 	    mobBgImage:"/posts/bank/Open_Restaurants_Jerusalem/M.jpg",
// 	    title: "Open Restaurants Jerusalem",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											19-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												www.open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h3>
// 								Open Restaurants Jerusalem
// 							</h3>
// 							<p>
// 								Taking place in the iconic city of Jerusalem at varying hours, \‘Open Restaurants\’ is a unique culinary festival giving visitors a glimpse into the fascinating cultural and culinary diversity of Jerusalem.
// 							</p>
// 							<p>
// 								The festival includes about 100 different events held all over the city of Jerusalem, even in places which are less culinary oriented, as well as in culinary adequate venues and combine food with art, culture, innovation and technology.
// 							</p>
//                          <p>
// 								Festival-goers will also have a chance to participate in a series of meetings, workshops and lectures by prominent local personalities, and visits to the city\'s famous restaurant kitchens.
// 							</p>
// 							<p>
// 								As part of the festival program, day and night tours will be held at various culinary centers throughout Jerusalem including flavors tours in the Old City,Ein Kerem and more. You are encouraged to take at least one of them!
// 							</p>
// 							<p>
// 								In addition, FoodTalks meetings will be held with leading culinary experts (we can’t reveal who they are, so keep guessing…), photographers and chefs. The top hotels in Jerusalem will also collaborate with their private chefs at special prices.
// 							</p>
// 							<p>
// 								Whether you’re a foodie or just a curious visitor, you are sure to enjoy this unique taste of magical Jerusalem’s culinary side happening between the 19th -23rd , November,2019.
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//                   id: "Jerusalem_Beer_Festival",
// 	              bgImage:"/posts/bank/jerusalem-beer-festival/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem-beer-festival/M.jpg",
// 	              title: "Jerusalem Beer Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Time</h2>
// 											<div class="text">
// 												<p>
// 													18:00 – 00:00
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													28 - 29.08.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 	                                <p>The city of Jerusalem is proud to host, for the 15th(!) year in a row – the fabulous and hugely popular ‘Beer Festival’.</p>
// 	                                <p>The Jerusalem Beer Festival is an internationally recognized celebration of good music, good food and of course, you guessed it, great beer. </p>
// 	                                <p>Held in the magical 3000-year-old city of Jerusalem, the festival boasts an incomparable atmosphere, guaranteeing an unforgettable experience. </p>
// 	                                <p>The iconic festival has become over the years, a symbol of Jerusalem's entertainment culture and creates a unique opportunity for visitors from around the globe, to enjoy a delicious variety of cold beers, food and people in open air of Jerusalem.</p>
// 	                                <p>During the festival you will have the opportunity to taste any (or all) of the variety special flavors of beers from around the country and the world (and we have over 120 of them), served in pop up bars, built specifically for the festival. </p>
// 	                                <p>The Jerusalem Beer Festival is the only festival of its kind in Israel, hosting a huge variety of large and international beer brands every year alongside a distinguished presence of local breweries. </p>
// 	                                <p>So make your way and join more than 15,000 visitors coming to enjoy the unique atmosphere, the fantastic live shows, the great food and the awesome people, and to celebrate the global love of Beer.</p>
//                                     <a href="https://www.jerusalembeer.com/en" target="_blank" class="jerusalem-link">www.jerusalembeer.com</a>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "DGTL_Festival",
// 	              bgImage:"/posts/bank/dgtl-festival2019/1.jpg",
// 	              mobBgImage:"/posts/bank/dgtl-festival2019/M.jpg",
// 	              title: "DGTL FESTIVAL",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													Hayarkon Park Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													14.10.19
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Mas iNformacion</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">
// 														www.tlv.dgtl.nl
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 							        <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to the Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>
//                                    <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now, Tel Aviv. DGTL brings together the worlds of music, technology and art, as well as the latest discoveries in production and sound.</p>
//                                    <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include four stages which, will operate simultaneously at any given moment.</p>
//                                    <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for reducing electricity consumption, vegetarian food only, a recycling plan and more. </p>
//                                    <p>The Festival will be held in the fabulous Yarkon Park,  situated in the heart of the buzzing city of Tel Aviv. As a hub of innovation, trendiness and exciting nightlife scene, it is the perfect host for DGTL festival. </p>
//                                    <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "The_International_Arts",
// 	              bgImage:"/posts/bank/international-arts/1.jpg",
// 	              mobBgImage:"/posts/bank/international-arts/M.jpg",
// 	              title: "The International Arts",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													12 - 24.08.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>
//                                     <h2>The International Arts and Crafts Festival 2019<br>
//                                     <small>Hutzot Hayotzer Jerusalem<small></h2>
//                                     <p>Jerusalem is packed with fantastic events throughout the summer. One of the most celebrated events is the colorful “Hutzot Hayotzer -International Art and Crafts Festival”. </p>
//                                     <p>This large-scale annual festival takes place in the Hutzot Hayotzer lane and the Sultan’s Pool, opposite the Tower of David and at the foot of the walls of the Old City. </p>
//                                     <p>The iconic Hutzot Hayotzer festival has been held for over 35 consecutive years. It has long since became a hugely popular tourist and artistic attraction for visitors from around the world. Visitors will enjoy more than 150 local artists who showcase their art including paintings, prints, ceramics, jewelry and more, as well as an international exhibition, showcasing the work of overseas artists.  They will be able to engage in fascinating art conversations and enjoy unique workshops, live performances, an Irish pub, huge sculptures, live Jazz music, all wrapped up in an authentic European carnival atmosphere. </p>
//                                     <p>The festival is open every evening (except Fridays) between 18:00 and 23:00 and on Saturday night from 21:00 until midnight, at the Hutzot Hayotzer, Mitchell Park and the Merrill Haasenfeld Amphitheater at the Sultan’s Pool.</p>
//                                     <p>Last but definitely not least, don’t miss the “Food around the world” - an Israeli and international food fair, which will include food stalls of various tastes from different world kitchens: Thai, Israeli, Chinese, Korean, and more.</p>
//                                     <a href="https://artfair-jer.com/english/" target="_blank" class="artfair-link">www.artfair-jer.com</a>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Jerusalem_Marathon",
// 	              bgImage:"/posts/bank/jer-marathon2019/1.jpg",
// 	              mobBgImage:"/posts/bank/jer-marathon2019/M.jpg",
// 	              title: "Jerusalem Marathon",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													20.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Mas iNformacion</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://jerusalem-marathon.com/default.aspx">
// 														jerusalem-marathon.com
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
//                                     <h2>A Spectacular run through the 3,000-Year-old city</h2>
//                                     <p>With 30,000 participants including hundreds of elite runners from around the world, The International Jerusalem marathon, is a fantastic celebration of body and mind in the heart of one of the most enchanted cities in the world. </p>
//                                     <p>The Jerusalem International Marathon provides the runners with the perfect opportunity to visit the ancient city while participating in a truly modern and excitement-filled competitive sporting event, with a series of cultural happenings planned around the central event.</p>
//                                     <p>The marathon offers a variety of tracks, from professional to family friendly.</p>
//                                     <p>The course takes you by the fascinating historical sites that reveal the 3,000 years of Jerusalem’s history, the cobblestones of the ancient and holy walled city of Jerusalem and through the modern city center of the capital. </p>
//                                     <p>The course includes the city’s best-known sites, among others the Knesset, the Old City, Sultan's Pool, Mount Zion, the German Colony, the Jerusalem Promenade and the Mount of Olives.</p>
//                                     <p>Runners are provided with the opportunity to compete in a setting of unparalleled natural and cultural beauty unlike any other international marathon course. The topography of the city lends itself to a challenging route that will test even the most experienced of runners. Ultimately guaranteeing an illuminating, challenging, thrilling and unforgettable experience for all runners. </p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Open_Houses_Festival",
// 	              bgImage:"/posts/bank/openhf/1.jpg",
// 	              mobBgImage:"/posts/bank/openhf/M.jpg",
// 	              title: "Open Houses Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv, City -Wide
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													19 - 21.09.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Mas iNformacion</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="//www.batim-il.org/DefaultEng.aspx?batim=">
// 														www.batim-il.org
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div><div class="clear"></div>
//                                     <h2>An amazing experience for design lovers everywhere</h2>
//                                     <p>This September, the nonstop city of Tel Aviv will be hosting for the 14th year, the fantastic ‘Open Houses’ Architecture and Design Festival. </p>
//                                     <p>The ‘Open Houses’ opens a one-time door to allow a glimpse into the forms of design, style of living, history, culture, technology, ecology and houses of added value that makes them intriguing and attractive</p>
//                                     <p>The event will include an exciting program of fascinating visits and tours to some of the most intriguing buildings in the city including private homes, apartments, historical as well as urban buildings. The Festival will also include special guided tours and attractions in unusual places -  from tours of residential apartments to tours of  new buildings. </p>
//                                     <p>Among the many buildings and structures open to the public, some of which have never been opened before are:  Tel Aviv Velodrome, opened for the first time, a ship from within, a synagogue from 1840 in Old Jaffa and some fan favorites including the helipad on the Azrieli roof and a glimpse of the atomic shelter at Dizengoff Center. </p>
//                                      <p>"Open Houses” is part of the Open House World Wide's international organization, operating in New York, London, Chicago, Rome, Barcelona, Melbourne, Dublin, Helsinki, and more. </p>
//                                     <p>Be sure to check out what is guaranteed to be a unique and unforgettable urban celebration in the awesome city of Tel Aviv!</p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "TelAviv_Marathon",
// 	              bgImage:"/posts/bank/tlv-marathon2020/1.jpg",
// 	              mobBgImage:"/posts/bank/tlv-marathon2020/M.jpg",
// 	              title: "La Maratón de Jerusalén",
// 	              smlTitle: "",
// 	              html: function(){
// 			              return {
// 				              __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													28.02.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Mas iNformacion</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=6607">
// 														www.tlvmarathon.co.il
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
//                                     <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Run and fun in the city that doesn’t stop</h2>
//                                     <p>Tel Aviv Marathon is the country’s biggest international sports event. A unique and exciting celebration for runners worldwide. The Marathon is held in the heart of the fabulous city of Tel Aviv, giving participants the opportunity to take in its remarkable sites and views while their heart beat becomes one with the pulse of this adrenaline charged metropolis. </p>
//                                      <p>Around 40,000 runners come from far and wide to take part in this multi-course annual even. Allowing runners in all levels and styles, from professional long-distance runners to beginners, to take part.</p>
//                                      <p>The Tel Aviv Marathon is city wide celebration stretching along the stunning beachfront, the amazing sites of the white city - a UNESCO World Heritage Site, and the city’s many buzzing stylish streets, packed with over 150,000 people taking part in the many side events, cheering the runners along the race’s flat and friendly course.   </p>
//                                      <p>The marathon is in fact a huge festival featuring a host of dedicated lively events before and after the race, full of live music, dancing and many other attractions to the delight of runners and supporters alike.  </p>
//                                      <p>Dubbed ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’. Tel Aviv offers a host of fascinating attractions from all walks of life including dazzling stretches of golden beaches, colorful markets, cutting edge culture and entertainment, outstanding nightlife & an exciting culinary scene. </p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Night_Run_TelAviv",
// 	              bgImage:"/posts/bank/tlv-nightrun2019/1.jpg",
// 	              mobBgImage:"/posts/bank/tlv-nightrun2019/M.jpg",
// 	              title: "Night Run Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											30.10.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tlvnightrun.co.il/MenuDefault.aspx?id=6571">
// 												www.tlvnightrun.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2>The most exhilarating 10km you will ever experience</h2>
//                                     <p>A lot has been said about the world-renowned city of Tel Aviv. Named among Lonely Planet’s 'Top 10 Action-Packed Cities’, this city is a truly trendy buzzing metropolis that doesn’t rest. While its official slogan is the Non Stop City, it truly gives NYC a run for its money for the title the City that doesn’t sleep. </p>
//                                     <p>This is especially the case when it comes to the amazing Night Run Tel Aviv annual race. </p>
//                                     <p>With around 25,000 runners and tens of thousands of cheering spectators, this upbeat adrenaline-charged race is more of a full-blown night time party for the scores of participants and spectators who come from all around the world to take part.</p>
//                                     <p>Taking place during the autumn, the 10KM night run begins well after sundown and follows a fantastic urban route along the streets of Tel Aviv, starting at  Rabin Square in the center of town, and south along Rothschild Boulevard, before continuing along Dizengoff Street, Nordau Boulevard, and into Park Hayarkon, reaching the finish line alongside the river. </p>
//                                     <p>You will be passing all the trendy,, fascinating attractions and renowned Bauhaus architecture the "White City" of Tel Aviv has been declared a UNESCO World Heritage Site for. </p>
//                                     <p>Best of all, The TLV Night Run ends with a celebratory finish line festival at Hayarkon park in the heart of the city where thousands more come to join the runners and spectators in an all-night rager of music, dancing and nonstop fun.</p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Celine_Dion",
// 	              bgImage:"/posts/bank/Celine_Dion/1.jpg",
// 	              mobBgImage:"/posts/bank/Celine_Dion/M.jpg",
// 	              title: "Celine Dion",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											04.08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.celinedion.com">
// 												www.celinedion.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Our Heart Goes On – for Celine Dion in Tel Aviv!</h2>
// 										<p>The Diva is coming! Now it’s official: Celine Dion will perform in Tel Aviv on August 4th of next summer and it’s going to be a hot one! This will be Dion’s first ever concert here, and boy are we excited.</p>
//                                         <p>The 6 Grammy award-winner will visit Tel Aviv, the city that never sleeps, to keep the party going all Night. Dion’s countless hits, “Because you Loved Me”, “Just Walk Away” and of course her all-time greatest hit – “My Heart Will Go On” – will hopefully make their debut live in Tel Aviv.</p>
//                                         <p>Tel Aviv has also hosted some of the largest art exhibitions, live shows and festivals, making it one of the liveliest cities in the world. With a combination of sun, rich nightlife scene, spectacular sights in every corner and the Dion’s first appearance – Tel Aviv is the place to be next summer.</p>
//                                         <p>Ticket sales have yet to open, but it’s never too early to start planning your next visit to Tel Aviv!
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Nickcave_Badseeds",
// 	              bgImage:"/Concerts/bank/nickcave_badseeds/1.jpg",
// 	              mobBgImage:"/Concerts/bank/nickcave_badseeds/M.jpg",
// 	              title: "NICK CAVE & BAD SEEDS",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Bloomfield Stadium, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											17.06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">
// 												Update Soon
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">NICK CAVE AND THE BAD SEEDS LIVE IN TEL AVIV!</h2>
//                                     <p>Nick Cave is coming to Tel Aviv to blow the roof off! Returning to the city that never sleeps in June 2020, the Australian pop-punk musician is coming to rock you.</p>
//                                     <p>Having recorded no less than 17 studio albums with his band, the talented musician is excited about his visit – which will be hotter than ever.</p>
//                                     <p>Coming back just a little more than two years after his previous performance here, this time, lighting up the newly renovated Bloomfield Stadium (which has hosted a long line of international artists). Judging by the last performance, this one should be truly sensational.</p>
//                                     <p>Tel Aviv has been known to attract and feature some of the biggest names in the world, making it one of the hottest cities when it comes to live concerts and the nightlife scene. This performance shouldn’t be any different and is a great opportunity to catch Nick Cave live, as part of his summer tour.</p>
//                                     <p>Warm summer nights, soft sand beaches and the mesmerizing music of a world-renowned artist – what more could you ask for? Tel Aviv has it all!</p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Louis_CK",
// 	              bgImage:"/posts/bank/Louis_CK/1.jpg",
// 	              mobBgImage:"/posts/bank/Louis_CK/M.jpg",
// 	              title: "He’s coming back! Louis CK in Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Hangar 11, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.facebook.com/events/%D7%A4%D7%99%D7%A1-%D7%90%D7%A8%D7%A0%D7%94-%D7%9E%D7%9C%D7%97%D7%94-%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D/%D7%9C%D7%95%D7%90%D7%99%D7%A1-%D7%A1%D7%99-%D7%A7%D7%99%D7%99-%D7%91%D7%94%D7%95%D7%A4%D7%A2%D7%94-%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C-louis-ck-live-in-israel/554683431359536/">
// 												Louis CK
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <p>Back for the second time, Louis CK will preform at the Hangar 11 in Tel Aviv, this upcoming November.</p>
//                                     <p>After his tremendous success in Jerusalem in 2016, Louis CK is about to return for another exclusive show; this time, right here in Tel Aviv, one of the hottest cities for live shows.</p>
//                                     <p>The talented, hilarious comedian is back in action after a two-year break making this show, bigger, better and funnier than ever. Having a wide following audience in Tel Aviv alone, the sharp comedian is sure to light up the stage.</p>
//                                     <p>Tel Aviv has hosted dozens of comedians from all over the world, including Jerry Seinfeld and Chris Rock, Jim Jefferies and many others, is the ultimate city for having a good time. The city is known for its art and culture as well as its exciting club scene and trendy bars and restaurants.</p>
//                                     <p>So book your trip now and get ready for an unforgettable time in the city that doesn’t stop!</p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Cycle_Tel_Aviv",
// 	              bgImage:"/Concerts/bank/cycle-tlv-2019/1.jpg",
// 	              mobBgImage:"/Concerts/bank/cycle-tlv-2019/M.jpg",
// 	              title: "Cycle Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											All Around Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											18.10.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <p>The mild to warm October weather, combined with the energetic vibe of Tel Aviv, provide the perfect setting for the biggest cycling event in the country.</p>
//                                     <p>Thousands of cycling enthusiasts flock to Tel Aviv to ride through the vibrant city, on a scenic course showing you everything Tel Aviv has to offer:</p>
//                                     <p>From the beautiful Yarkon Park, along the coast, past the city’s many dazzling beaches and back up to the park through the city center, you’ll get a glimpse of every characteristic place, the “Mediterranean capital” has to offer.</p>
//                                     <p>Everyone can experience the thrill and excitement of the event, from the 60 km course for professional riders to the 8 km course for families and beginners, there is even a rollerblades course for those who prefer to make their way through the city on foot.</p>
//                                     <p>With the locals coming out in droves to cheer on the event, you’ll see a colorful and diverse crowd, adding to the fun and excitement in the air.</p>
//                                     <p>Whether you’re looking for a personal challenge to compete against some of the top riders in the country, or you’re hoping to enjoy a family day out with the crowds, you’re sure to experience the beauty and energy that makes up the unique atmosphere of Tel Aviv.</p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "DGTL_Festival_2020",
// 	              bgImage:"/posts/bank/dgtl-festival2019/1.jpg",
// 	              mobBgImage:"/posts/bank/dgtl-festival2019/M.jpg",
// 	              title: "DGTL FESTIVAL",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													Hayarkon Park Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Mas iNformacion</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">
// 														www.tlv.dgtl.nl
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							         <p>DGTL Festival is back!  B</p>
//                                     <p>ringing yet another excellent musical program to Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>
//                                     <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now Tel Aviv and bringing together the worlds of music, technology, and art, as well as the latest discoveries in production and sound. </p>
//                                     <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include four stages which will operate simultaneously at any given moment.</p>
//                                     <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for saving electricity, vegetarian food only, a recycling plan and more. </p>
//                                     <p>The Festival will be held in the fabulous Yarkon Park in the heart of the buzzing city of Tel Aviv, a hub of innovation, trendiness and exciting nightlife scene, making it the perfect host for DGTL festival.</p>
//                                     <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world!
// 	                            `
// 			}
// 		}
//     },
//     {
//         id: "Pride_Week_2020",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Pride Week 2020",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											12.6.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<div class="responisve-iframe">
// 					             <iframe width="560" height="315" src="https://www.youtube.com/embed/U8KwXVP3Xng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 				             </div>
// 				             <div class="ac-cradit" style="margin-top: -15px;margin-bottom: 40px;">
// 							<span class="ac-cradit-text">Credits:</span>
// 								<span class="ac-cradit-text-1"><a href="https://www.youtube.com/channel/UCWN-mUP4IzdHLH7gaXHEKVw" target="_blank">Basti Hansen</a><br/>
// 							</div>
// 							<p></p>
// 							</div>
// 							 <h2 class="ac-align-center">The  most fabulous event of the Year</h2>
//                             <p class="ac-align-center ac-margin-bottom-20"><strong>Tel Aviv 2020 Pride Celebrations – guaranteed to blow your mind!</strong></p>
//                             <p>Tel Aviv, one of the most celebrated gay capitals in the world, is famous for its round the clock energy and extravagant nonstop parties, but by far one of the biggest and hottest events in the city are the Gay Pride Week festivities culminating in the awesome Friday Pride Parade.</p>
//                             <p>The parade, a tradition which began as early as 1998 draws a huge crowd of the coolest people from around the world who come together to celebrate and support freedom and the embracing of all lifestyles and genres in an open-minded off the charts celebration.</p>
//                             <p>The parade is the highlight of a week of gay pride events that take place around the city and include nonstop pride-themed parties, exhibitions, movie festivals, music concerts and so much more. </p>
//                             <p>The parade itself takes place along the buzzing main streets of amazing Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic floats, live music, dance performances and revelers dressed in a colorful festival dress.</p>
//                             <p>The parade culminates at the stunning Tel Aviv promenade by the shores of the beautiful Tel Aviv coastline where it turns into an epic adrenaline-charged beach party featuring leading DJs and live performances, lasting well into the small hours of the night.  </p>
//                             <p>The 2020 parade will take place on June 12th 2020 and participation, as always, will be completely free of charge. </p>
// 					               `
// 			}
// 		}
//     },
//     {
// 	              id: "Hutzot_Hayotzer_Jerusalem_2020",
// 	              bgImage:"/posts/bank/international-arts/1.jpg",
// 	              mobBgImage:"/posts/bank/international-arts/M.jpg",
// 	              title: "Hutzot Hayotzer Jerusalem",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													The Sultan’s Pool, Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 							        <div class="clear"></div>
//                                     <h2  class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">The International Arts and Crafts Festival</h2>
//                                     <p>Jerusalem is packed with fantastic events throughout the summer, one of the most celebrated events is the colorful “Hutzot Hayotzer International Art and Crafts Festival”. </p>
//                                     <p>This large-scale annual festival takes place in the Hutzot Hayotzer area and the Sultan’s Pool, opposite the Tower of David and at the foot of the walls of the Old City. </p>
//                                     <p>The iconic Hutzot Hayotzer festival has been held for over 35 consecutive years and has become a hugely popular tourist and artistic attraction for visitors from around the world.</p>
//                                     <p>The festival includes more than 150 local artists who showcase their art including paintings, prints, ceramics, jewelry and more. The festival also includes an international exhibition, showcasing the work of overseas artist.</p>
//                                     <p>Visitors will get to engage in a fascinating dialogue of art and enjoy unique workshops, live performances, an Irish pub, huge sculptures, live Jazz music and all in an authentic European carnival atmosphere. </p>
//                                     <p>The festival is open every evening (except Fridays) between 18:00 and 23:00 and on Saturday night from 21:00 until midnight, at the Hutzot Hayotzer, Mitchell Park and the Merrill Haasenfeld Amphitheater at the Sultan’s Pool.</p>
//                                     <p>Last but definitely not lease, don’t miss the “Food around the world” - an Israeli and international food fair which will include food stalls of various tastes from different world kitchens: Thai, Israeli, Chinese, Korean, and more.</p>
// 	                            `
// 			}
// 		}
//     },
//     {
//                   id: "Jerusalem_Beer_Festival_2020",
// 	              bgImage:"/posts/bank/jerusalem-beer-festival/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem-beer-festival/M.jpg",
// 	              title: "Jerusalem Beer Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Time</h2>
// 											<div class="text">
// 												<p>
// 													18:00 – 00:00
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							        <p>The city of Jerusalem is proud to host, for the 16th(!) year in a row – the fabulous and hugely popular ‘Beer Festival’. </p>
//                                     <p>The Jerusalem Beer Festival is an internationally recognized celebration of good music, good food and of course, you guessed it, great beer. </p>
//                                     <p>Held in the magical 3000-year-old city of Jerusalem, the festival boasts an unparalleled atmosphere, guaranteeing an unforgettable experience.</p>
//                                     <p>The iconic festival has become over the years a symbol of Jerusalem's entertainment culture and creates a unique opportunity for visitors from around the globe to enjoy a delicious variety of excellent cold beers, food and people in open Jerusalem air.</p>
//                                     <p>During the festival, you will have the opportunity to taste any (or all) of the over 120 special flavors of beers from around the country and the world, served in pop up bars, build specifically for the festival. </p>
//                                     <p>The Jerusalem Beer Festival is the only festival of its kind in Israel, hosting a huge variety of large and international beer brands every year alongside a distinguished presence of local artisanal breweries.</p>
//                                     <p>So make your way and join more than 15,000 visitors coming to enjoy the unique atmosphere, the fantastic live shows, the great food and the awesome people, and to celebrate the global love of Beer.</p>
// 	                            `
// 			}
// 		}
//     },
//     {
//         id: "Jerusalem_Wine_Festival_2020",
// 	    bgImage:"/Concerts/bank/jer-wine-festival-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jer-wine-festival-2020/M.jpg",
// 	    title: "Jerusalem Wine Festival",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							 <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Wine and dine in the holy city!</h2>
// 							<p>Relaxing summer evenings were made for an exquisite glass of fine wine! And for four days in August, you can enjoy world-class selections and award-winning food at the 16th Annual JWF. Hosted in the beauty of the Japanese Art Garden of the Israel Museum, this is considered by many to be Jerusalem’s premier social event. It’s a wine festival unlike any other, whose ambiance and stunning views of this historic city combine to make the JWF a not-to-be-missed experience.</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Hundreds of wines will be served by dozens of well-known and boutique wineries. There’ll be free wine tasting opportunities, along with a culinary oasis of stalls offering cheeses, chocolates, olive oils, exceptional sauces, and tasty jams. And speaking of tasty jams, the festival will get your party started every night with two different live music concerts.</p>
//                             <p>Every year, the JWF welcomes a diverse and refined crowd of over 20,000 wine and culture lovers to Jerusalem. Many attend over multiple evenings simply to soak in the atmosphere. You could even build your stay in the city around the festival! Certainly, your days will be filled with sightseeing, shopping, and loads of walking about. The perfect way to unwind after your busy days might well be several fun-filled nights at the Jerusalem Wine Festival!</p>
// 					     `
// 			}
// 		}
//     },
//     {
// 	              id: "Open_Houses_Festival_2020",
// 	              bgImage:"/posts/bank/openhf/1.jpg",
// 	              mobBgImage:"/posts/bank/openhf/M.jpg",
// 	              title: "Open Houses Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv, City -Wide
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													09.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Mas iNformacion</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="//www.batim-il.org/DefaultEng.aspx?batim=">
// 														www.batim-il.org
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div><div class="clear"></div>
//                                     <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">An amazing experience for design lovers everywhere</h2>
//                                     <p>This September, the nonstop city of Tel Aviv will be hosting for the 14th year in a row, the fantastic ‘Open Houses’ Architecture and Design Festival. </p>
//                                     <p>The event will include an exciting program of fascinating visits and tours to some of the most intriguing buildings in the city including private homes, apartments, historical buildings, and urban buildings. I from tours of residential apartments and new buildings. The Festival will also include special guided tours and attractions in unusual places.</p>
//                                     <p>The ‘Open Houses’ opens a one-time door and allow a glimpse into the forms of design, life forms, history, culture, technology, ecology and houses of added value that makes them intriguing and attractive</p>
//                                     <p>Among the many buildings and structures open to the public, some of which have never been opened before are:  Tel Aviv Velodrome, opened for the first time, a ship from within, a synagogue from 1840 in Old Jaffa and some fan favorites including the helipad on the Azrieli roof and a glimpse of the atomic shelter at Dizengoff Center. </p>
//                                     <p> "Open Houses” is part of the Open House World Wide's international organization, operating in New York, London, Chicago, Rome, Barcelona, Melbourne, Dublin, Helsinki, and more. </p>
//                                     <p>Be sure to check out what is guaranteed to be a unique and unforgettable urban celebration in the awesome city of Tel Aviv!</p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Purim_2020",
// 	              bgImage:"/Concerts/bank/purim2020/1.jpg",
// 	              mobBgImage:"/Concerts/bank/purim2020/M.jpg",
// 	              title: "Purim 2020",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Lugar</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv and Jerusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											 <h2>fecha</h2>
// 											<div class="text">
// 												<p>
// 													09-10.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									</div><div class="clear"></div>
//                                     <p>Every year in March, Tel Aviv and Jerusalem people dress up in costumes and the cities are a party and it’s all because of Purim – the most colorful and fun holiday of them all!</p>
// 		                            <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/1.jpg"} class="img-responsive" />
// 									</div>
// 		                            <p>As expected, the party capital doesn’t disappoint, as there are tons of events to choose from – with the annual street party being Tel Aviv’s biggest event. Thousands of dressed up people will gather together in Kikar Hamedina to enjoy performances from top musicians and dance together! The best part? It’s free of charge! If you won’t be too exhausted, you can also participate in Tel Aviv’s Zombie Walk. The name is self-explanatory, as the walk features hundreds of zombies walking through the streets of the city that never sleeps. Other events include Tel Aviv Street Party in Rothschild boulevard and many more.</p>
// 		                            <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/2.jpg"} class="img-responsive" />
// 									</div>
// 		                            <p>If you prefer to spend the holiday in the city of gold, have no fear as there are plenty of events taking place across Jerusalem – from carnivals to parties there is something for everyone: The official Jerusalem Purim events are held at Safra Square, featuring activities and performances for kids. Another option is the event at the Israel Museum that’s meant for the whole family. There’s also a Purim Rave Party at The Tower of David, the traditional parade at Nachlaot street, a party at Downtown Jerusalem building, a Purim party at the Shuka and more events to be confirmed!</p>
// 		                            <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/4.jpg"} class="img-responsive" />
// 									</div>
// 		                            <p>So choose your costume and come celebrate with us!</p>
// 	                            `
// 			}
// 		}
//     },
//     {
//         id: "TelAviv_Fashion_Week_2020",
// 	    bgImage:"/Concerts/bank/fashion-week-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/fashion-week-2020/M.jpg",
// 	    title: "TEL AVIV FASHION WEEK",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											03.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">C'est chic, magnifique!</h2>
//                             <p>Fashion events are always a celebration of elegance, imagination, creativity, and style. But the TAFW has been making its mark in the international fashion industry with its recent attention to changing ideals of beauty, featuring models, both male and female, of different ages, sizes, heights, colors, and religions. The 4-day event showcases uncommon displays from around the world and those close to home in and around Tel Aviv’s vibrant design scene. </p>
//                            <!--<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
// 							</div>-->
// 							<p>TAFW also embraces leading edge fashion concepts by exhibiting innovative uses of technology and textiles. And it’s especially proud of the support it provides to young designers. As in past editions, this 7th annual event will feature an Upcoming Designers show in which new talent will have an opportunity to share their wares with you!</p>
//                             <p>In 2020, Tel Aviv Fashion Week will once again take place in the historic Tachana complex. Formerly the final stop of the old Jaffa-to-Jerusalem railway, the station has been transformed into one of Tel Aviv’s coolest and most lively public spaces. Located in a trendy neighborhood of pastel-colored homes, unique boutiques, and numerous cafes, you’ll want to explore the entire area while you’re getting your vogue on at the TAFW!</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: "The_Jerusalem_March_2020",
// 	    bgImage:"/Concerts/bank/jerusalem-march/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jerusalem-march/M.jpg",
// 	    title: "The Jerusalem March",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											30.09.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<p>Taking place in October, the Jerusalem Walk is one of the most colorful and exciting events in the country, bringing together tens of thousands of marchers from around the world.</p>
//                              <p>The Jerusalem march includes three events - a morning walk on nature trails, a happening in Sacher Park and a festive parade that takes place in the streets of central Jerusalem.</p>
//                              <p>To ensure the inclusion of all those who want to join, the march offers a variety of routes with different lengths and difficulty levels. </p>
//                              <p><strong>Morning Tracks</strong><br/>
//                              	<u>Track A</u> - for those who can walk, about 12 km (07:00 to 09:00)</p>
//                              <p><strong>Ammunition Hill to Sacher Park.</strong><br/>
//                              	<u>Track B</u> - Medium difficulty level, about 9 km (07:30 to 09:30)</p>
//                              <p><strong>Mount Scopus to Sacher Park.</strong><br/>
//                                 <u>Track C </u>- easy / family difficulty level, about 4 km (08:00 to 10:00)</p>
//                              <p>Safra Square to Sacher Park.<br/>
//                              Sacher Park Festival </p>
//                              <p>Between 10:00 and 16:00 a festive happening will take place in Sacher Park that will include performances, live music and children’s shows, and a designated area dedicated for kids. </p>
//                              <p>The festive parade will begin at 15:00 and will follow the route of Bezalel, Hillel and King David streets and will end next to the bell park and will include collector vehicles, representative groups from Israel and around the world, orchestras, dance groups, IDF soldiers, street artists, sports teams and more.</p>
//                              <p>Don’t miss your chance to take part in this beautiful and lively Jerusalem celebration! </p>
// 				`
// 			}
// 		}
//     },
//     {
//         id:"The_Pixies_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											14.07.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas iNformacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">The Pixies - coming back to rock it live Tel Aviv!</h2>
// 										<p>The Israeli summer is always hot, but the Pixies are returning to Tel Aviv after 3 years to make it even hotter!</p>
// 			                            <p>The famous American band, well known for its signature style of aggressive punk rock and pop, is responsible for some of the most iconic tunes in music history, including their all-time audience favorite ‘where is my mind’. The pixies are returning to Tel Aviv for the third time as part of their promotional tour for their new album, ‘Beneath the Eyrie’. </p>
// 			                            <p>The pixies will be giving a single performance in the nonstop city of Tel Aviv, the perfect way to rock your beach, sun and fun Tel Aviv holiday.  The concert is set to be held in July, a fabulous time to enjoy the famous Tel Aviv summer, the parties, the amazing cuisine, and the stunning beaches. </p>
// 			                            <p>Tickets are selling fast so hurry up and book your trip today!  </p>
// 						`
// 			}
// 		}
// 	},
// 	{
//         id:"White_Night_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "White Night",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>fecha</h2>
// 									<div class="text">
// 										<p>
// 											06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">A “White Night” Rager In the Non-Stop City!</h2>
// 							<div class="responisve-iframe">
// 								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 							</div>
// 							<p>When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat. “White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open and everything is happening across the city at the same time…</p>
//                             <p>From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Adam Primer
// 							</small>
// 							<p>The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City", Tel Aviv’s largest architectural collection of Bauhaus style buildings a world cultural heritage site, giving it a unique status in the architectural heritage of the modern era.</p>
//                             <p>This historic declaration has been celebrated yearly ever since by Tel Aviv-Jaffa in a series of white night events, named after the "White City" and Tel Aviv’s other well-known characteristic: being “The City That Doesn’t Stop”.</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Kfir Sivan
// 							</small>
// 							<p>The White Night is a celebration of numerous events held throughout the city, which seems to expand with every passing year. In recent years, the celebrations  included (to name just a few): a unique midnight public picnic, an epic headphones party in the city’s main square, countless live music concerts, amazing indoor as well as street theatre performances, fascinating nighttime tours, night sports classes , Yoga at sunrise, and of course countless epic parties, all taking place all night across the city at the same time. </p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by Moshik Lindenbaum
// 							</small>
// 							<p>So you better get your rest on- you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv! </p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by: Guy Yechiely‎.
// 							</small>
// 						`
// 			}
// 		}
// 	},
// 	{
//         id:"Piano_Competition_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "La Competición Internacional de Piano Rubinstein 2020",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>Fecha</h2>
// 									<div class="text">
// 										<p>
// 											05-21.05.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas Informacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://arims.org.il/">
// 											www.arims.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<p>No faltan eventos fantásticos de arte y cultura en Tel Aviv, pero la Competición Internacional Rubinstein es el orgullo de la ciudad.</p>
// 							<p>39 pianistas de extremado talento han sido nominados para participar en la Competicion Internacional de Maestros del Piano Arthur Rubinstein. 15 competidores vienen de Asia, 10 de Europa del Este, 7 de Europa Occidental, 3 talentos locales, 2 de Georgia y 2 de los EE.UU. Tel Aviv, el núcleo cultural de Israel, se enorgullece de darles la bienvenida.</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/piano-competition-2020/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>Las primeras dos fases de esta prestigiosa competición tendrán lugar en el Museo del Arte de Tel Aviv, una de las instituciones culturales y artísticas líderes del país. El vibrante Mercado de Sarona está solo a 10 minutos andando.</p>
// 							<p>Las ultimas fases se celebrarán en el Auditorio de Charles Bronfman, también conocido como el Palacio de la Cultura (Heichal Ha Tarbut), en la plaza de Habima, al lado del teatro nacional. Algunas de las mejores cafeterías y restaurantes de Tel Aviv se encuentran muy cerca, además del precioso Rothschild Boulevard.</p>
// 							<p>La venta anticipada para socios ya ha empezado. La venta para todo el público empezó el 16 de febrero. del 2020.</p>
// 						`
// 			}
// 		}
// 	},
// 	{
//         id:"Red_Hot_Chili_Peppers_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Red Hot Chili Peppers",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Lugar</h2>
// 									<div class="text">
// 										<p>
// 											Parque Hayarkon Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>Fecha</h2>
// 									<div class="text">
// 										<p>
// 											10.06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Mas Informacion</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://redhotchilipeppers.com/">
// 											www.redhotchilipeppers.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<p>¡Son candentes, son sexis, son los Red Hot Chili Peppers, y vuelven a Tel Aviv por primera vez desde el 2012!</p>
// 							<p>Con 11 álbumes, 16 nominaciones a los Grammy y seis premios, esta banda mega-exitosa hará que tu cuerpo y alma bailen en el nuevo Festival Funkyard que se celebrará en el corazón verde de Tel Aviv – el parque Hayarkon.</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/red-hot-chili-peppers-2020/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>En diciembre pasado, la banda anunció la reincorporación por segunda vez de su legendario guitarrista John Frusciante, y es de esperar que los iconos del funk-rock de LA volverán a arrasar en el parque.</p>
// 							<p>Los Red Hot Chili Peppers darán un único concierto en la ciudad que nunca para, donde puedes empezar el día bronceándote en la playa con unas cervezas fresquitas y acabar en uno de los animados bares abiertos hasta el amanecer. Los Peppers actuarán al principio del verano cuando las temperaturas aún no son muy altas, aunque las fiestas por la ciudad están al rojo vivo.</p>
// 							<p>Las entradas ya están a la venta y se van a agotar, así que, ¡reserva tu viaje antes de que ya no queden más!</p>
// 						`
// 			}
// 		}
// 	},
// ];
// End live shows
var ShowsPostsData=[];var newPostdata=[{id:"eurovision",bgImage:"/posts/bank/eurovision/1.jpg",mobBgImage:"/posts/bank/eurovision/M/1.jpg",title:"EUROVISION TEL AVIV",ctg:"eurovision",isVid:false,smlTitle:"",html:function html(){return{__html:"\n\n                   \t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/eurovision/logo.png")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tA ONCE IN A LIFETIME OPPORTUNITY TO VISIT TEL AVIV AS IT HOSTS THE EUROVISION SONG CONTEST\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\t\t\t\t\t\n\t\t\t\t\t\tEpic song contest in the Non-Stop City\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSemi-final 1: 14 May 2019\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSemi-final 2: 16 May 2019\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tGrand Final: 18 May 2019\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tIt\u2019s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city.\n\t\t\t\t\t</p>\t\t\t\t\t\n\t\t\t\t\t<p>\n\t\t\t\t\t\tTel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak. Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest.\n\t\t\t\t\t</p>            \n                   \t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/eurovision/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tMajor productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega \u201CEuro Village\u201D which will be situated merely a minutes\u2019 walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest\u2019s semifinal and final. The contest itself will take place in the Expo Tel Aviv.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all!\n\t\t\t\t\t</p>\n\n            \t"};}},{id:"Get_ready_to_party",bgImage:"/posts/bank/Get_ready_to_party/1.jpg",mobBgImage:"/posts/bank/Get_ready_to_party/M/1.jpg",title:"The best Eurovision parties to be at",ctg:"eurovision",isVid:false,smlTitle:"",html:function html(){return{__html:"\n\n               <h3>\n               \tYour Total Guide to Tel Aviv Eurovision parties\n               </h3>\n               <p>\n\t\t\t\t\tFrom the Eurovision Village to the EXPO Centre, these are all the key places you need to know about for Eurovision 2019 in Tel Aviv\u2026\n\t\t\t\t</p>\n\t\t\t\t<h3>\n\t\t\t\t\tCHARLES CLORE PARTY VENUE\n\t\t\t\t</h3>\n\t\t\t\t<h3>\n\t\t\t\t\tCharles Clore Park: home to the largest Eurovision Village to have ever been made.\n\t\t\t\t</h3>\n\t\t\t\t<p>\n\t\t\t\t\tCharles Clore Park is located on the sea-front in the south-west of Tel Aviv. It\u2019s a beautiful green space overlooking Old Jaffa, one of the most ancient places in Tel Aviv. \n\t\t\t\t\tDuring Eurovision week it will be home to the Eurovision Village, where free concerts from the biggest Eurovision stars will take place. Highlights include Dana International and Conchita Wurst, plus parties and screenings of the live Eurovision TV shows will take place outside, right in-front of the beautiful Mediterranean sea! \n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tAlso, some of Israel\u2019s best chefs will be opening food stalls for the public to get first-hand experience of-mouth-watering Israeli and Middle-Eastern cuisine.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tCharles Clore is easy to get to: It\u2019s a five minute walk from the Carmelit bus terminal, so any bus terminating there is a good choice. Then you can just walk towards the sea and you\u2019ll see the village. If coming by foot, walk along the beach promenade. Or you can cycle or scoot along the sea front to get there. \n\t\t\t\t\tIt\u2019s a big park and will be having a Eurovision makeover, so you won\u2019t be able to miss it! In fact, this is the largest village to ever have been made for the Eurovision!\n\t\t\t\t</p>\n\t\t\t\t<h3>\n\t\t\t\t\tTEL AVIV PORT VENUE (\u201CThe Namal\u201D)\n\t\t\t\t</h3>\n\t\t\t\t<h3>\n\t\t\t\t\tHome to 2019\u2019s official Eurovision Euro Club\n\t\t\t\t</h3>\n\t\t\t\t<p>\n\t\t\t\t\tWith its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tWith its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tThe club will feature theme parties, live performances, screenings of the Eurovision live shows and many more surprises to be revealed. Former Eurovision acts and winners, both Israeli and international, are set to perform there during the Eurovision week, so the venue will offer much more than just a traditional night-club. Entry to the Euroclub is free for accredited fans, journalists, delegations and artists. Members of the general public can get in to the Euroclub by purchasing a special weekly bracelet, here:\n\t\t\t\t\t<a href=\"https://www.eventer.co.il/euroclub?fbclid=IwAR37-d_19OE7bsq0rQ_gPHAW-sRfn1QAMi-cxp_ID2pFtDODBYzbf5NB6S0\" target=\"_blank\">https://www.eventer.co.il</a>\n\t\t\t\t</p>\n\t\t\t\t<h3>\n\t\t\t\t\tEUROVISION VENUE\n\t\t\t\t</h3>\n\t\t\t\t<h3>\n\t\t\t\t\tExpo Tel Aviv: home to the Eurovision Song Contest itself\n\t\t\t\t</h3>\n\t\t\t\t<p>\n\t\t\t\t\tThe 2019 Eurovision Song Contest will be held at the Tel Aviv Expo center on the14th, 16th and 18th May. If you\u2019ve got tickets, this is the place you\u2019ll need to get to.\n\t\t\t\t\tIt\u2019s located on Rokach Boulevard in the north of the city, past HaYarkon Park and near to Tel Aviv University. To get there, use a journey planning app to find a bus route that will drop you right outside. Or, if travelling by train, get off at Tel Aviv University Train Station which is just a few minutes\u2019 away from the convention centre.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tDon\u2019t forget about the White Night, all the details are in the next article.\n\t\t\t\t</p>\n\n         \t"};}},{id:"Tourist_info",bgImage:"/posts/bank/Tourist_info/1.jpg",mobBgImage:"/posts/bank/Tourist_info/M/1.jpg",title:"Tourist info",ctg:"telaviv",isVid:false,smlTitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t<h3>\n\t\t\t\t\tHow to get to Tel Aviv from the airport:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tThe cheapest way to get into central Tel Aviv from Ben Gurion airport is by train. Follow the signs to the train station that\u2019s attached to the airport (it\u2019s clearly sign-posted) and look for a train that\u2019s going to Tel Aviv-HaHagana (for south Tel Aviv), Tel Aviv-HaShalom (for Central Tel Aviv), Tel Aviv-Savidor Center (for the Old North area of Tel Aviv), or Tel Aviv-University (for the Eurovision Song Contest venue itself). Please note that Tel Aviv HaShalom is closed on Fridays until September 2019. \n\t\t\t\t\tA one-way single ride ticket will cost 13 shekels 50, and the journey takes around 25 minutes. When you get off the train, you might want to take a taxi to your accommodation. Whenever you get in a taxi, ask the driver to use the meter (\u201Cmonet\u201D) and have cash ready to pay. Or see below for details of taxi apps. For more information and to plan your journey, visit <a href=\"https://www.rail.co.il/en\" target=\"_blank\">https://www.rail.co.il/en</a>: - it\u2019s in English!\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\tIf you\u2019d prefer to take a taxi all the way to Tel Aviv from the airport, then join the registered taxi queue outside the arrivals hall. A member of staff will ask you where you\u2019re going and how many passengers and cases you have, then will give you a ticket to hand to your driver. You can either use a meter or accept a fixed price. Journeys usually cost around 150-170 shekels for one person. \n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tHow to get from Tel Aviv to Jerusalem:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<h3>\n\t\t\t\t\tBy Bus\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tHead to the Tel Aviv Savidor train central station take bus no.480. The journey time is around 45 minutes. The bus route finishes at the Jerusalem Central Bus Station on Jaffa Road. From there you can take the tram or any other means of transportation available to you, to get to your final destination. \n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tBy Train\n\t\t\t\t\t</h3>            \n\t\t\t\t\t<p>\n\t\t\t\t\tYou can also take the brand new train! If you want to go to Jerusalem directly from Ben Gurion Airport, take the train to Navon Station in Jerusalem. The journey from the airport takes around 25 minutes. If you\u2019re connecting from other Tel Aviv stations, just take a train to Ben Gurion Airport station and change there for a connection to Navon.  \n\t\t\t\t\t</p>            \n\t\t\t\t\t<h3>\n\t\t\t\t\tHow to get around Tel Aviv\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tThe municipality of Tel Aviv will offer free public transport throughout the city over the weekend of the Eurovision Song Contest. \n\t\t\t\t\tFree buses will run on Friday and Saturday May 17-18.\n\t\t\t\t\tHowever Usually on Saturday there is no public transport in Tel Aviv (aside from taxies).\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\tFor the other days of Eurovision week, you\u2019ll need a Rav Kav card: Similar to the \u201COyster Card\u201D in London, a Rav Kav is a smart card that can be loaded with credit to allow you to ride on buses without needing to worry about cash. In fact, bus drivers no longer let you pay in cash, so it\u2019s super important to get a Rav Kav as soon as you arrive in Tel Aviv.\n\t\t\t\t\tTo get a card, just jump on a bus at any bus stop, and ask the driver for a Rav-Kav card - it costs 5 shekels (You will need exact change). Then, when you get off the bus, take the card anywhere with you. Some local 7/11s (Kiosk) provide top up serives, ask to add some credit. 50 shekels is probably enough for a one-week visit, as it will cover the cost of around 10 local journeys (each journey is 5 shekels 90). \n\t\t\t\t\tYou can also buy a Rav Kav at the official Rav Kav office at 35 Iban Gabirol Street, which is open Sunday to Thursday 8:00 - 20:00 and Friday and holiday eves 8:00 - 13:00 ,or in the Tel Aviv Savidor train station and Carmelit central. You can also add credit at any train station. \n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tCycling\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tTel Aviv is a cycling hot-spot and there are bike lanes all around the city, including one that runs all the way along the beach promenade from Jaffa in the south  the north of Tel Aviv and beyond, which are gorgeous locations to take a bike ride while soaking up the atmosphere and architecture of Tel Aviv. If you have a bicycle helmet, bring it with you. \n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tElectric Scooters\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tScooters have become super popular in Tel Aviv! They offer a convenient and fun way to get round the city. There are a few brands around \u2013 all you have to do is download the relevant app, follow instructions and off you go. Swap your handbag for a rucksack as this will help with balance and remember to keep an eye on the traffic and not to listen to music while scooting. If you have a helmet, it\u2019s a good idea to wear it while you scoot\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tWalking\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tWalking is also a great option too - your step-count will soar after a few days in the non-stop city! Equip yourself with a map, a sun-hat and a bottle fo water, and hit the pavements!\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tTransportation Apps \n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tThere are various transportation apps you can download before arrival to help you plan your way around. Search for one from each category: there are taxi apps, bicycle rental apps, scooter rental apps and journey planning apps. You can also ask your hotel concierge or apartment host for advice on how to get around Tel Aviv - they will be happy to help! \n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tWIFI\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tTel Aviv has a free Wifi network throughout the city. Look for the \u2018Free TLV\u2019 network in your smartphone - it works in 80 locations around the city. Most cafes and bars have free public Wifi networks you can use too; just ask for the password when you make your order. Hotels also have free Wifi so just ask for the password information when you check-in.\n\t\t\t\t\t</p>\n\n         \t"};}},{id:"White_night",bgImage:"/posts/bank/White_night/1.jpg",mobBgImage:"/posts/bank/White_night/M/1.jpg",title:"White night",ctg:"eurovision",isVid:false,smlTitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t\t<h3 class=\"align-center\">\n\t\t\t\t\t\t\t  White Night Lights Up Tel Aviv on 16th May \n\t\t\t\t\t\t\t</h3>\n        \t\t\t\t\t<div class=\"responisve-iframe\">\n\t\t\t\t\t\t\t\t<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/T0ugqxG5UaM\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<p>What do you get when you cross a Eurovision Semi-Final with an all-night party in a city that is famous for its 24/7 party energy? The answer is White Night, which will hit Tel Aviv this year on Thursday 16th May, just two days before the 2019 Eurovision Song Contest grand final.</p>\n                            <p>Featuring pop-up art installations, live music, dance parties, cultural events, food and drink, all fused together with Tel Aviv\u2019s eclectic atmosphere, White Night is one of the biggest cultural events of the year. </p>\n                            <p>And for 2019, it\u2019s taking place a month earlier than usual, so that visitors coming for the Eurovision Song Contest can also experience this magical experience in the White City of Tel Aviv.</p>\n\n\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/White_night/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<small>\n\t\t\t\t\t\t\t\tPhoto By: Adam Primer\n\t\t\t\t\t\t\t</small>\n\n\t\t\t\t\t\t\t<p>From sunset until sunrise, the city will be wide-awake with cultural activities. Locals and visitors alike are invited to explore the city and soak up all the activities on offer. Many bars, restaurants and shops will be offering experiences free of charge or at reduced rates, so it\u2019s definitely worth stocking up on sleep so you\u2019re ready to party all night long!</p>\n                            <p>And at the Eurovision Village in Charles Clore Park, there\u2019ll be an extra sparkle of Eurovision magic, as several icons of the competition take to the stage to entertain visitors during the night. </p>\n                            <p>Last year\u2019s runner-up, Eleni Foureira, who narrowly missed out to Tel Aviv\u2019s own Neta Barzilai with her smash-hit song \u201CFuego\u201D, will be performing, as will 2014 winner, Conchita Wurst from Austria, who will most likely perform his iconic winning song, \u201CRise Like a Phoenix\u201D while showcasing his new-look for 2019!</p>\n                            <p>They\u2019ll be joined by three more Queens of Eurovision, in the form of 1970s pop icon Anne-Marie David, who won for Luxembourg in 1973, Swedish pop star Carola H\xE4ggkvist, who won the contest in 1991, and Loreen, who also won for Sweden in 2012 with her song Euphoria. The performances will take place on the coast, overlooking the Mediterranean; the live semi-final will also be shown on big-screens in the Eurovision Village, off-set by jaw-dropping light compositions, created by the competition\u2019s official lighting partner OSRAM.</p>\n                            <p>All in all, White Night is a night not to be missed. So make the 15th May your duvet day and get-set to party all night long on Thursday 16th May 2019. Tel Aviv is ready and waiting to celebrate with you!</p>\n\n\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/White_night/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<small>\n\t\t\t\t\t\t\t\tPhoto By: Kfir Sivan\n\t\t\t\t\t\t\t</small>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/White_night/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<small>\n\t\t\t\t\t\t\t\tPhoto by Moshik Lindenbaum\n\t\t\t\t\t\t\t</small>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/White_night/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<small>\n\t\t\t\t\t\t\t\tPhoto by: Guy Yechiely\u200E.\n\t\t\t\t\t\t\t</small>\n\n         \t"};}},{id:"Tel_Aviv_Street_Food",bgImage:"/posts/bank/street-food/1.jpg",mobBgImage:"/posts/bank/street-food/M/1.jpg",title:"TEL AVIV STREET FOOD",ctg:"telaviv",isVid:true,vidId:"JQD9JpMaw9g",smlTitle:"",html:function html(){return{__html:"\n\n                     <h3>It is no wonder that Tel Aviv was named one of Saveur Magazine\u2019s \u201COutstanding Culinary Destinations</h3>\n\n                        <p>Tel Aviv, home to sandy beaches, non-stop action and a raging nightlife, is also chock-full of unique restaurants and bars, making the seaside city a trendy foodie destination. The Tel Aviv food industry is truly the city\u2019s heart and soul and while plenty of high-end eateries can be found throughout Tel Aviv, it is fresh local street food that has taken the city by storm.</p>\n\n                        <h3>Taking traditional street food to a whole new level</h3>\n\n                        <p>Say goodbye to the days where Tel Aviv street food was mostly limited to the scrumptious, yet singular concept of crisply fried falafel stuffed into a freshly baked pita. Today, the Tel Aviv street food scene is just that - a scene, with gourmet and specialty treats being served to the masses on local street corners. Take a walk down Ibn Gvirol, Ben Yehuda or Carmel streets and choose from a myriad of high-end meats, fish, prepared vegetables and sauces, all artfully inserted inside pita bread, between slices of toast or other casings. Nibble on the succulent delicacies inspired by the four corners of the world - sabich and tahini in laffa bread, unique herring sandwiches and more, as you continue to wander throughout the city, a taste of Israeli culture on your tongue and a pleasant sense of satisfaction in your belly.</p>\n\n\n                        <h3>Restaurant quality meals for the foodie on the go</h3>\n\n                        <p>What more could a bustling city full of hurried business professionals and excited tourists want than easy access to flavorful and trendy dishes that can be eaten on the go? With more and more unique streetside quick-stop eateries popping up throughout the city and serving dishes like entrecote-stuffed ciabatta bread and cornflour arepas, it is no wonder that Tel Aviv was named one of Saveur Magazine\u2019s \u201COutstanding Culinary Destinations.\u201D </p>\n\n                        <p>Foodies delight: Tel Aviv and its hip street food scene, with countless delectable choices on every corner, is the ultimate culinary travel destination and a must-visit stop on your next Israel trip.</p>\n\n         \t"};}},{id:"Jerusalem_Old_City",bgImage:"/posts/bank/jerusalem-old-city/1.jpg",mobBgImage:"/posts/bank/jerusalem-old-city/M/1.jpg",title:"LA CIUDAD VIEJA!",ctg:"jerusalem",isVid:true,// vidId:"FvAWuLQEOJw",
vidId:"rkjLPq-Zsp8",smlTitle:"",html:function html(){return{__html:"\n                     <br/>\n                     <h3>\n                         Sienta c\xF3mo la historia cobra vida. Insp\xEDrese con los tesoros de fama mundial de la Ciudad Vieja de Jerusal\xE9n\n                     </h3>\n                     <h3>Sienta el resplandor espiritual que irradia de sus murallas </h3>\n\t\t\t\t\t<p>Visitar la Ciudad Vieja de Jerusal\xE9n es como viajar a un nuevo mundo, m\xEDstico y m\xE1gico. Considerada durante mucho tiempo como uno de los lugares m\xE1s sagrados y visitados del mundo, que alberga estructuras y restos significativos para las tres religiones monote\xEDstas: juda\xEDsmo, cristianismo e islam. Un paseo por sus pasajes sagrados es una emocionante fuente de cambio de perspectiva hist\xF3rica, cultural y espiritual que no se puede perder.</p>\n                    \n\t\t\t\t\t<h3>Un entorno iluminado espiritualmente</h3>\n\t\t\t\t\t<p>\xDAnase a los numerosos turistas que visitan diariamente la Ciudad Vieja de Jerusal\xE9n y ser\xE1 transportado en el tiempo. Sea testigo c\xF3mo jud\xEDos, musulmanes, cristianos y armenios viven e interact\xFAan mientras visita los numerosos sitios inspiradores y espiritualmente edificantes, escondidos entre los callejones sinuosos de la Ciudad Vieja y camuflados por la uniformidad de la piedra de Jerusal\xE9n. Recorra la V\xEDa Dolorosa y visite las numerosas iglesias ornamentales, destacando la Iglesia del Santo Sepulcro, rinda respeto en la Tumba del Jard\xEDn, susurre una oraci\xF3n en el Muro Occidental (Kotel), visite los t\xFAneles del Kotel o ad\xE9ntrese en el muy ajetreado mercado \xE1rabe. Las estructuras son sensacionales y le conectan a una \xE9poca pasada.</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/jerusalem-old-city2/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t </div>\n\t\t\t\t\t<h3>Un paseo moderno a trav\xE9s de la historia antigua</h3>\n\t\t\t\t\t<p>Entre a la Ciudad Vieja por cualquiera de sus grandes y magn\xEDficas puertas y ser\xE1 transportado instant\xE1neamente a una \xE9poca antigua, con olores aut\xE9nticos y lugare\xF1os vestidos de forma tradicional. Aqu\xED, podr\xE1 encontrar estrechos carros tirados por burros, bicicletas y veh\xEDculos de tama\xF1o especial que dominan las estrechas calles y callejones y que dan una sensaci\xF3n r\xFAstica del viejo mundo. Comerciantes apasionados, gestionan bulliciosas tiendas, puestos y restaurantes, cada uno vende sus mercanc\xEDas con gran energ\xEDa.</p>\n\t\t\t\t\t<p>En la Ciudad Vieja aseg\xFArese de caminar a lo largo de las paredes de piedra antiguas y encontrar\xE1 impresionantes vistas,hermosas e hist\xF3ricamente ricas, de los sitios circundantes, lugares de inter\xE9s y acontecimientos cotidianos apasionantes. D\xE9 un paseo a lo largo de las murallas de la Ciudad Vieja o visite el adyacente Museo de la Torre de David, donde la historia cobra vida a trav\xE9s del sonido y la luz, magnificando la belleza pura y el significado de los adoquines que pisa.</p>\n\n\n\n                     <!--<p>No other place offers as many attractions and emotionally inspiring sites in a single square kilometer. A tour of the Old City of Jerusalem is an opportunity to get lost among the magical walkways and connect with the city\u2019s resplendent past, history, culture and spirituality. </p>\n\n                             <h3>The Western Wall</h3>\n                             <p>Thousands of years old, the Western Wall is the last remaining relic of the Second Jewish Temple and the most important Jewish prayer site in the world, where millions of visitors from around the world place notes with requests and prayers into its cracks.</p>\n                             \n                             <h3>Western Wall Tunnels</h3>\n                             <p>Located beneath the Western Wall, the tunnels provide a glimpse of the various periods in the history of Jerusalem and are as close as you'll probably get to travelling back in time.</p>\n\n                             <h3>City of David</h3>\n                             <p>Discover the story of Jerusalem during the reigns of Kings David, Solomon and Hezekiah in this captivating archeological site, where many treasures have been unearthed. A visit to the site will enable you to take a flashlight and wade through the flowing water of the Siloam Tunnel, which was carved during the reign of King Hezekiah.</p>\n\n                             <h3>The Old City Market</h3>\n                             <p>A must-see attraction made up of a series of alleyways, with numerous stalls offering a staggering variety of products of every imaginable kind. This lively bustling market (or shuk) is a perfect place to pick up a unique souvenir (haggling is a\n                             must) or try one of the many local delicacies.</p>-->\n         \t"};}},{id:"Jerusalem_Calling",bgImage:"/posts/bank/25/1.jpg",mobBgImage:"/posts/bank/25/M.jpg",vidId:"1Yx2Uht4rms",ctg:"jerusalem",isVid:true,title:"Jerusalén te está Llamando",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t    <p>\n\t\t\t\t\t\t\xBFQu\xE9 m\xE1s se puede decir sobre la ciudad m\xE1s singular del mundo? En pocas palabras: Bienvenido a Jerusal\xE9n, donde una historia gloriosa se entrelaza con una vida moderna y din\xE1mica.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tJerusal\xE9n alberga innumerables lugares hist\xF3ricos fascinantes, senderos m\xE1gicos, vistas impresionantes al atardecer, una gran variedad de opciones de entretenimiento, restaurantes que ofrecen emociones culinarias, una animada vida nocturna y una enorme oferta de centros para las artes y la cultura.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   La Ciudad Vieja\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tNing\xFAn otro lugar ofrece tantas atracciones y lugares de inspiradora emoci\xF3n en un solo kil\xF3metro cuadrado. La Ciudad Vieja de Jerusal\xE9n rebosa de oportunidades para conectarse con el resplandeciente pasado, la historia, la cultura y la espiritualidad de la ciudad. En el casco antiguo, encontrar\xE1 tesoros arqueol\xF3gicos que tienen miles de a\xF1os de antig\xFCedad, arte contempor\xE1neo y mercados bulliciosos donde puede comprar delicias exquisitas.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t  El Muro de las Lamentaciones:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tConsiderado el \xFAnico tramo restante del Segundo Templo, el Muro de las Lamentaciones se ha convertido en un verdadero sin\xF3nimo de Jerusal\xE9n. De antig\xFCedad milenaria, es el lugar de oraci\xF3n jud\xEDo m\xE1s importante del mundo, donde los chicos de trece a\xF1os acuden a celebrar sus Bar Mitzvahs, y donde millones de visitantes y turistas de todo el mundo colocan notas con peticiones y oraciones en sus grietas\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t  T\xFAneles del Muro de las Lamentaciones:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tVisitar los t\xFAneles es como entrar en una m\xE1quina del tiempo. Situados bajo el Muro de las Lamentaciones y el barrio musulm\xE1n, proporciona al visitante una visi\xF3n de los diferentes per\xEDodos de la historia de Jerusal\xE9n.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Ciudad de David:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSituada junto a la Puerta del Esti\xE9rcol, este lugar presenta la historia de Jerusal\xE9n durante los reinados del Rey David, el Rey Salom\xF3n y el Rey Ezequ\xEDas. Muchos tesoros arqueol\xF3gicos fueron desenterrados en la excavaci\xF3n, incluido un pendiente de oro de dos mil a\xF1os de antig\xFCedad.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t   Una visita al lugar le permitir\xE1 tomar una linterna y atravesar el agua que fluye del t\xFAnel Siloam, que fue construido durante el reinado del rey Ezequ\xEDas.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t V\xEDa Dolorosa\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tLos cristianos siguen los pasos de Jes\xFAs por la V\xEDa Dolorosa y las 14 Estaciones de la Cruz, recreando el fat\xEDdico camino que tuvo un impacto sin precedentes en el curso de la historia.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t  Iglesia del Santo Sepulcro:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSeg\xFAn la tradici\xF3n cristiana, la Iglesia es el lugar donde Jes\xFAs fue crucificado, sepultado y donde resucit\xF3 de entre los muertos. Ha sido durante mucho tiempo y sigue siendo un importante centro de peregrinaci\xF3n para cristianos de todo el mundo.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t El mercado de la Ciudad Vieja\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tEsta atracci\xF3n obligada se compone de una serie de callejones, con numerosos puestos que ofrecen una asombrosa variedad de recuerdos, ropa, comidas (productos horneados, especias, dulces, o tehini entre otros); quioscos que venden zumos de todo tipo, cer\xE1micas armenias, tambores y otros instrumentos musicales, artesan\xEDa en barro y mucho m\xE1s. El colorido mercado ofrece una experiencia aut\xE9ntica para disfrutar al m\xE1ximo que simplemente no se puede dejar pasar.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/4/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tAtracciones\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tTours en Segway:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tEsta forma de ver la ciudad cargada de adrenalina le permitir\xE1 apreciar la belleza de Jerusal\xE9n desde una perspectiva completamente diferente. Los recorridos en Segway parten de varios puntos c\xE9ntricos, como el paseo Armon HaNatziv (Talpiot Este), Yemin Moshe o la Ciudad Vieja, as\xED como tambi\xE9n desde cerca del Knesset y el \xE1rea de museos.\n\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n                        \n                        El Ascensor del Tiempo (Time Elevator):\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Si le gustan las atracciones de feria, le encantar\xE1 iluminar sus sentidos con el Ascensor del Tiempo (Time Elevator). Es una experiencia interactiva que traslada a los visitantes a lugares fascinantes a trav\xE9s de fabulosos viajes, con asientos en movimiento en una sala \xFAnica llena de efectos especiales.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n                        La Primera Estaci\xF3n (Hatachana):\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  La Primera Estaci\xF3n est\xE1 justo en el coraz\xF3n de Jerusal\xE9n, entre la Ciudad Vieja y el centro de la ciudad, y entre los barrios hist\xF3ricos de la Colonia Alemana y Yemin Moshe. Es donde estaba la primera estaci\xF3n de tren en Jerusal\xE9n, que fue construida en 1892. Despu\xE9s de experimentar una renovaci\xF3n y conservaci\xF3n la Primera Estaci\xF3n volvi\xF3 a abrir sus puertas como un animado lugar de entretenimiento.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Mercado de Mahane Yehuda:\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Para experimentar la ciudad lo m\xE1s aut\xE9nticamente posible, su itinerario debe incluir una parada en el Mercado de Mahane Yehuda. Este representa al Jerusal\xE9n del presente y del futuro. Mahane Yehuda a\xFAna de forma \xFAnica lo viejo y lo nuevo, con su mercado tradicional de frutas y verduras, junto con una excelente comida y una animada zona de entretenimiento.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Museos\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   En una ciudad llena de una gran cantidad de museos, tiene un sinf\xEDn de oportunidades para experimentar y aprender sobre los eventos del pasado y para visitar exhibiciones modernas y contempor\xE1neas.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t  Museo de Israel\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   El Museo de Israel es la instituci\xF3n cultural m\xE1s grande del pa\xEDs. Cuenta con numerosas alas y grandes colecciones de arte, arqueolog\xEDa y judaica. Uno de los aspectos m\xE1s destacados de cualquier visita al museo es el Santuario del Libro, con su dise\xF1o \xFAnico que se ha asociado estrechamente con la ciudad en s\xED.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Museo de la Torre de David:\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\nHace miles de a\xF1os, Jerusal\xE9n era una ciudad peque\xF1a, donde reyes y profetas recorr\xEDan a pie o a caballo sus callejones. Desde ese tiempo, uno de los s\xEDmbolos m\xE1s conocidos de la ciudad es la Torre de David, con su torreta manteni\xE9ndose en pie orgullosamente sobre la antigua fortaleza que tambi\xE9n se ha convertido en uno de los museos m\xE1s importantes de la ciudad.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/4/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Restaurantes\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  Jerusal\xE9n cuenta con muchos restaurantes, donde se puede degustar una amplia variedad de delicias locales e internacionales. Y si busca la experiencia gourmet, puede reservar una mesa en restaurantes de chefs exclusivos. Los siguientes son cinco de los lugares m\xE1s elegantes y populares de Jerusal\xE9n, que atraen a multitud de personas a lo largo del d\xEDa:\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Caf\xE9 Kadosh\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t Muy popular, el caf\xE9 sirve productos Kosher. \xA1Todo hecho en casa y delicioso!\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Tmol Shilshom\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  Un caf\xE9-librer\xEDa en el centro de la ciudad, favorecido por su calidez, deliciosa comida y servicio amigable. \xA1No te pierdas el shakshuka o el filete de salm\xF3n en salsa de higos!\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   The Eucalyptus\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  El restaurante Kosher, ubicado en el Barrio de los Artistas, sirve la interpretaci\xF3n del chef Moshe Basson de la cocina b\xEDblica. Cada plato tiene su origen en escenas b\xEDblicas y todas las especias y hierbas usadas crecen, como en la antig\xFCedad, en las colinas circundantes de Jerusal\xE9n y Judea. Una experiencia inolvidable.\n\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Darna\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  Un aut\xE9ntico restaurante marroqu\xED Glatt Kosher, ubicado en el coraz\xF3n de la ciudad. Experimente la c\xE1lida bienvenida y el verdadero significado de la hospitalidad marroqu\xED, mientras disfruta de la excelencia culinaria del Magreb.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Ima Restaurant\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  Justo al final de la calle del mercado de Mahane Yehuda, Ima ofrece excelente comida Kosher de Oriente Medio, servida en un ambiente familiar y relajado.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Y ninguna visita a Jerusal\xE9n est\xE1 completa sin un poco de hummus con un pan de pita reci\xE9n salido del horno. Los siguientes son algunos lugares de hummus ubicados en el centro:\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"cradit\">\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t<strong>Azura,</strong><small> en la secci\xF3n iraqu\xED del Mercado de Mahane Yehuda</small><br>\n\t\t\t\t\t\t\t<strong>Lina,</strong><small> en el Barrio Cristiano de la Ciudad Vieja</small><br>\n\t\t\t\t\t\t\t<strong>Hummus Acramawi,</strong><small>  en el Barrio Musulm\xE1n de la Ciudad Vieja </small><br>\n\t\t\t\t\t\t\t<strong>Hummus</strong><small> Ben Sira, en el centro de la ciudad junto al Hotel Mamilla </small><br>\n\t\t\t\t\t\t\t<strong>Abu Shukri,</strong><small> en el Barrio Musulm\xE1n en la Ciudad Vieja of Jerusal\xE9n </small><br>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t    </div>\n\n\t\t\t\t    <h3>\n\t\t\t\t        Vida Nocturna\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\t\t\t\t         Jerusal\xE9n est\xE1 de montones de restaurantes y lugares de entretenimiento que tambi\xE9n est\xE1n abiertos los viernes por la noche (el Sabbat jud\xEDo). Todas las \xE1reas de entretenimiento de Jerusal\xE9n ofrecen excelentes opciones para la diversi\xF3n del fin de semana los viernes por la noche, as\xED como los s\xE1bados, y desde luego puede disfrutar de una deliciosa velada con una cerveza fr\xEDa o bailando la mejor m\xFAsica.\n                         A continuaci\xF3n, tiene una peque\xF1a selecci\xF3n de bares y discotecas que est\xE1n muy animados los viernes por la noche y le dejar\xE1n con ganas de m\xE1s ...\n\t\t\t\t    </p>\n\n\t\t\t\t    <h3>\n\t\t\t\t       Mantra\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\t\t\t\t       Un \xEDntimo restaurante y vinoteca, donde el ambiente acogedor se combina con una excelente cocina.\n\t\t\t\t    </p>\n\n\t\t\t\t    <h3>\n\t\t\t\t       Gatsby Cocktail Room\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\t\t\t\t       El bar y sal\xF3n de c\xF3cteles evoca la magia de los Locos a\xF1os 20 y los d\xEDas de los cabarets.\n\t\t\t\t    </p>\n\n\t\t\t\t    <h3>\n\t\t\t\t        HaTaklit\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\t\t\t\t       Con un nombre que significa \u201Cel disco\u201D en hebreo, el moderno bar est\xE1 decorado con fundas de disco. Disfrute al m\xE1ximo del bar, la m\xFAsica en vivo, los DJ e incluso de int\xE9rpretes independientes.\n\t\t\t\t    </p>\n\n\t\t\t\t    <h3>\n\t\t\t\t       Toy Bar (HaTza\u2019atzua)\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\t\t\t\tCon una ubicaci\xF3n c\xE9ntrica, el Toy Bar ofrece excelentes bebidas, buena m\xFAsica de algunos de los mejores DJ locales y una gran experiencia de baile.\t\t\t\t    </p>\n\n\t\t\t\t    <h3>\n                        Sira\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n                       Uno de los clubes underground m\xE1s ecl\xE9cticos de la ciudad, con sala de juegos y pista de baile. El pub tambi\xE9n alberga eventos y actuaciones.\n\t\t\t\t    </p>\n\n\t\t\t\t    <h3>\n                        Even / Juke\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\t\t\t\t       Un club de m\xFAsica que presenta las bandas m\xE1s creativas de Israel, con \xE9nfasis en el jazz, el blues y el funk.\n\t\t\t\t    </p>\n\n\t\t\t\t    <h3>\n                       Video Pub\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\t\t\t\t       El \xFAnico bar gay \"oficial\" de Jerusal\xE9n alberga algunas de las fiestas m\xE1s locas de la ciudad.\n\t\t\t\t    </p>\n\n\t\t\t\t    <p>\n\t\t\t\t       \xA1Jerusal\xE9n es el mejor destino de vacaciones! Con tanto que ver y hacer, tanto para estimular sus sentidos y despertar su curiosidad, su viaje a Jerusal\xE9n promete ser una experiencia inolvidable. \xA1Reserve sus vacaciones ahora!\n\t\t\t\t    </p>\n\n\t\t\t\t    <div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/4/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>Taquilla:</h3>\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Eventos anuales\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Jerusal\xE9n es la sede de una serie de eventos anuales \xFAnicos. Consulte en Internet las fechas y m\xE1s informaci\xF3n.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/4/5.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\n         "};}},{id:"Outdoor_Adventures",bgImage:"/posts/bank/40/1.jpg",mobBgImage:"/posts/bank/40/M.jpg",title:"Outdoor Adventures",ctg:"telaviv",// vidId : '88OV6xU0vPI',
vidId:"Iyziun92P5A",isVid:true,smltitle:"",html:function html(){return{__html:"\n                <h3>An action-packed city that\u2019s perfect for active people</h3>\n\t\t\t<p>\n\t\t\t\tPeople in Tel Aviv live life to the fullest \u2013 and they do it outside. This city is chock-full with outdoor activities, and you can pick and choose your favorites. It\u2019s an action packed city \u2013 perfect for active people.\n\t\t\t</p>\n\t\t\t<h3>\n\t\t\t\tHayarkon Park\n\t\t\t</h3>\n\t\t\t<p>\n\t\t\t\tKnown as the \u201CCentral Park\u201D of Tel Aviv, Hayarkon Park is visited by approximately sixteen million people annually. Attractions range from picnics on the huge lawns, pedal boating on its beautiful manmade lake to cycle tracks and tours of the many amazing gardens, portraying nature at the heart of the city.\n\t\t\t</p>\n\t\t\t<h3>\n\t\t\t\tThe Cycling Scene\n\t\t\t</h3>\n\t\t\t<p>\n\t\t\t\tOne of the ultimate ways to discover Tel Aviv is via its 100km of dedicated bike lanes, where you can enjoy the Tel-O-Fun public bike hire system that lets residents and visitors pick up and drop off sleek green bicycles in 150 stations citywide. If you enjoy spending your time on wheels, you should also check out the many dedicated skating parks, where you can watch the local daredevils do their thing, or get your own skateboard or rollerblades and join the action.\n\t\t\t</p>\n\n         "};}},{id:"TelAviv_On_Wheels",ctg:"telaviv",bgImage:"/posts/bank/40/1.jpg",mobBgImage:"/posts/bank/40/M.jpg",isVid:true,// vidId: "88OV6xU0vPI",
vidId:"Iyziun92P5A",title:"Tel Aviv sobre ruedas",smltitle:"",html:function html(){return{__html:"\n\n            <br/>\n            <p>Dese una vuelta por la ciudad que no se detiene Vaya sobre ruedas all\xE1 d\xF3nde \xE9stas le lleven en esta fabulosa ciudad</p>\n\n            <div class=\"img-wrapper\">\n              <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/55/1.jpg")+" class=\"img-responsive\" />\n            </div>\n           \n          \n\n        "};}},{id:"Port_Pleasures",bgImage:"/posts/bank/23/1.jpg",mobBgImage:"/posts/bank/23/M.jpg",ctg:"telaviv",isVid:true,// vidId : "uC5KX4MVpC0",
vidId:"tgF0zMUYY2g",title:"Placeres Portuarios",smltitle:"",html:function html(){return{__html:"\n\n        \t\t\t<br/>\n                    <h3>Puertos de Tel Aviv y Jaffa \u2013 diferentes y fabulosos</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tEl puerto de Jaffa ofrece una historia antigua, edificios de piedra y callejuelas empedradas, mientras que el puerto de Tel Aviv es un foco de cultura contempor\xE1nea y esparcimiento.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Puerto de Jaffa\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tLa moderna ciudad de Tel Aviv tuvo su humilde principio en el puerto de Jaffa, donde inmigrantes, ej\xE9rcitos y mercaderes atracaban sus barcos. El puerto es famoso como uno de los m\xE1s antiguos del mundo y hoy en d\xEDa a\xFAn es utilizado por los pescadores locales, mientras que el \xE1rea hist\xF3rica circundante se convirti\xF3 en un destino tur\xEDstico popular.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/3/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t<div class=\"cradit\">\n\t\t\t\t\t\t\t\t<small>Dana Friedlander</small>\n\t\t\t\t\t    </div>\n\t\t\t\t\t</div>\n\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Los dep\xF3sitos portuarios junto a la orilla del mar se convirtieron en galer\xEDas y en espacios culturales. Como el centro Nalagahat, dirigido por la comunidad de sordos y ciegos en la galer\xEDa Dvir. Desde las d\xE1rsenas, las callejuelas empedradas siguen su curso hacia arriba a trav\xE9s de edificios recubiertos de piedra que recuerdan la ciudad vieja de Jerusal\xE9n. Entre los edificios hist\xF3ricos hay galer\xEDas, negocios especializados y excelentes restaurantes. Al llegar al nivel superior del antiguo puerto se puede ver la iglesia de San Pedro, el Puente de los Deseos, el Museo de la Antigua Jaffa y el Museo Ilana Goor.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/3/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t\t Puerto de Tel Aviv\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tEn contraste con el puerto de Jaffa, el ambiente en el puerto de Tel Aviv es m\xE1s comercial y contempor\xE1neo. El puerto actu\xF3 como tal entre los a\xF1os 1938 y 1965 sufriendo renovaciones y restauraciones a fin de convertirlo en un distrito de compras y ocio. El puerto consiste en hangares reconvertidos y un largo y amplio paseo que corre al lado de las d\xE1rsenas. Las familias suelen visitar el Centro Dyada, muy popular por sus actividades para ni\xF1os, o  visitan el Centro de Yoga, el Centro de la Mujer, la Sede de Congresos o el Instituto Cavim de Dise\xF1o y Arquitectura. El paseo est\xE1 siempre animado con artistas callejeros, eventos musicales y mercados al aire libre. Es un \xE1rea moderna y din\xE1mica para la expresi\xF3n cultural y la creatividad. Cuando cae el sol, el puerto de Tel Aviv se convierte en una popular zona nocturna con bares y clubes.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/3/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t<div class=\"cradit\">\n\t\t\t\t\t\t\t\t<small>Dana Friedlander</small>\n\t\t\t\t\t    </div>\n\t\t\t\t\t</div>\n\n         "};}},{id:"Dead_Sea_Video",bgImage:"/posts/bank/natures-glory/1.jpg",mobBgImage:"/posts/bank/natures-glory/M.jpg",title:"El Mar Muerto",ctg:"deadsea2",isVid:true,vidId:"3hxeenS25M0",smlTitle:"",html:function html(){return{__html:"\n                      <p>Si\xE9ntase en lo m\xE1s alto en el lugar m\xE1s bajo de la tierra.</p>\n                   \n         \t"};}},{id:"Dead_Sea2",bgImage:"/posts/videos/deadsea/1/1.jpg",mobBgImage:"/posts/videos/deadsea/1/M.jpg",title:"El Mar Muerto",// vidId: "ixFocykfYHo",
vidId:"3hxeenS25M0",ctg:"deadsea",isVid:true,smlTitle:"",html:function html(){return{__html:"\n\t\t\t<h3>Si\xE9ntase en lo m\xE1s alto en el lugar m\xE1s bajo de la tierra</h3>\n\t\t\t<p>\n\t\t\t\t\t Una maravilla geol\xF3gica en un entorno \xFAnico y sereno, el Mar Muerto es una atracci\xF3n tur\xEDstica sumamente popular. Experimente la calma tranquilidad del agua con sus distintas propiedades curativas mientras disfruta de la incomparable belleza del paisaje circundante. <strong>El Mar Muerto, tambi\xE9n conocido como el spa natural m\xE1s antiguo del mundo, ha sido bendecido con una concentraci\xF3n extremadamente alta de sal del 31.5%, permitiendo a los turistas de todas partes la incre\xEDble experiencia de flotar sin esfuerzo en las aguas del lugar m\xE1s bajo de la Tierra. Mientras est\xE9 aqu\xED, puede embadurnarse</strong> en el saludable barro negro de la zona o explorar los fascinantes e hist\xF3ricamente ricos paisajes cercanos.\n             </p>\n           <p>\n\t\t\t\t\t Hoteles de lujo, cocina variada, desde restaurantes gourmet hasta restaurantes de comida r\xE1pida, grandes tiendas de souvenirs, la extraordinaria historia de la cercana Masada y muchas actividades culturales durante todo el a\xF1o, hacen del Mar Muerto un destino popular para turistas locales y visitantes internacionales.\n            </p>\n\t\t\t"};}},{id:3,bgImage:"/posts/bank/23/1.jpg",mobBgImage:"/posts/bank/23/M.jpg",vidId:"LLOUxE-K_9Y",player_id_post:"3",title:"Port Pleasures",isVid:true,ctg:"telaviv",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<h3>The different charms of Tel Aviv and Jaffa Ports</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tJaffa Port offers an ancient history, stone buildings and cobbled lanes while Tel Aviv Port is a contemporary cultural, recreational and commercial hub.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t    Jaffa Port\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe modern city of Tel Aviv had its humble beginnings in the port of Jaffa where immigrants, armies and traders docked their ships. The port is famed as one of the oldest in the world and today it is still used by local fishermen while the historic surrounding area has become a popular tourist destination.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/3/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t<div class=\"cradit\">\n\t\t\t\t\t\t\t\t<small>Dana Friedlander</small>\n\t\t\t\t\t    </div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe waterside hangers have been converted into galleries and cultural spaces like the Nalaga\u2019at Center operated by the deaf and blind community and the Dvir Gallery. From the waterfront the ancient cobbled alleyways wend their way up through stone buildings reminiscent of old Jerusalem. In among the historic buildings are galleries, specialty stores and excellent restaurants. As you reach the upper levels of the Old Port area you can see St. Peter\u2019s Church, the Wishing Bridge, the Old Jaffa Museum and the Ilana Goor Museum.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/3/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tTel Aviv Port\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tIn contrast to Jaffa Port Tel Aviv has a more commercial and contemporary feel. The port operated from 1938 to 1965 and has undergone renewal and restoration to convert it into a shopping and entertainment district. The port area consists of converted hangers and a long wide waterfront promenade. It is popular with families visiting the Dyada Center for children\u2019s activities and others visiting the yoga center, center for women, conference venue and the Cavim Institute of Design and Architecture. The promenade is always alive with street performers, musical events and outdoor markets. The port is a contemporary and dynamic area for creative and cultural expression. When the sun goes down the Tel Aviv Port becomes a popular nightlife destination with bars and clubs.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/3/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t<div class=\"cradit\">\n\t\t\t\t\t\t\t\t<small>Dana Friedlander</small>\n\t\t\t\t\t    </div>\n\t\t\t\t\t</div>\n\n\n         "};}},{id:"TelAviv_By_The_Sea",bgImage:"posts/bank/17/1.jpg",mobBgImage:"posts/bank/17/M.jpg",title:"TEL AVIV JUNTO AL MAR",vidId:"EJAqEcK4Te0",isVid:true,ctg:"telaviv",smlTitle:"",html:function html(){return{__html:"\n\t\t\t\n\n\t\t\t<br/>\n\t\t\t<p>Porque una playa en Tel Aviv es vida, prep\xE1rese para la diversi\xF3n bajo el sol</p>\n\t\t\t<p>Aclamada como \"la capital m\xE1s cool del Mediterr\xE1neo \" por el New York Times y entre las \"10 mejores ciudades llenas de acci\xF3n\" por Lonely Planet, Tel Aviv es sin lugar a dudas el lugar para visitar en el Mediterr\xE1neo.</h3>\n\t\t\t<p>Nombrada por el <em>New York Times</em> \"La capital m\xE1s cool del Mediterr\xE1neo, <strong>Tel Aviv</strong> es &nbsp;cosmopolita, moderna y vibrante. Animada escena de arte, la UNESCO reconoci\xF3 la arquitectura Bauhaus, galardonada cocina, vida nocturna a nivel mundial, ambiente relajado y hermosas playas, todo convierte a la ciudad en uno de los destinos tur\xEDsticos m\xE1s importantes del mundo.</p>\n\t\t\t<p>Pero incluso en la ciudad que lo tiene todo, s\xF3lo hay un lugar para empezar&nbsp;<strong>la playa</strong>.</p>\n\t\t\t<h3>Descubra el coraz\xF3n de una ciudad chispeante</h3>\n\t\t\t<p><strong>Qu\xE9</strong>. El coraz\xF3n de la reconocida ciudad por <em>National Geographic</em> &nbsp;como la \"Miami Beach del Mediterr\xE1neo\" e incluida en su lista de las 10 mejores ciudades de playa del mundo, es su costa.</p>\n\t\t\t<p><strong>Por qu\xE9</strong>. Playas de arena, aguas c\xE1lidas, un mont\xF3n de deportes acu\xE1ticos y buen clima, \xBFnecesitamos decir m\xE1s? La costa de Tel Aviv est\xE1 compuesta por 13 playas que ofrecen experiencias distintas. De la ajetreada y moderna a la relajada y tranquila, juntas forman un tapiz rico y colorido de esta ciudad emocionante y diversa.</p>\n\t\t\t<p><strong>D\xF3nde</strong>. Situada en el extremo oeste de la ciudad, en Tel Aviv siempre est\xE1 a un paso de la playa. No hay necesidad de resistir la tentaci\xF3n. S\xF3lo cruce la calle, qu\xEDtese los zapatos y empiece a divertirse.</p>\n\t\t\t<h3>Elija su propia aventura en la playa</h3>\n\t\t\t<p><strong>Si\xE9ntase activo</strong>. Playa y deportes acu\xE1ticos son muy populares en Tel Aviv. Surf, vela, remo, nataci\xF3n, paddle surf, buceo, voleibol... la lista de posibilidades sigue y sigue.</p>\n\t\t\t<p><strong>Elija su actividad favorita y disfrute</strong>. Entonces, cuando escuche el \u201Ctoc-toc\u201D de las matkot (palas) en la playa, \xFAnase a este juego enormemente popular. No hay ganadores o perdedores aqu\xED, pero sigue siendo divertido ... y muy adictivo.</p>\n\t\t\t<p>Inscr\xEDbase al torneo de vela SAIL TLV que tiene lugar en la primavera e incluye yates de vela, yates de motor y barcos de motor de todo el mundo. Disfrute de las actividades deportivas y su maravillosa comunidad.</p>\n\t\t\t<p>\xBFQuiere m\xE1s? \xDAnase a los lugare\xF1os y monte en bicicleta, camine o corra por paseo mar\xEDtimo.</p>\n\t\t\t<p><strong>Social\xEDce.</strong> Construya castillos de arena con su familia, lleve a su perro a caminar y m\xE9zclese con la diversa multitud amigable.</p>\n\t\t\t<p><strong>Rel\xE1jese.</strong> \xBFQuiere frenar y relajarse? \xA1No hay problema! Encuentre un lugar tranquilo en una de las playas menos concurridas, vea (o \xFAnase) a los c\xEDrculos de tambor y si\xE9ntese en uno de los restaurantes a lo largo de la costa. Por la tarde, ac\xE9rquese al agua, tome una silla, si\xE9ntese y vea uno de los hermosos atardeceres de Tel Aviv. No hay nada mejor que eso.</p>\n\n\t\t\t"};}},{id:"Sarona_TelAviv",bgImage:"posts/bank/36/1.jpg",mobBgImage:"posts/bank/36/M.jpg",title:"Sarona Tel Aviv",isVid:true,ctg:"telaviv",// vidId: "AcjsyamDZL8",
// vidId: "VubRqT0Z9CM",
vidId:"MJ-gsGs1tqA",smlTitle:"",html:function html(){return{__html:"\n\t\t\t             <!--<h3>At Tel Aviv\u2019s Sarona Market, the culinary options are endless</h3>\n\n\t\t\t\t\t\t<p>Built in and around 150-year-old Templer structures in the heart of Tel Aviv is Israel\u2019s culinary melting pot: Sarona Market. Reflecting Tel Aviv\u2019s exemplary culinary atmosphere and placing a modern urban twist on the city\u2019s more traditional marketplaces, Sarona is the place to visit to satisfy your every craving - and get a taste for the diverse ethnic inspirations that drive the bustling sea-side city. </p>\n\n\n\n\t\t\t\t\t\t<h3>Visit Israel\u2019s largest covered culinary marketplace</h3>\n\n\t\t\t\t\t\t<p>From gourmet creations to spins on traditional local dishes, Sarona Market has it all and will satisfy every quaking belly. With over 90 restaurants, food stands, pubs and culinary boutiques operating seven days of the week, all you need to do is decide whether you\u2019d rather tuck into a bowl of succulent ramen, a plate of spicy empanadas, a tangy sub sandwich or a sweet baked confection. Can\u2019t decide? The eateries are all adjacent to one another, making a seafood entree followed by spicy pad thai or a juicy burger an easy feat. </p>\n\n\t\t\t\t\t\t<p>Need to take a break between courses? Sarona Market is also home to accessory shops, museums, a visitor\u2019s center and other fun, must-see attractions.  </p>\n\n\t\t\t\t\t\t<h3>Go Green</h3>\n\n\t\t\t\t\t\t<p>TGIF! Fridays at Sarona are exceptionally enthralling, with farm-fresh produce available for purchase, making the culinary experience that much more interactive and engaging. Once you\u2019ve selected your produce, continue on your urban market adventure, adding savory imported cheeses, top-quality Italian balsamic vinegar, boutique beers and sweet confections to your shopping bag, all tasty additions to a weekend home-cooked meal. </p>\n\n\t\t\t\t\t\t<p>Experience modern Israeli cuisine in full force at Sarona Market. With no end to the available culinary options reflecting the popular and unique foodie atmosphere of Tel Aviv, Sarona Market is a must-visit hotspot that will certainly satisfy every imaginable gustatory craving.</p>\n                        -->\n\n                        <br/>\n                        <p>Una gran selecci\xF3n de atracciones en una impresionante colonia Templaria renovada</p>\n                        <h3>En el mercado de Sarona de Tel Aviv, las opciones culinarias son infinitas</h3>\n\t\t\t\t\t\t<p>Construido sobre y alrededor de estructuras templarias &nbsp;de 150 a\xF1os, en el coraz\xF3n de Tel Aviv, es el crisol culinario de Israel. El mercado de Sarona refleja la atm\xF3sfera culinaria ejemplar de Tel Aviv, dando un giro urbano moderno a los mercados m\xE1s tradicionales de la ciudad. Sarona es el lugar para visitar, satisfacer antojos y saborear las diversas propuestas \xE9tnicas.</p>\n\t\t\t\t\t\t<h3>Visite el mercado culinario cubierto m\xE1s grande de Israel</h3>\n\t\t\t\t\t\t<p>Desde creaciones gourmet a platos tradicionales locales, el mercado de Sarona tiene todo y satisfar\xE1 cualquier estomago. Con m\xE1s de 90 restaurantes, puestos de comida, pubs y boutiques culinarias que operan los siete d\xEDas de la semana, todo lo que necesita hacer es decidir si prefiere un plato de suculento ramen, un plato de empanadas picantes, un s\xE1ndwich o dulces horneados. \xBFNo puede decidir? Los restaurantes est\xE1n uno al lado del otro, as\xED que puede empezar con un plato de marisco<s>s</s> de entrada, seguido de un plato picante tailand\xE9s o una jugosa hamburguesa.</p>\n\t\t\t\t\t\t<p>\xBFNecesita tomar un descanso entre los platos? El mercado de Sarona es tambi\xE9n hogar de tiendas de accesorios, museos, centro de visitantes y otras atracciones divertidas de visita obligada.</p>\n\t\t\t\t\t\t<h3>Vu\xE9lvase ecol\xF3gico</h3>\n\t\t\t\t\t\t<p>&nbsp;Los viernes en Sarona son excepcionalmente apasionantes, con productos frescos de granja disponibles para su compra, convirtiendo la experiencia culinaria mucho m\xE1s interactiva y atractiva. Una vez que haya seleccionado su producto, contin\xFAe con su aventura en el mercado urbano, a\xF1adiendo sabrosos quesos importados, vinagre bals\xE1mico italiano de alta calidad, cervezas boutique y dulces a su bolsa de la compra, y estar\xE1 listo para preparar una suculenta comida casera el fin de semana.</p>\n\t\t\t\t\t\t<p>Experimente la cocina israel\xED moderna en pleno apogeo en el mercado de Sarona. Sin limitar las opciones culinarias disponibles que reflejan la atm\xF3sfera gastron\xF3mica popular y \xFAnica de Tel Aviv, el mercado de Sarona es un lugar de visita obligada que sin duda satisface todos los antojos imaginables.</p>\n\n\t\t\t"};}},{id:"Neve_Tzedek",bgImage:"posts/bank/4/1.jpg",mobBgImage:"posts/bank/4/M.jpg",title:"Neve Tzedek",// vidId: "bHQwLO6cefs",
// vidId: "eRNnLm6R0LI",
vidId:"5jl13Z-38eE",smlTitle:"",isVid:true,ctg:"telaviv",html:function html(){return{__html:"\n                        <br/>\n\n                      \t<h3>Un oasis art\xEDstico en el coraz\xF3n de Tel Aviv</h3>\n                      \t<h3>Disfrute del ambiente m\xE1gico en las terrazas de los restaurantes y caf\xE9s de Neve Tzedek</h3>\n\t\t\t\t\t\t<p>Ubicado dentro de uno de los distritos m\xE1s antiguos de Tel Aviv, se encuentra una joya arquitect\xF3nica con un coraz\xF3n joven que no deja de latir. Establecido en 1887, Neve Tzedek, el primer barrio jud\xEDo fuera de la antigua ciudad portuaria de Jaffa, se ha convertido recientemente en un centro de moda para artistas de todas las disciplinas, que encajan perfectamente con la restaurada y pintoresca arquitectura oriental del distrito.</p>\n\t\t\t\t\t\t<h3>Un verdadero oasis en el animado Tel Aviv</h3>\n\t\t\t\t\t\t<p>Ya sea si est\xE1 buscando un plato de cer\xE1mica artesanal, un art\xEDculo \xFAnico de ropa, o joyas hechas con t\xE9cnicas tradicionales de soldadura, las innumerables boutiques, galer\xEDas, talleres de dise\xF1o y tiendas de moda en los edificios de estilo oriental alineadas en la calle Shabazi proporcionan una experiencia de compra \xFAnica y personal. Y con la fresca brisa marina refresc\xE1ndole mientras se pasea por el vecindario, empezar\xE1 a sentirse vivo y alegre, al igual que el esp\xEDritu caprichoso del barrio.</p>\n\t\t\t\t\t\t<p>Disfrute del ambiente acogedor en las terrazas de los restaurantes y caf\xE9s de Neve Tzedek con una comida ligera y deliciosa. Los numerosos restaurantes, ubicados en pintorescas e hist\xF3ricas estructuras construidas alrededor de las estrechas callejuelas del barrio, son vedaderas experiencias culinarias. Las suculentas comidas, en combinaci\xF3n con el aire sereno al caminar por por las calles, le transportar\xE1n a una realidad bohemia.</p>\n\t\t\t\t\t\t<h3>Donde la creatividad no conoce l\xEDmites</h3>\n\t\t\t\t\t\t<p>La visita a Neve Tzedek no estar\xEDa completa sin rendir homenaje al mejor creador de Tel Aviv en el Museo de Arte de Nachum Gutman, donde exposiciones permanentes y actividades interactivas realzan el ambiente art\xEDstico ejemplificado en el vecindario sereno, transport\xE1ndolo a otras galer\xEDas locales y estudios de cer\xE1mica.</p>\n\t\t\t\t\t\t<p>Visite el Centro Suzanne Dellal de Danza y Teatro de Tel Aviv, donde podr\xE1 presenciar una de las muchas actuaciones y festivales que el centro cultural celebra incluyendo las actuaciones de danza de m\xFAsica \xE9tnica, que fomentan una verdadera conexi\xF3n entre las artes esc\xE9nicas israel\xEDes y las exposiciones internacionales.</p>\n\t\t\t\t\t\t<p>Siga por la calle Shabazi hasta llegar a su cima y vea c\xF3mo la creatividad del barrio sigue fluyendo, desembocando en HaTachana, la antigua estaci\xF3n de trenes de Jaffa, recientemente transformada en otro lugar boutique, donde las tiendas y caf\xE9s emergen de un entorno sorprendentemente hist\xF3rico.</p>\n\t\t\t\t\t\t \t \n              \n\t\t\t"};}},{id:9,bgImage:"posts/bank/5/1.jpg",mobBgImage:"posts/bank/5/M.jpg",title:"Jerusalem Old and new ",isVid:true,ctg:"jerusalem",vidId:"MXtcTm_JXus",smlTitle:"",html:function html(){return{__html:"\n\t\t\t<h3>Ancient treasures and modern luxuries.</h3>\n\n\t\t\t<p>\n\t\t\t\tDowntown Jerusalem is the heart of the modern metropolis, bursting with nightlife, dining and cultural options to rival any major city in the world.\n\t\t\t</p>\n\t\t\t<p>\n\t\t\t\tThe area is made up of several neighborhoods and appealing locations such as charming Nachlat Shiva, the bustling Yafo Street and Ben Yehuda Street, with its own unique personality and atmosphere not to be missed.\n\t\t\t</p>\n\t\t\t<p>\n\t\t\t\tThe center of Jerusalem includes some of the city\u2019s most charming neighborhoods and fascinating attractions. For an unbeatable cultural experience, check out Jerusalem\u2019s variety of fascinating museums, including the world class Israel Museum, the Bible Lands Museum and Jerusalem\u2019s Science Museum.\n\t\t\t</p>\n\t\t\t<h3>\n\t\t\t\tMachane Yehuda Market\n\t\t\t</h3>\n\t\t\t<p>\n\t\t\t\tDiscover this market's unrivaled atmosphere and variety which draw thousands of tourists every day. Once the shopping is done and the food vendors close up, join the young trendy crowds, foreign and locals alike, who descend on the market to drink and party until the small hours, in the bars, restaurants and alleyways.\n\t\t\t</p>\n\t\t\t<h3>\n\t\t\t\tNahalat Shiv\u2019a\n\t\t\t</h3>\n\t\t\t<p>\n\t\t\t\tThis charming cobblestone neighborhood at the heart of the city offers an excellent selection of shops, restaurants, bars and outdoor caf\xE9s. Nahalat Shiva is home to Kikar Hamusica (Music Square) \u2013 a lively and trendy outdoor space that offers live music every day throughout the week.\n\t\t\t</p>\n\t\t\t<h3>\n\t\t\t\tYemin Moshe\n\t\t\t</h3>\n\t\t\t<p>\n\t\t\t\tThis lovely neighborhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. Home to artists, writers and academics, Yemin Moshe is known for its beautiful windmill and oriental style houses, green parks, lively music center and stunning views.\n\t\t\t</p>\n\t\t\t<h3>\n\t\t\t\tEin Kerem\n\t\t\t</h3>\n\t\t\t<p>\n\t\t\t\tNestled in a peaceful valley between the mountains and the terraced hills southwest of Jerusalem, Ein Kerem is one of Jerusalem\u2019s most picturesque neighborhoods. With its winding paved lanes, their charming stone houses adorned with arches, churches whose bells chime in the clear air, Ein Kerem radiates charm and beauty like an island in a sea of green forest\n\t\t\t</p>  \n\n\t\t\t"};}},{id:"Market_Madness",bgImage:"posts/bank/10/1.jpg",mobBgImage:"posts/bank/10/M.jpg",title:"MERCADO DE MAHANE YEHUDA",// vidId: "1Yx2Uht4rms",
vidId:"oy9ozIvV7Co",isVid:true,ctg:"culinary",smlTitle:"",html:function html(){return{__html:"\n                     <h3>No querr\xE1 perderse las vistas, los sonidos, los olores y, por supuesto, los sabores de este mercado</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tMiles de habitantes locales y turistas llegan durante el d\xEDa para presenciar el ambiente aut\xE9ntico y los entresijos del mercado, y por supuesto hacer algunas compras, y una vez que los vendedores de comida cierran, los fiesteros, tanto extranjeros como locales, bajan al mercado para beber en los bares, restaurantes y callejones.\n                       En realidad, el zoco jam\xE1s se toma un d\xEDa libre durante la semana, pero si est\xE1s buscando una noche verdaderamente electrizante, el jueves debe estar en tu punto de mira. Para los habitantes locales, es la \xFAnica noche que se puede salir sin tener que preocuparse por levantarse para el trabajo al d\xEDa siguiente, y se nota, ya que los bares y restaurantes permanecen abiertos hasta tarde, organizan fiestas que se esparcen por las calles y ofrecen eventos especiales.\n\t\t\t\t\t    <br>Mi \"cita\" y yo llegamos a las 19:20, cuando muchos de los vendedores todav\xEDa estaban abiertos, y los pasillos estaban llenos de compradores que buscaban gangas de fin de semana. Sin embargo, tan pronto los vendedores cerraron, los compradores se disiparon r\xE1pidamente, dejando espacio para la gente de fiesta.\n\t\t\t\t\t    <br>Aunque parece que fue ayer cuando el zoco era solo un lugar donde comprar y tal vez tomarse algo en un modesto restaurante local, en los \xFAltimos 5 a\xF1os m\xE1s o menos, el n\xFAmero de bares y restaurantes de moda se ha disparado hasta el punto de que no se puede hacer un seguimiento de todo, entre los nuevos que aparecen todos los d\xEDas y los lugares secretos escondidos en las esquinas que solo conocen los habitantes locales.\n                        \"Cuando ves las multitudes de gente de fiesta en el zoco un jueves por la noche, es f\xE1cil olvidar que hace tan solo unos pocos a\xF1os no habr\xEDas encontrado ni un alma aqu\xED a esas horas\", dice el gu\xEDa tur\xEDstico local Joel Haber. \"Pero la verdad es que este no es solo el siguiente paso l\xF3gico en el constante desarrollo hist\xF3rico de Mahane Yehuda, sino tambi\xE9n la nueva contribuci\xF3n m\xE1s vibrante a la escena nocturna de la ciudad. El zoco siempre ha sido la encrucijada donde se mezclan todos los habitantes de Jerusal\xE9n. Ahora los j\xF3venes y los que lo son menos, seculares y religiosos, se sientan todos juntos bebiendo cervezas y empap\xE1ndose del car\xE1cter especial del zoco \".\n\t\t\t\t\t    <br> Eche un vistazo a algunos de los establecimientos que han alcanzado m\xE1s o menos el estatus de estelares y que siempre prometen un buen momento.\n\t\t\t\t\t </p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   VINO, CENA y BAILE\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"posts/7/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   CASINO DE PARIS\n\t\t\t\t\t</h3>\n\n                    <p>\n\n                          Escondido en las profundidades del zoco georgiano entre las calles cubiertas y descubiertas del mercado,&nbsp;<a href = \"http://www.itraveljerusalem.com/city/jerusalem/casino-de-paris/\" target = \"_ blank\" > <strong>el Casino de Paris</strong> </a> &nbsp; tiene una colorida historia. El edificio en el que est\xE1 alojado ha sido utilizado como casino, hotel, club de oficiales brit\xE1nicos y burdel a lo largo de los a\xF1os, pero ahora es uno de los lugares con m\xE1s clase en el zoco. El p\xFAblico es algo m\xE1s mayor, atrayendo principalmente a profesionales de entre 30 y 40 a\xF1os, pero los jueves por la noche todav\xEDa tienen un aire de diversi\xF3n y juventud, mientras el bar permanece abierto hasta las 2 o 3 de la ma\xF1ana y sirve originales c\xF3cteles bien elaborados inspirados en el zoco, cervezas artesanales, buenos vinos y un ecl\xE9ctico men\xFA tambi\xE9n inspirado en los ingredientes y la cultura del zoco.\n\n                    </p>\n\n                    <h3>\n\t\t\t\t\t   CINCO DE MAYO\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Si est\xE1 buscando un ambiente de fiesta aut\xE9ntico, Cinco De Mayo no es un mal lugar para comenzar. El bar con frecuencia presenta DJ pinchando una variedad de estilos diferentes y encontrar\xE1s personas bebiendo, comiendo y tal vez incluso bailando hasta alrededor de las 02:00 los jueves por la noche. Los fiesteros realmente comienzan a abarrotar el lugar alrededor de las 22:30 as\xED que no se sorprendan si tienen problemas para encontrar un asiento m\xE1s tarde de esa hora, pero siempre pueden hacer como los habitantes locales: coger una bebida de dentro y pasar el rato en el callej\xF3n.\n                         A pesar del nombre, el Cinco de Mayo en realidad no tiene nada que ver con M\xE9xico o el 5 de mayo. El grupo de amigos que fundaron el bar tomaron el nombre de cuando estuvieron viviendo en una comuna en las afueras de Jerusal\xE9n, en la que nadie trabajaba el 5 de mayo.\n\t\t\t\t\t</p>\n\n                    <h3>\n\t\t\t\t\t  BAR SHUKA\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n                       A pesar de su ubicaci\xF3n fuera de la avenida principal y de un tama\xF1o relativamente peque\xF1o, el bar Shuka en la calle Egoz es uno de los lugares m\xE1s populares del zoco. Es un sitio de tipo carne con patatas que solo sirve cervezas israel\xEDes, licores selectos y peque\xF1os tentempi\xE9s, pero los jueves por la noche tiende a pasar de barecillo escondido a gran fiesta.\n                    </p>\n\n                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"posts/7/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t    QUE PASA\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Mientras tanto justo al lado, el Que Pasa es el valiente esfuerzo del propietario Yaniv Kovenshtein de recrear la cultura de las tapas que tanto amaba en Espa\xF1a.\n                        El copropietario y chef Avi Betito Golansky le da vida a la visi\xF3n con un men\xFA lleno de platos tama\xF1o tapa, incluyendo la sabrosa Bruschetta Cuca (sardinas, cebolla, aceite de oliva picante sobre delicioso pan crujiente) y Porcini Bruschetta (porcini salteados en mantequilla con ajo, aceite de almendras y perejil), alcachofas con trufas, sardinas fileteadas rellenas con queso Saint Moor y fritas con mantequilla de salvia encima de una exuberante ensalada de tomate, anillos de m\xFAjol fritos con pimientos asados, y m\xE1s. Si tienes apetito, tambi\xE9n tienen porciones m\xE1s grandes, como gnocchi, filete de lubina o salmonete.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Si bien el lema del bar es \"una cerveza por la tarde resuelve todos los problemas\", tambi\xE9n vale la pena ir un jueves por la noche al Que Pasa, sede de m\xFAsicos locales con regularidad.\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t    SHEM TOV\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Situado en la Calle Eshkol, una calle cerca del zoco abierto, Shem Tov realmente captura la atm\xF3sfera del zoco con un rico men\xFA de Oriente Medio, una selecci\xF3n bastante amplia de cerveza israel\xED, vino y licor y el golpe de gracia, m\xFAsica de todo el mundo que mantiene el alegre ambiente hasta las 2 o 3 de la ma\xF1ana. <br> Tambi\xE9n es un lugar excelente para tomar un vaso de sahleb fr\xEDo y un alimento b\xE1sico del zoco que por lo general se sirve caliente, hecho con harina de los tub\xE9rculos molidos de las orqu\xEDdeas con agua de rosas, leche y canela. Mmmmmm. \xA1Delicioso!\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t    BOCADOS DE \xDALTIMA HORA\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Si ha salido y ha estado bebiendo, probablemente tenga ganas de comer algo alrededor de la medianoche y, por suerte, todav\xEDa hay muchos restaurantes que satisfar\xE1n sus, probablemente, no tan espec\xEDficas necesidades.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"posts/7/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t    SORAMELO\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Si todo lo que ha bebido le ha provocado ganas de dulce, dir\xEDjase a Soramelo, en la entrada de Aggripas del zoco cubierto, para tomar unos gofres inspirados en el zoco.\n                         Llamado as\xED por una leyenda del vecindario conocida por tener una historia sobre todas las cosas, Soramelo sin duda ha dado lugar a algunas historias propias.<br>Soramelo se mantiene constantemente ocupado a lo largo de la noche con gente que se detiene para tomar una cerveza artesanal, un caf\xE9 o un bocado dulce, pero realmente se llena m\xE1s tarde, cuando las personas pasan de beber a los tentempi\xE9s nocturnos. Si usted es uno de ellos, tiene hasta las 3 de la ma\xF1ana del jueves para conseguir un gofre que absorba toda la cerveza y el arak. Pruebe el que tiene chocolate y tahina, \xA1no le decepcionar\xE1!\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t    MICHI\u2019S\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Michi's es un concepto simple pero delicioso que lo convierte en el restaurante perfecto para la noche: hamburguesas de alta calidad y s\xE1ndwiches de carne a un precio sorprendentemente bueno. Puede obtener una simple hamburguesa de 100 gramos en un panecillo fresco con bastante guarnici\xF3n por solo 17 NIS. Si realmente tiene hambre, tambi\xE9n puede obtener porciones m\xE1s grandes de carne, rosbif, s\xE1ndwiches de pollo y mucho m\xE1s. Michi's est\xE1 abierto hasta las 12 de la noche.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t    MEORAV YERUSHALMI\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Este puede ser el mejor lugar para hacerse con la famosa parrillada mixta Jerusal\xE9n, que consiste en una pita rellena de carne y casquer\xEDa con patatas fritas y ensalada como guarnici\xF3n. Adem\xE1s de la receta tradicional, tambi\xE9n sirven una parrillada mixta con pescado. Las porciones se pueden calificar de gigantes y son perfectas para aquellos a los que realmente se les ha abierto el apetito. Solo aseg\xFArate de llegar aqu\xED antes de la medianoche.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t    PASTA BASTA\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Con mucho, uno de los lugares m\xE1s populares en el zoco. Pasta Basta es el lugar ideal para disfrutar de platos frescos y caseros de pasta que no le llevar\xE1n a la ruina. Todo lo que tiene que hacer es elegir un tipo de pasta y una salsa, y su comida estar\xE1 lista. Los precios var\xEDan seg\xFAn el tipo de salsa y van de los 19 a los 26 NIS. Los gnocchi, raviolis y aderezos adicionales cuestan un poco m\xE1s.\n\t\t\t\t\t    <br> Pasta Basta est\xE1 abierto hasta la medianoche, y no se sorprenda cuando vea que hay cola en la entrada.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>Al\xE9grese la vista y su est\xF3mago en el mercado abierto de Jerusal\xE9n</h3>\n\t\t\t\t\t<p>Considerado el mercado abierto m\xE1s moderno y vibrante de Israel, el Mahane Yehuda de Jerusal\xE9n es un vivero de productos frescos, encantadores comerciantes, restaurantes pintorescos y entretenimiento \xFAnico.<br>Es un mercado que contin\xFAa&nbsp;reinvent\xE1ndose,&nbsp;donde&nbsp;la tradici\xF3n milenaria choca y se entrelaza con nuevas modas. Los colores y los olores que emanan de las delicias alineadas en los numerosos puestos son absolutamente fascinantes.</p>\n\t\t\t\t\t<!--<div>\n\t\t\t\t\t<iframe allowfullscreen=\"\" frameborder=\"0\" height=\"315\" src=\"https://www.youtube.com/embed/fJ7bLOOstgA?enablejsapi=1&amp;origin=https%3A%2F%2Fes.citiesbreak.com\" width=\"560\" data-gtm-yt-inspected-11422925_7=\"true\" id=\"471374627\"></iframe>\n\t\t\t\t\t</div>-->\n\t\t\t\t\t<h3>Admire la cultura y la cocina en grado m\xE1ximo</h3>\n\t\t\t\t\t<p>Pasee por los callejones largos y estrechos del mercado y encontrar\xE1 una gran variedad de restaurantes, cafeter\xEDas, pubs, restaurantes vegetarianos y tiendas al por menor escondidos en todos los rincones posibles. Al cruzar sus umbrales experimentar\xE1 una calma en relaci\xF3n con el ajetreo y el bullicio de los comerciantes locales que venden sus panes reci\xE9n horneados, frutas y hortalizas frescas, ensaladas preparadas, postres, arom\xE1ticas especias molidas y prote\xEDnas crudas a consumidores hambrientos. S\xF3lo los olores son suficientes para hacer que su est\xF3mago ruja, transport\xE1ndolo a culturas y comunidades de todo el mundo. Cada taz\xF3n de fruta de temporada, falafel caliente en una pita o halva aderezada es un regalo de bienvenida para sus sentidos.</p>\n\t\t\t\t\t<h3>Donde los paseos a pie satisfacen su curiosidad y su apetito</h3>\n\t\t\t\t\t<p>\xDAnase a uno de los muchos talleres del mercado o excursiones de degustaci\xF3n, que proporcionan a los turistas una experiencia interactiva de Mahane Yehuda a trav\xE9s de delicias preparadas en algunos de los puestos del mercado. Escuche historias sobre el mercado y conozca las tiendas y puestos \xFAnicos y especiales que ayudaron a moldear Mahane Yehuda como el mercado abierto m\xE1s famoso de Israel. Y, cuando la noche cae, experimente c\xF3mo el mercado cambia de marcha, convirti\xE9ndose en un lugar de moda y animado para j\xF3venes locales y turistas.</p>\n\n              \n\t\t\t"};}},{id:13,bgImage:"posts/bank/24/1.jpg",mobBgImage:"posts/bank/24/M.jpg",title:"The old city ",vidId:"rkjLPq-Zsp8",smlTitle:"",html:function html(){return{__html:"\n\t\t\t<h3>Feel the story come alive</h3>\n\t\t\t<p>\n\t\t\t   Become inspired by the world renowned treasures of the ancient city of Jerusalem.\n\t\t\t</p>\n              \n\t\t\t"};}},{id:14,bgImage:"posts/bank/32/1.jpg",mobBgImage:"posts/bank/32/M.jpg",title:"The Dead Sea ",vidId:"DzEJxjnC_UQ",isVid:true,ctg:"deadsea",smlTitle:"",html:function html(){return{__html:"\n\t\t\t<h3>Time to bask in nature\u2019s glory</h3>\n\t\t\t<p>\n\t\t\t   Get high on life in the lowest place on earth.\n\t\t\t</p>\n              \n\t\t\t"};}},{id:3,bgImage:"posts/bank/58/1.jpg",mobBgImage:"posts/bank/58/M.jpg",title:"The Dead Sea ",vidId:"DzEJxjnC_UQ",isVid:true,ctg:"deadsea",smlTitle:"",html:function html(){return{__html:"\n\t\t\t<h3>Time to bask in nature\u2019s glory</h3>\n              <p>\n\t\t\t\t\t\tThe Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth\u2019s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water\u2019s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.\n              </p>\n              <p>\n              \t\tThis is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.\n              </p>\n              <p>\n              \t\tThe Dead Sea is lined with spas, bathing beaches and spa hotels.\n              </p>\n\t\t\t"};}},{id:"Go_To_Guide",bgImage:"/posts/bank/gotoguide/1.jpg",mobBgImage:"/posts/bank/gotoguide/M/1.jpg",title:"GUÍA",ctg:"telaviv",isVid:false,smltitle:"",html:function html(){return{__html:"\n                    <h3>\n                   \xA1A menos de una hora!\n                    </h3>\n\t\t\t\t\t <p>Una de las mejores cosas de visitar Jerusal\xE9n y Tel Aviv es lo incre\xEDblemente diferentes y a la vez lo asombrosamente cerca que est\xE1n estos dos fabulosos destinos. De hecho, las dos ciudades est\xE1n a menos de una hora en coche la una de la otra, de manera que, si lo desea, podr\xEDa pasar el d\xEDa explorando los impresionantes lugares mundialmente famosos de Jerusal\xE9n y regresar a tiempo para ver la puesta de sol desde una de las impresionantes playas de Tel Aviv, antes de pasar toda la noche de fiesta en uno de los mejores clubes de la ciudad. \xA1Eso s\xED que es diversi\xF3n 24 horas!\n                     \n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/gotoguide/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t <p>Moverse entre Jerusal\xE9n y Tel Aviv es sencillo y existen varias formas de hacerlo seg\xFAn sus preferencias y su presupuesto:</p>\n                     <p><strong>Coche:</strong> si opta por alquilar un coche, ver\xE1 que la carretera 1 conecta las dos ciudades directamente, y se dar\xE1 cuenta de que las se\xF1ales de tr\xE1fico son bastante claras y est\xE1n escritas en tres idiomas. Sin embargo, es posible que desee utilizar una de las aplicaciones de navegaci\xF3n locales para mostrarle el camino y ayudarle a evitar los atascos. </p>\n                    \n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/gotoguide/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t <p><strong>Bus:</strong> existen bastantes autobuses p\xFAblicos que viajan entre Tel Aviv y Jerusal\xE9n. Este es sin duda uno de los medios de transporte m\xE1s convenientes y econ\xF3micos. </p>\n                     <p><strong>Tren:</strong> un pr\xE1ctico servicio ferroviario opera en varias estaciones principales entre Tel Aviv y Jerusal\xE9n. Actualmente se est\xE1n llevando a cabo obras de construcci\xF3n y pronto comenzar\xE1 a operar una nueva ruta de alta velocidad directa entre las dos ciudades. </p> \n                     <p><strong>Taxi:</strong> los taxis para realizar viajes interurbanos se pueden parar en la calle o reservar por tel\xE9fono o por las aplicaciones designadas, como Gett (GetTaxi).</p>\n                     <p>Taxis Sherut:</strong> los taxis del servicio \u201CSherut\u201D son furgonetas de 10 o 12 sitios que generalmente siguen las principales rutas de autob\xFAs, dentro de las principales ciudades, y entre ellas. En cuanto al precio, las tarifas de los taxis Sherut son fijas, como las de los autobuses p\xFAblicos. Los taxis Sherut tambi\xE9n ofrecen un servicio de reemplazo para los autobuses los viernes.</p>\n                     <p>Para m\xE1s informaci\xF3n sobre los horarios, rutas y estaciones de tren, visite <a href=\"https://www.rail.co.il/\" target=\"_blank\">www.rail.co.il</a></p>\n                     <p>Para m\xE1s informaci\xF3n sobre los horarios y rutas de autob\xFAs, visite <a href=\"https://www.bus.co.il/otobusimmvc?\" target=\"_blank\">www.bus.co.il</a> </p>\n                     <p>L\xEDnea telef\xF3nica de asistencia de Transporte P\xFAblico <a href=\"tel:*8787\">*8787</a></p>\n                     <p>Aplicaci\xF3n local de transporte - \u2018Moovit\u2019</p>\n                     <p>\xA1Venga a visitar la \xE9pica Tel Aviv y la inolvidable Jerusal\xE9n, a menos de una hora de distancia entre ellas!  </p>\n\n\n            \t"};}},{id:"Day_IsTrippin",bgImage:"/posts/bank/48/1.jpg",mobBgImage:"/posts/bank/48/M/1.jpg",title:"EXCURSIONES DE DÍA",isVid:false,ctg:"telaviv",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t<h3>De puerto a puerto.</h3>\n\n\t\t\t\t<p>Comience su d\xEDa en el parque Jaffa Slope Park, con una magn\xEDfica panor\xE1mica sobre la mayor parte de la costa israel\xED, y punto de partida hist\xF3rico de la metr\xF3poli, hace unos 4000 a\xF1os. Pida una taza de caf\xE9 en el antiguo puerto restaurado y dir\xEDjase hacia el norte para un agradable recorrido a lo largo del paseo mar\xEDtimo y disfrutar de la diversi\xF3n junto al mar.</p>\n                    <div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/37/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\t\t\t\t<p>Cruce la calle hacia la \"Tajana Compound\", un centro comercial al aire libre fabulosamente renovado ubicado en una estaci\xF3n de tren hist\xF3rica en desuso construida alrededor de 1890 como estaci\xF3n central de tren de Jaffa y Tel Aviv.</p>\n                    <p>Dir\xEDjase al pintoresco barrio de Neve Tzedek y cruce las hermosas callejuelas. Dese un capricho en sus boutiques hasta llegar al colorido bullicio del mercado de Carmel. Det\xE9ngase para probar la excelente comida callejera y si es martes o viernes, consid\xE9rese afortunado y haga algunas compras en el mercadillo tradicional Najlat Binyamin, donde los artesanos locales muestran su trabajo.</p>\n                    \n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/37/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\t\t\t\t<p>Siga su camino hasta el espl\xE9ndido Rothschild Blvd, el coraz\xF3n de la arquitectura Bauhaus y patrimonio internacional de la UNESCO. Aqu\xED podr\xE1 alquilar una bicicleta y unirse al flujo local hasta la Plaza Habima, sede del teatro nacional y de la orquesta filarm\xF3nica israel\xED. Dir\xEDjase a la animada y moderna calle Dizengoff o coma algo en alguna de las cafeter\xEDas de la plaza y siga caminando o pedaleando por Hen Blvd hasta la plaza Rabin.</p>\n                    <p>Eche un vistazo a la calle Eben Gabiroll, un centro de moda de la fabulosa ciudad, hogar de una gran variedad de restaurantes premiados, y excelentes bares y pubs donde puede comer o beber algo y mezclarse con los habitantes locales.</p>\n                    <p>S\xFAbase a un autob\xFAs de la l\xEDnea 5, un icono urbano en s\xED mismo, y b\xE1jese en el puerto de Tel Aviv. Disfrute del atardecer y observe el horizonte de Jaffa hacia el sur, donde comenz\xF3 el d\xEDa. Pase la noche en la zona y mire c\xF3mo se transforma en la escena nocturna m\xE1s animada de la ciudad, repleta de fabulosos bares y discotecas hechos a medida de una noche \xE9pica.</p>\n\n\n            \t"};}},{id:"Non_Stop_Culture",bgImage:"/posts/bank/non-stop-culture/1.jpg",mobBgImage:"/posts/bank/non-stop-culture/M/1.jpg",title:"Tiempo de cultura",isVid:false,// vidId:"JxSjC2kZfvI",
ctg:"telaviv",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<br/>\n                    <h3>Una variedad de fascinantes museos y galer\xEDas \xFAnicas</h3>\n\t\t\t\t    <h3>\n\t\t\t\t        El Museo de Arte de Tel Aviv\n\t\t\t\t    </h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\t El Museo de Arte de Tel Aviv presenta una variedad de exhibiciones permanentes y temporales en el Pabell\xF3n Helena Rubenstein, ubicado en la avenida Shaul Hamelej cerca del Auditorio Mann. Las exhibiciones permanentes incluyen algunos de los mejores trabajos del arte israel\xED, as\xED como esculturas del siglo XX y de la actualidad. Cuenta con pinturas europeas \u2013 impresionismo y post-impresionismo \u2013 desde el siglo XVI hasta el siglo XIX, as\xED como pintura europea y americana del siglo XX. La colecci\xF3n gr\xE1fica del museo incluye m\xE1s de 20.000 grabados y bocetos. Entre los impresionantes trabajos que se exhiben en el museo destaca una selecci\xF3n \xFAnica de relieves tempranos de Alexander Archipenko y trabajos de Chagall, que fueron donados al museo por el pintor antes de su creaci\xF3n. La conocida colecci\xF3n de arte decorativo de Helena Rubinstein se exhibe permanentemente en el pabell\xF3n que lleva su nombre.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t    <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/non-stop-culture/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t    </div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t         HORARIO DE APERTURA:\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\n                          Lunes, mi\xE9rcoles, s\xE1bados: 10:00 \u2013 18:00 hrs <br>\n                          Martes, jueves: 10:00 \u2013 22:00 hrs<br>\n                          Viernes: 10:00 \u2013 14:00 hrs <br>\n\n                          S\xE1bados: 10:00 \u2013 16:00 (julio- agosto cerrado los s\xE1bados)<br>\n                    </p>\n\n                    <p>\n                       PARA M\xC1S INFORMACI\xD3N, pinche en&nbsp;<a href=\"//www.tamuseum.org.il/en/default.aspx\" target=\"_blank\">Tel Aviv Museum of Art</a>\n                    </p>\n\n                    <h3>\n                       Beit Hatfutsot: El Museo de la Di\xE1spora\n                    </h3>\n\n                    <p>\n                        Beit Hatfutsot \u2013 El Museo de la Di\xE1spora Jud\xEDa, se encuentra en el campus de la Universidad de Tel Aviv, y ha ganado una distinci\xF3n honoraria en el mundo jud\xEDo por ser el primer museo de la historia del pueblo jud\xEDo que muestra su contribuci\xF3n a la cultura y creatividad de la humanidad, durante m\xE1s de dos milenios. La exhibici\xF3n permanente del museo describe la historia del pueblo jud\xEDo y vuelve la di\xE1spora a la vida a trav\xE9s de dibujos, videoclips, filmes, maquetas y otro medios. La exhibici\xF3n enfoca varios temas \u2013 incluyendo \u201Cel c\xEDrculo de vida de la familia jud\xEDa\u201D, \u201Cla comunidad\u201D, \u201Cla fe\u201D y \u201Cel retorno a Si\xF3n\u201D.\n                    </p>\n                        \n\n                    <p>\n\n                          PARA M\xC1S INFORMACI\xD3N, pinche en&nbsp;<a href=\"//www.bh.org.il/\" target=\"_blank\">Beit Hatfutsot: El Museo de la Di\xE1spora Jud\xEDa</a>\n\n                    </p>\n\n\n                    <h3>\n                        Museo de Eretz Israel\n                    </h3>\n\n                    <p>\n\n                           El Museo de Eretz Israel de Tel Aviv, es una instituci\xF3n interdisciplinaria que representa la historia del pa\xEDs y su cultura a trav\xE9s de una extensa exhibici\xF3n permanente, adem\xE1s de una variedad de exhibiciones temporales en temas como arqueolog\xEDa, etnograf\xEDa, folklore, judaica, historia cultural, identidad local, artesan\xEDas tradicionales y artes funcionales. Los pabellones del museo est\xE1n distribuidos dentro de un patio amplio con el antiguo mont\xEDculo arqueol\xF3gico de Tel Kassile, cuyas excavaciones revelaron hallazgos valiosos, posicionado en el centro. El museo alberga una variedad de maquinaria antigua reconstruida, como prensas de vino, prensas de aceite de oliva y un molino de harina, junto con un \u201Cmercado de artesanos\u201D que expone herramientas de trabajo tradicionales que fueron usadas en la Tierra de Israel y en toda la regi\xF3n. En el lugar tambi\xE9n se ubica un sofisticado planetario con el programa \u201CViaje al Universo\u201D adem\xE1s de la tienda del museo que ofrece una selecci\xF3n \xFAnica de regalos de producci\xF3n local y artesan\xEDa.<br>\n\n                            HORARIO DE APERTURA:<br>\n\n                          Domingos a mi\xE9rcoles: 10:00 \u2013 16:00 hrs<br>\n\n\n\n                          Jueves: 10:00 \u2013 20:00 hrs<br>\n\n\n\n                         Viernes y s\xE1bados: 10:00 \u2013 14:00 hrs<br>\n\n                        </p>\n\n                    <p>\n                       PARA M\xC1S INFORMACI\xD3N, pinche en <strong>&nbsp;</strong><a href=\"//www.eretzmuseum.org.il/e/\" target=\"_blank\">Eretz Israel Museum&nbsp;</a>\n                    </p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Beit Ha\u2019ir\n\t\t\t\t\t</h3>\n\n\n\t\t\t\t\t<p>\n\n                         El Beit Ha\xB4ir, renovado por el municipio, es la antigua sede de la municipalidad de Tel Aviv en la calle Bialick, y ahora es una muestra viva de la historia de la historia de la ciudad. El Beit Ha\xB4ir tiene una nueva exhibici\xF3n que resume la extensa colecci\xF3n de fotos y presentaciones de eventos e historias, lugares y experiencias de residentes de la ciudad a lo largo de los a\xF1os. Un proyecto que form\xF3 parte de las celebraciones del centenario de la ciudad. La sala principal cuenta con una presentaci\xF3n virtual, incluyendo cientos de pel\xEDculas documentales y miles de fotograf\xEDas in\xE9ditas y documentos que exponen los grandes hitos de los primeros a\xF1os de vida de la ciudad. En el Beit Ha\xB4ir tambi\xE9n se puede visitar la casa de Dizengoff, la residencia restaurada del primer alcalde de Tel Aviv, que incluye una exhibici\xF3n permanente.\n\n                          <br>\n                         HORARIO DE APERTURA:\n                           Domingos cerrado\n                         Lunes a jueves: 9:00-17:00 <br>\n                         Viernes y s\xE1bados: 10:00-14:00\n                    </p>\n\n                    <p>\n                      PARA M\xC1S INFORMACI\xD3N, pinche en <a href=\"//www.eretzmuseum.org.il/e/\" target=\"_blank\">Beit Ha\u2019ir</a>\n                    </p>\n\n                    <h3>\n                        Museo de la Experiencia Ol\xEDmpica\n                    <h3>\n\n                    <p>\n\n                         El Museo de la Experiencia Ol\xEDmpica es un nuevo museo en Tel Aviv, que ofrece un viaje por los cinco anillos de una hora de duraci\xF3n por las grandes marcas ol\xEDmpicas, con un enfoque especial en los mejores momentos ol\xEDmpicos de Israel. La Experiencia Ol\xEDmpica cuenta con modernas im\xE1genes e ilustraciones en alta tecnolog\xEDa, presentaciones audiovisuales, hologramas, pantallas interactivas, obras experimentales y mucho m\xE1s.<br>\n\n                          Tours guiados para grupos organizados salen cada 30 minutos. Se recomienda hacer reservas por adelantado.\n                          Horario de apertura: domingos a jueves: 10:00 \u2013 18:00 hrs, viernes: 10:00 \u2013 14:00 hrs.\n                          La Experiencia Ol\xEDmpica, calles Shitrit 6, Hadar Yosef, tel\xE9fono: +972-3-6498385\n\n                    </p>\n\n                    <p>\n                       PARA M\xC1S INFORMACI\xD3N, pinche en&nbsp;<a href=\"//www.olympic.one.co.il/General/Page.aspx?id=86&amp;siteid=2\" target=\"_blank\">Museo de la Experiencia Ol\xEDmpica</a>\n                    </p>\n\n                    \n\n                        <h3> Museo Ilana Goor, Jaffa</h3>\n\n                        <p>   La residencia privada de esta artista mundialmente conocida, se transform\xF3 en museo. Es posible ver sus esculturas, muebles, joyas y echar un vistazo a esta casa \xFAnica en Jaffa.<br>\n                          HORARIO DE APERTURA:<br>\n                          Domingos a viernes: 10:00 \u2013 16:00 hrs<br>\n                           S\xE1bados: 10:00 \u2013 18:00 hrs <br>\n\n                          <a href=\"//www.ilanagoormuseum.org/eng/\">www.ilanagoormuseum.org</a>\n                    </p>\n\n                    <h3>\n                        Museo del Palmaj\n                    </h3>\n\n                    <p>\n                       Evaluado como el museo n\xBA 1 de Tel Aviv por Trip Advisor, este museo se centra en el Palmaj, el brazo armado del Movimiento Sionista, que funcion\xF3 hasta el establecimiento del Estado de Israel.\n                    </p>\n\n                    <p>\n                        PARA M\xC1S INFORMACI\xD3N, pinche en&nbsp;<a href=\"//info.palmach.org.il/show_item.asp?itemId=8096&amp;levelId=42798&amp;itemType=0\" target=\"_blank\">Palmach Museum</a>\n                    </p>\n\n                    <h3>\n                        Otros museos interesantes\n                    </h3>\n\n                    <p>\n                        Tel Aviv-Yafo alberga una variedad de museos peque\xF1os y especializados, como la Casa de Ben Guri\xF3n (residencia personal de David Ben Guri\xF3n, el primer Primer Ministro de Israel), Beit Hatanaj (La Casa de la Biblia), el Museo de la Hagan\xE1 (organizaci\xF3n de defensa), el Museo del Ezel (Irg\xFAn Zva\xED Leum\xED \u2013 Organizaci\xF3n Militar Nacional), Beit Hasofer (Casa del Escritor), Beit Reuven, Museo Jabotinsky y muchos m\xE1s. Cada uno de estos peque\xF1os museos es una mina inagotable de tesoros en materia de objetos y artesan\xEDas. Beit Bialik por ejemplo \u2013 la casa del poeta nacional de Israel, muestra los libros, los muebles y enseres personales del renombrado poeta. La biblioteca personal de Bialik que incluye m\xE1s de 3.000 libros, se ha conservado, y los archivos del museo contienen miles de manuscritos, incluyendo la colecci\xF3n m\xE1s extensa de sus escritos.\n                    </p>\n\n                    <h3>\n                        HORARIOS DE APERTURA DE LOS MUSEOS DE TEL AVIV\n                    </h3>\n                    <h3>\n                       Museo del Ezel:\n                    </h3>\n\n                    <p>\n\n                         King George 38: Domingo a jueves 8:30 \u2013 16:00 hrs <br>\n\n                          PARA M\xC1S INFORMACI\xD3N, pinche en&nbsp;<a href=\"//www.goisrael.com/Tourism_Eng/Tourist%20Information/attractions/Pages/Etzel%20Museum.aspx\" target=\"_blank\">Etzel Museum</a>\n                    </p>\n\n                    <h3>\n                        Casa de Ben Gurion:\n                    </h3>\n\n                    <p>\n                           Domingos, martes-jueves 8:00 \u2013 15:00 hrs <br>\n                            Lunes 8:00 \u2013 17:00 hrs<br>\n                            Viernes 8:00 \u2013 13:00 hrs <br>\n                           S\xE1bados 11:00 \u2013 14:00 hrs\n                    </p>\n\n                    <p>\n                       PARA M\xC1S INFORMACI\xD3N, pinche en&nbsp;<a href=\"//www.bg-house.org/?categoryId=6575\" target=\"_blank\">Casa de Ben Gurion:</a>\n                    </p>\n\n                    <h3>\n                        Instituto Jabotinsky en Israel:\n                    </h3>\n\n                    <p>\n\n                        Domingo-jueves 8:00 \u2013 16:00 hrs <br>\n                        Para m\xE1s Informaci\xF3n, pinche en &nbsp;<a href=\"//en.jabotinsky.org/\" target=\"_blank\">Instituto Jabotinsky en Israel:</a>\n\n                    </p>\n\n                    <h3>\n                           Museo Israel:\n                    </h3>\n\n                    <p>\n                             Domingos, lunes, mi\xE9rcoles 9:00 \u2013 17:00 hrs<br>\n                            Lunes, jueves 9:00 \u2013 19:00 hrs<br>\n                            Viernes 9:00 \u2013 14:00 hrs<br>\n                              Para m\xE1s Informaci\xF3n, pinche en\n                            <a href=\"//www.imj.org.il/en/\">www.imj.org.il</a>\n                    </p>\n\n                    <h3>\n                        Centro de visitantes de Jaffa:\n                    </h3>\n\n                    <p>\n\n                            Verano: Domingos-jueves, s\xE1bados 9:00 \u2013 20:00 hrs<br>\n\n\n\n                            PARA M\xC1S INFORMACI\xD3N, pinche en  <br>\n\n                            <a href=\"//www.touristisrael.com/old-jaffa-visitors-center/3604/\" target=\"_blank\">Centro de visitantes de Jaffa: </a>\n\n                    </p>\n\n                    <h3>\n                         Casa de Joseph Bau:\n                    </h3>\n\n                   <p>\n\n                           Con cita previa \xFAnicamente (Tambi\xE9n fines de semana)<br>\n\n\n\n                            PARA M\xC1S INFORMACI\xD3N, pinche en&nbsp;<a href=\"//www.josephbau.com/\" target=\"_blank\">Casa de Joseph Bau</a>\n\n                    </p>\n\n                    <h3>\n                        Museo Rubin:\n                    </h3>\n\n                    <p>\n\n                            Domingos cerrado <br>\n                             Lunes, mi\xE9rcoles, jueves 10:00 \u2013 15:00 hrs<br>\n                             Lunes 10:00 \u2013 20:00 hrs<br>\n                             S\xE1bados 11:00 \u2013 14:00 hrs<br>\n\n                            PARA M\xC1S INFORMACI\xD3N, pinche en&nbsp;<a href=\"//www.rubinmuseum.org.il/\" target=\"_blank\">Museo Rubin</a>\n\n                    </p>\n\n                    \n\n\n                    <h3>\n                        Galer\xEDas de arte\n                    </h3>\n\n                    <p>\n                       No se pierda las docenas de elegantes galer\xEDas de arte, concentradas en su mayor\xEDa a los largo de la calle Gordon y en la ciudad vieja de Jaffa. Las galer\xEDas exhiben lo \xFAltimo en materia de arte israel\xED contempor\xE1neo. No diremos ni una palabra m\xE1s \u2013 dejamos que el arte hable por si mismo.\n                          </p>\n                    </p>\n            \t"};}},{id:"A_Taste_Of_Jerusalem",bgImage:"/posts/bank/taste-of-jerusalem/1.jpg",mobBgImage:"/posts/bank/taste-of-jerusalem/M/1.jpg",title:"Qué debe probar en Jerusalén",ctg:"culinaryjerusalem",isVid:true,// vidId: "2CSCe2WC7Ns",
vidId:"oy9ozIvV7Co",smlTitle:"",html:function html(){return{__html:"\n                \n\t\t\t\t <p>Jerusal\xE9n es una ciudad fascinante y m\xE1gica. Muchas personas que visitan Jerusal\xE9n alaban su sorprendente atm\xF3sfera, sus lugares inolvidables, sus impactantes vistas y mucho m\xE1s. Sin embargo, para entender realmente de qu\xE9 trata Jerusal\xE9n, hay algunas cosas que sencillamente tendr\xE1 que experimentar a trav\xE9s de su est\xF3mago. Aqu\xED tiene algunas de las cosas que deber\xEDa probar durante su visita:</p>\n                   \n\t                    \t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/39/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\t\t\t\t    <p><strong>Malabi:</strong> una combinaci\xF3n \xFAnica de bebida y postre, una mezcla a base de agua de rosas, leche, harina de ma\xEDz y az\xFAcar. El Malabi es un plato muy popular de Jerusal\xE9n, que se vende en muchos restaurantes y kioscos de Oriente Medio por toda la ciudad. Le garantizamos que no ha probado nunca nada parecido.</p>\n                    <p><strong>Knafe:</strong> un plato muy interesante y con un sabor sensacional cuando se sirve y come fresco. El Knafe es esencialmente un postre \xE1rabe hecho de queso de cabra fundido y cubierto con hilos de pasta de naranja, ba\xF1ado en sirope de agua de rosas. Encontrar el Knafe perfecto es una misi\xF3n, y una vez que lo encuentre, comerlo se convertir\xE1 en una adicci\xF3n.</p>\n                    <p><strong>Pretzel de Jerusal\xE9n:</strong> cuando recorra los fascinantes lugares del casco antiguo no olvide parar en uno de los carritos verdes y comprar un aut\xE9ntico pretzel de Jerusal\xE9n. Junto con este, obtendr\xE1 una hierba verde local arom\xE1tica llamada Zaatar que combina muy bien con la deliciosa masa.</p>\n                    <p><strong>Meorav Yerushalmi:</strong> se traduce literalmente como \"Jerusal\xE9n mixto\". Esta deliciosa mezcla de varias carnes con una combinaci\xF3n local de especias \xFAnica es una delicia total para los carn\xEDvoros.</p>\n                    <p><strong>Ashtanur:</strong> abreviatura en hebreo de \"fuego en el horno\", el Ashtanur es un aut\xE9ntico pan de pita local que podr\xE1 encontrar en el centro de la ciudad o en los mercados durante el almuerzo. Si est\xE1 especialmente hambriento, pru\xE9belo con shawarma o falafel.</p>\n                    <p><strong>Sabij:</strong> absolutamente original, el Sabij es un plato local verdaderamente \xFAnico compuesto por un pan de pita relleno de berenjena frita, huevos duros y pepinillos, generalmente cubierto por Amba, un sabroso condimento local. Una vez que lo pruebe, se enganchar\xE1 de por vida.</p>\n\n\n            \t"};}},{id:"Sectrets_Of_Jewish_Jerusalem",bgImage:"/posts/bank/sectrets-of-jewish-jerusalem/1.jpg",mobBgImage:"/posts/bank/sectrets-of-jewish-jerusalem/M/1.jpg",title:"LOS SECRETOS DE JERUSALÉN",ctg:"jerusalem",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                               \n\t\t\t\t\t\t\t\t<h3>An\xEDmese a hacer un viaje espiritual inolvidable en una Jerusal\xE9n espectacular</h3>\n\t\t\t\t\t\t\t\t<p>Jerusal\xE9n es una invitaci\xF3n abierta a un viaje que no olvidar\xE1. Suba las monta\xF1as, entre en la ciudad y sienta la mezcla \xFAnica entre pasado y presente, lo ordinario y extraordinario. Una de las ciudades m\xE1s antiguas del mundo, sagrada para jud\xEDos, cristianos y musulmanes, Jerusal\xE9n ofrece una experiencia sensorial y espiritual inigualable.</p>\n\t\t\t\t\t\t\t\t<p><strong>Entre</strong>. El coraz\xF3n de la ciudad m\xE1s sagrada en el juda\xEDsmo es la Ciudad Vieja. Entre a trav\xE9s de la hist\xF3rica<em> puerta de Jaffa</em>, o por <em>la puerta de Zion</em> que conduce directa <strong>al barrio jud\xEDo</strong>, uno de los cuatro barrios de la ciudad amurallada y hogar de los jud\xEDos casi ininterrumpidamente desde el siglo VIII a.C. Marav\xEDllese a trav\xE9s de los callejones, vea la gente, visite el <strong>Cardo</strong>, antigua calle principal de Jerusal\xE9n, y absorba el ambiente \xFAnico. Est\xE1 caminando tras los pasos de reyes y profetas - No es cosa ordinaria.</p>\n\t\t\t\t\t\t\t\t<h3>Sea testigo c\xF3mo la historia cobra vida y sienta la energ\xEDa espiritual profunda dentro de los muros</h3>\n\t\t\t\t\t\t\t\t<p><strong>Lo que est\xE1 por venir</strong>. El \xFAltimo segmento restante de las antiguas murallas que rodearon el Segundo Templo, <strong>el Muro Occidental</strong>, es un s\xEDmbolo de los anhelos jud\xEDos por su patria ancestral y espiritual. Cada jud\xEDo que no est\xE1 en Jerusal\xE9n reza en direcci\xF3n al lugar donde est\xE1 ahora, el lugar donde, seg\xFAn el juda\xEDsmo, Dios reside. No importa cu\xE1les sean sus creencias, es una experiencia de humildad. Honrar el esp\xEDritu del sitio y colocar una nota en la pared con una oraci\xF3n o un deseo.</p>\n\t\t\t\t\t\t\t\t<p><strong>Lo que hay debajo</strong>. Jerusal\xE9n est\xE1 literalmente cubierta de capas de historia y la historia conmovedora obtiene un nuevo significado aqu\xED.</p>\n\t\t\t\t\t\t\t\t <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t                <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/sectrets-of-jewish-jerusalem/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t\t\t\t\t\t                </div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t    <small style=\"color:#000; display:block;\">\n\t\t\t\t\t\t\t\t                      \t\t        Credit: Noam Chen\n\t\t\t\t\t\t\t\t                      \t        </small>\n\t\t\t\t\t\t\t\t<p>Haga el tour fascinante a <strong>los T\xFAneles del Muro Occidental</strong> y descubra sus secciones ocultas. La historia cobrar\xE1 vida a medida que avance por los pasajes subterr\xE1neos, averig\xFCe c\xF3mo era la vida en Jerusal\xE9n durante la era del Segundo Templo y aprenda sobre el arte, la arquitectura y las pr\xE1cticas de construcci\xF3n.</p>\n\t\t\t\t\t\t\t\t<p>Visite el sitio arqueol\xF3gico cercano, la <strong>Ciudad de David</strong> y aprenda m\xE1s sobre la historia de la ciudad. El Rey David la declar\xF3 como la capital unificada de las 12 tribus de Israel hace 3000 a\xF1os. Viaje entre los muros y fortalezas antiguas, fuentes ocultadas donde reyes fueron coronados y sigua el camino de los que huyeron de Jerusal\xE9n despu\xE9s de que la ciudad fuera conquistada por los romanos.</p>\n\t\t\t\t\t\t\t\t<h3>Marav\xEDllese de la extraordinaria vista impresionante y si\xE9ntase en la cima del mundo</h3>\n\t\t\t\t\t\t\t\t<p><strong>Lo que est\xE1 por encima</strong>. Originalmente construido para proteger la ciudad contra los intrusos, Jerusal\xE9n est\xE1 rodeada de murallas. Hoy <strong>los Muros de Jerusal\xE9n</strong> ofrecen una oportunidad para explorar la ciudad desde un \xE1ngulo diferente. Escuche las historias, vea la ciudad subterr\xE1nea y disfrute de toda esta belleza.</p>\n\t\t\t\t\t\t\t\t<p>Est\xE1 empezando a alcanzar la superficie.</p>\n\n            \t"};}},{id:"Jamie_Oliver",bgImage:"/posts/bank/jamie_oliver/1.jpg",mobBgImage:"/posts/bank/jamie_oliver/M/1.jpg",title:"Jamie Oliver degusta el desayuno de Tel Aviv",ctg:"culinarytelaviv",isVid:true,vidId:"gGe4W8WaIiQ",smlTitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t<small style=\"color:#000; display:block;position: relative;top: 5px;\">\n\t\t\t\t\t\tCredit:  Israeli food channel\n\t\t\t\t\t\t</small>\n\n            \t"};}},{id:"Enjoy_And_Indulge",bgImage:"/posts/bank/enjoy-and-indulge/1.jpg",mobBgImage:"/posts/bank/enjoy-and-indulge/M/1.jpg",title:"El destino de lujo definitivo",isVid:false,ctg:"telaviv",smltitle:"",html:function html(){return{__html:"\n                    <p>Olv\xEDdese del Caribe, Cannes o Las Maldivas. Si lo que quiere son unas vacaciones lujosas \xA1Tel Aviv es el sitio!</p>\n                    <p>En primer lugar, la ciudad, nombrada \"la ciudad m\xE1s cool\" por el NY Times, est\xE1 a solo unas pocas horas de distancia, lo que significa que no tiene que preocuparse por perder ni siquiera un minuto de sus vacaciones so\xF1adas en librarse del Jet Lag.</p>\n                    <p>Una vez aqu\xED, la primera sorpresa es el maravilloso clima soleado durante todo el a\xF1o, un placer a medida.</p>\n                    <p>A continuaci\xF3n, t\xFAmbese a descansar y rel\xE1jese en la gran variedad de alojamientos de lujo ofertados: desde hoteles 5 estrellas en primera l\xEDnea de playa a los numerosos y asombrosos hoteles boutique en lugares impresionantes por toda la ciudad.</p>\n                    \n                   \t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/38/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t <p>Para completar la experiencia, coja una toalla y dir\xEDjase a cualquiera de las preciosas playas, equipadas con todas las comodidades necesarias para pasar un d\xEDa fabuloso, por no hablar de la belleza de sus refrescantes aguas.</p>\n                    <p>\xBFTiene hambre? Disfrute de una gran selecci\xF3n de restaurantes gourmet, desde comida local hasta fusi\xF3n. Tel Aviv es conocida en todo el mundo por la calidad de su cocina, que se ofrece en restaurantes de chefs galardonados y que est\xE1n dise\xF1ados de forma exquisita.</p>\n                    <p>\xA1Es hora de irse de compras!. Coja su cartera y venga a echarle un vistazo a las boutiques de los dise\xF1adores locales, las exclusivas tiendas chic y los centros comerciales de lujo, donde podr\xE1 encontrar de todo, desde alta costura hasta las \xFAltimas tendencias internacionales.</p>\n                    <p>Para cerrar el d\xEDa, t\xF3mese una cerveza artesanal o un glamuroso coctel en cualquiera de los sensacionales clubes nocturnos o de los elegantes bares que hay por toda la ciudad, y baile hasta que salga el sol antes de dirigirse de vuelta a su hotel para un merecido descanso de 5 estrellas.   </p>\n                    <p>\xBFLujo? \xBFEstilo? \xBFGlamour? \xA1Lo tenemos todo! \xA1As\xED que dese prisa y reserve hoy su viaje a Tel Aviv!</p>\n\n\n            \t"};}},{id:"Cool_Jerusalem",bgImage:"/posts/bank/cool-jerusalem/1.jpg",mobBgImage:"/posts/bank/cool-jerusalem/M/1.jpg",title:"",ctg:"jerusalem",isVid:true,vidId:"nLKWDp5uA-U",smltitle:"Las sorpresas de Jerusalén",html:function html(){return{__html:"\n                    <br/>\n                    <h3>Una ciudad m\xE1s all\xE1 de las expectativas</h3>\n                     <p>Jerusal\xE9n es una ciudad mundialmente famosa y uno de los destinos vacacionales m\xE1s populares del mundo. Mucha gente visita Jerusal\xE9n cada a\xF1o por su significado hist\xF3rico, sus lugares sagrados, su hermosa arquitectura \xFAnica y su extraordinaria atm\xF3sfera. Sin embargo, Jerusal\xE9n est\xE1 llena de sorpresas y esta increible ciudad ofrece muchas cosas que la mayor\xEDa de la gente no asociar\xE1 con ella de inmediato. Estas son solo algunas de las cosas que no esperar\xEDa encontrar en Jerusal\xE9n:</p>\n                    \n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/40/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t <h3>Fiestas de verano</h3>\t\n                    <p>Cada a\xF1o, durante el verano, el centro de Jerusal\xE9n se inunda de fiestas los viernes a mediod\xEDa, llenas de m\xFAsica, baile, gente guapa de todo el mundo y un embriagador ambiente festivo, para calentar motores y comenzar con fuerza el fin de semana.</p>\n\n                    <h3>Un mercado de locura</h3>\n                    <p>Una experiencia incre\xEDble que tiene lugar las noches de los jueves, en las que el ajetreado mercado de Majane Yehuda se convierte en un animado escenario nocturno repleto de fant\xE1sticos bares y pubs y con m\xFAsica en vivo durante toda la noche.</p>\n\n                    <h3>Festivales</h3>\n                    <p>Jerusal\xE9n es una ciudad repleta de festivales, desde el famoso festival de cine hasta el festival del vino, un festival internacional de t\xEDteres e incluso un festival de la cerveza. Sean cuales sean sus gustos, seguro que encontrar\xE1 un festival acorde a su estilo en alg\xFAn punto de la ciudad.</p>\n\n                    <h3>El marat\xF3n de Jerusal\xE9n</h3>\n                    <p>Un marat\xF3n fant\xE1stico y extremadamente popular que ofrece varios recorridos, desde profesionales hasta familias, que pasan por fascinantes lugares hist\xF3ricos que ilustran 3000 a\xF1os de la historia de Jerusal\xE9n, garantizando una experiencia desafiante, emocionante e inolvidable para corredores y espectadores.</p>\n                    <h3>Museos y exhibiciones</h3>\n                    <p>La diversidad de la ciudad de Jerusal\xE9n se extiende a sus museos y eventos culturales, que se presentan por toda la ciudad. Desde el mundialmente famoso museo de Israel hasta Yad Vashem; del memorable espect\xE1culo de luz y sonido en la Ciudadela al paseo por las murallas (de d\xEDa o de noche), y mucho m\xE1s. La ciudad est\xE1 sencillamente repleta de incre\xEDbles experiencias culturales.</p>\n\n                    <h3>El mercado agropecuario</h3>\n                    <p>Cada viernes en la colonia alemana, en el coraz\xF3n de la ciudad, tiene lugar el mercado agropecuario local, en el que puede encontrar multitud de excelentes productos agr\xEDcolas, una gran variedad de delicias locales y extraordinarias ofertas.</p>\n\n                    <h3>Un acuario de nivel mundial</h3>\n                    <p>Uno de los acuarios m\xE1s grandes del Medio Oriente. Esta fabulosa atracci\xF3n para ni\xF1os y mayores abri\xF3 sus puertas al p\xFAblico este a\xF1o. El acuario mide 7000 metros cuadrados y alberga 40 especies marinas en 33 tanques de agua, el mayor de los cuales contiene 1,6 millones de litros de agua.</p>\n\n\n\n            \t"};}},{id:"Cycle_TelAviv",bgImage:"/posts/bank/cycle-in-telaviv/1.jpg",mobBgImage:"/posts/bank/cycle-in-telaviv/M/1.jpg",//   vidId: "Iyziun92P5A",
vidId:"5nqL-oIC0GA",isVid:true,ctg:"telaviv",title:"Tel Aviv en bici",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t<p>Siendo una de las ciudades m\xE1s modernas del mundo, no sorprende que Tel Aviv, en los \xFAltimos a\xF1os, se haya unido a la tendencia que se est\xE1 extendiendo por las ciudades m\xE1s famosas: la bicicleta.<p>\n                     <p>Explorar la ciudad en bici aporta varios beneficios: es respetuoso con el medio ambiente, al reducir sustancialmente el impacto ambiental; le ahorra un valioso tiempo de vacaciones que, de otro modo, pasar\xEDa metido en un atasco y, por supuesto, es muy saludable. El ciclismo es un ejercicio fant\xE1stico, y como turista, la bici como medio para explorar la ciudad es una forma fabulosa de disfrutar de sus vistas, sonidos y olores de cerca sin interferencias.<p>\n                     <p>Estas son solo algunas de las cosas que hacen de Tel Aviv una ciudad fant\xE1stica para el ciclismo:<p>\n                    \n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/41/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>Los carriles exclusivos para bicicletas: la ciudad de Tel Aviv es una gran defensora de las bicicletas como medio de transporte y, para apoyar la causa, hay m\xE1s de 100 km de carriles exclusivos para bicicletas pavimentados por toda la ciudad, para la seguridad y comodidad de sus usuarios. <p>\n                     <p>El tiempo: Tel Aviv goza de un clima fant\xE1stico durante todo el a\xF1o con muy poca lluvia, lo que la convierte en la ciudad perfecta para practicar ciclismo, disfrutando de la brisa fresca que llega desde la playa en el impresionante paseo mar\xEDtimo o descendiendo por sus asombrosas calles interiores con la fabulosa arquitectura Bauhaus.<p>\n                     <p>Tel-O-Fun:  Tel-O-Fun es un sistema p\xFAblico municipal de alquiler de bicicletas f\xE1cil, simple y econ\xF3mico. Con Tel-O-Fun, tanto residentes como visitantes pueden coger y dejar bicicletas de excelente calidad usando una tarjeta de cr\xE9dito en 150 estaciones por toda la ciudad.<p>\n                     <p>Lo mejor es que todo est\xE1 tan cerca en Tel Aviv que puede llevar su bici a la playa, pedalear a lo largo del precioso paseo mar\xEDtimo, disfrutar de un fant\xE1stico picnic en el parque Ha'Yarkon y llev\xE1rsela en una noche por la ciudad a los fabulosos clubes y bares de Dizengoff o el puerto.<p>\n                     <p>Ir en bici nunca fue tan f\xE1cil, saludable y divertido en la bella ciudad de Tel Aviv.<p>\n                       \n\n            \t"};}},{id:"TelAviv_Adventures",bgImage:"/posts/bank/telaviv-adventures/1.jpg",mobBgImage:"/posts/bank/telaviv-adventures/M/1.jpg",title:"Cosas geniales que hacer en Tel Aviv",smltitle:"",isVid:false,ctg:"telaviv",html:function html(){return{__html:"\n                   <p>Tel Aviv es mundialmente reconocida por ser la ciudad que nunca duerme, famosa por su incre\xEDble vida nocturna, las fabulosas playas, la fant\xE1stica cultura, el arte y mucho m\xE1s. Pero aqu\xED tiene algunas cosas menos conocidas que puede hacer durante sus vacaciones en la ciudad.</p>\n                    \n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/42/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t  <h3>Conozca los bares de pulsera</h3>\n                    <p>Los bares de pulsera son una excelente manera de pasar la noche bebiendo sin salirse del presupuesto. Simplemente dir\xEDjase a uno de los muchos bares en Tel Aviv que le permiten pagar por adelantado un precio fijo.  \xA1Diversi\xF3n asegurada!  </p>\n                    <h3>Tambores los viernes tarde</h3>\n                    <p>Dir\xEDjase a la famosa playa Banana el viernes por la tarde y dese un doble capricho: disfrute de la incre\xEDble sesi\xF3n de tambores en la playa y admire la hermosa puesta de sol, \xA1ambas completamente gratis!</p>\n                    <h3>Diversi\xF3n en la azotea</h3>\n                    <p>Tal vez sea el clima o tal vez sean las vistas, pero una cosa es segura: los habitantes de Tel Aviv adoran estar al aire libre, especialmente con una bebida en la mano. Durante el verano, la mayor\xEDa de los bares y pubs alzan el techo (\xA1literalmente!), y se convierten en establecimientos al aire libre, mientras que en las azoteas de edificios comerciales y de oficinas surgen numerosos bares. Para dar con estos impresionantes lugares, todo lo que necesita hacer es simplemente seguir los sonidos de la m\xFAsica y la diversi\xF3n.</p>\n                    <h3>Deporte al aire libre</h3>\n                    <p>Nada es m\xE1s importante que su salud, y una de las mejores cosas que puede hacer por su cuerpo es ejercitarlo. Tel Aviv ofrece algunas maneras excelentes de hacerlo, desde nadar en el mar o correr por el paseo mar\xEDtimo, hasta ir en bicicleta por las calles de la ciudad e incluso practicar gimnasia en cualquiera de las estaciones de ejercicio al aire libre ubicadas alrededor de la ciudad.</p>\n                    <h3>Grandes eventos estivales </h3>\n                    <p>Desde famosos artistas internacionales hasta incre\xEDbles festivales de tecnolog\xEDa, arte y cerveza, inauguraciones de galer\xEDas, exposiciones o m\xFAsica callejera en vivo, hasta cines al aire libre y fiestas en la playa que duran toda la noche, \xA1Tel Aviv en verano es una fuente inagotable de diversi\xF3n y entretenimiento que no debe dejar escapar!</p>\n\n\n            \t"};}},{id:"2_AWESOME_CITIES",bgImage:"/posts/bank/27/1.jpg",mobBgImage:"/posts/bank/27/M.jpg",title:"2 Ciudades Increibles",smltitle:"",isVid:true,vidId:"NlOJ-i5hJdI",ctg:"telavivAndJerusalem",html:function html(){return{__html:"\n\n\t\t\t\t\t<br/>\n\t\t\t\t\t<h3>Una escapada m\xE1gica e inolvidable hacia el sol</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tTel Aviv, una metr\xF3polis bulliciosa y muy moderna, con relucientes playas doradas, un ambiente a la \xFAltima y amplias oportunidades de diversi\xF3n con el aut\xE9ntico sabor de Oriente Medio, sin mencionar la excelente comida y caf\xE9. A tan solo cuarenta minutos, experimente un ritmo y una vida completamente distintos: Jerusal\xE9n, una ciudad con un esplendor incomparable. Ser\xE1 f\xE1cil comprender por qu\xE9 durante milenios ha sido tan inspirador para muchos.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSi bien tanto Tel Aviv como Jerusal\xE9n son dos ciudades ajetreadas, vitales e intrigantes que ofrecen una multitud de atracciones de visita obligada, no podr\xEDan ser m\xE1s diferentes. A pesar de su proximidad geogr\xE1fica, tienen paisajes, olores y sabores completamente diferentes. \xBFEn qu\xE9 otro lugar podr\xEDa combinar tan f\xE1cilmente el mejor destino de playa con una de las ciudades m\xE1s antiguas y sagradas de la historia?\n\t\t\t\t\t\tAs\xED que aqu\xED tiene una muestra de lo que puede hacer durante unas vacaciones en ambas ciudades.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>Tel Aviv \u2013 la ciudad que nunca duerme</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tHa aterrizado en Tel Aviv\u2026Experimente toda la emoci\xF3n que la primera ciudad hebrea tiene preparada. Descubra los deslumbrantes tonos azules del Mediterr\xE1neo, los pintorescos rincones de la Ciudad Blanca, sus mercados, restaurantes, sabores especiales y una animada vida nocturna. Tome algunas olas y entienda exactamente por qu\xE9 Tel Aviv es conocida como la ciudad sin pausa, que respira vitalidad las 24 horas del d\xEDa.\n\t\t\t\t\t\t\xA1Vamos!\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tNeve Tzedek:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tDescubra la magia de este espectacular y bellamente renovado barrio, ubicado en el extremo sur del paseo mar\xEDtimo de Tel Aviv, junto a Jaffa. Comience su ma\xF1ana con una experiencia culinaria que incluye un desayuno t\xEDpico israel\xED: deliciosos productos horneados, huevos, quesos y salsas, ensalada verde o ensalada picada, zumo de naranja y, por supuesto, un excelente caf\xE9. La visita recomendada a Neve Zedek le traslada a monumentos hist\xF3ricos y museos peque\xF1os y maravillosos.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tHatachana:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tTras recargar energ\xEDas, vaya a visitar Hatachana, que est\xE1 en las inmediaciones. All\xED podr\xE1 visitar edificios templarios renovados, as\xED como la antigua estaci\xF3n de tren de Jaffa, completamente restaurada. El lugar cuenta la historia de la estaci\xF3n de tren, con su l\xEDnea Jaffa-Jerusal\xE9n, que oper\xF3 aqu\xED desde 1892 hasta 1948.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tJaffa\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tDespu\xE9s, d\xE9 un paseo por el impresionante paseo mar\xEDtimo de Tel Aviv hasta Jaffa. Recomendamos visitar el puerto de Jaffa, considerado uno de los puertos m\xE1s antiguos del mundo. Rel\xE1jese en uno de los muchos caf\xE9s que salpican el muelle y observe a los pescadores en acci\xF3n. Luego, contin\xFAe hacia el colorido mercadillo, donde podr\xE1 disfrutar de un art\xEDculo vintage, cer\xE1mica armenia, una hamsa o cualquiera de la multitud de recuerdos. Por la noche, el \xE1rea se transforma en una bulliciosa escena de bares y restaurantes.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tPedalee hasta la playa:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tTel Aviv es conocida como la capital de la bicicleta de Israel. En un d\xEDa agradable, aquellos de ustedes con esp\xEDritu deportivo pueden alquilar una bicicleta en una de las estaciones de Tel-O-Fun o en cualquier otro lugar de alquiler de la ciudad. Ir en bicicleta desde Neve Zedek a la playa de Tel Baruch en la parte norte de la ciudad es una experiencia extraordinariamente divertida.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/1/7.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tMuseo Tierra de Israel (Eretz Israel)\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSi se encuentra en la parte norte de la ciudad, le sugerimos que visite el Museo Tierra de Israel. Es un museo multidisciplinar que se enfoca en la historia y la cultura de Israel a trav\xE9s de exhibiciones permanentes y temporales dedicadas a la arqueolog\xEDa, etnograf\xEDa, correos y filatelia, folclore, Judaica, artesan\xEDas tradicionales, arte popular, historia cultural e identidad local.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tBulevar Rothschild\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t\xBFBusca un lugar acogedor donde poder disfrutar de una excelente comida? Pruebe a comer en uno de los restaurantes en o alrededor del Bulevar Rothschild, en el mismo coraz\xF3n de la ciudad y una de las tres zonas que conforman la Ciudad Blanca, reconocida por la UNESCO como Patrimonio de la Humanidad. Esta calle, que define perfectamente la esencia de Tel Aviv, le ofrece una excelente oportunidad para observar a sus gentes. Tambi\xE9n puede dar un paseo y disfrutar de la impresionante arquitectura Bauhaus, el antiguo quiosco y los peque\xF1os museos que relatan la fascinante historia de Tel Aviv y su primer vecindario, Ahuzat Bayit.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tVida nocturna\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSi planea quedarse en la ciudad, puede optar por reservar una habitaci\xF3n en uno de los grandes hoteles ubicados en la playa, cerca del paseo mar\xEDtimo o en uno de los encantadores hoteles boutique. Si todav\xEDa tiene energ\xEDa y est\xE1 deseando ir, ahora es el momento de disfrutar en uno de los populares bares, discotecas, la \xD3pera, un espect\xE1culo de danza o cualquiera de los muchos eventos y festivales en Tel Aviv.\n\t\t\t\t\t\t\xBFHa terminado de probar la buena vida en Tel Aviv? Ahora disfrute de lo mejor de ambos mundos yendo a Jerusal\xE9n. \xA1Est\xE1 a solo 40 minutos! \xA1La Ciudad Santa le espera!\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/1/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tJerusal\xE9n \u2013 la ciudad m\xE1s hermosa del mundo\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tDescubra la ciudad m\xE1s sagrada para tres religiones: juda\xEDsmo, islamismo y cristianismo. Visite los lugares hist\xF3ricos, inhale los olores vertiginosos, pruebe los platos especiales, respire el aire puro de la monta\xF1a y divi\xE9rtase en los muchos lugares de entretenimiento de la ciudad.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tEin Kerem\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tAntes incluso de llegar a la ciudad, puede visitar el pintoresco barrio de Ein Kerem. A solo 20 minutos en coche del centro de la ciudad, es conocido por su car\xE1cter id\xEDlico. Ein Kerem, rodeado de zonas verdes, ofrece impresionantes vistas, encantadoras casas de piedra, iglesias y mezquitas, fascinantes lugares hist\xF3ricos, encantadores callejones, galer\xEDas y boutiques especiales, cafeter\xEDas y restaurantes de calidad, as\xED como exquisitos hoteles, tanto antiguos como nuevos.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tMuseo de Ciencias de Bloomfield\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tEl museo de ciencias de Jerusal\xE9n es un reino m\xE1gico para adultos y ni\xF1os por igual, lleno de objetos en movimiento, ilusiones \xF3pticas, experimentos el\xE9ctricos y de todo aquello que ha hecho de nuestro mundo un lugar m\xE1s f\xE1cil.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tLa Ciudad Vieja\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t\xA1En el Top de cualquier itinerario por Jerusal\xE9n! El casco antiguo de Jerusal\xE9n es, simplemente, un ancestral tesoro escondido para descubrir y deleitarse. La verdadera esencia de Jerusal\xE9n se oculta en los angostos y sinuosos callejones de la Ciudad Vieja: la atm\xF3sfera especial, la fascinante historia y los secretos se revelan entre sus antiguas piedras. Visite el Muro de las Lamentaciones para conmoverse con la santidad de las ruinas del Templo y para colocar una nota con una petici\xF3n al Sant\xEDsimo entre las piedras.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/1/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tEin Kerem\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tEven before reaching the city, you can visit the picturesque neighbourhood  of Ein Kerem. Just a 20-minute drive from the city centre, it is known for its idyllic character. Nestled in greenery, Ein Kerem brings you breathtaking views, charming stone houses, churches and mosques, fascinating historical sites, enchanting alleys, galleries and special boutique shops, cafes and fine restaurants, as well as exquisite hotels, both old and new.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tBloomfield Science Museum\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tJerusalem\u2019s science museum is a magical kingdom for adults and children alike, filled with moving objects, optical illusions, electrical experiments and everything that has made our world a user-friendly place.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tThe Old City\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tAt the top of any Jerusalem itinerary! The Old City of Jerusalem is, simply put, an ancient treasure trove of discovery and delight. The true essence of Jerusalem is hidden in the narrow, winding alleyways of the Old City: the special atmosphere, fascinating history and secrets are revealed among its ancient stones. Visit the Western Wall to be moved by the sanctity of the remains of the Temple and to place a note with a request to the Holy One between the stones.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/1/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSiga los pasos de Jes\xFAs, por la V\xEDa Dolorosa, hasta la Iglesia del Santo Sepulcro, hogar de los dos lugares m\xE1s sagrados del cristianismo: el lugar donde crucificaron a Jes\xFAs de Nazaret y la tumba vac\xEDa, de la cual se cree que resucit\xF3. Contin\xFAe hacia el Monte Si\xF3n, donde podr\xE1 visitar el Cen\xE1culo, que tradicionalmente se considera el sitio donde tuvo lugar la \xDAltima Cena. Luego, como Jes\xFAs hac\xEDa frecuentemente, visite el Monte de los Olivos para un momento de meditaci\xF3n en Getseman\xED, donde Jes\xFAs or\xF3 y sus disc\xEDpulos durmieron la noche anterior a la crucifixi\xF3n. Y suba a la azotea del Hospicio Austriaco de la Sagrada Familia para disfrutar de una vista verdaderamente magn\xEDfica de Jerusal\xE9n y de la Ciudad Vieja.\n\t\t\t\t\t\tPara sumergirse a\xFAn m\xE1s profundamente en las ra\xEDces de la antigua Jerusal\xE9n, recorra los t\xFAneles del Muro de las Lamentaciones, visite la C\xFApula de la Roca, el lugar sagrado donde se cree que Mahoma ascendi\xF3 al cielo, y la Iglesia Luterana del Redentor, hogar de uno de los \xF3rganos m\xE1s bellos de Israel.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tMercado de Mahane Yehuda\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tHa sido un d\xEDa largo. \xBFEmpieza a tener hambre? Ahora puede visitar el mercado de Mahane Yehuda, el bullicioso y vibrante mercado al aire libre de Jerusal\xE9n. Junto a los tradicionales puestos del mercado, muchos caf\xE9s y tiendas gourmet han surgido en los \xFAltimos a\xF1os.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tDe compras por Jerusal\xE9n:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t\xBFListo para algunas compras y souvenirs? Compre cer\xE1micas armenias o judaica en las hermosas y muy especiales tiendas de la Ciudad Viej. Tambi\xE9n encontrar\xE1 comercios que venden una gran cantidad de recuerdos de Israel en el centro de la ciudad. Encontrar\xE1 numerosas tiendas de ropa ubicadas en el paseo Ben-Yehuda. Y no se olvide de visitar las de segunda mano si quiere comprar algo un poco m\xE1s aut\xE9ntico. Adem\xE1s, no se pierda una visita al exclusivo centro comercial Mamila, considerado uno de los m\xE1s activos de la ciudad.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tTan diversas, tan distintas y sin embargo a tan solo un corto viaje la una de la otra, Jerusal\xE9n y Tel Aviv forman el paquete vacacional perfecto. Juntos, le ofrecen historia y modernidad, artefactos antiguos y artes modernas, diversi\xF3n al sol y el viaje m\xE1s espiritual de su vida. \xA1No hay nada mejor que eso! Entonces, \xBFa qu\xE9 espera? \xA1Reserve sus vacaciones ahora!\n\t\t\t\t\t</p>\n\n\n           "};}},{id:"Jerusalem",bgImage:"/posts/bank/jerusalem-p/1.jpg",mobBgImage:"/posts/bank/jerusalem-p/M.jpg",title:"Jerusalem",smltitle:"",isVid:true,vidId:"FvAWuLQEOJw",ctg:"jerusalem",html:function html(){return{__html:"\n\n\t\t\t\t\t<h3>A CITY OF MAGIC AND RADIANCE BEYOND YOUR WILDEST DREAMS</h3>\n\t\t\t\t\t<h3>Jerusalem is The Capital of Israel and By Far One of The Most Famous and Fascinating Cities in the World, Where Thousands of Years of Glorious History Seamlessly Intertwine with Modern Day Life.</h3>\n                              \n                                <p>Discover the overwhelming power of this 3,000 year old city - its innumerable historic sites and archeological wonders, its magical walkways and magnificent views which are guaranteed to leave a lasting impression. At the same time, the city\u2019s strikingly modern attractions promise around the clock excitement and pleasure for all lovers of culture, arts, music, and culinary delights.</p>\n\n                                <h3>Walk through 3000 years of history</h3>\n\n                                <p>The Old City of Jerusalem is a favourite for all visitors from first timers, seasoned visitors as well as the locals. Surrounded by an ancient wall that has been rebuilt throughout history, there are 7 gates allowing access to historical and holy sites here. Make your way down the stone cobbled streets and find yourself walking through four thousand years of history, leaving you humbled and yet excited as you connect the modern day present with the simple beginnings of the past.</p>\n                              \n                                <h3>Meet the modern vibrant Jerusalem</h3>\n\n                                <p>Step outside of the Old City and find everything that a typical modern city offers including hotels, promenades, restaurants and shopping malls. Visit museums, like the Israel Museum which is the largest cultural institution in Israel and ranked among the world\u2019s leading art and archaeology museums housing the infamous Dead Sea Scrolls (oldest biblical manuscripts) among other treasures. Local farms, wineries and breweries are set up around Jerusalem offering a variety of options to foodies ranging from the traditional Israeli cuisine to the contemporary and fusion fare paired with delicious award-winning wines and beers attracting enthusiast from all over the world.</p>\n                                <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/Jerusalem-p/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t    </div>\n                                <p>Visit Mahane Yehuda, a colourful and vibrant outdoor market with an attractive vibe filled with culture and delicious aromas of the delicacies sold here. Wait till sundown and see this \u2018shuk\u2019 transform into a trendy hangout with live music to suit every mood accompanied with energetic people, a growing \u2018street-art\u2019 gallery exceptional food and delightful drinks. Mahane Yehuda offers a special experience so walk down the streets, stop by a food joint, dance a little while enjoying a drink and make your way to the next spot.</p>\n\n                                <p>Drenched in art, history, culture and diversity the capital city of Israel loves to have a good time while allowing one to experience the contrast between old world historical charm and modern city living. As you drive in to Jerusalem you can\u2019t help but connect with the culture, archaeology and history of the many nations who have walked through here, where old meets new beyond the walls of the Old City in this unique world capital.</p>\n                                \n\t\t\t\t\n\n\n           "};}},{id:"Magical_Deadsea",bgImage:"/posts/bank/deadsea1/1.jpg",mobBgImage:"/posts/bank/deadsea1/M.jpg",title:"EL MAR MUERTO",smltitle:"",isVid:true,vidId:"Y2hAOLNcPKU",ctg:"deadsea",html:function html(){return{__html:"\n\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t\t\t<h3>La mente y el cuerpo se elevan en el lugar m\xE1s bajo de la tierra</h3>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<p>Rel\xE1jese en la \"bondad salada\" del mar Muerto</p>\n\t\t\t\t\t\t\t\t<p>Con una belleza natural impresionante, balnearios ricos en minerales calmantes, cualidades curativas demostradas y muchas experiencias \xFAnicas, no es de extra\xF1ar que el mar Muerto</p>\n\t\t\t\t\t\t\t\t<p><strong>Rel\xE1jese</strong>. Sal, barro, sol ... y hay m\xE1s. Sum\xE9rjase en manantiales sulfurosos naturales (calientes) y disfrute de tratamientos de spa. \xBFEst\xE1 familiarizado con la frase \"placer culpable\u201D? No se aplica aqu\xED. Saque \"culpable\" de la oraci\xF3n y simplemente disfrute de unas saludables y revitalizantes vacaciones relajantes.</p>\n                                <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/Magical-Deadsea/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t<p><strong>Flote</strong>. Gracias al excepcional alto nivel de soluci\xF3n salina en el agua, ser\xE1 capaz de realizar un peque\xF1o \"milagro\" y flotar\xE1 sin esfuerzo en el agua. Entre en el agua, recu\xE9stese y deje que la naturaleza siga su curso. Puede tomarle un minuto hasta que se&nbsp; acostumbre, pero entonces, lo prometemos, es m\xE1gico.</p>\n\t\t\t\t\t\t\t\t<p><strong>Sane</strong>. Entrar en la zona del mar Muerto es como entrar en un mundo diferente. Diferentes vistas, diferente ritmo, aire diferente e incluso un sol diferente.</p>\n\t\t\t\t\t\t\t\t<p>Los dos \xFAltimos son los resultados de las condiciones geol\xF3gicas especiales del \xE1rea y las principales razones de sus poderes curativos.</p>\n\t\t\t\t\t\t\t\t<p>La atm\xF3sfera es diferente porque en la soluci\xF3n salina se disuelven minerales ricos y saludables que usted inhala a trav\xE9s del aire. El sol es diferente porque la ubicaci\xF3n, tan por debajo del nivel del mar, debilita y filtra los da\xF1inos rayos UV. Salga y disfrute de los maravillosos regalos de la naturaleza.</p>\n\t\t\t\t\t\t\t\t<h3>Descubra al ni\xF1o en su interior y deje que la naturaleza le cure</h3>\n\t\t\t\t\t\t\t\t<p><strong>Emb\xE1rrese</strong> - El lodo del mar Muerto ha demostrado ser beneficioso para la salud. Mejora, revitaliza y proporciona alivio para su piel. Puede comprarlo y usarlo en casa, pero \xBFpor qu\xE9 perderse la oportunidad de sacar al ni\xF1o que lleva dentro? C\xFAbrase con ese barro negro de pies a cabeza y simplemente divi\xE9rtase. Seguro que se har\xE1 un selfie.</p>\n\t\t\t\t\t\t\t\t                               \n\n\n           "};}},{id:"Next_Level_DS",bgImage:"/posts/bank/1.jpg",mobBgImage:"/posts/bank/M.jpg",title:"TAKE RELAXATION TO THE NEXT LEVEL",smltitle:"",isVid:true,vidId:"Y2hAOLNcPKU",ctg:"deadsea",html:function html(){return{__html:"\n\n\t\t\t\t\t\n\t\t\t\t\t\n                     <p>\n\t\t\t\t\tThe Dead Sea, officially The Lowest Place On Earth (428m Below Sea Level) And A Shortlist Candidate For The World\u2019s 7 Natural Wonders, Is An Enthralling And Evocative Combination Of Natural Splendor, Compelling Ancient History And Modern Luxuries.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tFrom the healing powers of the Dead Sea\u2019s cobalt blue waters, through the awesome beauty of the surrounding landscape to the myriad of fascinating sights this area has to offer, the Dead Sea is a place of tranquility, health and inspiration for body and soul alike.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tFloat on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions. Along the main part of the 75 kilometer stretch dotted with beautiful beaches, you will also find world class hotels and spa facilities to guarantee a truly indulgent experience.\n\t\t\t\t</p>\n\t\t\t\t\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/next-level/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\t\t\t\t<p>\n\t\t\t\t\tThe Magical Beaches of the Dead Sea\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tThe beaches of the Dead Sea are like nothing else the world has to offer. There are many kilometers of beautifully developed and well-maintained spots where you can soak up the sun while on your dream vacation. Choose your spot on the rocky sand and take in the breathtaking scenery with the incredible mountain ranges surrounding the sea. The warm waters of the Dead Sea are always calm and offer superior relaxation from the minute you get in.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tOn the southern shores at the lowest point on earth, you will find an array of hotels where you can enjoy a magical sunrise over the lake, leaving an array of colors on the small ponds with the salt formations scattered throughout. To complete the experience of being at the Dead Sea, take some of the silky dark mud and lather it on allowing your skin to absorb the helpful minerals. Dead Sea mud has been proven beneficial to the skin and body. You will feel refreshed with skin that looks and feels younger. Give yourself the pampering that you deserve and get dirty with the Dead Sea mud \u2013 it\u2019s healthy!\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tDiscover the desert area around the Dead Sea\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tThere is more to do than just relaxing in the spas and floating in the Dead Sea. If you are travelling south from Jerusalem, complement your desert experience by stopping at kibbutz Ein Gedi, a natural oasis on the slopes of the Judean desert, and take a hike through a nature reserve where you will see wildlife like the ibex (a kind of mountain goat) and enjoy the waterfalls and pools cascading on the rock formation. Ein Gedi also offers hotel accommodations and spas which houses hot sulphur pools and have different types of healing and therapeutic massages too. Continue south from here to Masada, a national landmark with a strong historical connection, located at the top of a massive mountain that the adventure seeker can hike, or it can be reached comfortably by cable car.\n\t\t\t\t</p>\n\t\t\t\t<h3>\n\t\t\t\t\tMOUNT KARKOM\n\t\t\t\t</h3>\n\t\t\t\t<p>\n\t\t\t\t\tIn the heart of the western Negev lies a site considered one of the most significant landmarks in Christian history- the mysterious and beautiful Mount Karkom.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tFeaturing a wildly unspoiled landscape - an 847-meter-high limestone plateau scored by dramatic ravines, mount Karkom is believed by some scholars to be the site of the biblical Mount Sinai \u2013 mentioned often in the book of Exodus as the place where Moses received the Ten Commandments.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tWalking down the eight-kilometer-long loop-trail, on the banks of the Karkom dry riverbed are two rows of standing stones and a rounded wall, reminiscent of nomadic shrine of the type built by the Israelites of the time. Looking closely, one can even spot 12 standing stones, believed by some to represent the 12 tribes of Israel.\n\t\t\t\t</p>\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/next-level/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\t\t\t\t<p>\n\t\t\t\t\tAdding to the mystery and appeal, Mount Karkom features many famous rock drawings, depicting worshipping figures, animals and enigmatic symbols.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tTo visit the area Hikers must coordinate tour to the site in advance and use a Society for the Protection of Nature (SPNI) trail map (available in Hebrew only) to explore Mount Karkom.\n\t\t\t\t</p>          \n\n\n           "};}},{id:"Dead_Sea1",bgImage:"/posts/bank/deadsea1/1.jpg",mobBgImage:"/posts/bank/deadsea1/M.jpg",title:"ALEGRÍAS DEL MAR MUERTO",smltitle:"",isVid:false,ctg:"deadsea",html:function html(){return{__html:"\n                         <h3>Para un buen momento flotante</h3>\n                         <p>\n\t\t\tUna maravilla geol\xF3gica en un entorno \xFAnico y sereno, el Mar Muerto es una atracci\xF3n tur\xEDstica sumamente popular. Experimente la calma tranquilidad del agua con sus distintas propiedades curativas mientras disfruta de la incomparable belleza del paisaje circundante. <strong>El Mar Muerto, tambi\xE9n conocido como el spa natural m\xE1s antiguo del mundo, ha sido bendecido con una concentraci\xF3n extremadamente alta de sal del 31.5%, permitiendo a los turistas de todas partes la incre\xEDble experiencia de flotar sin esfuerzo en las aguas del lugar m\xE1s bajo de la Tierra. Mientras est\xE9 aqu\xED, puede embadurnarse</strong> en el saludable barro negro de la zona o explorar los fascinantes e hist\xF3ricamente ricos paisajes cercanos.\n              \t\t</p>\n\n              \t\t<p>\n\t\t\tHoteles de lujo, cocina variada, desde restaurantes gourmet hasta restaurantes de comida r\xE1pida, grandes tiendas de souvenirs, la extraordinaria historia de la cercana Masada y muchas actividades culturales durante todo el a\xF1o, hacen del Mar Muerto un destino popular para turistas locales y visitantes internacionales.\n              \t\t</p>\n\t\t\t\t\t\n\t\t\t\t\t\n                        \n\n\n           "};}},// {
// 	    id:"Eurovision",
//         bgImage : "/posts/bank/1.jpg",
//         mobBgImage : "/posts/bank/M.jpg",
//         title : "Eurovision Tel Aviv",
//         smltitle : "",
//         isVid:false,
//         ctg: "telaviv",
//         html: function(){
// 			return {
// 				__html: `
//                          <h3>Todo un clásico en la ciudad que nunca duerme</h3>
//                          <p>Una oportunidad irrepetible para visitar Tel Aviv durante la celebración del Festival de la Canción de Eurovisión.<br/>
//                             Semifinal 1: 14 de mayo de 2019<br/>
//                             Semifinal 2: 16 de mayo de 2019<br/>
//                             Gran final: 18 de mayo de 2019</p>
//                             <p>¡La cosa se está poniendo interesante en la fabulosa Tel Aviv! La ciudad que nunca duerme se alía con la emoción mientras se prepara para albergar el Festival de la Canción de Eurovisión 2019 en lo que promete ser uno de los eventos más gloriosos que jamás hayan tenido lugar en la famosa ciudad de la fiesta.
//                             <p>Tel Aviv, conocida por su increíble energía, playas impresionantes, un tiempo genial durante todo el año y su gente guapa, es el destino perfecto para una escapada inolvidable. Tel Aviv es también famosa en todo el mundo por su mentalidad abierta y su espíritu liberal, convirtiéndola en la anfitriona ideal para el concurso de canción de Eurovisión, que ofrece a viajeros de todas partes la oportunidad perfecta para disfrutar de esta vibrante y energética ciudad en su mejor momento.
//                             <div class="img-wrapper">
// 								 <img src=${getImgUrl() +  "/posts/eurovision/4.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Importantes producciones que realizar en el mes de mayo, cuando se celebre el concurso de Eurovisión, están ya en camino. Algunos de los eventos planeados incluyen una increíble ceremonia de inauguración, el momento “alfombra roja” e incluso una mega "Euro Villa", que se ubicará a solo unos minutos a pie del impresionante paseo marítimo de Tel Aviv y la playa. La Euro Villa estará abierta durante 10 días e incluirá actuaciones en vivo de súper estrellas del presente y el pasado, así como proyecciones de las semifinales del concurso y de la gran final de Eurovisión. El concurso en sí tendrá lugar en la Expo Tel Aviv.
//                             <p>El Festival de la Canción de Eurovisión en Tel Aviv será sin duda un evento único, así que ¡asegúrese de reservar su viaje ahora al concurso de Eurovisión más increíble hasta el momento, en la ciudad más increíble de todas!
//            `
//     }
//   }
// },
{id:"Tourist_Information",bgImage:"/posts/bank/1.jpg",mobBgImage:"/posts/bank/M.jpg",title:"Información de transporte para turistas",smltitle:"",isVid:false,ctg:"telaviv",html:function html(){return{__html:"\n                                <h3>\n\t\t\t\t\t\t\t\t\tC\xF3mo llegar a Tel Aviv desde el aeropuerto:\n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tLa forma m\xE1s econ\xF3mica de llegar al centro de Tel Aviv desde el aeropuerto de Ben Guri\xF3n es el tren. Sigue las se\xF1ales (la estaci\xF3n est\xE1 junto al aeropuerto) y busca un tren que vaya a Tel Aviv HaHagana (al sur de Tel Aviv), Tel Aviv-HaShalom (en el centro de Tel Aviv), Tel Aviv-Savidor Center (para la zona norte-vieja de Tel Aviv) o Tel Aviv-University (para llegar a Expo Tel Aviv). Hay que tener en cuenta que Tel Aviv HaShalom est\xE1 cerrado los viernes hasta septiembre del 2019.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tUn trayecto de ida cuesta 13,50 NIS (shekalim), y dura unos 25 minutos aproximadamente. Al bajar del tren, se puede coger un taxi al alojamiento. En el taxi, hay que pedirle al conductor que use el tax\xEDmetro (\u201Cmonet\u201D) y tener dinero en efectivo para pagar. Hay otras opciones en las apps de taxis. Para m\xE1s informaci\xF3n y para planificar tu trayecto, visita <a href=\"https://www.rail.co.il/en\" target=\"_blank\">https://www.rail.co.il/en</a> \u2013 (disponible en ingl\xE9s)\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tSi prefieres coger un taxi directamente del aeropuerto a Tel Aviv, hay una parada de taxis a la salida de la terminal. Un trabajador del aeropuerto te preguntar\xE1 el destino, el n\xFAmero de pasajeros, maletas y te dar\xE1 un ticket para dar al conductor. Puedes usar el tax\xEDmetro o aceptar un precio fijo. Los trayectos suelen costar entre 150-170 NIS por persona.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t\t\tC\xF3mo llegar de Tel Aviv a Jerusal\xE9n:\n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t\t\tEn autob\xFAs\n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tDir\xEDgete a la estaci\xF3n central de tren Tel Aviv Savidor y coge el bus n\xBA 480. El trayecto dura unos 45 minutos. La ruta del autob\xFAs finaliza en la estaci\xF3n central de autobuses de Jerusal\xE9n en Jaffa Road. Desde all\xED puedes coger el tranv\xEDa o cualquier otro medio de transporte disponible para llegar a tu destino. \n\t\t\t\t\t\t\t\t</p>\n                \t\t\t\t<h3>\n\t\t\t\t\t\t\t\t\tEn tren\n\t\t\t\t\t\t\t\t</h3>            \n            \t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\xA1Tambi\xE9n puedes coger el nuevo tren! Si quieres ir a Jerusal\xE9n directamente desde el aeropuerto de Ben Guri\xF3n, coge el tren a la estaci\xF3n de Navon de Jerusal\xE9n. El trayecto desde el aeropuerto dura unos 25 minutos. Si viajas desde otras estaciones en Tel Aviv, dir\xEDgete a la estaci\xF3n del aeropuerto de Ben Guri\xF3n y desde all\xED cambia para ir a Navon.\n\t\t\t\t\t\t\t\t</p>            \n\t\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t\t\tC\xF3mo moverte por Tel Aviv\n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t<!--El municipio de Tel Aviv ofrecer\xE1 transporte p\xFAblico gratuito por toda la ciudad durante el fin de semana de Eurovisi\xF3n.\n\t\t\t\t\t\t\t\t\tHabr\xE1 autobuses gratuitos el viernes 17 y s\xE1bado 18 de mayo.-->\n\t\t\t\t\t\t\t\t\tNormalmente los s\xE1bados no hay transporte p\xFAblico en Tel Aviv (aparte de taxis)\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<!--<p>\n\t\t\t\t\t\t\t\t\tPara los dem\xE1s d\xEDas de la semana de Eurovisi\xF3n, necesitar\xE1s una tarjeta Rav Kav: es parecida a la \u201Ctarjeta Oyster\u201D de Londres.  La tarjeta Rav Kav es una tarjeta inteligente que puede recargarse para poder usar los autobuses sin preocuparte por el efectivo. De hecho, ya no se puede pagar en efectivo, as\xED que es muy importante que adquieras una Rav Kav en cuanto llegues a Tel Aviv.\n\t\t\t\t\t\t\t\t</p>-->\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tSe puede adquirir la tarjeta Rav Kav en cualquier autob\xFAs, en cualquier parada, pidi\xE9ndosela.  Cuesta 5 NIS (debes llevar el dinero exacto). Luego, cuando bajes del autob\xFAs, esta tarjeta te sirve para todos los dem\xE1s. Algunos quioscos locales 7/11 ofrecen servicios de recarga para a\xF1adir cr\xE9dito. Con unos 50 NIS es suficiente para una semana, ya que cubre unos 10 trayectos locales (cada trayecto son 5,90 shekels).\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tTambi\xE9n puedes comprar la Rav Kav en las oficinas de Rav Kav en la calle Ibn Gabirol 35, abierta de domingo a jueves de 8:00 a 20:00 y los viernes y v\xEDsperas de festivos de 8:00 a 13:00, o en la estaci\xF3n de tren de Tel Aviv Savidor y Carmelit Central.\n\t\t\t\t\t\t\t\t\tSe puede recargar en cualquier estaci\xF3n de tren.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t\t\tEn bici\n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tTel Aviv est\xE1 adaptada para bicicletas con muchos carriles-bici por toda la ciudad, incluso hay uno que va a lo largo de toda la playa, desde Yafo, al sur, hasta el norte de Tel Aviv y m\xE1s all\xE1. Son unos lugares preciosos para ir en bici mientras disfrutas del ambiente y arquitectura de Tel Aviv. Si tienes un casco de bici, tr\xE1etelo.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t\t\tScooters el\xE9ctricos\n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\xA1Los scooters son muy populares en Tel Aviv! Ofrecen una manera c\xF3moda y divertida de moverte por la ciudad. Hay bastantes empresas. Lo \xFAnico que tienes que hacer es descargarte la app correspondiente, seguir las instrucciones y listo. Cambia tu bolso por una mochila, ya que te ayudar\xE1 con el equilibrio, presta atenci\xF3n al tr\xE1fico y no escuches m\xFAsica cuando montes. Si tienes un casco, es mejor que lo lleves puesto.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t\t\tCaminando\n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tCaminar es una muy buena opci\xF3n tambi\xE9n \xA1el contador de pasos subir\xE1 much\xEDsimo despu\xE9s de unos d\xEDas en la ciudad que nunca para! \xA1Equ\xEDpate con un mapa, una gorra para el sol, una botella de agua y a dominar las aceras!\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t\t\tApps de transporte \n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tHay varias apps de transporte que puedes descargarte antes de llegar para ayudarte a planificar tus trayectos. Busca una de cada categor\xEDa: hay apps para taxis, alquiler de bicis o scooters y apps para planificar los trayectos. Tambi\xE9n puedes pedirle consejo al conserje del hotel o due\xF1o del apartamento para organizar tus rutas.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t\t\tWifi\n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\tTel Aviv tiene una red de WIFI gratuita por toda la cuidad. Busca la red \u201CFree TLV\u201D en tu smartphone. Est\xE1 operativa en 80 ubicaciones de la ciudad. La mayor\xEDa de los bares tambi\xE9n tienen WIFI gratuita a tu disposici\xF3n; pide la contrase\xF1a cuando hagas tu pedido. Los hoteles tambi\xE9n ofrecen WIFI gratuita y puedes pedir la contrase\xF1a cuando hagas el registro.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<a href=\"//visit.tel-aviv.gov.il/move/airport\" target=\"_blank\" class=\"transportation\">Transportation.</a>\n           "};}},{id:"Natures_Glory",bgImage:"/posts/bank/natures-glory/1.jpg",mobBgImage:"/posts/bank/natures-glory/M.jpg",title:"NATURE'S GLORY",smltitle:"",isVid:true,vidId:"M627s8TdaB8",ctg:"deadsea",html:function html(){return{__html:"\n\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t    <p>\n\t\t\t\t\tGet high on life in the lowest place on earth\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tThe Dead Sea, officially the lowest place on earth (428m below sea level) and one the world\u2019s natural wonders, is an enthralling and evocative combination of natural splendor, compelling ancient history, and modern luxuries.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tFloat on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions.\n\t\t\t\t</p>\n\t\t\t\t<h3>\n\t\t\t\t\tNEW BOARDWALK AT THE DEAD SEA\n\t\t\t\t</h3>\n\t\t\t\t<p>\n\t\t\t\t\tJust in time for the Passover and Easter holidays, a new, stone 4k boardwalk and free, accessible public beaches with full facilities have opened in the hotels area of the Dead Sea. The promenade will eventually extend another ten kilometers, to include a total of 16 public beaches, connecting Ein Bokek and Hamei Zohar, along the southern part of the Dead Sea. This is part of a major new leisure and hotel complex that is planned for the region.\n\t\t\t\t</p>\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/natures-glory/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\t\t\t\t<p>\n\t\t\t\t\tVisitors to the Dead Sea - the lowest place on earth and the world\u2019s largest natural spa known for its unique wellness properties since Biblical times \u2013 can now enjoy full access to wide, sandy beaches, walking, jogging, cycling or even taking a Segway along the entire length of the new boardwalk. The new beaches are all free to the public, with facilities that include beach chairs, showers, canopies, sports equipment, children\u2019s playgrounds and more.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tThe beaches are accessible for the disabled, with special wheelchairs and trails that can take visitors right into the waters of the Dead Sea. Special illumination allows tourists and visitors to walk the boardwalk at night, while at the same time enjoying the very special atmosphere at the Dead Sea.\n\t\t\t\t</p>\n                               \n\n\n           "};}},{id:"Natural_Spa",bgImage:"/posts/bank/deadsea1/1.jpg",mobBgImage:"/posts/bank/deadsea1/M.jpg",title:"MAR MUERTO",smltitle:"",isVid:true,// vidId: "8p4qfkneH1c",
vidId:"Y2hAOLNcPKU",ctg:"deadsea",html:function html(){return{__html:"\n\n\t\t\t\t\t<br/>\n\t\t\t\t\t<h3>Si\xE9ntase en la cima del mundo - En el lugar m\xE1s bajo de la Tierra</h3>\n\t\t\t\t    <h3><span>Rel\xE1jese a otro nivel</span></h3>\n\t\t\t\t\t<p>El mar Muerto, oficialmente el lugar m\xE1s bajo de la Tierra (428m por debajo del nivel del mar) y un candidato preseleccionado para las 7 maravillas naturales del mundo, es una fascinante y evocadora combinaci\xF3n de esplendor natural, fascinante historia antigua y lujos modernos.</p>\n\t\t\t\t\t<p>Desde los poderes curativos de las aguas azules cobalto del mar Muerto, a trav\xE9s de la impresionante belleza del paisaje circundante, a un sinf\xEDn de lugares fascinantes que esta zona ofrece, el mar Muerto es un lugar de tranquilidad, salud e inspiraci\xF3n tanto para el cuerpo como para el alma.</p>\n\t\t\t\t\t<p>Flotar en las aguas, tomar un ba\xF1o de barro o ir a explorar. Con 330 d\xEDas soleados al a\xF1o, la zona del mar Muerto est\xE1 llena de atracciones magn\xEDficas, incluyendo balnearios, senderos magn\xEDficos, restaurantes gourmet y de comida r\xE1pida y atracciones cargadas de adrenalina. A lo largo del tramo principal de 75 kil\xF3metros, salpicado de hermosas playas, encontrar\xE1 hoteles de renombre mundial e instalaciones de spa que le garantizar\xE1n una experiencia verdaderamente gratificante.</p>\n                    <div class=\"img-wrapper\">\n\t\t\t\t\t    <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/natural-spa/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>Las playas m\xE1gicas del mar Muerto</h3>\n\t\t\t\t\t<p>Las playas del mar Muerto son \xFAnicas en el mundo. Muchos kil\xF3metros de lugares bellamente desarrollados y bien mantenidos, donde puede tomar el sol en sus vacaciones de ensue\xF1o. Elija un lugar y disfrute del impresionante paisaje con las incre\xEDbles monta\xF1as que rodean el mar. Las c\xE1lidas aguas del mar Muerto son siempre tranquilas y ofrecen m\xE1xima relajaci\xF3n desde el momento en que entra.</span></p>\n\t\t\t\t\t<p>En las costas del sur, en el punto m\xE1s bajo de la tierra, encontrar\xE1 una gran variedad de hoteles donde puede disfrutar de un amanecer inolvidable sobre el lago. Para completar la experiencia, tome un poco del sedoso barro oscuro y&nbsp; permita que su piel absorba los minerales beneficiosos. El lodo del mar Muerto ha sido demostrado cient\xEDficamente como beneficioso para la piel y el cuerpo. Se sentir\xE1 renovado con una piel que se ve y se siente m\xE1s joven. Dese el mimo que se merece y ens\xFAciese con el barro del mar Muerto - \xA1Es saludable!</span></p>\n\n\t\t\t\t\t<h3>Descubra la zona des\xE9rtica alrededor del mar Muerto</h3>\n\t\t\t\t\t<p>Adem\xE1s de &nbsp;relajarse en los balnearios y flotar en el mar Muerto hay mucho m\xE1s que hacer. Si viaja al sur desde Jerusal\xE9n, complemente su experiencia des\xE9rtica parando en el kibutz Ein Gedi, un oasis natural en las laderas del desierto de Judea, y camine a trav\xE9s de una reserva natural donde podr\xE1 ver vida silvestre como el ibex (una especie de cabra de monta\xF1a) y disfrutar de los saltos de agua y piscinas en cascada en la formaci\xF3n rocosa. Ein Gedi tambi\xE9n ofrece alojamiento en hoteles y spas con piscinas calientes de azufre y con diferentes tipos de masajes terap\xE9uticos. Contin\xFAe hacia el sur, hasta Masada, un punto de referencia nacional con una fuerte conexi\xF3n hist\xF3rica, situado en la cima de una gran monta\xF1a que puede subir caminando o c\xF3modamente en telef\xE9rico.</span></p>\t\t\n\n\t\t\t\t\t\n\n\t\t\t\t\t\n                               \n\n\n           "};}},{id:"Natural_Phenomena",bgImage:"/posts/bank/1.jpg",mobBgImage:"/posts/bank/M.jpg",title:"NATURAL PHENOMENA",smltitle:"",isVid:true,vidId:"Y2hAOLNcPKU",ctg:"deadsea",html:function html(){return{__html:"\n\n\t\t\t\t\t\n\t\t\t\t\t\n                        <p>\n\t\t\t\t\t\t\tThe Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth\u2019s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water\u2019s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/natural-phenomena/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t    </div>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tThis is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/natural-phenomena/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t    </div>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tThe Dead Sea is lined with spas, bathing beaches and spa hotels.\n\t\t\t\t\t\t</p>          \n\n\n           "};}},{id:"Masada",bgImage:"/posts/bank/1.jpg",mobBgImage:"/posts/bank/M.jpg",title:"MASADA",smltitle:"",isVid:true,vidId:"XxWa_MNm5x8",ctg:"deadsea",html:function html(){return{__html:"\n\n\t\t\t\t\t\n\t\t\t\t\t\n                    <p>        \t\n\t\t\t\tNext to the Dead Sea is a site that, unlike the rest of the landscape, appears to be part of the Rift Valley cliff but is in fact an oval-shaped flat-topped mesa \u2013 a mountain completely surrounded by a virtually sheer drop. In the days before helicopters and drones, this was about as secure a site as could be found for King Herod to build himself a palace fortress to which he could retire in the case of emergency. (And, as it was adjacent to the Dead Sea it was convenient for a monarch who historians tell us had a \u201Cchronic skin ailment\u201D - possibly psoriasis.) The splendor of Masada was epic. It was also a marvel of engineering that used artificial water courses to channel the desert\u2019s rare rainfall into giant cisterns where, despite the 120\xB0-Fahrenheit heat, they could make and store ice.\n\t\t\t</p>\t\t\t\n\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/masada/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t    </div>\n\t\t\t<p>\n\t\t\t\tAfter Herod\u2019s death the site was all-but abandoned\u2026until the year 73. After the Romans destroyed Jerusalem in 70 and expelled Jews from their holy city, a group of Jewish refugees made their way to the summit of Masada and converted the once grand palace into their home. Having no interest in the palace\u2019s grandeur and considering themselves zealots, the refugees built a synagogue, created a mikveh, planted crops and tended goats. The Romans, however, could not tolerate their defiance and went on to besiege the mountain for three years, condemning thousands of legionnaires to camp in the extreme heat in a quest to starve the mountaintop inhabitants into surrender. (The outlines of the Roman encampments are clearly visible to this day.) Thousands of Jewish slaves were forced to build a giant ramp to the summit and after the months it took to complete the  construction, the mountaintop zealots -- realizing that the next day would bring Roman soldiers into their hideout -- determined to commit mass suicide rather than have their their wives, children and themselves murdered or enslaved. When the Romans finally battered their way onto the mountaintop they met no resistance and discovered 960 corpses. Two women who had hidden themselves from the mass suicide shared details of the events with the \u201Cconquerors\u201D and Jewish Roman historian, Josephus, told the story of Masada in his book \u201CThe Jewish Wars.\u201D The pledge by the zealots\u2019 leader, Elazar Ben Yair on the last night of freedom has entered immortality: \u201CSince we long ago resolved never to be servants to the Romans, nor to any other than to God Himself, Who alone is the true and just Lord of mankind, the time is now come that obliges us to make that resolution true in practice...We were the very first that revolted, and we are the last to fight against them; and I cannot but esteem it as a favor that God has granted us, that it is still in our power to die bravely, and in a state of freedom.\u201D The Byzantines built a church atop Masada in the 4th-century, but it and the mountain went on to be abandoned for centuries.\n\t\t\t</p>\n\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/masada/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t    </div>\n\t\t\t<p>\n\t\t\t\tIn 1964. Israel\u2019s Professor Yigal Yadin lead a two-year international excavation to discover Masada\u2019s secrets. Their hundreds of discoveries support Josephus\u2019 history, with the archeologists even finding the clay tokens on which the zealots had carved names and used as lots to decide who would \u201Ceuthanize\u201D their families and themselves first\u2026and last.\n\t\t\t</p>\n\t\t\t<p>\n\t\t\t\tThe story of what occurred two millennia ago atop Masada has become a symbol of Israelis\u2019 commitment never to allow \u201CMasada to fall again\u201D and, fifty years after the excavation, Masada is, after Jerusalem, the most visited site in Israel. Access to the summit on foot is possible up the traditional snake path used by Herod, and up the Roman ramp.  But the majority of the millions of tourists who visit Masada are whisked from the Masada Museum and Visitors Center to the summit in giant cable cars that operate daily with the exception of Yom Kippur. Every June, the base of Masada becomes the site of giant Opera Festival and spectacle that uses the floodlit mountain as a backdrop.\n\t\t\t</p>          \n\n\n           "};}},{id:"Tel_Aviv",bgImage:"/posts/bank/telaviv-p/1.jpg",mobBgImage:"/posts/bank/telaviv-p/M.jpg",title:"TEL AVIV",smltitle:"",isVid:true,vidId:"I9a4BFWO_6w",ctg:"telaviv",html:function html(){return{__html:"\n\t\t\t                    <p>Hailed as \u2018The Mediterranean Capital of Cool\u2019 By the New York Times and among Lonely Planet\u2019s \u2018Top 10 Action-Packed Cities\u2019, Tel Aviv is without a doubt THE place to visit in the Mediterranean.</p>\n\t\t\t\t\t\t\t\t<p>Named by The New York Times \"The Mediterranean Capital of Cool\", Tel Aviv is a modern, vibrant cosmopolitan. Buzzing art scene, UNESCO recognized Bauhaus architecture, award-winning cuisine, world-class nightlife, friendly laid-back atmosphere and gorgeous beaches all earned the city its rightful place as one of the world's top travel destinations.</p>\n\n                                <p>But even in the city that has it all, there is only one place to start - the beach.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/telaviv-p/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t<h3>Discover the Heart of a Sizzling City</h3>\n\n                                <h3>What.</strong> The heart of the city National Geographic called \"Miami beach of the Mediterranean\" and included in its top 10 world's best Beach Cities list, is its coastline.</p>\n\n                                <h3>Why.</strong> Sandy beaches, warm waters, plenty of watersports opportunities and great weather, need we say more? Tel Aviv coastline is comprised of 13 unique beaches that each gives different view and offers a different experience. From the busy and trendy to the chill and laid-back, together they form a rich, colorful tapestry of this exciting and diverse city.</p>\n\n                                <h3>Where.</strong> Located at the western edge of the city, in Tel Aviv you're always one step away from the beach. No need to resist the temptation. Just cross the street, take off your shoes and start having fun.</p>\n\n                                <h3>Choose your own Beach Adventure</h3>\n\n                                <h3>Get Active.</strong> Beach and watersports are very popular in Tel Aviv. Surfing, sailing, rowing, swimming, Supping, diving, volleyball \u2013 the list of possibilities goes on and on.</p>\n\n                                <p>Choose your favorite activity and enjoy. Then, when you the click-clock sound of the Matkot on the beach, join the masses in this hugely popular Israeli paddle ball game. There are no winners or losers here, but it's still fun\u2026and very addictive.</p>\n\n                                <h3>Sign up</strong> for the SAIL TLV sailing tournament that takes place in the spring and includes sailing yachts, motor yachts and motor boats from all around the world. Enjoy the sports activities and the wonderful embracive community.</p>\n\n                                <p>Want more? Join the locals and bike, walk or jog on the promenade.</p>\n\n                                <h3>Get Social.</strong> Build castles in sand with your family, take your dog for a walk and mix with the friendly diverse crowd.</p>\n\n                                <h3>Get Chilled.</strong>  Want to slow down and relax? No problem! Find a quiet spot in one of the less crowded beaches, watch (or join) the drum circles and sit at one of the restaurants along the coast. In the afternoon, get close to the water, grab a chair, sit back and watch one of those beautiful Tel Aviv sunsets. It doesn't get better than this.</p>\n            \t      \n\n\n           "};}},{id:"Simply_Delicious",bgImage:"/posts/bank/simply-delicious/1.jpg",mobBgImage:"/posts/bank/simply-delicious/M.jpg",ctg:"culinarytelaviv",isVid:true,// vidId: "3wmvk3SknxA",
// vidId: "yFfkbHHWIc4",
vidId:"JQD9JpMaw9g",title:"Tel Aviv – Simplemente delicioso",smltitle:"",html:function html(){return{__html:"\n                    <br/>\n                    <h3>Cientos de espectaculares restaurantes, incre\xEDbles delicias de mercado y estupenda comida callejera</h3>\n                    <p> \n                       Un paraiso para los amantes de la comida <br/> Echa un vistazo a la impresionante escena culinaria de Tel Aviv\n                    </p>\n\t\t\t\t\t<p>\n\t\t\t\t\tSi eres un entusiasta de la comida (y seamos sinceros, la mayor\xEDa de nosotros lo somos) simplemente\n            tienes que probar un poco de Tel Aviv.\n\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t  \tLos chefs israel\xEDes se han hecho famosos en todo el mundo por sus platos innovadores, y la escena\n            culinaria de Tel Aviv est\xE1 en pleno auge.</p>\n            <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/simply-delicious/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t<p>\n\t\t\t\t    \tCon alrededor de 4500 Restaurantes, Tel Aviv es la verdadera meca de los amantes de la comida. Muchos de los restaurantes son propiedad de brillantes chefs aclamados a nivel mundial, que se formaron y trabajaron en algunos de los mejores establecimientos del mundo antes de regresar a Israel para poner su marca \xFAnica en la escena culinaria local.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t   La cocina de Tel Aviv tiene para todos los gustos. Nombrado como un \"destino vegano superior\" por el sitio web foodie de los EE. UU., The Daily Meal, Tel Aviv tiene alrededor de 400 restaurantes veganos. Querr\xE1 probar los excelentes platos tradicionales de comida callejera como Falafel y Hummus y tambi\xE9n la variedad de delicias en los mercados locales. Para una experiencia culinaria fant\xE1stica, no se pierda los restaurantes de moda en el puerto de Tel Aviv, en la avenida    Rothschild, en Neve Tzedek o en el complejo Tachana, recientemente renovado.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t    Algunas de las cocinas m\xE1s vanguardistas de la ciudad se pueden encontrar en Sarona Market, originalmente una Colonia Templaria alemana. Este mercado de 8.700 m2 ha sido meticulosamente restaurado y ahora alberga 91 tiendas de todas las categor\xEDas, puestos y restaurantes, donde puede experimentar platos nuevos que no solo son deliciosos, sino tambi\xE9n excepcionalmente originales.\n\t\t\t\t\t</p>\n\t\t\t\t\t\n\t\t\t\t\t\n\n         "};}},{id:"TLV_Culinary_Offer",bgImage:"/posts/bank/culinary-offer/1.jpg",mobBgImage:"/posts/bank/culinary-offer/M.jpg",ctg:"culinarytelaviv",isVid:true,vidId:"yFfkbHHWIc4",title:"LA OFERTA CULINARIA DE TEL AVIV",smltitle:"",html:function html(){return{__html:"\n                    <br/>\n                    <h3>La oferta culinaria de tel aviv: un regalo para los sentidos. Saboree la ciudad de Tel Aviv</h3>\n                   \n            \n\t\t\t\t\t\t\t    <p><strong>Tel Aviv</strong>, la ciudad que nunca duerme en la costa del mar Mediterr\xE1neo, es uno de los principales destinos de viaje del mundo. Vibrante, llena de acci\xF3n y divertida, la segunda ciudad m\xE1s grande de Israel lo tiene todo, incluida una escena culinaria creativa, moderna y galardonada que se ajusta a todas las preferencias y presupuestos. Desde sofisticados y modernos restaurantes gourmet hasta simples restaurantes tradicionales locales. Incluso fue votada como uno de los principales destinos para los viajeros veganos. S\xED, amantes de la buena comida, Tel Aviv es el lugar ideal para usted.</p>\n\t\t\t\t\t\t\t\t<p><strong>Al aire libre</strong>. Los habitantes de Tel Aviv adoran estar fuera. Siempre hay algo nuevo y emocionante sucediendo en la ciudad y eso incluye comida. \xBFQuiere explorar la escena culinaria de Tel Aviv? Comience simplemente saliendo. Vaya a una de las bulliciosas calles principales de Tel Aviv como <strong>Dizengoff</strong> e <strong>Ibn Gabirol</strong> y d\xE9jese maravillar. Los mejores caf\xE9s, restaurantes, bares, delicatesen y comida callejera est\xE1n justo debajo de sus pies.</p>\n\t\t\t\t\t\t\t\t<p><strong>Saboreando los mercados</strong>. Visite el <strong>mercado Carmel</strong>, el mercado m\xE1s grande y m\xE1s c\xE9ntrico y popular de la ciudad. Vaya al para\xEDso de comida gourmet y de especias, <strong>el mercado Levinsky,</strong> al sur de la ciudad. Consejo: t\xF3mese su tiempo. Algunas de las joyas culinarias de la ciudad est\xE1n escondidas en el interior de estas calles.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/culinary-offer/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t<p><strong>Local e internacional</strong>. Con inmigrantes de m\xE1s de 120 pa\xEDses, no es de extra\xF1ar que Tel Aviv sea un gran crisol (literalmente). Si la comida \xE9tnica para usted significa comida japonesa, tailandesa o india, aqu\xED hay un t\xE9rmino mucho m\xE1s amplio. Turca, marroqu\xED, persa, yemenita, et\xEDope, georgiana y la lista contin\xFAa.</p>\n\t\t\t\t\t\t\t\t<p>A\xFAn as\xED, Tel Aviv tambi\xE9n se enorgullece de la cocina local que se inspira en esta abundancia de cocinas internacionales y da un giro a los platos tradicionales. El resultado es delicioso y verdaderamente original. Visite el <strong>mercado de agricultores del puerto de Tel Aviv</strong> y el <strong>Mercado Sarona</strong> para probar algunos de los mejores alimentos que Tel Aviv tiene para ofrecer.</p>\n\t\t\t\t\t\t\t\t<p><strong>Sofisticado, refinado e innovador</strong>. No es un secreto que muchos de los mejores restaurantes de fama mundial de Israel se pueden encontrar en Tel Aviv. Los cocineros creativos y aventureros que experimentan con comida cl\xE1sica de Oriente Medio, el este de Asia y Europa convirtieron a Tel Aviv no solo en un centro de cocina gourmet en Israel, sino tambi\xE9n en un centro internacional. Inteligente y est\xE9ticamente impresionante, hacen uso de los ingredientes locales m\xE1s frescos: esta experiencia culinaria es algo que no olvidar\xE1.</p>\n\t\t\t\t\t\t\t\t<p><strong>Vegetariano y vegano</strong>. A diferencia de muchos lugares del mundo, pasar una semana (o m\xE1s) libre de carne y l\xE1cteos es muy simple. Encontrar\xE1 f\xE1cilmente comida r\xE1pida, \xE9tnica y gourmet. Encontrar\xE1 panader\xEDas, delicatesen, restaurantes con men\xFA vegetariano completo, as\xED como restaurantes \"amigables\" que ofrecen muchas opciones vegetarianas y veganas. Es fresco, sabroso e innovador.</p>\n\t\t\t\t\t\t\t\t<p>Lo que comenz\xF3 hace unos a\xF1os como otra tendencia, se convirti\xF3 en una de las principales caracter\xEDsticas de la escena culinaria de Tel Aviv. Dio paso a diversas influencias gastron\xF3micas y la impresionante variedad de verduras de los mercados, as\xED como refleja la conciencia altamente ambiental de la poblaci\xF3n de Tel Aviv.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\n\n         "};}},{id:"Nonstop_Excitement",bgImage:"/posts/bank/35/1.jpg",mobBgImage:"/posts/bank/35/M.jpg",title:"Emoción Sin Fin",// vidId_post : "88OV6xU0vPI",
vidId:"Iyziun92P5A",isVid:true,smltitle:"",ctg:"telaviv",html:function html(){return{__html:"\n\t\t\t\t<br/>\n                    <h3>Hermoso, colorido y emocionante - Incre\xEDble Tel Aviv</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tBienvenido a la ciudad que irradia vitalidad las 24 horas del d\xEDa, una ciudad feliz y vibrante que te acoge con los brazos abiertos. \xBFQu\xE9 tiene Tel Aviv que hace que los visitantes se enamoren de ella y vuelvan a por m\xE1s? Tel Aviv es conocida como la \"ciudad sin pausa\" de Israel, y realmente lo es. Los caf\xE9s est\xE1n a rebosar d\xEDa y noche. Su incomparable vida nocturna comienza al atardecer y se alarga hasta el amanecer.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\tY, lo que es m\xE1s, con un clima excelente casi todo el a\xF1o no importa cuando se visite, lo m\xE1s probable es que pueda disfrutar de la playa, dar un paseo o montar en bicicleta por el Parque Yarkon, visitar los dos antiguos puertos de la ciudad o simplemente disfrutar del placer de recorrer las calles de la primera ciudad israel\xED, donde puede disfrutar de una fascinante combinaci\xF3n de edificios hist\xF3ricos junto a proyectos nuevos y modernos. Y, por si fuera poco, la vibrante ciudad tambi\xE9n ofrece una gran variedad de eventos culturales y de entretenimiento para todas las edades.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t    Descubra por qu\xE9 Tel Aviv fue nombrada por National Geographic una de las 10 mejores ciudades de playa del mundo. Descubra por qu\xE9 fue calificada como un Destino Culinario Excepcional por la revista gourmet Sauver y reconocido como \"sobresaliente\" en la categor\xEDa Mejores Mercados y Tiendas. Es m\xE1s, Pastel Brasserie fue votado como el restaurante m\xE1s hermoso del mundo en 2014 por los premios International Space Design Awards. \xBFEs usted un aficionado al caf\xE9? Huffington Post coron\xF3 a esta moderna ciudad costera como una de las mejores ciudades del mundo para los amantes del caf\xE9. Impresionante, \xBFverdad? Pero a\xFAn no hemos terminado ...\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Tel Aviv venci\xF3 a otras 250 ciudades para llevarse a casa el <a href=\"//www.smartcityexpo.com/awards-2014\" target=\"_blank\"> Premio World Smart Cities Award 2014 </a>, gracias a su uso de la tecnolog\xEDa innovadora para beneficiar a sus residentes. Seg\xFAn Lonely Planet, <a href=\"//www.israel21c.org/tel-aviv-named-worlds-third-top-city/\" target=\"_blank\"> la urbe ocupa un lugar destacado en la lista de las ciudades con mejor vida nocturna del mundo </a>. Y <a href=\"//www.jpost.com/LifeStyle/Tel-Aviv-named-worlds-best-gay-city-for-2011\" target=\"_blank\"> Tel Aviv est\xE1 orgullosa de ser nombrada la mejor ciudad gay del mundo por GayCities </a> y American Airlines.\n\t                  <br>\n\t                 \t \xBFEst\xE1s planeando disfrutar en Tel Aviv? Aqu\xED tiene algunas recomendaciones que ayudar\xE1n a hacer de sus vacaciones un \xE9xito rotundo.\n\t                </p>\n\n\t                <h3>\n\t                \tLas playas\n\t                </h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\t\xA1La vida es una playa! A lo largo de toda la longitud de Tel Aviv-Jaffa, a orillas del Mediterr\xE1neo, se encuentran 13 playas que se extienden m\xE1s 14 kil\xF3metros. Estas playas, perfectas para nadar, divertirse y descansar, atraen a miles de visitantes locales y extranjeros. La temporada de playa va de mayo a octubre, pero incluso en invierno podr\xE1 disfrutar de muchos d\xEDas c\xE1lidos y encantadores en Tel Aviv. Los restaurantes, clubes y numerosos lugares de entretenimiento en el extenso paseo son un gran atractivo para todos los visitantes. Tambi\xE9n puede disfrutar de una amplia gama de deportes acu\xE1ticos.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/2/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tPuertos\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tTel Aviv alberga dos puertos ancestrales. Al visitarlos, quedar\xE1 impactado por la forma \xFAnica en que estos lugares fusionan pasado y presente, mientras usted celebra el d\xEDa (y la noche) en los numerosos clubes, restaurantes o cafeter\xEDas con vistas a los deslumbrantes tonos azules del mar Mediterr\xE1neo.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tPuerto de Tel Aviv\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tConstruido en 1938, el puerto se ha convertido en un punto de entretenimiento abierto al p\xFAblico en general. El espacio de 14 000 m2, con su cubierta de madera caracter\xEDstica, est\xE1 salpicado de bares, discotecas, cafeter\xEDas, restaurantes y tiendas. Es una atracci\xF3n obligada para cualquiera que busque una experiencia culinaria variada y deliciosa, compras y entretenimiento. Y por si eso no fuera suficiente, no encontrar\xE1 puestas de sol m\xE1s impresionantes en ning\xFAn otro lugar. As\xED que venga a disfrutar de la fresca brisa del mar. Al anochecer, el puerto se transforma en uno de los distritos de entretenimiento m\xE1s demandados de la ciudad y est\xE1 lleno de gente.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tPuerto de Jaffa\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tConsiderado uno de los puertos m\xE1s antiguos del mundo, pescadores, marineros, mercaderes, cruzados, conquistadores e inmigrantes dieron uso al Puerto de Jaffa durante miles de a\xF1os. Hoy en d\xEDa, el mismo contin\xFAa siendo utilizado como un puerto pesquero, y tambi\xE9n se est\xE1 renovando como atracci\xF3n urbana que ofrece actividades culturales y de ocio, compras y turismo, a la vez que se conserva su car\xE1cter hist\xF3rico y fascinante \xFAnico.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/2/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tVida nocturna\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tLos noct\xE1mbulos pueden disfrutar de los modernos bares y discotecas de la ciudad, y experimentar la variada vida nocturna que ofrece la ciudad sin pausa. Una noche t\xEDpica en Tel Aviv comienza a las 11 de la noche y, en algunos lugares, puede extenderse hasta el amanecer. La ciudad tambi\xE9n ofrece numerosos clubes para la comunidad gay.\n\t\t\t\t\t\tAlgunos de los lugares de moda en los que  puede bailar toda la noche son:\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tHaoman 17\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tEste es el mayor y m\xE1s consolidado mega-club de Tel Aviv. Alberga a algunos de los mejores DJ de todo el mundo.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t    Dizengoff Club\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Con tres barras bien surtidas, pista de baile, \xE1reas de descanso, salas VIP y m\xE1s, Dizengoff Club atrae una multitud a la moda. Baile m\xFAsica rock, comercial, disco, funk o cualquier otra cosa que pueda estar sonando.\n\t\t\t\t\t</p>\n\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t    Kuli Alma\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Uno de los clubes alternativos m\xE1s populares de la ciudad. Las paredes est\xE1n cubiertas con arte callejero y videoarte. Cuenta con exposiciones de artistas locales en el espacio de la galer\xEDa y tiene un agradable patio al aire libre, donde se puede tomar una copa, comer algo y relacionarse.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t    The Cat and Dog\n\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Un club underground situado en la zona de Carlebach que cuenta con m\xFAsica ecl\xE9ctica, bebidas que fluyen libremente y una pista de baile muy concurrida. Es sin duda uno de los lugares \xE1lgidos en la escena nocturna de Tel Aviv.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t    The Block\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Ganador de numerosos premios, incluyendo Mejor Club del A\xF1o y Mejores Fiestas del A\xF1o, y calificado por la BBC Radio 1 como poseedor de \"uno de los cinco mejores sistemas de sonido del mundo\", merece la pena visitarlo.\n\t\t\t\t\t</p>\n\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Y si andas buscando la experiencia del bar homosexual...\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t    Apolo Sexy Bar\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    \xDAnico bar gay en Tel Aviv exclusivo para hombres, el Apolo se inspira en los mejores clubes de Europa.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Amazona\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Es el mejor bar l\xE9sbico de Tel Aviv, con una gran atm\xF3sfera.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/2/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Mercados\n\t\t\t\t\t</h3>\n\t\t\t\t\t<h3>\n\t\t\t\t\t    Mercado del Carmel\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   El mercado mejor consolidado y m\xE1s famoso de la ciudad que, aparte del color de su mosaico humano sin igual, tambi\xE9n ofrece una variedad infinita de delicias, especias, comidas y otras tentadoras y encantadoras opciones. El mercado posee una actividad fren\xE9tica durante todo el a\xF1o. Y adem\xE1s de por los clientes habituales, es visitado por turistas extranjeros que aprovechan al m\xE1ximo esta experiencia de compra \xFAnica de Oriente Medio.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Mercado de Levinsky\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Un torbellino de panader\xEDas, comercios especializados, restaurantes y tiendas que venden especias, frutos secos, fruta deshidratada y alimentos ex\xF3ticos. Puede inscribirse en recorridos culinarios del mercado aderezados con historias, leyendas y secretos del mercado hist\xF3rico y del nuevo. El car\xE1cter \xFAnico del Levinsky lo convierte en una atracci\xF3n tanto para locales como para turistas.\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Mercadillo de Jaffa\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Situado en Jaffa, el famoso mercadillo ofrece art\xEDculos para el hogar, ropa de segunda mano y zapatos. Junto con las antig\xFCedades, la decoraci\xF3n del hogar y los muebles vintage, el mercado tambi\xE9n alberga cafeter\xEDas de moda, restaurantes que sirven solo el hummus y las habas m\xE1s aut\xE9nticos, y una bonanza de art\xEDculos del pasado.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Mercados gastron\xF3micos\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   En los \xFAltimos a\xF1os, se han abierto tres mercados gastron\xF3micos en Tel Aviv: Shuk HaNamal en el puerto de Tel Aviv, el Mercado de Sarona en Sarona y Shuk Tzafon en Ramat Hahayal, que ofrecen a los visitantes una experiencia que tentar\xE1 sus sentidos. Los mercados ofrecen productos frescos y excelentes materias primas que sirven para aquellas personas que aprecian la comida m\xE1s exquisita, fresca y deliciosa.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t    Mercado de Arte y Artesan\xEDa en el centro comercial peatonal Binyamin de Nahalat\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Un mercado que est\xE1 abierto los martes y viernes, decorando la calle con un abanico de colores. Paseando entre los puestos, puede encontrar una gran cantidad de ideas y regalos creativos y originales que no se encuentran en las tiendas, por ejemplo joyas de colores, papel mach\xE9, pinturas al \xF3leo, juguetes de madera, relojes de pared decorativos, figuritas de cristal en miniatura, Hamsas, mu\xF1ecas o art\xEDculos para el hogar.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/2/5.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t    Restaurantes\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    \xA1Tel Aviv es un para\xEDso gastron\xF3mico! M\xE1s all\xE1 del falafel y el shawarma, la ciudad est\xE1 llena de bares gourmet con los mejores chefs del pa\xEDs al frente y encantadoras cafeter\xEDas que sirven comidas ligeras y excelente caf\xE9. Junto con los establecimientos que tienen pr\xE1cticamente cualquier cosa y de todo en sus men\xFAs, Tel Aviv tambi\xE9n tiene muchos restaurantes y caf\xE9s Kosher, as\xED como excelentes lugares vegetarianos y veganos.\n                        Aqu\xED tiene algunas opciones excelentes para una comida deliciosa.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t   MIZLALA\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Este restaurante ofrece a los comensales platos inspirados por la creatividad y la pasi\xF3n del chef Meir Adoni. Situado en el elegante Binyamin de Nachalat en un edificio Bauhaus bellamente restaurado, Mizlala est\xE1 repleto de energ\xEDa vibrante y ofrece una experiencia culinaria inolvidable.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Topolopompo\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   El restaurante drag\xF3n de fuego del chef Avi Conforti y su particular arquitectura ofrece sabores, aromas y sensaciones que provienen del trabajo con fuego y especias. Una velada en el establecimiento es, como lo describe el chef, caliente, sexy y emocional. Una visita obligada.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Abraxas Norte (Tzfon Abraxas)\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    El famoso chef local Eyal Shani, sirve platos innovadores, inteligentes, deliciosos e inspiradores. Un lugar de moda que cuenta con una cocina abierta, Abraxas le permite saborear el ambiente junto con la comida, mientras observa al equipo de cocineros y su energ\xEDa contagiosa.\n                        <br> Y si la cocina vegetariana o vegana es m\xE1s lo suyo \u2026\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Hashwarma Hativonit\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Ampliamente considerado como uno de los mejores restaurantes veganos en Tel Aviv de comida callejera, disfrute de hamburguesas veganas, perritos calientes veganos, sin olvidar el shawarma vegano.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Nanuchka\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Sirve un delicioso men\xFA vegetariano georgiano en un entorno con suelos antiguos y obras de arte de algunos de los mejores artistas de Israel. El men\xFA es tan original y tan delicioso que incluso los carn\xEDvoros m\xE1s ac\xE9rrimos no echar\xE1n de menos la carne.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t  Buddha Burgers\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Un popular restaurante de comida r\xE1pida vegana que cuenta con un ambiente acogedor, precios asequibles y una amplia selecci\xF3n de platos, incluyendo hamburguesas, perritos calientes, shawarma y burritos.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t  Zakaim\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Se califican a si mismos como una boutique vegana, con una tarifa de mercado de agricultores, y donde todos los platos est\xE1n hechos con ingredientes locales y de temporada.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t  Tenat\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Denominado uno de los mejores restaurantes veganos en Tel Aviv por la Gu\xEDa Secreta de Tel Aviv, Tenat sirve un men\xFA et\xEDope totalmente vegetariano y sin gluten.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/2/6.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t  Cultura\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  Si usted es un aficionado al arte y la cultura, eche un vistazo a algunos de los muchos museos y galer\xEDas de arte repartidos por la ciudad.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t  Museo de Artes de Tel Aviv\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  El principal museo de la ciudad para el arte israel\xED e internacional contiene colecciones permanentes junto con exposiciones rotativas, y exhibe las mejores pinturas, esculturas, dise\xF1o y arquitectura, videograf\xEDa, dibujos y mucho m\xE1s.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t  Beit Hatfusot, el Museo del Pueblo Jud\xEDo\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  Beit Hatfutsot es una de las principales instituciones del mundo involucradas en la investigaci\xF3n del juda\xEDsmo y tambi\xE9n se considera el primer museo en explorar la historia y los logros del pueblo jud\xEDo. Una visita al museo es una experiencia jud\xEDa conmovedora, y permite echar un vistazo a fascinantes exhibiciones que presentan las importantes historias y eventos de la di\xE1spora jud\xEDa a lo largo de la historia.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  Tel Aviv le ofrece todo lo que una gran ciudad de vacaciones debe tener: mar y sol, amplias posibilidades de descanso y relajaci\xF3n junto a una vibrante escena cultural y excelente gastronom\xEDa, compras y una vitalidad insuperable. Con vuelos directos desde Madrid y Barcelona descubra exactamente qu\xE9 hace que las personas se entusiasmen con Tel Aviv.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/2/7.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t  Eventos anuales\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  \xA1Tel Aviv no se detiene aqu\xED! Ofrece eventos deportivos, culturales y de entretenimiento anuales. Le recomendamos que consulte las fechas por Internet. Aqu\xED tiene algunos eventos que recomendamos encarecidamente:\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t  La Noche en Blanco de Tel Aviv\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Una noche especial que se celebra una vez al a\xF1o. En esta noche, hay conciertos, fiestas, actuaciones en la calle, obras de teatro y m\xE1s, todo hasta altas horas de la noche. Los lugares del arte y la cultura de la ciudad permanecen abiertos, junto con los comercios y varios clubes. La mayor\xEDa de los eventos de la Noche en Blanco est\xE1n abiertos al p\xFAblico, ya sea de forma gratuita o por un precio de entrada m\xEDnimo.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t  Festival Open House:\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    El festival incluye una selecci\xF3n de extraordinarias visitas y tours a las casas y edificios m\xE1s fascinantes de la ciudad, la mayor\xEDa de los cuales nunca han sido abiertos al p\xFAblico.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t  Night Run Tel Aviv\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  Esta carrera de 10K atrae a miles de corredores y decenas de miles de espectadores entusiastas que vienen a ver esta incre\xEDble y alegre celebraci\xF3n. El final de la carrera est\xE1 marcado por una gran fiesta de ritmo y m\xFAsica en Ganei Yehoshua.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t  Desfile del Orgullo Gay en Tel Aviv\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  Un evento anual que se celebra cada mes de junio en Tel Aviv, una ciudad que se ha convertido en uno de los destinos gay m\xE1s populares del mundo. El desfile comienza con un emocionante evento en Meir Park, con discursos, desmesuradas actuaciones drags y mucho m\xE1s. Al terminar, el desfile comienza a abrirse paso a trav\xE9s de las principales calles, acompa\xF1ado de m\xFAsica excepcional, bandas desfilando, muchos participantes y decenas de miles de espectadores. El desfile culmina con una gran fiesta en la playa Charles Chlor. Pero eso no es todo ... Los eventos del orgullo contin\xFAan a trav\xE9s de docenas de fiestas por toda la ciudad.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t  Festival de Innovaci\xF3n DLD:\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  DLD Tel Aviv Digital Conference es la mayor reuni\xF3n global de innovadores y emprendedores de Israel, con cientos de empresas de nueva creaci\xF3n, capitales riesgo, inversores \xE1ngel y multinacionales l\xEDderes. Haciendo gala del mejor talento tecnol\xF3gico, las mayores inversiones de capital de riesgo per capita y de centros multinacionales para l\xEDderes de la industria como Intel, Google, Microsoft, Kimberly Clark, Amazon, GM, Amdocs, Facebook y otros, \xA1Tel Aviv es la mejor ubicaci\xF3n para conocer de cerca y en persona el hub de alta tecnolog\xEDa! El festival comprende numerosos eventos, conferencias, reuniones, confluencias y encuentros, todos enfocados en diferentes aspectos de la innovaci\xF3n digital, tecnol\xF3gica, social y urbana. \n\t\t\t\t\t</p>\n\n         "};}},{id:"Vegan_Friendly_TelAviv",bgImage:"posts/bank/8/1.jpg",mobBgImage:"posts/bank/8/M.jpg",title:"TEL AVIV EL MEJOR DESTINO VEGANO DEL MUNDO",ctg:"culinarytelaviv",isVid:true,// vidId: "prLvetkAWwg",
// vidId: "Gl-YB8qK5WI",
vidId:"9l04RfZ95J0",smlTitle:"",html:function html(){return{__html:"\n                   <h3>Explorar Tel Aviv nunca ha sido tan divertido o tan sabroso para veganos </h3>\n\t\t\t\t\t<p>Viajar a ciudades extranjeras puede ser dif\xEDcil para los veganos que siguen una dieta libre de platos de origen animal. No es as\xED en Tel Aviv, el hogar de una escuela culinaria totalmente vegana con decenas de restaurantes veganos. Tel Aviv ha adoptado el veganismo a medida que crece en popularidad, de tal modo que la revista culinaria <em>The Daily Meal</em> ha declarado a la ciudad como \"el mejor destino vegano del mundo\", por delante de otras ocho ciudades.</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"posts/6/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div><h3>Lo que los veganos quieren</h3>\n\t\t\t\t\t<p>Pasee por la ciudad de Tel Aviv y se encontrar\xE1 con innumerables bistr\xF3s, restaurantes y puestos de comida r\xE1pida veganos. Tome una bocanada de los aromas dulces y sabrosos que flotan por el aire de la ciudad y sabr\xE1 cuan cerca est\xE1 su pr\xF3ximo delicioso platillo. Siguiendo con los gustos y las demandas de los habitantes de Tel Aviv y los turistas, la mayor\xEDa de los restaurantes de la ciudad, o al menos aquellos que se respetan a s\xED mismos, tienen opciones veganas en sus men\xFAs. Otros ofrecen un men\xFA enteramente vegano, ofreciendo una versi\xF3n de las delicias locales como el falafel sin huevo, shawarma de seitan y pizza libre de queso.</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"posts/6/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>Pruebe los sabores mediterr\xE1neos frescos</h3>\n\t\t\t\t\t<p>Respire el fresco aire mediterr\xE1neo que le abrir\xE1 el apetito para comer algunos dulces locales frescos. Para los veganos que recorren Tel Aviv, los quejidos de su est\xF3mago son solamente una flecha que le se\xF1ala la direcci\xF3n de alg\xFAn producto local fresco transformado en riqu\xEDsimos platos que reflejan diversas culturas y tendencias culinarias.</p>\n\t\t\t\t\t<p>Israel dispone de muchas opciones de comida vegana, pero cuando se trata de restaurantes veganos, Tel Aviv es una verdadera gema culinaria. Ya se trate de comida r\xE1pida, un men\xFA gourmet o postres, Tel Aviv tiene una opci\xF3n vegana especialmente para usted, por lo que la ciudad israel\xED a orillas del mar es un destino de visita obligada en su pr\xF3ximo viaje a Israel.</p>\n\t\t\t\t\t\t\t\t\t\t\n                    \n                   \n\t\t\t\t\t\n                   \n\n\n\t\t\t"};}},{id:13,bgImage:"/posts/bank/28/1.jpg",mobBgImage:"/posts/bank/28/M.jpg",title:"Jerusalem Cuisine",ctg:"culinary",isVid:true,vidId:"2CSCe2WC7Ns",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t<h3>Exhilarating and diverse and oh so yummy</h3>\n\n\t\t\t\t\t<!--<div class=\"responisve-iframe\">\n\t\t\t\t\t\t<iframe src=\"https://www.youtube.com/embed/2CSCe2WC7Ns/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t</div>-->\n\t\t\t\t\t<p>\n\t\t\t\t\t\tJerusalem is filled with scores of lively and trendy restaurants and entertainment spots. The city is packed with areas offering excellent options for every form of day and night time entertainment, where you can enjoy a delightful evening over a great meal, a cold beer or dance to great music.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tIn Jerusalem, they say that you come for the hummus, but stay for the incredibly diverse cuisine. From traditional Middle Eastern and North African to South American, Asian fusion, and continental European cuisine; from street food to fine dining, Jerusalem\u2019s got it all. Jerusalem\u2019s wide array of culinary options can be found literally everywhere local delicacies in street stalls, authentic restaurants in the markets, and if you are looking for the gourmet experience, you can reserve a spot at one of the city\u2019s many exclusive chef restaurants.\n\t\t\t\t\t</p>\n\n         "};}},{id:"Coffee_In_TelAviv",bgImage:"posts/bank/42/1.jpg",mobBgImage:"posts/bank/42/M.jpg",title:"PAUSA PARA UN CAFÉ EN TEL AVIV",ctg:"culinarytelaviv",isVid:true,// vidId: "rVr0gqFC364",
vidId:"s6kkkk8_Q2g",smlTitle:"",html:function html(){return{__html:"\n\t\t\t             <p>Tel Aviv es famosa por ser una bulliciosa ciudad tur\xEDstica llena de paisajes, sonidos y actividades vibrantes, pero el coraz\xF3n de la ciudad late en sus caf\xE9s. <strong>La cultura del caf\xE9</strong> es fundamental para Tel Aviv, as\xED que reduzca la velocidad y absorba el esp\xEDritu de Tel Aviv con un caf\xE9.</p>\n\t\t\t\t\t\t\n\t\t\t\t\t    <h3>La cultura del caf\xE9</h3>\n\t\t\t\t\t\t<p>Si desea experimentar la Tel Aviv \"real\", no hay mejor manera que unirse a la tradici\xF3n de ir a una cafeter\xEDa. Podr\xEDa tomar algo en uno de los muchos caf\xE9s de moda de los turistas, pero \xBFpor qu\xE9 no salir de lo com\xFAn para sentir el ritmo de la vida cotidiana en una peque\xF1a cafeter\xEDa local? Observe el flujo de la ma\xF1ana a su alrededor, o \xFAnase a los residentes de Tel Aviv que llenan los caf\xE9s de la calle por las noches para disfrutar de la brisa fresca, charlar y, por supuesto, tomar un caf\xE9. Querr\xE1 quedarse en su mesa, as\xED que aproveche la variedad de deliciosas comidas que se sirven en cada cafeter\xEDa. Algunos lo deleitar\xE1n con ricos pasteles europeos, mientras que otros servir\xE1n comidas completas que se basan en una variedad de sabores y culturas.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t    <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"posts/coffe-in-tlv/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t    </div>\n\t\t\t\t\t\t<p>Tel Aviv est\xE1 llena de excelentes lugares para tomar caf\xE9, cada uno con un ambiente diferente. Disfrute de un caf\xE9 helado junto a la playa mientras toma el sol, m\xE9zclese con los lugare\xF1os en una elegante cafeter\xEDa entre los famosos edificios Bauhaus, en la moderna Neve Tzedek o rel\xE1jese con un caf\xE9 con leche en el revivido puerto de Tel Aviv. Observe a los en\xE9rgicos corredores bronceados, ciclistas y patinadores pasar de largo mientras toma un descanso para saborear la vida y un buen caf\xE9.<a name=\"_de4lxhpnquhm\" id=\"_de4lxhpnquhm\"></a></p>\n\t\t\t\t\t\t<h3>La hora del caf\xE9</h3>\n\t\t\t\t\t\t<p>En Tel Aviv, no solo beber\xE1 diferentes tipos de caf\xE9, absorber\xE1 diferentes mundos y tradiciones. Por la ma\xF1ana, la franquicia de Joe podr\xEDa ser un \u2018cafe hafuch\u2019 moderno y de moda: la versi\xF3n israel\xED de capuchino hecha con un chorro de caf\xE9 con leche al vapor que beben los j\xF3venes y entusiastas habitantes de Tel Aviv. Para tomar un caf\xE9 a media ma\xF1ana, deje que una olla de caf\xE9 turco tradicional, caliente, oscuro y fuerte lo lleve a un mundo diferente a solo unos minutos de la antigua Jaffa. El aroma y la atm\xF3sfera le transportar\xE1n a trav\xE9s de los a\xF1os a los olores y sabores del viejo Medio Oriente. Finalmente, \xFAnase a la costumbre mediterr\xE1nea de tomar un caf\xE9 por la tarde en una mesa al aire libre en el bulevar Rothschild con los \"sabras\".</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\n              \n\t\t\t"};}},{id:"Non_Stop_Markets",bgImage:"posts/bank/non-stop-markets/1.jpg",mobBgImage:"posts/bank/non-stop-markets/M.jpg",title:"Non Stop Markets",ctg:"telaviv",isVid:false,smlTitle:"",html:function html(){return{__html:"\n\t\t\t                 <p>A tour of the markets in Tel Aviv, with their unparalleled human tapestry and never-ending variety of delicacies is probably one of the best ways to get to know the true local spirit of Tel Aviv.<br>\n                             Here are some of the markets that are definitely a must, when visiting the sunny city:</p>\n\n                             <h3>Carmel Market:</h3>\n                             <p>The city\u2019s most famous market, renowned for its colorful spirit and food stalls, featuring fresh local delicacies and excellent restaurants serving fresh food straight from the market. You can also find hidden food placed behind the stalls and around the area. They are really worth finding. <br>\n                             <h3>The Flea Market:</h3>\n                             <p>Located in Jaffa, packed with fantastic authentic antiques from Tel Aviv and Jerusalem, a joy to bargain hunters. This market is also home to many fashionable and excellent caf\xE9s and restaurants of all varieties of cuisines: from Greek, to Italian, to Arabic.<br>\n                             <div class=\"img-wrapper\">\n\t\t\t\t\t\t         <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"posts/non-stop-markets/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t         </div>\n                             <h3>Nahalat Binyamin Arts & Crafts Market: </h3>\n                             <p>Open on Tuesdays and Fridays, this is a \u2018fair-like\u2019 artists\u2019 market, rich with creative and original ideas for gifts. It is just the place to pick up that perfect souvenir you won\u2019t find in any store.<br> \n                             <h3>Sarona Market</h3>\n                             <p>Offering a unique and fabulous culinary adventure, Sarona Market is located in the Trendy Sarona Complex, and is home to a modern and vibrant \u201Cfood court\u201D which offers a huge assortment of culinary options. Sarona is also extremely family friendly, filled with outdoor activities and fantastic playgrounds. <br>\n                             <h3>Tel Aviv Port Market</h3>\n                             <p>With more of a Farmers Market feel, this seaside Market is packed with tasty treats and specialty produce which you can enjoy, on the spot of take home as culinary souvenirs.<br>\n\n              \n\t\t\t"};}},{id:"Joys_Of_Jaffa",bgImage:"posts/bank/joys-of-jaffa/1.jpg",mobBgImage:"posts/bank/joys-of-jaffa/M.jpg",title:"JAFFA MÁGICA",ctg:"telaviv",isVid:true,// vidId:"uC5KX4MVpC0",
vidId:"tgF0zMUYY2g",smlTitle:"",html:function html(){return{__html:"\n\t\t\t            <br/>\n\t\t\t            <h3>Experimente todas las riquezas que ofrece la hermosa y antigua Jaffa</h3>\n\t\t\t            <h3>Historia colorida e irresistible encanto oriental</h3>\n\t\t\t\t\t\t<p>Los olores del mar aromatizados con caf\xE9 negro y especias de los mercados, la cultura oriental combinada con la europea, lo antiguo mezclado con lo nuevo - esto es Jaffa. Una de las ciudades portuarias m\xE1s antiguas del mundo, cuya historia se relaciona con el diluvio, Jaffa hoy es una ciudad vibrante que nunca deja de sorprender e innovar. Pintorescas callejuelas, galer\xEDas de arte, boutiques \xFAnicas, edificios antiguos, monumentos maravillosos y abundancia de aut\xE9nticos restaurantes de Oriente Medio. Un viaje a la antigua Jaffa es una experiencia estimulante multisensorial obligatoria para cualquier persona que visite Israel. Prep\xE1rese para enamorarse.</p>\n\t\t\t\t\t\t<h3>Descubra la magia de una vibrante ciudad portuaria</h3>\n\t\t\t\t\t\t<p>Situado en una colina con vistas al mar Mediterr\xE1neo, en la parte sur de Tel Aviv, Jaffa ha sido el centro de eventos hist\xF3ricos durante miles de a\xF1os. Todav\xEDa un puerto activo hoy, el <strong>Puerto de Jaffa</strong> es un gran lugar para explorar. Marav\xEDllese con las galer\xEDas de arte, boutiques y mercados de alimentos gourmet. Pasee por los antiguos muelles, escuche m\xFAsica en vivo, beba, coma y emp\xE1pese del ambiente especial.</p>\n\t\t\t\t\t\t<p>Para obtener una mejor vista de la ciudad, suba a la colina del <strong>Parque la Cima</strong> (<strong><em>Ha'Pisga</em></strong>) y contemple la hermosa ciudad y su bah\xEDa. En su camino hacia abajo, pida un deseo en el <strong>Puente de los Deseos</strong>. Qui\xE9n sabe, puede hacerse realidad.</p>\n\t\t\t\t\t\t<h3>Emb\xE1rquese en una aventura urbana rom\xE1ntica</h3>\n\t\t\t\t\t\t<p>Las calles de Jaffa est\xE1n llenas de sorpresas. Pasee por las estrechas calles de piedra de la Ciudad Vieja de Jaffa, descubra los patios escondidos y observe los peque\xF1os detalles: azulejos de cer\xE1mica pintados, peque\xF1as esculturas y terrazas. Observe a la gente, entre en las galer\xEDas de arte, estudios de artistas y boutiques \xFAnicas.</p>\n\t\t\t\t\t\t<p>Siga explorando. Desde la plaza de la <strong>Torre del Reloj</strong>, en el coraz\xF3n de la ciudad, contin\xFAe hasta el conocido <strong>Mercado de las Pulgas de Jaffa</strong> y haga su camino hacia tesoros ocultos. Es hora de probar esas habilidades de negociaci\xF3n. Disfrute de los peque\xF1os caf\xE9s pintorescos, restaurantes aut\xE9nticos de Oriente Medio, y algunos de los mejores hummus que probar\xE1. &nbsp;Garantizado.</p>\n\t\t\t            \n              \n\t\t\t"};}},{id:22,bgImage:"/posts/bank/43/1.jpg",mobBgImage:"/posts/bank/43/M.jpg",title:"Shakshuka Time",smltitle:"",isVid:true,vidId:"n4kCnPXEX7g",html:function html(){return{__html:"\n\n\t\t\t\t<h3>Learn how to make the world famous Shakshuka Dish!</h3>\n\n\t\t<!--<div class=\"responisve-iframe\">\n\t\t\t<iframe src=\"https://www.youtube.com/embed/n4kCnPXEX7g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t</div>-->\n\n      \t\t<p>\n      \t\tWhen you ask people who visit Tel Aviv and Jerusalem what was their favorite dish they tried on their trip, the answer, more often than not, will be Shakshuka. This Mediterranean delicacy, a definite local favorite is essentially a dish of eggs poached in a sauce of tomatoes, chili peppers, and onions rich in flavor and often served with bread and tahini. Of course, there are many variations on this dish according to local styles and tastes and it is usually served for breakfast or brunch though you\u2019\u2019ll find it makes for a fantastic dinner as well.\n      \t\t</p>\n      \t\t<p>\n      \t\tThe best way to eat Shakshuka is definitely by under the fantastic year round sun of Tel Aviv or Jerusalem, as you enjoy an amazing city break full of flavors and unforgettable experiences.\n      \t\t</p>\n      \t\t<p>\n      \t\tHowever, should wish to DIY and recreate the taste of the sensational Shakshuka in your own kitchen, here\u2019s how it\u2019s done:\n      \t\t</p>\n      \t\t<h3>\n            Ingredients\n          </h3>\n          <ul>\n             <li>2 tablespoons olive oil</li>\n             <li>1 onion, chopped</li>\n             <li>1 red bell pepper, seeded and diced</li>\n             <li>4 cloves garlic, minced</li>\n             <li>2 cans of diced tomatoes</li>\n             <li>6 eggs</li>\n             <li>2 tablespoon fresh cilantro, chopped</li>\n             <li>\xBE teaspoon salt</li>\n             <li>1 teaspoon paprika</li>\n             <li>\xBC teaspoon black pepper</li>\n             <li>1 jalapeno (optional)</li>\n          </ul>\n          <h3>\n             Instructions\n          </h3>\n          <ol>\n              <li>Preheat oven to 375 degrees while you wait.</li>\n              <li>Heat the olive oil in a heavy oven-safe pan over medium heat. Add in onion, bell pepper, and jalapeno and fry until onions are translucent.</li>\n              <li>Add in garlic and paprika. Add tomatoes, salt, and black pepper. </li>\n              <li>Bring to a simmer and reduce heat. cook for 10- 15 minutes. </li>\n              <li>Create 6 small spaces in the sauce and carefully crack each egg into the space.</li>\n              <li>Place pan into the preheated oven and cook until eggs whites are set \u2013 roughly 10 minutes.</li>\n              <li>Add cilantro as garnish before serving.  </li>\n              <li>Serve with bread and tahini and enjoy! </li>\n          </ol>\n\n         "};}},{id:"Gourmet_TelAviv",bgImage:"posts/bank/33/1.jpg",mobBgImage:"posts/bank/33/M.jpg",title:"TEL AVIV GOURMET SCENE",ctg:"culinarytelaviv",isVid:true,vidId:"jfyHxk8ZRrI",smlTitle:"",html:function html(){return{__html:"\n\t\t\t<h3>Wake up your taste buds in Tel Aviv</h3>\n\t\t\t<p>\n\t\t\t   Tel Aviv's huge variety of amazing restaurants - The perfect place to treat yourself.\n\t\t\t</p>\n              \n\t\t\t"};}},{id:34,bgImage:"/posts/34/1.jpg",mobBgImage:"/posts/34/M/1.jpg",title:"the DEAD SEA",ctg:"deadsea",isVid:false,player_id_post:"",smltitle:"",html:function html(){return{__html:"\n            \n\t\t\t\t<p>\n               \t\tA geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction.\n\n                </p>\n\n                <p>\n               \t\tExperience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. While here, you can bathe in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.\n\t\t\t\t\t\n                </p>\n\n                <p>\n\n\t\t\t\t\tLuxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.\n\n                </p>\n\t\t\t\t\n            \t "};}},{id:22,bgImage:"/posts/bank/43/1.jpg",mobBgImage:"/posts/bank/43/M.jpg",title:"Shakshuka Time",ctg:"culinary",isVid:true,vidId:"n4kCnPXEX7g",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<h3>Learn how to make the world famous Shakshuka Dish!</h3>\n\t\t\t\t<!--<div class=\"responisve-iframe\">\n\t\t\t\t\t\t<iframe src=\"https://www.youtube.com/embed/n4kCnPXEX7g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t</div>-->\n\n      \t\t<p>\n      \t\tWhen you ask people who visit Tel Aviv and Jerusalem what was their favorite dish they tried on their trip, the answer, more often than not, will be Shakshuka. This Mediterranean delicacy, a definite local favorite is essentially a dish of eggs poached in a sauce of tomatoes, chili peppers, and onions rich in flavor and often served with bread and tahini. Of course, there are many variations on this dish according to local styles and tastes and it is usually served for breakfast or brunch though you\u2019\u2019ll find it makes for a fantastic dinner as well.\n      \t\t</p>\n      \t\t<p>\n      \t\tThe best way to eat Shakshuka is definitely by under the fantastic year round sun of Tel Aviv or Jerusalem, as you enjoy an amazing city break full of flavors and unforgettable experiences.\n      \t\t</p>\n      \t\t<p>\n      \t\tHowever, should wish to DIY and recreate the taste of the sensational Shakshuka in your own kitchen, here\u2019s how it\u2019s done:\n      \t\t</p>\n      \t\t<h3>\n            Ingredients\n          </h3>\n          <ul>\n             <li>2 tablespoons olive oil</li>\n             <li>1 onion, chopped</li>\n             <li>1 red bell pepper, seeded and diced</li>\n             <li>4 cloves garlic, minced</li>\n             <li>2 cans of diced tomatoes</li>\n             <li>6 eggs</li>\n             <li>2 tablespoon fresh cilantro, chopped</li>\n             <li>\xBE teaspoon salt</li>\n             <li>1 teaspoon paprika</li>\n             <li>\xBC teaspoon black pepper</li>\n             <li>1 jalapeno (optional)</li>\n          </ul>\n          <h3>\n             Instructions\n          </h3>\n          <ol>\n              <li>Preheat oven to 375 degrees while you wait.</li>\n              <li>Heat the olive oil in a heavy oven-safe pan over medium heat. Add in onion, bell pepper, and jalapeno and fry until onions are translucent.</li>\n              <li>Add in garlic and paprika. Add tomatoes, salt, and black pepper. </li>\n              <li>Bring to a simmer and reduce heat. cook for 10- 15 minutes. </li>\n              <li>Create 6 small spaces in the sauce and carefully crack each egg into the space.</li>\n              <li>Place pan into the preheated oven and cook until eggs whites are set \u2013 roughly 10 minutes.</li>\n              <li>Add cilantro as garnish before serving.  </li>\n              <li>Serve with bread and tahini and enjoy! </li>\n          </ol>\n\n         "};}},{id:"The_Gates_Of_Jerusalem",ctg:"jerusalem",isVid:true,// vidId:"MXtcTm_JXus",
vidId:"V0Acsw3Hf_M",bgImage:"/posts/bank/gates-of-jerusalem/1.jpg",mobBgImage:"/posts/bank/gates-of-jerusalem/M.jpg",title:"THE GATES OF JERUSALEM",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t  \n\t\t\t\t                <p>Jerusalem\u2019s Old City walls, built in the early 16th century by the Turkish Sultan Suleiman the Magnificent, have eight gates. All but one (the Gate of Mercy) still serve Jerusalemites and visitors streaming to its markets, and sacred and historic sites.</p>\n\n                                <p>Following  is a thumbnail description of the gates, counter-clockwise from south to west:</p>\n\n                                <h3>The Zion Gate:</h3>\n\n                                <p>Bearing Jerusalem\u2019s earliest biblical name in Hebrew and English, this gate\u2019s  Arabic name is the Gate of the Prophet David, as the Tomb of King David, on adjacent Mount Zion, is only a few steps away. Zion Gate leads directly to the Armenian and Jewish quarters.</p>\n\n                                <h3>The Dung Gate:</strong> This gate\u2019s unusual name derives from the refuse dumped here in antiquity, where the prevailing winds would carry odors away. Nehemiah 2:13 mentions a Dung Gate that was probably near this one. This gate leads directly to the Western Wall and the Southern Wall Archaeological Park.</p>\n\n                                <h3>Gate of Mercy:</strong> This gate, in the eastern Temple-Mount wall, may be the best-known of them all. Also called the Golden Gate or the Eastern Gate, it has been blocked for centuries, and is said to be awaiting a miraculous opening when the Messiah comes and the dead are resurrected.</p>\n                                <div class=\"img-wrapper\">\n\t\t\t\t\t\t            <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/gates-of-jerusalem/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t            </div>\n\n\t\t\t\t\t\t\t    <h3>Lion\u2019s Gate:</h3>\n\n                                <p>This portal is named after a pair of ferocious-looking animal carvings that flank it. They are actually tigers, the heraldic symbol of the 13th-century Sultan Beybars. It is also called St. Stephen\u2019s Gate, after the first Christian martyr, who tradition says was stoned nearby. Lion\u2019s Gate, which leads to the Pools of Bethesda, the Via Dolorosa, and the markets, became famous during the Six Day War.</p>\n\n                                <h3>Herod\u2019s Gate:</h3>\n\n                                <p>  Despite its name, the notorious Judean king had nothing to do with this gate. In Arabic and Hebrew this north-facing gate, which leads to the Old City markets, is called the Flowers Gate. Some say the name derives from a rosette carved over it. However, in Arabic a similar word means \u201Cawakened,\u201D and may refer to a nearby cemetery and the hope of resurrection.</p>\n\n                                <h3> Damascus Gate:</h3>\n\n                                <p> This most imposing of Jerusalem\u2019s gateways also faces north and is named for the grand city from which Jerusalem\u2019s rulers once came. It is always a busy thoroughfare, thanks to the bustling markets within. Below the 16th-century gate, archaeologists have uncovered part of the entryway built by Emperor Hadrian in the second century CE.</p>\n\n                                <h3> The New Gate:</h3>\n\n                                <p>This is the only Old City entryway not part of the original design of the 16th-century walls. It was breached in the waning days of the Ottoman Empire to allow Christian pilgrims quicker access to their holy places within the ramparts.</p>\n\n                                <p>The Jaffa Gate: This was the destination of Jewish and Christian pilgrims disembarking at the Jaffa port, hence its name. It led (and still leads) directly to the Jewish and Christian quarters, as well as to the most popular parts of the market, and to the Tower of David Museum, once Jerusalem\u2019s citadel and now a showcase of its history.</p>\n\t\t\t\t\t\t\t    \n\n         "};}},{id:"Shopping_Delights",ctg:"jerusalem",isVid:true,// vidId:"MXtcTm_JXus",
// vidId:"JxSjC2kZfvI",
vidId:"V0Acsw3Hf_M",bgImage:"/posts/bank/shopping-delights/1.jpg",mobBgImage:"/posts/bank/shopping-delights/M.jpg",title:"Placer de Compras",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t    \n\t\t\t\t    <br/>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tDe la alta costura a los recuerdos - Jerusal\xE9n lo tiene todo\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tHay varias zonas de Jerusal\xE9n con paseos de compras al aire libre y tambi\xE9n algunos centros comerciales cubiertos. Cuando usted sale de compras por Jerusal\xE9n puede estar seguro de poder encontrar todo lo que busca y adecuado a todos los presupuesto.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n            CENTRO DE LA CIUDAD: BEN YEHUDA Y LAS CALLES CIRCUNDANTES\n          </h3>\n          <p>\n            Toda el \xE1rea del centro de la ciudad de Jerusal\xE9n es hoy en d\xEDa una calle de compras peatonal. El coraz\xF3n del centro es la calle Ben Yehuda, una peatonal llena de negocios y restaurantes que fue renovada algunos a\xF1os atr\xE1s a fin de hacerla m\xE1s acogedora, con sus aceras repavimentadas con piedra de Jerusal\xE9n, farolas de estilo cl\xE1sico, \xE1reas de asientos y una peque\xF1a fuente para empezar. Las calles circundantes tambi\xE9n disfrutaron de mejoras con la elegante renovaci\xF3n de las aceras de baldosas grises y las mismas farolas cl\xE1sicas emplazadas en Ben Yehuda. Esta renovaci\xF3n fue parte del lanzamiento del tren ligero en la calle Jaffa.\n          </p>\n\n          <p>\n            Dada la expansi\xF3n y la modernizaci\xF3n de todo el \xE1rea, cuando se sale de compras en Jerusal\xE9n vale la pena caminar sin rumbo por todas las calles del centro de la ciudad: Shatz, King George, Hillel, Ben Yehuda, Jaffa, Yoel Salomon y todas sus ramificaciones. Un consejo: los viernes durante el d\xEDa, eche un vistazo al mercadillo de los artistas en las calles Shatz y Bezalel \u2013 un lugar excelente para conseguir regalos hechos por artesanos locales.\n          </p>\n\n          <p>\n           Ben Yehuda en s\xED misma es una colina que conecta con la calle King George en la parte m\xE1s alta y con Jaffa en la parta baja, en el punto donde desemboca a la Plaza Zion (Kikar Tzion). Los puntos destacados de Ben Yehuda incluyen sucursales de dos compa\xF1\xEDas israel\xEDes famosas: Ahava, que produce productos del Mar Muerto y Teva-Naot, que produce zapatos de cuero de alta calidad. Ben Yehuda es tambi\xE9n un buen lugar para examinar souvernirs de judaica o cristianos a precios intermedios \u2013 \xA1y no se olvide de negociar el precio! En el \xE1rea tambi\xE9n se consiguen art\xEDculos pr\xE1cticos para la vida diaria, desde gorras hasta paraguas o productos electr\xF3nicos.\n          </p>\n\n          <!-- Hadar aked to hide this paragraph <p>\n            En el coraz\xF3n de Ben Yehuda, la Plaza Zion, se encuentra el recientemente instalado gran almac\xE9n Hamashbir LaTzarj\xE1n (com\xFAnmente conocido como \u201CHaMashbir\u201D), con varios pisos que ofrecen todo lo que se espera encontrar en esta clase de negocio. Cerca de la Plaza Zion se encuentra la joyer\xEDa Baltinester (calle Jaffa), de renombre por sus collares con nombre hechos por encargo. Desde la Plaza Zion se entra a Najalat Shiv\xE1, centrado en la calle Yoel Salomon, que alberga varios negocios de artistas de cer\xE1mica y orfebrer\xEDa, as\xED como boutiques de ropa.\n          </p>-->\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/5/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n                        EL MALL DE MAMILLA Y EL CARDO DE LA CIUDAD VIEJA: COMPRAS DE LUJO\n                        </h3>\n\n                        <p>\n                        Saliendo del \xE1rea de Ben Yehuda en direcci\xF3n a la Ciudad Vieja, se encontrar\xE1 con la incre\xEDblemente elegante Avenida Mall Alrov Mamilla, una pasarela comercial al aire libre de alto nivel arquitect\xF3nico. La avenida comienza en el hotel de 5 estrellas Mammilla Hotel y se expande hasta la Puerta de Jaffa, la entrada a la ciudad vieja, e incluye varias marcas de prestigio, tales como Versace, H. Stern, Nike y Gap, as\xED como regalos judaica de alto nivel. El lujoso Mall Mammilla tambi\xE9n exhibe regularmente obras de arte, ofrece m\xFAsica en vivo en su anfiteatro y promueve actividades para toda la familia, en especial durante las temporadas de fiestas. Revise nuestra agenda de eventos para m\xE1s informaci\xF3n.\n                        </p>\n\n                        <p>\n                          Durante sus tours por la Ciudad Vieja, descubrir\xE1 una experiencia de compra exclusiva en el Cardo del Barrio Jud\xEDo. La fila de negocios lujosos en el Cardo son adecuados en particular para la compra de recuerdos de Jerusal\xE9n, todo esto con el tel\xF3n de fondo tan especial de las columnas del antiguo Cardo romano y otras ruinas arqueol\xF3gicas. Por esta raz\xF3n el Cardo es una experiencia \xFAnica en su g\xE9nero para un visitante en Jerusal\xE9n, en la cual puede combinar un paseo a trav\xE9s de la historia con compras de alto nivel.\n                        </p>\n                        <h3>\n                         EL MALL DE MALJA EN JERUSAL\xC9N\n                        </h3>\n                        <p>\n                         El Mall de Malja de Jerusal\xE9n es una elecci\xF3n s\xF3lida para los que prefieren salir de compras en un centro comercial urbano cubierto, as\xED como para familias que buscan salir a esta clase de lugares.\n                        </p>\n\n                        <p>\n                         Cuando el mall de Malja fue abierto veinte a\xF1os atr\xE1s, fue apodado \u201CEl mall m\xE1s grande de Medio Oriente\u201D. Hoy en d\xEDa el mall de Malja ciertamente mantiene su estatus como el mayor conglomerado de negocios de Jerusal\xE9n, con m\xE1s de 250 tiendas para elegir\n                        </p>\n\n                        <p>\n                         El Mall de Malja alberga tanto negocios israel\xEDes como internacionales, con productos adecuados a presupuestos algo bajos hasta presupuesto medio y boutiques de alta calidad. Las marcas m\xE1s famosas del mundo, como H&M, Zara, Home Depot y Toys R Us tienen sucursales en este mall. Algunas tiendas de ropas israel\xEDes adecuadas a todos los bolsillos tienen tambi\xE9n lugar aqu\xED, as\xED como una sucursal de los grandes almacenes de HaMashbir LaTzarchan (el mismo almac\xE9n de la Plaza Zion), y el supermercado Mega. Adem\xE1s, el mall de Malja ofrece servicios pr\xE1cticos como sinagoga, oficina de correos y sucursal del Bank Hapoalim. Para comer existe una amplia selecci\xF3n de restaurantes en el patio de comidas, todo kosher.\n                        </p>\n\n\t\t\t\t\t\n\n\t\t\t\t\t<p>\n                        Las actividades incluyen una pista de patinaje de hielo cubierta que funciona durante el invierno, entretenimientos y talleres de artesan\xEDas durante las temporadas de las fiestas. Revise nuestra agenda de eventos para planificar su salida. Adem\xE1s, la sucursal de la tienda para beb\xE9s Shilav, tiene un stand de Gymboree adecuada para ni\xF1os de hasta seis a\xF1os de edad. Es f\xE1cil llegar al mall de Malja en autobuses desde el centro de la ciudad o en un taxi desde cualquier lugar.\n                        </p>\n                        <h3>\n                         EL MERCADO \xC1RABE EN LA CIUDAD VIEJA\n                        </h3>\n                        <p>\n                          Si usted est\xE1 en busca de lo aut\xE9ntico y de productos locales, el mercado \xE1rabe de la Ciudad Vieja es el lugar indicado. Se encuentra en los barrios musulm\xE1n y cristiano; entre por la Puerta de Jaffa y siga derecho hacia el barrio musulm\xE1n. Cuando vea vestidos y t\xFAnicas colgando de lo alto es se\xF1al de que ha llegado. se le puede llamar un \u201Cpeque\xF1o Estambul\u201D. El mercado \xE1rabe de la Ciudad Vieja es un mercado fiel al estilo de los mercados del Medio Oriente, lleno de artesan\xEDa end\xE9mica tanto en ropas como en comidas. Aqu\xED tambi\xE9n puede encontrar suvenirs cristianos, jud\xEDos y musulmanes, por lo general a un precio m\xE1s bajo que en la calle Ben Yehuda, dependiendo de su capacidad de regatear el precio. (Consejo: empiece ofreciendo la mitad del precio exigido.)\n                        </p>\n                        <p>\n                        En el mercado \xE1rabe podr\xE1 apreciar el sabor de como las cosas eran en el pasado y lleva funcionando en la Ciudad Vieja dede hace un par de milenios en esas estrechas callejuelas, diariamente; la autenticidad de este mercado centenario es algo sin paralelo en la cultura occidental en general e incluso en Israel en particular.\n                        </p>\n                        <div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/5/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n                        <h3>\n                         EL SHUK (MERCADO) MAHAN\xC9 YEHUDA\n                        </h3>\n\n                        <p>\n                        El mercado Mahan\xE9 Yehuda o el Shuk, es bien conocido por la combinaci\xF3n tan de Jerusal\xE9n de productos frescos y nueces, productos de pasteler\xEDas (como mazap\xE1n), junto con puestos de shwarma y falafel. En los \xFAltimos a\xF1os Mahan\xE9 Yehuda experiment\xF3 un giro hacia establecimientos m\xE1s selectos, yendo \u201Cdel Shuk al chic con negocios que se especializan en vinos y quesos, tiendas de alimentos naturales y saludables, restaurantes vegetarianos e incluso una sucursal de la cadena israel\xED internacional Caf\xE9 Aroma. Adem\xE1s de la comida, es posible encontrar regalos, tales como judaica, joyas y cer\xE1micas. Tambi\xE9n es posible adquirir productos electr\xF3nicos, tel\xE9fonos m\xF3viles y ropas a bajo precio, incluyendo pantalones Levi Strauss por alrededor de 15 Nis (de todos modos se parecen bastante a los verdaderos Levi).\n                        </p>\n                        <p>\n                         Incluso con su giro hacia lo exclusivo de los \xFAltimos a\xF1os, el shuk Mahan\xE9 Yehuda, es el aut\xE9ntico ambiente de Jerusal\xE9n, que a\xFAn permanece intacto, por lo cual la visita al shuk es obligatoria.\n                        </p>\n                        <h3>\n                          EN RESUMEN\n                        </h3>\n                        <p>\n                         Considerando todo esto, las compras en Jerusal\xE9n reflejan a la ciudad en s\xED misma, que se extiende en la escala desde lo antiguo hasta lo moderno, con opciones para presupuestos limitados y para los que buscan objetos de lujo. Usted vera que salir de compras en Jerusal\xE9n es realmente una experiencia variada y excitante.\n                         <br/>\n\u2013 Ver m\xE1s en: http://www.itraveljerusalem.com/articles/popular-shopping-places/#sthash.HdOTQ81q.dpuf\n                        </p>\n\n         "};}},(_ref={id:"TelAviv_Highlights",ctg:"telaviv",isVid:false,bgImage:"/posts/bank/37/1.jpg",mobBgImage:"/posts/bank/37/M.jpg",title:"Lo Más Destacado de Tel Aviv",smltitle:""},_defineProperty(_ref,"isVid",true),_defineProperty(_ref,"vidId","tgF0zMUYY2g"),_defineProperty(_ref,"html",function html(){return{__html:"\n\t\t\t\t\t<br/>\n\t\t\t\t\t<h3>Las 5 mejores cosas para ver y hacer en la ciudad:</h3>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tViejo Jaffa\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tA pesar de que data de miles de a\xF1os, una visita a Old Jaffa siempre\n\t\t\t\t\tse siente como un descubrimiento emocionante. Encantadores callejones sinuosos intercalados\n\t\t\t\t\tcon galer\xEDas de arte, edificios hist\xF3ricos, monumentos extraordinarios y multitud de pintorescos y aut\xE9nticos restaurantes. Un recorrido por el viejo Jaffa es una tremenda experiencia, un definido imperdible para cada turista que visita Israel.\n\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tPuerto de Jaffa\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tConsiderado uno de los puertos m\xE1s antiguos del mundo, el Puerto de Jaffa\n\t\t\t\t\tsirvi\xF3 a pescadores, marineros, mercaderes, cruzados, conquistadores e\n\t\t\t\t\tinmigrantes por miles de a\xF1os. Hoy, el puerto contin\xFAa sirviendo como\n\t\t\t\t\tun puerto pesquero, y tambi\xE9n se est\xE1 renovando como atracci\xF3n urbana, ofreciendo\n\t\t\t\t\tactividades culturales y de ocio, compras y turismo y al mismo tiempo, su car\xE1cter hist\xF3rico\n\t\t\t\t\ty fascinantemente \xFAnico.\n\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tPuerto de Tel Aviv\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tRecientemente restaurado, el \xE1rea portuaria de moda, realmente lo tiene todo. Durante el\n\t\t\t\t\td\xEDa puede, encontrarse vagando a trav\xE9s de \n\t\t\t\t\tespacios para tiendas de marca y boutique, compartir una comida en restaurantes\n\t\t\t\t\tcon magn\xEDficas vistas al mar y participar en muchas actividades para\n\t\t\t\t\ttoda la familia. Por la noche, sin embargo, las multitudes de j\xF3venes descienden a la zona que se transforma en uno de los uno de los puntos m\xE1s populares de la ciudad\n\t\t\t\t\tcon algunos de los mejores clubes y bares de Tel Aviv.\n\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t    \tLa Ciudad Blanca\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\xDAnete a un fascinante recorrido por la \"Ciudad Blanca\" de Tel Aviv y descubre por qu\xE9\n\t\t\t\t\tha sido declarado Patrimonio de la Humanidad por la UNESCO. La Ciudad Blanca es\n\t\t\t\t\tsede de la agrupaci\xF3n m\xE1s grande del mundo edificios de este estilo internacional, tambi\xE9n\n\t\t\t\t\tconocido como Bauhaus. Construido entre los a\xF1os 1920 y 1930, y minuciosamente\n\t\t\t\t\trestaurado, el barrio de la \"Ciudad Blanca\" es verdaderamente \xFAnico y\n\t\t\t\t\tun memorable tesoro arquitect\xF3nico.\n\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tNeve Tzedek\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tTome un descanso del ritmo agitado de Tel Aviv; esta escondida joya de barrio,\n\t\t\t\t\tcuenta con un hermoso estilo arquitect\xF3nico oriental y encantadoras calles\n\t\t\t\t\testrechas que hacen que Neve Tzedek, que literalmente significa un oasis de Justicia,\n\t\t\t\t\tsea un verdadero oasis en el coraz\xF3n mismo de la bulliciosa ciudad.\n\n\t\t\t\t\t</p>\n\n         "};}),_ref),{id:"Amazing_Nightlife",bgImage:"/posts/bank/18/1.jpg",mobBgImage:"/posts/bank/18/M.jpg",title:"Sorprendente Vida Nocturna",ctg:"telaviv",isVid:true,vidId:"ogEN7aRT0SM",// vidId:"WKfjMATNH8Q", - this is an old youtube video
smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t<div class=\"ac-cradit\">\n\t\t\t\t\t<span class=\"ac-cradit-text\">Credits:</span>\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"ac-cradit-text-1\">Tel Aviv Jaffa municipality<br/></span<\n\t\t\t\t\t\t<span class=\"ac-cradit-text-2\">UDINI prodactions<br/></span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p></p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<br/>\n\n\n                    <p>\n\t\t\t\t\t\t No has vivido la cultura de Tel Aviv hasta no haber bailado hasta el amanecer en uno de los famosos clubes nocturnos de la ciudad.\n\t\t\t\t\t</p>\n\t\t\t\t\t\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/8/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>\n                         Dizingoff \u2013  un aut\xE9ntico mega club, buen ambiente y buena m\xFAsica.\n                    </p>\n\n                    <p>\n                          The Cat and the Dog \u2013  para los m\xE1s trasnochadores, cuando la mayor\xEDa de los clubes ya cierran sus puertas, aqu\xED empieza la fiesta. La m\xFAsica, tan ecl\xE9ctica como su p\xFAblico.\n                    </p>\n\n                    <p>\n                         Biggy Z Bar \u2013 Inspirado en el Mardi Grass de Nueva Orleans, cuenta con una pista al aire libre y otra cubierta, as\xED como con la popular pol\xEDtica de \u201Cbebe todo lo que puedas beber\u201D para los que compran la pulsera del club.\n                    </p>\n\n                    <p>\n                         Dream Exhibition \u2013  Un elegante club con moderno equipo de sonido. Los mayores de 24 a\xF1os bailan al ritmo del rock, m\xFAsica comercial y estilo house.\n                    </p>\n\n                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/8/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>\n                          Valium \u2013 Un lujoso y espacioso club nocturno en el quinto piso del edificio Migdalor. Disfruta en la pista de baile o en la tranquila terraza.\n                          <br/>\n                          Ktovet \u2013 Un club alternativo con una curiosa decoraci\xF3n y DJ locales e internacionales para aquellos que simplemente quieren bailar.\n                           <br/>\n                         The Block \u2013 El techno \u2013 trance es la m\xFAsica preferida en este club, conocido por su excelente sistema de sonido de gran nivel.\n                           <br/>\n                          Kuli Alma \u2013 Donde se expone arte local y con zonas al aire libre, un men\xFA vegetariano y gran variedad de estilos musicales.\n                        </p>\n                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/8/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n                      <p>\n                      Clubes nocturnos alternativos \u2013 Club solo para hombres es el Apolo Bar (Allenby 46) y para mujeres el Barvaz (Ha\xB4Mejoga 10) o el Amazona para mujeres de 24 a\xF1os en adelante (Lilienblum 23).\n                    </p>\n\n         "};}},{id:"Boutique_Hospitality",bgImage:"/posts/bank/1.jpg",mobBgImage:"/posts/bank/M.jpg",title:"Boutique Hospitality",ctg:"telaviv",isVid:false,smltitle:"",html:function html(){return{__html:"\n\n                                <p>Tel Aviv has long been known as a young and vibrant seaside city, where life is fast-paced and non-stop. And with countless bars, restaurants, beaches, museums, shops and attractions lining every free inch of prime Tel Aviv real estate, the recent revolution in the city\u2019s boutique hotel offerings in the past two years has paved the way for luxury and leisure packed vacations, combining action with relaxation and increased visitor satisfaction.</p>\n\n                                <h3>A unique, personalized touch</h3>\n\n                                <p>If you are seeking a unique hospitality experience in a trendy neighborhood establishment that blends into the local infrastructure, a Tel Aviv boutique hotel stay is just what you need. Perfectly bringing together desired service and amenity features with an added increasingly personalized customer service, boutique hotels are known for their staff\u2019s exemplary accommodating attention to their visitors\u2019 every request and fancy.</p>\n\n                                <p>Built in converted heritage sites, restored old buildings or other contemporarily designed structures, each Tel Aviv neighborhood boutique hotel possesses unique themes, concepts and characteristics. Defined by their souls and coupled with uniquely designed guest rooms and a high level of customized service, the boutique hotels have great views of the \u201CCity that Never Sleeps\u201D from sprawling rooftop terraces, in-house spas, internet hubs and restaurants.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t            <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/boutique-hospitality/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t            Credit: Dana Friedlander\n\t\t\t\t\t            </div>\n\t\t\t\t\t\t\t   \n\t\t\t\t\t\t\t\t<h3>Live the big city</h3>\n\n                                <p>Looking to enjoy a romantic couple\u2019s getaway, find a quiet place to unwind during a weeklong business conference, gather your family for an intimate reunion or hang out with friends for a fun beach vacation? Don\u2019t want to travel far from your hotel room or sit in traffic to reach big city attractions, nightlife and events? The warm and inviting yet luxurious nature of boutique hotel stays in Tel Aviv provide the ideal hospitality experience that lets you \u201Clive\u201D Tel Aviv like a local, minus the onus of cleaning your own rooms and preparing your own meals.</p>\n\n                                <p>Think of boutique hotels as upscale and authentic guest houses in the heart of the big city. Somewhere you can go to escape the hustle and bustle when it\u2019s time to relax and be pampered, but still be able to pop out on a whim and casually enjoy the plethora of sites and services Tel Aviv offers the public, just like any one of  the city\u2019s locals. And with many of the city\u2019s boutique hotels situated in trendy areas, including in Neve Tzedek, along the coastline, in the diamond district and on Rothschild, Shenkin and Montefiore streets, a Tel Aviv boutique hotel stay is charming, authentic, pleasurable and exciting for all hospitality seekers.</p>\n            \n\n         "};}},{id:"Shakshuka_Time",ctg:"culinarytelaviv",bgImage:"/posts/bank/43/1.jpg",mobBgImage:"/posts/bank/43/M.jpg",isVid:true,vidId:"n4kCnPXEX7g",title:"Hora de Shakshuka",smltitle:"",html:function html(){return{__html:"\n\n         <br/>\n         <h3>\xA1Aprende a hacer el mundialmente famoso, Plato Shkshuka!</h3>\n          <p>\n          Cuando le preguntas a las personas que visitan Tel Aviv y Jerusal\xE9n al respecto de cu\xE1l fue su plato preferido a lo largo de su viaje, la respuesta, en la mayor\xEDa de los casos, ser\xE1 Shkshuka. Esta exquisitez mediterr\xE1nea, definida como favorito local, es esencialmente un plato de huevos escalfados en salsa de tomates, chiles o pimientos y cebollas ricas en sabor, sirvi\xE9ndose a menudo, con pan y tahini. Por supuesto, hay muchas variaciones de este plato de acuerdo a los gustos y estilos locales, sirvi\xE9ndose por lo general, para el desayuno o el brunch, aunque tambi\xE9n lo encontrar\xE1 fant\xE1stico para la cena.\n      \t\t</p>\n      \t\t<p>\n          La mejor forma de comer Shakshuka es, sin duda, durante todo el a\xF1o de fant\xE1stico sol en Tel Aviv o Jerusal\xE9n, mientras disfruta de un sorprendente descanso en una ciudad llena de sabores y experiencias inolvidables.\n      \t\t</p>\n      \t\t<p>\n          Sin embargo, si desea hacerlo con sus propias manos y recrear el sensacional sabor del Shakshuka en su propia cocina, as\xED es como se hace:\n      \t\t</p>\n      \t\t<h3>\n            Ingredientes\n          </h3>\n          <ul>\n             <li>2 cucharadas de aceite de oliva</li>\n             <li>1 cebolla picada</li>\n             <li>1 pimiento rojo, sin semillas y en cubitos</li>\n             <li>4 dientes de ajo picados</li>\n             <li>2 latas de tomates cortados en cubitos</li>\n             <li>6 huevos</li>\n             <li>2 cucharadas de cilantro fresco, picado</li>\n             <li>\xBE cucharadita de sal</li>\n             <li>1 cucharadita de piment\xF3n</li>\n             <li>\xBC cucharadita de pimienta negra</li>\n             <li>1 jalape\xF1o (opcional)</li>\n          </ul>\n          <br/><br/>\n          <h3>\n             Instrucciones\n          </h3>\n          <ol>\n              <li>Precalienta el horno a 375 grados mientras esperas.</li>\n              <li>Caliente a fuego medio el aceite de oliva en una sart\xE9n pesada apta para horno. Agregue la cebolla, el pimiento y el jalape\xF1o friendo hasta que las cebollas est\xE9n transl\xFAcidas.</li>\n              <li>Agregue el ajo y el piment\xF3n. Incorpore los tomates, la sal y la pimienta negra.</li>\n              <li>Lleve a fuego lento reduciendo el calor. Cocine de 10 a 15 minutos.</li>\n              <li>Cree 6 espacios peque\xF1os en la salsa y cuidadosamente rompa cada huevo en el espacio.</li>\n              <li>Coloque la cacerola en el horno precalentado y cocine hasta que los huevos se blanqueen estando listos en aproximadamente 10 minutos.</li>\n              <li>Agregue el cilantro como guarnici\xF3n antes de servir.</li>\n              <li>\xA1Sirve con pan, tahini y divi\xE9rtete!</li>\n          </ol>\n        "};}},// {
//     id: "Jerusalem_Cuisine",
//     ctg: "culinaryjerusalem",
//     bgImage: "/posts/bank/28/1.jpg",
//     mobBgImage: "/posts/bank/28/M.jpg",
//     isVid:true,
//     vidId: "2CSCe2WC7Ns",
//     title: "GASTRONOMÍA EN JERUSALÉN",
//     smltitle: "",
//     html: function() {
//         return {
//             __html: `
//            <br/>
//            <h2 >Los 5 restaurantes más<br> singulares de Jerusalén</h3>
//            <p>
//                            Jerusalén está llena de decenas de animados restaurantes a la moda y lugares de entretenimiento. Además está repleta de áreas que ofrecen excelentes opciones para todo tipo de entretenimientos, ya sean diurnos o nocturnos, donde podrá disfrutar de una deliciosa velada con una gran comida, una cerveza fría o un baile con buena música.
// 						</p>
// 						<p>
// 						   En Jerusalén, se dice que vienes por el hummus, pero te quedas por su increíblemente diversa cocina. Desde la gastronomía tradicional de Oriente Medio y Norte de África hasta Sudamérica, fusión asiática y continental europea; desde comida callejera hasta comida de etiqueta, Jerusalén lo tiene todo. Esta amplia variedad de opciones culinarias se puede encontrar literalmente en todas partes. Lugares como puestos callejeros ofreciendo delicias locales, auténticos restaurantes en los mercados, y si está buscando la experiencia gourmet, puede reservar un lugar en uno de los múltiples restaurantes exclusivos de la ciudad.
// 						</p>
//         `
//         }
//     }
// },
{id:"Jerusalem_Cuisine",bgImage:"/posts/bank/28/1.jpg",mobBgImage:"/posts/bank/28/M.jpg",title:"GASTRONOMÍA EN JERUSALÉN",ctg:"culinaryjerusalem",isVid:true,// vidId: "2CSCe2WC7Ns",
vidId:"oy9ozIvV7Co",smlTitle:"",html:function html(){return{__html:"\n                   <br/>\n           <h3>Los 5 restaurantes m\xE1s singulares de Jerusal\xE9n</h3>\n           <p>\n                           Jerusal\xE9n est\xE1 llena de decenas de animados restaurantes de moda y lugares de entretenimiento. Adem\xE1s est\xE1 repleta de \xE1reas que ofrecen excelentes opciones para todo tipo de entretenimientos, ya sean diurnos o nocturnos, donde podr\xE1 disfrutar de una deliciosa velada con una gran comida, una cerveza fr\xEDa o un baile con buena m\xFAsica.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t   En Jerusal\xE9n, se dice que vienes por el hummus, pero te quedas por su incre\xEDblemente diversa cocina. Desde la gastronom\xEDa tradicional de Oriente Medio y Norte de \xC1frica hasta Sudam\xE9rica, fusi\xF3n asi\xE1tica y continental europea; desde comida callejera hasta comida de etiqueta, Jerusal\xE9n lo tiene todo. Esta amplia variedad de opciones culinarias se puede encontrar literalmente en todas partes. Lugares como puestos callejeros ofreciendo delicias locales, aut\xE9nticos restaurantes en los mercados, y si est\xE1 buscando la experiencia gourmet, puede reservar un lugar en uno de los m\xFAltiples restaurantes exclusivos de la ciudad.\n\t\t\t\t\t\t</p>\n\n\t\t\t"};}},{id:10,bgImage:"/posts/bank/12/1.jpg",mobBgImage:"/posts/bank/12/M.jpg",ctg:"telaviv",isVid:false,title:"Culture Time",smltitle:" ",html:function html(){return{__html:"\n\n\t\t\t\t\t<h3>A variety of fascinating museums and unique galleries</h3>\n\n\t\t\t\t    <h3>\n\t\t\t\t        Tel Aviv Museum of Art\n\t\t\t\t    </h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe Tel Aviv Museum of Art presents a variety of permanent and temporal exhibits at its home in the Helena Rubenstein Pavilion, located on Shaul Hamelech Boulevard, next to the Mann Auditorium. The permanent exhibits include some of the best works of Israeli art, as well as sculptures from the 20\u2019s until today. It features European paintings \u2013 impressionism and post-impressionism \u2013 from the 16th to the 19th centuries, as well as European and American works of the 20th century. The museum\u2019s graphic collection includes more than 20,000 prints and sketches. Among the museum\u2019s outstanding works are a unique selection of early painted reliefs of Alexander Archipenko and works by Chagall, which he donated to the museum before its establishment. Helena Rubenstein\u2019s well-known collection of miniature rooms is on permanent display in the pavilion, which bears her name.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t        OPENING HOURS:\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\n                          Sun Closed <br>\n                          Mon, Wed, Sat 10:00-18:00 <br>\n                          Tue, Thu 10:00-22:00 <br>\n                          Fri 10:00-14:00 <br>\n                          Sat 10:00-16:00 (July-August closed on Sat)<br>\n                    </p>\n\n                    <p>\n                       For more information, pinche en&nbsp;<a href=\"//www.tamuseum.org.il/en/default.aspx\" target=\"_blank\">Tel Aviv Museum of Art</a>\n                    </p>\n\n                    <h3>\n                        Beit Hatfutsot: The Diaspora Museum\n                    </h3>\n\n                    <p>\n                       Beit Hatefutsot-The Jewish Diaspora Museum, situated on the Tel Aviv University campus, has gained honorary distinction throughout the Jewish world as the first museum of the history of the Jewish people to showcase the Jewish contribution to human creativity and culture over a period of more than two millennia. The Museum\u2019s permanent exhibition brings the story of the Jewish People throughout the Diaspora to life through drawings, video clips, films, reconstructed models and other means. The exhibit focuses on various subjects \u2013 including \u201CThe Jewish Family life cycle\u201D, \u201Cthe community\u201D, \u201Cthe faith\u201D, and \u201Cthe return to Zion\u201D.\n                    </p>\n\n                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/10/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>\n\n                          For more information, pinche en&nbsp;<a href=\"//www.bh.org.il/\" target=\"_blank\">Beit Hatfutsot: The Diaspora Museum</a>\n\n                    </p>\n\n                    <h3>\n                         Eretz Israel Museum\n                    </h3>\n\n                    <p>\n\n                            The Eretz Israel Museum- Tel Aviv is a multi-disciplinary institution. It presents the history of the land and its culture through an extensive permanent exhibit, in addition to a variety of temporary exhibits on subjects such as archaeology, ethnography, folklore, judaica, cultural history, local identity, traditional crafts and functional arts. The museum\u2019s pavilions are scattered throughout a spacious courtyard with the ancient archaeological mound of Tel Kassile, at which excavations revealed valuable findings, positioned at its center. The museum houses a variety of reconstructed ancient production devices, including wine presses, an olive oil press, and a flour mill, along with a \u201Ccraftsperson\u2019s marketplace\u201D which showcases traditional work instruments that were used in the Land of Israel and throughout the region. There is also a sophisticated Planetarium with its \u201CJourney to the Universe\u201D program, and a museum shop offering a unique selection of locally produced gifts and ornaments.<br>\n\n                            OPENING HOURS:<br>\n\n                          Sun-Wed 10:00-16:00 <br>\n\n\n\n                          Thu 10:00-20:00<br>\n\n\n\n                          Fri-Sat 10:00-14:00<br>\n\n                        </p>\n\n                    <p>\n                       For more information, pinche en <strong>&nbsp;</strong><a href=\"//www.eretzmuseum.org.il/e/\" target=\"_blank\">Eretz Israel Museum&nbsp;</a>\n                    </p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t    Beit Ha\u2019ir\n\t\t\t\t\t</h3>\n\n\n\t\t\t\t\t<p>\n\n                          Beit Ha\u2019ir, renovated by the city, was the old City Hall in Tel Aviv-Yafo on Bialik Street, and is now a living display of the city\u2019s history.  Beit Ha\u2019ir has a new exhibition, which sums up the extensive collection of photos and stories featuring events, sites, and experiences of residents throughout the years, a project that was part of the centenary celebrations of the city. The main hall has a virtual display, including hundreds of documentary films and thousands of rare photos and documents that showcase major events in the early years of city life.  At Beit Ha\u2019ir you can also visit the Dizengoff House, the restored residence of Meir Dizengoff, first mayor of Tel Aviv-Yafo, which includes a permanent exhibition.\n\n                          <br>\n                          OPENING HOURS:\n                          Sun Closed\n                          Mon-Thu 9:00-17:00 <br>\n                          Fri-Sat 10:00-14:00\n                    </p>\n\n                    <p>\n                      For more information, pinche en <a href=\"//www.eretzmuseum.org.il/e/\" target=\"_blank\">Beit Ha\u2019ir</a>\n                    </p>\n\n                    <h3>\n                        The Olympic Experience Museum\n                    <h3>\n\n                    <p>\n\n                          A new museum in Tel Aviv-Yafo, The Olympic Experience Museum, presents a one-hour, five-ring trip through the greatest Olympic records, with a special focus on Israel\u2019s finest moments. The Olympic Experience boasts state-of-the art high tech imaging and illustrations, audio-visuals presentations, holograms, interactive screens, hands-on trials and much, much more.\n\n                          Guided tours for organized groups every 30 minutes. Advanced reservation is recommended.\n\n                          Opening Hours: Sunday-Thursday: 10:00-18:00, Friday:  10:00-14:00\n\n                          The Olympic Experience, 6 Shitrit Street, Hadar-Yosef. Tel: +972-3-6498385\n\n                    </p>\n\n                    <p>\n                       For more information, pinche en&nbsp;<a href=\"//www.olympic.one.co.il/General/Page.aspx?id=86&amp;siteid=2\" target=\"_blank\">The Olympic Experience Museum</a>\n                    </p>\n\n                    <p>\n\n                          Ilana Goor Museum in Jaffa\n\n                          The private home of this world renowned artist has been turned into a museum. You can see her sculptures, furniture, jewelry and get a glimpse into this unique Jaffa home <br>\n                          OPENING HOURS: <br>\n                          Sun-Fri 10:00-16:00 <br>\n                          Sat 10:00-18:00<br>\n                          <a href=\"//www.ilanagoormuseum.org/eng/\">www.ilanagoormuseum.org</a>\n                    </p>\n\n                    <h3>\n                         Palmach Museum\n                    </h3>\n\n                    <p>\n                        Rated #1 Tel Aviv museum on Trip Advisor, this museum examines the Palmach, the military wing of the Zionist Movement, which functioned until the establishment of the State of Israel.\n                    </p>\n\n                    <p>\n                        For more information, pinche en&nbsp;<a href=\"//info.palmach.org.il/show_item.asp?itemId=8096&amp;levelId=42798&amp;itemType=0\" target=\"_blank\">Palmach Museum</a>\n                    </p>\n\n                    <h3>\n                        Other unique Museums\n                    </h3>\n\n                    <p>\n                        Tel Aviv-Yafo is home to a variety of smaller, specialized museums, such as Beit Ben Gurion (The home of David Ben Gurion, Israel\u2019s first prime minister), Beit Hatanach (The home of the Bible), The Haganah (defense) Museum, The I.Z.L. (the Irgun Zva\u2019I Leumi \u2013 National Military Organization) Museum, Beit Hasofer (author\u2019s house), Beit Reuven, The Jabotinsky Museum, and many others. Each of these smaller museums is a treasure house of artifacts. For example, Beit Bialik \u2013 the house of the national poet, displays the books, furniture and belongings of Israel\u2019s renowned national poet. Bialik\u2019s personal library of more than 3,000 books has been preserved, and the museum\u2019s archives contain thousands of manuscripts, including the most extensive collection of his writings.\n                    </p>\n\n                    <h3>\n                        OPENING HOURS OF TEL AVIV MUSEUMS:\n                    </h3>\n                    <h3>\n                        Etzel Museum:\n                    </h3>\n\n                    <p>\n\n                          King George 38: Sun-Thu 8:30-16:00 <br>\n\n                          For more information, pinche en&nbsp;<a href=\"//www.goisrael.com/Tourism_Eng/Tourist%20Information/attractions/Pages/Etzel%20Museum.aspx\" target=\"_blank\">Etzel Museum</a>\n                    </p>\n\n                    <h3>\n                        Ben Gurion House:\n                    </h3>\n\n                    <p>\n                            Sun, Tue-Thu 8:00-15:00 <br>\n                            Mon 8:00-17:00<br>\n                            Fri 8:00-13:00<br>\n                            Sat 11:00-14:00\n                    </p>\n\n                    <p>\n                       For more information, pinche en&nbsp;<a href=\"//www.bg-house.org/?categoryId=6575\" target=\"_blank\">Ben Gurion House</a>\n                    </p>\n\n                    <h3>\n                        Jabotinsky Institute in Israel:\n                    </h3>\n\n                    <p>\n\n                        Sun-Thu 8:00-16:00 <br>\n                        For more information, pinche en&nbsp;<a href=\"//en.jabotinsky.org/\" target=\"_blank\">Jabotinsky Institute in Israel</a>\n\n                    </p>\n\n                    <h3>\n                           The Israeli Museum:\n                    </h3>\n\n                    <p>\n                            Sun, Mon, Wed 9:00-17:00 <br>\n                            Tue, Thu 9:00-19:00<br>\n                            Fri 9:00-14:00 <br>\n                            For more information, pinche en\n                            <a href=\"//www.imj.org.il/en/\">www.imj.org.il</a>\n                    </p>\n\n                    <h3>\n                       Jaffa Visitors Center:\n                    </h3>\n\n                    <p>\n\n                            Summer Sun-Thu, Sat 9:00-20:00<br>\n\n                            Fri 9:00-17:00<br>\n\n                            Winter Sun-Thu, Sat 9:00-18:00<br>\n\n                            Fri 9:00-15:00<br>\n\n                            For more information, pinche en  <br>\n\n                            <a href=\"//www.touristisrael.com/old-jaffa-visitors-center/3604/\" target=\"_blank\">Jaffa Visitors Center</a>\n\n                    </p>\n\n                    <h3>\n                         Hall of Independence:\n                    </h3>\n\n                   <p>\n\n                            Sun-Thu 9:00-17:00 <br>\n\n                            Fri 9:00-14:00<br>\n\n                            For more information, pinche en&nbsp;<a href=\"//eng.ihi.org.il/\" target=\"_blank\">Hall of Independence</a>\n\n                    </p>\n\n                    <h3>\n                        The Bible Museum:\n                    </h3>\n\n                    <p>\n\n                            Sun-Fri 10:00-13:00 + 16:00-18:30 <br>\n\n                            For more information, pinche en&nbsp;<a href=\"//www.blmj.org/en/\" target=\"_blank\">The Bible Museum</a>\n\n                    </p>\n\n                    <h3>\n                        Joseph Bau house:\n                    </h3>\n\n                    <p>\n\n                            By appointment only (including weekends) <br>\n\n                            For more information, pinche en&nbsp;<a href=\"//www.josephbau.com/\" target=\"_blank\">Joseph Bau house</a>\n\n                    </p>\n\n                    <h3>\n                        Rubin Museum:\n                    </h3>\n\n                    <p>\n\n                            Sun Closed <br>\n\n                            Mon, Wed, Thu 10:00-15:00 <br>\n\n                            Tue 10:00-20:00<br>\n\n                            Sat 11:00-14:00<br>\n\n                            For more information, pinche en &nbsp;<a href=\"//www.rubinmuseum.org.il/\" target=\"_blank\">Rubin Museum</a>\n\n                    </p>\n\n                    <h3>\n                        Art Galleries\n                    </h3>\n\n                    <p>\n                        Don\u2019t miss the dozens of fine galleries, primarily located along Gordon Street and in the Old City of Jaffa, featuring the very latest in contemporary Israeli art. We won\u2019t say another word- we\u2019ll let the art speak for itself.\n                    </p>\n\n         "};}},{id:99,bgImage:"/posts/bank/20/1.jpg",mobBgImage:"/posts/bank/20/M.jpg",ctg:"jerusalem",isVid:true,vidId:"rkjLPq-Zsp8",title:"JERUSALEM MAIN SITES ",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t\t<!--<div class=\"responisve-iframe\">\n\t\t\t\t\t\t<iframe src=\"https://www.youtube.com/embed/rkjLPq-Zsp8/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t</div>-->\n\t\t\t\t\t<h3>\n\t\t\t\t    \tDiscover the history that stretches back thousands of years\n\t\t\t\t    </h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tLike any city, the charm and essence of Jerusalem is best absorbed by walking its streets. However, depending on your interests, you don\u2019t want to miss out on exploring at least some of these major attractions.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n                         When visiting religious sites, it\u2019s advised to dress modestly and wear clothing that covers your knees and elbows.\n                    </p>\n\n\t\t\t\t\t<p>\n                       A good place to start is Jerusalem\u2019s Old City, which has a very special and distinct atmosphere and is where many of the major attractions of Jerusalem are found.\n                    </p>\n\n                    <h3>\n                        OLD CITY\n                    </h3>\n\n                    <h3>\n                        JERUSALEM WESTERN WALL\n                    </h3>\n\n                    <p>\n                      The Western Wall, also known as the Wailing Wall and Kotel, is the western retaining wall of the Second Temple. Considered Judaisms\u2019s holiest site, the wall is divided into a men\u2019s and women\u2019s section where worshipers congregate throughout the day for morning, afternoon and evening services. Diverse crowds come to pray against the stones, to tuck small pieces of paper with prayers into the cracks and to simply marvel at the site.\n                    </p>\n\n                    <p>\n                          Address: Jewish Quarter, Old City <br>\n                          Phone: +972-2-627-3515<br>\n                          Hours: 24/7<br>\n                    </p>\n\n                    <h3>\n                        VIA DOLOROSA\n                    </h3>\n\n                    <p>\n                        TCrossing the Muslim Quarter from east to west is this street that traces the last steps of Jesus Christ as he was led to his crucifixion. Popular with both pilgrims and general tourists, the route marks 14 events on Christ\u2019s last walk and is also lined with shops and stalls. It is worth visiting on a Friday afternoon (3:00opm in winter; 4:00pm in summer) when the Franciscans lead a procession along the route.\n                        <br>Address: Via Dolorosa, Muslim Quarter, Old City.\n                    </p>\n\n                    <h3>\n                        JERUSALEM CHURCH OF THE HOLY SEPULCHER\n                    </h3>\n\n                    <p>\n                        One of the holiest sites for Christians, this impressive building draws millions of pilgrims from around the world every year. The compound is believed to be the site of Golgotha (the Hill of Calvary), where, according to the New Testament, Jesus was crucified, buried and resurrected.\n                        <br>\n                        Address: Between Suq Khan e-Zeit and Christian Quarter Rd, Christian Quarter, Old City<br>\n                        Phone: +972-2-627-3314 <br>\n                        Hours: Sun \u2013 Sat: 5:00am \u2013 8:00pm/9:00pm\n                    </p>\n\n\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t    DAVID\u2019S CITADEL\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   David\u2019s Citadel (also known as the Tower of David) was originally built in the second century BC to strategically strengthen a weak point in the city\u2019s defences, and was subsequently destroyed and rebuilt many times over the ensuing centuries. Since 1989, the grounds are home to a fascinating museum, which sheds light on the history of Jerusalem. Don\u2019t forget to take in the splendid view of Jerusalem from its ramparts.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n                          Address: Jaffa Gate, Christian Quarter, Old City <br>\n                          Phone: +972-2-626-5333<br>\n                          Hours: Sun-Thu: 10:00am -4:00pm, Fri: Closed, Sat: 10:00am \u2013 2:00pm (September-June), Sun-Thu:<br> 10:00am \u2013 5:00pm, Fri: 10:00am \u2013 2:00pm, Sat: 10:00am \u2013 5:00pm (July-August)\n                    </p>\n\n                    <h3>\n                        CITY OF DAVID\n                    </h3>\n\n                    <p>\n                        Situated deep below ground in the Arab village of Silwan is the remains of the once-grand citadel where a dynasty of Judean kings once ruled. A massive visitors\u2019 center offers a tour that begins with an observation point overlooking the remains of ancient Jerusalem, then continues underground with a look at recent archaeological finds and ends at the Gihon Spring, where according to tradition Solomon was anointed king. Visitors can also wade through the waters of the 2,700-year-old Hezekiah\u2019s Tunnel.\n                    </p>\n\n                    <p>\n                          Address: Silwan, East Jerusalem <br>\n                          Phone: +972-2-626-2341<br>\n                          Hours: Sun-Thu: 8:00am \u2013 5:00pm (winter), 8:00am \u2013 7:00pm (summer), Fri: 8:00am \u2013 1:00pm (winter), 8:00am \u2013 3:00pm (summer)\n                    </p>\n\n                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/9/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n                       MOUNT OF OLIVES\n                    </h3>\n\n                    <p>\n                        The hill that rises to the east of the Old City, the Mount of Olives, is a great place to take in views of the Old City and the Dome of the Rock. Its slopes are filled with holy and burial sites and are home to several grand churches including the Church of all Nations. To take in all the sights, it\u2019s best to start at the top, near to the Mosque of Ascension, and walk downhill to the Tomb of the Virgin. The Old City views are best in the morning. <br>\n                        Address: Mount of Olives, East Jerusalem\n                    </p>\n\n                    <h3>\n                        YEMIN MOSHE\n                    </h3>\n\n                    <p>\n                        This charming neighbourhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. It is known for its windmill and communal housing block, known as Mishkenot Shaananim, which is now a venue for art and culture. The area is home to artists, writers and academics and is renowned for its Oriental-style houses, green parks, a music center, the YMCA, King David Hotel, Herod\u2019s Family Tomb. <br>\n                        CITY CENTER\n                    </p>\n\n                    <h3>\n                        MAMILLA ALROV AVENUE\n                    </h3>\n\n                    <p>\n                          Situated between the city center and the Old City, Mamilla Alrov Avenue is a pedestrian mall that offers a selection of luxury shops, as well as upscale restaurants and cafes. Mamilla is known for its chic and tasteful European feel, and offers spectacular views of the Old City walls. <br>\n                          Address: 6 Yitzhak Kariv St, Jerusalem <br>\n                          Phone: +972-2-636-0000<br>\n                          Hours: Sun-Thu: 10:00am \u2013 9:30pm (winter), 10:00am \u2013 10:30pm (summer), Fri: 9:00am \u2013 2:00pm (winter), 9:30am \u2013 3:30pm (summer), Sat: One hour after Shabbat \u2013 11:00pm\n                    </p>\n\n                    <h3>\n                        BEN YEHUDA STREET\n                    </h3>\n\n                    <p>\n                    One of Jerusalem\u2019s prime hangout spots for locals and tourists alike, Ben Yehuda Street is a pedestrian mall extending between King George Street and Jaffa Road in downtown Jerusalem. The street is filled with gift shops, falafel and ice-cream stores, buskers, beggars, musicians and street performers.\n                    </p>\n\n\t\t\t\t\t<h3>\n                        NACHALAT SHIVA\n                    </h3>\n\n                    <p>\n                          This charming cobblestone neighbourhood just south of Ben Yehuda Street in the&nbsp;<a href=\"//www.itraveljerusalem.com/placecategory/food-nightlife?multi_hood=11\" target=\"_blank\"><strong>city center</strong></a>&nbsp;offers a great selection of shops, restaurants, bars and outdoor cafes. This is a great place to experience in summer and at night with many bustling until late.\n                    </p>\n\n                    <h3>\n                       MEAH SHEARIM\n                    </h3>\n\n                    <p>\n                          Though it is just a few minutes\u2019 walk from modern Ben Yehuda Street, the ultra-orthodox enclave of Mea Shearim is an entirely different reality. You will feel as though you have stepped into 18th Century Europe with Jewish Orthodoxy dressed in full traditional attire such as long black coats, black fur hats and stockings. When touring, it\u2019s recommended to dress extremely modestly, covering up your wrists and ankles, and to take photos with discretion. <br>\n                          Address: Meah Shearim Rd, Jerusalem\n                    </p>\n\n                    <h3>\n                        Mahane Yehuda Market\n                    </h3>\n\n                    <p>\n                          Often referred to as \u201Cthe shuk\u201D, Mahane Yehuda Market offers a huge assortment of fresh produce and food, as well as a variety of other shops like clothing stores, kitchenware shops, jewellery stores, ceramic stores and a variety of gentrified eateries. The shuk includes an open air and closed area, bounded by Jaffa Road on the one side and busy Agripas Street on the other. It\u2019s worth taking public transportation to the shuk as there is not a huge abundance of parking, and a great deal of traffic. If you can handle crowds, go on a Friday to experience last minute Shabbat shopping.<br>\n                          Address: Agripas and Jaffa Street, Jerusalem\n                    </p>\n\n                    <h3>\n                        OTHER AREAS OF JERUSALEM\n                    </h3>\n\n                    <h3>\n                       YAD VASHEM\n                    </h3>\n\n                    <p>\n                          Yad Vashem, Israel\u2019s national Holocaust memorial, commemorates the six million men, women and children murdered by the Nazis and their allies. Located at the foot of Mt. Herzl, Yad Vashem comprises several moving memorials, including the Hall of Remembrance and the haunting Children\u2019s Memorial; the Holocaust History Museum; the Museum of Holocaust Art; sculptures and installations; a massive archive and a research institute. Dress appropriately, and make sure to reserve at least a few hours for a visit to the Museum.  Address: Har Hazikaron <br>\n                          Phone: +972-2-644-3400\n                    </p>\n\n                    <h3>\n                       ISRAEL MUSEUM\n                    </h3>\n\n                    <p>\n                          You\u2019ll want to devote at least a day to Israel\u2019s largest cultural institution, the Israel Museum, which was re-launched in the summer of 2010 after a major overhaul. The Museum is made up of many different wings and a huge collection of art, archaeological findings and judaica. One of the major highlights is the distinctly shaped Shrine of the Book, which houses many ancient manuscripts including the Dead Sea Scrolls. Other highlights include the Youth Wing for children, the Billy Rose Art Garden, which showcases the development of western sculpture over the centuries, the Museum\u2019s Fine Arts Wing and its in-depth Archaeology Wing.\n                    </p>\n\n         "};}},{id:"Sensational_Beaches",ctg:"telaviv",isVid:true,// vidId:"XDei1Zy_cu4",
vidId:"EJAqEcK4Te0",bgImage:"/posts/bank/17/1.jpg",mobBgImage:"/posts/bank/17/M.jpg",title:"PLAYAS SENSACIONALES",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t\t<br/>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tVen a relajarte en las soleadas playas de Tel Aviv\n\t\t\t\t\t</h3>\n\t\t\t\t\t\n\n\t\t\t\t\t<p>\n\t\t\t\t\tRel\xE1jese en las soleadas playas de Tel Aviv, saque el protector solar, coja sus palas de playa y vaya a jugar.<br/>\n\t\t\t\t\t\tTel Aviv-Yafo cuenta con un largo paseo, que se extiende a lo largo de la orilla del mar y constituye su borde occidental. Las personas caminan, hacen footing, montan en bicicleta o se sientan en los bancos, llenando sus pulmones de aire fresco, todo ello dentro de estos 14 kil\xF3metros excepcionales con amplias vistas, horizontes azules y velas blancas que se balancean sobre las olas.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tDecenas de restaurantes, cafeter\xEDas y helader\xEDas, que est\xE1n llenos a todas horas, y pubs, discotecas y clubes de jazz que florecen al anochecer. Independientemente de la hora, abundan las atracciones: payasos, caricaturistas, tatuadores, peluqueros, magos y, por supuesto, el siempre cambiante desfile de personas que pasean por las playas cercanas. Justo al lado del paseo encontrar\xE1 arena limpia, tumbonas, vendedores de helados y amantes de la playa que nadan a diario, en invierno y en verano, pase lo que pase. Cada una de las 13 hermosas playas de Tel Aviv cuenta con caracter\xEDsticas \xFAnicas y ofrece una variedad de servicios, que incluyen puestos de salvavidas, quioscos, restaurantes, \xE1reas de juegos infantiles, gimnasios al aire libre y mucho m\xE1s.\n\t\t\t\t\t</p>\n\n                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/13/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tAlgunos consejos\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<ul>\n                      <li>Los viernes por la tarde en la playa Dolphinarium, puede participar en un festival improvisado de percusi\xF3n y una combinaci\xF3n brasile\xF1a de artes marciales, danza y m\xFAsica llamada capoeira.</li>\n                      <li>La playa de Gordon es ideal para el v\xF3ley playa.</li>\n                      <li>El observador religioso encontrar\xE1 nataci\xF3n por g\xE9neros en Hof Hadatiyim (playa de Nordau), justo al sur del puerto de Tel Aviv. Las mujeres y las ni\xF1as se ba\xF1an el domingo, el martes y el jueves, mientras que a los hombres y ni\xF1os se les permite el lunes, el mi\xE9rcoles y el viernes. Ambos g\xE9neros est\xE1n permitidos el s\xE1bado.</li>\n                      <li>La comunidad LGBT tiende a concentrarse en torno al tramo cercano al hotel Hilton, que se ha ganado el t\xEDtulo no oficial de la playa con mayor ambiente gay de la ciudad.</li>\n                      <li>La estrecha franja de arena cerca de la Marina est\xE1 menos concurrida y es m\xE1s tranquila que el resto de playas. En el puerto deportivo puede alquilar tablas de windsurf, tablas de surf, veleros, lanchas y equipos de buceo.</li>\n                      <li>El surf es popular en la playa junto al hotel Hilton, donde recientemente se instal\xF3 un sistema de iluminaci\xF3n especial para permitir el surf nocturno. </li>\n                      <li>El Kite Surfing es popular en la playa de Aviv.</li>\n                      <li>Para el windsurf, dir\xEDjase a la playa Dolfinarium.</li>\n                      <li>El voleibol se puede encontrar tanto en la playa de Aviv como en la de Gordon.</li>\n                      <li>Las playas de la ciudad est\xE1n bien equipadas con vestuarios, duchas y aseos. Los servicios salvavidas est\xE1n disponibles en temporada (mayo-octubre) y los oficiales de la polic\xEDa tur\xEDstica est\xE1n presentes para proporcionar servicios de seguridad, asistencia e informaci\xF3n. </li>\n                  \t</ul>\n\n                  \t<h3>\n\t\t\t\t\t\tCuriosidades\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<ul>\n                       <li> 8.500.000 ba\xF1istas disfrutan en las playas anualmente. </ li>\n                       <li> La temporada oficial de ba\xF1o es de mayo a octubre. </ li>\n                       <li> Hay 13 playas a lo largo de la costa de Tel Aviv-Yafo. </ li>\n                       <li> Cuatro playas son accesibles para personas con discapacidad: Tzuk, Tzuk del Norte, Metzizim y Hilton (todas en la parte norte de la ciudad). </ li>\n                       <li> Las playas de Tel Aviv-Yafo obtienen una alta puntuaci\xF3n en las pruebas que lleva a cabo el Ministerio de Medio Ambiente de Israel y se consideran muy limpias. </ li>\n                       <li> Una versi\xF3n israel\xED del tenis de playa, llamada&nbsp;<a href=\"//www.gomatkot.com/the-game/\" target=\"_blank\">Matkot</a>, es el deporte estrella que se juega a lo largo de las costas (\xA1cuidado con la cabeza!). </ li>\n                       <li> La sand\xEDa con queso feta es un aperitivo de playa muy popular. Los Artikim, o polos, tambi\xE9n son muy apreciados, con el sabor chocolate y pl\xE1tano como uno de los favoritos en la lista de la mayor\xEDa de la gente. </ Li>\n                  </ ul>\n\n                  \t<h3>\n\t\t\t\t\t\tReglas en la playa\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<ul>\n                      <li> Los ba\xF1istas deben obedecer a los salvavidas y guardias de rescate. </ li>\n                       <li> El ba\xF1o est\xE1 prohibido cuando no hay ning\xFAn socorrista trabajando. </ li>\n                       <li> Los ba\xF1os en el mar est\xE1n prohibidos cuando la bandera negra est\xE1 izada. </ li>\n                       <li> NO se permiten deportes de motor (motos de agua, embarcaciones). </ li>\n                       <li> Los veh\xEDculos motorizados est\xE1n prohibidos en las playas y pasarelas. </ li>\n                       <li> Se proh\xEDbe hacer hogueras en las playas. </ li>\n                    </ul>\n\n                    <h3>\n                    \tTemporada de ba\xF1o\n                    </h3>\n\n                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/13/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tDurante la temporada, se prestar\xE1n servicios de rescate, supervisi\xF3n y primeros auxilios en las siguientes playas: North Cliff, South Cliff, Tel Baruch, Hilton, Gordon, Frishman, Borgashov (la apertura se retras\xF3 debido a renovaciones), Jerusalem, Charles Clore y Givat Aliyah.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<strong>\n\t\t\t\t\t\t\tHorario:\n\t\t\t\t\t\t</strong>\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\t9-31 de Mayo: 07:00-17:00 <br />\n\t\t\t\t\t\tJunio: 07:00-18:00<br />\n\t\t\t\t\t\tJulio-Agosto: 07:00-19:00<br />\n\t\t\t\t\t\tSeptiembre-Octubre: 07:00-17:00 <br />\n\t\t\t\t\t\tSe proporcionar\xE1 inspecci\xF3n y limpieza en todas las playas mencionadas anteriormente, desde las 7 de la ma\xF1ana hasta \xFAltima hora de la tarde.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<strong>\n\t\t\t\t\t\t\tLa lista de precios de las playas es:\n\t\t\t\t\t\t</strong>\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tPita o pan con hummus o ensalada - 12 NIS <br />\n\t\t\t\t\t\tBotella peque\xF1a de agua mineral - 7 NIS <br />\n\t\t\t\t\t\tPolo - 5 NIS <br />\n\t\t\t\t\t\tTumbona reclinable (por d\xEDa) - 12 NIS <br />\n\t\t\t\t\t\tTumbona (por d\xEDa) - 6 NIS <br />\n\t\t\t\t\t\tSombrilla (por d\xEDa) - 6 NIS <br />\n\t\t\t\t\t</p>\n\t\t\t\t\t\n\t\t\t\t\t\n\n         "};}},{id:"Modern_And_Vibrant",bgImage:"/posts/bank/39/1.jpg",mobBgImage:"/posts/bank/39/M.jpg",ctg:"jerusalem",isVid:true,// vidId: "1Yx2Uht4rms",
vidId:"V0Acsw3Hf_M",title:"Moderna y Vibrante",smltitle:"",html:function html(){return{__html:"\n                            <br/>\n                            <h3>Mucho que ver en el bullicioso centro de la ciudad de Jerusal\xE9n</h3>\n                \n                            <p>\n\t\t\t\t\tEl centro de Jerusal\xE9n es el coraz\xF3n de esta moderna metr\xF3polis, lleno de vida nocturna, restaurantes y opciones culturales que le permiten competir con cualquier ciudad del mundo.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\tEl \xE1rea se compone de varios barrios y lugares atractivos como el encantador Nahalat Shiva, la bulliciosa Yafo Street y la calle Ben Yehuda, con su propia personalidad y atm\xF3sfera \xFAnicas que no debe perderse.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\tEl centro de Jerusal\xE9n incluye fascinantes atracciones y algunos de los barrios con m\xE1s encanto de la ciudad. Para una experiencia cultural inmejorable, visite la amplia variedad de fascinantes museos de Jerusal\xE9n, incluyendo el change to \"\"Museo de Israel, el Museo de las Tierras de la Biblia y el Museo de Ciencias de Jerusal\xE9n.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tMercado de Machane Yehuda\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tDescubra la incomparable atm\xF3sfera y variedad de este mercado que atrae a miles de turistas cada d\xEDa. Una vez que terminen las compras y cierren los vendedores de comida, \xFAnase a la multitud de j\xF3venes, tanto extranjeros como locales, que descienden al mercado para beber y divertirse hasta la madrugada, en los bares, restaurantes y callejones.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tNahalat Shiv'a\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tEste encantador barrio de adoquines en el coraz\xF3n de la ciudad ofrece una excelente selecci\xF3n de tiendas, restaurantes, bares y caf\xE9s al aire libre. Nahalat Shiva es el hogar de Kikar Hamusica (Manzana de la M\xFAsica), un moderno y animado espacio al aire, que ofrece m\xFAsica en vivo todos los d\xEDas durante toda la semana.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/modern-and-vibrant/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tYemin Moshe\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tEste precioso barrio frente a las murallas de la Ciudad Vieja fue construido originalmente para escapar de la sobrepoblaci\xF3n en el siglo XIX. Hogar de artistas, escritores y acad\xE9micos, Yemin Moshe es conocido por su hermoso molino de viento y sus casas de estilo oriental, sus parques verdes, su animado centro de m\xFAsica y sus impresionantes vistas.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tEin Kerem\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tUbicado en un tranquilo valle, entre las monta\xF1as y las colinas en terrazas al suroeste de Jerusal\xE9n, Ein Kerem es uno de los barrios m\xE1s pintorescos de Jerusal\xE9n. Con sus sinuosas calles empedradas, sus encantadoras casas de piedra adornadas con arcos, iglesias cuyas campanas repican en al aire, Ein Kerem irradia encanto y belleza como una isla en un mar de bosque verde.\n\t\t\t\t\t</p>\n\t\t\t\t\t\n\t\t\t\t\t\n\n         "};}},{id:"New_And_OLd_Jerusalem",bgImage:"/posts/bank/39/1.jpg",mobBgImage:"/posts/bank/39/M.jpg",ctg:"jerusalem",isVid:true,vidId:"JxSjC2kZfvI",title:"NUEVO Y ANTIGUO JERUSALÉN",smltitle:"",html:function html(){return{__html:"\n                            \n\t\t\t\t\t\n\t\t\t\t\t<p>Jerusal\xE9n es una invitaci\xF3n abierta a un viaje que no olvidar\xE1. Suba las monta\xF1as, entre en la ciudad y sienta la mezcla \xFAnica entre pasado y presente, lo ordinario y extraordinario. Una de las ciudades m\xE1s antiguas del mundo, sagrada para jud\xEDos, cristianos y musulmanes, Jerusal\xE9n ofrece una experiencia sensorial y espiritual inigualable.</p>\n\t\t\t\t\t<p><strong>Entre</strong>. El coraz\xF3n de la ciudad m\xE1s sagrada en el juda\xEDsmo es la Ciudad Vieja. Entre a trav\xE9s de la hist\xF3rica<em> puerta de Jaffa</em>, o por <em>la puerta de Zion</em> que conduce directa <strong>al barrio jud\xEDo</strong>, uno de los cuatro barrios de la ciudad amurallada y hogar de los jud\xEDos casi ininterrumpidamente desde&nbsp;el siglo VIII a.C. Marav\xEDllese a trav\xE9s de los callejones, vea la gente, visite el <strong>Cardo</strong>, antigua calle principal de Jerusal\xE9n y absorba el ambiente \xFAnico. Est\xE1 caminando tras los pasos de reyes y profetas - No es cosa ordinaria.</p>\n\t\t\t\t\t<h3>Sea testigo de c\xF3mo la historia cobra vida y sienta la energ\xEDa espiritual profunda dentro de los muros</h3>\n\t\t\t\t\t<p><strong>Lo que est\xE1 por venir</strong>. El \xFAltimo segmento restante de las antiguas murallas que rodearon el Segundo Templo, <strong>el Muro Occidental</strong>, es un s\xEDmbolo de los anhelos jud\xEDos por su patria ancestral y espiritual. Cada jud\xEDo que no est\xE1 en Jerusal\xE9n reza en direcci\xF3n al lugar donde est\xE1 ahora, el lugar donde, seg\xFAn el juda\xEDsmo, Dios reside. No importa cu\xE1les sean sus creencias, es una experiencia de humildad. Honrar el esp\xEDritu del sitio y colocar una nota en la pared con una oraci\xF3n o un deseo.</p>\n\t\t\t\t\t<h3>Lo que hay debajo</strong>. Jerusal\xE9n est\xE1 literalmente cubierta de capas de historia y la historia conmovedora obtiene un nuevo significado aqu\xED.</p>\n\t\t\t\t\t<p>Haga el fascinante tour de <strong>los T\xFAneles del Muro Occidental</strong> y descubra sus secciones ocultas. La historia cobrar\xE1 vida a medida que avance por los pasajes subterr\xE1neos, averig\xFCe c\xF3mo era la vida en Jerusal\xE9n durante la era del Segundo Templo y aprenda sobre el arte, la arquitectura y las t\xE9cnicas de construcci\xF3n.</p>\n\t\t\t\t\t<p>Visite el sitio arqueol\xF3gico cercano, la <strong>Ciudad de David</strong> y aprenda m\xE1s sobre la historia de la ciudad. El Rey David la declar\xF3 como la capital unificada de las 12 tribus de Israel hace 3000 a\xF1os. Haga un viaje entre los muros y fortalezas antiguas, fuentes ocultas donde reyes fueron coronados y sigua el camino de los residentes que huyeron de Jerusal\xE9n despu\xE9s de que la ciudad fuera conquistada por los romanos.</p>\n\t\t\t\t\t<h3>Marav\xEDllese de la impresionante vista y si\xE9ntase en la cima del mundo</h3>\n\t\t\t\t\t<p><strong>Lo que est\xE1 por encima</strong>. Originalmente construidas para proteger la ciudad contra los intrusos, Jerusal\xE9n est\xE1 rodeada de murallas. Hoy <strong>las murallas de Jerusal\xE9n</strong> ofrecen una oportunidad para explorar la ciudad desde un \xE1ngulo diferente. Escuche las historias, vea la ciudad subterr\xE1nea y disfrute de toda esta belleza.</p>\n\t\t\t\t\t<p>Est\xE1 empezando a alcanzar la superficie.</p>\n\n         "};}},{id:"Humus_In_Jerusalem",bgImage:"/posts/bank/humus-in-jerusalem/1.jpg",mobBgImage:"/posts/bank/humus-in-jerusalem/M.jpg",ctg:"jerusalem",isVid:false,title:"EL MEJOR HUMUS DE JERUSALÉN",smltitle:"",html:function html(){return{__html:"\n                        \n\t\t\t\t\t<p>\n\t\t\t\t\t\xBFC\xF3mo prefieres el hummus?<br/>\n\t\t\t\t\t\tHay dos certezas al visitar Jerusal\xE9n: comer\xE1 hummus y docenas de locales lo intentar\xE1n convencer que solo ellos saben d\xF3nde se come el mejor hummus de la ciudad. El aire de autoridad con el que se hacen estas recomendaciones, tales como \u201CLe doy mi palabra que en mi familia preparan (\xBFo se refiere a comen?) hummus desde hace siete generaciones\u201D, puede resultar confuso, en especial cuando dos personas parecen abogar por el mismo establecimiento.<br/>\n                        Perm\xEDtanos ayudarle, porque nosotros de verdad conocemos los mejores lugares de Jerusal\xE9n que ofrecen este plato tan importante de. Ahora en serio, los siguientes son (algunos) de los mejores lugares de Jerusal\xE9n para comer hummus.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/humus-in-jerusalem/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tPara aquellos que no est\xE1n seguros de qu\xE9 comida se trata exactamente, el hummus es un plato para mojar \u2013 sus or\xEDgenes se debaten vehementemente pero por lo general se acepta que su origen proviene de alg\xFAn lugar de Oriente Medio \u2013 hecho de garbanzos cocidos y finamente triturados, mezclado con tahina (en hebreo \u2013 tejina, una especie de mantequilla de semillas de s\xE9samo), aceite de oliva, zumo de lim\xF3n, sal y ajo. Se ofrece como plato de entrada en todos los restaurantes de Oriente Medio, donde los comensales mojan pan de pita en la mezcla. Sumergir el pan de pita en la mezcla es una parte importante de la experiencia de comer hummus.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/humus-in-jerusalem/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tAZURA, LA ZONA IRAQU\xCD DEL MERCADO MAHAN\xC9 YEHUDA\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t Hay muchas razones para visitar el mercado Mahan\xE9 Yehuda y Azura es una de ellas. Ubicado en la zona iraqu\xED del mercado, Azura es un muy buen lugar para probar hummus y comidas de Oriente Medio, tales como sopa y guisados de carne.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tLINA, BARRIO CRISTIANO EN LA CIUDAD VIEJA DE JERUSAL\xC9N\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tAlguno de los mejores lugares de hummus se encuentran dentro y en los alrededores de la Ciudad Vieja. Vaya al barrio cristiano a probar uno de los mejores restaurantes de hummus de Jerusal\xE9n. Lina, que ofrece un men\xFA enfocado en el hummus, se encuentra cerca de la estaci\xF3n 8 de la V\xEDa Dolorosa. Sirve un cierto n\xFAmero de variaciones del plato tradicional, como hummus con pi\xF1ones, hummus con jud\xEDas y hummus con huevo duro.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\t HUMMUS ACRAMAWI, BARRIO MUSULM\xC1N EN LA CIUDAD VIEJA\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t Hummus Acramawi, frente a la Puerta de Damasco en la Ciudad Vieja, es otro lugar que goza del afecto del p\xFAblico y es bien conocido tanto por su atm\xF3sfera aut\xE9ntica como por su excelente hummus. Fundado en 1952, Acramawi perfeccion\xF3 su producto durante d\xE9cadas.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tHUMMUS BEN SIRA, CENTRO DE LA CIUDAD CERCA DEL HOTEL MAMILLA\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tUno de los pocos restaurantes de hummus con insomnio, permanece abierto hasta primeras horas de la madrugada. Hummus Ben Sir\xE1 es el lugar perfecto para los que est\xE1n de fiesta y algo hambrientos despu\xE9s de disfrutar en los bares y clubes cercanos o para turistas que desean salir del hotel a altas horas de la noche.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tABU SHUKRI, BARRIO MUSULM\xC1N EN LA CIUDAD VIEJA\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t Abu Shukri es un peque\xF1o restaurante familiar en el barrio musulm\xE1n. Adem\xE1s del hummus ofrecen bolas de falafel y ensaladas. Abu Shukri no se encuentra en la zona lujosa de la ciudad, pero ofrece un asiento para escapar del calor (o del fr\xEDo). Sentarse en Abu Shukri despu\xE9s de deambular por las callejuelas de la Ciudad Vieja es una experiencia relajante y refrescante.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t PARA M\xC1S INFORMACI\xD3N: <a target=\"_blank\" href=\"//www.itraveljerusalem.com/articles/best-hummus/#sthash.fza0m1xK.dpuf\">http://www.itraveljerusalem.com/articles/best-hummus/#sthash.fza0m1xK.dpuf</a>\n\t\t\t\t\t</p>\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\n\n         "};}},{id:"Jerusalem_After_Dark_Fun",bgImage:"/posts/bank/modern-and-vibrant/1.jpg",mobBgImage:"/posts/bank/modern-and-vibrant/M.jpg",ctg:"jerusalem",isVid:true,vidId:"nLKWDp5uA-U",title:"After Dark Fun in the Holy City",smltitle:"",html:function html(){return{__html:"\n\n                \n\n\t\t\t\t\t\n\n\t\t\t\t\t            <p>Planning a trip to Jerusalem usually involves its many sights of culture and historical significance. However, just as important to many, Jerusalem\u2019s has an amazingly cool after dark scene, filled with music, hipster hangouts, dance clubs, and much more.</p>\n                              <p>To check it out, make your way to the City Center and explore the narrow streets just off Jaffa Street. There you\u2019ll find bars and nightclubs that range from comfortably mainstream to eccentrically funky. Rivlin Street is a popular hangout for young people, while Shoshan Street and the surrounding area offers a more laid-back grown up vibe.</p>\n                              <div class=\"img-wrapper\">\n\t\t\t\t\t\t          <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/modern-and-vibrant/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t          </div>\n                              <p>Machane Yehuda market offers a surprisingly awesome night out as in the evening it transforms into a trendy hotspot where vendor stalls and shops become the setting for bars, DJs, live music, and dancing. </p>\n                              <p>Betzalel Street is famous for its student artsy vibe and the many little bars are a great place to befriend the locals who come for a drink and a jam session. </p>\n                              <p>For a daytime change of pace head to the German Colony (Moshava) and, particularly, the neighborhood of Baka. Start at Beit Lechem Street where you\u2019ll have your choice of popular, contemporary restaurants and bars. Then stroll all the way up Emek Refaim Street or through HaMesila (Railway) Park until you reach The First Station \u2013 once a railroad depot in use for over a century, it transformed now into a trendy culinary, cultural, and retail delight.</p>\n            \t\n\n         "};}},{id:"Jerusalem_Musts",bgImage:"/posts/bank/38/1.jpg",mobBgImage:"/posts/bank/38/M.jpg",ctg:"jerusalem",isVid:true,// vidId: "k4OwoEk5wMw",
vidId:"FvAWuLQEOJw",title:"Jerusalén “Obligados”",smltitle:"",html:function html(){return{__html:"\n                       <br/\n\t\t\t\t    <h3>5 mejores cosas para hacer y ver en la impresionante ciudad</2>\n\t\t\t\t\t\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tExcursiones Segway\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tEsta forma de ver la ciudad llena de adrenalina te permitir\xE1 disfrutar de\n\t\t\t\t\tla belleza de Jerusal\xE9n desde una perspectiva completamente \xFAnica.\n\t\t\t\t\tLos recorridos en Segway parten de varios puntos centrales, como el Paseo\n\t\t\t\t\tde Armon HaNatziv (East Talpiot), Yemin Moshe y la Ciudad Vieja, as\xED como\n\t\t\t\t\ttambi\xE9n cerca del Knesset y la zona del museo.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tLa Primera Estaci\xF3n (Hatachana)\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tLa Primera Estaci\xF3n est\xE1 justo en el coraz\xF3n de Jerusal\xE9n, entre la\n\t\t\t\t\tCiudad Vieja y el Centro de la Ciudad, entre los barrios hist\xF3ricos de la\n\t\t\t\t\tColonia Alemana y Yemin Moshe. Es el sitio de la primera estaci\xF3n de tren\n\t\t\t\t\ten Jerusal\xE9n, que fue construida en 1892. Despu\xE9s de someterse a una\n\t\t\t\t\trenovaci\xF3n y conservaci\xF3n la Primera Estaci\xF3n se reabri\xF3 como un activo\n\t\t\t\t\tlugar de entretenimiento, abierto los siete d\xEDas de la semana.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/jerusalem-must/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tEl Ascensor del Tiempo\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tSi eres un fan\xE1tico de los viajes de diversi\xF3n, te encantar\xE1 tener tus sentidos\n\t\t\t\t\tal m\xE1ximo con el Ascensor del Tiempo. Es una experiencia interactiva que\n\t\t\t\t\tlleva a sus visitantes a trav\xE9s de viajes fabulosos a lugares fascinantes, con\n\t\t\t\t\tasientos basados en el movimiento, dentro de una sala \xFAnica, llena de\n\t\t\t\t\tefectos especiales.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tEl Zool\xF3gico B\xEDblico\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tSe extiende sobre 62 acres, este hermoso zool\xF3gico de dos niveles se\n\t\t\t\t\tcentra en un gran lago artificial completo con cascadas piscinas,\n\t\t\t\t\trodeado de espaciosos jardines y lugares de descanso con sombra. Para\n\t\t\t\t\tdeleite de ni\xF1os y adultos por igual, hay m\xE1s de 200 especies a la vista, la\n\t\t\t\t\tmayor\xEDa de ellas mencionadas en la Biblia y algunas casi extintas.\n\t\t\t\t\tEsto no significa que los animales comunes no est\xE9n presentes, incluso\n\t\t\t\t\thay ping\xFCinos. Cerca del zool\xF3gico hay un hermoso, enorme e impresionante\n\t\t\t\t\tacuario, abierto para los visitantes durante el d\xEDa y la noche, que muestra\n\t\t\t\t\tel h\xE1bitat marino del mar Mediterr\xE1neo, el Mar Rojo y m\xE1s.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/jerusalem-must/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tTeddy Park\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tLlamado as\xED en honor a Teddy Kollek quien fue alcalde de Jerusal\xE9n entre\n\t\t\t\t\t1965-1995; Teddy Park es divertido, hermoso e hist\xF3ricamente significativo.\n\t\t\t\t\tEl parque constituye un importante punto de encuentro entre la antigua\n\t\t\t\t\ty la nueva Jerusal\xE9n e incluye un estanque de los deseos, un impresionante\n\t\t\t\t\treloj solar, esculturas originales, propiedades hist\xF3ricas restauradas y una\n\t\t\t\t\tfant\xE1stica atracci\xF3n de fuentes. que ofrece un espectacular\n\t\t\t\t\tespect\xE1culo nocturno de luz y sonido.\n\n\t\t\t\t\t</p>\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\n\n         "};}},{id:16,bgImage:"/posts/bank/34/1.jpg",ctg:"eilat",isVid:true,vidId:"yXzhH92kREg",mobBgImage:"/posts/bank/34/M.jpg",title:"NEGEV MAJESTIC DESERT",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<h3>Action adventures in the desert sun. With so much to see and do, there is never a dull moment in the Negev</h3>\n\n\t\t\t\t\t<!--<div class=\"responisve-iframe\">\n\t\t\t\t\t\t<iframe src=\"https://www.youtube.com/embed/yXzhH92kREg/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t</div>-->\n\t\t\t\t\t<h3 class=\"negev-secondary-title\">\n\t\t\t\t\t\t\t\t The Negev Desert - Pure Magic Desert\n\t\t\t\t\t\t\t</h3>\n\n\n\t\t\t\t\t\t\t\n\n\n                            <!--negev text-->\n\n                            <p>\n\t\t\t\t\t\t\t\tThe Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tIsrael is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class=\"p-margin\">\n\t\t\t\t\t\t\t\tThere are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<h3>\n                                The Israeli desert is special for the following reasons:\n                            </h3>\n\n\t\t\t\t\t\t\t<ul class=\"p-margin\">\n\t\t\t\t\t\t\t    <li>\n\t\t\t\t\t\t\t\t\t\t<b>The desert is very near:</b> just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half).\n\t\t\t\t\t\t\t\t\t\tStarting from November, there will be direct flights from Europe and Russia to Ovda airport including Ryanair, Wizzair, and SAS.\n\t\t\t\t\t\t\t    </li>\n                                <li>\n                                        <b>Easy to Hike and Bike:</b> There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert. You can find a selection of trails on the following websites:<br>\n                                        <a href=\"//www.negevtour.co.il\" target=\"_blank\">www.negevtour.co.il</a>\n                                        <a href=\"//www.en.aravaway.co.il \" target=\"_blank\">www.en.aravaway.co.il</a>\n\t\t\t\t\t\t\t    </li>\n\t\t\t\t\t\t\t    <li>\n                                        <b>Cordial local population:</b> The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.\n\t\t\t\t\t\t\t    </li>\n\t\t\t\t\t\t\t    <li>\n                                        <b>Tourists Activities:</b> Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.\n\t\t\t\t\t\t\t    </li>\n\t\t\t\t\t\t\t    <li>\n                                        <b>Magnificent landscapes:</b> Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety<br>\n                                        <ul>\n                                        \t<li>\n                                        \t\tThere are spectacular sand dunes in the north.\n                                        \t</li>\n                                        \t<li>\n                                        \t\tThe Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.\n                                        \t</li>\n                                        \t<li>\n                                        \t\tIn the east, one experiences the African desert with wide savannas and acacia trees.\n                                        \t</li>\n                                        \t<li>\n                                        \t\tTo the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.\n                                        \t</li>\n                                        </ul>\n                                        During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers.\n\t\t\t\t\t\t\t\t\t\tMany tourists decide for to stay for 2 or 3 days in each region of the Negev.\n\n\t\t\t\t\t\t\t    </li>\n\t\t\t\t\t\t\t    <li>\n                                        <b>The Negev is very safe to travel.</b> In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.\n\t\t\t\t\t\t\t    </li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t    More information and tips for accommodation and recommendations:\n\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t   <a href=\"//www.negevtour.co.il/homepage/accommodation/?lang=en\" target=\"_blank\">www.negevtour.co.il</a><br>\n\t\t\t\t\t\t\t   <a href=\"https://en.aravaway.co.il/business/category/1/\" target=\"_blank\">www.en.aravaway.co.il</a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class=\"p-margin\">\n\t\t\t\t\t\t\t   <a href=\"//goisrael.de/taxonomy/term/85\" target=\"_blank\">Travel deals</a><br>\n\n\t\t\t\t\t\t\t</p>\n\n\n\n\n                            <!--Negev - Transportations-->\n\n\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t    NEGEV - LOCATION AND APPROACH\n\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t<p class=\"p-margin\">\n\t\t\t\t\t\t\t   Landing at the airports of Ovda or Eilat with the  onward journey to Mitzpe Ramon or Sde Boker:\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t   Public means of transportation:\n\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tBus 392 from Eilat to Mitzpe Ramon and Be'erSheva, stops at the airport of Ovda on Sunday at 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tArrival at the central bus station of Mitzpe Ramon after about an hour and a half.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tMondays - Thursdays at 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class=\"p-margin\">\n\t\t\t\t\t\t\t   <a href=\"//www.egged.co.il/HomePage.aspx\" target=\"_blank\">Bus service </a><br>\n\t\t\t\t\t\t\t   <a href=\"//www.egged.co.il/HomePage.aspx\" target=\"_blank\">Shuttle service from Ovda Airport </a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t   Car rental in Eilat, Mitzpe Ramon and Be'erSheva:\n\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tThere a multiple option in renting a car in these cities.\n                                There is a choice of international and Israeli companies.\n\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class=\"p-margin\">\n\t\t\t\t\t\t\t\tLanding at the Ben Gurion International Airport near Tel Aviv and onward journey for Negev to Mashabei Sadeh / Sde Boker / Mitzpe Ramon\n\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t   Public means of transportation:\n\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tBus routes 370/380 from Tel Aviv to Be'erSheva, routes 446/470 from Jerusalem to Be'erSheva.\n\t\t\t\t\t\t\t\t<a href=\"//www1.rail.co.il/EN/Pages/Homepage.aspx\" target=\"_blank\">Train from Ben Gurion or Tel Aviv to Be'erSheva.</a>\n                            </p>\n                            <p>\n\t\t\t\t\t\t\t\tFrom Be'erSheva bus routes 60, 64, 65, 660 Departure every morning 6 o'clock onward (approx. every 20 minutes).\n                                Arrival in Mashabei Sadeh in 35 minutes / SdeBoker area in 55 minutes / Mitzpe Ramon in 1 hour 20 minutes.\n                            </p>\n                            <p class=\"p-margin\">\n\t\t\t\t\t\t\t\tMore information about the public means of transportation is given <a href=\"https://www.bus.co.il/otobusimmvc?Language=en\" target=\"_blank\">here</a> or <a href=\"//www.egged.co.il/HomePage.aspx\">here</a>\n                            </p>\n\n\n                             <!--NEGEV DESERT-don't miss-->\n\n\n\n\n\n\n\n\n                            <h3 class=\"margin-h\">\n                                 NEGEV ROAD DISTANCES\n                            </h3>\n\t\t\t\t\t\t\t<table>\n\t\t\t\t\t\t\t  <tr>\n\t\t\t\t\t\t\t    <th></th>\n\t\t\t\t\t\t\t    <th>Tel Aviv</th>\n\t\t\t\t\t\t\t    <th>Jerusalem</th>\n\t\t\t\t\t\t\t    <th>Bee'r Sheva</th>\n\t\t\t\t\t\t\t    <th>Eilat</th>\n\t\t\t\t\t\t\t  </tr>\n\t\t\t\t\t\t\t  <tr>\n\t\t\t\t\t\t\t    <td class=\"place-table\"> <strong>Old Town <br class=\"show-on-mobile\"> Beer Sheva</strong></td>\n\t\t\t\t\t\t\t    <td>113 Km</td>\n\t\t\t\t\t\t\t    <td>122 Km</td>\n\t\t\t\t\t\t\t    <td></td>\n\t\t\t\t\t\t\t    <td>232 Km</td>\n\t\t\t\t\t\t\t  </tr>\n\t\t\t\t\t\t\t  <tr>\n\t\t\t\t\t\t\t    <td class=\"place-table\"><strong>Tel Arad</strong></td>\n\t\t\t\t\t\t\t    <td>134 Km</td>\n\t\t\t\t\t\t\t    <td>144 Km</td>\n\t\t\t\t\t\t\t    <td>40 Km</td>\n\t\t\t\t\t\t\t    <td>229 Km</td>\n\t\t\t\t\t\t\t  </tr>\n\t\t\t\t\t\t\t  <tr>\n\t\t\t\t\t\t\t    <td class=\"place-table\"><strong>Ben-Gurion's House <br class=\"show-on-mobile\">in Sde Boker</strong></td>\n\t\t\t\t\t\t\t    <td>162 Km</td>\n\t\t\t\t\t\t\t    <td>171 Km</td>\n\t\t\t\t\t\t\t    <td>49 Km</td>\n\t\t\t\t\t\t\t    <td>185 Km</td>\n\t\t\t\t\t\t\t  </tr>\n\t\t\t\t\t\t\t  <tr>\n\t\t\t\t\t\t\t    <td class=\"place-table\"><strong>Ramon Crater</strong></td>\n\t\t\t\t\t\t\t    <td>210 Km</td>\n\t\t\t\t\t\t\t    <td>192 Km</td>\n\t\t\t\t\t\t\t    <td>97 Km</td>\n\t\t\t\t\t\t\t    <td>141 Km</td>\n\t\t\t\t\t\t\t  </tr>\n\t\t\t\t\t\t\t  <tr>\n\t\t\t\t\t\t\t    <td class=\"place-table\"><strong>Hai Bar Wildlife <br class=\"show-on-mobile\"> reserve Yotvata</strong></td>\n\t\t\t\t\t\t\t    <td>323 Km</td>\n\t\t\t\t\t\t\t    <td>288 Km</td>\n\t\t\t\t\t\t\t    <td>202 Km</td>\n\t\t\t\t\t\t\t    <td>35 Km</td>\n\t\t\t\t\t\t\t  </tr>\n\t\t\t\t\t\t\t  <tr>\n\t\t\t\t\t\t\t    <td class=\"place-table\"><strong>Timna Park</strong></td>\n\t\t\t\t\t\t\t    <td>330 Km</td>\n\t\t\t\t\t\t\t    <td>294 Km</td>\n\t\t\t\t\t\t\t    <td>208 Km</td>\n\t\t\t\t\t\t\t    <td>30 Km</td>\n\t\t\t\t\t\t\t  </tr>\n\t\t\t\t\t\t\t</table>\n\n                            <h3>\n\t\t\t\t\t\t\t\tNEGEV DESERT - DON'T MISS\n\t\t\t\t\t\t\t</h3>\n\n\t\t\t\t\t\t\t <h3>\n                                Ramon Crater\n                            </h3>\n\n                            <p>\n                                At the heart of Israel\u2019s vast Negev Desert, lies the Ramon Crater, the world\u2019s largest erosion crater,also known as Machtesh Ramon.\n\t\t\t\t\t\t\t\tEncompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an longated heart, and forms Israel\u2019s largest national park, the Ramon Nature Reserve.\n\t\t\t\t\t\t\t\tFar from the city lights and crowds, featuring multicolored sandstone, volcanic rock and fossils, the Ramon Crater is often described as Israel\u2019s very own Grand Canyon.\n\t\t\t\t\t\t\t\tThe truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.\n\n                            </p>\n\n                            <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/7.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<h3>\n                                Timna Park\n                            </h3>\n\n                            <p>\n                               15,000 acres in a horseshoeshaped valley surrounded by steep cliffs, Timna Park is an extraordinarily stunning experience and an absolute treat for hiking enthusiasts. Here you'll witness the marvelous works of nature, as well as the amazing wildlife, plants and trees which make the desert their home, surviving in the harsh arid conditions.\n                               With its multitude of attractions, colorful sands and craggy mountains, Timna Park is an incomparable visitor magnet.\n\n                            </p>\n\n                            <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/9.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<h2 class=\"title-to-play\">\n\t\t\t\t\t\t\t\tCLICK TO PLAY: Timna Park - An Exhilarating Desert Adventure\n\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t<div class=\"responisve-iframe\">\n\t\t\t\t\t\t\t    <iframe src=\"https://www.youtube.com/embed/i_4QKtXIeto/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\n\n                            <h3>\n\t\t\t\t\t\t\t    Sandboarding in the desert\n\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tAn iconic desert experience. The plush sweeping sand dunes of the Negev desert allow you to glide down sitting down or standing up at an exhilarating pace. This is a fantastic and very special skill, which once you master (it\u2019s really very easy) you can call yourself a genuine sand surfer \u2013 how cool is that?\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!--<div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>-->\n\n\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t    Negev at night\n\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tThe sky of the Negev at night is a mesmerizing sight. Simply look up once darkness sets and you will immediately be struck by the splendor of millions of twinkling stars, lighting up the blue-black darkness in a radiance that can only be seen in the dessert.\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t    Sunrise at Masada\n\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tAvailable only to those brave enough to climb atop by foot - watching the Sunrise at Masada is undoubtedly one of the most unforgettable experiences to be had in Israel. The slow rise of the sun as it emerges over the Jordanian Moab Mountains and the Dead Sea, shedding its light on the surrounding desert landscapes, is a truly spectacular sight, one which you will not soon forget.\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/6.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\n\n\t\t\t\t\t\t\t<h3>\n                                NEGEV - ISRAEL\u2019S MAJESTIC DESERT\n                            </h3>\n                            <h3>\n                                Where Adventure and Inspiration Await\n                            </h3>\n                            <p>\n                              An ideal destination for travelers who love adventure in the great outdoors.\n\t\t\t\t\t\t\t  The south of Israel is sparsely populated, but packed with fascinating sites and activities.\n\n                            </p>\n                            <p class=\"p-margin\">\n                                With amazing natural wonders and beauty, the South boasts magnificent views that are guaranteed to take your breath away, from sunrise to sunset.\n\t\t\t\t\t\t\t\tA desert but definitely not deserted, there is so much to see and do here \u2013 there are many extraordinary geological marvels, significant historical landmarks and wonderful nature reserves, where you can go hiking, cycling and camel riding, or enjoy adrenaline-charged safari rides in the desert.\n\t\t\t\t\t\t\t\tSimply put, this majestic Southern region is one of the country\u2019s greatest assets and an absolute must on the itinerary.\n\n                            </p>\n\n\n\t\t\t\t\t\t\t<h3>\n                                Sde Boker\n                            </h3>\n\n                            <p class=\"p-margin\">\n                                A remarkable glance to the history of the State of Israel, Sde Boker is a Kibbutz originally established by pioneers, with the mission to settle the Negev in the early 50\u2019s.\n                                Sde Boker is renowned as the home of David Ben Gurion, Israel\u2019s first Prime Minister whose home is now a museum open to the public.\n\n\n                            </p>\n\n                            <h3>\n                                Vidor Center\n                            </h3>\n\n                            <p class=\"p-margin\">\n                                A truly unique attraction, offering a multi-sensory experience of the exceptional nature of the Arava region. Visitors to the center can discover advanced farming methods, the local flora and fauna, climate challenges, and special qualities of the soil and water of the desert.\n                            </p>\n\n\n\n                            <h3>\n                                Nevatim\n                            </h3>\n\n                            <p class=\"p-margin\">\n                               A visit to Nevatim, the home to Cochin Jews, is a fascinating experience. Cochin Jews, originally from India, immigrated to Israel after the establishment of the State. Cochin Jews consider themselves as one of the most ancient Jewish communities in the world.\n                               The Center for Cochin Heritage at Moshav Nevatim tells the story of this unique community.\n                            </p>\n\n                            <h3>\n\t\t\t\t\t\t\t   MidBurn Festival\n\t\t\t\t\t\t\t</h3>\n\n\t\t\t\t\t\t\t<p class=\"p-margin\">\n\t\t\t\t\t\t\t\tIsrael\u2019s own version of the famous \u201CBurning Man\u201D festival; where for 6 days, a temporary city is set up in the Negev desert, creating a platform which allows a communal life style, creativity, art and radical self-expression.\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<div class=\"responisve-iframe\">\n\t\t\t\t\t\t\t    <iframe src=\"https://www.youtube.com/embed/QL3BGy2p77g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<br>\n\n                            <h3>\n                                The Bedouin Experience\n                            </h3>\n\n                            <p>\n                               The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging.\n                               A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality. From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a longforgotten way of life.\n\n                            </p>\n\n                            <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/8.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<h3>\n                                The Culinary Queens of Yeruham\n                            </h3>\n\n                            <p class=\"p-margin\">\n                              For a truly memorable local experience, make sure to visit the Culinary Queens of Yeruham \u2013 a unique project, in which the wonderful women of Yeroham host tourists from far and wide for an excellent traditional meal in their homes, creating an unforgettable experience of smells, colors and flavors.\n                              Get to know the real life of locals through their fascinating stories, while tasting the ethnic delicacies and enjoying their amazing hospitality.\n\n                            </p>\n                            <h3>\n                                The Old City of Be'er Sheva\n                            </h3>\n\n                            <p class=\"p-margin\">\n                               Said to have been founded by biblical Abraham, Be'er Sheva is one of the oldest cities in the country, with evidence of a settlement dating back thousands of years. As charming as it is historic, the old city of Be'er Sheva offers a fascinating mosaic of urban spaces, and exploring the Old City will reveal a rare wealth of unique architecture, extensive history and stories as old as time.\n                            </p>\n                            <h3>\n                                Carasso Science Park\n                            </h3>\n\n                            <p>\n                               New in the Old City of Be\u2019er Sheva, the Carasso Science Park, spread over 4.25 acres, is the largest science park in Israel.\n                               Engaging and entertaining for all ages, Carasso Science Park features an interactive museum and a scientific garden with games and hands-on activities. The park also offers ten interactive exhibitions in various fields of science including: Genetics, Communication, Microelectronics, Nuclear Energy and more.\n\n                            </p>\n                            <h3>\n                                Arad\n                            </h3>\n\n                            <p class=\"p-margin\">\n                               Arad of the new millennium is a town with young spirit and rich experience. Arad and its surroundings have been blessed with beautiful landscapes, desert tranquility, and many walking trails nestled amongst untouched desert nooks, suitable for any age or style.\n                               With lots of attractions and plenty of tourism sites in and around the city, Arad is the perfect starting point and your natural gate to the perfect desert vacation.\n\n                            </p>\n\n\n\t\t\t\t\t\t\t<h3>\n                               Yotvata Hai-Bar\n                            </h3>\n\n                            <p>\n                               The Yotvata Hai-Bar Nature Reserve is the area\u2019s largest animal breeding and reclamation center for animals before they are reintroduced into the wild. The reserve boasts wonderful attractions that are an absolute delight for animal lovers, including the predators\u2019 center with its live predators and small desert animals, a Nocturnal animal\u2019s observatory in dark room conditions and 12 square kilometers of ground where herds of herbivores roam free.\n\n                            </p>\n\n                            <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/10.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t</div>\n\n\n\t\t\t\t\t\t\t<h3>\n                               Extreme Adventures\n                            </h3>\n\n                            <p>\n                               The south of Israel is a total dream destination for adventure-hungry travelers.  Its unique and challenging terrain make for an ideal setting for various extreme sports and activities including abseiling down steep ravens and canyons, dirt biking and off road cycling which are extremely popular in this area as are the 4x4 adventure drives which are all the rage for locals and tourists alike.\n\n                            </p>\n\n                            <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/11.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t    Camel rides\n\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tA definite throwback, this is still most authentic way to explore the marvelous desert surrounding. Riding on the back of a Camel is an activity found in a number of camel farms across the Negev and one guaranteed to last in your memory.\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/5.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\n\n                            <!--NEGEV - \u05D5PDATED TEXT SITES-->\n\n                            <h3>\n                                EVENTS IN THE NEGEV: CALENDAR\n                            </h3>\n\t\t\t\t\t\t\n\n\n\t\t\t\t\t\t\t<div class=\"row-1 mounth-row\">\n\t\t\t\t\t             <div class=\"mounths active\">\n\t\t\t\t\t            <p id=\"myHeader1\" data-div=\"newboxes1\" onClick=\"toggleMounth(event)\" href=\"\">January <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\n\n\t\t\t\t\t         <div class=\"mounths month-mid\">\n\t\t\t\t\t            <p id=\"myHeader2\" data-div=\"newboxes2\" onClick=\"toggleMounth(event)\" href=\"\">February <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\n\n\t\t\t\t\t         <div class=\"mounths\" >\n\t\t\t\t\t            <p id=\"myHeader3\" data-div=\"newboxes3\" onClick=\"toggleMounth(event)\" href=\"\">May <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\n\t\t\t\t\t         <div class=\"mounths month-mid\">\n\t\t\t\t\t            <p id=\"myHeader1\" data-div=\"newboxes4\"onClick=\"toggleMounth(event)\"  href=\"\">June <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\n\t\t\t\t\t         <div class=\"mounths\">\n\t\t\t\t\t            <p id=\"myHeader2\" data-div=\"newboxes5\" onClick=\"toggleMounth(event)\" href=\"\">July <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\t\t\t\t\t        </div>\n\n\n\n\t\t\t\t\t        <div class=\"row-2 mounth-row\">\n\t\t\t\t\t          <div class=\"mounths\" >\n\t\t\t\t\t            <p id=\"myHeader3\" data-div=\"newboxes6\" onClick=\"toggleMounth(event)\" href=\"\">August <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\n\t\t\t\t\t         <div class=\"mounths month-mid\">\n\t\t\t\t\t            <p id=\"myHeader1\" data-div=\"newboxes7\"onClick=\"toggleMounth(event)\"  href=\"\">October <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\n\t\t\t\t\t         <div class=\"mounths\">\n\t\t\t\t\t            <p id=\"myHeader2\" data-div=\"newboxes8\" onClick=\"toggleMounth(event)\" href=\"\">November <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\n\n\t\t\t\t\t         <div class=\"mounths month-mid\" >\n\t\t\t\t\t            <p id=\"myHeader3\" data-div=\"newboxes9\" onClick=\"toggleMounth(event)\" href=\"\">December <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\n\t\t\t\t\t        </div>\n\n\n\n\t\t\t\t\t         <div class=\"newboxes\" id=\"newboxes1\" style=\"    display: block;\"> <!--Jen-->\n\t\t\t\t\t                Round The Arava Race - The 63-kilometer bike race named after Yoni Friedman offers a breathtaking desert landscape, endless expanses of nature, the power of spirituality, serenity and serenity and a connection to an extraordinary sporting experience. The starting point and end of the race are in Moshav Hatzeva.<br>\n\t\t\t\t\t                <a href=\"https://www.arava-active.co.il/MenuDefault.aspx?id=4240\" target=\"_blank\">www.arava-active.co.il</a>\n\t\t\t\t\t        </div>\n\t\t\t\t\t        <div class=\"newboxes\" id=\"newboxes2\"><!--Feb-->\n\t\t\t\t\t                Darom Adom is an annual festival held during the Anemone flower's blossoming season in the northern Negev region. The festival offers agricultural tours, farmers' markets, and countryside lodging, as well as sports activities such as marches, race, bike tours through the red fields of the northern Negev and other activities such as artistic performances. The local tourism association \"Shikma Besor\" is responsible for the festival and its yearly activities.<br>\n\t\t\t\t\t                <a href=\"//daromadom.habsor.co.il/\" target=\"_blank\">www.daromadom.habsor.co.il</a>\n\t\t\t\t\t        </div>\n\t\t\t\t\t        <div class=\"newboxes\" id=\"newboxes3\"><!--May-->\n\t\t\t\t\t                The cherry festival takes place in the Yatir Forest, which is the largest forest in Israel where large orchards of orchards grow, and is a 5-minute drive from Be'er Sheva. The event includes a cherry harvest for the whole family, sweet and sour snacks, baking pita bread, sheep herding, cheese gibbon, local farmers' market, klezmer melodies, climbing wall, omega and many other activities for the whole family.<br>\n\t\t\t\t\t                <a href=\"//kinderland.co.il/events/%D7%A4%D7%A1%D7%98%D7%99%D7%91%D7%9C-%D7%93%D7%95%D7%91%D7%93%D7%91%D7%9F-%D7%91%D7%99%D7%A2%D7%A8-2017-%D7%A7%D7%98%D7%99%D7%A3-%D7%A2%D7%A6%D7%9E%D7%99-%D7%A9%D7%9C-%D7%93%D7%91%D7%93%D7%91%D7%A0/\" target=\"_blank\">www.kinderland.co.il</a>\n\t\t\t\t\t        </div>\n\n\t\t\t\t\t        <div class=\"newboxes\" id=\"newboxes4\"><!--June-->\n\t\t\t\t\t                Experience the magic of Ramadan nights in Rahat - when the night becomes a day and the streets are bustling with life. Join an unforgettable tour at the most special time of the year, giving a unique glimpse into Bedouin culture in Rahat. Meet the authentic dishes, absorb the fragrances of spices and roasted coffee, discover the secrets of Rahat from local guides and enjoy street performances, Debka music and more.<br>\n\t\t\t\t\t                <a href=\"//ramadan-nights.co.il/\" target=\"_blank\">www.ramadan-nights.co.il</a><br>\n\t\t\t\t\t                The Cinema South Festival, initiated by the School of Sound and Screen Arts at Sapir Academic College, started in 2002 with an emphasis on student films. Within a few years, however, became the festival an international film festival that provides a central stage for Israeli cinema, international quality and radical cinema. The festival takes place every year in June for five full days in various locations throughout the northern and western Negev. This is a festival that opens its doors to anyone, free of charge. The South Cinema Festival is produced from a unique cultural agenda relevant to the place where it was created.<br>\n\t\t\t\t\t                <a href=\"//csf.sapir.ac.il/csf2017/csf.sapir.ac.il/index.html\" target=\"_blank\">www.csf.sapir.ac.il</a>\n\t\t\t\t\t        </div>\n\t\t\t\t\t        <div class=\"newboxes\" id=\"newboxes5\"><!--July-->\n\t\t\t\t\t               The International Fringe Festival Beer Sheva is a multi-disciplinary festival that crosses audiences and ages and constitutes a quality stage for the best Israeli and international artists from the fields of theater, dance, music, street art and the plastic arts. The festival is considered one of the major fringe events in Israel and the largest and leading cultural festivals in the south of the country. The festival was recently received by the EFFE (European Festivals Association) and is gaining a reputation as a prestigious event.<br>\n\t\t\t\t\t               <a href=\"https://www.iffb7.com/\" target=\"_blank\">www.iffb7.com</a>\n\t\t\t\t\t        </div>\n\t\t\t\t\t        <div class=\"newboxes\" id=\"newboxes6\"> <!--Aug-->\n\t\t\t\t\t               Negev Of Stars - Like every summer, the Earth passes through the shrapnel left behind by the comet SWIFT-TATTLE. These fragments penetrate our atmosphere and create a spectacular view of \"shooting stars\". During this time in the Negev celebratethe people the amazing experience of the Perseid Meters, a number of astronomical events - a joint observation of the meteor shower, observation points with elaborate telescopes, lectures and many other activities.\n\t\t\t\t\t        </div>\n\t\t\t\t\t        <div class=\"newboxes\" id=\"newboxes7\"><!--Oct-->\n\t\t\t\t\t                The Tamar Festival is a combination of the ideal Israeli soundtrack and the spectacular vista of Masada and the Dead Sea region. The extraordinary experience takes place with concerts over 4 days at various locations and at different times over 24 hours, when the audience ventures out to the country's most extraordinary sites and landscapes.<br>\n\t\t\t\t\t                <a href=\"//www.tamarfestival.com/\" target=\"_blank\">www.tamarfestival.com</a><br>\n\t\t\t\t\t                Desert Magic Festival - The first Bedouin festival: A variety of experiential activities for the whole family that provide an authentic glimpse into the ancient Bedouin tradition.<br>\n\t\t\t\t\t                <a href=\"//www.kesem-hamidbar.co.il/\" target=\"_blank\">www.kesem-hamidbar.co.il</a>\n\t\t\t\t\t        </div>\n\t\t\t\t\t        <div class=\"newboxes\" id=\"newboxes8\"><!--Nov-->\n\t\t\t\t\t                The Arava Film Festival is a unique event that has been going on for several years every November in the heart of the Arush Nature Reserve, adjacent to Tzukim. The films at the festival are screened in the evening and in the night, under the stars in the open air. They are the first line of international production that has been screened at world film festivals in the last year. Among the films of the festival are films for children and teenagers, as well as short films produced and filmed during the past year in the Arava. The films are screened on a giant screen and the audience can relax on a spacious and surprisingly comfortable platform, which was built especially for this purpose in the valley between the mountain cliffs of the eastern Negev.<br>\n\t\t\t\t\t                <a href=\"https://www.aravaff.co.il/\" target=\"_blank\">www.aravaff.co.il</a>\n\t\t\t\t\t        </div>\n\t\t\t\t\t        <div class=\"newboxes\" id=\"newboxes9\"><!--Dec-->\n\t\t\t\t\t                Ben-Gurion's march has been taking place for more than 20 years, at the initiative of the Ramat Negev Regional Council, following the daily sporting march of the first Prime Minister, David Ben-Gurion, during his stay in Kibbutz Sde-Boker. The march takes place on three tracks \u2013 a short track for families (7 km), a medium pathway (15 km) and a long one (22 km).<br>\n\t\t\t\t\t                <a href=\"//www.zaadatbg.org.il/\" target=\"_blank\">www.zaadatbg.org.il</a><br>\n\t\t\t\t\t                 Docaviv Negev - Docaviv, the Tel Aviv International Documentary Film Festival, is the largest film festival in the city of Tel Aviv, and the only festival in Israel dedicated in its entirety to documentary films. In order to expose as wide an audience as possible to documentary work, the NPO also organizes a regional festivals: Docaviv Negev, held in Yeruham, as well as dozens of documentary film screenings at cultural centers located throughout the country. Each year, Docaviv NPO awards Israel\u2019s largest prize for an original Israeli documentary production, and alongside it, prizes for the Best International Film Award, prizes for outstanding student filmmakers, and an additional prize within the Depth of Field framework, for innovative, inspiring documentary films from around the world.<br>\n\t\t\t\t\t                <a href=\"//www.docaviv.co.il/\" target=\"_blank\">www.docaviv.co.il</a>\n\t\t\t\t\t        </div>\n\n\n\n\n                            <a href=\"//graphics-lapam.org.il/clients/tayarut/negev/files/assets/basic-html/page-1.html#\" target=\"_blank\">FOR MORE IMFORMATION CLICK HERE </a>\n\n\n         "};}},{ctg:"telavivAndJerusalem",isVid:false,id:41,bgImage:"/posts/bank/family/1.jpg",mobBgImage:"/posts/bank/family/M/1.jpg",title:"Tel Aviv y Jerusalén",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<h3>Diversi\xF3n sin parar para toda la familia.</h3>\n\n              \t\t<p>Viajar con ni\xF1os a Tel Aviv y Jerusal\xE9n es una experiencia fant\xE1stica. Ambas ciudades, como la mayor\xEDa del pa\xEDs, son muy familiares y podr\xE1n encontrar numerosas atracciones sorprendentes y actividades emocionantes, de la naturaleza a la cultura, para disfrutar en familia. Vaya donde vaya, es probable que encuentre ni\xF1os en las calles con sus padres, abuelos o en grupos.</p>\n\n                               <p>Con hasta 300 d\xEDas soleados al a\xF1o, las hermosas playas de Tel Aviv se convierten en uno de los destinos favoritos tanto de locales como de turistas. Las playas en s\xED ofrecen una combinaci\xF3n fabulosa de sol y diversi\xF3n. El paseo mar\xEDtimo de Tel Aviv es un excelente lugar para que los ni\xF1os puedan caminar, correr o montar en bicicleta o mini scooter, y hay muchos parques infantiles y caf\xE9s.</p>\n\n                              <p> Para pasar un d\xEDa divertido al aire libre, ll\xE9vese una cesta de picnic al hermoso Parque Yarkon y disfrute de montar en bicicleta, pasear en barca o correr. Tel Aviv tambi\xE9n ofrece multitud de pr\xE1cticos museos y exhibiciones, actuaciones gratuitas, especialmente en la hermosa \xE1rea del puerto de Tel Aviv, y entretenimiento al aire libre con los que la diversi\xF3n est\xE1 asegurada para los visitantes de todas las edades.</p>\n\n                               <p>Una visita a Jerusal\xE9n despertar\xE1 la imaginaci\xF3n de sus peque\xF1os con sus pintorescas callejuelas, sus museos \xFAnicos y su fascinante historia. A la sombra de sus parques, con fuentes de agua, exhibiciones y espect\xE1culos orientados a los ni\xF1os, siempre encontrar\xE1 algo para todas las edades.</p>\n\n                               <p>Una incre\xEDble variedad de comida har\xE1 las delicias de ni\xF1os y mayores por igual. Desde puestos de comida al aire libre hasta restaurantes en los que comer sentados, no faltan los lugares donde comer, y la mayor\xEDa de los restaurantes y caf\xE9s ofrecen men\xFAs infantiles a precios reducidos.</p>\n\n                               <p>La diversi\xF3n y la satisfacci\xF3n est\xE1n garantizadas en su visita a Tel Aviv o Jerusal\xE9n con ni\xF1os, especialmente por la gran variedad de actividades que aqu\xED les esperan. Desde animales hasta museos, parques y espect\xE1culos, siempre hay algo emocionante que ver, escuchar o hacer para todos y cada uno, desde los m\xE1s peque\xF1os hasta los abuelos.</p>\n\n\t\t<div class=\"img-wrapper\">\n\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/35/1.jpg")+" class=\"img-responsive\" />\n\t\t</div>\n              \t\t<h3>\n                                              Tel Aviv\n                              </h3>\n                              <p><strong>\"Luna Park\": </strong>un fant\xE1stico parque de atracciones en el coraz\xF3n de la ciudad que ofrece una variedad de atracciones emocionantes para toda la familia. Justo enfrente del famoso Parque Yarkon, el pulm\xF3n verde de Tel Aviv.</p>\n                              <p><strong> Parque Yarkon:</strong> el tranquilo Parque Yarkon, a las afueras de la bulliciosa ciudad, ofrece hermosas y amplias zonas verdes, paseos en barca por el r\xEDo o en bicicleta a lo largo de sus carriles bici, campos deportivos, y mucho m\xE1s. Disfrute de un picnic con una impresionante vista de la silueta de Tel Aviv en el horizonte.</p>\n                               <p><strong>Globo aerost\xE1tico:</strong> tras relajarse en el magn\xEDfico Parque Yarkon, desp\xE9jese con una hermosa vista de Tel Aviv como nunca lo hab\xEDa visto, flote sobre el Parque Yarkon en una experiencia que es ideal tanto para viajes rom\xE1nticos como para la diversi\xF3n familiar.</p>\n                               <p><strong>Observatorio:</strong> mientras se encuentre en Azrieli, no deje de visitar el incre\xEDble observatorio ubicado en el \xFAltimo piso para una vista a 360\xB0 de Tel Aviv que los m\xE1s peque\xF1os no olvidar\xE1n facilmente.</p>\n                               <p><strong>El Planetario:</strong> una introducci\xF3n divertida a la astronom\xEDa, en la que ser\xE1 transportado al espacio por exhibiciones interactivas, asientos giratorios y presentaciones informativas para toda la familia.</p>\n                               <p><strong>Safari:</strong> con la mayor colecci\xF3n de animales en el Medio Oriente, puede pasar un d\xEDa maravilloso en la naturaleza a solo 15 minutos del coraz\xF3n de Tel Aviv, desde donde puede echar un vistazo al resto de las impresionantes atracciones de la ciudad.</p>\n                               <p><strong>HaTachana, la antigua estaci\xF3n de trenes de Tel Aviv:</strong> el complejo Old Train Station ofrece algo para todos y cada uno, con restaurantes, actividades para ni\xF1os, galer\xEDas de arte, espect\xE1culos callejeros e incluso un paseo en tren que har\xE1 las delicias de toda la familia.</p>\n                              <p><strong> Puerto de Tel Aviv:</strong> respire la brisa marina desde el hermoso puerto deportivo, t\xF3mese algo y disfrute de las incre\xEDbles actuaciones callejeras de m\xFAsica, magia y m\xE1s, pensadas espec\xEDficamente para divertir a los m\xE1s peque\xF1os.</p>\n                              <p><strong> Feria callejera Nachlat Binyamin:</strong> la mayor de este tipo en Israel, la feria es una experiencia alegre y bulliciosa de artesan\xEDa, m\xFAsica en vivo, actuaciones callejeras y caf\xE9s que gustar\xE1 a todos</p>\n                              <p><strong> Sarona:</strong> n\xFAcleo de restaurantes, cafeter\xEDas y bares de moda, el mercado cubierto es un destino popular para las parejas, grupos y familias que buscan uno de los lugares de mayor actualidad en la ciudad.</p>\n\n                              <h3>\n                                              Museos: \n                              </h3>\n                              <p><strong>Museo de Arte de Tel Aviv:</strong> con una gran cantidad de colecciones, gu\xEDas, actividades creativas e interactivas y juegos, el museo es un tesoro tanto para los padres como para sus hijos.</p>\n                              <p><strong>Museo de Historia Natural:</strong> inaugurado en 2018, el museo de 5 plantas, con sus 3000 objetos, ofrece a los ni\xF1os la posibilidad de ver de cerca las criaturas del pa\xEDs.</p>\n                              <p><strong>Museo de la Experiencia Ol\xEDmpica:</strong> disponible a trav\xE9s de visitas guiadas, presenta una visi\xF3n interactiva de la historia del deporte en Israel por medio de divertidas exhibiciones multimedia para toda la familia.</p>\n                              <p><strong>Independence Hall,</strong> el lugar de nacimiento del Estado de Israel y de la primera ciudad de habla hebrea, Tel Aviv. Un viaje fascinante a trav\xE9s de la change to \"\"historia.</p>\n                               \n\t\t<div class=\"img-wrapper\">\n\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/35/2.jpg")+" class=\"img-responsive\" />\n\t\t</div>\n              \t\t <h3>\n                                             Jerusal\xE9n \n                              </h3>\n                              <p><strong>Ciudad de David:</strong></strong> una experiencia arqueol\xF3gica inmersiva en el coraz\xF3n de la antigua Jerusal\xE9n, que incluye excavaciones arqueol\xF3gicas, visitas guiadas y un paseo por un t\xFAnel de agua subterr\xE1neo.</p>\n                              <p><strong>Espect\xE1culo nocturno de luz y sonido:</strong> un impresionante espect\xE1culo, el primero de esta clase, en el que las paredes de la Ciudadela se convierten en escenario de un espect\xE1culo nocturno que celebra los 4000 a\xF1os de historia de Jerusal\xE9n a trav\xE9s de im\xE1genes y sonidos.</p>\n                              <p><strong>El acuario: </strong>una de las atracciones m\xE1s populares de Jerusal\xE9n, inaugurado a finales de 2017, ofrece una aventura cautivadora a trav\xE9s de los cuatro mares de Israel que emocionar\xE1 a todos, desde j\xF3venes hasta mayores.</p>\n                              <p><strong>Time Elevator:</strong></strong> sum\xE9rjase con la realidad virtual en un viaje por la fascinante historia de Jerusal\xE9n, con asientos en movimiento y efectos especiales que sorprender\xE1n a todos.</p>\n                             <p><strong> El jard\xEDn bot\xE1nico:</strong> una impresionante joya en el coraz\xF3n de la ciudad, con m\xE1s de 6000 especies de plantas de todo el mundo, es un lugar interesante y tranquilo para que todo el mundo disfrute.</p>\n                              <p><strong>Segway Tours:</strong> adecuado para adolescentes algo m\xE1s mayores y adultos, los recorridos en Segway ofrecen una experiencia inolvidable a trav\xE9s de \xE1reas fascinantes, lo que le permitir\xE1 disfrutar del car\xE1cter moderno y antiguo de la ciudad.</p>\n                              <p><strong>Mini Israel: </strong>ofrece cientos de mini r\xE9plicas de monumentos israel\xEDes, una visi\xF3n \xFAnica a vista de p\xE1jaro de lugares hist\xF3ricos, religiosos y modernos de todo el pa\xEDs.</p>\n\n                              <h3>\n                                   Museos:\n                              </h3>\n                              <p><strong>Museo de Israel:</strong> un destacado museo de arte y arqueolog\xEDa que te sumerge en la rica historia y cultura del pa\xEDs y sus gentes, con exhibiciones que interesar\xE1n a visitantes de todas las edades.</p>\n                              <p><strong>Museo de la Torre de David:</strong> la hist\xF3rica entrada al casco antiguo de Jerusal\xE9n, la ciudadela medieval cuenta con modelos en 3D, pasadizos ocultos, y recorridos y actividades familiares.</p>\n                              <p><strong>Museo Activo Ein Yael:</strong> ofrece un viaje emp\xEDrico a trav\xE9s de una antigua calle romana, con talleres creativos, horneado de pitas y reuniones cara a cara con personajes de la \xE9poca, a las familias les encantar\xE1 este d\xEDa.</p>\n                             <p><strong> Museo de Ciencias Bloomfield:</strong> un fant\xE1stico museo cultural y educativo orientado a los ni\xF1os, que presenta exposiciones y exhibiciones interactivas sobre temas de ciencia y tecnolog\xEDa.</p>\n\n\n            \t"};}},{ctg:"telaviv",isVid:true,vidId:"ogEN7aRT0SM",id:"Party_Capital",bgImage:"/posts/bank/party-capital/1.jpg",mobBgImage:"/posts/bank/party-capital/M.jpg",title:"Party Capital",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t<div class=\"ac-cradit\">\n\t\t\t\t\t\t\t<span class=\"ac-cradit-text\">Credits:</span>\n\t\t\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t\t\t<span class=\"ac-cradit-text-1\">Tel Aviv Jaffa municipality<br/></span<\n\t\t\t\t\t\t\t\t<span class=\"ac-cradit-text-2\">UDINI prodactions<br/></span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p></p>\n\t\t\t\t\t\t</div>\n\n                            <h3>Epic Nights in the non stop city</h3>\n              \t\t        <p>Tel Aviv is rightly famous as one of the world\u2019s great nightlife cities, with her warm Mediterranean climate making it ideal to party outdoors for most of the year. As the sun goes down the city transforms into a welcoming nighttime experience that\u2019s pulsing with life.</p>\n\n                            <h3>Tel Aviv by Night</h3>\n                            <p>No matter what time it is, there\u2019s always something going on in Tel Aviv. Watch the sun go down at a casual beach bar, feet in the warm sand and a cold drink in your hand, before moving on to taste craft brews in a packed, friendly pub, enjoy an exotic cocktail in a relaxed bar or eat something delicious before heading off to one of Tel Aviv\u2019s pumping, pulsing clubs to dance the night away.</p>\n                            \n                            <p>Foodies will love the amazing cocktails mixed by Tel Aviv\u2019s expert baristas, Israel\u2019s lively pub scene serving craft beers and snacks, and the restaurants that range from elegant to casual to street pop-ups, offering every possible style and type of food. Eat your heart out!</p>\n                            <div class=\"img-wrapper\">\n\t\t\t                    <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/party-capital/1.jpg")+" class=\"img-responsive\" />\n\t\t                    </div>\n                            <h3>Making the Most of Tel Aviv\u2019s Nightlife</h3>\n                            <p>Spend a relaxed evening in an upmarket wine bar in a trendy neighborhood like Neve Tzedek, where you\u2019ll be introduced to some of Israel\u2019s highly acclaimed wines. Move on to chill at one of the many bars that feature live bands, or enjoy some culture with your cocktails in one of Tel Aviv\u2019s new and exciting gallery bars that display pieces by up and coming artists.</p>\n\n                            <p>If you want a pumping party night on the town, Tel Aviv is the right place to find it. Tel Aviv\u2019s nightclubs are world-famous, often hosting international DJs. During the long summer season some of the beaches transform into nightclubs for all-night raves, with throbbing beats, lasers and pulsing music. The party doesn\u2019t reach full swing until 2am in most of Tel Aviv\u2019s wildly popular nightclubs, manned by top DJs. You\u2019ll find every time of club, from intimate to massive and from throwback dance to the newest electric indie beats.</p>\n\n                            <p>The LGBTQ scene is also hot in Tel Aviv, with some of the best parties and music nights hosted by gay-friendly clubs and bars. Whether you want chilled or full-on, cultural or flirty, you\u2019ll find countless places to hang out at every hour of the day and night.</p>\n                            <p>Tel Aviv\u2019s awesome nightlife scene has become famous worldwide. The city the doesn\u2019t stop is teaming up with endless possibilities designed for an epic night out! </p>\n                            <p>Start slow and easy in a bar at the chilled out Port of Tel Aviv, or grab yourself a shoreline table, perhaps at Jerusalem Beach. Order a beer, feel the sand between your toes, and watch the sunset.</p>\n                            <p>Now that you\u2019re in a mellow mood, it\u2019s time to get your groove on. you\u2019ll be spoiled for choice with upscale clubs, bracelet bars, and other hangouts around Tel Aviv\u2019s White City, Rothschild Boulevard and nearby streets (Levontin, Yehuda HaLevi, Lillenblum, and Allenby), with their trendy see and be seen vibe, filled with young party people all night long. </p>\n                            <div class=\"img-wrapper\">\n\t\t\t                    <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/party-capital/2.jpg")+" class=\"img-responsive\" />\n\t\t                    </div>\n                            <p>A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don\u2019t miss the up and coming hipster style Flea Market area in Jaffa.</p>\n                            <p>Want a more mainstream approach to a night on the town? Three streets \u2013 King George, Dizengoff, and Ibn Gabirol \u2013 will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.</p>\n                            <p>Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv! </p>\n\n            \t"};}},(_ref2={ctg:"jerusalem",isVid:false,id:"Mamilla_Avenue",bgImage:"/posts/bank/mamila-avenue/1.jpg",mobBgImage:"/posts/bank/mamila-avenue/M.jpg",title:"AVENIADA MAMILLA, UN PASEO POR EL ARTE",smltitle:""},_defineProperty(_ref2,"isVid",true),_defineProperty(_ref2,"vidId","JxSjC2kZfvI"),_defineProperty(_ref2,"html",function html(){return{__html:"\n                               \n\n\t\t                         <h3>Lujo moderno con el esplendor de la Jerusal\xE9n antigua</h3>\n\t\t\t\t\t\t\t\t<p>Justo entre la antigua y nueva Jerusal\xE9n, frente a la impresionante vista de las murallas de la Ciudad Vieja y a pocos pasos de la Puerta de Jaffa y el Muro Occidental, se encuentra la avenida Alrov Mamilla. El moderno centro comercial al aire libre, que se hizo popular entre los lugare\xF1os y turistas por su proximidad a la ciudad vieja y al reunir lo mejor de todos los mundos: rica historia, cultura local y una sofisticada experiencia de compras en una ubicaci\xF3n inmejorable.</p>\n                                <div class=\"img-wrapper\">\n\t\t\t                         <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/mamila-avenue/1.jpg")+" class=\"img-responsive\" />\n\t\t                         </div>\n\t\t\t\t\t\t\t\t<h3>Descubra el moderno complejo de ocio a los pies de la Ciudad Vieja de Jerusal\xE9n</h3>\n\t\t\t\t\t\t\t\t<p>Camine por las calles adoquinadas de Jerusal\xE9n y busque las placas que cuentan la&nbsp;historia&nbsp;de las estructuras hist\xF3ricas de la zona. Disfrute de las actuaciones de teatro callejero, si\xE9ntese en uno de los restaurantes y caf\xE9s locales y disfrute de una mezcla de gran calidad de tiendas de dise\xF1adores de marcas locales y l\xEDderes mundiales.</p>\n\t\t\t\t\t\t\t\t<p>Por la noche, tome asiento en uno de los excelentes bares de la zona, alce los ojos y admire la espectacular vista de la Ciudad Vieja justo enfrente. No hay otro lugar como este en el mundo.</p>\n\t\t\t\t\t\t\t\t<h3>Visite las calles que unen la Ciudad Vieja con la Nueva Jerusal\xE9n</h3>\n\t\t\t\t\t\t\t\t<p>La Avenida Mamilla es un complejo de entretenimiento contempor\xE1neo que ofrece a sus visitantes un sabor de la rica, original y siempre innovadora cultura de Jerusal\xE9n.</p>\n\t\t\t\t\t\t\t\t<p>Para experimentar plenamente lo que la Avenida Mamilla tiene para ofrecer, la mejor \xE9poca es cuando el clima es c\xE1lido. Miles de personas pasean por la avenida cada noche, con algo m\xE1s de fresco, durante el verano y disfrutan de una variedad de eventos culturales. \xDAnase a ellos y disfrute de las ferias de arte callejero, exposiciones abiertas, teatro de calle, payasos, acr\xF3batas, bateristas y actuaciones musicales diarias. Con tanto que ver y hacer, nunca querr\xE1 irse.</p>\n\n            \t"};}),_ref2),{ctg:"jerusalem",isVid:true,vidId:"nLKWDp5uA-U",id:"First_Time_In_Jerusalem",bgImage:"/posts/bank/first-time-in-jerusalem/1.jpg",mobBgImage:"/posts/bank/first-time-in-jerusalem/M.jpg",title:"FIRST TIME IN JERUSALEM",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t<h3>The must list for the first-time visitor</h3>\n\n              \t\t<p>\n\t\t\t\t\t\tScour the globe it\u2019s hard to match Jerusalem for history, culture, and significance! So rich in sites and activities, it\u2019s difficult to know where to begin. Here are a few suggestions\u2026\n              \t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tJerusalem is the nexus of three of the world\u2019s great faiths. As such, you might want to consider religious, spiritual, or historical locations that will be meaningful to you.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tAlmost any itinerary will include Old City. Famous as the home of the Western Wall, and the Church of the Holy Sepulcher, you could spend days exploring its four quarters \u2013 Jewish, Christian, Muslim, and Armenian \u2013 and only see but a small part of its many treasures. Make sure to download the free Audio Tours of Jerusalem app, which offers dozens of walking routes, GPS maps, and geo-location alerts as you approach each site.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/first-time-in-jerusalem/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tA five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don\u2019t miss the up and coming hipster style Flea Market area in Jaffa.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tWant a more mainstream approach to a night on the town? Three streets \u2013 King George, Dizengoff, and Ibn Gabirol \u2013 will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tWherever you go, you will always find where to have an awesome night in nonstop Tel Aviv!\n\t\t\t\t\t</p>\n            \t"};}},{ctg:"telavivAndJerusalem",isVid:false,id:44,bgImage:"/posts/bank/travelling-on-budget/1.jpg",mobBgImage:"/posts/bank/travelling-on-budget/M.jpg",title:"TRAVELLING ON A BUDGET",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t    <h3>Making It Count in Tel Aviv and Jerusalem!</h3>\n\n              \t\t<p>\n\t\t\t\t\t\tSo you\u2019ve heard of the stunning beaches, the amazing sights and the fabulous cuisine and you are looking to travel to Jerusalem and Tel Aviv, but affordability is a concern. Well, pack your bags and worry no more! Both cities offer low-cost accommodations, transportation, and meals, as well as countless sites to see and things to do, which require little or no expense.\n              \t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tFor affordable accommodation you can choose from the many hostels and smaller hotels, many of which are located only a few minutes\u2019 walk from Tel Aviv\u2019s Beaches and Jerusalem\u2019s main attractions.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tGetting around? In both cities it\u2019s a snap with a Rav Kav card. Purchase one for little more than a dollar at\u201DAl Hakav\u201D (on the line) Service centers at central stations and other locations around the city. Jerusalem also offers an affordable City Pass option, and in Tel Aviv, the Tel Ofan bicycle rental municipal service is a great and low cost way to get around in the city.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/80/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tWhat to do? Jerusalem and Tel Aviv are packed with sites, marketplaces, parks, nearby nature reserves and hiking trails. There are endless ways to not spend a dime and fill your trip with unforgettable experiences.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tFinally, everyone\u2019s gotta eat, from hummus to gourmet, both cities are famous for great street food and low-price restaurants offering cheap lunch time dining.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSo come visit Tel Aviv and Jerusalem where you are guaranteed a fantastic time without breaking the bank.\n\t\t\t\t\t</p>\n            \t"};}},{ctg:"jerusalem",isVid:false,id:45,bgImage:"/posts/bank/upscale-jerusalem/1.jpg",mobBgImage:"/posts/bank/upscale-jerusalem/M.jpg",title:"UPSCALE JERUSALEM",smltitle:"",html:function html(){return{__html:"\n                    <h3>Modern luxuries for the pampered traveler</h3>\n              \t\t<p>\n\t\t\t\t\t\tWhen it comes to luxury travel, high class accommodations, fine dining, and top-drawer shopping options Jerusalem is a city that\u2019s truly arrived.\n              \t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe city features numerous 5-star and boutique hotels ready to custom cater to your needs for comfort and relaxation, offering amazing rooftop views and inhouse spa treatments to boot.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/81/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tLooking to delight your palette? Well, in 2018, several Jerusalem establishments were listed in the prestige French restaurant guide, Gault & Millau. Beyond that, the city features and is increasingly attracting some of the world\u2019s best chefs.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tWhen it comes to style, fashion, and swanky shopping, Jerusalem has any number of places you\u2019ll want to visit. Among these are Arlov Mamilla Avenue. This happening and trendy outdoor mall complex is a must for your go-to city destinations. Even better, it\u2019s situated just steps away from the Old City\u2019s Jaffa Gate.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tAnother not-to-be-missed stop on your itinerary is the elegant The First Station. For over 100 years a railway depot, the site has been transformed into an urban shopping and culinary mecca that\u2019s chock-a-block with restaurants, shops, art galleries and an artists\u2019 marketplace three days a week, as well as live performances and more.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tAnd as long as you\u2019re in the neighborhood, treat yourself to a romantic afternoon or evening on Emek Refaim Street, the German Colony\u2019s main thoroughfare. Its beguiling architecture laid back mood, stylish boutiques, intimate restaurants, and 1920s-era cinema offer an absolute treat for all the senses.\n\t\t\t\t\t</p>\n            \t"};}},// End Posts
{id:5,ctg:"deadsea",isVid:false,bgImage:"posts/bank/100/1.jpg",mobBgImage:"posts/bank/100/M.jpg",title:"Dead Sea Joys",smlTitle:"",html:function html(){return{__html:"\n\t\t\t\t\t<h3>For a floating good time</h3>\n\n\t\t\t              <p>\n\t\t\t                              A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction. \n\t\t\t                              Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. \n\t\t\t                              <strong>The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, \n\t\t\t                              allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. \n\t\t\t                              While here, you can bathe</strong> in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.\n\t\t\t              </p>\n\n\t\t\t              <p>\n\t\t\t                              Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.\n\t\t\t              </p>\n\t\t\t              \n\t\t\t"};}},// No translation, Hadar asked to hide this post
// {
// 	id:"Ultimate_Beach_Fun",
//                bgImage : "/posts/bank/17/1.jpg",
//         	mobBgImage : "/posts/bank/17/M.jpg",
//               title : "ULTIMATE BEACH FUN",
//               ctg:"telaviv",
//               isVid:true,
//               vidId:"I9a4BFWO_6w",
//               smltitle : "",
//               html: function(){
// 			return {
// 				__html: `
//             		<p>Israel has a wide selection of beaches to choose from. The wide Mediterranean stretch along the west side of the country boasts wide golden sands and the gorgeous blue waves of the med.</p>
//         		 	<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/24/1.jpg"} class="img-responsive" />
// 					</div>
//             		<p>Up North the Sea of Galilee have some lovely beaches where you can camp out, barbeque and really make a day of it. The Galilee offer boat hire and water sport equipment for some water fun!</p>
//             	 `
//     }
//   }
// },
// End No translation, Hadar asked to hide this post
{id:"Purchases_In_Israel",bgImage:"/posts/bank/purches-in-israel/1.jpg",mobBgImage:"/posts/bank/purches-in-israel/M.jpg",title:"COMPRAS EN ISRAEL",ctg:"jerusalem",isVid:false,smltitle:"",html:function html(){return{__html:"\n              \n              \n                                   \n                                <p>Ir de compras en Israel es algo m\xE1s que adquirir cosas. Se convierte en la mejor manera de pensar en sus seres queridos y amigos en casa, porque les traer\xE1 (y para usted tambi\xE9n) un bolso, una botella o una caja que simboliza las maravillas que vivi\xF3. A medida que avanza a trav\xE9s de los mercados, tiendas y galer\xEDas, ver\xE1 la incre\xEDble variedad de productos y seguro que encontrar\xE1 algo para todos y se divertir\xE1 al mismo tiempo.</p>\n\t\t\t\t\t\t\t\t<h3>Hermosos souvenirs de Oriente Medio</h3>\n\t\t\t\t\t\t\t\t<p>Algunos de los recuerdos m\xE1s significativos le est\xE1n esperando en los lugares santos de Israel en Galilea y Jerusal\xE9n. Los llamativos art\xEDculos de cer\xE1mica armenia en azul y blanco adornados con temas familiares de los lugares sagrados son populares como recuerdos y \xFAtiles como platos para la mesa. Madera de olivo y n\xE1car, artesan\xEDas que recrean siglos de antig\xFCedad, ahora adornan biblias, cajas, broches y muchos otros elementos que mantendr\xE1n su visita fresca en su mente y coraz\xF3n.</p>\n\t\t\t\t\t\t\t\t<h3>Judaica \xFAnica</h3>\n\t\t\t\t\t\t\t\t<p>\xA1Qu\xE9 mejor manera de recordar Safed, Jerusal\xE9n, Jaffa u otros centros judaicos que adornar una mesa de Sabbath y de fiestas que&nbsp; una cobertura bordada a mano para Challah o matzah (\xA1ligera y f\xE1cil de guardar en la maleta!) o candelabros,&nbsp; una copa de kiddush o una menorah de Chanukkah en plata contempor\xE1nea o tradicional, esta\xF1o, vidrio o cer\xE1mica. Las mezuzahs son el regalo perfecto para una fiesta de inauguraci\xF3n de una casa, y un manto de oraci\xF3n (talit) es un recuerdo de Bar / Bat Mitzvah para toda la vida.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t               <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/purches-in-israel/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\n\t\t\t\t\t               </div>\n\t\t\t\t\t\t\t\t<h3>Cosm\xE9tica y Productos minerales del mar Muerto</h3>\n\t\t\t\t\t\t\t\t<p>Israel es el hogar del spa al aire libre m\xE1s grande del mundo - el mar Muerto - y despu\xE9s de ba\xF1arse en su agua rica en minerales, su piel y su cabello tendr\xE1n una suavidad incomparable. Y s\xED, efectivamente, \xA1lo comercializan! Puede comprar una gama entera de productos realizados en base a los minerales del mar Muerto, embalados maravillosamente.&nbsp; Son el regalo perfecto de Israel.</p>\n\t\t\t\t\t\t\t\t<h3>Compras</h3>\n\t\t\t\t\t\t\t\t<p>Seguramente querr\xE1 curiosear por las tiendas&nbsp;o boutiques de dise\xF1adores de ropa israel\xEDes en su estancia en Israel. Ropa de beb\xE9 100% algod\xF3n tambi\xE9n es f\xE1cil de meter en su maleta como regalo. \xBFHa caminado por Israel? Antes de que su viaje termine, compre un par de sandalias o zapatos hechos en Israel.</p>\n\t\t\t\t\t\t\t\t<h3>Joyer\xEDa</h3>\n\t\t\t\t\t\t\t\t<p>Los dise\xF1adores de joyer\xEDa israel\xEDes se encuentran en las mejores tiendas de todo el mundo y cuando usted compra en Israel est\xE1 en el lugar de origen. Particularmente, son atractivos los brazaletes de moda con sus cristales multicolores y abalorios con dise\xF1os interminables, as\xED como las creaciones en malaquita fina verde-azul (piedra de Eilat) y as\xED todos sabr\xE1n que estuvo en Israel cuando se lo ponga.</p>\n\t\t\t\t\t\t\t\t<p>Israel ha sido durante mucho tiempo famoso por el tallado y pulido de sus diamantes y la experiencia, el conocimiento y la habilidad de sus expertos en diamantes es \xFAnica. Como un pa\xEDs exportador de diamantes, comprar en Israel a menudo goza de la ventaja de un precio reducido. Tambi\xE9n puede visitar una instalaci\xF3n de tallado y pulido de diamantes para aprender todo sobre la industria.</p>\n\t\t\t\t\t\t\t\t<h3>No se olvide de la comida</h3>\n\t\t\t\t\t\t\t\t<p>En un pa\xEDs famoso por su cocina de los cuatro rincones de la tierra, los productos alimenticios envasados&nbsp; son ideales para llevar a casa. Hay especias como el hisopo b\xEDblico para su cocinero favorito y d\xE1tiles dulces bien envasados para ofrecer en su oficina o club de lectura, y una variedad de t\xE9s de hierbas, miel, premiados vinos y otros productos.</p>\n\t\t\t\t\t\t\t\t<p>Y cuando usted y sus regalos lleguen al aeropuerto, le encantar\xE1 el incentivo especial de reembolso de Impuestos al valor a\xF1adido en compras de m\xE1s de $ 100 en las tiendas participantes.</p>\n\t\t\t\t\t\t\t\t            \t\n            \t "};}},// {
// 	id:"Jerusalem_Fun",
//                bgImage : "/posts/bank/jerusalem-fun/1.jpg",
//         	mobBgImage : "/posts/bank/jerusalem-fun/M.jpg",
//               title : "JERUSALEM FUN",
//               ctg:"jerusalem",
//               isVid:true,
//               vidId: "nLKWDp5uA-U",
//               smltitle : "",
//               html: function(){
// 			return {
// 				__html: `
//                                <p>Planning a trip to Jerusalem usually involves its many sights of culture and historical significance. However, just as important to many, Jerusalem’s has an amazingly cool after dark scene, filled with music, hipster hangouts, dance clubs, and much more.</p>
//                                 <div class="img-wrapper">
// 						               <img src=${getImgUrl() +  "/posts/jerusalem-fun/1.jpg"} class="img-responsive" />
// 					               </div>
//                                  <p>To check it out, make your way to the <b>City Center</b> and explore the narrow streets just off <b>Jaffa Street</b>. There you’ll find bars and nightclubs that range from comfortably mainstream to eccentrically funky. <b>Rivlin Street</b> is a popular hangout for young people, while <b>Shoshan Street</b> and the surrounding area offers a more laid-back grown up vibe.</p>
//                                  <p>Machane Yehuda market offers a surprisingly awesome night out as in the evening it transforms into a trendy hotspot where vendor stalls and shops become the setting for bars, DJs, live music, and dancing.</p>
//                                  <p>Betzalel Street is famous for its student artsy vibe and the many little bars are a great place to befriend the locals who come for a drink and a jam session.</p>
//                                  <p>For a daytime change of pace head to the <b>German Colony (Moshava)</b> and, particularly, the neighborhood of <b>Baka</b>. Start at <b>Beit Lechem Street</b> where you’ll have your choice of popular, contemporary restaurants and bars. Then stroll all the way up <b>Emek Refaim Street</b> or through <b>HaMesila (Railway) Park</b> until you reach The <b>First Station</b> – once a railroad depot in use for over a century, it transformed now into a trendy culinary, cultural, and retail delight.</p>
//             	 `
//     }
//   }
// },
{id:"Western_Wall_Wonders",bgImage:"/posts/bank/30/1.jpg",mobBgImage:"/posts/bank/30/M.jpg",title:"WESTERN WALL WONDERS",ctg:"jerusalem",isVid:false,player_id_post:"",smltitle:"",html:function html(){return{__html:"\n              \n\n\t\t\t\t<p>\n\t\t\t\t\tThe Western Wall (or Kotel, in Hebrew) was part of the most magnificent building Jerusalem had ever seen, which was the Second Temple, built by the great King Herod.\n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\tThe Second Temple was destroyed in the year 70 CE and despite the destruction that took place, all four of the Temple Mount support walls remained standing.  Throughout the generations since the Temple\u2019s destruction, the Western Wall was the remnant closest to the site of the Temple\u2019s \u2018holies of holies - a place where only the Jewish High Priests were allowed, as it was there they believed God was present.  The actual remains of the Temple can be found the Western Wall Tunnels, which are an extraordinary journey through time.\n\t\t\t\t</p>\n\t\t\t\t\n             \t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/27/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\n\t\t\t\t<p>\n\t\t\t\t\tFor centuries Jewish People from around the world have been going there to mourn the loss of this grand temple. You will often find hundreds of people of different nationalities and religions\u2019 pouring out their heart with prayers as the wall is believed to have enormous spiritual significance. \n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\tIt is tradition for the people that visit to write a note and place it in the cracks of the Western Wall, as it is believed the message will be taken to God. You will often find doves resting in the crevices of this impressive structure, which are a symbol of peace.\n\t\t\t\t</p>\n\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/27/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\n\t\t\t\t<p>\n\t\t\t\t\tThe Western Wall is a national symbol as the ancient bricks have seen Israel and the Jewish peoples  birth, exile and redemption. It\u2019s a very popular location for national ceremonies and even Bar Mitzvah to take place\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tFor more information   <a  target=\"_blank\" href=\"//www.thekotel.org\">www.thekotel.org</a>\n\t\t\t\t</p>\n                \n            \t "};}},{id:28,bgImage:"/posts/bank/white-city-splendor/1.jpg",mobBgImage:"/posts/bank/white-city-splendor/M.jpg",title:"WHITE CITY SPLENDOR",ctg:"telaviv",isVid:false,smltitle:"",html:function html(){return{__html:"\n              \n\t\t\t\t\n\n\t\t\t\t<p>\n\t\t\t\t\tTel Aviv\u2019s \u201CWHITE CITY\u201D is a UNESCO World Heritage Site, because the city is home to more Bauhaus, modern and \u201CInternational\u201D architecture than any city on earth.\n\t\t\t\t</p>\n\n\t\t\t\t\n\t\t\t\t\n             \t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/28/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\n\t\t\t\t<p>\n\t\t\t\t\tTel Aviv was founded in 1909 as a garden suburb of the crowded port city of Jaffa. Very quickly it grew into a bustling metropolis so that by 1929, it was a flourishing city that was the apex of the Zionist dream. With the rise to power of Hitler in 1933, dozens of German Jewish architects escaped to Palestine \u2013 many of whom were students or graduates of the legendary Bauhaus school of design. The burgeoning of Tel Aviv required more and more buildings, and the arriving architects very quickly adapted their northern European Bauhaus design to the needs of the eastern Mediterranean heat. A walk through central Tel Aviv will bring you face to face with dozens of these extraordinary office buildings, apartment buildings and stores.\n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\t<a  target=\"_blank\" href=\"//www.bauhaus-center.com/\">www.bauhaus-center.com/</a>\n\t\t\t\t</p>\n                \n            \t "};}},{id:"Tower_Of_David_Museum",bgImage:"/posts/bank/30/1.jpg",mobBgImage:"/posts/bank/30/M.jpg",title:"TOWER OF DAVID MUSEUM",ctg:"jerusalem",isVid:false,smltitle:"",html:function html(){return{__html:"\n            \n\n\t\t\t\t<p>\n\t\t\t\t\tJerusalem\u2019s Citadel, known as the \u201CTower of David\u201D, is a historical and archaeological asset of international significance. The Tower is a medieval fortress that is located near the Jaffa Gate, the historical entrance to the Old City and has been the symbol for the city of Jerusalem for generations.\n\t\t\t\t</p>\n\n\t\t\t\t\n\t\t\t\t\n             \t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/29/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\n\t\t\t\t<p>\n\t\t\t\t\tAt the Tower of David Museum you are presented with Jerusalem\u2019s astounding story. While absorbing yourself in legends of the past and their dramatic chronicles it will not take you long to realise that the very stones of the museum are part of this city\u2019s living history.\n\t\t\t\t</p>\n\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/29/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\n\n\t\t\t\t<p>\n\t\t\t\t\tThe 500-year-old walls are part of the Turkish citadel; its name derives from a tower so massive that early Jerusalemites ascribed it to their great King David and despite the name being \u2018The Tower of David\u2019 it was actually build by King Herod.\n\t\t\t\t</p>\n\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/29/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\n\t\t\t\t<p>\n\t\t\t\t\tYour visit can begin with a breath-taking view of old and new Jerusalem from the top of the tower. Each ancient room has been revamped to showcase a different period, allowing the tempestuous events of 4,000 years to fall perfectly into place in your mind.\n\t\t\t\t</p>\n\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/29/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\n\t\t\t\t<p>\n\t\t\t\t\tThe windows frame glimpses of modern Jerusalem, and with each doorway you exit, you look down into the citadel\u2019s central courtyard, where archaeologists have unearthed remains dating from the Maccabees to the Middle Ages. This incredible site really is a maze of time!\n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\tThe museum also utilizes its unique space for multi-sensory exhibits by leading designers and artists from Israel and abroad. This One of a kind museum hosts the annual \u2018Night Spectacular\u2019 which is a unique sound and light show where the whole of the Citadel is lit up with stunning designs!\n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\tFor more information:   <a href=\"//www.tod.org.il/en/\">www.tod.org.il/en/</a>\n\n\t\t\t\t</p>\n                \n            \t "};}},{id:"Must_Eat_In_Jerusalem",bgImage:"/posts/bank/must-in-jerusalem/1.jpg",mobBgImage:"/posts/bank/must-in-jerusalem/M.jpg",title:"Qué debe probar en Jerusalén",ctg:"jerusalem",isVid:true,vidId:"2CSCe2WC7Ns",smltitle:"",html:function html(){return{__html:"\n            \n                               <p>Jerusal\xE9n es una ciudad fascinante y m\xE1gica. Muchas personas que visitan Jerusal\xE9n alaban su sorprendente atm\xF3sfera, sus lugares inolvidables, sus impactantes vistas y mucho m\xE1s. Sin embargo, para entender realmente de qu\xE9 trata Jerusal\xE9n, hay algunas cosas que sencillamente tendr\xE1 que experimentar a trav\xE9s de su est\xF3mago. Aqu\xED tiene algunas de las cosas que deber\xEDa probar durante su visita:</p>\n                    \n                               <div class=\"img-wrapper\">\n\t\t\t\t\t\t                 <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/must-in-jerusalem/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t                 </div>\n\n\t\t\t\t\t\t\t    <p><strong>Malabi:</strong> una combinaci\xF3n \xFAnica de bebida y postre, una mezcla a base de agua de rosas, leche, harina de ma\xEDz y az\xFAcar. El Malabi es un plato muy popular de Jerusal\xE9n, que se vende en muchos restaurantes y kioscos de Oriente Medio por toda la ciudad. Le garantizamos que no ha probado nunca nada parecido.</p>\n                                <p><strong>Knafe:</strong> un plato muy interesante y con un sabor sensacional cuando se sirve y come fresco. El Knafe es esencialmente un postre \xE1rabe hecho de queso de cabra fundido y cubierto con hilos de pasta de naranja, ba\xF1ado en sirope de agua de rosas dulce. Encontrar el Knafe perfecto es una misi\xF3n, y una vez que lo encuentre, comerlo se convertir\xE1 en una adicci\xF3n.</p>\n                                <p><strong>Pretzel de Jerusal\xE9n:</strong> cuando recorra los fascinantes lugares de la Ciudad Vieja no olvide parar en uno de los carritos verdes y comprar un aut\xE9ntico pretzel de Jerusal\xE9n. Junto con este, obtendr\xE1 una hierba verde local arom\xE1tica llamada Zaatar que combina muy bien con la deliciosa masa.</p>\n                                <p><strong>Meorav Yerushalmi:</strong> se traduce literalmente como \"Jerusal\xE9n mixto\". Esta deliciosa mezcla de varias carnes con una combinaci\xF3n local de especias \xFAnica es una delicia total para los carn\xEDvoros.</p>\n                                <p><strong>Ashtanur:</strong> abreviatura en hebreo de \"fuego en el horno\", el Ashtanur es un aut\xE9ntico pan de pita local que podr\xE1 encontrar en el centro de la ciudad o en los mercados durante el almuerzo. Si est\xE1 especialmente hambriento, pru\xE9belo con shawarma o falafel.</p>\n                                <p><strong>Sabij:</strong> absolutamente original, el Sabij es un plato local verdaderamente \xFAnico compuesto por un pan de pita relleno de berenjena frita, huevos duros y pepinillos, generalmente cubierto por Amba, un sabroso condimento local. Una vez que lo pruebe, se enganchar\xE1 de por vida.</p>\n\n                \n            \t "};}},{id:"Jerusalem_Arts",bgImage:"/posts/bank/jerusalem-art/1.jpg",mobBgImage:"/posts/bank/jerusalem-art/M.jpg",title:"JERUSALEM’S ART",ctg:"jerusalem",isVid:false,smltitle:"",html:function html(){return{__html:"\n            \n                                <h3>Finding Inspiration in Jerusalem</h3>\n\n                                <p>There's no doubt Jerusalem is one of the most fascinating cities in the world. Its fusion of diverse religions, traditions, ancient history and modern city life intrigues visitors for centuries. It's also what attracts artists there. Today's Jerusalem is full of Museums, galleries, marketplaces and cultural festivals, which together form a vivid and unique Art and Culture scene. Prepare to be inspired.</p>\n\n                                <p>Discover. On a hill next to the Knesset and Israel's Supreme Court, situated Israel's largest cultural institution and one of the world's leading museums in art and archeology, The Israel Museum. Start with the archeological wing. Organized chronologically, the pieces there form the most extensive collection in the world for biblical and Holy Land archeology. Continue to the outstanding Jewish Art and Life wing, the impressive Fine Arts collection and the rotating contemporary art exhibitions. Don't miss few of the museum's highlights \u2013 The Shrine of The Book which holds the Dead Sea Scrolls and the stunning Art Garden looking over the Jerusalem Mountains. Tip: Give yourself time. It's an accessible, fascinating museum and there's so much to see.</p>\n                                <div class=\"img-wrapper\">\n\t\t\t\t\t\t                <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/jerusalem-art/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t                </div>\n\t\t\t\t\t\t\t    <small style=\"color:#000; display:block;\">\n                      \t\t        Credit: Noam Chen\n                      \t        </small>\n\n\t\t\t\t\t\t\t\t<p>In close proximity to the Israel Museum you'll find the riveting <strong>Bible Lands Museum</strong>. Describes as \"an interactive time capsule\", it's the only museum of its kind in the world. Tour through the galleries and discover the wonders of the lives of ancient cultures in the Near East and their interrelations from the dawn on of civilization to the early Christian era.</p>\n\n                                <h3>Experience</strong>. Go to <strong>The Artists' Colony of Jerusalem</strong> (Hutzot Hayotzer) and experience creativity. This Art and Craft complex is a workplace for artists and designers from various fields. Stroll down this picturesque boulevard of shops and galleries underneath the northern walls of the Old City and see artists at work. Hear stories, learn about traditional and more contemporary art techniques and purchase works directly from the artists.</p>\n\n                                <p>See the <strong>Tower of David Light Show</strong>, known as the Jerusalem Night Spectacular. This truly stunning show combines modern technology with the city's history and the beauty of the Tower. You'll witness the walls and walkways comes alive with a 3D light show and vibrant music that pulls the viewer into an almost dreamlike experience.</p>\n\n                                <h3>Celebrate</strong>. Jerusalem has rich history but it's also a bustling modern city that loves to celebrate. Make sure to check the city's rich schedule of festival and cultural events and enjoy of the best Jerusalem has to offer throughout the year.</p>\n\n                                <p>Celebrate <strong>The Israel Festival</strong>, Israel's prominent multidisciplinary international festival that presents a large variety of outstanding theatre, contemporary dance, classical music and performance from all around the world. Join the Jerusalem Arts and Craft fair Hutzot Hayotzer where you'll meet Israeli and international artists and listen to great music; visit Jerusalem Night Market and stroll through the many stalls set by all types of artists and designers, showing off and selling their wares; Experience the Light in Jerusalem Festivalthat provides a dramatic unique and artistic dimension to the old city through use of light; listen to opera in the Jerusalem Opera Festival. Set in the Sultan pool, you'll watch great performance with the great Jerusalem night summer air and stunning view as a backdrop.</p>\n\n                                <p>Don't miss the Jerusalem Sacred Music Festival. As part of the Jerusalem Season of Culture, this extraordinary festival brings together diverse artists from huge array of fields, cultures and traditions that show and explore 'sacred' music from all around the world.</p>\n            \t\n                \n            \t "};}},{id:"All_Sensory_Markets",bgImage:"/posts/bank/1.jpg",mobBgImage:"/posts/bank/M.jpg",ctg:"jerusalem",isVid:false,title:"ALL SENSORY MARKETS",player_id_post:"",smltitle:"",html:function html(){return{__html:"\n            \n\n\t\t\t\t<p>\n\t\t\t\t\tFor a genuine Middle Eastern experience you can\u2019t beat a visit to one of Israel\u2019s many markets (Shuks).  The different colours, textures, smells, tastes and sounds of these hives of activity can be a highlight of any Israel visit.  \n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\tThese markets are a melting pot of cultures and a great place to give your bartering skills a go. Through the winding cobbled streets you will find, fresh produce, souvenirs, art and handmade jewellery\u2026the list is endless. Bring home a gift for your friends and family or just enjoy walking around and tasting different flavours.\n\t\t\t\t</p>\n\t\t\t\t\n\t\t\t\t\n             \t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/30/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\n\t\t\t\t<h3>\n\t\t\t\t\tTel Aviv\n\t\t\t\t</h3>\n\t\t\t\t<p>\n\t\t\t\t\tThe Carmel Market, or Shuk HaCarmel, is the most famous of all Tel Aviv\u2019s marketplaces. In recent years, it\u2019s even joined the ranks of Tel Aviv\u2019s trendy spots for bars, restaurants, coffee shops and chef-owned food stalls. It\u2019s no wonder Shuk HaCarmel is Tel Aviv\u2019s largest and most-centrally located shuk: From hand-made Jachnun, a traditional Yemenite dish, to boutique cheeses, and from one-off cotton clothes to designer threads, HaCarmel has it all. Plan your visit around your tastebuds and food preferences - salted fish, cured meats, Middle Eastern fare, fresh baked French pastries, and local-roasted coffee or fresh-pressed fruit or vegetable juice blends to wash it all down.\n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\t<a target=\"_blank\" href=\"//www.shuktlv.co.il/en/category/carmel-market\">\n\t\t\t\t\t\twww.shuktlv.co.il/en/category/carmel-market\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/30/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\n\t\t\t\t<p>\n\t\t\t\t\tNachlat Binyamin arts and crafts fair was established in 1988. It is the oldest and biggest of its kind in Israel, and one of the nicest in the world. The market is home to over two hundred artists who use materials such as wood, glass, fabric, plastic, paper\u2026even rocks (almost anything) to hand-make what they sell on their stall. \n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\t<a target=\"_blank\" href=\"//www.shuktlv.co.il/en/category/carmel-market\">\n\t\t\t\t\t\twww.shuktlv.co.il/en/category/carmel-market\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/30/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\t\t\t\t<h3>\n\t\t\t\t\tJerusalem\n\t\t\t\t</h3>\n\n\t\t\t\t<p>\n\t\t\t\t\tThe Machane Yehuda market is widely recognized as a symbol of the Jerusalem, and for a very good reason: Jerusalemites see it as a place that represents them, symbolizes them, and gives them a unique identity in a larger Israeli social context. Jerusalem today has many shopping and entertainment centres, but there is something about the Machane Yehuda market that attracts people, even without a shopping list.  From the heady scent of spices to the colourful displays of fruits and vegetables, a trip to this market is pleasing for all your senses.\n\t\t\t\t</p>\n\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/29/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\n\t\t\t\t<p>\n\t\t\t\t\tOne option of experiencing this market is by buying a \u2018Machane Yehuda Bites Card\u2019.  This card is comprised of vouchers curated in order to give you a chance to try a variety of products, flavours and the aromas of the market - without having to depend on an organized group or tour.  For more information please click here: \n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\t<a target=\"_blank\" href=\"//www.machne.co.il/en/\">\n\t\t\t\t\t\thttp://www.machne.co.il/en/\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\t\t\t\t\n                \n            \t "};}},{id:31,bgImage:"/posts/bank/20/1.jpg",mobBgImage:"/posts/bank/20/M.jpg",title:"UNFORGETTABLE YAD VASHEM",ctg:"jerusalem",isVid:false,player_id_post:"",smltitle:"",html:function html(){return{__html:"\n            \n\n\t\t\t\t<p>\n\t\t\t\t\tYad Vashem, Israel\u2019s main Holocaust remembrance and education centre is situated on the green slopes of Har HaZikaron, (the Mount of Remembrance) in Jerusalem.\n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\tIsrael\u2019s Holocaust commemoration project began in 1953 with the task of perpetuating the memory of Holocaust victims and documenting the history of the Jewish people during the Holocaust so that it will be remembered by future generations. This project was an important step for the young nation of Israel at the time and was significant for the citizens of Israel, particularly for the survivors of the ghettos and concentration camps.\n\t\t\t\t</p>\n\t\t\t\t\n\t\t\t\t\n             \t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/31/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\n\t\t\t\t<p>\n\t\t\t\t\tThe new Yad Vashem museum was opened to the public in 2005. The museum is designed in the shape of a prism penetrating the mountain. Divided into nine galleries, the museum relates the stories of the Jewish communities before the Second World War and the series of events beginning from the rise of the Nazis to power, the pursuit of the Jews, their eviction to the ghettos and ending with \u201Cthe Final Solution\u201D and mass genocide\n\t\t\t\t</p>\n\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/31/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\n\n\t\t\t\t<p>\n\t\t\t\t\tThe personal experiences and feelings of the victims of the Holocaust constitute the groundwork for the museum\u2019s exhibits. Photographs, films, documents, letters, works of art, and personal items found in the camps and ghettos are all an integral part of the exhibits. As you exit the Museum itself is the Hall of Names, an inspiring memorial containing over three million names of Holocaust victims that were submitted by their families and relatives. Names can still be submitted by visitors to the memorial and added to the computerized archive.\n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\tIn addition to the Holocaust History Museum Yad Vashem has other memorials and monuments including  the Hall of Remembrance, where the ashes of the dead are buried and an eternal flame burns in commemoration; Yad Layeled, the children\u2019s memorial, commemorating the one and a half million Jewish children who were murdered in the Holocaust;\n\t\t\t\t</p>\n\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/31/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\t\t\t\t\n\t\t\t\t<p>\n\t\t\t\t\tThe Memorial to the Deportees, an authentic railroad car hanging over the cliff on the road winding down from the mountain. The car was used to transport Jews who had been banished from their homes to the concentration camps.\n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\tThe Avenue of the Righteous Among the Nations has over 2,000 trees which were planted in honor of non-Jews who endangered their lives in order to rescue Jews from the Nazis; The archives and library of Yad Vashem House the world\u2019s largest repository of material about the Holocaust;\n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\tVisiting the Yad Vashem museum is an emotional and heartrending experience, but seeing the exhibits and remembering the Holocaust gives the more than one million individuals, world leaders and dignitaries who pass through its doors annually a meaningful way to commemorate the six million Jewish victims of the Holocaust.\n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\tFor more information   <a target=\"_blank\" href=\"//www.yadvashem.org/\">www.yadvashem.org</a>\n\t\t\t\t</p>\n                \n            \t "};}},{id:"What_To_Pack",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:false,title:"QUÉ PONER EN LA MALETA",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t\t\t<p>Israel es un pa\xEDs moderno y desarrollado&nbsp;y puede comprar pr\xE1cticamente cualquier cosa que necesite durante su estancia, incluyendo ropa, cosm\xE9ticos y productos de higiene.</p>\n\t\t\t\t\t\t\t\t<p>Si est\xE1 visitando Israel durante el verano necesitar\xE1 ropa ligera - camisas de manga corta y sin mangas, pantalones cortos, sandalias, zapatos de playa y un traje de ba\xF1o. Tambi\xE9n es buena idea llevar un su\xE9ter o una chaqueta, ya que las noches en las monta\xF1as y en el desierto pueden ser frescas.</p>\n\t\t\t\t\t\t\t\t<p>Si est\xE1 visitando Israel en el invierno, necesitar\xE1 ropa abrigada, un abrigo (preferiblemente un impermeable), buenos zapatos, un paraguas, guantes y una bufanda. El clima en Israel no es tan fr\xEDo como en Europa, pero los d\xEDas pueden ser lluviosos y fr\xEDos.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/what-to-pack/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t<p>Es buena idea traer una bolsa peque\xF1a para excursiones de un d\xEDa. Si est\xE1 viajando a Eilat o al mar Muerto, es buena idea traer un traje de ba\xF1o, ya que el agua es lo suficientemente caliente como para nadar all\xED incluso en invierno.</p>\n\t\t\t\t\t\t\t\t<p>Protector solar, un sombrero&nbsp;y gafas de sol son elementos esenciales durante todo el a\xF1o.</p>\n\t\t\t\t\t\t\t\t<p>Si est\xE1 planeando&nbsp; ir de excursi\xF3n, necesitar\xE1 buenos zapatos y mucha agua, ya sea en una cantimplora o en varias botellas. Si est\xE1 planeando dormir al aire libre, un saco de dormir, una tienda de campa\xF1a y un equipo de campamento. La mayor\xEDa de los albergues suministran s\xE1banas y mantas.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\n\n\t\t                        "};}},{id:"Electrical_Appliances",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:false,title:"ELECTRICIDAD",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\u200B La fuente de alimentaci\xF3n israel\xED es monof\xE1sica de 220 voltios a 50 hercios. La mayor\xEDa de los enchufes en Israel tienen tres orificios, pero muchos funcionar\xE1n con enchufes europeos de dos agujeros. Los visitantes que quieran utilizar m\xE1quinas de afeitar, planchas m\xF3viles y otros peque\xF1os electrodom\xE9sticos pueden necesitar transformadores o adaptadores de enchufes.\n\t\t\t\t\t\t\t\t\t</p>\n                                <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/electrical-appliances/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t    </div>\n\n\t\t                        "};}},{id:"Weather",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:false,title:"CLIMA",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t\t\t\t\t<p>Con alrededor de 40 d\xEDas de lluvia al a\xF1o de promedio, Israel es conocido por su predisposici\xF3n al sol, pero tenga en cuenta que este es un pa\xEDs de 4 estaciones. Los veranos son largos, duran de abril a octubre y el m\xE1ximo calor y humedad es usualmente alrededor de julio-agosto. El oto\xF1o y el invierno duran de noviembre a marzo.</p>\n<p>La ciudad meridional de Eilat disfruta de casi 360 (!) d\xEDas soleados al a\xF1o, convirti\xE9ndola en la ciudad m\xE1s c\xE1lida de Israel.</p>\n<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/weather-planyour-trip/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t    </div>\n<p>El Servicio Meteorol\xF3gico de Israel: <a href=\"//www.ims.gov.il\" rel=\"nofollow\" target=\"_blank\">www.ims.gov.il</a></p>\n\t\t\t\t\t\t\t\t\n\n\t\t                        "};}},{id:"Transportation",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:false,title:"TRANSPORTE",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t\t\t\t\t<p>Israel es un pa\xEDs peque\xF1o, donde se puede llegar r\xE1pida y c\xF3modamente a cualquier lugar. Los taxis son comunes en Israel para los trayectos urbanos e interurbanos y pueden ser parados en la calle o reservados por tel\xE9fono o aplicaciones internacionales designadas como Gett.</p>\n<p>Las principales formas de transporte p\xFAblico son los autobuses y el servicio nacional de tren que ofrece un medio de transporte conveniente, a un precio razonable para viajar a casi todos los destinos del pa\xEDs.</p>\n<p>Servicios de Informaci\xF3n de trenes: <a href=\"//www.rail.co.il\" rel=\"nofollow\" target=\"_blank\">www.rail.co.il</a> / Tel\xE9fono: 08-6831222 o * 5770.</p>\n<p>Servicios de informaci\xF3n de autobuses: <a href=\"//bus.gov.il/?language=en#/origindestination/1/0\" rel=\"nofollow\" target=\"_blank\">www.bus.co.il</a> / Tel\xE9fono: 1-900-72-1111</p>\n<p>Los billetes se pueden comprar en las taquillas de la estaci\xF3n central de autobuses en cada ciudad, o a trav\xE9s del conductor. La mayor\xEDa de las l\xEDneas de autob\xFAs no funcionan en Shabat o en las fiestas jud\xEDas. El servicio termina el viernes por la tarde y se reanuda el s\xE1bado por la noche.</p>\n<p>Los estudiantes tienen derecho a descuentos en las l\xEDneas de autobuses interurbanos. Para recibir un descuento deben presentar una tarjeta de estudiante internacional al comprar los billetes.</p>\n<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/transportation/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t    </div>\n<h3>Tarjeta de viaje inteligente - Rav Kav</h3>\n<p>Los turistas pueden comprar una tarjeta &nbsp;an\xF3nima de Rav Kav. Se puede comprar a bordo por una peque\xF1a tarifa, y luego la pueden recargar, por lo general con un 20% de descuento.</p>\n<p>Para su informaci\xF3n:</p>\n<p>\u2022 &nbsp;Rav Kav se puede utilizar para pagar el transporte de varios pasajeros.</p>\n<p>\u2022 La cuota de un ni\xF1o es como la de un adulto.</p>\n<p>\u2022 Rav Kav se puede utilizar en una regi\xF3n y no entre regiones a menos que se recargue espec\xEDficamente para las rutas deseadas.</p>\n<p>\u2022 En algunas \xE1reas, es posible obtener viajes diarios ilimitados dentro de esa regi\xF3n solamente.</p>\n<h3>Vuelos dom\xE9sticos</h3>\n<p>Como ya bien sabe, Israel es un pa\xEDs peque\xF1o, y por esta raz\xF3n, s\xF3lo vale la pena considerar volar entre Eilat y Tel Aviv. Varias compa\xF1\xEDas operan vuelos de Eilat al aeropuerto de Ben Gurion, o de Sde Dov al norte de Tel Aviv. Las tarifas a\xE9reas son razonables, pero son m\xE1s altas que las tarifas de autob\xFAs.</p>\n\n<p>Arkia Tel\xE9fono: 00 972 3 690 2222,</p>\n<p>Israir Tel\xE9fono: 00 972 3 795 5777</p>\n<h3>Alquiler de coche</h3>\n<p>La mayor\xEDa de las empresas de alquiler de coches internacionales y las empresas locales tienen oficinas en las grandes ciudades y en el aeropuerto de Ben Gurion. Se recomienda reservar un coche con anticipaci\xF3n desde el extranjero.</p>\n<p>Para alquilar un coche en Israel el conductor debe ser mayor de 24 a\xF1os, y debe tener una licencia de conducir internacional v\xE1lida (no en el caso de UE) y una tarjeta de cr\xE9dito internacional.</p>\n<p>Israel tiene una extensa red de carreteras y se\xF1alizaci\xF3n clara en la mayor\xEDa de los lugares (en hebreo, ingl\xE9s y \xE1rabe).</p>\n<h3>Conducir en Israel</h3>\n<p><strong>La edad m\xEDnima</strong> para conducir en Israel es 17 a\xF1os y el lado de conducci\xF3n de la carretera es el derecho. Los l\xEDmites de velocidad son de 30 a 50km / h en ciudades, 80-90 en carreteras, 130 en autopistas y la autopista de peaje 6. Los cinturones de seguridad son obligatorios, y si usted est\xE1 disfrutando de una noche en la ciudad, tenga en cuenta que hay una pol\xEDtica de tolerancia cero si bebe y conduce, as\xED que designe un conductor y disfrute con seguridad.</p>\n<h3>Autopista de Peaje 6</h3>\n<p>La autopista 6 funciona como un peaje electr\xF3nico sin barreras en las entradas o salidas y sin sem\xE1foros que permite trayectos ininterrumpidos. Los sistemas avanzados de informaci\xF3n computarizada instalados a lo largo de la carretera incluyen peajes electr\xF3nicos, identificaci\xF3n de veh\xEDculos, categorizaci\xF3n por tipos de tarifas (suscripci\xF3n o no registrados) y calculan el n\xFAmero de secciones de autopistas que cada veh\xEDculo realiza. Cada trayecto se tabula autom\xE1ticamente y se factura. Los conductores disfrutan de una experiencia de viaje rica, c\xF3moda y segura con un l\xEDmite de velocidad de 130 kil\xF3metros por hora.</p>\n<p>Los turistas que alquilen un coche se les cobrar\xE1 a trav\xE9s de su tarjeta de cr\xE9dito. Consulte con la empresa de alquiler las condiciones y tarifas.</p>\n<p>La mayor\xEDa de las empresas de alquiler de coches no ofrecen seguros para las \xE1reas de Cisjordania bajo el control de la Autoridad Palestina. Los turistas que deseen conducir con autom\xF3viles alquilados a las \xE1reas de la Autoridad Palestina se les recomienda contratar un seguro apropiado.</p>\n\t\t\t\t\t\t\t\t\n            \t\n\n\t\t                        "};}},{id:"Israeli_Currency",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:false,title:"ISRAELI CURRENCY",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tEilat\u2019s currency is the New Israel Shekel (NIS) or shekel for short (pluralized as shkalim in Hebrew or shekels in English). There are 100 agorot (agora in singular) in each shekel. Bank notes are in values of 20, 50, 100, and 200 NIS; coins are in values of 10, 5, 2 & 1 NIS and you have 50 and 10 aggorrot.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t\tExchange Services \n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tUnlimited sums of local and foreign money may be brought into Israel as cash, credit cards or State of Israel bonds. Foreign currency of all kinds may be exchanged at the airport, banks, post offices, most hotels or licensed exchange agencies in large cities. \n\t\t\t\t\t\t\t\tA passport is required when exchanging currencies. The rates vary from place to place, and banks charge a commission. More Information is available here.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t\tCash Withdrawals \n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tHolders of international credit cards can withdraw local or foreign currency at banks which accept their credit cards. There are ATM Machines outside most banks.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t\tValue-added tax refunds\n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tEilat is a VAT-free zone, but if you visit other places in Israel, foreign tourists may request VAT refunds on purchases made during their visits. Be sure to keep your receipts.\n\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/israeli-currency/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t    </div>\n            \t\n\n\t\t                        "};}},{id:"Immigration_Customs",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:false,title:"INMIGRACIÓN Y ADUANAS",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t\t\t        <h3>Procedimientos en los puntos fronterizos</h3>\n                                \n                                \n\t\t\t\t\t\t\t    <h3>Control de pasaportes</h3>\n\t\t\t\t\t\t\t\t<p>A su llegada a Israel, los visitantes pasan el control de pasaportes y deben presentar un pasaporte v\xE1lido por lo menos seis menos posterior a la fecha de su salida.</p>\n\t\t\t\t\t\t\t\t<p>Por favor, tenga en cuenta que Israel ha incorporado un sistema tecnol\xF3gico nuevo y moderno para satisfacer las necesidades de las diferentes autoridades de Inmigraci\xF3n, Seguridad, Aeroportuaria y Turismo, adem\xE1s de proporcionar al turista las credenciales necesarias para probar su estatus de visado sin estampar el pasaporte. Con s\xF3lo pulsar un bot\xF3n, el puesto de control de fronteras imprimir\xE1 una tarjeta que incluye los detalles principales del viajero como en la primera p\xE1gina del pasaporte. La tarjeta tambi\xE9n mostrar\xE1 la fecha de llegada y la informaci\xF3n de la visa. Esta tarjeta se llama el \"paso de puerta electr\xF3nico\".</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t    <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/immigration-customs/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t<p>El Pase de Puerta es una forma oficial de identificaci\xF3n mientras se encuentra en Israel. Pedimos a todos los turistas que mantengan la tarjeta a mano en todo momento como prueba de su estatus.</p>\n\t\t\t\t\t\t\t\t<p>Llegada a\xE9rea y terrestre de pasajeros - Los viajeros que llegan al aeropuerto contin\xFAan al \xE1rea de equipajes despu\xE9s de inspeccionar sus pasaportes. Los carritos est\xE1n a su disposici\xF3n. Desde all\xED, contin\xFAan al control aduanero y a la salida del aeropuerto.<br/>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<h3>Aduana</h3>\n\t\t\t\t\t\t\t\t<p>Puede descargar informaci\xF3n general sobre las leyes y pol\xEDticas de la Autoridad de Aduanas<br/>\n\t\t\t\t\t\t\t\t<a href=\"https://www.gov.il/en/departments/topics/tourist-and-travelers-info/govil-landing-page\" rel=\"nofollow\" target=\"_blank\">https://www.gov.il/en/departments/topics/tourist-and-travelers-info/govil-landing-page</a></p>\n\t\t\t\t\t\t\t\t<p>Por favor, tenga en cuenta que viajar por el cruce del Puente de Allenby tiene limitaciones y directivas espec\xEDficas. Por ejemplo, los visitantes que pasan por el Puente de Allenby entre Israel/Jordania pueden llevar hasta 2000 dinares jordanos en efectivo.</p>\n\t\t\t\t\t\t\t\t<h3>Aduanas e IVA para Turistas:</h3>\n\t\t\t\t\t\t\t\t<a href=\"https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx\" rel=\"nofollow\" target=\"_blank\">https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx</a></p>\n\t\t\t\t\t\t\t\t<p><strong>Aparte </strong><strong>del cruce del Puente de Allenby</strong><strong>, y para todas las otras entradas, incluyendo aeropuertos</strong>, la siguiente gu\xEDa tur\xEDstica es relevante para los visitantes seg\xFAn lo definido por la Autoridad de Aduanas y Tributaria:<br/>\n\t\t\t\t\t\t\t\t<a href=\"https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx\" rel=\"nofollow\" target=\"_blank\">https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx</a><br/>\n\t\t\t\t\t\t\t\t<a href=\"https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx\" rel=\"nofollow\" target=\"_blank\">https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx</a></p>\n\t\t\t\t\t\t\t\t<p>Tenga en cuenta que hay un sistema de tr\xE1nsito aduanero de dos canales, uno verde y otro rojo, en el aeropuerto Ben Gurion y diversos puntos de cruce. Los visitantes que no tienen mercanc\xEDas para ser declaradas pueden pasar por el canal verde en la salida de la sala de llegada de pasajeros.</p>\n\t\t\t\t\t\t\t\t\t\t    \n\t\t                        "};}},{id:"Frequently_Asked_Questions",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:false,title:"PREGUNTAS MÁS FRECUENTES",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t\t\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t\t\t\t\t\t<h3>Preguntas frecuentes sobre Covid19</h3>\n\t\t\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t\t   <ol start=\"1\">\n\t\t\t\t\t                               <li>\n\t\t\t\t\t\t\t\t                  <strong>Soy un turista en Israel y creo que podr\xEDa tener el COVID-19, \xBFA d\xF3nde debo acudir?</strong><br/>\n\t\t\t\t\t\t\t\t                  Si tienes 38\xBAC o m\xE1s de fiebre, tos, dificultad para respirar u otros problemas respiratorios, debes auto aislarte inmediatamente y llamar a la l\xEDnea directa de 101 de Servicios de Urgencia de MDA para indicaciones m\xE9dicas.\n\t\t\t\t\t\t\t\t                  <strong class=\"ac-pink\">\n\t\t\t\t\t\t\t\t                    No acudas a una cl\xEDnica o sala de urgencias.\n\t\t\t\t\t\t\t\t                  </strong>\n\t\t\t\t\t\t\t\t                </li>\n\t\t\t\t\t\t\t\t                <li>\n\t\t\t\t\t\t\t\t                  <strong>\xBFCu\xE1ndo volver\xE1 a aceptar Israel a visitantes de fuera</strong><br/>\n\t\t\t\t\t\t\t\t                  En este momento no hay fecha conocida en la que Israel volver\xE1 a permitir la entrada a los visitantes extranjeros.\n\t\t\t\t\t\t\t\t                </li>\n\t\t\t\t\t                               \n\t\t\t\t\t                              </ol>\n\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t<h3>\xBFIsrael est\xE1 muy lejos?</h3>\n\t\t\t\t\t\t\t\t\t\t\t<p>A 4 horas de vuelo desde Barcelona y 5 desde Madrid.&nbsp; Hay vuelos directos con El Al, Iberia, Air Europa, Vueling y Norwegian.&nbsp; Para pasajeros procedentes de Latino Am\xE9rica, existen numerosas conexiones con m\xFAltiples compa\xF1\xEDas.</p>\n\t\t\t\t\t\t\t\t\t\t\t<h3>\xBFQu\xE9 documentos necesito para viajar a Israel?</h3>\n\t\t\t\t\t\t\t\t\t\t\t<p>Para ciudadanos espa\xF1oles, todo lo que necesita es un pasaporte v\xE1lido por lo menos seis meses m\xE1s que su fecha de llegada a Israel. (Para estancias de hasta tres meses, no necesita visa). Para cualquier otra nacionalidad, consulte en:<br><a href=\"//mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf\" rel=\"nofollow\" target=\"_blank\">http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a></p>\n\t\t\t\t\t\t\t\t\t\t\t<h3>\xBFEs seguro viajar a Israel?</h3>\n\t\t\t\t\t\t\t\t\t\t\t<p>No le pedir\xEDamos que viniera si no lo fuera. Cada a\xF1o entre 3 y 4 millones de turistas vienen de vacaciones a Israel - y aparte de aquellos que se enamoran de un israel\xED - o de Israel - todos vuelven a casa sanos y salvos. M\xE1s de 90 compa\xF1\xEDas a\xE9reas no volar\xEDan a Israel si no fuera seguro.</span></p>\n\t\t\t\t\t\t\t\t\t\t\t<h3>He o\xEDdo que hay una entrevista de seguridad antes de mi vuelo ...</h3>\n\t\t\t\t\t\t\t\t\t\t\t<p>Si usted vuela con EL AL Israel Airlines o cualquier otra compa\xF1\xEDa israel\xED, &nbsp;sepa que las precauciones de seguridad tomadas por las l\xEDneas a\xE9reas israel\xEDes son la envidia de las compa\xF1\xEDas a\xE9reas del mundo. En la facturaci\xF3n para sus vuelos se le preguntar\xE1n algunas cuestiones durante una entrevista de seguridad. Algunas de las preguntas pueden parecer<s>,</s> intrusivas, irrelevantes o repetitivas. S\xF3lo responda con sinceridad y no pierda la calma. Recuerde, las preguntas est\xE1n dise\xF1adas para protegerlo a usted y a los otros pasajeros. Al salir de Israel, el proceso de salida es id\xE9ntico al que se ha se\xF1alado anteriormente, para todas las l\xEDneas a\xE9reas.</span></p>\n\t\t\t\t\t\t\t\t\t\t\t<h3>\xBFPuedo combinar mi visita a Israel con Jordania y / o Egipto?</h3><p>Por supuesto. Hay vuelos regulares entre Tel Aviv y El Cairo y Tel Aviv y Amm\xE1n. O puede ir por tierra: cruzar la frontera entre Israel y Egipto por Eilat / Taba, o entre Israel y Jordania por Eilat o el Puente Sheikh Hussein al sur del Mar de Galilea. Consulte con los consulados locales egipcios y jordanos los requisitos de visado antes de viajar.</span></p>\n\t\t\t\t\t\t\t\t\t\t\t<h3>\xBFQu\xE9 pasa si quiero visitar otro pa\xEDs \xE1rabe?</h3>\n\t\t\t\t\t\t\t\t\t\t\t<p>No hay problema. Al igual que muchos pa\xEDses europeos, Israel ya no sella los pasaportes de los visitantes, por lo que su pasaporte no indica que estuvo aqu\xED.</span></p>\n\t\t\t\t\t\t\t\t\t\t\t<h3>\xBFPuedo visitar la Autoridad Palestina?</h3>\n\t\t\t\t\t\t\t\t\t\t\t<p>Visitar Bel\xE9n es muy simple, y miles de visitantes lo hacen todos los d\xEDas. Puede tomar un tour (consulte con la recepci\xF3n del hotel) o tome un taxi hasta el cruce de Jerusal\xE9n / Bel\xE9n y tome un taxi palestino en Bel\xE9n.</span></p>\n\t\t\t\t\t\t\t\t\t\t\t<h3>\xBFQu\xE9 pasa con la salud, medicamentos, vacunas?</h3>\n\t\t\t\t\t\t\t\t\t\t\t<p>Israel es un pa\xEDs ultramoderno con el mayor n\xFAmero de m\xE9dicos per c\xE1pita del mundo y un sistema sanitario y hospitalario que es la envidia del mundo. No se requieren vacunas para visitar Israel (a menos que haya estado recientemente en una zona donde se han producido epidemias de fiebre amarilla, c\xF3lera o \xE9bola). Puede comprar la mayor\xEDa de los medicamentos sin receta en Israel. Tambi\xE9n puede traer suministros de sus medicamentos recetados. (Si necesita traer jeringas y viales de medicina - traiga una carta de su m\xE9dico que lo atestig\xFCe, por si acaso.) Si necesita consultar a un m\xE9dico en Israel, consulte con la recepci\xF3n del hotel. Siempre se recomienda un seguro de viaje (incluida la cobertura m\xE9dica) para todos los viajes al extranjero.</p>\n\t\t\t\t\t\t\t\t\t\t\t<h3>\xBFQu\xE9 ponerse?</h3>\n\t\t\t\t\t\t\t\t\t\t\t<p>Al igual que en casi todas partes del mundo, el estilo informal es perfecto para todos los d\xEDas. Traiga buenos zapatos para caminar o zapatillas y ropa variada. A los israel\xEDes (especialmente las mujeres) les gusta ser \"elegante informal\" por las tardes en Tel Aviv y Jerusal\xE9n. Algunos santuarios religiosos requieren vestido decoroso (brazos y piernas cubiertos, y, ocasionalmente, no se permiten pantalones para las mujeres). No se olvide de su traje de ba\xF1o y, para el mar Muerto, calzado de goma para entrar en el agua.</span></p>\n\t\t\t\t\t\t\t\t\t\t\t<h3>\xBFQu\xE9 pasa con el dinero?</h3>\n\t\t\t\t\t\t\t\t\t\t\t<p>La moneda israel\xED es el Shekel (oficialmente \"Nuevo Shekel israel\xED\"), que vale alrededor de 4\u20AC. <a href=\"//www.boi.org.il/en/Markets/ExchangeRates/Pages/Default.aspx\" rel=\"nofollow\" target=\"_blank\">Haga clic aqu\xED para ver la tasa de conversi\xF3n actual</a>. A su llegada a Israel, es una buena idea usar su tarjeta bancaria para retirar algunos Shekels del cajero autom\xE1tico en las salas de llegada de Ben Gurion (consulte con su banco pol\xEDtica de comisi\xF3n) o cambiar peque\xF1as cantidades de euros o cheques de viaje en un banco o su hotel. Hay cajeros autom\xE1ticos en todo Israel y las tarjetas de cr\xE9dito son ampliamente aceptadas.</span></p>\n\t\t\t\t\t\t\t\t\t\t\t<h3>Electricidad</h3>\n\t\t\t\t\t\t\t\t\t\t\t<p>Casi todas las habitaciones de&nbsp;hotel est\xE1n equipadas con secador de pelo, y todas tienen tomas para m\xE1quinas de afeitar. Para otros aparatos, la electricidad de Israel es 220V A / C, monof\xE1sico de 50 ciclos; Se pueden utilizar transformadores de 110V-220V. Los enchufes israel\xEDes tienen tres clavijas, pero normalmente los adaptadores europeos de dos clavijas funcionan.</p>\n\t\t\t\t\t\t\t\t\t\t\t<h3>Mantenerse en contacto \u2013 Hora en Israel</h3>\n\t\t\t\t\t\t\t\t\t\t\t<p>La mayor\xEDa de los hoteles tienen wi-fi gratuito en el vest\xEDbulo, y algunos hoteles ofrecen internet gratis en la habitaci\xF3n. Muchos hoteles tambi\xE9n tienen centros de negocios donde puede acceder a su correo electr\xF3nico e Internet sin cargo alguno. Hay una hora m\xE1s con respecto al huso horario de Espa\xF1a (pen\xEDnsula).</p>\n\t\t\t\t\t\t\t\t\t\t\t<h3>Temperaturas</h3>\n\t\t\t\t\t\t\t\t\t\t\t<p>Aunque la mayor parte del a\xF1o reina un tiem&shy;po caluroso y soleado, en invierno puede hacer fr\xEDo, en especial en la monta\xF1a y por la noche. El invier&shy;no es tambi\xE9n la temporada de lluvias, as\xED que si viene en invierno venga preparado.</p>\n\t\t\t\t\t\t\t\t\t\t\t<h3>Las pautas generales son:</h3>\n\t\t\t\t\t\t\t\t\t\t\t<p>VERANO (Jun / Jul / Aug / Septiembre): Tel Aviv y Tiber\xEDades son calurosos y h\xFAmedos (como Barcelona o M\xE1laga). Jerusal\xE9n es m\xE1s seco y fresco, especialmente en la noche. Masada y Eilat son extremadamente calurosas... pero seco. No habr\xE1 una gota de lluvia.</p>\n\t\t\t\t\t\t\t\t\t\t\t<p>ENTRE TIEMPO (finales de Mar / Abr / Mayo / finales de Sep / Oct / Nov): Las temperaturas diurnas son muy agradables.&nbsp; (pero m\xE1s c\xE1lido&nbsp; en el mar Rojo y Muerto).</p>\n\t\t\t\t\t\t\t\t\t\t\t<p>INVIERNO (Dic / Ene / Febrero / Marzo): El clima invernal puede fluctuar. Algunos inviernos son suaves y soleados, otros son severos y nublados. A menudo hay fuertes lluvias y en enero y febrero, incluso a veces, nieve. En Jerusal\xE9n y Galilea har\xE1 fr\xEDo por la noche.</p>\n\t\t\t\t\t\t\t\t\t\t\t<h3>C\xF3mo moverse</h3>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>AUTOB\xDAS:</strong> Israel tiene uno de los mejores y m\xE1s baratos sistemas de autobuses del mundo, y casi todas las ciudades, pueblos y asentamientos est\xE1n conectados.</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>TREN:</strong> Los trenes de alta velocidad conectan el aeropuerto Ben Gurion con Tel Aviv, Jerusal\xE9n y Haifa, y hay servicio de tren r\xE1pido, eficiente y barato en gran parte del pa\xEDs. <a href=\"//www.rail.co.il/EN/Pages/Homepage.aspx\" rel=\"nofollow\" target=\"_blank\">Haga clic</a> para obtener informaci\xF3n completa.</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>VUELOS:</strong> Tel Aviv y Eilat est\xE1n conectados por varios vuelos diarios a bordo de Arkia, El Al e Israir, y tambi\xE9n hay vuelos a Haifa y la Galilea.</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>TAXIS:</strong> Hay taxis disponibles en las ciudades, y los taxistas tambi\xE9n est\xE1n dispuestos a llevarle entre ciudades. Compruebe el precio antes de iniciar su viaje.</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>TAXIS COMPARTIDOS:</strong> Los taxis compartidos o \"Sherut\" son muy populares. Hay estaciones \"Sherut\" en todas las ciudades. Pregunte en su hotel por la parada de sherut m\xE1s cercano.</p>\n\t\t\t\t\t\t\t\t\t\t\t<h3>ALQUILER DE COCHES:</h3>\n\t\t\t\t\t\t\t\t\t\t\t<p>La mayor\xEDa de las compa\xF1\xEDas de alquiler de coches internacionales tienen oficinas en Israel y tambi\xE9n hay excelentes empresas israel\xEDes. Su licencia de conducir espa\xF1ola es v\xE1lida en Israel.&nbsp;Otras nacionalidades, consulte con la compa\xF1\xEDa de alquiler.</p>\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t                        "};}},{id:"Passports_Visa",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:false,title:"PASAPORTES Y VISAS",smltitle:"",html:function html(){return{__html:"\n                                <p>Todos los visitantes a Israel deben tener un pasaporte v\xE1lido por lo menos seis menos posterior a la fecha de salida del pa\xEDs. Las personas sin nacionalidad deben tener un salvoconducto v\xE1lido, as\xED como una visa de regreso al pa\xEDs que la emiti\xF3.</p>\n\t\t\t\t\t\t\t\t<p>Los visitantes tienen derecho a permanecer en Israel hasta tres meses desde la fecha de su llegada, de acuerdo a las condiciones del visado que se les ha concedido. Los visitantes que deseen trabajar en Israel deben presentar una solicitud al Ministerio del Interior para obtener una visa especial.</p>\n\t\t\t\t\t\t\t\t<p>Israel ya no sella pasaportes en los aeropuertos y en la mayor\xEDa de los cruces terrestres. Sin embargo, debido a que a veces surgen dificultades t\xE9cnicas y, a veces, el control fronterizo debe volver al m\xE9todo de sellado de pasaportes, recomendamos que los turistas que contin\xFAan desde Israel a los pa\xEDses \xE1rabes <strong>soliciten oficialmente</strong> que el sello israel\xED no aparezca en su pasaporte. El turista debe notificar al empleado esta solicitud antes de sellar los documentos.</p>\n\t\t\t\t\t\t\t\t<h3>El \u201Cpase de puerta electr\xF3nico\u201D</h3>\n\t\t\t\t\t\t\t\t<p>De conformidad al art\xEDculo 13 de la ley de 1952 en relaci\xF3n a la entrada a Israel, un inspector oficial o un oficial de polic\xEDa puede solicitar la identificaci\xF3n y la prueba de su estatus legal en Israel. La estaci\xF3n de control de fronteras imprimir\xE1 una tarjeta que incluye los detalles principales del viajero tal y como aparece en la primera p\xE1gina del pasaporte. La tarjeta tambi\xE9n mostrar\xE1 la fecha de llegada y la informaci\xF3n de la visa. Esta tarjeta se denomina \"Pase de Puerta Electr\xF3nico\" y es un sistema tecnol\xF3gico nuevo que satisface las necesidades de las diferentes autoridades de Inmigraci\xF3n, Seguridad, Aeroportuarias y Turismo, as\xED como proporciona al turista las credenciales necesarias para acreditar su estado de visado. <strong>El \"Pase de Puerta Electr\xF3nico\" sustituye al sistema de sellado de pasaportes.</strong> En el aeropuerto, esta tarjeta permite al viajero salir de la terminal de llegadas sin m\xE1s demora.</p>\n\t\t\t\t\t\t\t\t  <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/passports-visa/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t    </div><br>\n\t\t\t\t\t\t\t\t<p><strong>El pase de puerta es una forma oficial de identificaci\xF3n mientras se encuentra en Israel</strong>. Pedimos a todos los turistas que mantengan la tarjeta a mano en todo momento como prueba de su estado de visa. En el aeropuerto y en cruces terrestres designados, esta tarjeta permite al viajero salir de la terminal de llegadas y continuar a la zona de recogida de equipaje.</p>\n\t\t\t\t\t\t\t\t<h3>Se le pide al turista que mantenga la tarjeta a mano en todo momento.</h3>\n\t\t\t\t\t\t\t\t<h3>&#8203;Visas de turismo</h3>\n\t\t\t\t\t\t\t\t<p>Damos la bienvenida a los visitantes a Israel. Muchos pa\xEDses cuentan con un Programa de Exenci\xF3n de Visas con Israel, que permite a sus ciudadanos visitar Israel sin visa. Antes de embarcarse en un viaje, los visitantes que deseen detenerse en Israel en su camino a otros destinos deben comprobar si necesitan una visa de turista. La lista de pa\xEDses en el siguiente enlace especifica los paises desde los que los turistas deben presentar una visa.</p>\n\t\t\t\t\t\t\t\t<p><a href=\"//mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf\" rel=\"nofollow\" target=\"_blank\">Http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a></p>\n\t\t\t\t\t\t\t\t<p>Todos los viajeros del Programa de Exenci\xF3n de Visas deben presentar un pasaporte legible por m\xE1quina en el puerto de entrada para entrar en Israel sin una visa; de lo contrario, se requiere visa. Esto se aplica a los turistas que llegan con una tarjeta de embarque de pa\xEDses con un Programa de Exenci\xF3n.</p>\n\t\t\t\t\t\t\t\t<h3>Extensi\xF3n de su estad\xEDa</h3>\n\t\t\t\t\t\t\t\t<p>Su visa puede ser extendida (con coste) en la oficina del Ministerio del Interior m\xE1s cercana, llame por favor a su centro de llamadas al: * 3450 o marque 12223450</p>\n\t\t\t\t\t\t\t\t                             \n\t\t\t\t\t\t\t   \n\t\t                        "};}},{id:"Crazy_Night",ctg:"telaviv",bgImage:"/posts/bank/crazy-night/1.jpg",mobBgImage:"/posts/bank/crazy-night/M.jpg",isVid:true,vidId:"ogEN7aRT0SM",title:"Looking for a crazy nightlife?",smltitle:"",html:function html(){return{__html:"<div class=\"ac-cradit\">\n\t\t\t\t\t\t\t\t\t<span class=\"ac-cradit-text\">Credits:</span>\n\t\t\t\t\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t\t\t\t\t<span class=\"ac-cradit-text-1\">Tel Aviv Jaffa municipality<br/></span<\n\t\t\t\t\t\t\t\t\t\t<span class=\"ac-cradit-text-2\">UDINI prodactions<br/></span>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p></p>\n\t\t\t\t\t\t\t\t\t</div>\n                               <h3>\n                                 Book your trip to Tel Aviv!\n                               </h3>\n                               <p>\n                                 Amazing nightlife in Tel Aviv <a href=\"https://en.citiesbreak.com/Posts/telaviv/Amazing_Nightlife\" target=\"_blank\">Click here >> </a>\n                               </p>\n\t\t                        "};}},{id:"Heart_Of_The_World",ctg:"jerusalem",bgImage:"/posts/bank/heart-of-the-world/1.jpg",mobBgImage:"/posts/bank/heart-of-the-world/M.jpg",isVid:true,vidId:"nLKWDp5uA-U",title:"Jerusalén, el corazón del mundo",smltitle:"",html:function html(){return{__html:"\n                               <br/>\n                                <h3>Cruce las puertas y conozca otro aspecto de la ciudad vieja de Jerusal\xE9n</h3>\n                                <p>Las murallas de la Ciudad Vieja de Jerusal\xE9n, construidas a principios del siglo XVI por el sult\xE1n turco Solim\xE1n el Magn\xEDfico, tienen ocho puertas. Todas menos una (la Puerta de la Misericordia) siguen sirviendo a los habitantes de Jerusal\xE9n y a los visitantes que llegan a sus mercados y a los sitios sagrados e hist\xF3ricos.</p>\n\t\t\t\t\t\t\t\t<p>La siguiente es una descripci\xF3n resumida de las puertas, en sentido contrario a las agujas del reloj, de sur a oeste:</p>\n\t\t\t\t\t\t\t\t<p><strong>La Puerta de Si\xF3n:</strong>Con el nombre b\xEDblico m\xE1s antiguo de Jerusal\xE9n en hebreo e ingl\xE9s, el nombre \xE1rabe de esta puerta es la Puerta del profeta David, ya que la Tumba del Rey David, en el cercano monte Si\xF3n, est\xE1 a s\xF3lo unos pasos.&nbsp;La&nbsp; Puerta de Si\xF3n conduce directamente a los barrios armenio y jud\xEDo.</p>\n\t\t\t\t\t\t\t\t<p><strong>La Puerta del Esti\xE9rcol</strong>: El nombre inusual de esta puerta deriva de la basura arrojada aqu\xED en la antig\xFCedad, donde los vientos se llevaban los olores. Nehem\xEDas 2:13 menciona una puerta de esti\xE9rcol &nbsp;que probablemente estaba cerca de \xE9sta. Conduce directamente al Muro Occidental y al Parque Arqueol\xF3gico.</p>\n\t\t\t\t\t\t\t\t<p><strong>Puerta de la Misericordia</strong>: Esta puerta, en la pared oriental del Monte del Templo, puede ser la m\xE1s conocida de todas. Tambi\xE9n se llama la Puerta Dorada o la Puerta Oriental, permanece bloqueada desde hace&nbsp; siglos, y se dice que est\xE1 esperando una apertura milagrosa cuando el Mes\xEDas venga y los muertos sean resucitados.</p>\n\t\t\t\t\t\t\t\t<p><strong>Puerta de los Leones:</strong>Este portal lleva el nombre por un par de relieves de animales de aspecto feroz que lo flanquean. En realidad son tigres, el s\xEDmbolo her\xE1ldico del sult\xE1n Baibars del siglo XIII. Tambi\xE9n se llama Puerta de San Esteban, desde que el primer m\xE1rtir cristiano, seg\xFAn la tradici\xF3n, fuera apedreado no muy lejos. La Puerta de los Leones, que conduce a las Piscinas de Bethesda, la V\xEDa Dolorosa y los mercados, se hizo famosa durante la Guerra de los Seis D\xEDas.</p>\n\t\t\t\t\t\t\t\t<p><strong>Puerta de Herodes:</strong>A pesar de su nombre, el famoso rey de Judea no ten\xEDa nada que ver con esta puerta. En \xE1rabe y hebreo esta puerta orientada hacia el norte, que conduce a los mercados de la Ciudad Vieja, se llama la Puerta de las Flores. Algunos dicen que el nombre deriva de una roseta tallada sobre ella. Sin embargo, en \xE1rabe una palabra similar significa \"despertado\", y puede referirse a un cementerio cercano y la esperanza de la resurrecci\xF3n.</p>\n\t\t\t\t\t\t\t\t<p><strong>Puerta de Damasco:</strong>Esta es la m\xE1s imponente de las puertas de entrada a Jerusal\xE9n en direcci\xF3n al norte y se llama as\xED por la gran ciudad de la que llegaron los gobernantes de Jerusal\xE9n. Siempre es una zona muy concurrida, gracias a los bulliciosos mercados. Debajo de la puerta del siglo XVI, los arque\xF3logos han descubierto parte de la entrada construida por el emperador Adriano en el siglo II d.C.</p>\n\t\t\t\t\t\t\t\t<p><strong>La Puerta Nueva:</strong>Esta es la \xFAnica entrada de la Ciudad Vieja que no forma parte del dise\xF1o original de las murallas del siglo XVI. Fue abierta en el ocaso del Imperio Otomano para permitir a los peregrinos cristianos un acceso m\xE1s r\xE1pido a los lugares sagrados dentro de las murallas.</p>\n\t\t\t\t\t\t\t\t<p><strong>La Puerta de Jaffa:</strong> Este fue el destino de los peregrinos jud\xEDos&nbsp;y cristianos que desembarcaron en el puerto de Jaffa, de ah\xED su nombre. Conduc\xEDa (y a\xFAn dirige) directamente a los barrios jud\xEDo y cristiano, as\xED como a las partes m\xE1s populares del mercado, y al Museo de la Torre de David, una vez ciudadela de Jerusal\xE9n&nbsp; y ahora un escaparate de su historia.</p>\n\t\t\t\t\t\t\t\t\t\t                  \n\t\t                        "};}},{id:"Neot_Semadar",ctg:"eilat-negev",bgImage:"/posts/bank/Neot_Semadar/1.jpg",mobBgImage:"/posts/bank/Neot_Semadar/M.jpg",isVid:false,title:"Neot Semadar",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t\t\t\t\t  \n  \n\t\t\t\t\t\t<p>Ubicado en el coraz\xF3n del desierto de Arav\xE1 en Israel, Neot Semadar ofrece a los viajeros un viaje \xFAnico donde el arte, la ecolog\xEDa y la comunidad se entrelazan. Este extraordinario kibutz es mucho m\xE1s que un destino: es un lienzo vivo de creatividad humana y armon\xEDa medioambiental.</p>\n\t\t\t\t\t\t<p>Imagina un lugar donde el prodigio arquitect\xF3nico converge con la innovaci\xF3n ecol\xF3gica. El centro art\xEDstico del kibutz se erige como un testimonio de dise\xF1o colaborativo, con un edificio extraordinario de estructuras redondeadas y audaces, coronado por una impresionante torre de observaci\xF3n de 38 metros. Cada elemento cuenta una historia de vis i\xF3n colectiva y expresi\xF3n art\xEDstica.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/Neot_Semadar/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p>Los visitantes podr\xE9is explorar las m\xFAltiples facetas de esta comunidad amante del desierto.  Los talleres de artistas exhiben artesan\xEDa local, incluyendo pintura en seda, talla en madera y textiles. El paisaje circundante ofrece panor\xE1micas de 360 grados que os dejar\xE1n sin aliento, invit\xE1ndoos a conectar con la cruda belleza del entorno natural.</p>\n\t\t\t\t\t\t<p>M\xE1s all\xE1 de la est\xE9tica, Neot Semadar representa un compromiso profundo con un estilo de vida sostenible. La comunidad practica la agricultura ecol\xF3gica, productos artesanales y mantiene una biodiversidad sorprendente que atrae a investigadores cient\xEDficos. Con m\xE1s de 196 especies de fauna documentadas, el kibutz se distingue como un santuario ecol\xF3gico \xFAnico en su especie.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/Neot_Semadar/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p>Para quienes busc\xE1is una experiencia inmersiva, el lugar ofrece oportunidades de participar en la vida comunitaria, asistir a talleres y degustar productos ecol\xF3gicos locales. El alojamiento os brinda un retiro sereno en medio del desierto, permiti\xE9ndoos desconectar y reconectar con los ritmos de la naturaleza.</p>\n\t\t\t\t\t\t<p>Una visita a Neot Semadar va m\xE1s all\xE1 del turismo convencional: es un viaje al interior de una comunidad reflexiva y creativa que reinventa el potencial humano en perfecta armon\xEDa con el paisaje des\xE9rtico.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/Neot_Semadar/3.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p>Para obtener informaci\xF3n adicional sobre el kibutz y las opciones de visita, consultad nuestra p\xE1gina web:  <a href=\"https://neot-semadar.com/en\" rel=\"noopener\" target=\"_blank\">https://neot-semadar.com/en</a></p>\n\t\t\t\t\t\t "};}},{id:"Privacy_Policy",ctg:"telaviv",bgImage:"/HomeSlider/desktop/1.jpg",mobBgImage:"/HomeSlider/M/3.jpg",isVid:false,title:"PRIVACY POLICY",smltitle:"",html:function html(){return{__html:"\n\n\n\t\t\t\t\t\t\t<p><u><span>Last updated</span></u><span>: March 4, 2020</span></p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3><span>OUR COMMITMENT TO YOU</span><span>&nbsp;</span></h3>\n\t\t\t\t\t\t\t<p>We, at&nbsp;The Israeli government, the Ministry of Tourism (\"<strong>us</strong>\", \"<strong>we</strong>\" or the<strong>&nbsp;\"Ministry</strong>\") respect the privacy of our users (each, a \"<strong>User</strong>\" or \"<strong>you</strong>\") and are committed to protect the privacy of Users who access, download, install, register, use or engage with our website, our mobile application(s), and any other service we provide (the<strong>&nbsp;</strong>\"<strong>Website</strong>\" and \"<strong>App</strong>\" respectively, and collectively the \"<strong>Service(s)</strong>\"). &nbsp;</p>\n\t\t\t\t\t\t\t<p>We've prepared this Privacy Policy to outline our practices with respect to collecting, using and disclosing your information when you use the Services. We encourage you to read this Privacy Policy carefully and use it to make informed decisions. By using the Services, you agree to the terms of this Privacy Policy and your continued use of the Services constitutes your ongoing agreement to the Privacy Policy.</p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3><span>CONTENTS</span></h3>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t  <a href=\"#Grounds\" style=\"color:#000\"><span>1. </span>GROUNDS FOR DATA COLLECTION</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#WhatType\" style=\"color:#000\"><span>2. </span>WHAT TYPE OF DATA WE COLLECT?</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#HowDoWeUse\" style=\"color:#000\"><span>3. </span>HOW DO WE USE THE DATA WE COLLECT?</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#Tracking\" style=\"color:#000\"><span>4. </span>TRACKING TECHNOLOGIES</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#WitWhom\" style=\"color:#000\"><span>5. </span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#HowWeProtect\" style=\"color:#000\"><span>6. </span>HOW WE PROTECT YOUR INFORMATION</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#Retention\" style=\"color:#000\"><span>7. </span>RETENTION</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#UserRigths\" style=\"color:#000\"><span>8. </span>USER RIGHTS</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#Transfer\" style=\"color:#000\"><span>9. </span>TRANSFER OF DATA OUTSIDE THE EEA</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#OurPolicy\" style=\"color:#000\"><span>10. </span>OUR POLICY TOWARD CHILDREN</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#HowToContactUs\" style=\"color:#000\"><span>11. </span>HOW TO CONTACT US?</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#Updates\" style=\"color:#000\"><span>12. </span>UPDATES TO THIS POLICY</a><br/>\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"Grounds\"><span>GROUNDS FOR DATA COLLECTION</span><span>&nbsp;</span></h3>\n\t\t\t\t\t\t\t<p><span>Processing of your \u201C<strong>Personal Data</strong>\u201D (meaning any information which may potentially allow your identification, either directly or by using reasonable means) is necessary for the performance of our contractual obligations towards you, for providing you with our Services and the operation of our Website, to protect our legitimate interests and for compliance with legal and regulatory obligations to which we are subject.</span></p>\n\t\t\t\t\t\t\t<p><span>When you use our Services, you consent to the collection, storage, use, disclosure and other uses of your Personal Information as described in this Privacy Policy.</span></p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"WhatType\"><span>WHAT TYPE OF DATA WE COLLECT?</span></h3>\n\t\t\t\t\t\t\t<h3><span>Personal Data</span></h3>\n\t\t\t\t\t\t\t<p><span>In the course of using the Services, we may collect certain Personal Data to provide and improve the Services, to contact or identify you, to enable you to access certain parts of the Service</span><span>&nbsp;or as otherwise indicated in this Policy. We collect the following Personal Data about you</span><span>:</span></p>\n\t\t\t\t\t\t\t<ul style=\"list-style-type: disc;margin-left:0in;\">\n\t\t\t\t\t\t\t  <li><span>When you send us an email&nbsp;</span><span>or contact us through a contact form on the Website, we will collect your name and email address so we could respond to your inquiry. We may also collect any Personal Data that you choose to include in your inquiry to us.</span></li>\n\t\t\t\t\t\t\t  <li><span>Our webserver may also automatically collect your IP address, and unique online identifiers. These details are pseudonymized (cannot directly identify you) and are collected for the purpose of delivering relevant content and operating and improving our Service.</span></li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t<h3><span>Non-Personal Data</span></h3>\n\t\t\t\t\t\t\t<p><span>We also collect data about the use of our Service and the characteristics and activities of users, in order to operate it and improve it. We may collect the following non-Personal Data:&nbsp;</span><span>Your operating system, device type, session start/stop time, time zone, network connection type (e.g., Wi-Fi, cellular), your general location (city and country), and general information regarding your browser and device.</span></p>\n\t\t\t\t\t\t\t<p><span>If we combine Personal Data with non-Personal Data, the combined data will be treated as Personal Data.&nbsp;</span></p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"HowDoWeUse\"><span>HOW DO WE USE THE DATA WE COLLECT?</span></h3>\n\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t  <li><strong><span>Provision of the Service</span></strong><em><span>&nbsp;\u2013&nbsp;</span></em><span>we will use the Personal Data you provide us for the provision and improvement of our Service, providing customer support and to respond to your queries.&nbsp;</span></li>\n\t\t\t\t\t\t\t  <li><strong><span>Service announcements</span></strong><span>&nbsp;- we will use your Personal Data to communicate with you and to keep you informed of our latest updates to our Service and offer you service offers.</span></li>\n\t\t\t\t\t\t\t  <li><strong><span>Analytics, surveys and research</span></strong><span>&nbsp;- from time to time, we may conduct surveys or test features, and analyze the data we have to develop, evaluate and improve these features, all in order to improve our Services and offerings, and think of new and exciting features for our users.</span></li>\n\t\t\t\t\t\t\t  <li><strong><span>Protecting our interests</span></strong><em><span>&nbsp;-&nbsp;</span></em><span>we may use your Personal Data when we believe it\u2019s necessary in order to take precautions against liabilities, investigate and defend ourselves against any third party claims or allegations, investigate and protect ourselves from fraud, protect the security or integrity of our services and protect the rights and property of the Ministry, its users and/or partners.&nbsp;</span></li>\n\t\t\t\t\t\t\t  <li><strong><span>Enforcing of policies</span></strong><span>&nbsp;- we may use your Personal Data in order to enforce our policies, including but not limited to our <a href=\"https://goisrael.com/Posts/telaviv/Privacy_Policy\" style=\"text-decoration:underline;color:#000\" target=\"_blank\"> Terms </a></span><span style=\"line-height:115%;font-family:Calibri;font-size:8.0pt;color:windowtext;\">\n\t\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t\t</span><span style=\"line-height:;font-family:Calibri;line-height:;color:windowtext;\">.&nbsp;</span></li>\n\t\t\t\t\t\t\t  <li><strong><span>Compliance with legal and regulatory requirements</span></strong><span>&nbsp;- we may use your Personal Data to investigate violations, and as required by law, regulation or other governmental authority, or to comply with a subpoena or similar legal process.</span></li>\n\t\t\t\t\t\t\t  <li><strong><span>Newsletter</span></strong><span>&nbsp;- we may use your Personal Data in order to send you our newsletter, if you subscribed to it. &nbsp;</span>\n\t\t\t\t\t\t\t\t<ol style=\"list-style-type: circle;\">\n\t\t\t\t\t\t\t\t  <li><u><span>Opt-out of receiving our newsletter</span></u><span>&nbsp;- You may choose not to receive our newsletter by clicking on the \u201Cunsubscribe\u201D link contained therein. Please note that even if you unsubscribe, we may continue to send you Service-related updates and notifications, or reply to your queries and feedback you provide us.&nbsp;</span></li>\n\t\t\t\t\t\t\t\t</ol>\n\t\t\t\t\t\t\t  </li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"Tracking\"><span>TRACKING TECHNOLOGIES</span></h3>\n\t\t\t\t\t\t\t<p><span>When you visit or access our Services we use (and authorize 3<sup>rd</sup> parties to use) pixels, cookies, events and other technologies (collectively, \"<strong>Tracking Technologies</strong>\"). Those allow us to automatically collect information about you, your device and your online behavior, in order to enhance your navigation in our Services, improve our Services\u2019 performance, perform analytics and customize your experience. In addition, we may merge data we have with data collected through these tracking technologies and data we may obtain from other sources and, as a result, such data may become Personal Data.</span></p>\n\t\t\t\t\t\t\t<p>If you do not accept the use of cookies by us, please disable cookies by following the instructions below. However, please note that disabling cookies might seriously affect the function, User experience and other features of our Services.</p>\n\t\t\t\t\t\t\t<h3>Types of Tracking Technologies We Use</h3>\n\t\t\t\t\t\t\t<p>There are two broad categories of cookies: (a) <strong>First party cookies</strong>, served directly by us to your computer or mobile device, and (b) <strong>Third party cookies</strong>, served by a third party. We use third party cookies for functionality, performance and analytics, and social media purposes.</p>\n\t\t\t\t\t\t\t<p>Cookies can remain on your computer or mobile device for different periods of time. Some cookies are \"session cookies\" and expires upon closing of your browser. Other cookies are \"persistent cookies\", meaning that they survive after your browser is closed. They can be used by websites to recognize your computer when you open your browser and browse the Internet again.</p>\n\t\t\t\t\t\t\t<p>For example, we use a performance tracking technology tool called \u201C<strong>Google Analytics</strong>\u201D to collect information about the use of the Website. Google Analytics collects information such as how often users visit this site, what pages they visit when they do so, and what other sites they used prior to coming to this Site. We use the information we get from Google Analytics to maintain and improve the Site and our products. We do not combine the information collected through the use of Google Analytics with personally identifiable information. Google\u2019s ability to use and share information collected by Google Analytics about your visits to this Site is restricted by the Google Analytics Terms of Service, available at \n\t\t\t\t\t\t\t  <a href=\"//www.google.com/analytics/terms/us.html\" target=\"_blank\" style=\"text-decoration:underline;color:#000\">www.google.com/analytics/</a>, and the Google Privacy Policy, available at \n\t\t\t\t\t\t\t  <a href=\"//www.google.com/policies/privacy/\" target=\"_blank\" style=\"text-decoration:underline;color:#000\">www.google.com/policies/</a>. You can opt-out of Google's collection of Personal Data through Google Analytics by downloading and installing the Google Analytics Opt-out Browser Add-on, available at \n\t\t\t\t\t\t\t  <a href=\"https://tools.google.com/dlpage/gaoptout\" target=\"_blank\" style=\"text-decoration:underline;color:#000\">tools.google.com/dlpage/gaoptout</a>.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<h3><span>Interest-Based Advertising &amp; User Choice</span></h3>\n\t\t\t\t\t\t\t<p>Through our Services, we may display advertisements that are tailored to you, for example ads or partner services that are based on your recent browsing behavior. In order to tailor advertisements and services in which you might be interested, we as well as certain third parties may use Tracking Technologies to display advertisements based on your visits to the Websites, to target advertisements to you for products and services in which you might be interested, and to measure the effectiveness of the ads. You can turn off certain third party Tracking Technologies used for behavioral advertising purposes by visiting the Network Advertising Initiative&nbsp;or by visiting the&nbsp;DAA opt-out program&nbsp;or the&nbsp;EDAA consumer choice page&nbsp;(if you reside in the EU) using the links provided below. Please note that certain Tracking Technologies operate at the device and browser level, so to fully opt-out across devices, you will need to do so on each device and browser individually, as described below as well.</p>\n\t\t\t\t\t\t\t<h3><span>How to Manage Your Tracking Technologies Settings</span></h3>\n\t\t\t\t\t\t\t<p>There are various ways in which you can manage and control your Tracking Technologies settings. Please remember that, by deleting or blocking Tracking Technologies, some of the features of the Services may not work properly or as effectively.</p>\n\t\t\t\t\t\t\t<p style=\"margin-bottom:6.0pt;\"><strong>Turning off cookies via your web browser\n\t\t\t\t\t\t\t\t<br>&nbsp;\n\t\t\t\t\t\t\t  </strong>Most web browsers will provide you with some general information about cookies, enable you to see what cookies are stored on your device, allow you to delete them all or on an individual basis, and enable you to block or allow cookies for all websites or individually selected websites. You can also normally turn off third party cookies separately. Please note that the settings offered by a browser or device often only apply to that particular browser or device. Information about cookies is usually found in the \"Help\" section of the web browser. Below are some links to some commonly used web browsers:</p>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t  <a href=\"https://support.google.com/chrome/answer/95647?hl=en\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Google Chrome</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"https://support.microsoft.com/en-us/kb/260971\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Internet Explorer</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Mozilla Firefox</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"https://support.apple.com/kb/PH5042?locale=en_US\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Safari (Desktop)</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"https://support.apple.com/en-us/HT201265\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Safari (Mobile)</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"//support.google.com/ics/nexus/bin/answer.py?hl=en&amp;answer=2425067\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Android Browser</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"//www.opera.com/help\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Opera</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"//www.opera.com/help/mobile/android#privacy\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Opera Mobile</span></a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p>For other browsers, please consult the documentation that your browser manufacturer provides.</p>\n\t\t\t\t\t\t\t<p style=\"margin-bottom:6.0pt;\"><strong>Turning off third party cookies\n\t\t\t\t\t\t\t\t<br>&nbsp;\n\t\t\t\t\t\t\t  </strong>You can turn off certain third party targeting/advertising cookies by visiting the following link:&nbsp;\n\t\t\t\t\t\t\t  <a href=\"//www.networkadvertising.org/choices/\" target=\"_blank\" style=\"text-decoration:underline;color:#000\">Network Advertising Initiative</a>.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<h3><span>Other helpful resources</span><br/></h3>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t<span>To learn more about advertisers\u2019 use of cookies the following links may be helpful:</span><br/>\n\t\t\t\t\t\t\t  <a href=\"//www.youronlinechoices.eu/\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>European Interactive Digital Advertising Alliance (EU)</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"//www.iab.net/\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Internet Advertising Bureau (US)</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"//www.iabeurope.eu/\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Internet Advertising Bureau (EU)</span></a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p style=\"margin-top:6.0pt;margin-right:0in;margin-bottom:.0001pt;margin-left:0in;text-align:justify;\"><strong>Turning off cookies on a mobile device</strong></h3>\n\t\t\t\t\t\t\t<p>You can-opt out of certain types of interest-based advertising, by accessing the \u201Csettings\u201D on your device:</p>\n\t\t\t\t\t\t\t<ul style=\"list-style-type: disc;margin-left:undefined;\">\n\t\t\t\t\t\t\t  <li><strong><span>If you're using an Apple device</span></strong><span>&nbsp;you can configure your device to limit ad tracking to by clicking on \"settings\" &gt; \"privacy\" &gt; \"advertising\" and toggling \"limit ad tracking\" to \u2018on.\u2019</span></strong></li>\n\t\t\t\t\t\t\t  <li><strong><span>If you're using an Android device</span></strong><span>&nbsp;you can opt out of most app-based tracking for advertising by opening the \"Google Settings\" app on your device, selecting \"Ads\", and then selecting the option to opt-out of interest-based ads.</span></strong></li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t<p>Please note that the above information may change when manufacturers update their systems. Also note, that your device may use another platform, not described above. In that case, please consult the manufacturer documentation for further instructions.</p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"WitWhom\"><span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</span></h3>\n\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t  <li><strong><span>Internal concerned parties</span></strong><span>&nbsp;- we may share your information with other</span><span style=\"color:windowtext;\">&nbsp;</span><span>government ministries, as well as our employees, as needed to provide our Services.</span></li>\n\t\t\t\t\t\t\t  <li><strong><span>Business partners</span></strong><span>&nbsp;- we may share your information with business partners such as storage and analytics providers who help us provide you with our Services. These third parties may have access to your Personal Data so that they may perform these tasks on our behalf, but they are obligated to comply with the highest security standards and applicable data protection legislation, and may not use your Personal Data for any other purpose.</span></li>\n\t\t\t\t\t\t\t  <li><strong><span>Compliance with laws and law enforcement entities</span></strong><span>&nbsp;- we cooperate with other governmental agencies and law enforcement officials to enforce and comply with the law. We will disclose Personal Data about you to government or law enforcement officials or private parties if we, in our sole discretion, believe necessary or appropriate to respond to claims and legal process (including but not limited to subpoenas), to protect our or a third party's property and rights, to protect the safety of the public or any person, or to prevent or stop any activity we may consider to be, or to pose a risk of being, illegal, unethical, inappropriate or legally actionable.&nbsp;</span></li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"HowWeProtect\"><span>HOW WE PROTECT YOUR INFORMATION</span></h3>\n\t\t\t\t\t\t\t<p><span>We have implemented administrative, technical, and physical safeguards to help prevent unauthorized access, use, or disclosure of your Personal Data. Your data is stored on secure servers and isn\u2019t publicly available. We limit access of your information only to those employees or partners on a \u201Cneed to know\u201D basis, in order to enable the carrying out of the agreement between us.&nbsp;</span></p>\n\t\t\t\t\t\t\t<p><span>While we seek to protect your information to ensure that it is kept confidential, we cannot absolutely guarantee its security. You should be aware that there is always some risk involved in transmitting information over the internet. While we strive to protect your Personal Data, we cannot ensure or warrant the security and privacy of your Personal Data or other content you transmit using the Service, and you do so at your own risk.&nbsp;</span></p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"Retention\"><span>RETENTION</span></h3>\n\t\t\t\t\t\t\t<p><span>We will retain your Personal Data for as long as necessary to provide our Services, and as necessary to comply with our legal obligations, resolve disputes, and enforce our policies. Retention periods will be determined taking into account the type of information that is collected and the purpose for which it is collected, bearing in mind the requirements applicable to the situation and the need to destroy outdated, unused information at the earliest reasonable time. Under applicable regulations, we will keep records containing Personal Data, communications and anything else as required by applicable laws and regulations.&nbsp;</span></p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3  id=\"UserRigths\"><span>USER RIGHTS</span></h3>\n\t\t\t\t\t\t\t<h4><strong><span style=\"font-family:&quot;Calibri&quot;,sans-serif;color:windowtext;font-style:normal;\">EU User Rights</span></strong></h4>\n\t\t\t\t\t\t\t<p><span>As an EU resident, you may request to:&nbsp;</span></p>\n\t\t\t\t\t\t\t<ol start=\"1\" style=\"list-style-type: lower-alpha;margin-left: 0px;\">\n\t\t\t\t\t\t\t  <li><span>Receive confirmation as to whether or not Personal Data concerning you is being processed, and access your stored Personal Data, together with supplementary information.&nbsp;</span></li>\n\t\t\t\t\t\t\t  <li><span>Receive a copy of Personal Data you directly volunteer to us in a structured, commonly used and machine-readable format.&nbsp;</span></li>\n\t\t\t\t\t\t\t  <li><span>Request rectification of your Personal Data that is in our control.</span></li>\n\t\t\t\t\t\t\t  <li><span>Request erasure of your Personal Data.&nbsp;</span></li>\n\t\t\t\t\t\t\t  <li><span>Object to the processing of Personal Data by us.&nbsp;</span></li>\n\t\t\t\t\t\t\t  <li><span>Request to restrict processing of your Personal Data by us.</span></li>\n\t\t\t\t\t\t\t  <li><span>Lodge a complaint with a supervisory authority.</span></li>\n\t\t\t\t\t\t\t</ol>\n\t\t\t\t\t\t\t<p><span>Please note that these rights pertain to EU residents only, are not absolute, and may be subject to our own legitimate interests and regulatory requirements.&nbsp;</span></p>\n\t\t\t\t\t\t\t<p><span>Users Outside the EU -&nbsp;</span></strong><span>Some of the aforementioned rights are applicable in certain jurisdictions outside the EU as well. Users residing outside the EU are welcome to contact us for any questions or requests by using the details provided below.</span></p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"Transfer\"><span>TRANSFER OF DATA OUTSIDE THE EEA</span><span>&nbsp;</span></h3>\n\t\t\t\t\t\t\t<p><span>If you reside in the European Union (\"<strong>EU</strong>\"), please note that some data recipients may be located outside the EEA. In such cases we will transfer your data only to such countries as approved by the European Commission as providing adequate level of data protection, or enter into legal agreements ensuring an adequate level of data protection.</span></p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"OurPolicy\"><span>OUR POLICY TOWARD CHILDREN</span></h3>\n\t\t\t\t\t\t\t<p>We do not knowingly collect or solicit personal information from anyone under 18 years of age, (or the age of consent as determined under the applicable laws where the individual resides; \u201C<strong>Age of Consent</strong>\u201D). By accessing, using or interacting with our Services, you certify to us that you are not under the Age of Consent. In the event that we learn that we have collected personal information from an individual under the Age of Consent without verification of parental consent, we will delete that information upon discovery. If you believe that we might have any information from or about an individual under the Age of Consent, then please contact us through the contact details available below.</p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"HowToContactUs\"><span>HOW TO CONTACT US?</span></h3>\n\t\t\t\t\t\t\t<p><span>If you wish to exercise any of the aforementioned rights, or receive more information, please contact us using the details below:</span><br/>Email:<a href=\"mailto:Dpo@tourism.gov.il\" style=\"text-decoration:underline;color:#000\"> Dpo@tourism.gov.il</a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"Updates\"><span>UPDATES TO THIS POLICY</span></h3>\n\t\t\t\t\t\t\t<p>This Privacy Policy is subject to changes from time to time, in our sole discretion. The most current version will always be posted on our Services (as reflected in the \"Last Updated\" heading). You are advised to check for updates regularly. By continuing to access or use our Services after any revisions become effective, you agree to be bound by the updated Privacy Policy.&nbsp;</p>\n\n\t\t\t\t\t\t   \n\t\t\t\t\t\t\t"};}},{id:"Destination_For_All",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:true,vidId:"QWA7qwsbbGY",title:"UN DESTINO PARA TODOS",smltitle:"",html:function html(){return{__html:"\n\n\n\t\t\t<p>El n\xFAmero de visitas a Israel est\xE1 teniendo un crecimiento sin precedentes. M\xE1s y m\xE1s gente de todo el mundo est\xE1 cumpliendo su sue\xF1o de visitar Israel. El Ministerio de Turismo se compromete a ayudar a todo aquel que quiera visitarlo, aunque tenga alguna discapacidad.</p>\n\t\t\t<p>En cuanto a la accesibilidad, Israel es l\xEDder mundial en legislaci\xF3n.</p>\n\t\t\t<p>Desde la infraestructura hasta el servicio, Israel proporciona una estancia acogedora y sin problemas.</p>\n\t\t\t<p>Vea los enlaces siguientes de todos los que ayudan y aseguran una estancia f\xE1cil, agradable y sin barreras.</p>\n\n\t\t   <div class=\"img-wrapper\">\n\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/destination-for-all/1.jpg")+" class=\"img-responsive\">\n\t\t\t</div><br>\n\t\t\t<h3>ONGs y viajes</h3>\n\t\t\t\n\t\t\t<p><u>Bosques, parques y lugares accesibles en Israel</u><br/>\n\t\t\tEn los \xFAltimos a\xF1os, KKL-JNF se ha dedicado a desarrollar las instalaciones adecuadas para discapacitados f\xEDsicos en sus bosques y parques. Nuestro objetivo es abrir la naturaleza a todos los sectores de la poblaci\xF3n, creando un entorno a trav\xE9s del cual las personas con movilidad limitada puedan desplazarse de forma segura y c\xF3moda. Tambi\xE9n hemos dado un paso m\xE1s y hemos llevado la naturaleza a los colegios con proyectos \xFAnicos en colegios de educaci\xF3n especial. <a href=\"//www.kkl-jnf.org/tourism-and-recreation/accessible-forests-parks-sites-israel/\" target=\"_blank\">www.kkl-jnf.org</a>\n\t\t   </p>\n\n\t\t   <h3>Autoridades para la Naturaleza y los Parques de Israel</h3>\n\t\t   <p>INPA se ha dedicado en los \xFAltimos a\xF1os a habilitar el entorno para personas con discapacidades. En todos los parques nacionales, reservas naturales, lugares de antig\xFCedades y patrimonios de la humanidad, se est\xE1 trabajando para mejorar la accesibilidad y facilitar el acceso.<br/>\n\t\t\tINPA est\xE1 haciendo todo lo que est\xE1 en su mano para aumentar la cantidad de visitantes con discapacidades que puedan recorrer y disfrutar los distintos lugares y todas las actividades que ofrecen.<br/>\n\t\t\tEn la p\xE1gina web hay m\xE1s informaci\xF3n y mapas relevantes. <a href=\"https://www.parks.org.il/en/accessibility/\" target=\"_blank\">www.parks.org.il</a></p>\n\t\t\t \n\t\t\t<div class=\"img-wrapper\">\n\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/destination-for-all/2.jpg")+" class=\"img-responsive\">\n\t\t </div><br>\n\t\t\t <h3>Yad Sarah para Turistas</h3>\n\t\t\t <p>Viajar al extranjero es un desaf\xEDo a personas con necesidades especiales. Yad Sarah para turistas ofrece la asistencia a personas con necesidades especiales y sus familiares lo que garantizar\xE1 unas vacaciones agradables y relajadas. Una vez concretados los planes en el departamento de turismo, el visitante puede sentarse y relajarse, sabiendo que todo estar\xE1 resuelto por un representante de Yad Sarah.</p>\n\t\t   \n\t\t\t\t<p> <u>Algunos de los servicios disponibles:</u>:<br/>\n\t\t\t\t \n\t\t\t\t\u2022 Pr\xE9stamo del equipo m\xE9dico necesario. Se puede organizar la entrega en un hotel o residencia por un m\xF3dico precio.<br/>\n\t\t\t\t\u2022 Equipar la habitaci\xF3n de hotel para que su estancia sea m\xE1s c\xF3moda, con camas especiales, sillas, etc.<br/>\n\t\t\t\t\u2022 Pr\xE9stamo de cilindros/concentradores de ox\xEDgeno.<br/>\n\t\t\t\t\u2022 Traslados en furgonetas con bloqueo para sillas de ruedas, incluyendo traslados de ida y vuelta del aeropuerto y visitas tur\xEDsticas.<br/>\n\t\t\t\t\u2022 Recomendaci\xF3n de gu\xEDas tur\xEDsticos especializados en guiar a turistas con movilidad limitada y necesidades especiales, y asesoramiento sobre sitios tur\xEDsticos de f\xE1cil acceso.<br/>\n\n\t\t\t\t<br/>\n\t\t\t\tEl servicio personalizado de Yad Sarah est\xE1 disponible para cualquier turista con necesidades especiales, con previo aviso al departamento de turismo.<br/>\n\t\t\n\n\t\t Este servicio est\xE1 disponible en todo Israel.<br/>\n\n\t\t\tPara m\xE1s informaci\xF3n, o para organizar un traslado o excursi\xF3n, llame al departamento de Turismo al <a href=\"tel:+97226444382\">+972-2-6444382</a> o env\xEDenos un correo electr\xF3nico: <a href=\"mailto:chaimvi@yadsarah.org.il\">chaimvi@yadsarah.org.il</a></p>\n\t\t\t<div class=\"img-wrapper\">\n\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/destination-for-all/3.jpg")+" class=\"img-responsive\">\n\t\t </div><br>\n\t\t\t<h3>Access Israel</h3>\n\t\t\t<p>Access Israel es una organizaci\xF3n sin \xE1nimo de lucro que promueve la accesibilidad y la inclusi\xF3n de personas con discapacidades y ancianos en todos los \xE1mbitos de la vida. Access Israel fue creada en 1999 por Yuval Wagner, un ex piloto de helic\xF3ptero, postrado a una silla de ruedas debido a un accidente. Access Israel lleva a cabo diversos proyectos para cumplir el objetivo de tener una sociedad totalmente accesible e inclusiva, con proyectos de sensibilizaci\xF3n en los colegios, consultor\xEDa de accesibilidad para empresas, cursos de accesibilidad, cursos de lenguaje de signos, conferencias sobre diversos temas y m\xE1s. Adem\xE1s, Access Israel trabaja para promover la accesibilidad en la ley israel\xED, dirige un centro de quejas de accesibilidad y organiza eventos de sensibilizaci\xF3n para el p\xFAblico. Access Israel promueve la accesibilidad y la inclusi\xF3n en todos los \xE1mbitos de la vida,  en la educaci\xF3n, el turismo, cultura, situaciones de emergencia y m\xE1s. Turismo accesible en la p\xE1gina web de Access Israel.\n\t\t\t\t<a href=\"https://www.aisrael.org/?CategoryID=3030\" target=\"_blank\">Accessible Tourism on Access Israel website</a></p>\n                 <h3>LOTEM</h3>\n\t\t\t\t<p> Es la organizaci\xF3n m\xE1s importante en Israel para actividades de aprendizaje al aire libre para ni\xF1os con necesidades especiales, y ofrece actividades educativas al aire libre, as\xED como excursiones adaptadas. \nSurin Hershko, un h\xE9roe de guerra que result\xF3 gravemente herido en la Operaci\xF3n Entebbe en 1976, es fundador y presidente de LOTEM. Su inspiraci\xF3n para LOTEM viene del coraz\xF3n: \"Dar a los ni\xF1os el derecho b\xE1sico de experimentar la vida al aire libre, es el prop\xF3sito de mi vida y me llena de gran alegr\xEDa\". La sede principal, Emek HaShalom (Valle de la Paz), es una granja de 40 acres ubicada en el norte de Israel, cerca de Yokneam. En medio de un precioso valle, la granja est\xE1 rodeada por naturaleza floreciente y el tranquilo fluir de las aguas. Proporciona una experiencia de aprendizaje con pr\xE1cticas en un jard\xEDn de ense\xF1anza, prensas de aceite y vino habilitadas para sillas de ruedas, panader\xEDa y senderos aptos tambi\xE9n para sillas de ruedas.\n                </p>\n\t\t\t\t<p>Lotem comprende el papel vital que desempe\xF1a el aire libre en la vida de los israel\xEDes, y el impacto inconmensurable que tiene en la sociedad, no solo en la persona con una necesidad especial, sino tambi\xE9n en su familia y la comunidad. Su labor es garantizar que ning\xFAn miembro de la sociedad se quede atr\xE1s, LOTEM brinda la oportunidad a ni\xF1os y adultos con necesidades especiales de aprender y participar en actividades al aire libre en todo el pa\xEDs. \n\t\t\t\t<a href=\"https://www.lotem.net/?page_id=386\" target=\"_blank\">www.lotem.net</a></p>\n\n\t\t\t\t<h2 class=\"ac-margin-bottom-20 ac-margin-top-20\"> Transporte</h3>\n\t\t\t\t<h3>Autoridad aeroportuaria de Israel</h3>\n\t\t\t\t<p>Por ley, la Autoridad aeroportuaria de Israel es responsable de proporcionar la infraestructura f\xEDsica para la actividad de las entidades que prestan servicios a los pasajeros asistidos. Sin embargo, conforme a las normas de transporte, la responsabilidad del manejo de los pasajeros asistidos y su equipaje, desde el momento de su entrada en el edificio de la terminal, o su desembarque del avi\xF3n, recae sobre la aerol\xEDnea con la que vuelan los pasajeros. El servicio dentro del aeropuerto Ben Guri\xF3n lo proporcionan las empresas dedicadas a la asistencia en tierra. Este servicio incluye el acompa\xF1amiento y asistencia a pasajeros discapacitados en los trayectos de salida y llegada. \n\t\t\t\t<a href=\"https://www.iaa.gov.il/en-us/airports/bengurion/pages/accessibility.aspx\" target=\"_blank\">www.iaa.gov.il</a></p>\n\t\t\t\t<h3>Estas son las empresas de asistencia en tierra: </h3>\n\t\t\t\t<p>Aero Handling: <a href=\"//www.aerohandling.com/\" target=\"_blank\">www.aerohandling.com</a><br/>\n\t\t\t\tLaufer Aviation: GHI <a href=\"//lauferghi.com/\" target=\"_blank\">www.lauferghi.com</a><br/>\n\t\t\t\tQAS: <a href=\"//www.qasisrael.co.il\" target=\"_blank\">www.qasisrael.co.il</a><br/>\n\n\n\t\t\t\t</p>\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/destination-for-all/4.jpg")+" class=\"img-responsive\">\n\t\t\t </div><br>\n\n\t\t\t\t<p>Tel\xE9fono de Atenci\xF3n al cliente del Ministerio de Transporte (llamada local) <a href=\"tel:5678*\">5678*</a></p>\n\t\t\t\t\n\t\t\t\t<h3>Transporte p\xFAblico</h3>\n\t\t\t\t<p>Trenes: en caso de necesitar asistencia de un miembro del personal de la estaci\xF3n para subir y bajar del tren, debe coordinar con antelaci\xF3n su viaje con 'Israel Railways', a trav\xE9s de la p\xE1gina web o a trav\xE9s de la l\xEDnea directa <a href=\"tel:*5770\">*5770</a>.</p>\n\t\t\t\t \n\t\t\t\t<p><u>'Israel Railways'</u> har\xE1 todo lo posible para brindarle el mejor servicio, aunque no haya coordinado su viaje con antelaci\xF3n.</p>\n\t\t\t\t<p>En cualquier caso, s\xED se debe coordinar con antelaci\xF3n todos los viajes que tengan lugar entre las 20:00 de la tarde y las 06:00 de la ma\xF1ana siguiente, as\xED como los viajes que se realicen el s\xE1bado por la noche.</p>\n\t\t\t\t<p><u>Autobuses:</u> todas las l\xEDneas de autobuses de la ciudad est\xE1n adaptadas para personas discapacitadas. Los autobuses interestatales est\xE1n parcialmente habilitados.</p>\n\t\t\t\t<p><u>Taxis:</u> es dif\xEDcil encontrar un taxi adaptado directamente en la calle. Se recomienda hacer una reserva de <a href=\"https://www.aisrael.org/?CategoryID=2657&ArticleID=64179\" target=\"_blank\">https://www.aisrael.org/?CategoryID=2657&ArticleID=64179</a>.</p>\n\n\n\t\t\t\t<h2  class=\"ac-margin-bottom-20 ac-margin-top-20\">Alojamiento</h3>\n\t\t\t\t<p>Todos los tipos de alojamiento en Israel con 7 o m\xE1s habitaciones est\xE1n obligados por ley a ofrecer al menos 1 habitaci\xF3n adaptada. Todos los proveedores de servicios con un m\xEDnimo de 25 empleados tambi\xE9n deben tener un Supervisor de Accesibilidad. Estas leyes aseguran que no queda ni un rinc\xF3n en Israel en el que no haya la soluci\xF3n perfecta para el alojamiento. Siempre es recomendable escribir un email previo a la visita para coordinar sus expectativas.</p>\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/destination-for-all/5.jpg")+" class=\"img-responsive\">\n\t\t\t </div><br>\n\t\t\t\t\n\t\t\t\t\n\t\t\t\t<div id=\"ac-left-nav\">\n\t\t\t\t<h2 class=\"ac-margin-bottom-20 pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t\t\t<span class=\"ng-binding\">Accessibility for those with special needs at the beaches:</span>\n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t<ul id=\"chaptersList\" class=\"list-unstyled xs-mb-0\">\n\t\t\t\t\t\n\t\t\t\t\t\t<!-- ngRepeat: chapter in Guide.Chapters -->\n\t\t\t\t\t\t<li data-show=\"1\" class=\"ac-active ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope light-gray-e7-background blue-border-right-5px\" ng-repeat=\"chapter in Guide.Chapters\" ng-class=\"getDecorationForLi($index)\" ng-click=\"openChapterMenu(false,$index);updateChapterIndex($index);\" role=\"button\" tabindex=\"0\">\n\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t<span ng-class=\"CurrChapterindex == ($index) ? 'reforma-bold ': ''\" class=\"blue-txt description-txt nounderline  ng-binding reforma-bold\">Northern District</span>\t\t\t\t\t\t                  \n\t\t\t\t\t\t\t<img src=\""+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/a-down.png")+"\" class=\"img-responsive a-arrow-img\" alt=\"\">\n\t\t\t\t\t\t\n\t\t\t\t\t\t</li><!-- end ngRepeat: chapter in Guide.Chapters -->\n\t\t\t\t\t\t<li data-show=\"2\" class=\"ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope\" ng-repeat=\"chapter in Guide.Chapters\" ng-class=\"getDecorationForLi($index)\" ng-click=\"openChapterMenu(false,$index);updateChapterIndex($index);\" role=\"button\" tabindex=\"0\" >\n\t\t\t\t\t\t\t<span ng-class=\"CurrChapterindex == ($index) ? 'reforma-bold ': ''\" class=\"blue-txt description-txt reforma nounderline  ng-binding\">Haifa District</span>\n\t\t\t\t\t\t\t<img src=\""+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/a-down.png")+"\" class=\"img-responsive a-arrow-img\" alt=\"\">\n\t\t\t\t\t\t</li><!-- end ngRepeat: chapter in Guide.Chapters -->\n\t\t\t\t\t\t<li data-show=\"3\" class=\"ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope\" ng-repeat=\"chapter in Guide.Chapters\" ng-class=\"getDecorationForLi($index)\" ng-click=\"openChapterMenu(false,$index);updateChapterIndex($index);\" role=\"button\" tabindex=\"0\" >\n\t\t\t\t\t\t\t<span ng-class=\"CurrChapterindex == ($index) ? 'reforma-bold ': ''\" class=\"blue-txt description-txt reforma nounderline  ng-binding\">Central District</span>\n\t\t\t\t\t\t\t<img src=\""+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/a-down.png")+"\" class=\"img-responsive a-arrow-img\" alt=\"\">\n\t\t\t\t\t\n\t\t\t\t\t\t</li><!-- end ngRepeat: chapter in Guide.Chapters -->\n\t\t\t\t\t\t<div class=\"clear show-on-mobile\"></div>\n\t\t\t\t\t\t<li data-show=\"4\" class=\"ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope\" ng-repeat=\"chapter in Guide.Chapters\" ng-class=\"getDecorationForLi($index)\" ng-click=\"openChapterMenu(false,$index);updateChapterIndex($index);\" role=\"button\" tabindex=\"0\" >\n\t\t\t\t\t\t\t<span ng-class=\"CurrChapterindex == ($index) ? 'reforma-bold ': ''\" class=\"blue-txt description-txt reforma nounderline  ng-binding\">Tel Aviv District</span>\n\t\t\t\t\t\t\t<img src=\""+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/a-down.png")+"\" class=\"img-responsive a-arrow-img\" alt=\"\">\n\t\t\t\t\t\n\t\t\t\t\t\t</li>\n\t\t\t\t\t\t<!-- end ngRepeat: chapter in Guide.Chapters --><li data-show=\"5\" class=\"ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope\" ng-repeat=\"chapter in Guide.Chapters\" ng-class=\"getDecorationForLi($index)\" ng-click=\"openChapterMenu(false,$index);updateChapterIndex($index);\" role=\"button\" tabindex=\"0\" >\n\t\t\t\t\t\t\t<span ng-class=\"CurrChapterindex == ($index) ? 'reforma-bold ': ''\" class=\"blue-txt description-txt reforma nounderline  ng-binding\">Southern District</span>\n\t\t\t\t\t\t\t<img src=\""+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/a-down.png")+"\" class=\"img-responsive a-arrow-img\" alt=\"\">\n\t\t\t\t\t\n\t\t\t\t\t\t</li><!-- end ngRepeat: chapter in Guide.Chapters -->\n\t\t\t\t\t\t<div class=\"clear\"></div>\n\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\n\t\t\t\t<div id=\"res\">\n\t\t\t\t\t<!-- ac part -->\n\t\t\t\t\t<div class=\"ac-part ac-part-1 ac-part-active\">\n\n\t\t\t\t\t\t<div ng-include=\"chapterItem\" class=\"row row-gov ng-scope\">\n\t\t\t\t\t\t\t<!-- Sub Title -->\n\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope\">\n\t\t\t\t\t\t\t\t<h2 class=\"h2 gray-txt pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t\t\t<span class=\"ng-binding\">Northern District</span>\n\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope\">\n\t\t\t\t\t\t\t\t<!-- IMAGE TAG  ------->\n\t\t\t\t\t\t\t\t<!--- Image-->\n\n\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"row row-gov no-gutters ng-scope\">\n\t\t\t\t\t\t\t<div class=\"position-relative col-lg-10 lg-p-0\">\n\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image.ClickURLRef -->\n\n\t\t\t\t\t\t\t\t<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if=\"!CurrChapter.Image.ClickURLRef\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->\n\t\t\t\t\t\t\t\t<!--Image desc-->\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t<div class=\"position-absolute\">\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"xs-mb-10 ng-scope\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- End IMAGE TAG  ------->\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--Content Text-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div id=\"GuidesChapterContent-1\" style=\"overflow: hidden;\" ng-bind-html=\"CurrChapter.Content | to_trusted\" fixed-tables=\"\" class=\"xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding\"><div class=\"table-responsive\"><div><div class=\"changeWidth0\" style=\"width: auto;\"></div><table cellpadding=\"1\" cellspacing=\"1\" style=\"width: 100%;\" class=\"table ui-responsive\" data-mode=\"reflow\" data-role=\"table\">\n\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Kineret Municipal Unio</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Parking&nbsp;&nbsp; &nbsp;</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Tzinbari</td>\n\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Berniki</td>\n\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>At the nearby Shikmim beach</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Shikmim</td>\n\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Hukok</td>\n\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Amnon</td>\n\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Kinar</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Doga</td>\n\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>Closed</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Tze\u2019elon</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Kursi</td>\n\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>At the nearby Levanon beach</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Levanon</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Halukim</td>\n\t\t\t\t\t\t\t\t\t<td>At the nearby Levanon beach</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>At the nearby Levanon beach</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Shizaf</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Dugit \u2013 Golan</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Gofra</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Tiberias</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Guy</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Galei Kineret - Rimonim</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Leonardo Pacific</td>\n\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>Closed for renovations</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Coco Hot / Holiday Inn</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Jordan Valley Regional Council</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Ein Gev Vacation</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Ginnosar</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Migdal Regional Council</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Restal Magdala</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Mateh Asher Regional Council</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Banana Beach Achziv</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Nahariya</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Sokolov</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Galil Central</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Acco</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Argaman Central</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Hatmarim</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t</table></div></div>\n\n\t\t\t\t\t\t<p>&nbsp;</p>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--Chapters/Collapse-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-12\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngRepeat: collapse in CurrChapter.Collapses -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--End of Chapters/Collapse-->\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-12 xs-mb-25 lg-mb-30\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: !isOnPrintMode --><div ng-if=\"!isOnPrintMode\" class=\"ng-scope\">\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if=\"Guide.Chapters.length > 1\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- horizontal line -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov xs-mb-25 lg-mb-30 xs-mb-25 \">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"horizontal-line\"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: Guide.Chapters.length > 1 -->\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--arrows subject nav  \u05D3\u05E4\u05D3\u05D5\u05E3-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end\" ng-class=\"{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05E7\u05D5\u05D3\u05DD -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapterindex > 0 -->\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05D1\u05D0 -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div ng-show=\"CurrChapterindex < lastIndex\" class=\"col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer\" ng-click=\"updateChapterIndex(CurrChapterindex + 1)\" role=\"button\" tabindex=\"0\" aria-hidden=\"false\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"guideBreakLine xs-ml-10 pull-left width-100 text-left height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\">Next page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Haifa District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-left toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: !isOnPrintMode -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- ac- part -->\n\n\t\t\t\t\t<!-- ac part 2 -->\n\t\t\t\t\t<div class=\"ac-part ac-part-2\">\n\t\t\t\t\t<div ng-include=\"chapterItem\" class=\"row row-gov ng-scope\">\n\t\t\t\t\t<!-- Sub Title -->\n\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope\">\n\t\t\t\t\t\t<h2 class=\"h2 gray-txt pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t<span class=\"ng-binding\">Haifa District</span>\n\t\t\t\t\t\t</h3>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope\">\n\t\t\t\t\t\t<!-- IMAGE TAG  ------->\n\t\t\t\t\t\t<!--- Image-->\n\n<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"row row-gov no-gutters ng-scope\">\n<div class=\"position-relative col-lg-10 lg-p-0\">\n\t<!-- ngIf: CurrChapter.Image.ClickURLRef -->\n\n\t<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if=\"!CurrChapter.Image.ClickURLRef\" class=\"ng-scope\">\n\t</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->\n\t<!--Image desc-->\n\t<div>\n\t\t<div class=\"position-absolute\">\n\t\t\t<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->\n\t\t</div>\n\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"xs-mb-10 ng-scope\">\n\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t</div>\n</div>\n</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t<!-- End IMAGE TAG  ------->\n\n\t\t\t\t\t\t<div class=\"row row-gov no-gutters\">\n\t\t\t\t\t\t\t<!--Content Text-->\n\t\t\t\t\t\t\t<div id=\"GuidesChapterContent-2\" style=\"overflow: hidden;\" ng-bind-html=\"CurrChapter.Content | to_trusted\" fixed-tables=\"\" class=\"xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding\"><div class=\"table-responsive\"><div><div class=\"changeWidth0\" style=\"width: auto;\"></div><table align=\"left\" cellpadding=\"1\" cellspacing=\"1\" style=\"width: 100%;\" class=\"table ui-responsive\" data-mode=\"reflow\" data-role=\"table\">\n<tbody>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Kiryat Yam</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td><strong>Name of beach</strong></td>\n\t\t<td><strong>Parking</strong></td>\n\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t<td><strong>Access to shade</strong></td>\n\t\t<td><strong>Access to water</strong></td>\n\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Zevulun</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Haifa</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td><strong>Name of beach</strong></td>\n\t\t<td><strong>Parking</strong></td>\n\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t<td><strong>Access to shade</strong></td>\n\t\t<td><strong>Access to water</strong></td>\n\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Zamir 1</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Zamir 2</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Neot Kiryat Haim Central</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Bat Galim 1</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Bat Galim 2</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Hof Hacarmel Regional Council</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td><strong>Name of beach</strong></td>\n\t\t<td><strong>Parking</strong></td>\n\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t<td><strong>Access to shade</strong></td>\n\t\t<td><strong>Access to water</strong></td>\n\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Dor Central 2</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Neve Yam</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Aqueduct</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Jisr a-Zarka Regional Council</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td><strong>Name of beach</strong></td>\n\t\t<td><strong>Parking</strong></td>\n\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t<td><strong>Access to shade</strong></td>\n\t\t<td><strong>Access to water</strong></td>\n\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Jisr</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Hadera</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td><strong>Name of beach</strong></td>\n\t\t<td><strong>Parking</strong></td>\n\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t<td><strong>Access to shade</strong></td>\n\t\t<td><strong>Access to water</strong></td>\n\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Kfar Yam&nbsp;</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Olga Central 2</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n</tbody>\n</table></div></div>\n\n<p>&nbsp;</p>\n</div>\n\n\t\t\t\t\t\t\t<!--Chapters/Collapse-->\n\t\t\t\t\t\t\t<div class=\"col-12\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n\t\t\t\t\t\t\t\t<!-- ngRepeat: collapse in CurrChapter.Collapses -->\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->\n\t\t\t\t\t\t\t<!--End of Chapters/Collapse-->\n\n\t\t\t\t\t\t\t<div class=\"col-12 xs-mb-25 lg-mb-30\">\n\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t<!-- Files for Download-->\n<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->\n\n\t\t\t\t\t\t\t\t<!-- ngIf: !isOnPrintMode --><div ng-if=\"!isOnPrintMode\" class=\"ng-scope\">\n\n\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if=\"Guide.Chapters.length > 1\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t<!-- horizontal line -->\n\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov xs-mb-25 lg-mb-30 xs-mb-25 \">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"horizontal-line\"></div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: Guide.Chapters.length > 1 -->\n\n\t\t\t\t\t\t\t\t\t<!--arrows subject nav  \u05D3\u05E4\u05D3\u05D5\u05E3-->\n\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end\" ng-class=\"{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]\">\n\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05E7\u05D5\u05D3\u05DD -->\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapterindex > 0 --><div ng-if=\"CurrChapterindex > 0\" class=\"col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope\" ng-click=\"updateChapterIndex(CurrChapterindex - 1)\" role=\"button\" tabindex=\"0\">\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-right toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\"> Previous page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Northern District</span>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapterindex > 0 -->\n\n\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05D1\u05D0 -->\n\t\t\t\t\t\t\t\t\t\t<div ng-show=\"CurrChapterindex < lastIndex\" class=\"col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer\" ng-click=\"updateChapterIndex(CurrChapterindex + 1)\" role=\"button\" tabindex=\"0\" aria-hidden=\"false\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"guideBreakLine xs-ml-10 pull-left width-100 text-left height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\">Next page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Central District</span>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-left toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div><!-- end ngIf: !isOnPrintMode -->\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- end ac part-2 -->\n\n\t\t\t\t\t<!-- ac-part-3 -->\n\t\t\t\t\t<div class=\"ac-part ac-part-3\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div ng-include=\"chapterItem\" class=\"row row-gov ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- Sub Title -->\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<h2 class=\"h2 gray-txt pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"ng-binding\">Central District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- IMAGE TAG  ------->\n\t\t\t\t\t\t\t\t\t\t\t\t\t<!--- Image-->\n\t\t\t\t\t\t\n\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"row row-gov no-gutters ng-scope\">\n\t\t\t\t\t\t\t<div class=\"position-relative col-lg-10 lg-p-0\">\n\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image.ClickURLRef -->\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if=\"!CurrChapter.Image.ClickURLRef\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->\n\t\t\t\t\t\t\t\t<!--Image desc-->\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t<div class=\"position-absolute\">\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"xs-mb-10 ng-scope\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- End IMAGE TAG  ------->\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--Content Text-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div id=\"GuidesChapterContent-3\" style=\"overflow: hidden;\" ng-bind-html=\"CurrChapter.Content | to_trusted\" fixed-tables=\"\" class=\"xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding\"><div class=\"table-responsive\"><div><div class=\"changeWidth0\" style=\"width: auto;\"></div><table cellpadding=\"1\" cellspacing=\"1\" style=\"width: 100%;\" class=\"table ui-responsive\" data-mode=\"reflow\" data-role=\"table\">\n\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Emek Hefer Regional Council</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Michmoret \u2013 Station number 1</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Michmoret \u2013 Station number 2</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Joint with number 1</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Beit Yannai</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>NeUrim Beach</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Netanya</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Kiryat Tzanz</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>HaOnot Beach</td>\n\t\t\t\t\t\t\t\t\t<td>Parking</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Ampi Beach</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Herzl</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Sironit Beach A</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Sironit Beach B</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Argaman Beach</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Poleg Beach</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Hof Hasharon Regional Council</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Shefayim (Ga\u2019ash)</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Rishon Le-Zion</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Beach number 1 \u2013 Hakachol (Blue) Beach</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Beach number 2 \u2013 Neve Hof Beach</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Beach number 3 \u2013 Hofit Beach</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Beach number 4 \u2013 Tel Yonah Beach</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Beach number 5 \u2013 Hayeladim (Children\u2019s) Beach</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td>Beach number 6 \u2013 separate beach</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Gan Raveh Regional Council</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t<td>Palmahim Beach</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t</table></div></div>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p>&nbsp;</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--Chapters/Collapse-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-12\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngRepeat: collapse in CurrChapter.Collapses -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--End of Chapters/Collapse-->\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-12 xs-mb-25 lg-mb-30\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: !isOnPrintMode --><div ng-if=\"!isOnPrintMode\" class=\"ng-scope\">\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if=\"Guide.Chapters.length > 1\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- horizontal line -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov xs-mb-25 lg-mb-30 xs-mb-25 \">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"horizontal-line\"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: Guide.Chapters.length > 1 -->\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--arrows subject nav  \u05D3\u05E4\u05D3\u05D5\u05E3-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end\" ng-class=\"{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05E7\u05D5\u05D3\u05DD -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapterindex > 0 --><div ng-if=\"CurrChapterindex > 0\" class=\"col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope\" ng-click=\"updateChapterIndex(CurrChapterindex - 1)\" role=\"button\" tabindex=\"0\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-right toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\"> Previous page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Haifa District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapterindex > 0 -->\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05D1\u05D0 -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div ng-show=\"CurrChapterindex < lastIndex\" class=\"col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer\" ng-click=\"updateChapterIndex(CurrChapterindex + 1)\" role=\"button\" tabindex=\"0\" aria-hidden=\"false\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"guideBreakLine xs-ml-10 pull-left width-100 text-left height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\">Next page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Tel Aviv District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-left toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: !isOnPrintMode -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- end ac-part-3 -->\n\n\t\t\t\t\t<!-- ac-part-4 -->\n\t\t\t\t\t<div class=\"ac-part ac-part-4\">\n\t\t\t\t\t<div ng-include=\"chapterItem\" class=\"row row-gov ng-scope\">\n\t\t\t<!-- Sub Title -->\n\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope\">\n\t\t\t\t<h2 class=\"h2 gray-txt pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t<span class=\"ng-binding\">Tel Aviv District</span>\n\t\t\t\t</h3>\n\t\t\t</div>\n\n\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope\">\n\t\t\t\t<!-- IMAGE TAG  ------->\n\t\t\t\t<!--- Image-->\n\n<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"row row-gov no-gutters ng-scope\">\n<div class=\"position-relative col-lg-10 lg-p-0\">\n<!-- ngIf: CurrChapter.Image.ClickURLRef -->\n\n<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if=\"!CurrChapter.Image.ClickURLRef\" class=\"ng-scope\">\n</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->\n<!--Image desc-->\n<div>\n<div class=\"position-absolute\">\n\t<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->\n</div>\n<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"xs-mb-10 ng-scope\">\n\t<span class=\"small-txt ng-binding\"></span>\n\t<span class=\"small-txt ng-binding\"></span>\n</div><!-- end ngIf: CurrChapter.Image -->\n</div>\n</div>\n</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t<!-- End IMAGE TAG  ------->\n\n\t\t\t\t<div class=\"row row-gov no-gutters\">\n\t\t\t\t\t<!--Content Text-->\n\t\t\t\t\t<div id=\"GuidesChapterContent-4\" style=\"overflow: hidden;\" ng-bind-html=\"CurrChapter.Content | to_trusted\" fixed-tables=\"\" class=\"xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding\"><div class=\"table-responsive\"><div><div class=\"changeWidth0\" style=\"width: auto;\"></div><table cellpadding=\"1\" cellspacing=\"1\" style=\"width: 100%;\" class=\"table ui-responsive\" data-mode=\"reflow\" data-role=\"table\">\n<tbody>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Herzliya</strong></td>\n</tr>\n<tr style=\"background-color: rgb(244, 244, 244);\">\n<td><strong>Name of beach</strong></td>\n<td><strong>Parking</strong></td>\n<td><strong>Bathrooms and showers</strong></td>\n<td><strong>Access to shade</strong></td>\n<td><strong>Access to water</strong></td>\n<td><strong>Bathing chairs for the disabled</strong></td>\n</tr>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td>Nof Yam</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n</tr>\n<tr style=\"background-color: rgb(244, 244, 244);\">\n<td>Hasharon&nbsp;&nbsp; &nbsp;Yes</td>\n<td>Yes</td>\n<td>No</td>\n<td>No</td>\n<td>Yes</td>\n<td>No</td>\n</tr>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td>Zevulun</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n</tr>\n<tr style=\"background-color: rgb(244, 244, 244);\">\n<td>Acadia North Beach&nbsp;&nbsp; &nbsp;</td>\n<td>Yes</td>\n<td>Yes</td>\n<td>No</td>\n<td>Yes</td>\n<td>No</td>\n</tr>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td>Acadia South Beach</td>\n<td>Yes</td>\n<td>Yes</td>\n<td>No</td>\n<td>Yes</td>\n<td>Yes</td>\n</tr>\n<tr style=\"background-color: rgb(244, 244, 244);\">\n<td>Acadia South Beach \u2013 Disabled</td>\n<td>Yes</td>\n<td>Yes</td>\n<td>No</td>\n<td>Yes</td>\n<td>Yes</td>\n</tr>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td>Separate beach</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n</tr>\n<tr style=\"background-color: rgb(244, 244, 244);\">\n<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Tel Aviv - Jaffa</strong></td>\n</tr>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td><strong>Name of beach</strong></td>\n<td><strong>Parking</strong></td>\n<td><strong>Bathrooms and showers</strong></td>\n<td><strong>Access to shade</strong></td>\n<td><strong>Access to water</strong></td>\n<td><strong>Bathing chairs for the disabled</strong></td>\n</tr>\n<tr style=\"background-color: rgb(244, 244, 244);\">\n<td>HaTzuk Beach \u2013 Station number 1</td>\n<td>Yes</td>\n<td>Yes</td>\n<td>No</td>\n<td>No</td>\n<td>Yes</td>\n</tr>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td>Tel Baruch Beach \u2013 Station number 1</td>\n<td>Yes</td>\n<td>Yes</td>\n<td>No</td>\n<td>No</td>\n<td>Yes</td>\n</tr>\n<tr style=\"background-color: rgb(244, 244, 244);\">\n<td>Nordau (Metzitzim) Beach</td>\n<td>Yes</td>\n<td>Yes</td>\n<td>Yes</td>\n<td>No</td>\n<td>Yes</td>\n</tr>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td>Nordau separate beach</td>\n<td>Yes</td>\n<td>Bathrooms only</td>\n<td>Yes</td>\n<td>No</td>\n<td>Yes</td>\n</tr>\n<tr style=\"background-color: rgb(244, 244, 244);\">\n<td>Gordon</td>\n<td>No</td>\n<td>Bathrooms only</td>\n<td>No</td>\n<td>No</td>\n<td>Yes</td>\n</tr>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td>Bograshov</td>\n<td>No</td>\n<td>Bathrooms only</td>\n<td>No</td>\n<td>No</td>\n<td>Yes</td>\n</tr>\n<tr style=\"background-color: rgb(244, 244, 244);\">\n<td>Allenby (Jerusalem)</td>\n<td>No</td>\n<td>Yes</td>\n<td>No</td>\n<td>No</td>\n<td>Yes</td>\n</tr>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td>Charles Clore</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n</tr>\n<tr style=\"background-color: rgb(244, 244, 244);\">\n<td>Jaffa \u2013 Givat HaAliyah</td>\n<td>Yes</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>Yes</td>\n</tr>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td>Hilton North</td>\n<td>Yes</td>\n<td>Yes</td>\n<td>Yes</td>\n<td>Yes</td>\n<td>Yes</td>\n</tr>\n<tr style=\"background-color: rgb(244, 244, 244);\">\n<td>HaTzuk Beach \u2013 Station number 2</td>\n<td>Yes</td>\n<td>Bathrooms only</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n</tr>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td>Frishman</td>\n<td>No</td>\n<td>Bathrooms only</td>\n<td>No</td>\n<td>No</td>\n<td>Yes</td>\n</tr>\n<tr style=\"background-color: rgb(244, 244, 244);\">\n<td>Aviv Beach</td>\n<td>No</td>\n<td>Bathrooms only</td>\n<td>No</td>\n<td>No</td>\n<td>Yes</td>\n</tr>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Bat Yam</strong></td>\n</tr>\n<tr style=\"background-color: rgb(244, 244, 244);\">\n<td><strong>Name of beach</strong></td>\n<td><strong>Parking</strong></td>\n<td><strong>Bathrooms and showers</strong></td>\n<td><strong>Access to shade</strong></td>\n<td><strong>Access to water</strong></td>\n<td><strong>Bathing chairs for the disabled</strong></td>\n</tr>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td>HaSela \u2013 Station number 1</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n</tr>\n<tr style=\"background-color: rgb(244, 244, 244);\">\n<td>HaSela \u2013 Station number 2</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n</tr>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td>HaSela \u2013 Station number 3</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n</tr>\n<tr style=\"background-color: rgb(244, 244, 244);\">\n<td>Sample Beach</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n</tr>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td>Riviera</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n</tr>\n<tr style=\"background-color: rgb(244, 244, 244);\">\n<td>Separate beach</td>\n<td>Yes</td>\n<td>Bathrooms only</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n</tr>\n<tr style=\"background-color: rgb(255, 255, 255);\">\n<td>Tayo</td>\n<td>Yes</td>\n<td>Bathrooms only</td>\n<td>No</td>\n<td>No</td>\n<td>No</td>\n</tr>\n</tbody>\n</table></div></div>\n\n<p>&nbsp;</p>\n</div>\n\n\t\t\t\t\t<!--Chapters/Collapse-->\n\t\t\t\t\t<div class=\"col-12\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n\t\t\t\t\t\t<!-- ngRepeat: collapse in CurrChapter.Collapses -->\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->\n\t\t\t\t\t<!--End of Chapters/Collapse-->\n\n\t\t\t\t\t<div class=\"col-12 xs-mb-25 lg-mb-30\">\n\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t<!-- Files for Download-->\n<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->\n\n\t\t\t\t\t\t<!-- ngIf: !isOnPrintMode --><div ng-if=\"!isOnPrintMode\" class=\"ng-scope\">\n\n\t\t\t\t\t\t\t<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if=\"Guide.Chapters.length > 1\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t<!-- horizontal line -->\n\t\t\t\t\t\t\t\t<div class=\"row row-gov xs-mb-25 lg-mb-30 xs-mb-25 \">\n\t\t\t\t\t\t\t\t\t<div class=\"horizontal-line\"></div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div><!-- end ngIf: Guide.Chapters.length > 1 -->\n\n\t\t\t\t\t\t\t<!--arrows subject nav  \u05D3\u05E4\u05D3\u05D5\u05E3-->\n\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end\" ng-class=\"{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]\">\n\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05E7\u05D5\u05D3\u05DD -->\n\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapterindex > 0 --><div ng-if=\"CurrChapterindex > 0\" class=\"col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope\" ng-click=\"updateChapterIndex(CurrChapterindex - 1)\" role=\"button\" tabindex=\"0\">\n\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-right toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t<div class=\"xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\"> Previous page:</span>\n\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Central District</span>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapterindex > 0 -->\n\n\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05D1\u05D0 -->\n\t\t\t\t\t\t\t\t<div ng-show=\"CurrChapterindex < lastIndex\" class=\"col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer\" ng-click=\"updateChapterIndex(CurrChapterindex + 1)\" role=\"button\" tabindex=\"0\" aria-hidden=\"false\">\n\t\t\t\t\t\t\t\t\t<div class=\"guideBreakLine xs-ml-10 pull-left width-100 text-left height100\">\n\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\">Next page:</span>\n\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Southern District</span>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-left toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div><!-- end ngIf: !isOnPrintMode -->\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- end ac-part-4 -->\n\n\t\t\t\t\t<!-- ac-part-5 -->\n\t\t\t\t\t<div class=\"ac-part ac-part-5\">\n\t\t\t\t\t<div ng-include=\"chapterItem\" class=\"row row-gov ng-scope\">\n\t\t\t\t\t<!-- Sub Title -->\n\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope\">\n\t\t\t\t\t\t<h2 class=\"h2 gray-txt pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t<span class=\"ng-binding\">Southern District</span>\n\t\t\t\t\t\t</h3>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope\">\n\t\t\t\t\t\t<!-- IMAGE TAG  ------->\n\t\t\t\t\t\t<!--- Image-->\n\n<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"row row-gov no-gutters ng-scope\">\n<div class=\"position-relative col-lg-10 lg-p-0\">\n\t<!-- ngIf: CurrChapter.Image.ClickURLRef -->\n\n\t<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if=\"!CurrChapter.Image.ClickURLRef\" class=\"ng-scope\">\n\t</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->\n\t<!--Image desc-->\n\t<div>\n\t\t<div class=\"position-absolute\">\n\t\t\t<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->\n\t\t</div>\n\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"xs-mb-10 ng-scope\">\n\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t</div>\n</div>\n</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t<!-- End IMAGE TAG  ------->\n\n\t\t\t\t\t\t<div class=\"row row-gov no-gutters\">\n\t\t\t\t\t\t\t<!--Content Text-->\n\t\t\t\t\t\t\t<div id=\"GuidesChapterContent-5\" style=\"overflow: hidden;\" ng-bind-html=\"CurrChapter.Content | to_trusted\" fixed-tables=\"\" class=\"xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding\"><div class=\"table-responsive\"><div><div class=\"changeWidth0\" style=\"width: auto;\"></div><table cellpadding=\"1\" cellspacing=\"1\" style=\"width: 100%;\" class=\"table ui-responsive\" data-mode=\"reflow\" data-role=\"table\">\n<tbody>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Ashdod</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td><strong>Name of beach</strong></td>\n\t\t<td><strong>Parking</strong></td>\n\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t<td><strong>Access to shade</strong></td>\n\t\t<td><strong>Access to water</strong></td>\n\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Mei Ami Beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Lido</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>&nbsp;</td>\n\t\t<td>&nbsp;</td>\n\t\t<td>&nbsp;</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Oranim</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Hakshatot</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Separate beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Rova K</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Riviera</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td colspan=\"6\" style=\"text-align: center;\"><strong>Hof Ashkelon Regional Council</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td><strong>Name of beach</strong></td>\n\t\t<td><strong>Parking</strong></td>\n\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t<td><strong>Access to shade</strong></td>\n\t\t<td><strong>Access to water</strong></td>\n\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Nitzanim</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Zikim</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Ashkelon</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td><strong>Name of beach</strong></td>\n\t\t<td><strong>Parking</strong></td>\n\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t<td><strong>Access to shade</strong></td>\n\t\t<td><strong>Access to water</strong></td>\n\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Bar Kochva North</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Bar Kochva South</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Delila North</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Delila South</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Ashkelon National Park Beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Separate beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>\u05DC\u05D0</td>\n\t\t<td>\u05DC\u05D0</td>\n\t\t<td>\u05DC\u05D0</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Tamar Regional Council</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td><strong>Name of beach</strong></td>\n\t\t<td><strong>Parking</strong></td>\n\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t<td><strong>Access to shade</strong></td>\n\t\t<td><strong>Access to water</strong></td>\n\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Mazor Springs</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Meridian Beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Hod Hotel Beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Tzel Harim</td>\n\t\t<td>Yes</td>\n\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Crown Plaza Beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Lot</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Lot\u2019s Wife</td>\n\t\t<td>Yes</td>\n\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Ein Bokek South</td>\n\t\t<td>Yes</td>\n\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Daniel Hotel Beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Solarium Beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Isrotel Beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>International Beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Leonardo Plaza Beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Zohar Springs (North)</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Separate beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Leonardo Club Beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Eilat&nbsp;&nbsp; &nbsp;</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td><strong>Name of beach</strong></td>\n\t\t<td><strong>Parking</strong></td>\n\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t<td><strong>Access to shade</strong></td>\n\t\t<td><strong>Access to water</strong></td>\n\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td><br>\n\t\tSeparate beach</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Herod\u2019s beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t</tr>\n\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td><br>\n\t\tNorthwestern Beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t</tr>\n</tbody>\n</table></div></div>\n\n<p>&nbsp;</p>\n</div>\n\n\t\t\t\t\t\t\t<!--Chapters/Collapse-->\n\t\t\t\t\t\t\t<div class=\"col-12\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n\t\t\t\t\t\t\t\t<!-- ngRepeat: collapse in CurrChapter.Collapses -->\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->\n\t\t\t\t\t\t\t<!--End of Chapters/Collapse-->\n\n\t\t\t\t\t\t\t<div class=\"col-12 xs-mb-25 lg-mb-30\">\n\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t<!-- Files for Download-->\n<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->\n\n\t\t\t\t\t\t\t\t<!-- ngIf: !isOnPrintMode --><div ng-if=\"!isOnPrintMode\" class=\"ng-scope\">\n\n\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if=\"Guide.Chapters.length > 1\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t<!-- horizontal line -->\n\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov xs-mb-25 lg-mb-30 xs-mb-25 \">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"horizontal-line\"></div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: Guide.Chapters.length > 1 -->\n\n\t\t\t\t\t\t\t\t\t<!--arrows subject nav  \u05D3\u05E4\u05D3\u05D5\u05E3-->\n\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-start\" ng-class=\"{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]\">\n\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05E7\u05D5\u05D3\u05DD -->\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapterindex > 0 --><div ng-if=\"CurrChapterindex > 0\" class=\"col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope\" ng-click=\"updateChapterIndex(CurrChapterindex - 1)\" role=\"button\" tabindex=\"0\">\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-right toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\"> Previous page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Tel Aviv District</span>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapterindex > 0 -->\n\n\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05D1\u05D0 -->\n\t\t\t\t\t\t\t\t\t\t<div ng-show=\"CurrChapterindex < lastIndex\" class=\"col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer ng-hide\" ng-click=\"updateChapterIndex(CurrChapterindex + 1)\" role=\"button\" tabindex=\"0\" aria-hidden=\"true\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"guideBreakLine xs-ml-10 pull-left width-100 text-left height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\">Next page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\"></span>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-left toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div><!-- end ngIf: !isOnPrintMode -->\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- end ac-part-5 -->\n\n\t\t\t\t</div>\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/destination-for-all/6.jpg")+" class=\"img-responsive\">\n\t\t\t </div><br>\n\t\t\t\t\t\n\t\t\t\t\t"};}},// {
// 				id:"EILAT1",
// 		       	ctg : "eilat-negev",
// 		        bgImage : "/HomeSlider/desktop/4.jpg",
// 		        mobBgImage : "/HomeSlider/M/3.jpg",
// 		       	isVid:true,
// 		       	vidId: "ZdnNT-GDJv4",
// 		        title : "EILAT",
// 		        smltitle : "",
// 		        html: function(){
// 					return {
// 						__html: `
//                         <p>Eilat is a port that is Israel’s outlet to India, eastern Asia and Africa. Six decades ago it was a shanty-style frontier town, but Eilat has developed into one of Israel’s major resorts whose Red Sea beaches and dozens of hotels attract Israelis and tourists from 100 countries. Eilat is devoted to vacationing. Resorts line the promenade and lagoon, along with a giant shopping mall, restaurants and a variety of attractions for visitors young and old. Eilat is also an entrée to one of the world’s most magnificent coral reefs: the Eilat Underwater Observatory is a must for every visitor, as is the dolphin reef where tourists swim with the dolphins.</p>
//                         <div class="img-wrapper">
// 								    <img src=${getImgUrl()+ "/posts/eilat1/1.jpg"} class="img-responsive">
// 							    </div>
//                         <p>Eilat is a 4/5-hour drive from Tel Aviv and Jerusalem – or a one-hour flight into Eilat Airport which sits in the heart of town. A 15-minute drive south from Eilat brings visitors to the crossing point to Egypt. And 10-minutes to the north, tourists cross to Jordan and the neighboring port city of Aqaba. Many visitors to Eilat take day trips to Petra in Jordan.</p>
//                          <div class="img-wrapper">
// 								    <img src=${getImgUrl()+ "/posts/eilat1/2.jpg"} class="img-responsive">
// 							    </div>
//                         <h3>Take a deep at the Red Sea</h3>
//                         <p>An amazing attraction in itself, Eilat’s gorgeous Red Sea and the 10 kilometer-long shoreline surrounding it are the city’s focal point and the main attraction for tourists from far and wide.<br> With their clean, clear and unexpectedly cool water allowing a welcome escape from the city’s high temperatures and dry air, and the wide variety of facilities and attractions, Eilat’s beaches are the perfect spot for sunbathing, rest and relaxation.</p>
//                         <p>Extreme sports enthusiasts will love the dozens of water sports clubs spread along the southern and northern coasts of Eilat, and the range of activities such as Jet skiing, banana boats, tubing, kayaking and much more.</p>
//                         <h3>Feel the vibe</h3>
//                         <p>When evening comes and the hot desert sun sets on Eilat and the pools and beaches close, that is just the time to shower, change and hit the town’s fantastic nightlife scene. Eilat holds a unique record – the city with the most clubs, bars and other entertainment venues per capita in Israel, so there is no shortage of hotspots to make your night as fun-filled as your day.</p>
//                         <h3>A desert adventure</h3>
//                         <p>North of the city lies the southern Arava, a region of breathtaking desert vistas, and one of the most recommended areas to visit in the country, where you can feel the vast expanses and hike steep cliffs, valleys, streams and more.</p>
//                         <p>The colorful and stunning mountains of the Eilat area, besides contributing to the city's breathtaking view, will provide all nature lovers with an unforgettable experience. There are a variety of routes and sites to visit and enjoy by hiking, bicycling, driving, camel riding and even rock climbing or rappelling down cliffs for the extreme sports enthusiasts.</p>
//                         <p>Don't wait up. Visit Eilat. Escape to the sun.</p>
// 						 `
// 		    }
// 		  }
// 		},
// {
// 		id:"Welcome_To_Eilat",
//        	ctg : "eilat-negev",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:true,
//        	vidId:"ZdnNT-GDJv4",
//         title : "WELCOME TO EILAT",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
//                                 <h3>A city of sun and fun!</h3>
// 							<p>The southernmost city in Israel, Eilat is renowned for its spectacular combination of the surrounding desert landscape, the beautiful bay and the summer sun that shines all year round.</p>
// 							<p>Whether you come to stay in Eilat as a family, a couple or even by yourself, you will find loads to see and do here. Accommodations are abundant, ranging from youth hostels to the r luxury resorts, offering visitors an unforgettable 5 star experience, with everything from the finest restaurants to beach side service.</p>
// 							<p></p>
// 							<div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/welcome-to-eilat/1.jpg"} class="img-responsive">
// 							</div>
// 							<p>With a whopping 360 Sunny days a year, a visit to Eilat is a fun-filled experience, where you get to relax, recharge and get energized all at the same time. This lively resort city offers a multitude of year-round activities and attractions, excellent restaurants and cafés, shopping centers and trendy bars and clubs.</p>
// 							<h3>The Red Sea</strong><br> An amazing attraction, Eilat’s gorgeous Red Sea and the 10-kilometer-long shoreline surrounding it are the city’s focal point and the main attraction for tourists from far and wide. With their clean, clear and unexpectedly cool water, allowing a welcome escape from the city’s high temperatures and dry air, and the wide variety of facilities and attractions, Eilat’s beaches are the perfect spot for sunbathing, rest and relaxation.</p>
// 							<p>Extreme sports enthusiasts will love the dozens of water sports clubs spread along the Southern and Northern coasts of Eilat, and the range of activities such as Jet skiing, banana boats, tubing, kayaking and much more.</p>
// 							<p></p>
//                         `
//     }
//   }
// },
{id:"The_Ultimate_Holiday",ctg:"eilat-negev",bgImage:"/posts/bank/eilat1/1.jpg",mobBgImage:"/posts/bank/eilat1/M.jpg",isVid:false,title:"¿POR QUÉ EILAT ES EL MEJOR DESTINO DE VACACIONES?",smltitle:"",html:function html(){return{__html:"\n                                 \n                                 <br/>\n                                <h3>Explorando la Ciudad del Sol Eterno<h3>\n\t\t\t\t\t\t\t    <p><strong>Eilat</strong>, la ciudad m\xE1s al sur de Israel, tiene todo lo que necesita para unas vacaciones perfectas. Ya sea si est\xE1 buscando una escapada rom\xE1ntica, vacaciones familiares, una aventura llena de acci\xF3n o una fiesta con sus amigos, esta bulliciosa ciudad tur\xEDstica a orillas del mar Rojo es el lugar perfecto para usted. Sol mediterr\xE1neo, aguas cristalinas, balnearios relajantes, vida nocturna vibrante, compras libres de impuestos y una interminable lista de atracciones, eso es Eilat.</p>\n\t\t\t\t\t\t\t\t<p><strong>Disfrute de los rayos del sol</strong>. Con el sol de verano que brilla durante todo el a\xF1o, el mejor momento para visitar Eilat es... cualquier momento! Incluso en medio del fr\xEDo invierno europeo, Eilat ofrece una escapada del fr\xEDo. Solo s\xFAbase a un avi\xF3n y en unas pocas horas dejar\xE1 de tiritar y se sentir\xE1 lleno de vida.</p>\n\t\t\t\t\t\t\t\t<p><strong>Elija su casa de vacaciones.</strong> Hostales y albergues asequibles a su bolsillo o lujosos hoteles y hoteles boutique. Centros tur\xEDsticos orientados a familias y grupos o apartados, tranquilos y rom\xE1nticos: Eilat ofrece una gran variedad de alojamientos para todos los presupuestos y necesidades.</p>\n\t\t\t\t\t\t\t\t<p><strong>Salte al agua</strong>. Con m\xE1s de 7 km de la impresionante costa del mar Rojo, Eilat tiene mucho que ofrecer cuando se trata de actividades acu\xE1ticas. Desde snorkel y buceo hasta windsurf, kite-surf, navegaci\xF3n y mucho m\xE1s, esta ciudad lo tiene todo.</p>\n\t\t\t\t\t\t\t\t<p>Experimente el <strong>arrecife de delfines</strong>, una playa ecol\xF3gica familiar con un magn\xEDfico jard\xEDn bot\xE1nico, piscinas de relajaci\xF3n y la atracci\xF3n principal: una oportunidad para ver, tocar, nadar y bucear con delfines. (<em>No se preocupe, toda interacci\xF3n con estas hermosas criaturas se basa \xFAnicamente en la libre elecci\xF3n del delf\xEDn</em>).</p>\n                                <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/the-ultimate-holiday/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p>Visite el <strong>Observatorio Submarino</strong>, una de las atracciones m\xE1s populares de Eilat que le permite a usted y su familia ver y aprender sobre la vida marina \xFAnica del mar Rojo. A trav\xE9s de los enormes ventanales observar\xE1 tiburones, tortugas, rayas y peces multicolores del mar Rojo. Navegando en un barco con visi\xF3n submarina, se sentir\xE1 parte de este m\xE1gico reino submarino.</p>\n\t\t\t\t\t\t\t\t<p>No se pierda la famosa <strong>Reserva Natural de Coral Beach</strong> y su impresionante arrecife de corales. Practique snorkel y buceo para ver los coloridos peces y las extraordinarias plantas acu\xE1ticas en este raro y delicado h\xE1bitat natural.</p>\n\t\t\t\t\t\t\t\t<p><strong>De aventura por el desierto</strong>. El desierto del Negev ofrece algunas de las rutas panor\xE1micas m\xE1s espectaculares de Israel. Senderismo, ciclismo o paseos en jeep para explorar y maravillarse con la belleza que le rodea.</p>\n\t\t\t\t\t\t\t\t<p>A solo 25 km al norte de Eilat, encontrar\xE1 el <strong>Valle de Timna</strong>. Realice un recorrido, explore el espl\xE9ndido paisaje y la antig\xFCedad de la primera mina de cobre del mundo y disfrute de las numerosas atracciones que ofrece a familias y aventureros.</p>\n\t\t\t\t\t\t\t\t<p>\xBFQuiere complementar su aventura? Desde la ciudad es f\xE1cilmente accesible el resto del pa\xEDs. Haga una excursi\xF3n de un d\xEDa al mar Muerto o Jerusal\xE9n.</p>\n\t\t\t\t\t\t\t\t<p><strong>Relajese</strong>. Eilat es una ciudad tranquila donde hacer un alto y descansar. Fiel a su estilo, est\xE1 llena de fant\xE1sticas instalaciones de spa que ofrecen diferentes tratamientos, desde masajes tradicionales hasta terapia de agua. <em>Conf\xEDe en nosotros, \xA1vale la pena!</em></p>\n\t\t\t\t\t\t\t\t<p><strong>Compre, coma, beba y festeje</strong>. Compre en el bazar del paseo mar\xEDtimo, en el lujoso bulevar y en numerosos centros comerciales, \xA1todo es libre de impuestos!</p>\n\t\t\t\t\t\t\t\t<p><strong>Salga de fiesta por la noche.</strong> Divi\xE9rtase viendo el colorido espect\xE1culo audiovisual de la fuente musical; prep\xE1rese para dejarse cautivar por el espect\xE1culo Wow al estilo de Broadway que combina baile, efectos de luz acrob\xE1ticos, gran banda sonora y muchas sorpresas m\xE1s.</p>\n\t\t\t\t\t\t\t\t<p>Cene en uno de los muchos restaurantes y bares de la ciudad y luego baile en un club.</p>\n\t\t\t\t\t\t\t\t<p>No hay nada mejor que esto.</p>\n\t\t\t\t\t\t\t\t                               \n                               \n\t\t\t\t\t\t\t  \n\n\n\t\t                        "};}},{id:"Eilat_Calling",ctg:"eilat-negev",bgImage:"/posts/bank/eilat2/1.jpg",mobBgImage:"/posts/bank/eilat2/M.jpg",isVid:true,vidId:"ZdnNT-GDJv4",title:"EILAT EL VERANO INTERMINABLE",smltitle:"",html:function html(){return{__html:"\n                                  \n\t\t\t\t\t\t\t\t\t<h3>La capital del mar Rojo, Eilat, es la ciudad tur\xEDstica m\xE1s famosa de Israel que atrae a casi 2.8 millones de visitantes al a\xF1o que vienen de vacaciones a las orillas del impresionante mar Rojo</h3>\n\t\t\t\t\t\t\t\t\t<p>Eilat, la ciudad m\xE1s meridional de Israel, es famosa por su espectacular combinaci\xF3n de paisaje des\xE9rtico circundante, la hermosa bah\xEDa y el sol de verano que brilla todo el a\xF1o.</span></p>\n\t\t\t\t\t\t\t\t\t<p>Si viene a Eilat con su familia, pareja o incluso s\xF3lo, encontrar\xE1 mucho para ver y hacer y variedad de alojamiento, que incluye desde los mejores hoteles de lujo de 5 estrellas a apartamentos acogedores de Airbnb y albergues juveniles.</span></p>\n\t\t\t\t\t\t\t\t\t<p>Eilat cuenta con&nbsp; 360 d\xEDas de sol al a\xF1o, lo que la hace muy popular entre los turistas de todo el mundo que buscan alejarse de su fr\xEDo clima invernal.</span><br>Una visita a Eilat es una experiencia llena de diversi\xF3n donde se relajar\xE1 y se llenar\xE1 de energ\xEDa al mismo tiempo. Esta animada ciudad ofrece una multitud de actividades y atracciones durante todo el a\xF1o, excelentes restaurantes y caf\xE9s, centros comerciales y bares y clubes de moda.</span><br>\xBF</span>La mejor parte? Todo en Eilat est\xE1 a pocos pasos de la playa.</span></p>\n\t\t\t\t\t\t\t\t\t<h3>Sum\xE9rjase en las profundidades del mar Rojo</h3>\n\t\t\t\t\t\t\t\t\t<p>Una atracci\xF3n incre\xEDble por s\xED misma, el magn\xEDfico mar Rojo de Eilat y la costa de 10 kil\xF3metros que la rodean son el punto focal de la ciudad y la principal atracci\xF3n para turistas de todo el mundo.</span><br>Las playas de Eilat son perfectas para tomar el sol, descansar y relajarse, gracias a su agua transparente y fresca que permite una escapada de las altas temperaturas y del aire seco de la ciudad, sin olvidar la gran variedad de instalaciones y atracciones.</span><br>Los entusiastas de los deportes extremos adorar\xE1n las decenas de clubes de deportes acu\xE1ticos que se extienden por las costas del sur y norte de Eilat y la gama de actividades como esqu\xED acu\xE1tico, bananas, snorkel, kayak y mucho m\xE1s.</span></p>\n\t\t\t\t\t\t\t\t\t<h3>Viva la noche</h3>\n\t\t\t\t\t\t\t\t\t<p>Cuando cae la tarde y el sol del desierto da una tregua y las piscinas y las playas cierran, es justo el momento de ducharse, cambiarse y disfrutar de la vida nocturna fant\xE1stica de la ciudad. Eilat tiene un r\xE9cord \xFAnico - la ciudad con m\xE1s clubes, bares y otros lugares de entretenimiento per c\xE1pita en Israel, por lo que no hay escasez de lugares para disfrutar de la noche tanto como del d\xEDa.</span></p>\n\t\t\t\t\t\t\t\t\t<h3>Una aventura en el desierto</h3>\n\t\t\t\t\t\t\t\t\t<p>Al norte de la ciudad se encuentra la sure\xF1a Arava, una regi\xF3n con impresionantes vistas al desierto, y una de las zonas m\xE1s recomendables para visitar en el pa\xEDs, donde puede sentir las vastas extensiones y caminar por los cortados escarpados, valles, arroyos y mucho m\xE1s.</span></p>\n\t\t\t\t\t\t\t\t\t<p>Las coloridas e impresionantes monta\xF1as de la zona de Eilat, adem\xE1s de contribuir a la impresionante vista de la ciudad, proporcionan a todos los amantes de la naturaleza una experiencia inolvidable. Hay una variedad de rutas y lugares para visitar y disfrutar del senderismo, ciclismo, conducci\xF3n, paseo en camello e incluso escalada en roca o rapel en los cortados para los entusiastas de los deportes extremos.</span></p>\n\t\t\t\t\t\t\t\t\t<p>No espere. Visite Eilat. Escape al sol.</span></p>\n\t\t\t\t\t\t\t\t\t\t\t                        "};}},{id:"Eilat_Doolphin_Reef",ctg:"eilat-negev",bgImage:"/posts/bank/eilat1/1.jpg",mobBgImage:"/posts/bank/eilat1/M.jpg",isVid:true,vidId:"3Cvz8GoxNzA",title:"EL ARRECIFE DE DELFINES DE EILAT",smltitle:"",html:function html(){return{__html:"\n                              \n\t\t\t\t\t\t\t    <p>Un encuentro fant\xE1stico con la fauna.</p>\n\t\t\t\t\t\t\t    <h3>Nade con los delfines en la singular atracci\xF3n de Eilat.</h3>\n\t\t\t\t\t\t\t\t<p>El Arrecife de delfines de Eilat es un tesoro de vida silvestre en las costas del mar Rojo, donde aventuras llenas de acci\xF3n acompa\xF1an a la naturaleza y relajaci\xF3n. En el arrecife, los visitantes entran en un sitio m\xE1gico, interactuando con los delfines en su h\xE1bitat natural; una impresionante playa, donde la vida vegetal est\xE1 en plena floraci\xF3n y la vista es impresionante.</p>\n\t\t\t\t\t\t\t\t<p>El largo muelle es un lugar asombroso para observar a los delfines locales \"nariz de botella\u201D mientras realizan sus rutinas diarias: comer, jugar, cazar, aparearse y socializarse - a veces tambi\xE9n se relacionan con los visitantes humanos del sitio. Los que buscan una experiencia m\xE1s pr\xE1ctica, pueden intentar interactuar con los delfines a trav\xE9s de las variadas actividades abiertas al p\xFAblico.</p>\n\t\t\t\t\t\t\t\t<p>Una experiencia verdaderamente inolvidable, es observar a los delfines durante las comidas, programadas pero encantadoras. Hay algo emocionante en el juego en\xE9rgico e infantil de los delfines con sus adiestradores, esperando ansiosamente su comida. La alegr\xEDa absoluta que sienten una vez que alcanzan la comida provoca casi instintivamente una oleada de aplausos por parte de todos los espectadores. De hecho, los visitantes tienden a sentirse tan emocionados y satisfechos como si fueran ellos mismos los que han recibido comida.</p>\n\n\t\t\t\t\t\t\t\t<p>Sienta la belleza del arrecife y zamb\xFAllase con los delfines, obs\xE9rvelos en su ecosistema; nadando hasta seis metros de profundidad y experimente la vida magn\xEDfica y secreta. Otra opci\xF3n para los visitantes es nadar con los delfines. Flotar junto a ellos&nbsp;permite a humanos y delfines interactuar de forma divertida.</p>\n\t\t\t\t\t\t\t\t<p>En las \"piscinas de relajaci\xF3n\" del arrecife, los visitantes pueden dejar que sus preocupaciones desaparezcan mientras flotan al son de m\xFAsica relajante. Los restaurantes del lugar llenar\xE1n de mimos y atenciones a los visitantes, sin que tengan que salir del peque\xF1o santuario de belleza natural.</p>\n\t\t\t\t\t\t\t\t\t\t                      \n\t\t                        "};}},{id:"Action_Packed_Eilat",ctg:"eilat-negev",bgImage:"/HomeSlider/desktop/4.jpg",mobBgImage:"/HomeSlider/M/3.jpg",isVid:false,title:"ACTION PACKED EILAT",smltitle:"",html:function html(){return{__html:"\n                               <p>So, you\u2019ve heard about the fabulous beaches, the awesome nightlife and fantastic atmosphere of year round sunny Eilat, but aren\u2019t you wondering, amongst all the leisure, what to do with the excess energy? Well wonder no more. Here are just some of the amazing ways to have some action-packed fun in the sun:</p>\n\t\t                       \n                                   <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/action-packed-eilat/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t   <p>Eilat\u2019s stunning red sea offers loads of fantastic adventures. For one, its gorgeous underwater environment is known as a world-famous <b>scuba diving destination</b>. Not a pro? No problem. There are short courses that run for 1-2 days.</p>\n\t\t\t\t\t\t\t\t   <p>Atop the waves, you\u2019ll find, <b>windsurfing</b>, <b>kitesurfing</b>, and <b>stand-up paddle boarding</b> options for which it\u2019s always an ideal time in Eilat, with its pristine beaches, calm waters, and perfect sunny weather almost year-round. By the way, don\u2019t worry about equipment or experience, as there are plenty of options for rentals and individual or group lessons for all ages as well as all-inclusive packages. You\u2019ll be flying across the sea in no time!</p>\n\t\t\t\t\t\t\t\t   <p>Looking to flex a few more muscles? Eilat\u2019s nearby desert area offers <b>fantastic hikes</b> in stunning trails where you can <b>walk or bike</b> through breathtaking desert scenery.<span class=\"Apple-converted-space\">&nbsp; </span>Feeling adventurous? Check out the huge array of unique action attractions from unforgettable camel rides to <b>adrenaline charged ATV rides</b> to thrilling off cliff <b>paragliding,</b> guaranteed to get the heart racing.</p>\n\t\t\t\t\t\t\t\t   <p>If your holidays are all about breathtaking adventures, Eilat is definitely the place for you!</p>\n\t\t\t\t\t\t\t\t \n\n\n\t\t                        "};}},// {
// 		id:"Eilat_Ultimate_Beachside",
//        	ctg : "eilat-negev",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:true,
//        	vidId:"ZdnNT-GDJv4",
//         title : "EILAT ULTIMATE BEACHSIDE",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
// 						   <p><strong data-mk-aweb-org-font-size="17">Enjoy the water attractions that make Eilat the ultimate beachside getaway</h3>
// 						   <p>Surrounded by water, Eilat, Israel’s most southern city, is a wet and wild adventure hub unlike anywhere else in the country. Eilat boasts top beaches, water sports, activities and attractions, open to the public year-round due to the warm local climate.</p>
// 						   <p>Dip your toes in the clear, blue waters of Eilat’s beaches, spanning over twelve kilometers of sand, boardwalk, hotel and commercial attractions.</p>
// 						   <p>Relax at one of the more secluded and quiet southern beach locations and swim around the coral reefs, or enjoy a vibrant tourist scene at one of the northern beaches, where nearby hotels, restaurants and shops keep the public satisfied and entertained. Or, enjoy the region from aboard a yacht sailing through the waters, allowing you to soak up the sun, unwind and socialize.</p>
// 						   <p>Delve into the uniquely beautiful habitat of the Eilat Coral Beach Nature Reserve. Put on snorkeling gear and observe or interact with the local sea creatures as they swim about.</p>
// 						   <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/eilat-ultimate-beachside/1.jpg"} class="img-responsive">
// 							</div>
// 						   <p><strong data-mk-aweb-org-font-size="17">The heart of Israel’s extreme water adventures</h3>
// 						   <p>Eilat is the heart of Israel’s extreme water adventures. Feel the wind in your hair and sun on your cheeks as you embark upon a water ski, jetski, banana boat, surfing or glass bottom boat ride, speeding through the waters at an exhilarating pace. Prefer to remain above water? Opt instead to take in an aerial view of the waters and parasail over the Eilat Bay.</p>
// 						   <p>Do you love wildlife? Swim or snorkel with dolphins at Eilat’s Dolphin Reef. The unique ecological site, in the midst of a magical beach, allows visitors an up-close glimpse into the dolphins’ lives and makes for an exciting outdoor adventure. Fancy an underwater experience without getting wet? Take a tour of the Eilat Underwater Observatory, a captivating glimpse into life below sea level, combined with interactive activities and special exhibits.</p>
//                         `
//     }
//   }
// },
{id:"One_Day_In_Eilat",ctg:"eilat-negev",bgImage:"/HomeSlider/desktop/4.jpg",mobBgImage:"/HomeSlider/M/3.jpg",isVid:false,title:"ONE DAY IN EILAT",smltitle:"",html:function html(){return{__html:"\n                              \n\t\t\t\t\t\t\t\t   <h3>Suggestions for an awesome day in the sun</h3>\n\t\t\t\t\t\t\t\t   <p>Whether you\u2019re staying in one of the city\u2019s 5 star hotels, a hostel or have opted for the cool camping alternative, we recommend to start your day with a delicious breakfast and make your way to the <b>Dolphin Reef</b>. This is one of the most popular attractions in Eilat, where you can touch, swim and dive with these beautiful creatures. Watch the dolphins in their natural habitat, visit the underwater photo center, or take part in either scuba diving or snorkeling. Check out also <b>Coral Beach</b>, the natural underwater reserve that extends for 1,200 meters along the coast and gives you the opportunity to go snorkeling with an extraordinary variety of tropical fish in a beautiful coral reef.</p>\n\t\t\t\t\t\t\t\t   <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/one-day-in-eilat/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t   <p>Once you\u2019ve dried off, head to the stunning <b>Botanical Gardens</b> within Eilat. You\u2019ll find there more than 1,000 types of trees and plants from all around the world, streams, waterfalls, a rainforest and bird sanctuaries.</p>\n\t\t\t\t\t\t\t\t   <p>To end of your day with something slightly different, head just outside of Eilat to the <b>Red Canyon,</b> where you can track through the riverbed and between the red Nubian sandstone walls that have been sculpted over the centuries by wind and water.</p>\n\t\t\t\t\t\t\t\t   <p>When evening comes, make your way to the buzzing Eilat promenade ,stroll by the shops and market stands which are open until late. You can treat yourself to a meal in any of the dozens of the excellent restaurants and caf\xE9s or a drink in any of the lively seaside pubs and bars.</p>\n\t\t\t\t\t\t\t\t  \n\t\t                        "};}},{id:"Majestic_Desert",ctg:"eilat-negev",bgImage:"/posts/bank/negev1/1.jpg",mobBgImage:"/posts/bank/negev1/M.jpg",isVid:false,title:"EL NEGEV - EL MAJESTUOSO DESIERTO DE ISRAEL",smltitle:"",html:function html(){return{__html:"\n                                   <div class=\"responisve-iframe\">\n\t\t\t\t\t\t\t           <iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/yXzhH92kREg\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>\n\t\t\t\t\t\t           </div>\n\t\t\t\t\t\t\t\t   <h3>DONDE LA AVENTURA Y LA INSPIRACI\xD3N AGUARDAN</h3>\n\t\t\t\t\t\t\t\t   <p>UN DESTINO IDEAL PARA VIAJEROS QUE AMAN LA AVENTURA AL AIRE LIBRE, EL SUR DE ISRAEL EST\xC1 ESCASAMENTE POBLADO, PERO LLENO DE SITIOS FASCINANTES Y ACTIVIDADES.</p>\n\t\t\t\t\t\t\t\t\t<p >Con impresionantes maravillas naturales y belleza, el sur cuenta con magn\xEDficas vistas que seguro le quitar\xE1n el aliento, desde el amanecer hasta el atardecer.</p>\n\t\t\t\t\t\t\t\t\t<p >Un desierto pero definitivamente no des\xE9rtico, hay tanto que ver y hacer aqu\xED - hay muchas maravillas geol\xF3gicas, importantes hitos hist\xF3ricos y maravillosas reservas naturales donde puede practicar senderismo, ciclismo y paseos en camello o disfrutar de paseos por el desierto en 4x4 cargados de adrenalina.</p>\n\t\t\t\t\t\t\t\t\t<p >En pocas palabras, esta majestuosa regi\xF3n meridional es uno de los mayores activos del pa\xEDs y una visita obligada en el itinerario.</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<h3>Cr\xE1ter de Ram\xF3n</h3><br/>\n\t\t\t\t\t\t\t\t\t<div class=\"responisve-iframe\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t           <iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/QL3BGy2p77g\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t           </div>\n\t\t\t\t\t\t\t\t\t<p >En el coraz\xF3n del gran desierto del Negev de Israel se encuentra el cr\xE1ter de Ram\xF3n, el cr\xE1ter de erosi\xF3n m\xE1s grande del mundo, tambi\xE9n conocido como Maktesh Ramon. Este fascinante fen\xF3meno natural, que abarca una gran diversidad de rocas de colores y formas fant\xE1sticas, mide 40 km de longitud entre 2 y 10 km de ancho, con forma de coraz\xF3n largo, cuenta con el parque nacional m\xE1s grande de Israel, la Reserva Natural Ram\xF3n.<br>Lejos de las luces de la ciudad y las multitudes y con arena multicolor, roca volc\xE1nica y f\xF3siles, el cr\xE1ter de Ram\xF3n es a menudo descrito como el Gran Ca\xF1\xF3n de Israel.<br>Las impresionantes vistas desde el mirador del Maktesh Ramon con un desnivel de 300 metros, recuerdan a un tel\xF3n de fondo de Hollywood, ofrecen una poderosa experiencia para turistas de todo el mundo, durante todo el a\xF1o</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/majestic-desert/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<h3>La experiencia beduina</h3>\n\t\t\t\t\t\t\t\t\t<p >La hospitalidad beduina es una experiencia verdaderamente incomparable, agradable y&nbsp;atractiva.<br>Un grupo de tribus n\xF3madas ind\xEDgenas de la zona que se remontan a cientos de a\xF1os atr\xE1s, los beduinos de Israel, siguen viviendo de forma tradicional, abriendo sus corazones y sus hogares y su forma de vida al p\xFAblico para compartir sus costumbres y su hospitalidad conocida mundialmente.<br>Desde paseos en camello hasta comidas beduinas tradicionales e incluso noches en tiendas beduinas, todas estas atracciones son muy populares ente los turistas de la regi\xF3n que les brinda la oportunidad de descubrir y conectarse con un estilo de vida olvidado.</p>\n\t\t\t\t\t\t\t\t\t<h3>La Ciudad Vieja de Be'er Sheva</h3>\n\t\t\t\t\t\t\t\t\t<p >Se dice que fue fundada por Abraham, el Patriarca, Be'er Sheva es una de las ciudades m\xE1s antiguas del pa\xEDs. La ciudad vieja de Be'er Sheva, tan encantadora como hist\xF3rica, ofrece un fascinante mosaico de espacios urbanos y al explorar la ciudad antigua revela una rara riqueza de arquitectura \xFAnica, con&nbsp;historias tan antiguas como el tiempo.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/majestic-desert/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<h3>Arad</h3>\n\t\t\t\t\t\t\t\t\t<p >Arad del nuevo milenio es una ciudad con esp\xEDritu joven y rica experiencia. Arad y sus alrededores han sido bendecidos con hermosos paisajes, la tranquilidad del desierto, y muchos senderos para caminar en solitario, adecuados para cualquier edad o estilo.<br>Con un mont\xF3n de atracciones y un mont\xF3n de sitios de turismo en la ciudad y alrededor, Arad es el punto de partida perfecto y su puerta natural a las vacaciones perfectas en el desierto.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/majestic-desert/3.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<h3>Naturaleza</h3>\n\t\t\t\t\t\t\t\t\t<h3>Yotvata Hai-Bar</h3>\n\t\t\t\t\t\t\t\t\t<p >La reserva natural de Yotvata Hai-Bar es el centro m\xE1s grande de&nbsp; cr\xEDa y recuperaci\xF3n de animales antes de ser reintroducidos en la vida salvaje. La reserva cuenta con maravillosas atracciones que son un deleite absoluto para los amantes de los animales, incluyendo el centro de los depredadores con espec\xEDmenes vivos y peque\xF1os animales del desierto, un observatorio de animales nocturnos en condiciones oscuras y 12 kil\xF3metros cuadrados de terreno donde las manadas de herb\xEDvoros vagan libres.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/majestic-desert/4.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<h3>Aventuras extremas</h3>\n\t\t\t\t\t\t\t\t\t<p >El sur de Israel es un destino de ensue\xF1o total para viajeros aventureros. Su terreno \xFAnico y desafiante es un escenario ideal para diversos deportes extremos y actividades como descenso por ca\xF1ones empinados y ciclismo en todas sus variedades que son muy populares en esta zona, as\xED como son los tours de aventura en 4x4 que est\xE1 de moda tanto para lugare\xF1os como turistas.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t           \n\t\t\t\t\t\t\t\t\n                                   \n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\n\n\n\t\t                        "};}},// {
// 		id:"Negev1",
//        	ctg : "eilat-negev",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:true,
//        	vidId:"yXzhH92kREg",
//         title : "NEGEV",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
//                              <p>The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.</p>
// 					   <p>Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.</p>
// 					   <p>There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.</p>
// 					   <div class="img-wrapper">
// 										<img src=${getImgUrl()+ "/posts/negev/1.jpg"} class="img-responsive">
// 							</div>
// 					   <h3>The Israeli desert is special for the following reasons:</h3>
// 					   <ul>
// 					      <li><strong>The desert is very near:</strong>&nbsp;just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half). Starting from November, there will be direct flights from Europe and Russia to Ovda airport including&nbsp;Ryanair, Wizzair, and SAS.</li>
// 					      <li><strong>Easy to Hike and Bike:</strong>&nbsp;There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert.</li>
// 					      <li><strong>Cordial local population:</strong>&nbsp;The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.</li>
// 					      <li><strong>Tourists Activities:</strong>&nbsp;Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.</li>
// 					      <li>
// 					         <strong>Magnificent landscapes:</strong>&nbsp;Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety
// 					         <ul>
// 					            <li>There are spectacular sand dunes in the north.</li>
// 					            <li>The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.</li>
// 					            <li>In the east, one experiences the African desert with wide savannas and acacia trees.</li>
// 					            <li>To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.</li>
// 					         </ul>
// 					         <p>During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers. Many tourists decide for to stay for 2 or 3 days in each region of the Negev.</p>
// 					      </li>
// 					      <li><strong>The Negev is very safe to travel.</strong>&nbsp;In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.</li>
// 					   </ul>
// 					   <div class="img-wrapper">
// 										<img src=${getImgUrl()+ "/posts/negev/2.jpg"} class="img-responsive">
// 							</div>
//                         `
//     }
//   }
// },
{id:"Location_And_Approach",ctg:"eilat-negev",bgImage:"/posts/bank/negev3/1.jpg",mobBgImage:"/posts/bank/negev3/M.jpg",isVid:true,vidId:"5AAqIhkq_tQ",title:"NEGEV – CÓMO LLEGAR UBICACIÓN Y ENFOQUE",smltitle:"",html:function html(){return{__html:"\n                              \n\t\t\t\t\t\t\t\t    <p>Aterrizaje en los aeropuertos de Ovda o Eilat para seguir&nbsp; a Mitzpe Ramon o Sde Boker:</p>\n\t\t\t\t\t\t\t\t\t<h3>Medios de transporte p\xFAblicos:</h3>\n\t\t\t\t\t\t\t\t\t<p><strong>Autob\xFAs 392</strong> de Eilat a Mitzpe Ramon y Be'erSheva, para en el aeropuerto de Ovda los <strong>domingos</strong> a las 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.</p>\n\t\t\t\t\t\t\t\t\t<p>Llegada a la estaci\xF3n central de autobuses de Mitzpe Ramon una hora y media.</p>\n\t\t\t\t\t\t\t\t\t<h3>Lunes a jueves</strong> a las 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.</p>\n\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/location-and-approach/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t\t\t</div><br/><br/>\n\t\t\t\t\t\t\t\t\t<p><a href=\"//www.egged.co.il/HomePage.aspx\" target=\"_blank\">Servicio de autob\xFAs</a><br/>\n\t\t\t\t\t\t\t\t\t<a href=\"https://eilatshuttle.com/\" target=\"_blank\">Servicio de transporte desde el aeropuerto de Ovda</a></p>\n\t\t\t\t\t\t\t\t\t<h3>Alquiler de coches en Eilat, Mitzpe Ramon y Be'erSheva:</h3>\n\t\t\t\t\t\t\t\t\t<p>Hay varias opciones de alquiler de coches en estas ciudades. Hay una selecci\xF3n de compa\xF1\xEDas internacionales e israel\xEDes.</p>\n\t\t\t\t\t\t\t\t\t<p>Aterrizaje en el Aeropuerto Internacional Ben Gurion cerca de Tel Aviv y continuando viaje a Negev a Mashabei Sadeh / Sde Boker / Mitzpe Ramon</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/location-and-approach/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<h3>Medios p\xFAblicos de transporte:</h3>\n\t\t\t\t\t\t\t\t\t<div class=\"responisve-iframe\">\n\t\t\t\t\t\t\t           <iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/i_4QKtXIeto\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>\n\t\t\t\t\t\t           </div>\n\t\t\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t\t<li>Rutas de autob\xFAs 370/380 de Tel Aviv a Be'er Sheva.</li>\n\t\t\t\t\t\t\t\t\t<li>Rutas de autob\xFAs 446/470 desde Jerusal\xE9n a Be'er Sheva.</li>\n\t\t\t\t\t\t\t\t\t<li>Tren desde Ben Gurion o Tel Aviv a Be'er Sheva.</li>\n\t\t\t\t\t\t\t\t\t<li>Desde Be'er Sheva las rutas de autob\xFAs 60, 64, 65, 660. Salida todas las ma\xF1anas a las 6 a.m. (aproximadamente cada 20 minutos). Llegada a Mashabei Sadeh en 35 minutos / \xE1rea de Sde Boker en 55 minutos / Mitzpe Ramon en 1 hora y 20 minutos.</li>\n\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/location-and-approach/3.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p>Puede encontrar m\xE1s informaci\xF3n sobre los medios de transporte p\xFAblico en los siguientes enlaces: <a href=\"https://www.bus.co.il/otobusimmvc?Language=en\" target=\"_blank\">https://www.bus.co.il/otobusimmvc?Language=en</a>;\n\t\t\t\t\t\t\t\t\t<br/><a href=\"//www.egged.co.il/HomePage.aspx\" target=\"_blank\">http://www.egged.co.il/HomePage.aspx</span></a></span></p>\n\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t           <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/location-and-approach/3.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/location-and-approach/4.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/location-and-approach/5.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\n\n\t\t                        "};}},// {
// 		id:"Stay_In_The_Negev",
//        	ctg : "eilat-negev",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:false,
//         title : "STAY IN THE NEGEV",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `<p> A trip to the Negev offers so much more than just grand vistas and tranquil surroundings one tends to think about when conjuring up the word desert. While the Negev still offers all the natural beauty, calmness and wondrous sites, which the desert tourist is looking for, it is also extremely interesting, westernized and packed with activities and adventures and even offers all the comforts of a modern holiday.</p>
//                                <p> The Negev offers a huge variety of accommodation options. So much more than just a place to lay your hat down, the form of accommodation you choose will offer you opportunity to acquaint yourself with the undisputable gem of the Negev - its local community. From the Kibbutz residents to the lone farm dwellers and the local Bedouin folk, you will find the people of the Negev are warm, hospitable and always ready to lend a hand. Here are just a few examples of hospitality options, which can be found in the Negev:</p>
//                                <div class="img-wrapper">
// 										<img src=${getImgUrl()+ "/posts/stay-in-the-negev/1.jpg"} class="img-responsive">
// 						  </div>
// 						   <p>Hotels – the Negev has a huge host of hotel options ranging from budget hotels to 5-star international prize-winning luxury hotels, where you can chill in style during your desert break.</p>
// 						   <p>Hostels – an affordable accommodation geared mostly towards young travelers. Here many tourists enjoy the opportunity to meet and engage with other like-minded travelers from all over the world and spend their evenings socializing and often creating lasting friendships.</p>
// 						   <p>Zimmers -This is Israel’s version of the Bed and Breakfast, usually separate from the owners’ own home, these are often more secluded and cozy lodgings, suitable for travelers looking for romance and peaceful settings.</p>
// 						   <p>Bedouin Hospitality tents- the definite Negev must, this truly unique and authentic form of hospitality, which welcomes you into the indigenous Bedouin community’s way of life, affords an exceptional opportunity to take part in the Bedouin traditions in their natural environment – highly recommended.</p>
// 						   <p>Khans – again, unique to the Negev, the popular Kahns are in fact large outdoors complexes, which offer huts and communal sleep areas as well as all basic facilities. While Kahns are often a more basic and rustic form of accommodation, they are an excellent way to experience the chilled atmosphere of the area, connect with other travelers and locals and feel part of the natural surroundings of the desert.</p>
// 						   <p>Lone farms – a more recently developed form of accommodation, lone farms are in fact guest rooms in quaint and remote family-run farms throughout the Negev. &nbsp;Combining tranquil settings with home comforts, the lone farms offer privacy, incredible views and an authentic way to experience the awesome desert atmosphere of the Negev.</p>
// 						   <p>Kibbutz - a distinctly Israeli form of collective communal settlements, Kibbutz accommodations offer good value accommodation at affordable prices. The true appeal of the Kibbutz, however, is their uncountably their special atmosphere and communal spirit, and the residents warm, inviting and hospitable spirit, guaranteeing a pleasant and memorable stay.</p>
//                         `
//     }
//   }
// },
// {
// 		id:"Pure_Desert_Magic",
//        	ctg : "eilat-negev",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:false,
//         title : "NEGEV PURE DESERT MAGIC",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
// 				               <p>The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.</p>
// 							   <p>Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.</p>
// 							   <p>There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.</p>
// 							   <div class="img-wrapper">
// 										<img src=${getImgUrl()+ "/posts/pure-desert-magic/1.jpg"} class="img-responsive">
// 						       </div>
// 						       <p><strong data-mk-aweb-org-font-size="17">The Israeli desert is special for the following reasons</strong>:</p>
// 							   <ul>
// 							      <li><strong>The desert is very near</strong>&nbsp;- just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half).</li>
// 							   </ul>
// 							   <p>Starting from November, there will be direct flights from Europe and Russia to Ovda airport including&nbsp;<strong>Ryanair</strong>,&nbsp;<strong>Wizzair</strong>, and&nbsp;<strong>SAS</strong>.</p>
// 							   <p>For further details check the following link:&nbsp;<a href="//www.iaa.gov.il/en-US/airports/ovda/Pages/default.aspx" target="_blank" rel="noopener">www.iaa.gov.il</a></p>
// 							   <ul>
// 							      <li><strong>Easy to Hike and Bike</strong>: There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert. You can find a selection of trails on the following websites:&nbsp;<a href="//www.negevtour.co.il/" target="_blank" rel="noopener">www.negevtour.co.il</a>&nbsp;;&nbsp;<a href="//www.en.aravaway.co.il/" target="_blank" rel="noopener">www.en.aravaway.co.il</a></li>
// 							      <li><strong>Cordial local population</strong>: The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.</li>
// 							      <li><strong>Tourists Activities:</strong>&nbsp;Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.</li>
// 							      <li>
// 							         <strong><strong>Magnificent landscapes:&nbsp;Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety</strong></strong>
// 							         <ul>
// 							            <li>There are spectacular sand dunes in the north.</li>
// 							            <li>The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.</li>
// 							            <li>In the east, one experiences the African desert with wide savannas and acacia trees.</li>
// 							            <li>To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.</li>
// 							         </ul>
// 							      </li>
// 							   </ul>
// 							   <p>During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers.</p>
// 							   <p>Many tourists decide for to stay for 2 or 3 days in each region of the Negev.</p>
// 							   <ul>
// 							      <li><strong>The Negev is very safe to travel</strong>. In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.</li>
// 							   </ul>
// 							   <h3>More information and tips for accommodation and recommendations:</h3>
// 							   <p><a href="//www.negevtour.co.il/" target="_blank" rel="noopener">www.negevtour.co.il</a></p>
// 							   <p><a href="//www.en.aravaway.co.il/" target="_blank" rel="noopener">www.en.aravaway.co.il</a></p>
// 									                        `
//     }
//   }
// },
{id:"Action_Fun_In_The_Desert",ctg:"eilat-negev",bgImage:"/posts/bank/negev2/1.jpg",mobBgImage:"/posts/bank/negev2/M.jpg",isVid:true,vidId:"yXzhH92kREg",title:"EL NEGEV: AVENTURA EN EL DESIERTO",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t          <h3>El negev: aventura en el desierto no hay lugar como el negev para unas vacaciones relajantes bajo el sol del desierto</h3>\n\t\t\t\t\t\t\t\t   <p>El desierto del Negev de Israel es un lugar impresionante para visitar. Cubre m\xE1s de la mitad de la superficie total de Israel&nbsp; y es una regi\xF3n rica en arena, sol, parques naturales y atracciones tur\xEDsticas. La regi\xF3n sur del pa\xEDs es una visita obligada en su pr\xF3ximo viaje a Israel, especialmente si busca un lugar amplio y una experiencia del desierto israel\xED estrellada.</span></p>\n\t\t\t\t\t\t\t\t\t<h3>Rel\xE1jese rodeado de incre\xEDbles maravillas naturales</h3>\n\t\t\t\t\t\t\t\t\t<p>Dir\xEDjase hacia el sur, al desierto del Negev, donde la arena y el sol se mezclan y conectan con la regi\xF3n a trav\xE9s de emocionantes rutas de senderismo, impresionantes vistas, sitios hist\xF3ricos y atracciones tur\xEDsticas. Elija entre una amplia variedad de actividades para satisfacer sus intereses \xFAnicos,&nbsp; encontrarse con animales majestuosos y&nbsp; familiarizarse con las culturas antiguas. Dir\xEDjase al cr\xE1ter de Ram\xF3n, donde la vista es infinita. Desenrolle una estera de yoga o si\xE9ntese en la colorida arena y disfrute de un momento de profunda e intensa meditaci\xF3n. Cuando el sol se pone y el cielo se llena de estrellas, viaje a un centro de hospitalidad beduino, donde los hu\xE9spedes son tratados como reyes con deliciosos dulces, divertidos paseos en camello y la oportunidad de acampar en el desierto. O bien, viaje a lo largo de la Ruta del Incienso y visite las cuatro ciudades locales que florecieron gracias al comercio de especias y se convirtieron en sitios del patrimonio mundial.</span></p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/action-fun-in-the-desert/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t</div> \n\t\t\t\t\t\t\t\t\t<h3>Cuando se trata de vacaciones familiares, el cielo del desierto es el l\xEDmite</h3>\n\t\t\t\t\t\t\t\t\t<p>El desierto israel\xED tiene actividades divertidas y maravillosos alojamientos que se adaptan a las necesidades de todas las familias, muy cerca de muchos hoteles modernos y pintorescas casas de hu\xE9spedes. Lleno de sitios y actividades incre\xEDbles, el Negev es un gran lugar para la diversi\xF3n simple; ir de excursi\xF3n a parques nacionales, andar en bicicleta por los senderos para bicicletas de la regi\xF3n o conducir en todoterreno (o conducci\xF3n de ATV) arriba y abajo por las dunas. Las vastas extensiones y el paisaje monta\xF1oso lo convierten en una aventura emocionante, independientemente de la actividad que elija. Si est\xE1 buscando una forma m\xE1s relajada de pasar sus vacaciones, visite una bodega del Negev, contemple un manantial de aguas cristalinas en el coraz\xF3n del desierto israel\xED o visite una granja. O aproveche su visita al Negev para viajar un poco m\xE1s y flotar en el salado mar Muerto, limpiando su piel en el barro aterciopelado de la regi\xF3n.</span></p>\n\t\t\t\t\t\t\t\t\t<p>photo credit: &nbsp;Dafna Tal</p>\n\t\t\t\t\t\t\t\t   \n\t\t\t\t\t\t\t\t                           \n\t\t                        "};}},{id:"The_Incense_Route",ctg:"eilat-negev",bgImage:"/posts/bank/negev3/1.jpg",mobBgImage:"/posts/bank/negev3/M.jpg",isVid:true,vidId:"5AAqIhkq_tQ",title:"LA RUTA DEL INCIENSO",smltitle:"",html:function html(){return{__html:"  \n\t\t\t\t\t\t                <br/><h3>Una historia de \xE9xito comercial de 2.000 a\xF1os de antig\xFCedad</h3>\n\t\t\t\t\t\t                <p>La legendaria Ruta del Incienso es una historia de \xE9xito comercial con 2.000 a\xF1os de antig\xFCedad.<br/>\n\t\t\t\t\t\t\t\t\t\tEn esa \xE9poca, sin transporte, carreteras o mapas, largas caravanas de camellos atravesaban senderos dif\xEDciles encontr\xE1ndose con ladrones, saqueadores, obst\xE1culos y gobernantes de mente estrecha. Con bienes valiosos, la ruta comenzaba en Yemen hacia el este, cruzaba Arabia Saudita, Jordania e Israel terminando en el puerto de Gaza, donde fueron cargados en buques mercantes con destino a Europa. All\xED, las mujeres del Imperio Romano pod\xEDan disfrutar de los perfumes del incienso y la mirra, los sabores de las especias orientales y las sales \xFAtiles para cocinar y conservar alimentos.</p>\n\t\t\t\t\t\t\t\t\t\t<p>El viaje de la Ruta del Incienso de 2.400 kil\xF3metros duraba unos seis meses. Las caravanas de camellos, con miles de personas, avanzaban con paso lento, pasando por 56 paradas, donde se deten\xEDan a descansar, cuidar de los animales y reunir fuerzas para el d\xEDa siguiente.</p>\n\t\t\t\t\t\t\t\t\t\t <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/the-incense-route/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t        </div> \n\t\t\t\t\t\t\t\t\t\t<p>La secci\xF3n israel\xED de la Ruta del Incienso cubr\xEDa unos 150 kil\xF3metros. Al otro lado del desierto del Negev todav\xEDa hay ruinas de la ruta, y muchos viajeros se dispusieron a seguirlos&nbsp; explorando el desierto y tratar de experimentar el estilo de vida de los expertos del desierto. Varias de las paradas de descanso contin\xFAan comenzando en Moa de Arava en la frontera con Jordania, donde las ruinas de una posada, un puesto de guardia,&nbsp; agricultura,&nbsp; cuevas,&nbsp; dep\xF3sitos y un acueducto a\xFAn son evidentes. Desde aqu\xED, la ruta contin\xFAa hacia el noroeste hasta Mamshit, una gran ciudad cuyas impresionantes ruinas incluyen una posada, iglesias, una casa de ba\xF1os, piscinas de recolecci\xF3n de agua de lluvia y otras estructuras.</p>\n\t\t\t\t\t\t\t\t\t\t<p>La siguiente parada era la ciudad de Avdat, ubicada en lo alto de una colina. Aqu\xED tambi\xE9n est\xE1n las ruinas de una fortaleza, iglesias, una prensa de aceite, un taller de cer\xE1mica, casas, una casa de ba\xF1os e incluso cuevas funerarias.</p>\n\t\t\t\t\t\t\t\t\t\t<p>La caravana continuaba de Avdat a Shivta, una peque\xF1a ciudad con un sistema de agua bien desarrollado, piscinas, prensas de aceite y algunas iglesias. La pen\xFAltima y m\xE1s septentrional parada fue Halutsa, de la que quedan las ruinas de un teatro y una iglesia, y desde donde las caravanas se dirig\xEDan directamente a Gaza. Se agregaron algunas estaciones menores en el camino, Kasra, Nekarot, Makhmal y Grafon, as\xED como una posada adicional, Ein-Saharonim, de la cual todav\xEDa hay un patio rodeado de talleres y un ba\xF1o.</p>\n\t\t\t\t\t\t\t\t\t\t<p>A lo largo de la ruta, hay embalses, torres de vigilancia, sitios rituales, instalaciones de ba\xF1o e hitos que marcaron la ruta.</p>\n\t\t\t\t\t\t\t\t\t\t<p>Moa, Mamshit, Avdat, Shivta y Haluza, as\xED como Ein-Saharonim, son accesibles con cualquier veh\xEDculo. La ruta en s\xED, a trav\xE9s del desierto es transitable solo en jeeps, aunque ciclistas y&nbsp; peatones tambi\xE9n pueden disfrutar del fascinante sendero. En 2005, la UNESCO declar\xF3 la Ruta del Incienso Patrimonio de la Humanidad. Israel lo invita cordialmente al Negev y a Arav\xE1 a seguir los pasos de los n\xF3madas y disfrutar de las impresionantes historias y del espl\xE9ndido legado que dej\xF3 un testigo silencioso en una \xE9poca tormentosa.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t                \n\t\t\t\t\t\t\t\t     \n\t\t\t\t\t\t\t\t\t\t                        "};}},{id:"Mount_Karkom",ctg:"eilat-negev",bgImage:"/HomeSlider/desktop/4.jpg",mobBgImage:"/HomeSlider/M/3.jpg",isVid:false,title:"MOUNT KARKOM",smltitle:"",html:function html(){return{__html:"\n                                  <p>In the heart of the western Negev lies a site considered one of the most significant landmarks in Christian history- the mysterious and beautiful Mount Karkom.</p>\n\t\t\t\t\t\t\t\t   <p>Featuring a wildly unspoiled landscape - an 847-meter-high limestone plateau scored by dramatic ravines, mount Karkom is believed by some scholars to be the site of the biblical Mount Sinai \u2013 mentioned often in the book of Exodus as the place where Moses received the Ten Commandments.</p>\n\t\t\t\t\t\t\t\t   <p>Walking down the eight-kilometer-long loop-trail, on the banks of the Karkom dry riverbed are two rows of standing stones and a rounded wall, reminiscent of nomadic shrine of the type built by the Israelites of the time. Looking closely, one can even spot 12 standing stones, believed by some to represent the 12 tribes of Israel.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/mount-karkom/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t       </div>\t\n\t\t\t\t\t\t\t\t       <p>Adding to the mystery and appeal, Mount Karkom features many famous rock drawings, depicting worshipping figures, animals and enigmatic symbols.</p>\n                                    <p>To visit the area Hikers must coordinate tour to the site in advance and use a Society for the Protection of Nature (SPNI) trail map (available in Hebrew only) to explore Mount Karkom.</p>                      \n\n\t\t\t\t\t\t\t\t\t\t                        "};}},{id:"Ha_Arava",ctg:"eilat-negev",bgImage:"/posts/bank/negev3/1.jpg",mobBgImage:"/posts/bank/negev3/M.jpg",isVid:false,title:"ARAVÁ: ¡SORPRÉNDASE!",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t       <p>Entre la intersecci\xF3n de Menucha en el norte y la primera rotonda entrando a Eilat, abrazado por Har HaNegev, las Monta\xF1as Eilat al oeste y las monta\xF1as Edom al este est\xE1 ... Arav\xE1: un tramo estrecho pero impresionante donde <i>sentir\xE1</i> el desierto, con todo lo que ofrece, con su pareja, familia o grupo. Los visitantes tienen muchas maneras de ver Arav\xE1, ya sea a pie, en bicicleta, en autom\xF3vil o autob\xFAs. Los alojamientos van desde m\xE1ximo lujo a \"glamping\" para dormir bajo las estrellas. Aqu\xED tiene una lista recomendada de que ver y que hacer:</p>\n\t\t\t\t\t\t\t\t<h3>Parque Nacional&nbsp; Timna</h3>\n\t\t\t\t\t\t\t\t<p>Nuestro reci\xE9n inaugurado centro de visitantes en la entrada del parque le da la bienvenida con una introducci\xF3n informativa del sorprendente paisaje de Timna, que combina arenisca roja esculpida por la naturaleza yuxtapuesta con cantos rodados en blanco y negro que crean un espectacular tel\xF3n de fondo. Timna en forma de U, descubre tesoros de diferentes \xE9pocas y cuenta la historia de antiguas minas de cobre egipcias que todav\xEDa producen mineral, mediante aut\xE9nticas reliquias y otros hallazgos.</p>\n\t\t\t\t\t\t\t\t<p>Timna cuenta con m\xE1s de 25 rutas de senderismo, ciclismo (incluida una pista \xFAnica) y automovilismo, entre ellas, el <b>Hongo</b>, los <b>Arcos</b>, los <b>Pilares de Salom\xF3n</b>, el <b>Ca\xF1\xF3n Rosado</b>, el <b>Sacacorchos</b> y las <b>Caras</b>. Y hay m\xE1s: el Tabern\xE1culo, una r\xE9plica exacta del &nbsp;tabern\xE1culo b\xEDblico llevado por los israelitas mientras deambulaban por el Sina\xED; un lago con botes de pedales; preparaci\xF3n de botellas de arena de colores y otras artes y artesan\xEDas; alquiler de bicicletas; un camping regulado; y la Posada del Rey Salom\xF3n, donde puede disfrutar de un refrigerio en el desierto y comprar suvenires.</p>\n\t\t\t\t\t\t\t\t<h3>Hai-Bar santuario de fauna</h3>\n\t\t\t\t\t\t\t\t<p>El objetivo de Hai-Bar es reintroducir &nbsp;los animales mencionados en la Biblia en la naturaleza. Mientras tanto, los animales est\xE1n protegidos y cuidados en sus h\xE1bitats naturales, abiertos a los visitantes. Estos incluyen circuitos para veh\xEDculos motorizados donde se puede disfrutar de un safari que incluye \xD3xix, ant\xEDlopes de cuerno de tornillo, y ... \xA1avestruces! ... intercalados con la flora del desierto, incluida la acacia b\xEDblica. En nuestra tienda se venden&nbsp; CD en varios idiomas para guiarlo. Las visitas guiadas se realizan los s\xE1bados a las 11 a.m. \xA1la hora del \"brunch\" de los animales! Camping con servicios tambi\xE9n est\xE1 disponible.</p>\n                                <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/ha-arava/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t<h3>Granja de especias Eilat</h3>\n\t\t\t\t\t\t\t\t<p>La granja, que se dedica a la investigaci\xF3n de la maricultura, se encuentra en un antiguo cruce entre la Ruta de las Especias y la Via Maris, frente a las monta\xF1as de Edom. Se cultivan aqu\xED algas marinas, almejas, gambas artemias y los dottybacks de orqu\xEDdeas (tambi\xE9n conocidos como \"peces Friedman\", llamados as\xED por el due\xF1o de la granja que los descubri\xF3).</p>\n\t\t\t\t\t\t\t\t<p>El centro de visitantes de la granja es una celebraci\xF3n para los sentidos, donde al entrar, le envuelven las fragancias de docenas de especias, mezclas e infusiones tanto para cocinar como curativas; as\xED como una variedad de utensilios de cocina y utensilios especiales, cuyos usos estar\xE1 encantado de explicarle nuestro personal.</p>\n\t\t\t\t\t\t\t\t<h3>Consuma productos org\xE1nicos en Ne\xF3t Smad\xE1r</h3>\n\t\t\t\t\t\t\t\t<p>Realice un recorrido a pie auto-guiado por nuestra comunidad, que cuenta con un impresionante centro art\xEDstico que tard\xF3 13 a\xF1os en construirse, a trav\xE9s de nuestros terrenos, que reflejan nuestra atenci\xF3n al detalle combinado con nuestro car\xE1cter r\xFAstico, vi\xF1edo org\xE1nico y la bodega m\xE1s sure\xF1a de Israel.</p>\n\t\t\t\t\t\t\t\t<p>Nuestro centro de arte alberga talleres de artesan\xEDa y una galer\xEDa que exhibe y vende su trabajo. El centro de la estructura, conocida por su torre caracter\xEDstica, es un eje hidrante que enfr\xEDa todo el edificio en lugar del aire acondicionado convencional. Todo el centro, por dentro y por fuera, presenta carpinter\xEDa ornamental, elaborada por nuestros miembros de la comunidad.</p>\n                                 <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/ha-arava/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t<h3>Arav\xE1 despu\xE9s del anochecer</h3>\n\t\t\t\t\t\t\t\t<p>El paisaje cambia al atardecer, desde las monta\xF1as de Edom, cambiando a tonos cada vez m\xE1s oscuros rojizos y color p\xFArpura, en la noche plagada de estrellas y ba\xF1ada por la luz de la luna. Es hora de dormir ... lo ayudaremos a elegir el alojamiento m\xE1s adecuado y c\xF3modo. Ll\xE1menos al tel\xE9fono fijo +972 (8) 661.6976.</p>\n\n\t\t\t\t\t\t\t\t    \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t                               \n\t\t                        "};}},{id:"Machtesh_Ramon",ctg:"eilat-negev",bgImage:"/HomeSlider/desktop/4.jpg",mobBgImage:"/HomeSlider/M/3.jpg",isVid:false,title:"MACHTESH RAMON",smltitle:"",html:function html(){return{__html:"\n                                <p>At the heart of Israel\u2019s vast Negev Desert, lies the Ramon Crater, the world\u2019s largest erosion crater, also known as Machtesh Ramon. Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an elongated heart, and forms Israel\u2019s largest national park, the Ramon Nature Reserve.</p>\n\t\t                        <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/machtes-ramon/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p>Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock, and fossils, the Ramon Crater is often described as Israel\u2019s very own Grand Canyon.</p>\n\t\t\t\t\t\t\t\t<p>The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.</p>\n\t\t\t\t\t\t\t\t<p>A visit to Machtesh Ramon offers a range of exciting experiences and attractions specifically geared towards tourists and world travelers:</p>\n\t\t\t\t\t\t\t\t<h3>Ramon Crater Visitor Center</strong>&nbsp;\u2013&nbsp; Built on the crater\u2019s edge, the visitor center overlooks the awesome views from the Machtesh and offers an opportunity to learn about its unique natural phenomena, and also about the life and work of Ilan Ramon, the first Israeli astronaut.</p>\n\t\t\t\t\t\t\t\t<h3>Hai Ramon</strong>&nbsp;- Raising awareness to the local animal population, The Hai Ramon animal park offers a fascinating encounter with the often obscure and unseen small animals of the desert, The site features about 40 species of animals: lizards, snakes, turtles, spurs, hedgehogs, falcons, pheasants and more.</p>\n\t\t\t\t\t\t\t\t<h3>Kahn Saharonim</strong>&nbsp;\u2013 a short walk from this once station on the Nabatean Spice Route, is Ein Saharonim, a beautiful spring (dry in the summer) which features rich vegetation and the footprints of the many animals that come to enjoy its waters.</p>\n\t\t\t\t\t\t\t\t<h3>The Carpentry</strong>&nbsp;\u2013 a fascinating geological phenomenon, The Carpentry is a concentration of elongated stones in the form of prisms formed when the sandstone was \"baked\" at the high temperature created by a hot lava flow from the depths of the earth. During its cooling, the rock formed into thousands of ribbed columns, and the fragments of the columns act as the prisms.</p>\n\t\t\t\t\t\t\t\t<h3>The Ammonite Wall</strong>&nbsp;- a rock wall featuring fossils of ammonites - marine animals that lived millions of years ago in the sea which then covered the entire Negev area.</p>\n\t\t\t\t\t\t\t\t<p>A trip to Machtesh Ramon is a fascinating experience, one guaranteed to create a strong impression and a lasting memory.</p>\n\n\t\t                        "};}},{id:"Epic_Masada",ctg:"eilat-negev",bgImage:"/posts/bank/negev4/1.jpg",mobBgImage:"/posts/bank/negev4/M.jpg",isVid:true,vidId:"XxWa_MNm5x8",title:"EXPLORE MASADA",smltitle:"",html:function html(){return{__html:"   <h3>La cumbre del valor en el coraz\xF3n del desierto de Judea</h3><br/>\n\t\t\t\t\t\t            <h3>Reviva la historia \xE9pica en la cima de la gloriosa fortificaci\xF3n del desierto de Judea</h3>\n\t\t\t\t\t\t\t\t\t<p >Viaje al Parque Nacional Masada, la \xFAnica, aislada, antigua fortificaci\xF3n&nbsp; del desierto de Judea, con vistas al cercano mar Muerto. Camine por el serpenteante sendero o escalera romana desde la base de la fortificaci\xF3n, o entre en el Centro de Visitantes de Masada. Llegue a la cumbre a trav\xE9s del telef\xE9rico y comience a experimentar una parte de la historia antigua, como si todav\xEDa estuviera realiz\xE1ndose.</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<h3>Explore ruinas regias y si\xE9ntase parte de la historia</h3>\n\t\t\t\t\t\t\t\t\t<p>Entre a lo que fue una vez residencia de lujo que forma la fortaleza final habitada por los luchadores por la libertad, que valientemente libraron la guerra contra el imperio romano despu\xE9s de la destrucci\xF3n del segundo templo. Un sitio tan rico en narrativa hist\xF3rica, que las frescas paredes de piedra lloran pr\xE1cticamente por las almas valientes que eligieron la muerte prematura a la esclavitud bajo el r\xE9gimen enemigo.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/epic-masada/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t\t<h3>Donde experimentar cultura y religi\xF3n alcanza nuevas alturas</h3>\n\t\t\t\t\t\t\t\t\t<p>Pasee por las ruinas del palacio y descubra las habitaciones y estructuras, hallazgos arqueol\xF3gicos que destacan la vida en Masada durante el asedio romano. Entre por la zona norte, las ruinas del palacio de la fortaleza privada del rey Herodes. Susurre una oraci\xF3n en la antigua sinagoga, donde los jud\xEDos se re\xFAnen tres veces al d\xEDa para orar por la salvaci\xF3n. Rinda homenaje a los fallecidos combatientes por la libertad que echaron a suerte, en la \"Sala de la Loter\xEDa\" el orden de las muertes inminentes de los hombres, hasta que el \xFAltimo puso fin a su vida tambi\xE9n.</p>\n\t\t\t\t\t\t\t\t\t<p>&nbsp;Mire lo que queda de una iglesia de la \xE9poca bizantina y sus obras de arte en mosaico, posiblemente usadas durante siglos por monjes cristianos escapados desde el siglo I, durante un per\xEDodo de aproximadamente 600 a\xF1os.</p>\n\t\t\t\t\t\t\t\t\t<p >Experimente Masada como uno de los patrimonios de la humanidad de la UNESCO, con el espect\xE1culo de luces en la base de la fortificaci\xF3n, que se adentra en el modo de vida y las batallas experimentadas en el sitio hace siglos.</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t  \n\t\t\t\t\t\t\t    "};}},{id:"The_Bedouin_Experience",ctg:"eilat-negev",bgImage:"/HomeSlider/desktop/4.jpg",mobBgImage:"/HomeSlider/M/3.jpg",isVid:false,title:"THE BEDOUIN EXPERIENCE",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t           <p>The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging.</p>\n                                   <p>A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality.</p>\n                                   <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/the-bedouin-experience/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t   <p>From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a long-forgotten way of life.</p>\n\t\t                        "};}},{id:"The_Israel_National_Trail",ctg:"eilat-negev",bgImage:"/HomeSlider/desktop/4.jpg",mobBgImage:"/HomeSlider/M/3.jpg",isVid:false,title:"THE ISRAEL NATIONAL TRAIL",smltitle:"",html:function html(){return{__html:"\n                                 <p>The Israel National Trail (\u201CShvil Israel\u201D) is a national project, paving a marked and safe hiking route across the country. Over 900km long, the route is one of the most rewarding ways to experience the nature and community in Israel.</p>\n\t\t                          <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/the-israel-national-trail/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t   <p>The Israel Bike Trail (Part of The Israel National Trail Project) is a national initiative to create mountain biking trail that crosses the country from north to south, connecting Mt. Hermon at one end with Eilat at the other. Perfectly suited for bicycle tourism, the trail passes through national sites and amazing landscapes, allowing riders to experience Israel's diversity of culture and types of communities along the way.The trail is one of the longest demarcated trails in the world suited to, and with appropriate signage for, mountain biking.</p>\n\n\t\t                        "};}},{id:"Timna_Treasures",ctg:"eilat-negev",bgImage:"/posts/bank/negev4/1.jpg",mobBgImage:"/posts/bank/negev4/M.jpg",isVid:true,vidId:"i_4QKtXIeto",title:"PARQUE DE TIMNA",smltitle:"",html:function html(){return{__html:"  <h3>Una aventura, un desierto, una emoci\xF3n</h3>\n                                   <h3>Explore la belleza natural y atracciones emocionantes que el Parque Timna tiene para ofrecer</h3>\n\t\t\t\t\t\t\t\t\t<p>El parque Timna es una experiencia \xFAnica, ubicado a s\xF3lo 20 minutos de Eilat, en el coraz\xF3n del desierto israel\xED y situado entre impresionantes paisajes naturales. Con atractivos y actividades que combinan <s>la</s> naturaleza, <s>las</s> antig\xFCedades hist\xF3ricas y <s>la</s> aventura, los amplios terrenos impresionan a visitantes de todas las edades e intereses.</span></p>\n\t\t\t\t\t\t\t\t\t<h3>Sea testigo de fen\xF3menos naturales sobresalientes</h3>\n\t\t\t\t\t\t\t\t\t<p>Camine a trav\xE9s de los jardines del parque y contemple las <strong>formaciones rocosas \xFAnicas</strong> del sitio con nombres interesantes y formas raras que puede tocar: &nbsp;\"Seta\", &nbsp;&nbsp;\"Media Seta\u201D, \" Ca\xF1\xF3n Rosa \", \"Arcos\", \" Pilares de Salom\xF3n \" y \" Valle de los bocetos de la roca \" representan la vida de una \xE9poca anterior, lo que le permite sentir como si estuviera presenciando algo verdaderamente espectacular.</span></p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/timna-treasures/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t\t<h3>Caminata al aire libre</h3>\n\t\t\t\t\t\t\t\t\t<p>Elija uno de los 20 senderos bien marcados del parque, cada uno varia el nivel de dificultad, adapt\xE1ndose a sus necesidades individuales o de grupo y capacidades. Camine a trav\xE9s de los senderos espectaculares, geol\xF3gicos y arqueol\xF3gicamente significativos, o elija en su lugar descansar en el <strong>lago Timna</strong> a la sombra con zonas para hacer camping o si lo prefiere coma en el restaurante Khan King Solomon, donde puede adem\xE1s hacer talleres&nbsp; relacionados con el desierto como botellas de arena de colores , o darse una vuelta en barcos de pedales.</span></p>\n\t\t\t\t\t\t\t\t\t<p>Si lo que le gusta son los <strong>deportes extremos</strong> pruebe rappel, tirolina y excursiones en bicicleta, que seguro le dejar\xE1n lleno de energ\xEDa.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/timna-treasures/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t\t<h3>Experimente hoy tiempos antiguos</h3>\n\t\t\t\t\t\t\t\t\t<p>Conozca la historia b\xEDblica del desierto, durante una visita guiada al <strong>Tabern\xE1culo </strong>reconstruido, con una r\xE9plica del Altar, el Santo de los Santos y el Arca. Observe c\xF3mo los visitantes m\xE1s j\xF3venes miran con asombro la reproducci\xF3n de la estructura santa que Dios orden\xF3 a los jud\xEDos que construyeran en el desierto (delete the&nbsp; hyphen -) &nbsp;y los visitantes mayores examinen la reconstrucci\xF3n para verificar la exactitud hist\xF3rica, aprendiendo una cosa o dos a lo largo del camino.</span></p>\n\t\t\t\t\t\t\t\t\t<p>Parque Timna. Donde la historia se encuentra con la aventura, en lo profundo del desierto israel\xED.</span></p>\n\t\t\t\t\t\t\t\t\t                                    \n\t\t\t\t\t\t\t\t  \n\t\t\t\t\t\t\t\t  \n\t\t                        "};}},{id:"Negev_Desert_Dont_Miss",ctg:"eilat-negev",bgImage:"/posts/bank/negev1/1.jpg",mobBgImage:"/posts/bank/negev1/M.jpg",isVid:false,title:"DESIERTO DE NEGEV - NO SE LO PIERDA",smltitle:"",html:function html(){return{__html:"\n                                    <h3>Sandboard en el desierto</h3>\n\t\t\t\t\t\t\t\t\t<p>Una experiencia ic\xF3nica en el desierto Las incre\xEDbles dunas de arena del desierto del Negev le permiten deslizarse sentado o de pie a un ritmo vertiginoso. Esta es una habilidad fant\xE1stica y muy especial, que una vez que domine (es realmente muy f\xE1cil) puede nominarse como un aut\xE9ntico surfista de arena: \xBFgenial no?</p>\n                                    <h3>El Negev por la noche</h3>\n\t\t\t\t\t\t\t\t\t<p>El cielo del Negev por la noche es fascinante. Simplemente mire hacia arriba y de inmediato quedar\xE1 impresionado por el esplendor de millones de estrellas titilantes, iluminando la oscuridad azul-negra en un resplandor que solo se puede ver en el desierto.</p>\n                                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/negev-desert-dont-miss/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n                                    <h3>Paseos en camello</h3>\n\t\t\t\t\t\t\t\t\t<p>Retroceda en el tiempo para explorar el maravilloso entorno del desierto. Montar en camello es una actividad que puede encontrar en varios criaderos en el Negev.</p>\n\t\t\t\t\t\t\t\t\t<h3>Festival MidBurn</h3>\n\t\t\t\t\t\t\t\t\t<p>La propia versi\xF3n de Israel del famoso festival de \"Hombre Ardiente\"; donde durante 6 d\xEDas, se establece una ciudad temporal en el desierto de Negev, creando una plataforma que permite un estilo de vida comunitario, creatividad, arte y autoexpresi\xF3n radical.</p>\n\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<h3>Amanecer en Masada</h3>\n\t\t\t\t\t\t\t\t\t<p>Disponible solo para aquellos que son lo suficientemente valientes como para subir a pie: ver el amanecer en Masada es, sin duda, una de las experiencias m\xE1s inolvidables en Israel. El lento ascenso del sol a medida que emerge sobre las monta\xF1as jordanas de Moab y el Mar Muerto, arrojando su luz sobre los paisajes des\xE9rticos circundantes, es una vista verdaderamente espectacular, que no olvidar\xE1 pronto.</p>\n\t\t\t\t\t\t\t\t\t                                  \n                                  \n\t     \n\n\t\t                        "};}},// {
// 		id:"Negev_Charms",
//        	ctg : "eilat-negev",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:true,
//        	vidId:"3UddwPEzDXo",
//         title : "ESCAPE TO THE NEVEG",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
//                                 <p>A desert holiday is unlike any other - the tranquility, the awe inspiring grand vistas, the clear star-studded night skies, all come together to create a truly mesmerizing and exotic experience most of us do not to partake in during our day to day lives.</p>
//                                 <p>The Negev is so much more than just a Desert. While it still offers all the natural beauty, calmness and wonderous sites which the desert tourist is looking for, it is also extremely westernized and packed with activities and adventures while offering all the comforts of a holiday. This is exactly what makes a trip to the Negev the perfect destination for travelers from all over the world. Another gem of the Negev is undoubtedly its local community, from the Kibbutz residents to the lone farm dwellers and the local Bedouin folk, the people of the Negev are warm, hospitable and always ready to lend a hand. The Negev is rich in geological and archeological treasures and offers loads of exciting activities for the more adventurous travelers.</p>
//                           <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/negev-charms/1.jpg"} class="img-responsive">
// 						   </div>
// 						   <p>At the same time, visitors looking for relaxation are sure to find it in the tranquil surroundings, and for some urban excitement, the nearby cities provide a wide range of city fun from culinary treats to exciting nightlife.</p>
//                         `
//     }
//   }
// },
// {
// 		id:"Galilee",
//        	ctg : "north",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:true,
//        	vidId:"5Ep3GgxELag",
//         title : "GALILEE",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
// 				          <p>Most of northern Israel is generically known as The Galilee (Galil in Hebrew). It stretches virtually from the Mediterranean to the harp-shaped Sea Of Galilee and River Jordan on whose shores vast history has been made. Here is Mount Gilboa where King Saul and his son, Jonathan, died in battle against the Phillistines. Here is Hazor, where Deborah killed Sisera. Here, at Mount Meron, is the grave of Rabbi Hillel. Here in Tzippori, Hamat Tveriya and Bet Alpha, gorgeous 1,800-year-old synagogue mosaics have been discovered. Here is Armageddon (Megiddo) where Solomon built giant stables. Here is the lakeshore city of Tiberias, one of the “Four Holy Cities of Judaism” (another is Galilee’s Safed), which reached fame 2,000 years ago as one of the chief locations in which the Talmud was written.</p>
//                                 <h3 >Galilee</h3>
//                                 <div class="responisve-iframe">
// 					           <iframe width="560" height="315" src="https://www.youtube.com/embed/lzYzxyvnfng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 				           </div>
// 				           <p>The restoration of the Jewish homeland in the period beginning in the 1880’s was largely centered in the Galilee, and in the ensuing 130 years a much neglected landscape of not much more than olive trees has been transformed into one of the most fertile areas in the world. Here are dozens of kibbutzim and independently owned farms – whose produce feeds not only Israelis but is also flown daily to the grocery stores and flower markets of Europe. Here are some of Israel’s 300+ vineyards producing award winning wines. And here are pretty villages, towns and cities including Nazareth and Carmiel.</p>
//                                 <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/galilee/1.jpg"} class="img-responsive">
// 						   </div>
// 						   <p>In addition to hotels and very comfortable kibbutz guest houses, the Galilee is filled with dozens of country bed-and-breakfast accommodations, known as zimmerim. Many offer luxurious accommodations, including pools, and make a delightful base for relaxing and touring.</p>
//                         `
//     }
//   }
// },
// {
// 		id:"Caesarea",
//        	ctg : "north",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:true,
//        	vidId:"eLZ433_S6HI",
//         title : "CAESAREA",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `  <p>The Roman port city of Caesarea is one of Israel’s wonders, combining ancient structures, archeology and a picture-perfect harbor, and adapting them for modern use.</p>
//                                 <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/caesarea/1.jpg"} class="img-responsive">
// 						   </div>
// 						   <p>Built by Rome’s Judean Governor, Pontius Pilate, two millennia ago, Caesarea was one of the largest and most magnificent ports in the Mediterranean, with giant piers stretching out into the sea to accommodate dozens of ships. The city of Caesarea contained a giant hippodrome, aqueduct and theater; a thousand years later the Crusaders arrived and built a giant fortress, and then came the Ottomans, who turned it into a seaside town. Today, the Roman theatre is a venue for concerts, the Crusader fortress is thrilling to visit and the Ottoman harbor and beach are full of cafes, restaurants and a visitors’ center. Caesarea is 45 minutes’ drive from Tel Aviv, 20 from Haifa.</p>
//                         `
//     }
//   }
// },
{id:"Acre",ctg:"north",bgImage:"/posts/bank/north3/1.jpg",mobBgImage:"/posts/bank/north3/M.jpg",isVid:true,vidId:"KlXXyToCmCM",title:"CIUDAD VIEJA DE ACRE",smltitle:"",html:function html(){return{__html:" \n\t\t\t\t\t\t          <br/>\n\t\t\t\t\t\t          <h3>Viaje tras los pasos de los cruzados</h3>\n\t\t\t\t\t\t          \n\t\t\t\t\t\t\t\t  \n\t\t\t\t\t\t\t\t   <h3>Una antigua ciudad amurallada convertida en centro cultural del norte de Israel</h3>\n\t\t\t\t\t\t\t\t\t<p>La Ciudad Vieja de Acre es uno de los lugares m\xE1s excepcionales de Israel. Una verdadera ciudad costera rodeada de antiguos muros de piedra, la Ciudad Vieja de Acre es el hogar de innumerables tesoros hist\xF3ricos y culinarios y desprende un ambiente \xFAnico y sublime, a diferencia de cualquier otro lugar del pa\xEDs.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/acre/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t\t<h3>Encuentre un patrimonio hist\xF3rico cautivador</h3>\n\t\t\t\t\t\t\t\t\t<p>Prep\xE1rese para una ciudad con sitios y atracciones fascinantes que expone las vidas y pr\xE1cticas de los cruzados que una vez gobernaron la Ciudad Vieja de Acre. Contemple las grandes y antiguas murallas que rodean la Ciudad Vieja, protegiendo a los habitantes de Acre durante el asedio de Napole\xF3n. Visite el puerto del Acre, donde puede cerrar los ojos, respirar el aire fresco del mar e imaginar el sitio como un verdadero centro de actividad mar\xEDtima, donde se establecieron los lazos con Occidente y los peregrinos descubrieron una entrada principal a la Tierra de Israel.</p>\n\t\t\t\t\t\t\t\t\t<p>Recorra un espectacular y antiguo sitio subterr\xE1neo, conocido como <strong>T\xFAnel de los Templarios</strong>. En el pasado conect\xF3 una fortaleza estrat\xE9gica con el puerto de Acre, ayudando a los peregrinos a entrar en Israel, el pasadizo de piedra sirve hoy como met\xE1fora de cooperaci\xF3n y perseverancia y es impresionante caminar por \xE9l. Contin\xFAe hasta la Fortaleza Hospitalaria (Sala de los Caballeros), establecida por el rey Ricardo Coraz\xF3n de Le\xF3n durante la tercera cruzada. Las ruinas de lo que una vez fue el patio central del basti\xF3n, rodeado de arcos, es un verdadero testimonio de los lazos profundos forjados en la ciudad durante los tiempos dif\xEDciles.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/acre/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   </div>\t\n\t\t\t\t\t\t\t\t\t<h3>Un raro matrimonio de autenticidad y culturas</h3>\n\t\t\t\t\t\t\t\t\t<p>De los sitios antiguos y atracciones, el <strong>mercado</strong> de Acre ejemplifica persistentemente la aut\xE9ntica red de las culturas orientales y occidentales sobre las cuales la ciudad costera fue fundada y contin\xFAa prosperando. El mercado es donde los gustos y los olores llenan el aire - y los lugare\xF1os de las cuatro esquinas del mundo envuelven al p\xFAblico, alimentando sus corazones y sus vientres con gemas culturales y golosinas culinarias, tales como pasteles dulces orientales, especias preparadas localmente, productos frescos y peces que todav\xEDa coletean. Camine hacia el extremo sur del mercado y visite la sinagoga de Ramchal y el hogar del artista Chaim Parchi, dos sitios que a\xF1aden estilo, tradici\xF3n y vitalidad al ya bullicioso centro cultural.</p>\t\t\t\t\t   \n\t\t\t\t\t\t\t\t\t\t\t                        \n\t\t                        "};}},{id:"Haifa",ctg:"north",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",isVid:true,vidId:"3ahATaKkhBk",title:"HAIFA BELLEZA QUE INSPIRA",smltitle:"",html:function html(){return{__html:"  <br/>\n                                    <h3>Tranquilidad urbana y paisajes hipnotizadores</h3>\n\t\t\t\t\t\t\t\t\t<p>Con acantilados escarpados sobre la orilla del mar Mediterr\xE1neo y verdes colinas con vistas al puerto de Haifa, la tercera ciudad m\xE1s grande de Israel cuenta con algunas de las vistas m\xE1s pintorescas del pa\xEDs. Inmensamente hermosa, tranquila y un modelo para la convivencia entre las diferentes comunidades religiosas, Haifa es m\xE1s que un lugar - es una forma de vida. Camine bajo los pinos y disfrute de la diversidad cultural de la ciudad, animada escena intelectual, atm\xF3sfera pac\xEDfica y belleza innegable. Se sentir\xE1 obligado a inspirarse.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/haifa/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t\t<h3>Rod\xE9ese de serenidad y belleza</h3>\n\t\t\t\t\t\t\t\t\t<p>Una de las principales atracciones tur\xEDsticas de Haifa son los mundialmente famosos <strong>Jardines Baha'i</strong>. Declarado por la UNESCO en 2008 como Patrimonio de la Humanidad por su \"excepcional valor universal\", es un lugar de excepcional belleza con m\xE1s de un mill\xF3n de visitantes cada a\xF1o.</p>\n\t\t\t\t\t\t\t\t\t<p>Comience su visita en la cima del monte Carmelo en el encantador Louis Promenade. Contemple la impresionante vista que se extiende desde la ciudad de Haifa a toda la costa y las verdes monta\xF1as de Galilea en la distancia.</p>\n\t\t\t\t\t\t\t\t\t <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/haifa/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t\t<p>Explore los jardines por s\xED mismo o tome un tour gratuito. Camine por las terrazas en cascada, con los setos y parterres arreglados y nutridos con amor por los jardineros. Visite el santuario de la b\xF3veda de oro del Bab, que es el lugar de descanso del profeta Herald de Baha'i. Marav\xEDllese con los colores y las formas geom\xE9tricas de estos jardines colgantes \xFAnicos y disfrute de la serenidad que evoca.</p>\n\t\t\t\t\t\t\t\t\t<h3>Descubra el coraz\xF3n de la escena cultural de Haifa</h3>\n\t\t\t\t\t\t\t\t\t<p>Los jardines Baha'i terminan en el barrio de la colonia alemana. Originalmente construido como una comunidad templar\xEDa alemana en la d\xE9cada de 1860. En estos d\xEDas es el coraz\xF3n de la escena cultural de Haifa y centro tur\xEDstico con restaurantes, bares, galer\xEDas y hoteles boutique. Pasee por las calles de piedra, visite las galer\xEDas y disfrute de la hermosa arquitectura. Coma, beba en los caf\xE9s locales y restaurantes, explore la vida nocturna y sum\xE9rjase en la multitud. Al final de la noche, no se olvide de levantar la cabeza y admirar la magn\xEDfica iluminaci\xF3n de los jardines Baha'i. Reconfortar\xE1 su coraz\xF3n.</p>\n\n\t\t\t\t\t\t\t\t    \n\t\t\t\t\t\t\t\t  \n\t\t                        "};}},{id:"Safed",ctg:"north",bgImage:"/posts/bank/north2/1.jpg",mobBgImage:"/posts/bank/north2/M.jpg",isVid:true,vidId:"i3_ihL51bHo",title:"SAFED DONDE LO MÍSTICO SE ENCUENTRA CON LO MUNDANO",smltitle:"",html:function html(){return{__html:"  \n\t\t\t\t\t\t\t\t\t<h3>Sum\xE9rjase en el arte y la espiritualidad para una nueva interpretaci\xF3n de la vida</h3>\n\t\t\t\t\t\t\t\t\t<p>Con infinitas vistas que se extienden a horizontes lejanos y un aire de monta\xF1a pr\xEDstino, Safed le cautivar\xE1 instant\xE1neamente al momento de su llegada. Conocida como la capital del misticismo jud\xEDo en el pasado y el presente, esta impresionante ciudad antigua en lo alto de una colina es la m\xE1s alta de Galilea y de todo Israel, tanto desde el punto de vista geol\xF3gico como espiritual. Una de las cuatro ciudades sagradas del juda\xEDsmo, Safed ofrece un viaje palpablemente m\xEDstico que le dejar\xE1 impresionado por su profunda energ\xEDa.</p>\n\t\t\t\t\t\t\t\t\t<p>A un corto trayecto en coche del venerado mar de Galilea, Safed le da la bienvenida con pintorescos callejones de adoquines y arquitectura numinosa. Escuche c\xF3mo las almas de la historia comparten sus secretos a trav\xE9s de una antigua fortaleza erigida por los cruzados, las influencias mamelucas, otomanas y brit\xE1nicas, el Monumento a la Guerra de la Independencia, as\xED como una profunda historia sagrada encarnada por extraordinarias sinagogas y antiguas tumbas.</p>\n\t\t\t\t\t\t\t\t\t<h3>La Capital Eterna de la Cabal\xE1</h3>\n\t\t\t\t\t\t\t\t\t<p>Desde el rabino Shimon Bar-Yohai, el autor del segundo siglo de la obra fundacional de la C\xE1bala conocida como Zohar, hasta Ari HaKadosh, el padre de la C\xE1bala contempor\xE1nea, Safed ha sido el hogar de los m\xE1s altos m\xEDsticos del juda\xEDsmo y sus devotos estudiantes. Fue en el siglo XVI cuando Ari HaKadosh \"democratiz\xF3\" las ense\xF1anzas cabal\xEDsticas trayendo una nueva comprensi\xF3n,&nbsp; que permiti\xF3 a la Cabal\xE1 llegar a los laicos.</p>\n\t\t\t\t\t\t\t\t\t<p>Mientras camina de una sinagoga a la siguiente, sentir\xE1 c\xF3mo Safed se convirti\xF3 en el hogar inmutable de un linaje tan largo de aspirantes espirituales, independientemente de todo lo que la historia derrib\xF3. La sinagoga Abuhav cuyos elementos arquitect\xF3nicos encarnan el misticismo num\xE9rico, la sinagoga Ari Ashkenazi dedicada a Ari HaKadosh y la sinagoga Yosef Caro le transportar\xE1n a trav\xE9s del tiempo y hacia los mundos superiores del misticismo.</p>\n\t\t\t\t\t\t            <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/Safed/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t\t<h3>Una ciudad vieja inspiradora</h3>\n\t\t\t\t\t\t\t\t\t<p>A\xF1ada m\xE1s momentos inolvidables a su viaje recorriendo los sinuosos callejones de adoquines en la Ciudad Vieja, viendo edificios de piedra \xFAnicos y continuando hasta la Colonia de Artistas. Hogar de galer\xEDas que le presentar\xE1n las exquisitas obras de artistas locales, incluida una gran variedad de Judaica, esta parte de la Ciudad Vieja es para los amantes de todo lo relacionado con el arte. El Museo de Mu\xF1ecas y el Museo de Arte Impreso son visitas obligadas especiales para los amantes de la cultura.</p>\n\t\t\t\t\t\t\t\t\t<p>Safed puede ser tan nutritivo para su cuerpo como para su alma: las ecl\xE9cticas ofertas de comida de la Ciudad Vieja prometen satisfacer todos los gustos y presupuestos. Desde panqueques yemen\xEDes y comida callejera hasta delicias inesperadas en restaurantes, encontrar\xE1 todo lo que est\xE1 buscando y m\xE1s en esta encantadora ciudad de profundas tradiciones.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t   \t\t\t\t\t\t\t   \n\t\t                        "};}},{id:"The_Bahai_Gardens",ctg:"north",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",isVid:true,vidId:"3ahATaKkhBk",title:"La puerta de entrada al Norte de Israel",smltitle:"",html:function html(){return{__html:" \n\t\t\t\t\t\t            <br/>\n\t\t\t\t\t\t            <p>La animada \"Capital del Norte\", Haifa es la tercera ciudad m\xE1s grande de Israel y de lejos una de sus m\xE1s emocionantes<span dir=\"RTL\">.</span></p>\n\t\t\t\t\t\t\t\t\t<p>Si bien una visita en primavera o verano es una excelente oportunidad para ir a nadar o descansar en una de sus hermosas playas, Haifa est\xE1 repleta de cosas para hacer y ver todo el a\xF1o<span dir=\"RTL\">.</span></p>\n\t\t\t\t\t\t\t\t\t<p>La fant\xE1stica ubicaci\xF3n de Haifa en las laderas del impresionante monte Carmel (una atracci\xF3n por s\xED misma) se ha ganado el apodo de \"San Francisco de Israel\", y siendo fiel a esta reputaci\xF3n, est\xE1 inundada de impresionantes playas, fascinantes lugares de inter\xE9s, animada vida nocturna y una atrevida escena musical<span dir=\"RTL\">.</span></p>\n\t\t\t\t\t\t\t\t\t<h3>Jardines Bah\xE1'\xED - Belleza, grandeza y dise\xF1o inspirado</h3>\n\t\t\t\t\t\t\t\t\t<p>En julio de 2008, los Jardines Bah\xE1'\xED fueron declarados Patrimonio de la Humanidad por la UNESCO en reconocimiento a su \"valor universal sobresaliente\" como lugar santo de peregrinaci\xF3n para los seguidores de la fe Bah\xE1'\xED<span dir=\"RTL\">.</span></p>\n\t\t\t\t\t\t\t\t\t<p>El santuario y los jardines Bah\xE1'\xEDs son una creaci\xF3n de belleza, grandeza y exquisito dise\xF1o en un ambiente especial y tranquilo como ning\xFAn otro. Los Jardines Bah\xE1'\xED son tambi\xE9n una de las atracciones m\xE1s populares del pa\xEDs, atrayendo a m\xE1s de un mill\xF3n de visitantes al a\xF1o<span dir=\"RTL\">.</span></p>\n\t\t\t\t\t\t\t\t\t <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/bahai-gardens/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t\t<h3>Monte Carmel - La monta\xF1a siempre verde cerca de la orilla mediterr\xE1nea de Israel</h3>\n\t\t\t\t\t\t\t\t\t<p>Uno de los atractivos m\xE1s llamativos es el monte Carmel, un s\xEDmbolo de la belleza y la floraci\xF3n, y un panorama ideal para caminatas y picnics familiares. No hay necesidad de esforzarse demasiado para admirar las vistas espectaculares desde la cima del monte Carmel, ya que puede viajar por la ciudad en metro, el Carmelit<span dir=\"RTL\">.</span></p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/bahai-gardens/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t\t<h3>Arte y Cultura</h3>\n\t\t\t\t\t\t\t\t\t<p>Haifa es una ciudad creativa y vibrante y, como tal, se pueden encontrar en cada esquina lugares de arte fant\xE1sticos y atracciones culturales. Entre los muchos lugares excelentes que ofrece se encuentra el notable Museo de Ciencia y Tecnolog\xEDa de Madatech, el Museo Nacional de Ciencias de Israel, el Museo de Arte de Haifa y el Zool\xF3gico Educativo de Haifa, ubicado en el monte Carmel<span dir=\"RTL\">.</span></p>\n\t\t\t\t\t\t\t\t\t<p>Haifa tambi\xE9n cuenta con eventos culturales ricos y variados, como el Festival de las Fiestas de todas las Fiestas, que celebra los festivales jud\xEDo, cristiano y musulm\xE1n, que tienen lugar en diciembre. Tampoco se pierda el Festival Internacional de Cine de Haifa, un evento de una semana que se celebra cada mes de septiembre, transformando la ciudad entera en una gran atracci\xF3n exhibe m\xE1s de un centenar de pel\xEDculas de todos los g\xE9neros posibles<span dir=\"RTL\">.</span></p>\n\n\t\t\t\t\t\t         \n\t\t\t\t\t\t\t\t   \n\t\t\t\t\t\t\t\t    \n\t\t                        "};}},{id:"The_Sea_Of_Galilee",ctg:"north",bgImage:"/posts/bank/north2/1.jpg",mobBgImage:"/posts/bank/north2/M.jpg",isVid:true,vidId:"haG-t3wwuMc",title:"EL MAR DE GALILEE (Kinneret)",smltitle:"",html:function html(){return{__html:"\n                                  \n\t\t\t\t\t\t\t\t   \n\t\t                        "};}},{id:"Rosh_Pina",ctg:"north",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",isVid:true,vidId:"_qKbHL5-qrQ",title:"ROSH PINA",smltitle:"",html:function html(){return{__html:"  \n\t\t\t\t\t\t           <h3>El secreto tur\xEDstico de la Galilea pastoral <br/>Viaje en el tiempo en el pintoresco pueblo de Galilea </h3>\n\t\t\t\t\t\t\t\t\t<p>Conocida como la Princesa de Galilea, Rosh Pina es el hogar de la combinaci\xF3n perfecta de lugares con inter\xE9s natural, cultural, hist\xF3rico&nbsp;y de entretenimiento. Una hermosa aldea norte\xF1a restaurada, serena, donde los olivos y casas pintorescas est\xE1n rodeados de exuberantes campos. Rosh Pina es el lugar ideal para unas vacaciones tranquilas y relajantes, donde los visitantes pueden recrear la vida de la aldea, hace m\xE1s de un siglo.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/rosh-pina/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t\t<h3>Donde el silencio m\xE1gico se rompe s\xF3lo por el canto de los p\xE1jaros</h3>\n\t\t\t\t\t\t\t\t\t<p>\xBFBusca un lugar tranquilo lleno de naturaleza, que recuerda a la Toscana de Italia o la Alcarria de Espa\xF1a? Dir\xEDjase hacia el norte a Rosh Pina, donde sus impresionantes paisajes rurales permanecen intactos y se sentir\xE1 transportado a una \xE9poca anterior. Elija entre las muchas casas de hu\xE9spedes disponibles, equipadas para proporcionar la m\xE1xima hospitalidad, intercaladas en las callejuelas rom\xE1nticas del pueblo, ausente del bullicio de la gran ciudad y disfrute en esta hospitalaria y pintoresca comunidad.</p>\n\t\t\t\t\t\t\t\t\t<p>Aproveche la belleza natural de la localidad y pasee por los espl\xE9ndidos senderos verdes que rodean el r\xEDo Rosh Pina o los <strong>Jardines del Bar\xF3n de Rothschild</strong>, parecidos a los grandes jardines de Versalles. Respire el aire fresco y disfrute de la belleza natural mientras recarga las bater\xEDas.</p>\n\t\t\t\t\t\t\t\t\t<h3>Una colonia de vacaciones con un encanto \xFAnico y art\xEDstico</h3>\n\t\t\t\t\t\t\t\t\t<p>Pasee por las calles adoquinadas del pueblo, que recuerdan a viejas ciudades europeas, y encontrar\xE1 una encantadora atm\xF3sfera cultural y art\xEDstica rodeada de las magn\xEDficas monta\xF1as de la Galilea. Un lugar de tiendas de moda, restaurantes gourmet, galer\xEDas de arte, museos, festivales, sitios hist\xF3ricos y un centro comercial. La ciudad est\xE1 llena de antig\xFCedad, cultura, naturaleza y delicias culinarias, relatando la historia de la primera \" Moshava de la Galilea \" (Ciudad) y el asentamiento de comunidades jud\xEDas en Israel.</p>\n\t\t\t\t\t\t\t\t\t                                 \n\t\t\t\t\t\t\t\t   \t\t\t\t\t\t   \n\t\t                        "};}},{id:"Nazareth",ctg:"north",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",isVid:true,vidId:"1M7N5BcmjFM",title:"NAZARET LA CUNA DEL CRISTIANISMO",smltitle:"",html:function html(){return{__html:" \n\n\t\t\t\t\t\t         <h3>Una antigua ciudad rica en historia, fascinante arqueolog\xEDa, cultura moderna y talism\xE1n de Oriente Medio</h3>\n\t\t\t\t\t\t\t\t<p>Nazaret o Natsrat, como su nombre se pronuncia en hebreo, es la cuna del cristianismo, la ciudad donde, seg\xFAn la tradici\xF3n, el \xE1ngel Gabriel le dijo a Mar\xEDa que concebir\xEDa por el poder del Esp\xEDritu Santo y el lugar donde Jes\xFAs pas\xF3 su ni\xF1ez y juventud. Nazaret, en la baja Galilea, se encuentra en el coraz\xF3n de un valle rodeado de monta\xF1as que abarcan varios de los sitios cristianos m\xE1s importantes del mundo. Esta es una ciudad de religi\xF3n y fe, de espiritualidad y santidad, pero tambi\xE9n una ciudad con una rica historia, fascinante arqueolog\xEDa, cultura moderna y encanto de Oriente Medio.</p>\n\t\t\t\t\t\t\t\t<h3>La cuna del cristianismo</h3>\n\t\t\t\t\t\t\t\t<p>Nazaret, que comenz\xF3 como un peque\xF1o pueblo jud\xEDo hace unos 2.000 a\xF1os, se convirti\xF3 en un basti\xF3n del cristianismo en el per\xEDodo bizantino, unos pocos cientos de a\xF1os despu\xE9s. Durante ese per\xEDodo el nombre de Nazaret se extendi\xF3 por todas partes, y los anhelos de ver el lugar donde la Virgen Mar\xEDa y Jesucristo hab\xEDan vivido convirtieron a la ciudad en un lugar popular&nbsp; de peregrinaci\xF3n. Estas visitas condujeron a la construcci\xF3n de la primera iglesia de la ciudad - la Iglesia de la Anunciaci\xF3n en el sitio tradicional de la casa de Jos\xE9 y Mar\xEDa. Muchas m\xE1s iglesias se han construido a lo largo de la ciudad, y fueron destruidas y reconstruidas con los cambios en el gobierno musulm\xE1n y cristiano a trav\xE9s de los siglos. En el siglo XIX, Nazaret atrajo un renovado inter\xE9s y los cristianos volvieron a vivir en esta ciudad y reconstruyeron iglesias y monasterios. Hoy Nazaret es la ciudad \xE1rabe m\xE1s grande en Israel y tiene cerca de 30 iglesias y monasterios, as\xED como mezquitas y sinagogas antiguas.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/nazareth/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t<h3>Un sabor de la Ciudad Vieja </h3><p>Un recorrido por Nazaret es como revivir sus diferentes per\xEDodos. Cada era dej\xF3 detr\xE1s de ella un s\xEDmbolo de gran alcance que la convirti\xF3 en un sitio tur\xEDstico encantador y popular en la era moderna. La mayor\xEDa de los sitios se concentran en la Ciudad Vieja, construida a mediados del siglo XIX en un encantador estilo arquitect\xF3nico de Oriente Medio. Un paseo por las callejuelas, entre las casas pintorescas, es una experiencia incre\xEDble y vale la pena caminar lentamente para disfrutar de su belleza.</p>\n\t\t\t\t\t\t\t\t<p>Hay muchas iglesias antiguas en la Ciudad Vieja, con la Iglesia de la Anunciaci\xF3n encabezando la lista. La iglesia reconstruida conserv\xF3 partes de las iglesias anteriores, de los per\xEDodos cruzado y bizantino. La iglesia tambi\xE9n alberga una impresionante colecci\xF3n de pinturas.</p>\n\t\t\t\t\t\t\t\t<p>Justo al lado de esta iglesia est\xE1 la iglesia de San Jos\xE9, construida sobre las ruinas de edificios agr\xEDcolas donde, seg\xFAn la tradici\xF3n, Jos\xE9, el esposo de Mar\xEDa, ten\xEDa su taller de carpinter\xEDa. Mientras que la Iglesia de la Anunciaci\xF3n fue construida en el sitio de la casa de Mar\xEDa, la Iglesia Ortodoxa Griega de la Anunciaci\xF3n se construye sobre el Pozo de Mar\xEDa, de la cual se dice que la madre de Jes\xFAs bebi\xF3. Esta es una estructura del per\xEDodo de los cruzados y tiene algunos frescos interesantes. Seg\xFAn la tradici\xF3n, esta es la ubicaci\xF3n de la sinagoga en la que Jes\xFAs or\xF3.</p>\n\t\t\t\t\t\t\t\t<p>Entre las muchas otras iglesias de Nazaret est\xE1 la iglesia Mensa Christi, la iglesia Maronita, la iglesia de San Gabriel y la iglesia Salesiana. La Ciudad Vieja tambi\xE9n tiene importantes edificios de la \xE9poca otomana, incluyendo la Saraya, o Casa de Gobierno, construida por Daher el Omar, el gobernador de Galilea en el siglo XVIII, y la mezquita Blanca, que se utiliza hoy como una casa de oraci\xF3n y un centro de educaci\xF3n y cultura. La mezquita Blanca tambi\xE9n alberga un museo con exposiciones que documentan la historia de Nazaret.</p>\n\t\t\t\t\t\t\t\t<p>Ninguna visita a la Ciudad Vieja de Nazaret estar\xEDa completa sin una visita al mercado local, que se ha convertido en una atracci\xF3n popular y conocida gracias a los coloridos puestos y la variedad de mercanc\xEDas. En el mercado puede disfrutar de una fiesta visual de tejidos de moda, el sabor de las especias y los alimentos locales. Todos los sonidos, paisajes, olores y sabores prometen una aut\xE9ntica experiencia de Oriente Medio.</p>\n\t\t\t\t\t\t\t\t<h3>Un vistazo al talism\xE1n de Oriente Medio</h3>\n\t\t\t\t\t\t\t\t<p>Nazaret est\xE1 lleno de encantadores rincones que abrir\xE1n su coraz\xF3n a su belleza. Otro lugar que vale la pena visitar durante un recorrido a pie es el paseo de Nabi Sain para disfrutar de la maravillosa vista de la Galilea. Puede visitar la antigua casa de ba\xF1o turco descubierta durante las renovaciones de una de las tiendas de la ciudad, explore una casa solariega de lujo con una muestra de las riquezas y costumbres de la clase alta otomana del siglo &nbsp;XIX, que incluye algunos frescos incre\xEDbles. Tambi\xE9n vale la pena visitar la casa del obispo ortodoxo griego, donde puede caminar por una serie de pasajes subterr\xE1neos descubiertos en el patio. Otro sitio interesante es el complejo construido por los rusos como un albergue para los peregrinos.</p>\n\t\t\t\t\t\t\t\t<p>Nazaret, que ha acogido a los peregrinos durante siglos, cuenta con albergues cristianos y hoteles de lujo para la comodidad de los turistas que acuden a este importante sitio, especialmente por Navidad. Decenas de restaurantes sirven comidas deliciosas con aromas maravillosos que atraen a los visitantes todo el a\xF1o. Nazaret es ideal durante la Navidad, cuando la ciudad est\xE1 decorada para la fiesta y sus colores y emoci\xF3n se unen a la atm\xF3sfera santa y los sonidos de la oraci\xF3n que emanan de las iglesias de la ciudad.</p>\n\n\t\t\t\t\t\t\t\t \t\t\t\t\t\t   \n\t\t                        "};}},{id:"Cheers_To_Israel",ctg:"culinarynorth",bgImage:"/posts/bank/north3/1.jpg",mobBgImage:"/posts/bank/north3/M.jpg",isVid:true,vidId:"Cxii1yKqKwI",title:"GREAT WITH WHITE OR RED",smltitle:"",html:function html(){return{__html:"  <p>Over the past decade, Israeli wine-making has become a vital and thriving industry.</p>\n                                   <p>The fertile land of the area has been recognized worldwide as an excellent setting for burgeoning vineyards, and the local scene is trendy and opulent.</p>\n                                   <p>In the north, the general atmosphere reminiscent of French or Italian wine regions while the south&nbsp;has become renowned for its burgeoning&nbsp;wine scene, thanks to pioneering farmers and their use of computerized drip irrigation.</p>\n                                  <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/cheers-to-israel/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t    <p><span style=\"font-family: arial,sans-serif;\">The Israeli wine scene allows visitors a fantastic experience combining delectable wine tastings with the stunning vistas and energy this has to offer.</span></p>\n\t\t\t\t\t\t\t\t   <p>So come get a taste of Israel\u2019s wine country through its many fantastic tours of the vineyards and boutique wineries, the fantastic wine and music festivals and year-round wine-themed events.</p>\n\t\t\t\t\t\t\t\t   <p>FYI, a visit to Israel goes great with white or red.</p>\n\t\t\t\t\t\t\t\t   \n\t\t                        "};}},{id:"A_Galilean_Treat",ctg:"culinarynorth",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",isVid:true,vidId:"kF808ENuuTQ",title:"UNAS VACACIONES CULINARIAS EN LA GALILEA",smltitle:"",html:function html(){return{__html:"  \n\t\t\t\t\t\t                  <br/><h3>Un para\xEDso para los amantes de la buena mesa</strong>  </p>\n\n                                  \n\t\t\t\t\t\t\t\t   <p>Una visita a Galilea ofrece sabores y gustos diferentes a cualquiera que haya experimentado antes. Desde quesos regionales hechos a mano en las industrias l\xE1cteas artesanales hasta vinos de clase mundial, vi\xF1edos boutique, restaurantes gourmet familiares, frutas reci\xE9n recolectadas y vegetales llenos de sabor, Galilea es un para\xEDso para los entusiastas de la comida.</p>\n\t\t\t\t\t\t\t\t\t<h3>Una regi\xF3n que fluye con leche y vino</h3>\n\t\t\t\t\t\t\t\t\t<p>Visite una lecher\xEDa artesanal para descubrir la riqueza de los quesos de Galilea y participe en&nbsp; la elaboraci\xF3n del queso. Deje que un experto quesero lo gu\xEDe mientras degusta algunos de los muchos quesos tiernos, curados y semicurados \xFAnicos de la zona, como el <em>lebane</em>, un cremoso queso tierno con forma de yogur hecho de leche de oveja o cabra que a menudo se sirve mezclado con especias locales como el <em>za'atar</em>; o <em>zefatit</em>, un queso de oveja salado que se moldea en una cesta y lleva el nombre de la zona de <em>Zefat</em>, o Safed, donde se hizo por primera vez.</p>\n\t\t\t\t\t\t\t\t\t<p>Si desea un poco de vino para acompa\xF1ar su queso, est\xE1 de enhorabuena. Cada vino es mejor que el anterior. Una reciente revoluci\xF3n en la elaboraci\xF3n de vino hizo que las bodegas boutique surgieran en el variado terreno de Galilea; cada vi\xF1edo cultiva uvas con un sabor espec\xEDfico del suelo en el que crecen. Contemple las colinas cubiertas de parras mientras saborea vinos tintos profundos y afrutados y vinos blancos frescos bajo la gu\xEDa de los mejores en\xF3logos de Israel. Explore las mezclas de uva que produjeron vinos que obtuvieron los m\xE1ximos honores en las ferias de vino del mundo, muchas de las cuales no est\xE1n disponibles para la venta fuera de Israel.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/galilean-treat/1.jpg")+" class=\"img-responsive\">\n\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<h3>Pruebe la cosecha</h3>\n\t\t\t\t\t\t\t\t\t<p>Visite los huertos de recolecci\xF3n propia para deleitarse con bayas, manzanas, cerezas, melocotones, ciruelas e incluso \"sabra\", una fruta que es regordeta, jugosa y rebosante de sabor. Visite las granjas de especias para oler y probar una gama de hierbas y especias en constante cambio, tanto las que le son familiares como las que nunca ha visto antes. Descubra los sabores nativos de Galilea y cree sus propios t\xE9s de hierbas y mezclas de especias.</p>\n\t\t\t\t\t\t\t\t\t<p>Otra de las cosechas importantes de Galilea, el aceite de oliva, tambi\xE9n le espera. Si pensaba que todo el aceite de oliva tiene el mismo sabor, una visita a una granja de aceite de oliva familiar en Galilea cambiar\xE1 su opini\xF3n. Pruebe aceites de oliva para saber qu\xE9 hace que cada sabor sea diferente y participe en una recolecci\xF3n de aceitunas y pr\xE9nselas a la antigua usanza para hacer su propio aceite de oliva virgen extra.</p>\n\t\t\t\t\t\t\t\t\t<h3>Mercados y Restaurantes</h3>\n\t\t\t\t\t\t\t\t\t<p>Las ciudades antiguas de Galilea cuentan con una gran cantidad de mercados donde se pueden comprar los mejores productos locales y productos artesanales, a menudo vendidos por los expertos que los elaboran. Deambule por los mercados, deguste y pruebe en los mercados para descubrir delicias en cada esquina, o contrate un experto gu\xEDa gastron\xF3mico que le guiar\xE1 a los mejores puestos y los mejores manjares.</p>\n\t\t\t\t\t\t\t\t\t<p>Mientras pasea por la Galilea siguiendo sus papilas gustativas, encontrar\xE1 restaurantes gourmet escondidos en los rincones m\xE1s ins\xF3litos. Algunas de las mejores cocinas del pa\xEDs se sirven en los modestos restaurantes de Galilea, ubicados junto a magn\xEDficas vistas. Muchos son gestionados por familias, sirven platos elaborados con amor a partir de ingredientes con los que crecieron o se criaron a solo unas pocas millas. Pero para realmente sondear las profundidades de los productos de Galilea, tome parte en un taller de cocina. Est\xE1n dirigidos por chefs locales que conocen la tierra por dentro y por fuera, y est\xE1n ansiosos por compartir la mejor manera de elegir, preparar y disfrutar los productos locales m\xE1s sabrosos. As\xED podr\xE1 elegir sus ingredientes antes de prepararlos, haciendo platos que saben mejor que cualquier plato que haya cocinado antes.</p>\n\t\t\t\t\t\t\t\t\t<h3>La experiencia \xFAnica de Galilea</h3>\n\t\t\t\t\t\t\t\t\t<p>Galilea es mucho m\xE1s que una serie de deliciosos sabores. Visite fortalezas en ruinas y sitios b\xEDblicos donde Jes\xFAs predic\xF3 y se libraron batallas. Suba a las monta\xF1as, disfrute del rafting en aguas r\xE1pidas y camine junto a arroyos burbujeantes como parte de sus vacaciones de ensue\xF1o en Galilea.</p>\n\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t \t\t   \n\t\t                        "};}},{id:"Galilee_Action",ctg:"north",bgImage:"/posts/bank/north2/1.jpg",mobBgImage:"/posts/bank/north2/M.jpg",isVid:true,vidId:"5Ep3GgxELag",title:"ACCIÓN EN LA GALILEA AVENTURAS EN LA GALILEA",smltitle:"",html:function html(){return{__html:"  \n\n\t\t\t\t\t\t\t\t\t<p>La gran cantidad de r\xEDos, lagos y la costa de la Galilea son una inmensa&nbsp; fuente de diversi\xF3n para todas las edades. Los que buscan emociones fuertes salpicar\xE1n sus rostros mientras compiten con sus amigos en kayak en las aguas bravas. Familias o parejas pueden relajarse nadando en las verdes y frescas orillas de uno de los muchos r\xEDos de la Galilea. Puede refrescarse con emocionantes actividades acu\xE1ticas como esqu\xED acu\xE1tico o kite surf en el mar de Galilea. A lo largo de la costa, a los turistas les encanta pasar el rato en las c\xE1lidas playas de arena de la Galilea o visitar la belleza resplandeciente de las grutas de Rosh Hanikra.</p>\n\t\t\t\t\t\t\t\t\t<p>Los deportes extremos se pueden practicar tanto en tierra como en aire y en agua. Los turistas activos pueden disfrutar de actividades llenas de adrenalina, como salto de esqui, caminar en las duras pistas de monta\xF1a o descender en rappel por acantilados desafiantes. En invierno, disfrute de los deportes en la nieve de la cordillera de Hermon como esqu\xED y snowboard en pistas f\xE1ciles o desafiantes.</p>\n\t\t\t\t\t\t\t\t\t<p>La impresionante abundancia natural de la Galilea</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/galilee-action/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p>La Galilea est\xE1 llena de \xE1reas de belleza natural donde familias, parejas y grupos de amigos pueden caminar, vislumbrar la vida silvestre o simplemente disfrutar de un picnic en la naturaleza. Recorriendo tranquilos senderos a caballo o siguiendo los senderos bien se\xF1alizados a pie o en bicicleta, encontrara belleza, diversi\xF3n y emoci\xF3n donde quiera que vaya. Observe la naturaleza de una manera m\xE1s relajada observando aves y fauna en la Reserva Natural del Valle de Hula, o experimente la magia de todo el mosaico de bosques, campos y r\xEDo que se despliegan por debajo mientras se eleva en un globo en el Gilboa. No deje pasar la oportunidad de sumergirse en la espiritualidad de sitios sagrados para cristianos, jud\xEDos y bah\xE1'\xEDs.</p>\n\t\t\t\t\t\t\t\t\t<p>Las numerosas rutas de senderismo de la Galilea son un im\xE1n para excursionistas de todas las edades, durante todo el a\xF1o. Ya sea si prefiere un paseo sombreado junto a suaves arroyos, la emoci\xF3n de escalar monta\xF1as y rapel, o disfrutar el logro de alcanzar la incre\xEDble vista en la cima de una desafiante colina, encontrar\xE1 el camino perfecto esper\xE1ndolo. En la Galilea, todas las opciones est\xE1n abiertas.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t   \n\t\t\t\t\t\t\t\t   \n\t\t                        "};}},{id:"Bet_Shean",ctg:"north",bgImage:"/posts/bank/north3/1.jpg",mobBgImage:"/posts/bank/north3/M.jpg",isVid:false,title:"BET SHE’AN",smltitle:"",html:function html(){return{__html:"  <p>South of the Sea of Galilee are the remains of one of the largest cities in the Roman-Byzantine Empire, Bet She\u2019an. One of ten ancient cities (hence \u201CDecapolis\u201D) that included Philadelphia (present day Amman in Jordan) and Jerash, Scythopolis ((Bet She\u2019an) was the only decapolis city west of the Jordan river.  It was very grand, with a giant theater, streets of tall columns, shops, bathhouses a hippodrome and hundreds of homes.</p>\n                                  <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/bet-shean/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t   <p>However, the splendid city was toppled in 749 by a massive earthquake, and never rebuilt. Over the centuries the ruins were overgrown \u2013 and it was not until the mid-20th century that Israeli archeologists pulled Bet She\u2019an out of the murk, discovering (and restoring) the theater, the Cardo, the columns and much more.</p>\n\t\t\t\t\t\t\t\t   \n\t\t                        "};}},{id:"Zichron_Yaakov",ctg:"north",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",isVid:false,title:"ZICHRON YA’AKOV",smltitle:"",html:function html(){return{__html:" <p>Zichron Ya\u2019akov is a wonderful town for tourists, both local and foreign. This picturesque moshava semi-cooperative farming community built at the tip of the Carmel mountain range is the first moshava ever built in Israel and is a main tourism and vacation site in this region.</p>\n                                  <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/zichron-yaakov/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t    <p>Anyone who visits&nbsp;<strong>Zichron&nbsp;Ya\u2019akov&nbsp;</strong>goes straight to Ha-Nadiv Street, and Ha-Meyasdim Street in the town center, which has become a very popular pedestrian mall, thanks to the special atmosphere in this place. The streets are paved with stones and pass between the moshava\u2019s original houses (some of which have been reconstructed), which are bustling with activity.</p>\n\t\t\t\t\t\t\t\t   <p>There are many quaint and charming restaurants and coffee shops, interspersed between beautifully designed stores that sell local art works and lovely souvenirs. There are art galleries, unique artists' studios and workshops. New, modern buildings stand alongside old ones, such as the synagogue and the administration building, an old courtyard with a display of antique agricultural implements.</p>\n\t\t\t\t\t\t\t\t   <p>From its early days,&nbsp;<strong>Zichron Ya\u2019akov</strong>&nbsp;had two main characteristics: wine and tranquility. The moshava\u2019s founding farmers cultivated vineyards and the large winery built here in 1889 became the area\u2019s most important industry. During the British Mandate period (1917-1948), the moshava became a holiday resort and rural vacations site, and to this day has hotels, spas and guesthouses.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   \n\t\t                        "};}},// {
// 		id:"Discover_The_Wine_Routes",
//        	ctg : "north",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:true,
//        	vidId:"Cxii1yKqKwI",
//         title : "DISCOVER THE WINE ROUTES",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `  <p>Discover a different Israel through it's wineries and vineyards, through the passion of the people who are crafting award winning wines from home grown grapes.</p>
//                                  <p>Enjoy vintage wines, gourmet foods, and gorgeous scenery. Spend time experiencing Israel as you never have before, as a Wine Connoisseur! The beauty of these routes in Israel is of course the authentic wine but also the incredible landscapes that surround the wineries. Many of the wineries are situated near ‘Zimmers’ which are little spa complexes that are dotted around northern Israel. They have little cabins with Jacuzzis that face out to the magnificent views of the rolling green hills. You can relax in your personal cabin with a splendid glass of wine from the local winery.</p>
//                                 <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/discover-the-wine-routes/1.jpg"} class="img-responsive">
// 						   </div>
// 						   <div class="wpb_wrapper"><p>The Middle East &amp; Eastern Mediterranean was the cradle of wine production, and the ancient land of Canaan is in fact one of the earliest countries to cultivate wine over 2,000 years before the vine came to Europe.</p><p>There are currently over 25 commercial wineries and over 150 boutique wineries in Israel where wine making has become a personal obsession with wine makers striving to produce world class wines.</p><p>Israel like other 'long' countries such as Chile or Italy enjoys a variety of microclimates. While the northern region gets much rain and even snow in the winter, just a few hours away Israel's southern region is very arid with desert conditions. This range in microclimates supports many grape varieties, which can grow on several different types of soil, yielding excellent results.</p><p>As always in matters of taste, you must visit Israel’s wineries and vineyards and decide for yourself which is your favourite!</p><p></p></div>
//                         `
//     }
//   }
// },
{id:"Birdtastic_Hula_Lake",ctg:"north",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",isVid:true,vidId:"ImobrsxsKl8",title:"LAGO HULA",smltitle:"",html:function html(){return{__html:" \n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<h3>La naturaleza en su mejor momento</h3>\n\n\t\t\t\t\t\t<h3>Descubra uno de los mejores sitios de observaci\xF3n de aves del mundo</h3>\n\t\t\t\t\t\t<p>En el coraz\xF3n del pintoresco valle de Hula, en la Galilea Superior, a s\xF3lo dos horas en coche al norte de Tel Aviv, entre dos majestuosas cordilleras, se encuentra un lugar de extraordinaria belleza - el lago Hula. Uno de los sitios de observaci\xF3n de aves m\xE1s importantes del mundo, esta reserva ecol\xF3gica de pantanos internacionalmente reconocida, es un oasis para aves y amantes de la naturaleza de todas partes. Ofrece una oportunidad \xFAnica para sentir la naturaleza sin barreras. &nbsp;Una experiencia inolvidable.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/birdtastic-hula-lake/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t<p>Durante cada temporada de migraci\xF3n (primavera y oto\xF1o), m\xE1s de 500 millones de aves y cerca de 400 especies viajan a trav\xE9s del lago Hula. Este para\xEDso de pantanos es la parada perfecta para peque\xF1os, cormoranes, garzas, pel\xEDcanos, rapaces y grullas, por mencionar algunas. &nbsp;</p>\n\t\t\t\t\t\t<p>Declarado por la Revista BBC Wildlife como uno de los diez mejores sitios de observaci\xF3n de aves del mundo, el lago Hula o como se llama en hebreo Agamon Hula, atrae naturalmente a los observadores de aves de todo el mundo. \xDAnase al festival internacional de aves Hula cada a\xF1o en el oto\xF1o y disfrute de una verdadera experiencia que no se puede perder<span dir=\"RTL\">.</span></p>\n\t\t\t\t\t\t<p>Hay varias maneras de presenciar este deslumbrante fen\xF3meno. Todo lo que necesita es simplemente elegir su aventura<span dir=\"RTL\">.</span></p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/birdtastic-hula-lake/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t<p><strong>Explore los senderos</strong>. Recorra los senderos m\xE1gicos del parque. Puede caminar, ir en bicicleta o conducir en quad runners. Pasar\xE1 a trav\xE9s de los \xE1rboles frutales y obtendr\xE1 una visi\xF3n de la vida silvestre del humedal<span dir=\"RTL\">.</span></p>\n\t\t\t\t\t\t<p><strong>Maneje un tractor</strong>. \xDAnase a una visita guiada en un tractor \"Safari Vag\xF3n\" que le lleva a las profundidades de las instalaciones de Agamon. El vag\xF3n \"le esconde\" de los p\xE1jaros y por lo tanto permite un encuentro \xEDntimo y personal con estas hermosas criaturas<span dir=\"RTL\">.</span></p>\n\t\t\t\t\t\t<p><strong>Excursiones nocturnas y a la salida del sol</strong>. Para los m\xE1s aventureros, hay 2 experiencias especiales de tour. Uno de ellos es el 'Tour del amanecer' que ofrece inmejorables oportunidades de observaci\xF3n de aves y fotograf\xEDa. Alternativamente, el ' Tour del b\xFAho' que ofrece un aspecto completamente diferente de la reserva. Con la hoguera y bajo la mirada de las estrellas, podr\xE1 observar la vida de los gatos salvajes, aves rapaces nocturnas y murci\xE9lagos<span dir=\"RTL\">.</span></p>\n\t\t\t\t\t\t<p>Levante el esp\xEDritu y sea testigo del trabajo de preservaci\xF3n de la naturaleza </p>\n\t\t\t\t\t\t<p><em>Agamon</em> Hula ha ganado fama mundial por ser un modelo de <s>un</s> sistema ecol\xF3gico sostenible equilibrando naturaleza, turismo y agricultura<span dir=\"RTL\">.</span></p>\n\t\t\t\t\t\t<p>Visite el centro de anillamiento en el parque y observe el trabajo realizado para preservar la naturaleza. Haga la excursi\xF3n \"Isla de aves\" y tal vez <s>incluso</s> tendr\xE1 la oportunidad de liberar un p\xE1jaro a la naturaleza. No hay nada mejor que esto<span dir=\"RTL\">.</span></p>\n\t\t\t\t\t\t<p>Con tantos tipos diferentes de animales y el trabajo incansable para preservar la naturaleza de forma creativa, el lago Hula ofrece m\xE1s que un viaje divertido con hermosos paisajes. Es una inusual experiencia que abre el coraz\xF3n y la mente<span dir=\"RTL\">.</span></p>\n\t\t\t\t\t\t\t\t\t\t\t\t\n\n\t\t\t\t\t\t\t\t   \n\t\t\t\t\t\t\t\t                    \n\t\t                        "};}},{id:"The_Kibbutz_Experience",ctg:"north",bgImage:"/posts/bank/north2/1.jpg",mobBgImage:"/posts/bank/north2/M.jpg",isVid:false,title:"THE INCOMPARABLE KIBBUTZ EXPERIENCE",smltitle:"",html:function html(){return{__html:"  \n\t\t\t\t\t\t           <p>Predominantly based amongst beautiful landscape settings dotted around the country the Kibbutz life is a modern day phenomenon and a totally unique way of living. The movement which started in 1905 is a collective community way of living traditionally based on agriculture. Each kibbutz would sell its own produce.  The people living on them would all collectively work together to preserve it and work the land.</p>\n                                  <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/kibbutz-experience/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t    <p>The word \u2018Kibbutz\u2019 in Hebrew means group.&nbsp;The point being it is a voluntary democratic community where people live and work together to generate economically. It is founded on the principles of communal ownership of property and social equality.</p>\n                                   <p>Some would describe the beautiful settings and a life of equality a utopia and why not experience it for yourself?&nbsp; Many of the Kibbutzim are open to visitors whether you would like to stay a few hours or a few months learning what this life is all about.</p>\n\t\t\t\t\t\t\t\t   \n\t\t                        "};}},{id:"National_Parks",ctg:"north",bgImage:"/posts/bank/north3/1.jpg",mobBgImage:"/posts/bank/north3/M.jpg",isVid:false,title:"NATIONAL PARKS",smltitle:"",html:function html(){return{__html:" \n\n\t\t\t\t\t\t          <p>Despite Israel being small its scenery varies immensely! You will find new cities and old, beaches and lakes, deserts and green mountains. Israel\u2019s National parks and nature reserves make all this possible for you to experience the wondrous landscapes.</p>\n                                  <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/national-parks/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t   <p>In the south of the country you will find the expanse of the golden and orange plains of the desert. The Negev, Arava and Eilat are the fiery beautiful landscapes of the south that home the Dead Sea, Mitzpe Ramon and the beautiful desert oasis of En gedi not mention some wonderful hiking and cycling trails. When the sun sets the south turns in to a red illuminous sea of magic and when dark the sky turns in to a blanket of sparkles as the vast scenery makes it possible to see every star.</p>\n                                   <p>In the North of the country you are welcomed with Luscious green hills and mountains including the snow-capped Mount Hermon.&nbsp; The Golan Heights home to magnificent mountainous scenery and an array of cultures.&nbsp; There are endless forest trails and water fall hikes for all the family to enjoy. The view from the mountain tops is breath taking as your eyes take you all the way out to the Mediterranean. Below the mountains you will find the green slopes of the Galilee home to the famous Kinneret, wineries and some wonderful relaxation spa\u2019s. It really is a wonderland.</p>\n\t\t\t\t\t\t\t\t   <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/national-parks/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t   <p>The national parks offer exciting cultural and natural adventures. You have the opportunity to visit magnificent historical sites and follow wonderful nature trails while searching for some of the countries species i.e. The desert ibex and leopards, Eagles in the Golan. The impressive diversity of natural wonders, encounters with unspoiled nature and with plants.</p>\n\t\t                        "};}},{id:"Tiberias",ctg:"north",bgImage:"/posts/bank/north2/1.jpg",mobBgImage:"/posts/bank/north2/M.jpg",isVid:false,title:"TIBERIAS (TVERYA)",smltitle:"",html:function html(){return{__html:"  \n\t\t\t\t\t\t           <p>Located at the shores of the Sea of Galilee, Tiberias, the capital of the Galilee, was established in the early Roman period and has served as a religious, administrative and culture center of the Jewish people for many years.</p>\n                                  <p>In addition to its rich history and significance, modern day Tiberias is synonymous with holiday in Israel. Here one can enjoy a variety of activities the city has to offer, and experience a wonderful mix of relaxation, nature and history, along with contemporary attractions, active water sports, pilgrimage sites and unique tourist attractions</p>\n                                  <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/tiberias/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t   <p>A visit to Tiberias is not complete without a visit to its surrounding area, which features many must-see sights, including The city Bet Shean, one of the oldest cities in the world, and one of the country\u2019s largest archaeological sites; Magdala (Migdal) the ancient town on the Sea of Galilee which was home to many of Jesus\u2019s disciples and is said to have been the home of Mary Magdalene; Megiddo, a beautiful and impressive national park and one of the most important archeological sites in Israel from the time of the Bible. Once an ancient city of critical strategic importance, Megiddo is a UNESCO World Heritage Site, and an inspiring location for lovers of history and archeology.</p>\n\t\t\t\t\t\t\t\t   \n\t\t                        "};}},{id:"Discover_Galilei",ctg:"north",bgImage:"/posts/bank/north3/1.jpg",mobBgImage:"/posts/bank/north3/M.jpg",isVid:false,title:"DESCUBRA LOS TESOROS OCULTOS DE LA GALILEA",smltitle:"",html:function html(){return{__html:"  <p>Descubra la exuberante campi\xF1a del norte de Israel, donde las pintorescas ciudades coronan las colinas de la Alta y Baja Galilea y las bodegas y restaurantes boutique est\xE1n escondidos junto a sitios hist\xF3ricos antiguos. Hosp\xE9dese en un hotel de lujo o disfrute de unas aut\xE9nticas vacaciones de campo en uno de los famosos <em>\"zimmers\"</em> de Galilea, casas rurales de gesti\xF3n familiar en peque\xF1os pueblos, para ver Israel a trav\xE9s de nuevos ojos.</p>\n\t\t\t\t\t\t\t\t\t<h3>Donde la historia cobra vida</h3>\n\t\t\t\t\t\t\t\t\t<p>Galilea est\xE1 llena de sitios hist\xF3ricos. Visite los pueblos antiguos de Kfar Nahum (Cafarna\xFAn) y Migdal (Magdala) y entre a la Casa de San Pedro en Cafarna\xFAn. Vea las impresionantes iglesias y monasterios alrededor del mar de Galilea que marcaron los primeros d\xEDas del cristianismo. Puede respirar la santidad de Safed, una de las cuatro antiguas ciudades espirituales del juda\xEDsmo, mientras explora el centro cabal\xEDstico m\xE1s importante del mundo. Descubra las sinagogas m\xE1s antiguas del mundo en sitios como Baram y explore las fortalezas de los cruzados de Montfort y Nimrod. Brinde sus respetos a Maim\xF3nides en la antigua ciudad de Tiber\xEDades y experimente las maravillas del antiguo Akko (Acre), la ciudad subterr\xE1nea de los cruzados y el t\xFAnel y fortaleza de los Templarios.</p>\n\t\t\t\t\t\t\t\t\t<h3>Un para\xEDso gourmet en la Galilea</h3>\n\t\t\t\t\t\t\t\t\t<p>Las bodegas boutique y las lecher\xEDas artesanales esperan en cada esquina de Galilea, junto con aut\xE9nticos platos drusos y \xE1rabes cocinados en fogatas. Pruebe los alimentos directamente de las granjas org\xE1nicas y del productor, haga una pausa en los restaurantes gourmet de gesti\xF3n familiar y coma las frutas m\xE1s frescas en los huertos de producci\xF3n propia. Descubra Israel, que fluye no solo con leche y miel, sino tambi\xE9n con vino, aceite de oliva, quesos de cabra y fruta deliciosa.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/discover-galilei/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t\t<h3>Actividades emocionantes junto a hermosos paisajes&nbsp; </h3>\n\t\t\t\t\t\t\t\t\t<p>Las onduladas colinas verdes de la Baja Galilea est\xE1n entrecruzadas por r\xEDos y son perfectas para caminatas a la sombra. Los que buscan adrenalina pueden subir y bajar por las espectaculares alturas de la Alta Galilea y emocionarse con el descenso de r\xE1pidos en las aguas turbulentas del r\xEDo Jord\xE1n. Tambi\xE9n se ofrecen emocionantes paseos en jeep, paseos a caballo, alquiler de bicicletas o paintball. Hay actividades m\xE1s suaves y vislumbrar la t\xEDmida vida salvaje de Israel en extensas reservas naturales o dar un paseo en bote por las tranquilas aguas del mar de Galilea. Incluso puede disfrutar de los deportes de invierno en las laderas cubiertas de nieve del enorme monte Herm\xF3n en el extremo norte del pa\xEDs.</p>\n\t\t\t\t\t\t\t\t\t<p>Visite el norte de Israel para las vacaciones que siempre ha so\xF1ado.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t          \n\t\t\t\t\t\t\t\t  \n\t\t                        "};}}];

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loader_css__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Loader_css__);
var Loader=function Loader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"spinner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce3"}));};/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(88);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(53)
  , test    = {};
test[__webpack_require__(9)('toStringTag')] = 'z';
if(test + '' != '[object z]'){
  __webpack_require__(19)(Object.prototype, 'toString', function toString(){
    return '[object ' + classof(this) + ']';
  }, true);
}

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(54)
  , TAG = __webpack_require__(9)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 54 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(95)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(33)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(12)
  , core      = __webpack_require__(20)
  , hide      = __webpack_require__(13)
  , redefine  = __webpack_require__(19)
  , ctx       = __webpack_require__(34)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
    , key, own, out, exp;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && key in target;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if(target && !own)redefine(target, key, out);
    // export
    if(exports[key] != out)hide(exports, key, exp);
    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;  // forced
$export.G = 2;  // global
$export.S = 4;  // static
$export.P = 8;  // proto
$export.B = 16; // bind
$export.W = 32; // wrap
module.exports = $export;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(99);
var global      = __webpack_require__(12)
  , hide        = __webpack_require__(13)
  , Iterators   = __webpack_require__(21)
  , ITERATOR    = __webpack_require__(9)('iterator')
  , NL          = global.NodeList
  , HTC         = global.HTMLCollection
  , NLProto     = NL && NL.prototype
  , HTCProto    = HTC && HTC.prototype
  , ArrayValues = Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;
if(NLProto && !NLProto[ITERATOR])hide(NLProto, ITERATOR, ArrayValues);
if(HTCProto && !HTCProto[ITERATOR])hide(HTCProto, ITERATOR, ArrayValues);

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $            = __webpack_require__(15)
  , hide         = __webpack_require__(13)
  , redefineAll  = __webpack_require__(63)
  , ctx          = __webpack_require__(34)
  , strictNew    = __webpack_require__(64)
  , defined      = __webpack_require__(32)
  , forOf        = __webpack_require__(65)
  , $iterDefine  = __webpack_require__(33)
  , step         = __webpack_require__(61)
  , ID           = __webpack_require__(30)('id')
  , $has         = __webpack_require__(35)
  , isObject     = __webpack_require__(37)
  , setSpecies   = __webpack_require__(108)
  , DESCRIPTORS  = __webpack_require__(31)
  , isExtensible = Object.isExtensible || isObject
  , SIZE         = DESCRIPTORS ? '_s' : 'size'
  , id           = 0;

var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!$has(it, ID)){
    // can't set id to frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add id
    if(!create)return 'E';
    // add missing object id
    hide(it, ID, ++id);
  // return object id with prefix
  } return 'O' + it[ID];
};

var getEntry = function(that, key){
  // fast case
  var index = fastKey(key), entry;
  if(index !== 'F')return that._i[index];
  // frozen object case
  for(entry = that._f; entry; entry = entry.n){
    if(entry.k == key)return entry;
  }
};

module.exports = {
  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
    var C = wrapper(function(that, iterable){
      strictNew(that, C, NAME);
      that._i = $.create(null); // index
      that._f = undefined;      // first entry
      that._l = undefined;      // last entry
      that[SIZE] = 0;           // size
      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear(){
        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
          entry.r = true;
          if(entry.p)entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function(key){
        var that  = this
          , entry = getEntry(that, key);
        if(entry){
          var next = entry.n
            , prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if(prev)prev.n = next;
          if(next)next.p = prev;
          if(that._f == entry)that._f = next;
          if(that._l == entry)that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /*, that = undefined */){
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
          , entry;
        while(entry = entry ? entry.n : this._f){
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while(entry && entry.r)entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key){
        return !!getEntry(this, key);
      }
    });
    if(DESCRIPTORS)$.setDesc(C.prototype, 'size', {
      get: function(){
        return defined(this[SIZE]);
      }
    });
    return C;
  },
  def: function(that, key, value){
    var entry = getEntry(that, key)
      , prev, index;
    // change existing entry
    if(entry){
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if(!that._f)that._f = entry;
      if(prev)prev.n = entry;
      that[SIZE]++;
      // add to index
      if(index !== 'F')that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function(C, NAME, IS_MAP){
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function(iterated, kind){
      this._t = iterated;  // target
      this._k = kind;      // kind
      this._l = undefined; // previous
    }, function(){
      var that  = this
        , kind  = that._k
        , entry = that._l;
      // revert to the last existing entry
      while(entry && entry.r)entry = entry.p;
      // get next entry
      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if(kind == 'keys'  )return step(0, entry.k);
      if(kind == 'values')return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(19);
module.exports = function(target, src){
  for(var key in src)redefine(target, key, src[key]);
  return target;
};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name){
  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
  return it;
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(34)
  , call        = __webpack_require__(104)
  , isArrayIter = __webpack_require__(105)
  , anObject    = __webpack_require__(66)
  , toLength    = __webpack_require__(106)
  , getIterFn   = __webpack_require__(107);
module.exports = function(iterable, entries, fn, that){
  var iterFn = getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    call(iterator, f, step.value, entries);
  }
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(37);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global         = __webpack_require__(12)
  , $export        = __webpack_require__(59)
  , redefine       = __webpack_require__(19)
  , redefineAll    = __webpack_require__(63)
  , forOf          = __webpack_require__(65)
  , strictNew      = __webpack_require__(64)
  , isObject       = __webpack_require__(37)
  , fails          = __webpack_require__(56)
  , $iterDetect    = __webpack_require__(109)
  , setToStringTag = __webpack_require__(36);

module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
  var Base  = global[NAME]
    , C     = Base
    , ADDER = IS_MAP ? 'set' : 'add'
    , proto = C && C.prototype
    , O     = {};
  var fixMethod = function(KEY){
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a){
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a){
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
    new C().entries().next();
  }))){
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
  } else {
    var instance             = new C
      // early implementations not supports chaining
      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
      // most early implementations doesn't supports iterables, most modern - not close it correctly
      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
      // for early implementations -0 and +0 not the same
      , BUGGY_ZERO;
    if(!ACCEPT_ITERABLES){ 
      C = wrapper(function(target, iterable){
        strictNew(target, C, NAME);
        var that = new Base;
        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    IS_WEAK || instance.forEach(function(val, key){
      BUGGY_ZERO = 1 / key === -Infinity;
    });
    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
    // weak collections should not contains .clear method
    if(IS_WEAK && proto.clear)delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);

  return C;
};

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(70);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(40);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(138)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Helpers = exports.ScrollElement = exports.ScrollLink = exports.animateScroll = exports.scrollSpy = exports.Events = exports.scroller = exports.Element = exports.Button = exports.Link = undefined;

var _Link = __webpack_require__(153);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(157);

var _Button2 = _interopRequireDefault(_Button);

var _Element = __webpack_require__(158);

var _Element2 = _interopRequireDefault(_Element);

var _scroller = __webpack_require__(24);

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = __webpack_require__(44);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = __webpack_require__(42);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = __webpack_require__(74);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = __webpack_require__(41);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = __webpack_require__(76);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = __webpack_require__(159);

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Link = _Link2.default;
exports.Button = _Button2.default;
exports.Element = _Element2.default;
exports.scroller = _scroller2.default;
exports.Events = _scrollEvents2.default;
exports.scrollSpy = _scrollSpy2.default;
exports.animateScroll = _animateScroll2.default;
exports.ScrollLink = _scrollLink2.default;
exports.ScrollElement = _scrollElement2.default;
exports.Helpers = _Helpers2.default;
exports.default = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(25);

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__(155);

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__(156);

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__(44);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPositionY: 0,
    startPositionY: 0,
    targetPositionY: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    deltaTop: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.deltaTop = Math.round(data.targetPositionY - data.startPositionY);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPositionY = data.startPositionY + Math.ceil(data.deltaTop * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    data.containerElement.scrollTop = data.currentPositionY;
  } else {
    window.scrollTo(0, data.currentPositionY);
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(y, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  _cancelEvents2.default.subscribe(function () {
    options.data.cancel = true;
  });

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPositionY = currentPositionY(options);
  options.data.targetPositionY = options.absolute ? y : y + options.data.startPositionY;

  if (options.data.startPositionY === options.data.targetPositionY) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPositionY);
    }
    return;
  }

  options.data.deltaTop = Math.round(options.data.targetPositionY - options.data.startPositionY);

  options.data.duration = functionWrapper(options.duration)(options.data.deltaTop);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2.default.registered['begin']) {
    _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toY, options) {
  animateTopScroll(toY, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toY, options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(currentPositionY(options) + toY, options);
};

exports.default = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(43);

var _utils = __webpack_require__(25);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.pushHash(to);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

exports.default = scrollHash;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(16);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = __webpack_require__(24);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Component) {
  var Element = function (_React$Component) {
    _inherits(Element, _React$Component);

    function Element(props) {
      _classCallCheck(this, Element);

      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2.default.Component);

  ;

  Element.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
  };

  return Element;
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var settle = __webpack_require__(164);
var buildURL = __webpack_require__(166);
var parseHeaders = __webpack_require__(167);
var isURLSameOrigin = __webpack_require__(168);
var createError = __webpack_require__(79);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(169);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(165);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 82 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DealItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UI_UI__ = __webpack_require__(2);
var DealItem=function DealItem(props){var callToActionText=props.callToActionText!=undefined?props.callToActionText:'BOOK NOW';var cssClass=props.cssClass!=undefined?props.cssClass:'';var isReminder=props.isReminder!=undefined?props.isReminder:'';var job=props.job!=undefined?props.job:'';var new_day=new Date();// alert(new_day);
var corrent_month=new_day.getMonth();// alert(corrent_month);
var chinise_blackfriday=new_day.getDate();var world_blackfriday=new_day.getDate();var jobHTML=null;var blackfriday_friday_html='';if((chinise_blackfriday==11||world_blackfriday==29)&&corrent_month==10){blackfriday_friday_html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-black-friday'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'https://en.citiesbreak.com/twocities/assets/img/sale.png',className:'img-responsive'}));}if(job!=''){jobHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'job-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'(',job,')');}var html=null;if(isReminder){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"deal-item "+cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank','data-agent':props.brand,href:props.bookNowLink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brand-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.brand)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-img-desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:props.descFontSize},Object(__WEBPACK_IMPORTED_MODULE_1__Utility_Utility__["h" /* limitText */])(props.desc,100))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI__["j" /* Img */],{desktopImg:props.brandImg}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.price,jobHTML)))));}else{html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"deal-item "+cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank','data-agent':props.brand,href:props.bookNowLink},blackfriday_friday_html,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brand-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.brand)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'small'},'From'),' ',props.price,jobHTML)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-img-desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:props.descFontSize},Object(__WEBPACK_IMPORTED_MODULE_1__Utility_Utility__["h" /* limitText */])(props.desc,100))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI__["j" /* Img */],{desktopImg:props.brandImg}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrapper'},callToActionText,' >'))));}return html;};

/***/ }),
/* 84 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(86);
module.exports = __webpack_require__(91);


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(87).enable();
  window.Promise = __webpack_require__(89);
}

// fetch() polyfill for making API calls.
__webpack_require__(90);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(29);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(51);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(51);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fontfaceobserver__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fontfaceobserver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fontfaceobserver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_map__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_es6_set__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf_polyfill__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raf_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fonts_fonts_css__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fonts_fonts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__fonts_fonts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ie_css__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ie_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ie_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_router_dom__ = __webpack_require__(7);
// import registerServiceWorker from './registerServiceWorker';
var fontA=new __WEBPACK_IMPORTED_MODULE_0_fontfaceobserver___default.a('MyriadProRegular');var fontB=new __WEBPACK_IMPORTED_MODULE_0_fontfaceobserver___default.a('MyriadProSemibold');fontA.load().then(function(){console.log('Family A is available');});fontB.load().then(function(){console.log('Family B is available');});window.matchMedia=window.matchMedia||function(){return{matches:false,addListener:function addListener(){},removeListener:function removeListener(){}};};// const browserHistory = {};
var basename="/";// const basename = "/go-israel-new/";
// const basename = "/";
__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_router_dom__["a" /* BrowserRouter */],{basename:basename,forceRefresh:true},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__App__["a" /* default */],null)),document.getElementById('root'));// registerServiceWorker();

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

/* Font Face Observer v2.1.0 - © Bram Stein. License: BSD-3-Clause */(function(){function l(a,b){document.addEventListener?a.addEventListener("scroll",b,!1):a.attachEvent("scroll",b)}function m(a){document.body?a():document.addEventListener?document.addEventListener("DOMContentLoaded",function c(){document.removeEventListener("DOMContentLoaded",c);a()}):document.attachEvent("onreadystatechange",function k(){if("interactive"==document.readyState||"complete"==document.readyState)document.detachEvent("onreadystatechange",k),a()})};function t(a){this.a=document.createElement("div");this.a.setAttribute("aria-hidden","true");this.a.appendChild(document.createTextNode(a));this.b=document.createElement("span");this.c=document.createElement("span");this.h=document.createElement("span");this.f=document.createElement("span");this.g=-1;this.b.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.c.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";
this.f.style.cssText="max-width:none;display:inline-block;position:absolute;height:100%;width:100%;overflow:scroll;font-size:16px;";this.h.style.cssText="display:inline-block;width:200%;height:200%;font-size:16px;max-width:none;";this.b.appendChild(this.h);this.c.appendChild(this.f);this.a.appendChild(this.b);this.a.appendChild(this.c)}
function u(a,b){a.a.style.cssText="max-width:none;min-width:20px;min-height:20px;display:inline-block;overflow:hidden;position:absolute;width:auto;margin:0;padding:0;top:-999px;white-space:nowrap;font-synthesis:none;font:"+b+";"}function z(a){var b=a.a.offsetWidth,c=b+100;a.f.style.width=c+"px";a.c.scrollLeft=c;a.b.scrollLeft=a.b.scrollWidth+100;return a.g!==b?(a.g=b,!0):!1}function A(a,b){function c(){var a=k;z(a)&&a.a.parentNode&&b(a.g)}var k=a;l(a.b,c);l(a.c,c);z(a)};function B(a,b){var c=b||{};this.family=a;this.style=c.style||"normal";this.weight=c.weight||"normal";this.stretch=c.stretch||"normal"}var C=null,D=null,E=null,F=null;function G(){if(null===D)if(J()&&/Apple/.test(window.navigator.vendor)){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))(?:\.([0-9]+))/.exec(window.navigator.userAgent);D=!!a&&603>parseInt(a[1],10)}else D=!1;return D}function J(){null===F&&(F=!!document.fonts);return F}
function K(){if(null===E){var a=document.createElement("div");try{a.style.font="condensed 100px sans-serif"}catch(b){}E=""!==a.style.font}return E}function L(a,b){return[a.style,a.weight,K()?a.stretch:"","100px",b].join(" ")}
B.prototype.load=function(a,b){var c=this,k=a||"BESbswy",r=0,n=b||3E3,H=(new Date).getTime();return new Promise(function(a,b){if(J()&&!G()){var M=new Promise(function(a,b){function e(){(new Date).getTime()-H>=n?b(Error(""+n+"ms timeout exceeded")):document.fonts.load(L(c,'"'+c.family+'"'),k).then(function(c){1<=c.length?a():setTimeout(e,25)},b)}e()}),N=new Promise(function(a,c){r=setTimeout(function(){c(Error(""+n+"ms timeout exceeded"))},n)});Promise.race([N,M]).then(function(){clearTimeout(r);a(c)},
b)}else m(function(){function v(){var b;if(b=-1!=f&&-1!=g||-1!=f&&-1!=h||-1!=g&&-1!=h)(b=f!=g&&f!=h&&g!=h)||(null===C&&(b=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent),C=!!b&&(536>parseInt(b[1],10)||536===parseInt(b[1],10)&&11>=parseInt(b[2],10))),b=C&&(f==w&&g==w&&h==w||f==x&&g==x&&h==x||f==y&&g==y&&h==y)),b=!b;b&&(d.parentNode&&d.parentNode.removeChild(d),clearTimeout(r),a(c))}function I(){if((new Date).getTime()-H>=n)d.parentNode&&d.parentNode.removeChild(d),b(Error(""+
n+"ms timeout exceeded"));else{var a=document.hidden;if(!0===a||void 0===a)f=e.a.offsetWidth,g=p.a.offsetWidth,h=q.a.offsetWidth,v();r=setTimeout(I,50)}}var e=new t(k),p=new t(k),q=new t(k),f=-1,g=-1,h=-1,w=-1,x=-1,y=-1,d=document.createElement("div");d.dir="ltr";u(e,L(c,"sans-serif"));u(p,L(c,"serif"));u(q,L(c,"monospace"));d.appendChild(e.a);d.appendChild(p.a);d.appendChild(q.a);document.body.appendChild(d);w=e.a.offsetWidth;x=p.a.offsetWidth;y=q.a.offsetWidth;I();A(e,function(a){f=a;v()});u(e,
L(c,'"'+c.family+'",sans-serif'));A(p,function(a){g=a;v()});u(p,L(c,'"'+c.family+'",serif'));A(q,function(a){h=a;v()});u(q,L(c,'"'+c.family+'",monospace'))})})}; true?module.exports=B:(window.FontFaceObserver=B,window.FontFaceObserver.prototype.load=B.prototype.load);}());


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(52);
__webpack_require__(57);
__webpack_require__(60);
__webpack_require__(103);
module.exports = __webpack_require__(20).Map;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(12)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(58)
  , defined   = __webpack_require__(32);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = false;

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $              = __webpack_require__(15)
  , descriptor     = __webpack_require__(55)
  , setToStringTag = __webpack_require__(36)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(13)(IteratorPrototype, __webpack_require__(9)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(100)
  , step             = __webpack_require__(61)
  , Iterators        = __webpack_require__(21)
  , toIObject        = __webpack_require__(101);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(33)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(9)('unscopables')
  , ArrayProto  = Array.prototype;
if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(13)(ArrayProto, UNSCOPABLES, {});
module.exports = function(key){
  ArrayProto[UNSCOPABLES][key] = true;
};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(102)
  , defined = __webpack_require__(32);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(54);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(62);

// 23.1 Map Objects
__webpack_require__(67)('Map', function(get){
  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key){
    var entry = strong.getEntry(this, key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value){
    return strong.def(this, key === 0 ? 0 : key, value);
  }
}, strong, true);

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(66);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(21)
  , ITERATOR   = __webpack_require__(9)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(58)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(53)
  , ITERATOR  = __webpack_require__(9)('iterator')
  , Iterators = __webpack_require__(21);
module.exports = __webpack_require__(20).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(12)
  , $           = __webpack_require__(15)
  , DESCRIPTORS = __webpack_require__(31)
  , SPECIES     = __webpack_require__(9)('species');

module.exports = function(KEY){
  var C = global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(9)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(52);
__webpack_require__(57);
__webpack_require__(60);
__webpack_require__(111);
module.exports = __webpack_require__(20).Set;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(62);

// 23.2 Set Objects
__webpack_require__(67)('Set', function(get){
  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value){
    return strong.def(this, value = value === 0 ? 0 : value, value);
  }
}, strong);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(113).polyfill()


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(114)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)))

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(29),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.13.0";


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(29),r=__webpack_require__(118);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;pa.hasOwnProperty("ReactCurrentDispatcher")||(pa.ReactCurrentDispatcher={current:null});pa.hasOwnProperty("ReactCurrentBatchConfig")||(pa.ReactCurrentBatchConfig={suspense:null});
var qa=/^(.*)[\\\/]/,v="function"===typeof Symbol&&Symbol.for,ra=v?Symbol.for("react.element"):60103,sa=v?Symbol.for("react.portal"):60106,ta=v?Symbol.for("react.fragment"):60107,ua=v?Symbol.for("react.strict_mode"):60108,va=v?Symbol.for("react.profiler"):60114,wa=v?Symbol.for("react.provider"):60109,xa=v?Symbol.for("react.context"):60110,ya=v?Symbol.for("react.concurrent_mode"):60111,za=v?Symbol.for("react.forward_ref"):60112,Aa=v?Symbol.for("react.suspense"):60113,Ba=v?Symbol.for("react.suspense_list"):
60120,Ca=v?Symbol.for("react.memo"):60115,Da=v?Symbol.for("react.lazy"):60116,Ea=v?Symbol.for("react.block"):60121,Fa="function"===typeof Symbol&&Symbol.iterator;function Ga(a){if(null===a||"object"!==typeof a)return null;a=Fa&&a[Fa]||a["@@iterator"];return"function"===typeof a?a:null}function Ha(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Ia(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ta:return"Fragment";case sa:return"Portal";case va:return"Profiler";case ua:return"StrictMode";case Aa:return"Suspense";case Ba:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case xa:return"Context.Consumer";case wa:return"Context.Provider";case za:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ca:return Ia(a.type);case Ea:return Ia(a.render);case Da:if(a=1===a._status?a._result:null)return Ia(a)}return null}function Ja(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Ia(a.type);c=null;d&&(c=Ia(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(qa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}var Ka=null,La={};
function Ma(){if(Ka)for(var a in La){var b=La[a],c=Ka.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!Na[c]){if(!b.extractEvents)throw Error(u(97,a));Na[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(Oa.hasOwnProperty(h))throw Error(u(99,h));Oa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Pa(k[e],g,h);e=!0}else f.registrationName?(Pa(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function Pa(a,b,c){if(Qa[a])throw Error(u(100,a));Qa[a]=b;Ra[a]=b.eventTypes[c].dependencies}var Na=[],Oa={},Qa={},Ra={};function Sa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!La.hasOwnProperty(c)||La[c]!==d){if(La[c])throw Error(u(102,c));La[c]=d;b=!0}}b&&Ma()}var Ta=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Ua=null,Va=null,Wa=null;
function Xa(a){if(a=ma(a)){if("function"!==typeof Ua)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),Ua(a.stateNode,a.type,b))}}function Ya(a){Va?Wa?Wa.push(a):Wa=[a]:Va=a}function Za(){if(Va){var a=Va,b=Wa;Wa=Va=null;Xa(a);if(b)for(a=0;a<b.length;a++)Xa(b[a])}}function $a(a,b){return a(b)}function ab(a,b,c,d,e){return a(b,c,d,e)}function bb(){}var cb=$a,db=!1,eb=!1;function fb(){if(null!==Va||null!==Wa)bb(),Za()}
function gb(a,b,c){if(eb)return a(b,c);eb=!0;try{return cb(a,b,c)}finally{eb=!1,fb()}}var hb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ib=Object.prototype.hasOwnProperty,jb={},kb={};
function lb(a){if(ib.call(kb,a))return!0;if(ib.call(jb,a))return!1;if(hb.test(a))return kb[a]=!0;jb[a]=!0;return!1}function mb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function nb(a,b,c,d){if(null===b||"undefined"===typeof b||mb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function C(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var E={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){E[a]=new C(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];E[b]=new C(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){E[a]=new C(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){E[a]=new C(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){E[a]=new C(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){E[a]=new C(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){E[a]=new C(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){E[a]=new C(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){E[a]=new C(a,5,!1,a.toLowerCase(),null,!1)});var ob=/[\-:]([a-z])/g;function pb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(ob,
pb);E[b]=new C(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(ob,pb);E[b]=new C(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(ob,pb);E[b]=new C(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){E[a]=new C(a,1,!1,a.toLowerCase(),null,!1)});
E.xlinkHref=new C("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){E[a]=new C(a,1,!1,a.toLowerCase(),null,!0)});
function qb(a,b,c,d){var e=E.hasOwnProperty(b)?E[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(nb(b,c,e,d)&&(c=null),d||null===e?lb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&qb(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
Ta&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!Ta)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<Na.length;k++){var l=Na[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){db||bb();var e=id,f=db;db=!0;try{ab(e,a,b,c,d)}finally{(db=f)||fb()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{gb(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{gb(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=Ra[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=Ta&&"CompositionEvent"in window,ke=null;Ta&&"documentMode"in document&&(ke=document.documentMode);
var le=Ta&&"TextEvent"in window&&!ke,me=Ta&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Ya(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;Ta&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),db)mc(a);else{db=!0;try{$a(Ce,a)}finally{db=!1,fb()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=Ta&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=Ra.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(Ka)throw Error(u(101));Ka=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Ma();var xf=Nc;la=Qd;ma=xf;na=Pd;Sa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Ia(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=pa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case ra:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case sa:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
Ga(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case ra:return c.key===e?c.type===ta?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case sa:return c.key===e?l(a,b,c,d):null}if(Og(c)||Ga(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case ra:return a=a.get(null===d.key?c:d.key)||null,d.type===ta?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case sa:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||Ga(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=Ga(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ta&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case ra:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ta){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ta?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case sa:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(Ga(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=pa.ReactCurrentDispatcher,kh=pa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=pa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Qa.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(Qa.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):Qa.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(Qa.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&qb(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:Ja(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Ja(c));null!==c&&Ia(c.type);b=b.value;null!==a&&1===a.tag&&Ia(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):qb(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=pa.ReactCurrentDispatcher,dj=pa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):g.memoizedState=null}var m=0!==
(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;break a}h=void 0;g=b;var A=e.pingCache;
null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((Ia(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Ja(g))}S!==jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=
h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}
function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Ha(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===za)return 11;if(a===Ca)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ta:return Wg(c.children,e,f,b);case ya:g=8;e|=7;break;case ua:g=8;e|=1;break;case va:return a=Sh(12,c,b,e|8),a.elementType=va,a.type=va,a.expirationTime=f,a;case Aa:return a=Sh(13,c,b,e),a.type=Aa,a.elementType=Aa,a.expirationTime=f,a;case Ba:return a=Sh(19,c,b,e),a.elementType=Ba,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case wa:g=
10;break a;case xa:g=9;break a;case za:g=11;break a;case Ca:g=14;break a;case Da:g=16;d=null;break a;case Ea:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:sa,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
Ua=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};$a=Mj;
ab=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};bb=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};cb=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,Sa,Oa,Xd,function(a){jc(a,Wd)},Ya,Za,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:pa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.13.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.13.0";


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(119);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Routes_Routes__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_css__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Loader_Loader__ = __webpack_require__(50);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this));_this.handleLoader=function(){_this.setState({isLoading:false});};_this.state={isLoading:true,currentBrowser:Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["d" /* getBrowser */])()// https://tc39.github.io/ecma262/#sec-array.prototype.find
};if(!Array.prototype.find){Object.defineProperty(Array.prototype,'find',{value:function value(predicate){// 1. Let O be ? ToObject(this value).
if(this==null){throw new TypeError('"this" is null or not defined');}var o=Object(this);// 2. Let len be ? ToLength(? Get(O, "length")).
var len=o.length>>>0;// 3. If IsCallable(predicate) is false, throw a TypeError exception.
if(typeof predicate!=='function'){throw new TypeError('predicate must be a function');}// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
var thisArg=arguments[1];// 5. Let k be 0.
var k=0;// 6. Repeat, while k < len
while(k<len){// a. Let Pk be ! ToString(k).
// b. Let kValue be ? Get(O, Pk).
// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
// d. If testResult is true, return kValue.
var kValue=o[k];if(predicate.call(thisArg,kValue,k,o)){return kValue;}// e. Increase k by 1.
k++;}// 7. Return undefined.
return undefined;}});}return _this;}_createClass(App,[{key:'render',value:function render(){var _this2=this;var cssClass='desktopVersion ';if(Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["g" /* isMobile */])()){cssClass=' MobileVersion ';}var version=this.state.currentBrowser.version;version=parseInt(version);// alert(this.state.currentBrowser)
var html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App '+this.state.currentBrowser.name+'  '+this.state.currentBrowser.name+'-'+version+' '+cssClass},void window.scrollTo(0,0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Routes_Routes__["a" /* Routes */],null));if(this.state.isLoading===true){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App '+this.state.currentBrowser},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Loader_Loader__["a" /* default */],null));window.setTimeout(function(){_this2.handleLoader();},500);}return html;}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pages_Home_Home__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pages_SpacielDeals_SpacielDeals__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pages_ExporeTelAvivAndJerusalem_ExporeTelAvivAndJerusalem__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pages_TermsOfUse_TermsOfUse__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Pages_ThingsToDo_ThingsToDo__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Pages_WhereToGo_WhereToGo__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Pages_FAQ_FAQ__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pages_TelAvivPage_TelAvivPage__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Pages_JerusalemPage_JerusalemPage__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Pages_CulinaryPage_CulinaryPage__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Pages_DeadSeaPage_DeadSeaPage__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Pages_TouristInfo_TouristInfoPage__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Pages_EilatNegevPage_EilatNegevPage__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Pages_NorthPage_NorthPage__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Pages_CoronaVirusPage_CoronaVirus__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Posts_Videos_Videos__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Posts_Concerts_Concerts__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Posts_Posts_Posts__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Pages_Gallery_TA_GalleryTA__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Pages_Gallery_JA_GalleryJA__ = __webpack_require__(260);
/*
DEFINE CLIENT APP ROUTS 
*/// pages
// Posts
// Gallery
var Routes=function Routes(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/TelAvivPage',component:__WEBPACK_IMPORTED_MODULE_9__Pages_TelAvivPage_TelAvivPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/EilatNegevPage',component:__WEBPACK_IMPORTED_MODULE_14__Pages_EilatNegevPage_EilatNegevPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/NorthPage',component:__WEBPACK_IMPORTED_MODULE_15__Pages_NorthPage_NorthPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/JerusalemPage',component:__WEBPACK_IMPORTED_MODULE_10__Pages_JerusalemPage_JerusalemPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/CulinaryPage',component:__WEBPACK_IMPORTED_MODULE_11__Pages_CulinaryPage_CulinaryPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/DeadSeaPage',component:__WEBPACK_IMPORTED_MODULE_12__Pages_DeadSeaPage_DeadSeaPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/TouristInfoPage',component:__WEBPACK_IMPORTED_MODULE_13__Pages_TouristInfo_TouristInfoPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/CoronaVirusPage',component:__WEBPACK_IMPORTED_MODULE_16__Pages_CoronaVirusPage_CoronaVirus__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/FAQ',component:__WEBPACK_IMPORTED_MODULE_8__Pages_FAQ_FAQ__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/thingsToDo',component:__WEBPACK_IMPORTED_MODULE_6__Pages_ThingsToDo_ThingsToDo__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/whereToGo',component:__WEBPACK_IMPORTED_MODULE_7__Pages_WhereToGo_WhereToGo__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/bestDeals',component:__WEBPACK_IMPORTED_MODULE_3__Pages_SpacielDeals_SpacielDeals__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/Gallery/:galleryId',component:__WEBPACK_IMPORTED_MODULE_20__Pages_Gallery_TA_GalleryTA__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/Gallery/',component:__WEBPACK_IMPORTED_MODULE_20__Pages_Gallery_TA_GalleryTA__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/TermsOfUse',component:__WEBPACK_IMPORTED_MODULE_5__Pages_TermsOfUse_TermsOfUse__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/Videos',component:__WEBPACK_IMPORTED_MODULE_4__Pages_ExporeTelAvivAndJerusalem_ExporeTelAvivAndJerusalem__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Posts/Videos/:ctgId/:vidId',component:__WEBPACK_IMPORTED_MODULE_17__Posts_Videos_Videos__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Posts/:ctgId/:id',component:__WEBPACK_IMPORTED_MODULE_19__Posts_Posts_Posts__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/',component:__WEBPACK_IMPORTED_MODULE_2__Pages_Home_Home__["a" /* default */]}));};

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(38);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(126);
var invariant = __webpack_require__(127);
var ReactPropTypesSecret = __webpack_require__(128);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(38);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(136);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(39);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(68);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(140);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(142);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(72);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(144);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(39);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(146);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(40);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(72);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(40);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(150);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(70);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactjs_popup__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lazyload__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_Deals_DealItem__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Home_css__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Home_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Home_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import AgreeCookies from '../../Components/AgreeCookies/AgreeCookies'
// private class data
var galleryObj1={img:"Home/7.jpg",link:"/Pages/Gallery/ta",text:"TEL AVIV"};var galleryObj2={img:"Home/8.jpg",link:"/Pages/Gallery/ja",text:"JERUSALÉN"};var galleryObj3={img:"Home/9.jpg",link:"/Pages/Gallery/deadsea",text:"EL MAR MUERTO"};var galleryObj4={img:"Home/10.jpg",link:"/Pages/Gallery/yp",text:"SUS PHOTOS"};// function Shuffle(o) {
//   for(var j, x, i = o.length; i; j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
//   return o;
// };
var Home=function(_Component){_inherits(Home,_Component);function Home(props){_classCallCheck(this,Home);var _this=_possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).call(this,props));_this.updateDimensions=function(){var w=window,d=document,documentElement=d.documentElement,body=d.getElementsByTagName("body")[0],width=w.innerWidth||documentElement.clientWidth||body.clientWidth;// height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;
_this.setState({width:width});};_this.openModal=function(id){var url=Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["f" /* getUrl */])()+"instagram-api.php?ID="+id;// var url = 'https://www.instagram.com/p/'+id+'/?tagged=takeme2telaviv&__a=1';
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url,{}).then(function(res){var obj=res.data;var userinfo=obj.graphql.shortcode_media;var likes=userinfo.edge_media_preview_like.count;var username=userinfo.owner.username;var caption=userinfo.edge_media_to_caption.edges[0].node.text;var userProfileImg=userinfo.owner.profile_pic_url;// console.log(username);
_this.setState({open:true,instagramId:id,instagramUserImg:userProfileImg,instagramCaption:caption,instagramUserName:username,instagramLikes:likes});});};_this.closeModal=function(){_this.setState({open:false});};_this.playVideo=function(event){// alert(this.state.imageState);
_this.setState({imageState:false});};_this.playVideo2=function(event){// alert(this.state.imageState);
_this.setState({imageState2:false});};_this.playVideo3=function(event){// alert(this.state.imageState);
_this.setState({imageState3:false});};_this.playVideo4=function(event){// alert(this.state.imageState);
_this.setState({imageState4:false});};_this.playVideo5=function(event){// alert(this.state.imageState);
_this.setState({imageState5:false});};_this.playVideo6=function(event){// alert(this.state.imageState);
_this.setState({imageState6:false});};_this.playVideo7=function(event){// alert(this.state.imageState);
_this.setState({imageState7:false});};_this.playVideo8=function(event){// alert(this.state.imageState);
_this.setState({imageState8:false});};_this.playVideo9=function(event){// alert(this.state.imageState);
_this.setState({imageState9:false});};_this.playVideo10=function(event){// alert(this.state.imageState);
_this.setState({imageState10:false});};_this.closeAlert=function(event){document.getElementById("travel-alert").style.display="none";};_this.setVideoMobile=function(vidId,id){// alert('setVideoMobile : ' +   vidId);
_this.setState({MobileVidId1:vidId,MobileVidId1Elm:id});};_this.setVideoMobile2=function(vidId,id){// alert('setVideoMobile : ' +   vidId);
_this.setState({MobileVidId2:vidId,MobileVidId2Elm:id});};_this.setVideoMobile3=function(vidId,id){// alert('setVideoMobile : ' +   vidId);
_this.setState({MobileVidId3:vidId,MobileVidId3Elm:id});};_this.setVideo=function(vidId,ctg){// alert("ss");
if(ctg==="culinary"||ctg==="culinarytelaviv"||ctg==="culinaryjerusalem"||ctg==="culinarynorth"){_this.setState({culinaryVid:vidId});var e=document.getElementById("CULINARY");__WEBPACK_IMPORTED_MODULE_2_react_scroll__["animateScroll"].scrollTo(e.offsetTop-100);if(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */]){_this.setState({imageState7:false});}}else{var elm=document.getElementById("expore-tel-aviv-and-jerusalem");__WEBPACK_IMPORTED_MODULE_2_react_scroll__["animateScroll"].scrollTo(elm.offsetTop-100);_this.setState({exporeTelAvivAndjerusalemMainVid:vidId});if(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */]){_this.setState({imageState8:false});}}};_this.setCurrentFaq=function(id){var faq=[].concat(_toConsumableArray(_this.state.faq));var current=faq.find(function(o){return o.id===id;});if(current.isOpen===true){current.isOpen=false;}else{current.isOpen=true;}_this.setState({faq:faq});};_this.handleisVidClick=function(){_this.setState({isVidClick:!_this.state.isVidClick});};_this.playVideo=_this.playVideo.bind(_this);_this.playVideo2=_this.playVideo2.bind(_this);_this.playVideo3=_this.playVideo3.bind(_this);_this.playVideo4=_this.playVideo4.bind(_this);_this.state={isVidClick:false,instagramData:[],instagramDataMobile:[],northArrMobile:[],// isLoading : true;
// exporeTelAvivAndjerusalemMainVid: "5nqL-oIC0GA", old video
// exporeTelAvivAndjerusalemMainVid: "nLKWDp5uA-U", changed at 17.05.2020
exporeTelAvivAndjerusalemMainVid:"FYtk8JMMZRE",eurovisionMainVid:"5PAjhoH0NWU",TelAvivAndjerusalemVideoState:0,culinaryVid:"jfyHxk8ZRrI",culinaryVidState:0,faq:__WEBPACK_IMPORTED_MODULE_9__Data_Data__["c" /* faqData */],telAvivWeather:20,waterTemp:20,jerusalemWeather:20,deadSeaWeather:15,shirCssClass:" btn-shir",supportCssClass:" new-support-btn",open:false,instagramId:null,instagramUserImg:null,instagramCaption:null,instagramUserName:null,instagramLikes:null,imageState:true,imageState2:true,imageState3:true,imageState4:true,imageState5:true,imageState6:true,imageState7:true,imageState8:true,imageState9:true,imageState10:true,width:0,MobileVidId1:"",MobileVidId1Elm:"",MobileVidId2:"",MobileVidId2Elm:"",MobileVidId3:"",MobileVidId3Elm:"",isInit:true};return _this;}_createClass(Home,[{key:"componentWillMount",value:function componentWillMount(){this.updateDimensions();}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener("resize",this.updateDimensions);}},{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["a" /* asyncgetWeather */])(),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["c" /* geinstagramData */])()]).then(function(response){var weather=response[0];var instagramData=response[1];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({instagramData:instagramData.posts,jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({instagramData:instagramData.posts,jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({instagramData:instagramData.posts,jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}//This was added for mobile youtube butn play
},{key:"render",value:function render(){var _this3=this;var remindersHtml=__WEBPACK_IMPORTED_MODULE_9__Data_Data__["a" /* Reminders */].map(function(o,i){var cssClass="";if(o.hasOwnProperty("cssClass")){cssClass=o.cssClass;}var job="";if(o.hasOwnProperty("job")){job=o.job;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Components_Deals_DealItem__["a" /* DealItem */],{brand:o.site,isReminder:true,price:"“"+o.quote+"”",desc:"",brandImg:o.img,cssClass:cssClass,ctg:o.ctg,job:o.job,callToActionText:"READ MORE"});});var sliderSettings={dots:false,autoplay:true,// lazyLoad: 'ondemand',
infinite:true,lazyLoad:"ondemand",cssEase:"linear",slidesToShow:this.props.items!=undefined?this.props.items:3,slidesToScroll:3,responsive:[{breakpoint:1000,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:600,settings:{slidesToShow:1,slidesToScroll:1}}]};var sliderSettings2={dots:false,autoplay:true,// lazyLoad: 'ondemand',
infinite:true,lazyLoad:"ondemand",cssEase:"linear",slidesToShow:this.props.items!=undefined?this.props.items:3,slidesToScroll:3,responsive:[{breakpoint:1000,settings:{slidesToShow:2,slidesToScroll:1}},{breakpoint:600,settings:{slidesToShow:1,slidesToScroll:1}}]};var culinaryArr=[];var postsArr=[];var videoArr=[];var eurovisionArr=[];var eilatNegevArr=[];var jerusalemArr=[];var telavivArr=[];var northArr=[];var deadseaArr=[];__WEBPACK_IMPORTED_MODULE_9__Data_Data__["d" /* newPosts */].map(function(o){// console.log('o' , o);
if(o.ctg==="culinary"||o.ctg==="culinarytelaviv"||o.ctg==="culinaryjerusalem"||o.ctg==="culinarynorth"){culinaryArr.push(o);}else if(o.ctg==="eurovision"){eurovisionArr.push(o);}else if(o.ctg==="eilat-negev"){eilatNegevArr.push(o);}else if(o.ctg==="north"){northArr.push(o);}else if(o.ctg==="jerusalem"){jerusalemArr.push(o);}else if(o.ctg==="telaviv"){telavivArr.push(o);}else if(o.ctg==="deadsea"){deadseaArr.push(o);}else{postsArr.push(o);}});console.log("newVideos:",__WEBPACK_IMPORTED_MODULE_9__Data_Data__["e" /* newVideos */]);__WEBPACK_IMPORTED_MODULE_9__Data_Data__["e" /* newVideos */].map(function(o){// console.log('o' , o);
if(o.isVid===true||o.forVidPage===true){videoArr.push(o);}});// videoArr = Shuffle(videoArr);
// console.log('Shuffle vid' , videoArr);
var videoMobileArr=[];if(videoArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(videoArr.length){// console.log( 'easd' ,  postsArr.splice(0,4) );
videoMobileArr.push(videoArr.splice(0,size));}}var videosHtml=null;if(videoMobileArr.length>0){videosHtml=videoMobileArr.map(function(arr,i){return arr.map(function(o,i){// var title = o.title;
var url="Posts/"+o.ctg+"/"+o.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:o.desc,img:o.img,link:url,doBlank:true,mobileId:"",click:function click(){_this3.setVideo(o.vidId,o.ctg);}});});});videosHtml=videosHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var postsHtml=postsArr.map(function(o,i){// const url = "/Posts/" + o.id ;
var url="/Posts/"+o.ctg+"/"+o.id;if(o.hasOwnProperty("showOnHome")&&o.showOnHome===false){}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});}});var deadseamObileArr=[];if(deadseaArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(deadseaArr.length){// console.log( 'easd' ,  deadseaArr.splice(0,4) );
deadseamObileArr.push(deadseaArr.splice(0,size));}}var deadseaPostsHtml=null;if(deadseamObileArr.length>0){deadseaPostsHtml=deadseamObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});deadseaPostsHtml=deadseaPostsHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var eilatNegevmObileArr=[];if(eilatNegevArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(eilatNegevArr.length){// console.log( 'easd' ,  eilatNegevArr.splice(0,4) );
eilatNegevmObileArr.push(eilatNegevArr.splice(0,size));}}var eilatNegevPostsHtml=null;if(eilatNegevmObileArr.length>0){eilatNegevPostsHtml=eilatNegevmObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});eilatNegevPostsHtml=eilatNegevPostsHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var jerusalemmObileArr=[];if(jerusalemArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(jerusalemArr.length){// console.log( 'easd' ,  jerusalemArr.splice(0,4) );
jerusalemmObileArr.push(jerusalemArr.splice(0,size));}}var jerusalemPostsHtml=null;if(jerusalemmObileArr.length>0){jerusalemPostsHtml=jerusalemmObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});jerusalemPostsHtml=jerusalemPostsHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var telavivmObileArr=[];if(telavivArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(telavivArr.length){// console.log( 'easd' ,  telavivArr.splice(0,4) );
telavivmObileArr.push(telavivArr.splice(0,size));}}var telavivPostsHtml=null;if(telavivmObileArr.length>0){telavivPostsHtml=telavivmObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});telavivPostsHtml=telavivPostsHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var northmObileArr=[];if(northArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(northArr.length){// console.log( 'easd' ,  northArr.splice(0,4) );
northmObileArr.push(northArr.splice(0,size));}}var northPostsHtml=null;if(northmObileArr.length>0){northPostsHtml=northmObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});northPostsHtml=northPostsHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var culinaryMobileArr=[];if(culinaryArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(culinaryArr.length){// console.log( 'easd' ,  culinaryArr.splice(0,4) );
culinaryMobileArr.push(culinaryArr.splice(0,size));}}var culinaryHtml=null;if(culinaryMobileArr.length>0){culinaryHtml=culinaryMobileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:o.desc,img:o.img,link:url,doBlank:true,mobileId:"",click:function click(){_this3.setVideo(o.vidId,o.ctg);}});});});culinaryHtml=culinaryHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var eurovisionHtml=eurovisionArr.map(function(o,i){// const url = "/Posts/" + o.id ;
var url="/Posts/"+o.ctg+"/"+o.id;if(o.hasOwnProperty("showOnHome")&&o.showOnHome===false){}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});}});var date1=new Date();var hasBean=[];var notHasBean=[];__WEBPACK_IMPORTED_MODULE_9__Data_Data__["f" /* showsArr */].map(function(o,i){var isTodayBigger=Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["b" /* compareDates */])(date1,o.date);if(isTodayBigger===true||o.date==="30.12.2017"||o.date==="21.06.2018"){// o.cssClass +=" addOpacity ";
// hasBean.push(o);
}else{o.cssClass="";notHasBean.push(o);}});// marge two array into array
var newshowsArr=[].concat(notHasBean,hasBean);var concertsmObileArr=[];if(newshowsArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(newshowsArr.length){// console.log( 'easd' ,  newshowsArr.splice(0,4) );
concertsmObileArr.push(newshowsArr.splice(0,size));}}var concertSHtml=null;if(concertsmObileArr.length>0){concertSHtml=concertsmObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;if(_this3.state.width<1000){title=o.title;}var url="Posts/Concerts/"+o.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});concertSHtml=concertSHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var faqHtml=this.state.faq.map(function(o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["e" /* FaqItem */],{key:o.id,q:o.q,answer:o.answer,isOpen:o.isOpen,click:function click(){_this3.setCurrentFaq(o.id);}});});var instagramHtml=null;var img1Url="Home/Mobile/1.jpg";var img2Url="Home/Mobile/2.jpg";var img3Url="Home/Mobile/3.jpg";var img4Url="Home/Mobile/4.jpg";var callToActionHtml="";var twoCitesOneBreakVid="";var euroVisionVid="";var culinaryVid="";var galleryHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:galleryObj1.img,cssClass:"col-100",link:galleryObj1.link,text:galleryObj1.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:galleryObj3.img,cssClass:"col-100",link:galleryObj3.link,text:galleryObj3.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:galleryObj2.img,cssClass:"col-100",link:galleryObj2.link,text:galleryObj2.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:galleryObj4.img,cssClass:"col-100",link:galleryObj4.link,text:galleryObj4.text}));if(this.state.width>1000){callToActionHtml=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["b" /* AnimateCallToAction */],{src:"btn_shir.png",cssClass:this.state.shirCssClass,link:"/international/Pages/bestDeals"}));img1Url="Home/1.jpg";img2Url="Home/2.jpg";img3Url="Home/3.jpg";img4Url="Home/4.jpg";{/*euroVisionVid = <div className="hide-on-mobile">
                <ResponsiveYouTubeIframe vidId={this.state.eurovisionMainVid}  />
              </div>*/}{/*twoCitesOneBreakVid = <div className="hide-on-mobile">
                <ResponsiveYouTubeIframe vidId={this.state.exporeTelAvivAndjerusalemMainVid}  />
              </div>*/}{/*culinaryVid = <div className="hide-on-mobile">
        <ResponsiveYouTubeIframe vidId={this.state.culinaryVid} />
      </div>
      galleryHTML = <div className="row more-info-row">
                      <ImgAndText img={galleryObj1.img} cssClass={" col-33"} link={galleryObj1.link} text={galleryObj1.text} />
                      <ImgAndText img={galleryObj2.img} cssClass={" col-33"} link={galleryObj2.link} text={galleryObj2.text} />
                      <ImgAndText img={galleryObj3.img} cssClass={" col-33"} link={galleryObj3.link} text={galleryObj3.text} />

                  </div>*/}}else{galleryHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row more-info-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:galleryObj1.img,cssClass:" col-33",link:galleryObj1.link,text:galleryObj1.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:galleryObj2.img,cssClass:" col-33",link:galleryObj2.link,text:galleryObj2.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:galleryObj3.img,cssClass:" col-33",link:galleryObj3.link,text:galleryObj3.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:galleryObj4.img,cssClass:" col-33",link:galleryObj4.link,text:galleryObj4.text}));}var instagramData=this.state.instagramData;// console.log('instagramData: ' , instagramData);
var insta_size=2;// if ( this.state.width < 1000 ) {
//     size = 4;
// }
if(this.state.width<600){insta_size=4;}if(instagramData.length>0){while(instagramData.length>0){this.state.instagramDataMobile.push(instagramData.splice(0,insta_size));}}if(this.state.instagramDataMobile.length>0){instagramHtml=this.state.instagramDataMobile.map(function(arr,i){return arr.map(function(o,i){var imgLink="instagram/"+o.id+".jpg";if(_this3.state.width<600){imgLink="instagram/Mobile/"+o.id+".jpg";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:o.id,onClick:function onClick(){_this3.openModal(o.id);}}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["l" /* InstagremSliderItem */],{title:o.publishBy,cssClass:"InstagremSliderItem-"+i,img:imgLink}));});});// console.log('instagramHtml2' , instagramHtml2);
instagramHtml=instagramHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var currentInstagramLikeUrl="https://www.instagram.com/p/"+this.state.instagramId+"/";var currentInstagramUrl="https://www.instagram.com/"+this.state.instagramUserName+"/";var currentInstagramImgUrl="instagram/"+this.state.instagramId+".jpg";var a=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["h" /* HomeSlider */],{isHomeSlider:true,waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}));// if ( this.state.isVidClick === true ){
//   a = <section className="home-section caruasel-wrapper banners-caruasel-wrapper" id="part-1" >
//   <ResponsiveYouTubeIframe vidId={"5PAjhoH0NWU"} />
//   </section>
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page align-center page-home"},callToActionHtml,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["p" /* TravelAlert */],{click:this.closeAlert}),a,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section hide-on-mobile",id:"weather-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,"DATOS INTERESANTES"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"weather-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["r" /* WeatherIcon */],{label:"TIEMPO DE VUELO",temp:"5H30"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["r" /* WeatherIcon */],{label:"TEMPERATURA DEL AGUA.",temp:this.state.waterTemp}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["r" /* WeatherIcon */],{label:"EL TIEMPO EN TEL AVIV",temp:this.state.telAvivWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["r" /* WeatherIcon */],{label:"EL TIEMPO EN JERUSALEM",temp:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["r" /* WeatherIcon */],{label:"EL TIEMPO EN EL MAR MUERTO",temp:this.state.deadSeaWeather}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:100},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"eurovision"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),euroVisionVid,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},eurovisionHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"video"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,"DOS CIUDADES UNA ESCAPADA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-explure-israel.jpg",click:this.playVideo}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"n3caX3AN_a4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"more-info-wrapper add-margin-top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row more-info-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:img1Url,cssClass:"first",link:"/Pages/whereToGo",text:"A DONDE IR >"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:img2Url,cssClass:"last",link:"/Pages/thingsToDo",text:"QUÉ HACER >"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row more-info-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:img4Url,cssClass:"first",link:"/Pages/TouristInfoPage",text:"INFO. TURÍSTICA >"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* ImgAndText */],{img:img3Url,cssClass:"last",link:"/Pages/Videos",text:"VÍDEOS >"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:100},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"expore-tel-aviv-and-jerusalem"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/thingsToDo",className:"ac-plan-your-trip"},"ORGANIZA TU VIAJE")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState8?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-more-things-todo.jpg",click:this.playVideo8}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:this.state.exporeTelAvivAndjerusalemMainVid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},videosHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"jerusalem-posts"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/JerusalemPage",className:"ac-jerusalem-posts"},"JERUSAL\xC9N")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState9?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-jerusalem.jpg",click:this.playVideo9}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"nLKWDp5uA-U"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},jerusalemPostsHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"telaviv-posts"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/TelavivPage",className:"ac-telaviv-posts"},"TEL AVIV")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState10?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-telaviv.jpg",click:this.playVideo10}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"XDei1Zy_cu4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},telavivPostsHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:100},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"CULINARY"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/CulinaryPage",className:"ac-coolinary-exp"},"LA MEJOR EXPERIENCIA CULINARIA")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-culinary.jpg",click:this.playVideo7}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:this.state.culinaryVid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},culinaryHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"deadsea-posts"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/DeadSeaPage",className:"ac-dead-posts"},"EL MAR MUERTO")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-deadsea.jpg",click:this.playVideo2}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"8p4qfkneH1c"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},deadseaPostsHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"eilat-negev-posts"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/EilatNegevPage",className:"ac-eilat-negev-posts"},"VISITA EL NEGEV Y EILAT")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-negev-eilat.jpg",click:this.playVideo3}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"ZdnNT-GDJv4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},eilatNegevPostsHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"north"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/NorthPage",className:"ac-north-posts"},"VISITA EL NORTE")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState4?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-north.jpg",click:this.playVideo4}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"fZ_WdHpHRT8"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings2},northPostsHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"instagram"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,"SUS FOTOS DE ISRAEL"),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState5?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-insta.jpg",click:this.playVideo5}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"z0OoUqKkwwM"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ac-credit-home"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Cr\xE9dito: Fabio Wibmer")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},instagramHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"shows"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/liveShows",className:"ac-shows"},"ESPECT\xC1CULOS EN DIRECTO")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},concertSHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"gallery"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/Gallery/",className:"ac-gallery-home-page"},"GALER\xCDA")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),galleryHTML,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding ",id:"faq"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/FAQ",className:"ac-faq"},"FAQ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"faq-wrapper"},faqHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Components_Footer_Footer__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactjs_popup__["a" /* default */],{open:this.state.open,closeOnDocumentClick:true,onClose:this.closeModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"close",onClick:this.closeModal},"\xD7"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"userImgInstagram"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* Img */],{desktopImg:currentInstagramImgUrl})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"user-info-instagram"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:currentInstagramUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"userProfileImgWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:this.state.instagramUserImg})),"@",this.state.instagramUserName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"instagramCaption"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.state.instagramCaption!=null?Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["h" /* limitText */])(this.state.instagramCaption,130):""))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:currentInstagramLikeUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"like-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* Img */],{desktopImg:"like.png"}))))));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(41);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LinkElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(LinkElement);

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(43);

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

exports.default = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(41);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck(this, ButtonElement);

    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'input',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(ButtonElement);

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollElement = __webpack_require__(76);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck(this, ElementWrapper);

    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` from props
      var newProps = _extends({}, this.props);
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

;

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

exports.default = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* DEPRECATED */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(16);

var utils = __webpack_require__(25);
var scrollSpy = __webpack_require__(42);
var defaultScroller = __webpack_require__(24);
var PropTypes = __webpack_require__(5);
var scrollHash = __webpack_require__(75);

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    ;

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    ;

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

module.exports = Helpers;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var bind = __webpack_require__(77);
var Axios = __webpack_require__(162);
var defaults = __webpack_require__(47);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(81);
axios.CancelToken = __webpack_require__(175);
axios.isCancel = __webpack_require__(80);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(176);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(47);
var utils = __webpack_require__(8);
var InterceptorManager = __webpack_require__(170);
var dispatchRequest = __webpack_require__(171);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(79);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var transformData = __webpack_require__(172);
var isCancel = __webpack_require__(80);
var defaults = __webpack_require__(47);
var isAbsoluteURL = __webpack_require__(173);
var combineURLs = __webpack_require__(174);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(81);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = on;
exports.off = off;
function on(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.addEventListener) {
    el.addEventListener(eventName, callback, opts);
  } else if (el.attachEvent) {
    el.attachEvent("on" + eventName, function (e) {
      callback.call(el, e || window.event);
    });
  }
}

function off(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.removeEventListener) {
    el.removeEventListener(eventName, callback, opts);
  } else if (el.detachEvent) {
    el.detachEvent("on" + eventName, callback);
  }
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @fileOverview Find scroll parent
 */

exports.default = function (node) {
  if (!(node instanceof HTMLElement)) {
    return document.documentElement;
  }

  var excludeStaticParent = node.style.position === 'absolute';
  var overflowRegex = /(scroll|auto)/;
  var parent = node;

  while (parent) {
    if (!parent.parentNode) {
      return node.ownerDocument || document.documentElement;
    }

    var style = window.getComputedStyle(parent);
    var position = style.position;
    var overflow = style.overflow;
    var overflowX = style['overflow-x'];
    var overflowY = style['overflow-y'];

    if (position === 'static' && excludeStaticParent) {
      parent = parent.parentNode;
      continue;
    }

    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return node.ownerDocument || node.documentElement || document.documentElement;
};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;

  var later = function later() {
    var last = +new Date() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = +new Date();

    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throttle;
/*eslint-disable */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(182);


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(183);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 183 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserInfo = /** @class */ (function () {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
    }
    return BrowserInfo;
}());
exports.BrowserInfo = BrowserInfo;
var NodeInfo = /** @class */ (function () {
    function NodeInfo(version) {
        this.version = version;
        this.name = 'node';
        this.os = process.platform;
    }
    return NodeInfo;
}());
exports.NodeInfo = NodeInfo;
var BotInfo = /** @class */ (function () {
    function BotInfo() {
        this.bot = true; // NOTE: deprecated test name instead
        this.name = 'bot';
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}());
exports.BotInfo = BotInfo;
// tslint:disable-next-line:max-line-length
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [
    ['aol', /AOLShield\/([0-9\._]+)/],
    ['edge', /Edge\/([0-9\._]+)/],
    ['edge-ios', /EdgiOS\/([0-9\._]+)/],
    ['yandexbrowser', /YaBrowser\/([0-9\._]+)/],
    ['vivaldi', /Vivaldi\/([0-9\.]+)/],
    ['kakaotalk', /KAKAOTALK\s([0-9\.]+)/],
    ['samsung', /SamsungBrowser\/([0-9\.]+)/],
    ['silk', /\bSilk\/([0-9._-]+)\b/],
    ['miui', /MiuiBrowser\/([0-9\.]+)$/],
    ['beaker', /BeakerBrowser\/([0-9\.]+)/],
    ['edge-chromium', /Edg\/([0-9\.]+)/],
    [
        'chromium-webview',
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/,
    ],
    ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
    ['phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/],
    ['crios', /CriOS\/([0-9\.]+)(:?\s|$)/],
    ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/],
    ['fxios', /FxiOS\/([0-9\.]+)/],
    ['opera-mini', /Opera Mini.*Version\/([0-9\.]+)/],
    ['opera', /Opera\/([0-9\.]+)(?:\s|$)/],
    ['opera', /OPR\/([0-9\.]+)(:?\s|$)/],
    ['ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
    ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
    ['ie', /MSIE\s(7\.0)/],
    ['bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/],
    ['android', /Android\s([0-9\.]+)/],
    ['ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/],
    ['safari', /Version\/([0-9\._]+).*Safari/],
    ['facebook', /FBAV\/([0-9\.]+)/],
    ['instagram', /Instagram\s([0-9\.]+)/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
    ['searchbot', SEARCHBOX_UA_REGEX],
];
var operatingSystemRules = [
    ['iOS', /iP(hone|od|ad)/],
    ['Android OS', /Android/],
    ['BlackBerry OS', /BlackBerry|BB10/],
    ['Windows Mobile', /IEMobile/],
    ['Amazon OS', /Kindle/],
    ['Windows 3.11', /Win16/],
    ['Windows 95', /(Windows 95)|(Win95)|(Windows_95)/],
    ['Windows 98', /(Windows 98)|(Win98)/],
    ['Windows 2000', /(Windows NT 5.0)|(Windows 2000)/],
    ['Windows XP', /(Windows NT 5.1)|(Windows XP)/],
    ['Windows Server 2003', /(Windows NT 5.2)/],
    ['Windows Vista', /(Windows NT 6.0)/],
    ['Windows 7', /(Windows NT 6.1)/],
    ['Windows 8', /(Windows NT 6.2)/],
    ['Windows 8.1', /(Windows NT 6.3)/],
    ['Windows 10', /(Windows NT 10.0)/],
    ['Windows ME', /Windows ME/],
    ['Open BSD', /OpenBSD/],
    ['Sun OS', /SunOS/],
    ['Chrome OS', /CrOS/],
    ['Linux', /(Linux)|(X11)/],
    ['Mac OS', /(Mac_PowerPC)|(Macintosh)/],
    ['QNX', /QNX/],
    ['BeOS', /BeOS/],
    ['OS/2', /OS\/2/],
    ['Search Bot', SEARCHBOT_OS_REGEX],
];
function detect(userAgent) {
    if (!!userAgent) {
        return parseUserAgent(userAgent);
    }
    if (typeof navigator !== 'undefined') {
        return parseUserAgent(navigator.userAgent);
    }
    return getNodeVersion();
}
exports.detect = detect;
function parseUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    var matchedRule = ua !== '' &&
        userAgentRules.reduce(function (matched, _a) {
            var browser = _a[0], regex = _a[1];
            if (matched) {
                return matched;
            }
            var uaMatch = regex.exec(ua);
            return !!uaMatch && [browser, uaMatch];
        }, false);
    if (!matchedRule) {
        return null;
    }
    var name = matchedRule[0], match = matchedRule[1];
    if (name === 'searchbot') {
        return new BotInfo();
    }
    var versionParts = match[1] && match[1].split(/[._]/).slice(0, 3);
    if (versionParts) {
        if (versionParts.length < REQUIRED_VERSION_PARTS) {
            versionParts = __spreadArrays(versionParts, createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length));
        }
    }
    else {
        versionParts = [];
    }
    return new BrowserInfo(name, versionParts.join('.'), detectOS(ua));
}
exports.parseUserAgent = parseUserAgent;
function detectOS(ua) {
    for (var ii = 0, count = operatingSystemRules.length; ii < count; ii++) {
        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.test(ua);
        if (match) {
            return os;
        }
    }
    return null;
}
exports.detectOS = detectOS;
function getNodeVersion() {
    var isNode = typeof process !== 'undefined' && process.version;
    return isNode ? new NodeInfo(process.version.slice(1)) : null;
}
exports.getNodeVersion = getNodeVersion;
function createVersionParts(count) {
    var output = [];
    for (var ii = 0; ii < count; ii++) {
        output.push('0');
    }
    return output;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)))

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Validator Class 
 * @DESC  simplae validation class
*/var Validator=function(){function Validator(){_classCallCheck(this,Validator);}_createClass(Validator,[{key:'simpleValidation',value:function simpleValidation(o){if(o.val===''){this.show_popup(o.err_1);return false;}else{return true;}}// email validation 
},{key:'email_validation',value:function email_validation(o){if(o.val===""){this.show_popup(o.err_1);return false;}else{if(o.expression.test(o.val)===false){this.show_popup(o.err_2);return false;}else{return true;}}}// regx validation 
},{key:'regx_validation',value:function regx_validation(obj){if(obj.val===''){this.show_popup(obj.err_1);return false;}else{if(obj.expression.test(obj.val)){return true;}else{this.show_popup(obj.err_2);return false;}}}// alert 
},{key:'show_popup',value:function show_popup(msg){alert(msg);}}]);return Validator;}();/* harmony default export */ __webpack_exports__["a"] = (Validator);

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _slider = __webpack_require__(187);

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(188);

var _json2mq = __webpack_require__(195);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(197);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _innerSliderUtils = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(198);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.innerSliderRefHandler = function (ref) {
      return _this.innerSlider = ref;
    };

    _this.slickPrev = function () {
      return _this.innerSlider.slickPrev();
    };

    _this.slickNext = function () {
      return _this.innerSlider.slickNext();
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    };

    _this.slickPause = function () {
      return _this.innerSlider.pause("paused");
    };

    _this.slickPlay = function () {
      return _this.innerSlider.autoPlay("play");
    };

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  Slider.prototype.media = function media(query, handler) {
    // javascript handler for  css media query
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  // handles responsive breakpoints


  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // performance monitoring
    //if (process.env.NODE_ENV !== 'production') {
    //const { whyDidYouUpdate } = require('why-did-you-update')
    //whyDidYouUpdate(React)
    //}
    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      // sort them in increasing order of their numerical value
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        // media query for each breakpoint
        var bQuery = void 0;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({
            minWidth: breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });
        }
        // when not using server side rendering
        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      // convert javascript object to media query string
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
    } else {
      settings = _extends({}, _defaultProps2.default, this.props);
    }

    // force scrolling by one if centerMode is on
    if (settings.centerMode) {
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
      }
      settings.slidesToScroll = 1;
    }
    // force showing one slide and scrolling by one if the fade mode is on
    if (settings.fade) {
      if (settings.slidesToShow > 1 && "production" !== "production") {
        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
      }
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
      }
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    // makes sure that children is an array, even when there is only 1 child
    var children = _react2.default.Children.toArray(this.props.children);

    // Children may contain false or null, so we should filter them
    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
    children = children.filter(function (child) {
      if (typeof child === "string") {
        return !!child.trim();
      }
      return !!child;
    });

    // rows and slidesPerRow logic is handled here
    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
      settings.variableWidth = false;
    }
    var newChildren = [];
    var currentWidth = null;
    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];
      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];
        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && children[k].props.style) {
            currentWidth = children[k].props.style.width;
          }
          if (k >= children.length) break;
          row.push(_react2.default.cloneElement(children[k], {
            key: 100 * i + 10 * j + k,
            tabIndex: -1,
            style: {
              width: 100 / settings.slidesPerRow + "%",
              display: "inline-block"
            }
          }));
        }
        newSlide.push(_react2.default.createElement(
          "div",
          { key: 10 * i + j },
          row
        ));
      }
      if (settings.variableWidth) {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i, style: { width: currentWidth } },
          newSlide
        ));
      } else {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i },
          newSlide
        ));
      }
    }

    if (settings === "unslick") {
      var className = "regular slider " + (this.props.className || "");
      return _react2.default.createElement(
        "div",
        { className: className },
        newChildren
      );
    } else if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }
    return _react2.default.createElement(
      _innerSlider.InnerSlider,
      _extends({ ref: this.innerSliderRefHandler }, settings),
      newChildren
    );
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(16);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _initialState = __webpack_require__(189);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(190);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(27);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(28);

var _track = __webpack_require__(191);

var _dots = __webpack_require__(192);

var _arrows = __webpack_require__(193);

var _resizeObserverPolyfill = __webpack_require__(194);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSlider = exports.InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.listRefHandler = function (ref) {
      return _this.list = ref;
    };

    _this.trackRefHandler = function (ref) {
      return _this.track = ref;
    };

    _this.adaptHeight = function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    };

    _this.componentWillMount = function () {
      _this.ssrInit();
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    };

    _this.componentDidMount = function () {
      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill2.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      // To support server-side rendering
      if (!window) {
        return;
      }
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    };

    _this.componentWillUnmount = function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);
      var setTrackStyle = false;
      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }
        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    };

    _this.componentDidUpdate = function () {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
    };

    _this.onWindowResized = function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash2.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    };

    _this.resizeWindow = function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!_reactDom2.default.findDOMNode(_this.track)) return;
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    };

    _this.updateState = function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _extends({}, spec, { left: targetLeft });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    };

    _this.ssrInit = function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }
        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
        }
        _this.setState({
          trackStyle: _trackStyle
        });
        return;
      }
      var childrenCount = _react2.default.Children.count(_this.props.children);
      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    };

    _this.checkImagesLoad = function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    };

    _this.progressiveLazyLoad = function () {
      var slidesToLoad = [];
      var spec = _extends({}, _this.props, _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    };

    _this.slideHandler = function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange;
      // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({ animating: animating });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    };

    _this.changeSlide = function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _extends({}, _this.props, _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    };

    _this.clickHandler = function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    };

    _this.keyHandler = function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({ message: dir });
    };

    _this.selectHandler = function (options) {
      _this.changeSlide(options);
    };

    _this.disableBodyScroll = function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    };

    _this.enableBodyScroll = function () {
      window.ontouchmove = null;
    };

    _this.swipeStart = function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    };

    _this.swipeMove = function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    };

    _this.swipeEnd = function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    };

    _this.slickPrev = function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "previous" });
      }, 0));
    };

    _this.slickNext = function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "next" });
      }, 0));
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    };

    _this.play = function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    };

    _this.autoPlay = function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({ autoplaying: "playing" });
    };

    _this.pause = function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({ autoplaying: "paused" });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({ autoplaying: "focused" });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({ autoplaying: "hovered" });
        }
      }
    };

    _this.onDotsOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onDotsLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onTrackOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onTrackLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onSlideFocus = function () {
      return _this.props.autoplay && _this.pause("focused");
    };

    _this.onSlideBlur = function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    };

    _this.render = function () {
      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _extends({}, _this.props, _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;

      trackProps = _extends({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });

      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;

        dotProps = _extends({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react2.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };

      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = { className: "slick-list" };
        innerSliderProps = { className: className };
      }
      return _react2.default.createElement(
        "div",
        innerSliderProps,
        !_this.props.unslick ? prevArrow : "",
        _react2.default.createElement(
          "div",
          _extends({ ref: _this.listRefHandler }, listProps),
          _react2.default.createElement(
            _track.Track,
            _extends({ ref: _this.trackRefHandler }, trackProps),
            _this.props.children
          )
        ),
        !_this.props.unslick ? nextArrow : "",
        !_this.props.unslick ? dots : ""
      );
    };

    _this.list = null;
    _this.track = null;
    _this.state = _extends({}, _initialState2.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react2.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react2.default.Component);

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false, // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
  trackStyle: {},
  trackWidth: 0
};

exports.default = initialState;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(27);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react2.default.Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react2.default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
    // push a cloned element of the desired slide
    slides.push(_react2.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames2.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;
        if (key < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides(this.props);
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    return _react2.default.createElement(
      "div",
      _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents),
      slides
    );
  };

  return Track;
}(_react2.default.PureComponent);

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(27);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = exports.Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll,
      slidesToShow: this.props.slidesToShow,
      infinite: this.props.infinite
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: "dots",
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
      return _react2.default.createElement(
        "li",
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
      className: this.props.dotsClass
    }, mouseEvents));
  };

  return Dots;
}(_react2.default.PureComponent);

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(27);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { "slick-arrow": true, "slick-prev": true };
    var prevHandler = this.clickHandler.bind(this, { message: "previous" });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses["slick-disabled"] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { display: "block" },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        "button",
        _extends({ key: "0", type: "button" }, prevArrowProps),
        " ",
        "Previous"
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.PureComponent);

var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { "slick-arrow": true, "slick-next": true };
    var nextHandler = this.clickHandler.bind(this, { message: "next" });

    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
      nextClasses["slick-disabled"] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { display: "block" },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        "button",
        _extends({ key: "1", type: "button" }, nextArrowProps),
        " ",
        "Next"
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.PureComponent);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18)))

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(196);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 196 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react2.default.createElement(
      "ul",
      { style: { display: "block" } },
      dots
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react2.default.createElement(
      "button",
      null,
      i + 1
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

exports.default = defaultProps;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(199);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(200);
var Util = __webpack_require__(82);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(201);
var each = __webpack_require__(82).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Deals_css__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Deals_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Deals_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DealItem__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utility_Utility__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Deals=function(_Component){_inherits(Deals,_Component);function Deals(props){_classCallCheck(this,Deals);var _this=_possibleConstructorReturn(this,(Deals.__proto__||Object.getPrototypeOf(Deals)).call(this,props));_this.image_url=Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["e" /* getImgUrl */])();_this.dealsSliderSettings={dots:true,infinite:true,cssEase:'linear',autoplay:false,lazyLoad:"ondemand",slidesToShow:_this.props.items!=undefined?_this.props.items:3,slidesToScroll:1,responsive:[{breakpoint:1000,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:600,settings:{slidesToShow:1,slidesToScroll:1}}]};_this.deals=[{title:"NORWEGIAN",desc:"VUELOS A TEL AVIV",price:"199€",logo:"/Deals/norwegian.png",link:"https://www.norwegian.com/reserva/reserve-su-vuelo/preciosbaratos/?A_City=TLV&AdultCount=1&ChildCount=0&CurrencyCode=EUR&D_City=BCN&D_Day=06&D_Month=202002&D_SelectedDay=06&IncludeTransit=true&InfantCount=0&R_Day=06&R_Month=202002&R_SelectedDay=06&TripType=2#/?origin=BCN&destination=TLV&outbound=2020-02&inbound=2020-02&selectedInbound=2020-02-09&adults=1&currency=EUR",book_now:"RESERVA YA"},{title:"Iberia",desc:"Gran variedad de vuelos económicos a Tel Aviv desde 249 EURO",price:" 249€",logo:"/Deals/iberia.png",link:"https://www.iberia.com/vuelos-baratos/Madrid-Tel-Aviv/",book_now:"RESERVA YA"},{title:"Air Europa",desc:"Gran variedad de vuelos económicos a Tel Aviv desde 250 EURO",price:" 250€",logo:"/Deals/aireuropa.png",link:"https://www.aireuropa.com/es-es/ofertas-de-vuelos-desde-madrid-a-tel-aviv",book_now:"RESERVA YA"},{title:"Vueling",desc:"Gran variedad de vuelos económicos a Tel Aviv desde 251 EURO",price:" 251€",logo:"/Deals/vueling.png",link:"https://www.vueling.com/en/routes/cheap-flights-from-madrid-to-telaviv",book_now:"RESERVA YA"},{title:"NAUTALIA VIAJES",desc:"VUELO + HOTEL A JERUSALÉN",price:"257€",logo:"/Deals/9.jpg",link:"https://www.nautaliaviajes.com/vuelo-hotel/asia/israel/",book_now:"RESERVA YA"},{title:"El Al",desc:"Vuele a Tel Aviv",price:" 294€",logo:"/Deals/elal.png",link:"https://www.elal.com/Spain/Pages/default.aspx",book_now:"RESERVA YA"},{title:"TEL AVIV HOTEL",desc:"el sitio perfecto para una escapada urbana Cena gratuita para dos personas",price:" 120€",logo:"/Deals/tlv-hotels.png",link:"https://www.visit-tel-aviv.com/en/promotions/telaviv",book_now:"RESERVA YA"},{title:"MAPA DINAMICS",desc:"JERUSALÉN",price:" 478€",logo:"/Deals/mapa.jpg",link:"https://www.mapadinamics.com/idea/454826/jerusalen",book_now:"RESERVA YA"},{title:"Travelplan",desc:"ESTANCIA EN TELAVIV",price:" 485€",logo:"/Deals/20.jpg",link:"http://www.travelplan.es/b2b/html/pub/catalogos_xml/new_contenedor_virtual.html?catalogo=2019_2020/isj1920&numpagina=18",book_now:"RESERVA YA"},{title:"Logitravel",desc:"TEL AVIV",price:"535€",logo:"/Deals/10.jpg",link:"https://www.logitravel.com/viajes/asia/israel/",book_now:"RESERVA YA"},{title:"LUXOTOUR",desc:"Escapada a Jerusalén y alrededores",price:" 565€",logo:"/Deals/28.png",link:"https://www.luxotour.es/reservar/escapada-jerusalen-y-alrededores-20_-5122?search_date=",book_now:"RESERVA YA"},{title:"Travelplan",desc:"ESTANCIAS EN JERUSALÉN",price:" 599€",logo:"/Deals/20.jpg",link:"http://www.travelplan.es/b2b/html/pub/catalogos_xml/new_contenedor_virtual.html?catalogo=2019_2020/isj1920&numpagina=20",book_now:"RESERVA YA"},{title:"Tourist Forum",desc:"Escapada a Israel",price:"631€",logo:"/Deals/turist-forum.jpg",link:"https://www.touristforum.net/escapada-israel-telaviv-jerusalen?utm_source=GoIsrael&utm_medium=web&utm_campaign=Israel",book_now:"RESERVA YA"},{title:"Viajes El Corte Inglés",desc:"DESCUBRE ISRAEL",price:"681€",logo:"/Deals/31.png",link:"https://transporte-hotel.viajeselcorteingles.es/idea/236369/descubre-israel?tripId=0",book_now:"RESERVA YA"},{title:"Dynamic Tours",desc:"ESTANCIA EN JERUSALÉN",price:" 717€",logo:"/Deals/16.jpg",link:"https://www.dynamic-tours.com/detalle-oferta.php?oferta=110",book_now:"RESERVA YA"},{title:"CATAI",desc:"ESTANCIA EN JERUSALÉN",price:"720€",logo:"/Deals/5.jpg",link:"https://www.catai.es/viajes/estancia-en-jerusalen.html/13922/travelpricer",book_now:"RESERVA YA"},{title:"Tarawa Travel",desc:"PLAYAS DE TEL AVIV",price:" 740€",logo:"/Deals/17.jpg",link:"https://www.tarawatravel.com/Viaje/Israel-Playas-de-Tel-Aviv/28-2596",book_now:"RESERVA YA"},{title:"TOURIST FORUM",desc:"Escapada a Jerusalén",price:"749€",logo:"/Deals/turist-forum.jpg",link:"https://www.touristforum.net/escapada-israel-jerusalen?utm_source=GoIsrael&utm_medium=web&utm_campaign=Jerusalen",book_now:"RESERVA YA"},{title:"WORLD TRAVEL BITAKORA",desc:"ESCAPADA A JERUSALÉN",price:" 762€",logo:"/Deals/bikatora.png",link:"https://www.wtbitakora.com/Circuitos/Detalle?ProductCode=OM0250&BrochureNumber=167&ProductCode=OM0250&BrochureNumber=167",book_now:"RESERVA YA"},{title:"Travelplan",desc:"COMBINADO TELAVIV Y <br>JERUSALÉN MÁGICOS",price:" 799€",logo:"/Deals/20.jpg",link:"http://www.travelplan.es/b2b/html/pub/catalogos_xml/new_contenedor_virtual.html?catalogo=2019_2020/isj1920&numpagina=32",book_now:"RESERVA YA"},{title:"Girovolt Viatges",desc:"DESCUBRIENDO TEL AVIV Y JERUSALÉN",price:" 821€",logo:"/Deals/11.jpg",link:"http://www.viatgesgirovol.com/?msgOrigen=6&CODART=ART02539",book_now:"RESERVA YA"},{title:"Tarawa Travel",desc:"JERUSALÉN CLÁSICO",price:" 825€",logo:"/Deals/17.jpg",link:"http://www.tarawatravel.com/Viaje/Jerusalen-Clasico/28-2059/",book_now:"RESERVA YA"},{title:"Viatges Travelling",desc:"TEL AVIV GAY",price:" 940€",logo:"/Deals/12.jpg",link:"http://viatgestravelling.com/destino/tel-aviv-gay/ ",book_now:"RESERVA YA"},{title:"TUI SPAIN",desc:"Jerusalén Soñado",price:" 1039€",logo:"/Deals/3.jpg",link:"https://es.tui.com/Viajes/Ficha?CodigoProducto=AOA19IL83&NumeroFolleto=1221",book_now:"RESERVA YA"},{title:"TUI SPAIN",desc:"Telaviv y Jerusalén. 6 días ",price:" 1094€",logo:"/Deals/3.jpg",link:"https://es.tui.com/Viajes/Ficha?CodigoProducto=A0A19IL84&NumeroFolleto=1221",book_now:"RESERVA YA"},{title:"VIAJES PRÓXIMO ORIENTE",desc:"Escapada a Jerusalén",price:" 1259€",logo:"/Deals/11b.png",link:"https://www.viajesproximoriente.com/circuito/10-escapada-a-jerusalen",book_now:"RESERVA YA"}];return _this;}_createClass(Deals,[{key:'render',value:function render(){var dealsHtml=this.deals.map(function(o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DealItem__["a" /* DealItem */],{brand:o.title,price:o.price,brandImg:o.logo,desc:o.desc,bookNowLink:o.link,descFontSize:o.fontSize});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deals-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:this.dealsSliderSettings},dealsHtml));}}]);return Deals;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Deals);

/***/ }),
/* 206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_deep_equal__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fast_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_youtube_player__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_youtube_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_youtube_player__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * Check whether a `props` change should result in the video being updated.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldUpdateVideo(prevProps, props) {
  // A changing video should always trigger an update
  if (prevProps.videoId !== props.videoId) {
    return true;
  }

  // Otherwise, a change in the start/end time playerVars also requires a player
  // update.
  var prevVars = prevProps.opts.playerVars || {};
  var vars = props.opts.playerVars || {};

  return prevVars.start !== vars.start || prevVars.end !== vars.end;
}

/**
 * Neutralise API options that only require a video update, leaving only options
 * that require a player reset. The results can then be compared to see if a
 * player reset is necessary.
 *
 * @param {Object} opts
 */
function filterResetOptions(opts) {
  return _extends({}, opts, {
    playerVars: _extends({}, opts.playerVars, {
      autoplay: 0,
      start: 0,
      end: 0
    })
  });
}

/**
 * Check whether a `props` change should result in the player being reset.
 * The player is reset when the `props.opts` change, except if the only change
 * is in the `start` and `end` playerVars, because a video update can deal with
 * those.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldResetPlayer(prevProps, props) {
  return !__WEBPACK_IMPORTED_MODULE_2_fast_deep_equal___default()(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
}

/**
 * Check whether a props change should result in an id or className update.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldUpdatePlayer(prevProps, props) {
  return prevProps.id !== props.id || prevProps.className !== props.className;
}

var YouTube = function (_React$Component) {
  _inherits(YouTube, _React$Component);

  function YouTube(props) {
    _classCallCheck(this, YouTube);

    var _this = _possibleConstructorReturn(this, (YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call(this, props));

    _this.onPlayerReady = function (event) {
      return _this.props.onReady(event);
    };

    _this.onPlayerError = function (event) {
      return _this.props.onError(event);
    };

    _this.onPlayerStateChange = function (event) {
      _this.props.onStateChange(event);
      switch (event.data) {

        case YouTube.PlayerState.ENDED:
          _this.props.onEnd(event);
          break;

        case YouTube.PlayerState.PLAYING:
          _this.props.onPlay(event);
          break;

        case YouTube.PlayerState.PAUSED:
          _this.props.onPause(event);
          break;

        default:
      }
    };

    _this.onPlayerPlaybackRateChange = function (event) {
      return _this.props.onPlaybackRateChange(event);
    };

    _this.onPlayerPlaybackQualityChange = function (event) {
      return _this.props.onPlaybackQualityChange(event);
    };

    _this.createPlayer = function () {
      // do not attempt to create a player server-side, it won't work
      if (typeof document === 'undefined') return;
      // create player
      var playerOpts = _extends({}, _this.props.opts, {
        // preload the `videoId` video if one is already given
        videoId: _this.props.videoId
      });
      _this.internalPlayer = __WEBPACK_IMPORTED_MODULE_3_youtube_player___default()(_this.container, playerOpts);
      // attach event handlers
      _this.internalPlayer.on('ready', _this.onPlayerReady);
      _this.internalPlayer.on('error', _this.onPlayerError);
      _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);
      _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);
      _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
    };

    _this.resetPlayer = function () {
      return _this.internalPlayer.destroy().then(_this.createPlayer);
    };

    _this.updatePlayer = function () {
      _this.internalPlayer.getIframe().then(function (iframe) {
        if (_this.props.id) iframe.setAttribute('id', _this.props.id);else iframe.removeAttribute('id');
        if (_this.props.className) iframe.setAttribute('class', _this.props.className);else iframe.removeAttribute('class');
      });
    };

    _this.updateVideo = function () {
      if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
        _this.internalPlayer.stopVideo();
        return;
      }

      // set queueing options
      var autoplay = false;
      var opts = {
        videoId: _this.props.videoId
      };
      if ('playerVars' in _this.props.opts) {
        autoplay = _this.props.opts.playerVars.autoplay === 1;
        if ('start' in _this.props.opts.playerVars) {
          opts.startSeconds = _this.props.opts.playerVars.start;
        }
        if ('end' in _this.props.opts.playerVars) {
          opts.endSeconds = _this.props.opts.playerVars.end;
        }
      }

      // if autoplay is enabled loadVideoById
      if (autoplay) {
        _this.internalPlayer.loadVideoById(opts);
        return;
      }
      // default behaviour just cues the video
      _this.internalPlayer.cueVideoById(opts);
    };

    _this.refContainer = function (container) {
      _this.container = container;
    };

    _this.container = null;
    _this.internalPlayer = null;
    return _this;
  }

  /**
    * Expose PlayerState constants for convenience. These constants can also be
    * accessed through the global YT object after the YouTube IFrame API is instantiated.
    * https://developers.google.com/youtube/iframe_api_reference#onStateChange
    */


  _createClass(YouTube, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createPlayer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (shouldUpdatePlayer(prevProps, this.props)) {
        this.updatePlayer();
      }

      if (shouldResetPlayer(prevProps, this.props)) {
        this.resetPlayer();
      }

      if (shouldUpdateVideo(prevProps, this.props)) {
        this.updateVideo();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      /**
       * Note: The `youtube-player` package that is used promisifies all Youtube
       * Player API calls, which introduces a delay of a tick before it actually
       * gets destroyed. Since React attempts to remove the element instantly
       * this method isn't quick enough to reset the container element.
       */
      this.internalPlayer.destroy();
    }

    /**
     * https://developers.google.com/youtube/iframe_api_reference#onReady
     *
     * @param {Object} event
     *   @param {Object} target - player object
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onError
     *
     * @param {Object} event
     *   @param {Integer} data  - error type
     *   @param {Object} target - player object
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onStateChange
     *
     * @param {Object} event
     *   @param {Integer} data  - status change type
     *   @param {Object} target - actual YT player
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackRateChange
     *
     * @param {Object} event
     *   @param {Float} data    - playback rate
     *   @param {Object} target - actual YT player
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackQualityChange
     *
     * @param {Object} event
     *   @param {String} data   - playback quality
     *   @param {Object} target - actual YT player
     */


    /**
     * Initialize the Youtube Player API on the container and attach event handlers
     */


    /**
     * Shorthand for destroying and then re-creating the Youtube Player
     */


    /**
     * Method to update the id and class of the Youtube Player iframe.
     * React should update this automatically but since the Youtube Player API
     * replaced the DIV that is mounted by React we need to do this manually.
     */


    /**
     * Call Youtube Player API methods to update the currently playing video.
     * Depeding on the `opts.playerVars.autoplay` this function uses one of two
     * Youtube Player API methods to update the video.
     */

  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: this.props.containerClassName },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { id: this.props.id, className: this.props.className, ref: this.refContainer })
      );
    }
  }]);

  return YouTube;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

YouTube.propTypes = {
  videoId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // custom ID for player element
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // custom class name for player element
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  // custom class name for player container element
  containerClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
  opts: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any),

  // event subscriptions
  onReady: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onError: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPause: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onEnd: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onStateChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlaybackRateChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlaybackQualityChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};
YouTube.defaultProps = {
  id: null,
  className: null,
  opts: {},
  containerClassName: '',
  onReady: function onReady() {},
  onError: function onError() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onEnd: function onEnd() {},
  onStateChange: function onStateChange() {},
  onPlaybackRateChange: function onPlaybackRateChange() {},
  onPlaybackQualityChange: function onPlaybackQualityChange() {}
};
YouTube.PlayerState = {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  CUED: 5
};


/* harmony default export */ __webpack_exports__["a"] = (YouTube);

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  return a!==a && b!==b;
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _sister = __webpack_require__(210);

var _sister2 = _interopRequireDefault(_sister);

var _loadYouTubeIframeApi = __webpack_require__(211);

var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);

var _YouTubePlayer = __webpack_require__(213);

var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */

/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */
var youtubeIframeAPI = void 0;

/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param maybeElementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */

exports.default = function (maybeElementId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var emitter = (0, _sister2.default)();

  if (!youtubeIframeAPI) {
    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
  }

  if (options.events) {
    throw new Error('Event handlers cannot be overwritten.');
  }

  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
    throw new Error('Element "' + maybeElementId + '" does not exist.');
  }

  options.events = _YouTubePlayer2.default.proxyEvents(emitter);

  var playerAPIReady = new Promise(function (resolve) {
    if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
      var player = maybeElementId;

      resolve(player);
    } else {
      // asume maybeElementId can be rendered inside
      // eslint-disable-next-line promise/catch-or-return
      youtubeIframeAPI.then(function (YT) {
        // eslint-disable-line promise/prefer-await-to-then
        var player = new YT.Player(maybeElementId, options);

        emitter.on('ready', function () {
          resolve(player);
        });

        return null;
      });
    }
  });

  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);

  playerApi.on = emitter.on;
  playerApi.off = emitter.off;

  return playerApi;
};

module.exports = exports['default'];

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Sister;

/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/
Sister = function () {
    var sister = {},
        events = {};

    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */

    /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */
    sister.on = function (name, handler) {
        var listener = {name: name, handler: handler};
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };

    /**
     * @param {listener}
     */
    sister.off = function (listener) {
        var index = events[listener.name].indexOf(listener);

        if (index !== -1) {
            events[listener.name].splice(index, 1);
        }
    };

    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */
    sister.trigger = function (name, data) {
        var listeners = events[name],
            i;

        if (listeners) {
            i = listeners.length;
            while (i--) {
                listeners[i].handler(data);
            }
        }
    };

    return sister;
};

module.exports = Sister;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loadScript = __webpack_require__(212);

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (emitter) {
  /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */
  var iframeAPIReady = new Promise(function (resolve) {
    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
      resolve(window.YT);

      return;
    } else {
      var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';

      (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
        if (error) {
          emitter.trigger('error', error);
        }
      });
    }

    var previous = window.onYouTubeIframeAPIReady;

    // The API will call this function when page has finished downloading
    // the JavaScript for the player API.
    window.onYouTubeIframeAPIReady = function () {
      if (previous) {
        previous();
      }

      resolve(window.YT);
    };
  });

  return iframeAPIReady;
};

module.exports = exports['default'];

/***/ }),
/* 212 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debug = __webpack_require__(214);

var _debug2 = _interopRequireDefault(_debug);

var _functionNames = __webpack_require__(217);

var _functionNames2 = _interopRequireDefault(_functionNames);

var _eventNames = __webpack_require__(218);

var _eventNames2 = _interopRequireDefault(_eventNames);

var _FunctionStateMap = __webpack_require__(219);

var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable promise/prefer-await-to-then */

var debug = (0, _debug2.default)('youtube-player');

var YouTubePlayer = {};

/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
YouTubePlayer.proxyEvents = function (emitter) {
  var events = {};

  var _loop = function _loop(eventName) {
    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);

    events[onEventName] = function (event) {
      debug('event "%s"', onEventName, event);

      emitter.trigger(eventName, event);
    };
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return events;
};

/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */
YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var functions = {};

  var _loop2 = function _loop2(functionName) {
    if (strictState && _FunctionStateMap2.default[functionName]) {
      functions[functionName] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return playerAPIReady.then(function (player) {
          var stateInfo = _FunctionStateMap2.default[functionName];
          var playerState = player.getPlayerState();

          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          var value = player[functionName].apply(player, args);

          // TRICKY: For functions like `seekTo`, a change in state must be
          // triggered given that the resulting state could match the initial
          // state.
          if (stateInfo.stateChangeRequired ||

          // eslint-disable-next-line no-extra-parens
          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
            return new Promise(function (resolve) {
              var onPlayerStateChange = function onPlayerStateChange() {
                var playerStateAfterChange = player.getPlayerState();

                var timeout = void 0;

                if (typeof stateInfo.timeout === 'number') {
                  timeout = setTimeout(function () {
                    player.removeEventListener('onStateChange', onPlayerStateChange);

                    resolve();
                  }, stateInfo.timeout);
                }

                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                  player.removeEventListener('onStateChange', onPlayerStateChange);

                  clearTimeout(timeout);

                  resolve();
                }
              };

              player.addEventListener('onStateChange', onPlayerStateChange);
            }).then(function () {
              return value;
            });
          }

          return value;
        });
      };
    } else {
      functions[functionName] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return playerAPIReady.then(function (player) {
          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          return player[functionName].apply(player, args);
        });
      };
    }
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var functionName = _step2.value;

      _loop2(functionName);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return functions;
};

exports.default = YouTubePlayer;
module.exports = exports['default'];

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(215);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":""}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)))

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(216);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 216 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */
exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
module.exports = exports['default'];

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */
exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
module.exports = exports['default'];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PlayerStates = __webpack_require__(220);

var _PlayerStates2 = _interopRequireDefault(_PlayerStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  pauseVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
    stateChangeRequired: false
  },
  playVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
    stateChangeRequired: false
  },
  seekTo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
    stateChangeRequired: true,

    // TRICKY: `seekTo` may not cause a state change if no buffering is
    // required.
    timeout: 3000
  }
};
module.exports = exports['default'];

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GDPRWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var GDPRWrapper=function GDPRWrapper(_ref){var children=_ref.children,group=_ref.group;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isConsentGiven=_useState2[0],setIsConsentGiven=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var checkConsent=function checkConsent(){// Method 1: Check via ultimateGdpr API
if(window.ultimateGdpr&&typeof window.ultimateGdpr.getConsentGroups==="function"){var consentGroups=window.ultimateGdpr.getConsentGroups();console.log('GDPR consent groups:',consentGroups,'Looking for:',group);setIsConsentGiven(consentGroups.includes(group));return;}// Method 2: Check cookie directly
var getCookie=function getCookie(name){var value="; "+document.cookie;var parts=value.split("; "+name+"=");if(parts.length===2)return parts.pop().split(';').shift();return null;};var groupCookie=getCookie(group);console.log("Cookie "+group+":",groupCookie);if(groupCookie==='true'){setIsConsentGiven(true);return;}// Default: no consent
console.warn("GDPR plugin is not loaded or getConsentGroups is undefined.");setIsConsentGiven(false);};// Listen for consent updates
document.addEventListener("ct-ultimate-gdpr-cookie-update",checkConsent);// Also check every 2 seconds (fallback)
var intervalId=setInterval(checkConsent,2000);// Initial check
checkConsent();return function(){document.removeEventListener("ct-ultimate-gdpr-cookie-update",checkConsent);clearInterval(intervalId);};},[group]);return isConsentGiven?children:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{textAlign:'center',padding:'40px 20px',background:'#f5f5f5',borderRadius:'8px',margin:'20px 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{fontSize:'16px',color:'#333',marginBottom:'15px'}},"Para ver este v\xEDdeo, acepte las cookies de funcionalidad en su configuraci\xF3n de privacidad."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){console.log('Cookie Settings button clicked');// Use jQuery (loaded in index.html)
var $=window.jQuery||window.$||window.ct$;if(!$){console.error('jQuery not found!');return;}console.log('jQuery found, trying to open modal...');// Method 1: Try to trigger the gear icon click
var gearIcon=$('#ct-ultimate-gdpr-cookie-open');console.log('Gear icon found:',gearIcon.length);if(gearIcon.length>0){gearIcon.click();return;}// Method 2: Try the change settings button
var settingsBtn=$('#ct-ultimate-gdpr-cookie-change-settings');console.log('Settings button found:',settingsBtn.length);if(settingsBtn.length>0){settingsBtn.click();return;}// Method 3: Show modal directly
var modal=$('#ct-ultimate-gdpr-cookie-modal');console.log('Modal found:',modal.length);if(modal.length>0){modal.show();$('body').addClass('cookie-modal-open');$('html').addClass('cookie-modal-open');$('#ct-ultimate-gdpr-cookie-open').hide();}else{console.error('Could not find GDPR modal!');}},style:{background:'#6a8ee7',color:'white',border:'none',padding:'12px 24px',borderRadius:'4px',cursor:'pointer',fontSize:'14px',fontWeight:'bold',width:'maxWidth'}},"Configuraci\xF3n de cookies"));};

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var Http=__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({// baseURL: 'https://en.citiesbreak.com',
});/* harmony default export */ __webpack_exports__["a"] = (Http);

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__ = __webpack_require__(4);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SpacielDeals=function(_Component){_inherits(SpacielDeals,_Component);function SpacielDeals(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SpacielDeals);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SpacielDeals.__proto__||Object.getPrototypeOf(SpacielDeals)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SpacielDeals,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==='undefined'?'undefined':_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page align-center page-SpacielDeals'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeSlider */],{isHomeSlider:true,waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeDeals */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__["a" /* default */],null));}}]);return SpacielDeals;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SpacielDeals);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ExporeTelAvivAndJerusalem_css__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ExporeTelAvivAndJerusalem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ExporeTelAvivAndJerusalem_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ExporeTelAvivAndJerusalem=function(_Component){_inherits(ExporeTelAvivAndJerusalem,_Component);function ExporeTelAvivAndJerusalem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ExporeTelAvivAndJerusalem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ExporeTelAvivAndJerusalem.__proto__||Object.getPrototypeOf(ExporeTelAvivAndJerusalem)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ExporeTelAvivAndJerusalem,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==='undefined'?'undefined':_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["d" /* newPosts */]));// get video posts 
var nonVidPosts=posts.filter(function(o,i){return(o.isVid===true||o.forVidPage===true)&&o.isDouble!==true;// return ( o.isVid === true  || o.forVidPage === true) 
});var concertSHtml=nonVidPosts.map(function(o,i){var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url="/Posts/Videos/"+o.ctg+'/'+o.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-ExporeTelAvivAndJerusalem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/posts/bank/page-videos/1.jpg',mobileImg:'/posts/bank/page-videos/M.jpg',cssClass:'telaviv',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'VIDEOS'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:'FYtk8JMMZRE'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},concertSHtml))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return ExporeTelAvivAndJerusalem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ExporeTelAvivAndJerusalem);

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TermsOfUse_css__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TermsOfUse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TermsOfUse_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TermsOfUse=function(_Component){_inherits(TermsOfUse,_Component);function TermsOfUse(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TermsOfUse);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TermsOfUse.__proto__||Object.getPrototypeOf(TermsOfUse)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TermsOfUse,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==='undefined'?'undefined':_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page align-left page-TermsOfUse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'Terms of Use'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'General'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The Israeli Ministry of Tourism (hereinafter- the Ministry) offers the information on this website (hereinafter- the service) subject to your acceptance, with no amendments whatsoever, of the terms, conditions and notifications contained herein. By using the Service you signify your agreement to all such terms, conditions and notifications. Please read these Terms of Use carefully before using the Service. If you do not agree to all these terms, you may not use the Service. The term \u201CUser\u201D as follows shall mean each person who establishes or accesses a connection to the service.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Liability'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The information provided to User is provided for his convenience only. Information that concerns third parties should be verified with the service providers themselves before making a decision based on the information shown.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'It is emphasized that the businesses whose details are provided in the Service are not supervised or reviewed by the Ministry and are not under its responsibility, and the Ministry therefore is not responsible in any way for the service provided to any visitor, including the quality and nature of the physical facilities or the service, the prices charged, the visitor\u2019s satisfaction, etc. The Ministry shall not be held liable for any damage caused to User and/or to any visitor in the course of any visit or use made based on the information provided to him/her by the Service. The information provided to User informs of the existence per se of the businesses (attractions, accommodation, events, etc.) and is not in any way a specific recommendation to use a particular business. Full responsibility for the service is imposed on the service provider. The information provided on the Service may not be construed as endorsement, approval, recommendation or favoring of the use of a particular service or of a visit to a particular site and/or business. The Ministry shall not be held liable for the suitability of the Service to User\u2019s needs. Furthermore, the Ministry shall not be held liable for errors or mistakes in the information provided to User which was not produced by the Ministry but is received from third parties.. User alone is responsible for the way in which he/she uses the Service. The Ministry shall not be held liable for any damage caused to User or to any third party as a direct or indirect result of using the Service, including damage caused due to the use of software applications downloaded directly through the Service or activated as a result of the use of the Service, including Java, JavaScript and ActiveX. For purposes of this section, \u201CThe Ministry\u201D includes its employees and representatives.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Links'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'As part of the Service, the Service may provide links to other websites. The following conditions apply to the use of those links, without derogating from the other conditions in these Terms of Use. The links are provided solely for the convenience of User. Regarding links to external sites which are not owned by the State of Israel (third party sites), unless otherwise stipulated on this Site, no legal or commercial relationship exists between the Ministry and the owners of third party sites, and the Ministry has no control over or right to material found on those sites. The Ministry is not responsible for the content of third party sites and/or for information on commercial or noncommercial products or services offered on them, including the nature or quality thereof. It is recommended to check the information with the service providers or with another relevant party. Links to third party sites may not be construed as endorsement, approval, recommendation or favoring by the State of Israel of those linked-to sites, including documents and other material found on them, of the operators of said sites and of the products or services presented and/or offered on them. At the time each link was included in this Service, the information contained on the linked-to site was found to be compatible with the purposes of the Service and the link itself was functional. However, it is possible that with the passage of time changes have occurred in the linked-to site. If User feels that the linked-to site or material is inappropriate, or if User finds that the link is no longer operational, he/she is requested to inform the Ministry via email at: NitsanI@tourism.gov.il'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Deals/packages'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The Ministry serves as an information channel and is not responsible whatsoever for the packages advertised herein by third commercial parties. Any and all purchases of packages appearing on this page shall not take place on the Ministry\u2019s platform and the purchase shall be performed on the platform of the entity who is advertising the package. Full responsibility for the service is imposed on the service provider and not the Ministry of Tourism. The packages are neither supervised nor reviewed by the Ministry and are not under its responsibility, therefore it is recommended to verify the information with the service providers themselves before making a decision based on the information shown.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Copyright'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The copyrights of the website and its content belong to the Ministry. Subject to copyright law, User may not copy, redistribute, retransmit or publish protected material, without the prior written consent of the Ministry.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Contacting the Ministry'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Any question regarding this Service and other questions relating to the Ministry\u2019s sphere of activity may be addressed directly to the Ministry by email at: NitsanI@tourism.gov.il'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Official Publications of the State of Israel'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'In the event of a conflict or inconsistency between material published in the Service and material appearing in official written publications of the State of Israel, only the material contained in such official publications shall be deemed correct.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Copyright Infringement Notification'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you believe your copyright-protected work was posted on this page without authorization, you may submit a copyright infringement notification by e-mail to nitsani@tourism.gov.il. Notification and requests should be submitted by the copyright owner or an agent authorized to act on the owner\u2019s behalf.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Defamation'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'If you believe that any content uploaded, posted or published on this website is defamatory, please submit your notification by e-mail to NitsanI@tourism.gov.il.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__["a" /* default */],null));}}]);return TermsOfUse;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TermsOfUse);

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThingsToDo_css__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThingsToDo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ThingsToDo_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ThingsToDo=function(_Component){_inherits(ThingsToDo,_Component);function ThingsToDo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ThingsToDo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ThingsToDo.__proto__||Object.getPrototypeOf(ThingsToDo)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ThingsToDo,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==='undefined'?'undefined':_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["d" /* newPosts */]));// get non video posts and culinary posts
var nonVidPosts=posts.filter(function(o,i){// return  o.isVid === false  || o.ctg === 'culinary' || o.isDouble !== true;
return o.isVid===false||o.ctg==='culinary';});var thingsToDoPosts=[].concat(_toConsumableArray(posts));//  const thingsToDoPosts = posts.filter((o , i )=>{
//   return (o.isDouble == false);
// })
var postsHtml=thingsToDoPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-ExporeTelAvivAndJerusalem page-thingsToDo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/posts/bank/page-thingstodo/1.jpg',mobileImg:'/posts/bank/page-thingstodo/M.jpg',cssClass:'jerusalim',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'QU\xC9 HACER'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},postsHtml))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return ThingsToDo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ThingsToDo);

/***/ }),
/* 233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_SimpleSlider_SimpleSlider__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__innerPage_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WhereToGo_css__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WhereToGo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__WhereToGo_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// private class data 
var PageObj1={img:'wtg1.jpg',img_mob:'wtg1-mob.jpg',link:'/Pages/TelAvivPage',text:'TEL AVIV'};var PageObj2={img:'wtg2.jpg',img_mob:'wtg2-mob.jpg',link:'/Pages/JerusalemPage',text:'JERUSALÉN'};var PageObj3={img:'wtg3.jpg',img_mob:'wtg3.jpg',link:'/Pages/DeadSeaPage',text:'EL MAR MUERTO'};var PageObj4={img:'wtg5.jpg',img_mob:'wtg5.jpg',link:'/Pages/NorthPage',text:'EL NORTE'};var PageObj5={img:'wtg4.jpg',img_mob:'wtg4.jpg',link:'/Pages/EilatNegevPage',text:'EILAT Y EL NEGEV'};var PageObj6={img_mob:'wtg6-mob.jpg',link:'/Pages/thingsToDo',text:'QUÉ HACER'};var WhereToGo=function(_Component){_inherits(WhereToGo,_Component);function WhereToGo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WhereToGo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WhereToGo.__proto__||Object.getPrototypeOf(WhereToGo)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0,telAvivVideo:"XDei1Zy_cu4",telAvivVideoState:0,jerusalemVideo:"k4OwoEk5wMw",jerusalemVideoState:0,deadSeaVideo:"DzEJxjnC_UQ",deadSeaVideoState:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WhereToGo,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==='undefined'?'undefined':_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){var _React$createElement;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-whereToGo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'relative'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/posts/bank/page-wheretogo/1.jpg',mobileImg:'/posts/bank/page-wheretogo/M.jpg',cssClass:'jerusalim',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'home-section home-section-padding weather-section',id:'expore-tel-aviv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ac-flex ac-flex-column'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["i" /* HomeTitle */],null,'A DONDE IR'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-row ac-flex ac-flex-row ac-flex-row-mob'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-inner-50 ac-margin-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["k" /* ImgAndText */],{img:PageObj1.img,img_mob:PageObj1.img_mob,cssClass:" col-100",link:PageObj1.link,text:PageObj1.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show_more button',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/TelAvivPage'},'LEE M\xC1S >>')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-inner-50'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["k" /* ImgAndText */],{img:PageObj2.img,img_mob:PageObj2.img_mob,cssClass:" col-100",link:PageObj2.link,text:PageObj2.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show_more button',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/JerusalemPage'},'LEE M\xC1S >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-row ac-flex ac-flex-row ac-flex-row-mob'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-inner-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["k" /* ImgAndText */],{img:PageObj3.img,img_mob:PageObj3.img_mob,cssClass:" col-100",link:PageObj3.link,text:PageObj3.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show_more button',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/DeadSeaPage'},'LEE M\xC1S >>')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-inner-33  ac-margin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["k" /* ImgAndText */],(_React$createElement={img:PageObj4.img,img_mob:PageObj6.img_mob},_defineProperty(_React$createElement,'img_mob',PageObj4.img_mob),_defineProperty(_React$createElement,'cssClass'," col-100"),_defineProperty(_React$createElement,'link',PageObj4.link),_defineProperty(_React$createElement,'text',PageObj4.text),_React$createElement)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show_more button',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/NorthPage'},'LEE M\xC1S >>')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-inner-33'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["k" /* ImgAndText */],{img:PageObj5.img,img_mob:PageObj5.img_mob,cssClass:" col-100",link:PageObj5.link,text:PageObj5.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show_more button',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/EilatNegevPage'},'LEE M\xC1S >>')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-inner-33 show-on-mobile ac-margin'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["k" /* ImgAndText */],{img_mob:PageObj6.img_mob,cssClass:" col-100",link:PageObj6.link,text:PageObj6.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show_more button',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/thingsToDo'},'LEE M\xC1S >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_Footer_Footer__["a" /* default */],null));}}]);return WhereToGo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (WhereToGo);

/***/ }),
/* 235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FAQ=function(_Component){_inherits(FAQ,_Component);function FAQ(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FAQ);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FAQ.__proto__||Object.getPrototypeOf(FAQ)).call.apply(_ref,[this].concat(args))),_this),_this.state={faq:__WEBPACK_IMPORTED_MODULE_3__Data_Data__["c" /* faqData */],telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_this.setCurrentFaq=function(id){var faq=[].concat(_toConsumableArray(_this.state.faq));var current=faq.find(function(o){return o.id===id;});if(current.isOpen===true){current.isOpen=false;}else{current.isOpen=true;}_this.setState({faq:faq});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FAQ,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==='undefined'?'undefined':_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){var _this3=this;var faqHtml=this.state.faq.map(function(o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["e" /* FaqItem */],{q:o.q,answer:o.answer,isOpen:o.isOpen,click:function click(){_this3.setCurrentFaq(o.id);}});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page align-center page-FAQ inner-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'FAQ'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faq-wrapper'},faqHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return FAQ;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FAQ);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TelAvivPage_css__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TelAvivPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TelAvivPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TelAvivPage=function(_Component){_inherits(TelAvivPage,_Component);function TelAvivPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TelAvivPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TelAvivPage.__proto__||Object.getPrototypeOf(TelAvivPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TelAvivPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==='undefined'?'undefined':_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["d" /* newPosts */]));// get non video posts and culinary posts
var telAvivPosts=posts.filter(function(o,i){return(o.ctg==='telaviv'||o.ctg==='telavivAndJerusalem'||o.ctg==='culinarytelaviv')&&o.isDouble!==true;});// const thingsToDoPosts = [ ...posts ];
var postsHtml=telAvivPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-telaviv'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/posts/bank/page-telaviv/1.jpg',mobileImg:'/posts/bank/page-telaviv/M.jpg',cssClass:'telaviv',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'TEL AVIV'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"XDei1Zy_cu4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},postsHtml))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return TelAvivPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TelAvivPage);

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JerusalemPage_css__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JerusalemPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__JerusalemPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var JerusalemPage=function(_Component){_inherits(JerusalemPage,_Component);function JerusalemPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,JerusalemPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=JerusalemPage.__proto__||Object.getPrototypeOf(JerusalemPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(JerusalemPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==='undefined'?'undefined':_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["d" /* newPosts */]));// get non video posts and culinary posts
var jerusalemPosts=posts.filter(function(o,i){return(o.ctg==='jerusalem'||o.ctg==='culinaryjerusalem')&&o.isDouble!==true;});// const thingsToDoPosts = [ ...posts ];
var postsHtml=jerusalemPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-jerusalem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/posts/bank/page-jerusalem/1.jpg',mobileImg:'/posts/bank/page-jerusalem/M.jpg',cssClass:'jerusalim',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'JERUSAL\xC9N'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"nLKWDp5uA-U"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},postsHtml))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return JerusalemPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (JerusalemPage);

/***/ }),
/* 240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CulinaryPage_css__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CulinaryPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CulinaryPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CulinaryPage=function(_Component){_inherits(CulinaryPage,_Component);function CulinaryPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CulinaryPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CulinaryPage.__proto__||Object.getPrototypeOf(CulinaryPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CulinaryPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==='undefined'?'undefined':_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["d" /* newPosts */]));// get non video posts and culinary posts
var culinaryPosts=posts.filter(function(o,i){return(o.ctg==='culinary'||o.ctg==='culinaryjerusalem'||o.ctg==='culinarytelaviv'||o.ctg==='culinarynorth')&&o.isDouble!==true;});// const thingsToDoPosts = [ ...posts ];
var postsHtml=culinaryPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-culinary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/posts/bank/page-culinary/1.jpg',mobileImg:'/posts/bank/page-culinary/M.jpg',cssClass:'telaviv',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'LA CULINARIA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"jfyHxk8ZRrI"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},postsHtml))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return CulinaryPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CulinaryPage);

/***/ }),
/* 242 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DeadSeaPage_css__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DeadSeaPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DeadSeaPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeadSeaPage=function(_Component){_inherits(DeadSeaPage,_Component);function DeadSeaPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DeadSeaPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeadSeaPage.__proto__||Object.getPrototypeOf(DeadSeaPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeadSeaPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==='undefined'?'undefined':_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["d" /* newPosts */]));// get non video posts and culinary posts
var deadseaPosts=posts.filter(function(o,i){return o.ctg==='deadsea'&&o.isDouble!==true;});// const thingsToDoPosts = [ ...posts ];
var postsHtml=deadseaPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-deadsea'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'EL MAR MUERTO'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"8p4qfkneH1c"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},postsHtml))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return DeadSeaPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DeadSeaPage);

/***/ }),
/* 244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TouristInfoPage_css__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TouristInfoPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TouristInfoPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TouristInfoPage=function(_Component){_inherits(TouristInfoPage,_Component);function TouristInfoPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TouristInfoPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TouristInfoPage.__proto__||Object.getPrototypeOf(TouristInfoPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TouristInfoPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==='undefined'?'undefined':_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["b" /* TouristInfoPosts */]));// get non video posts and culinary posts
var telAvivPosts=posts.filter(function(o,i){return o.ctg==='TouristInfo';});// const thingsToDoPosts = [ ...posts ];
var postsHtml=telAvivPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-touristinfo'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/posts/bank/page-tourist/1.jpg',mobileImg:'/posts/bank/page-tourist/M.jpg',cssClass:'telaviv',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'INFORMACI\xD3N TUR\xCDSTICA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"XDei1Zy_cu4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},postsHtml))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return TouristInfoPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TouristInfoPage);

/***/ }),
/* 246 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EilatNegevPage_css__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EilatNegevPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__EilatNegevPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EilatNegevPage=function(_Component){_inherits(EilatNegevPage,_Component);function EilatNegevPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EilatNegevPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EilatNegevPage.__proto__||Object.getPrototypeOf(EilatNegevPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EilatNegevPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==='undefined'?'undefined':_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["d" /* newPosts */]));// get non video posts and culinary posts
var eilatnegevPosts=posts.filter(function(o,i){return o.ctg==='eilat-negev'&&o.isDouble!==true;});// const thingsToDoPosts = [ ...posts ];
var postsHtml=eilatnegevPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-eilatnegev'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'EILAT Y EL NEGEV'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"ZdnNT-GDJv4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},postsHtml))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return EilatNegevPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (EilatNegevPage);

/***/ }),
/* 248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NorthPage_css__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NorthPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__NorthPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NorthPage=function(_Component){_inherits(NorthPage,_Component);function NorthPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NorthPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NorthPage.__proto__||Object.getPrototypeOf(NorthPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NorthPage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==='undefined'?'undefined':_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){// get all posts 
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["d" /* newPosts */]));// get non video posts and culinary posts
var northPosts=posts.filter(function(o,i){return(o.ctg==='north'||o.ctg==='culinarynorth')&&o.isDouble!==true;});// const thingsToDoPosts = [ ...posts ];
var postsHtml=northPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+'/'+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});console.log('northposts ',northPosts);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-page align-center page-north'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'live-shows-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["i" /* HomeTitle */],null,'EL NORTE'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:"fZ_WdHpHRT8"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'live-shows-wrapper'},postsHtml))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return NorthPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NorthPage);

/***/ }),
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CoronaVirus_css__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CoronaVirus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CoronaVirus_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CoronaVirus=function(_Component){_inherits(CoronaVirus,_Component);function CoronaVirus(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CoronaVirus);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CoronaVirus.__proto__||Object.getPrototypeOf(CoronaVirus)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CoronaVirus,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==='undefined'?'undefined':_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page align-left page-Corona-virus'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Durante estos tiempos dif\xEDciles, en Israel estamos con vosotros, los espa\xF1oles, rezando y apoyando, unidos por la esperanza de un ma\xF1ana m\xE1s positivo y mejor.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'ac-pink'},'ULTIMAS NOTICIAS PARA TURISTAS CON DESTINO A ISRAEL SOBRE EL CORONAVIRUS (COVID-19) :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'ac-pink ac-margin-top-1 ac-bigger'},'Turistas que desean',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{className:'show-on-mobile'}),' viajar a Israel:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'ac-align-left-15'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'En este momento y hasta nuevo aviso,'),' queda prohibida la entrada a Israel para no-ciudadanos o residentes de Israel que vienen de cualquier parte del mundo. En casos excepcionales, se puede pedir la aprobaci\xF3n del Ministerio de Exteriores demostrando que se puede estar auto-aislado durante 14 d\xEDas.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'ac-pink ac-bigger'},' Reglas generales para todos',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{className:'show-on-mobile'}),' los que se encuentren en Israel:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Para obtener las \xFAltimas noticias de casos de coronavirus en Israel, visite la p\xE1gina del Departamento de Salud. ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://govextra.gov.il/ministry-of-health/corona/corona-virus-en/',target:'_blank'},'website'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'El gobierno israel\xED est\xE1 supervisando el brote de cerca y ha implementado medidas temporales como restricciones en las fronteras para viajeros de todo el mundo.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Las personas que muestren s\xEDntomas, no pueden acompa\xF1ar a pacientes o visitar residencias de ancianos.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'ac-pink'},'\xA1Importante! '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Si se le ha exigido el auto aislamiento, ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,', debe informarlo al Ministerio de Salud: '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://govforms.gov.il/mw/forms/HouseIsolation%40health.gov.il?displang=en',target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'www.govforms.gov.il/')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Si tiene 38\xBAC o m\xE1s de fiebre, tos, dificultad para respirar, o alg\xFAn otro s\xEDntoma respiratorio, ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'ac-pink'},'hay que auto-aislarse inmediatamente y llamar al 101, l\xEDnea directa de los Servicios de Emergencia de MDA para indicaciones m\xE9dicas.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'ac-pink'},'\xA1Est\xE1 completamente prohibido entrar en cl\xEDnicas u hospitales si muestra alguno de los s\xEDntomas descritos!'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'ac-pink'},'Preguntas frecuentes sobre Covid19'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',{start:'1',className:'ac-padding-start'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',{start:'1',className:'ac-padding-start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'ac-pink'},'Soy un turista en Israel y creo que podr\xEDa tener el COVID-19, \xBFA d\xF3nde debo acudir?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'Si tienes 38\xBAC o m\xE1s de fiebre, tos, dificultad para respirar u otros problemas respiratorios, debes auto aislarte inmediatamente y llamar a la l\xEDnea directa de 101 de Servicios de Urgencia de MDA para indicaciones m\xE9dicas.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'ac-pink'},'No acudas a una cl\xEDnica o sala de urgencias.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',{className:'ac-pink'},'\xBFCu\xE1ndo volver\xE1 a aceptar Israel a visitantes de fuera'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'En este momento no hay fecha conocida en la que Israel volver\xE1 a permitir la entrada a los visitantes extranjeros.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["j" /* Img */],{desktopImg:"infection.jpg"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__["a" /* default */],null));}}]);return CoronaVirus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CoronaVirus);

/***/ }),
/* 252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Posts_css__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Posts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Posts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Videos_css__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Videos_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Videos_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PostsData__ = __webpack_require__(49);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VideoPosts=function(_Component){_inherits(VideoPosts,_Component);function VideoPosts(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VideoPosts);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VideoPosts.__proto__||Object.getPrototypeOf(VideoPosts)).call.apply(_ref,[this].concat(args))),_this),_this.state={id:_this.props.match.params.vidId,ctgId:_this.props.match.params.ctgId},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VideoPosts,[{key:'componentWillMount',value:function componentWillMount(){}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'render',value:function render(){var _this2=this;console.log('ctgId:',this.state.ctgId);var counter=0;var videosHtml=null;var mixVideos=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9__PostsData__["b" /* newPostdata */]));var shuffleData=Object(__WEBPACK_IMPORTED_MODULE_4__Utility_Utility__["i" /* shuffle */])(mixVideos);console.log('shuffleData:',typeof shuffleData==='undefined'?'undefined':_typeof(shuffleData));var current=__WEBPACK_IMPORTED_MODULE_9__PostsData__["b" /* newPostdata */].find(function(o){if(_this2.props.match.params.ctgId!=undefined){if(o.hasOwnProperty("ctg")){return o.id===_this2.state.id&&o.ctg===_this2.state.ctgId;}}});if(this.props.match.params.ctgId!=undefined){videosHtml=shuffleData.map(function(o,i){if(o.hasOwnProperty("ctg")){if(o.ctg===_this2.props.match.params.ctgId){var postFromPostData=__WEBPACK_IMPORTED_MODULE_5__Data_Data__["d" /* newPosts */].find(function(obj,index){return obj.id===o.id&&obj.ctg===o.ctg;});console.log('postFromPostData',postFromPostData);if(postFromPostData!=undefined&&postFromPostData.id!==current.id){counter++;if(counter<=3){var component=null;var url="/Posts/Videos/"+o.ctg+"/"+o.id;if(o.isVid===true){component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:postFromPostData.title,desc:postFromPostData.sml_desc,img:postFromPostData.side_img,link:url});}else{url="/Posts/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:postFromPostData.title,desc:postFromPostData.sml_desc,img:postFromPostData.side_img,link:url});}return component;}}}else if(o.ctg==='culinary'||o.ctg==='culinaryjerusalem'||o.ctg==='culinarytelaviv'||o.ctg==='culinarynorth'){var _postFromPostData=__WEBPACK_IMPORTED_MODULE_5__Data_Data__["d" /* newPosts */].find(function(obj,index){return obj.id===o.id&&obj.ctg===o.ctg;});console.log('postFromPostData',_postFromPostData);if(_postFromPostData!=undefined&&_postFromPostData.id!==current.id){counter++;if(counter<=3){var _component=null;var _url="/Posts/Videos/"+o.ctg+"/"+o.id;if(o.isVid===true){_component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:_postFromPostData.title,desc:_postFromPostData.sml_desc,img:_postFromPostData.side_img,link:_url});}else{_url="/Posts/"+o.ctg+"/"+o.id;_component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:_postFromPostData.title,desc:_postFromPostData.sml_desc,img:_postFromPostData.side_img,link:_url});}return _component;}}}}});}var html=null;if(current!=undefined){console.log("current",current);var vidHTML=null;var smlTitle=null;var title=null;if(current.isVid===true){vidHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:current.vidId});}title=current.title;var smltitle=current.hasOwnProperty("smltitle")?current.smltitle:current.smlTitle;var titleHTML=null;var smlTitleHTML=null;if(smltitle!==''){titleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'page-section-big-title'},title);smlTitleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["i" /* HomeTitle */],null,smltitle);}else{titleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'page-section-big-title'});smlTitleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["i" /* HomeTitle */],null,title);}html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-post post post-type-videos inner-post-'+current.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'post-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-post-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["j" /* Img */],{desktopImg:current.bgImage,mobileImg:current.mobBgImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container align-center white'},titleHTML)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-75'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},smlTitleHTML,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),vidHTML,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'html-wrapper',dangerouslySetInnerHTML:current.html()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["g" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-25 sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["i" /* HomeTitle */],null,'V\xCDDEO RELACIONADO:'),videosHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Footer_Footer__["a" /* default */],null));}return html;}}]);return VideoPosts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(VideoPosts));

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Loader_Loader__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Posts_css__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Posts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Posts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PostsData__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConcertsPosts=function(_Component){_inherits(ConcertsPosts,_Component);function ConcertsPosts(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ConcertsPosts);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ConcertsPosts.__proto__||Object.getPrototypeOf(ConcertsPosts)).call.apply(_ref,[this].concat(args))),_this),_this.state={id:_this.props.match.params.id},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ConcertsPosts,[{key:'componentWillMount',value:function componentWillMount(){}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'render',value:function render(){var _this2=this;var counter=0;var currDate=new Date();var videosHtml=Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["i" /* shuffle */])(__WEBPACK_IMPORTED_MODULE_6__Data_Data__["f" /* showsArr */]).map(function(o,i){var cssClass='';var isTodayBigger=Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["b" /* compareDates */])(currDate,o.date);counter++;if(counter<=3&&!isTodayBigger===true){var url="/Posts/Concerts/"+o.id;if(url==="/Posts/Concerts/undefined"){cssClass="no-inner-page";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["c" /* ConcertSliderItem */],{key:i,title:o.title,desc:o.date,img:o.img,link:url,cssClass:cssClass});}else{counter--;}});var current=__WEBPACK_IMPORTED_MODULE_9__PostsData__["a" /* ShowsPostsData */].find(function(o){return o.id==_this2.props.match.params.id;});var html=null;if(current!=undefined){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-post post post-type-Concerts inner-post-'+current.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'post-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-post-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* Img */],{desktopImg:current.bgImage,mobileImg:current.mobBgImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container align-center white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'page-section-big-title'},current.title))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-75'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'html-wrapper',dangerouslySetInnerHTML:current.html()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["g" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-25 sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* HomeTitle */],null,'VIVIR EN ISRAEL'),videosHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Footer_Footer__["a" /* default */],null));}return html;}}]);return ConcertsPosts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(ConcertsPosts));

/***/ }),
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Posts_css__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Posts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Posts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Posts_css__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Posts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Posts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PostsData__ = __webpack_require__(49);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Posts=function(_Component){_inherits(Posts,_Component);function Posts(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Posts);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Posts.__proto__||Object.getPrototypeOf(Posts)).call.apply(_ref,[this].concat(args))),_this),_this.state={id:_this.props.match.params.vidId,ctgId:_this.props.match.params.ctgId},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Posts,[{key:'componentWillMount',value:function componentWillMount(){// console.log(this.props.match.params)
}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'render',value:function render(){var _this2=this;var counter=0;var videosHtml=null;var mixVideos=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9__PostsData__["b" /* newPostdata */]));var limitRelatedPost=3;// alert(this.props.match.params.id);
if(this.props.match.params.id==="34"){limitRelatedPost=2;}var shuffleData=Object(__WEBPACK_IMPORTED_MODULE_4__Utility_Utility__["i" /* shuffle */])(mixVideos);var current=__WEBPACK_IMPORTED_MODULE_9__PostsData__["b" /* newPostdata */].find(function(o){if(_this2.props.match.params.ctgId!=undefined){if(o.hasOwnProperty("ctg")){// console.log('o' , o);
return o.id==_this2.props.match.params.id&&o.ctg==_this2.props.match.params.ctgId;}}else{return o.id===_this2.props.match.params.id;}});console.log("current",current);if(this.props.match.params.ctgId!=undefined){videosHtml=shuffleData.map(function(o,i){if(o.hasOwnProperty("ctg")){// if (  o.ctg === this.props.match.params.ctgId  && parseInt(o.id) !== parseInt(this.props.match.params.id) ) {
if(o.ctg===_this2.props.match.params.ctgId){var postFromPostData=__WEBPACK_IMPORTED_MODULE_5__Data_Data__["d" /* newPosts */].find(function(obj,index){return obj.id===o.id&&obj.ctg===o.ctg;});console.log('postFromPostData',postFromPostData);if(postFromPostData!=undefined&&postFromPostData.id!==current.id){counter++;if(counter<=limitRelatedPost){var component=null;var url="/Posts/Videos/"+o.ctg+"/"+o.id;if(o.isVid===true){component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:postFromPostData.title,desc:postFromPostData.sml_desc,img:postFromPostData.img,link:url});}else{url="/Posts/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:postFromPostData.title,desc:postFromPostData.sml_desc,img:postFromPostData.img,link:url});}return component;}}}if(o.ctg===_this2.props.match.params.ctgId){var postFromTouristData=__WEBPACK_IMPORTED_MODULE_5__Data_Data__["b" /* TouristInfoPosts */].find(function(obj,index){return obj.id===o.id&&obj.ctg===o.ctg;});console.log('postFromTouristData',postFromTouristData);if(postFromTouristData!=undefined){counter++;if(counter<=limitRelatedPost){var _component=null;var _url="/Posts/Videos/"+o.ctg+"/"+o.id;if(o.isVid===true){_component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["q" /* VideoSliderItem */],{key:i,title:postFromTouristData.title,desc:postFromTouristData.sml_desc,img:postFromTouristData.img,link:_url});}else{_url="/Posts/"+o.ctg+"/"+o.id;_component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["n" /* PostSliderItem */],{key:i,title:postFromTouristData.title,desc:postFromTouristData.sml_desc,img:postFromTouristData.img,link:_url});}return _component;}}}}});}var html=null;var smlTitle=null;var title=null;if(current!=undefined){console.log('success');var vidHTML=null;if(current.isVid===true){vidHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:current.vidId});}var _title=current.title;var smltitle=current.hasOwnProperty("smltitle")?current.smltitle:current.smlTitle;var titleHTML=null;var smlTitleHTML=null;if(smltitle!==''){titleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'page-section-big-title'},_title);smlTitleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["i" /* HomeTitle */],null,smltitle);}else{titleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'page-section-big-title'});smlTitleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["i" /* HomeTitle */],null,_title);}// client custom req
console.log('this.state',this.state);// if ( current.id === 5 ) {
//   titleHTML = '';
// }
html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-post post post-type-videos post-type-posts inner-post-'+current.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'post-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-post-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["j" /* Img */],{desktopImg:current.bgImage,mobileImg:current.mobBgImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container align-center white'},titleHTML)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-75'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},smlTitleHTML,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),vidHTML,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'html-wrapper',dangerouslySetInnerHTML:current.html()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["g" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-25 sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["i" /* HomeTitle */],null,'Art\xEDculos Relacionados'),videosHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Footer_Footer__["a" /* default */],null));}return html;}}]);return Posts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Posts));

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lazyload__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactjs_popup__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Components_Loader_Loader__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Gallery_css__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Gallery_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Gallery_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GalleryTA=function(_Component){_inherits(GalleryTA,_Component);function GalleryTA(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GalleryTA);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GalleryTA.__proto__||Object.getPrototypeOf(GalleryTA)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,instagramData:[],instagramDataMobile:[],instagramId:null,instagramUserImg:null,instagramCaption:null,instagramUserName:null,instagramLikes:null,waterTemp:0,jerusalemWeather:0,open:false,isInstaOpen:false,openInstagram:false,id:null,isLoader:false,ctg:'',galleryId:'',relatedGalery:[{title:'TEL AVIV',cityId:'ta'},{title:'DEAD SEA',cityId:'deadsea'},{title:'JERUSALEM',cityId:'ja'},{title:'EILAT',cityId:'eilat'},{title:'NEGEV',cityId:'negev'},{title:'CAESAREA',cityId:'caesarea'},{title:'HAIFA',cityId:'haifa'},{title:'CULINARY',cityId:'culinary'},{title:'GALILEE',cityId:'galilee'},{title:'YOUR PHOTOS FROM ISRAEL',cityId:'yp'}]},_this.OpenLoader=function(){_this.setState({isLoader:true});console.log('LOADERLOADERLOADER:',_this.state.isLoader);},_this.openModel2=function(id){_this.setState({isLoader:true});// var url ='https://view.activated.co.il/twocities/de/instagram-api.php?ID=' + id; 
// var url = 'https://www.instagram.com/p/' + id; 
// window.open(url);
setTimeout(function(){var url=Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'instagram-api.php?ID='+id;var url='https://en.citiesbreak.com/instagram-api.php?ID='+id;// var url = 'https://new.goisrael.com/eu/instagram-api.php?ID=' + id; 
console.log('id:',id);// alert(url);
// var url = 'https://www.instagram.com/p/'+id+'/?tagged=takeme2telaviv&__a=1';
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url,{}).then(function(res){var obj=res.data;_this.setState({isLoader:false});if(obj==null){var url='https://www.instagram.com/p/'+id;window.open(url);}else{var userinfo=obj.graphql.shortcode_media;var likes=userinfo.edge_media_preview_like.count;var username=userinfo.owner.username;var caption=userinfo.edge_media_to_caption.edges[0].node.text;var userProfileImg=userinfo.owner.profile_pic_url;console.log(username);_this.setState({isInstaOpen:true,instagramId:id,instagramUserImg:userProfileImg,instagramCaption:caption,instagramUserName:username,instagramLikes:likes});}});},2000);},_this.openModal=function(id,ctg){_this.setState({open:true,ctg:ctg,id:id});},_this.closeModal=function(){_this.setState({open:false});},_this.closeModal2=function(){_this.setState({isInstaOpen:false});},_this.updateDimensions=function(){var w=window,d=document,documentElement=d.documentElement,body=d.getElementsByTagName('body')[0],width=w.innerWidth||documentElement.clientWidth||body.clientWidth;// height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;
_this.setState({width:width});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GalleryTA,[{key:'componentWillMount',value:function componentWillMount(){this.updateDimensions();}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('scroll',this.handleScroll);window.removeEventListener('resize',this.updateDimensions);}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var galleryId='noGalleryId';var videoId='';var cityName='';var stopLoopAt=32;console.log(this.props);if(this.props.match.params.galleryId!==undefined){galleryId=this.props.match.params.galleryId;if(galleryId==='ja'){videoId='V0Acsw3Hf_M';stopLoopAt=32;cityName='JERUSALEM';}else if(galleryId==='ta'){videoId='5nqL-oIC0GA';stopLoopAt=28;cityName='TEL AVIV';}else if(galleryId==='deadsea'){videoId='M627s8TdaB8';stopLoopAt=13;cityName='DEAD SEA';}else if(galleryId==='eilat'){videoId='ZdnNT-GDJv4';stopLoopAt=17;cityName='EILAT';}else if(galleryId==='caesarea'){videoId='eLZ433_S6HI';stopLoopAt=4;cityName='CAESAREA';}else if(galleryId==='negev'){videoId='XxWa_MNm5x8';stopLoopAt=17;cityName='NEGEV';}else if(galleryId==='haifa'){videoId='3ahATaKkhBk';stopLoopAt=17;cityName='HAIFA';}else if(galleryId==='culinary'){videoId='JQD9JpMaw9g';stopLoopAt=13;cityName='CULINARY';}else if(galleryId==='galilee'){videoId='ImobrsxsKl8';stopLoopAt=17;cityName='GALILEE';}else if(galleryId==='markets'){videoId='2CSCe2WC7Ns';stopLoopAt=13;cityName='MARKETS';}else if(galleryId==='yp'){videoId='M627s8TdaB8';stopLoopAt=102;cityName='YOUR PHOTOS FROM ISRAEL';}}Promise.all([Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["a" /* asyncgetWeather */])(),Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["c" /* geinstagramData */])()]).then(function(response){var weather=response[0];var instagramData=response[1];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==='undefined'?'undefined':_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({instagramData:instagramData.posts,jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({instagramData:instagramData.posts,jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({instagramData:instagramData.posts,jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});}},{key:'render',value:function render(){var _this3=this;// let count  = 30;
var gallery=[];for(var i=1;i<=32;i++){gallery.push({id:i});};var sliderSettings={dots:false,autoplay:true,// lazyLoad: 'ondemand',
infinite:true,lazyLoad:"ondemand",cssEase:'linear',slidesToShow:3,slidesToScroll:3,responsive:[{breakpoint:1000,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:600,settings:{slidesToShow:2,slidesToScroll:1}}]};var singleGalleryImg='';var singleGalleryImgMob='';var galleryHtml='';var galleryHtml2='';var galleryHtml3='';var galleryHtml4='';var galleryHtml5='';var galleryHtml6='';var galleryHtml7='';var galleryHtml8='';var galleryHtml9='';var galleryHtml10='';var stopLoopAt='';var finatlHtmlToRender='';var videoId='';var relatedGaleryHtml=null;{/*let cover = <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />;*/}var cover=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["d" /* CoverSection */],{desktopImg:'/posts/bank/page-gallery/1.jpg',mobileImg:'/posts/bank/page-gallery/M.jpg',cssClass:'telaviv',waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather});var cityName='';var cssClass='';var instagramHtml=null;var bigImgPath="gallery/ta/big/"+this.state.id+".jpg";if(this.state.ctg==='ja'){bigImgPath="gallery/ja/big/"+this.state.id+".jpg";}else if(this.state.ctg==='deadsea'){bigImgPath="gallery/deadsea/big/"+this.state.id+".jpg";}else if(this.state.ctg==='eilat'){bigImgPath="gallery/eilat/big/"+this.state.id+".jpg";}else if(this.state.ctg==='caesarea'){bigImgPath="gallery/caesarea/big/"+this.state.id+".jpg";}else if(this.state.ctg==='negev'){bigImgPath="gallery/negev/big/"+this.state.id+".jpg";}else if(this.state.ctg==='haifa'){bigImgPath="gallery/haifa/big/"+this.state.id+".jpg";}else if(this.state.ctg==='culinary'){bigImgPath="gallery/culinary/big/"+this.state.id+".jpg";}else if(this.state.ctg==='galilee'){bigImgPath="gallery/galilee/big/"+this.state.id+".jpg";}else if(this.state.ctg==='markets'){bigImgPath="gallery/markets/big/"+this.state.id+".jpg";}if(this.props.match.params.galleryId===undefined){var instagramData=this.state.instagramData;var size=1;// if ( this.state.width < 600 ) {
//     size = 4;
// }
if(instagramData.length>0){while(instagramData.length>0){this.state.instagramDataMobile.push(instagramData.splice(0,size));}}if(this.state.instagramDataMobile.length>0){instagramHtml=this.state.instagramDataMobile.map(function(arr,i){return arr.map(function(o,i){var imgLink="instagram/"+o.id+".jpg";if(_this3.state.width<600){imgLink="instagram/Mobile/"+o.id+".jpg";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:o.id,onClick:function onClick(){_this3.openModel2(o.id);}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["l" /* InstagremSliderItem */],{title:o.publishBy,cssClass:'InstagremSliderItem-'+i,img:"instagram/"+o.id+".jpg"}));});});// console.log('instagramHtml2' , instagramHtml2);
instagramHtml=instagramHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i},o);});}var _currentInstagramLikeUrl='https://www.instagram.com/p/'+this.state.instagramId+'/';var _currentInstagramUrl='https://www.instagram.com/'+this.state.instagramUserName+'/';var _currentInstagramImgUrl="instagram/"+this.state.instagramId+".jpg";// alert('currentInstagramImgUrl : ' +currentInstagramImgUrl);
// alert('currentInstagramUrl : ' +currentInstagramUrl);
// alert('currentInstagramLikeUrl : ' +currentInstagramLikeUrl);
galleryHtml=gallery.map(function(o,i){console.log(o);var cssClass='col';if(i%3===0){cssClass+=" first ";}if(i<=28){var imgPath="gallery/ta/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'ta');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml2=gallery.map(function(o,i){var cssClass='col';if(i<=32){var imgPath="gallery/ja/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'ja');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml3=gallery.map(function(o,i){var cssClass='col';if(i<=13){var imgPath="gallery/deadsea/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'deadsea');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml4=gallery.map(function(o,i){var cssClass='col';if(i<=17){var imgPath="gallery/eilat/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'eilat');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml5=gallery.map(function(o,i){var cssClass='col';if(i<=4){var imgPath="gallery/caesarea/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'caesarea');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml6=gallery.map(function(o,i){var cssClass='col';if(i<=17){var imgPath="gallery/negev/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'negev');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml7=gallery.map(function(o,i){var cssClass='col';if(i<=5){var imgPath="gallery/haifa/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'haifa');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml8=gallery.map(function(o,i){var cssClass='col';if(i<=13){var imgPath="gallery/culinary/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'culinary');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml9=gallery.map(function(o,i){var cssClass='col';if(i<=17){var imgPath="gallery/galilee/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'galilee');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});galleryHtml10=gallery.map(function(o,i){var cssClass='col';if(i<=13){var imgPath="gallery/markets/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,'markets');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});finatlHtmlToRender=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'post-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner',id:'instagram'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,'SUS FOTOS DE ISRAEL'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},instagramHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/yp'},'MUESTRA TODAS >>')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner',id:'tel-aviv-gallery'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/ta'},'TEL AVIV')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/ta'},'MUESTRA TODAS >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/ja'},'JERUSAL\xC9N')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/ja'},'MUESTRA TODAS >>')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/deadsea'},'EL MAR MUERTO')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml3)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/deadsea'},'MUESTRA TODAS >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/eilat'},'EILAT')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml4)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/eilat'},'MUESTRA TODAS >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/caesarea'},'CAESAREA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml5)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/caesarea'},'MUESTRA TODAS >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/negev'},'EL NEGEV')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml6)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/negev'},'MUESTRA TODAS >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/haifa'},'HAIFA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml7)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/haifa'},'MUESTRA TODAS >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/culinary'},'CULINARIA')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml8)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/culinary'},'MUESTRA TODAS >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/galilee'},'EL GALILEE')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml9)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/galilee'},'MUESTRA TODAS >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/markets'},'LOS MERCADOS')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml10)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'button show_more',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery/markets'},'MUESTRA TODAS >>')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactjs_popup__["a" /* default */],{open:this.state.isInstaOpen,closeOnDocumentClick:true,onClose:this.closeModal2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'close',onClick:this.closeModal2},'\xD7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userImgInstagram'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:_currentInstagramImgUrl})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-info-instagram'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:_currentInstagramUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userProfileImgWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.state.instagramUserImg})),'@',this.state.instagramUserName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instagramCaption'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.state.instagramCaption!=null?Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["h" /* limitText */])(this.state.instagramCaption,130):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:_currentInstagramLikeUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'like-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:"like.png"}))))));__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactjs_popup__["a" /* default */],{open:this.state.open,closeOnDocumentClick:true,onClose:this.closeModal2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'close',onClick:this.closeModal2},'\xD7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userImgInstagram'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:_currentInstagramImgUrl})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-info-instagram'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:_currentInstagramUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userProfileImgWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.state.instagramUserImg})),'@',this.state.instagramUserName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instagramCaption'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.state.instagramCaption!=null?Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["h" /* limitText */])(this.state.instagramCaption,130):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:_currentInstagramLikeUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'like-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:"like.png"})))));}else{var galleryId=this.state.galleryId;var imgToShow='';if(galleryId==='ta'){imgToShow='1.jpg';}else if(galleryId==='ja'){imgToShow='4.jpg';}else if(galleryId==='deadsea'){imgToShow='6.jpg';}else if(galleryId==='eilat'){imgToShow='1.jpg';}console.log('weoking1');if(galleryId==='ta'||galleryId==='deadsea'||galleryId==='ja'||galleryId==='eilat'||galleryId==='negev'||galleryId==='caesarea'||galleryId==='haifa'||galleryId==='galilee'||galleryId==='culinary'||galleryId==='markets'){console.log('weoking');cover=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:'gallery/'+'/ctg/Main/'+galleryId+'.jpg',mobileImg:'gallery/'+'/ctg/Mobile/'+galleryId+'.jpg'});bigImgPath="gallery/"+galleryId+"/big/"+this.state.id+".jpg";galleryHtml=gallery.map(function(o,i){var cssClass='col';if(_this3.state.stopLoopAt%3!=0&&i===_this3.state.stopLoopAt-1){// cssClass += ' last';
cssClass+=' ';}if(i<=_this3.state.stopLoopAt){var imgPath="gallery/"+galleryId+"/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,key:o.id,onClick:function onClick(){_this3.openModal(o.id,galleryId);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));}});}else if(galleryId==='yp'){// console.log("this.props.match.params.galleryId 10_10 :", this.props.match.params.galleryId);
cover=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:'gallery/ctg/Main/'+galleryId+'.jpg',mobileImg:'gallery/'+'ctg/Mobile/'+galleryId+'.jpg'});galleryHtml=this.state.instagramData.map(function(o,i){var obj_id=o.id;var obj_publishBy=o.publishBy;// console.log('OOOOO:', o);
// return arr.map((o , i) =>  {
var imgLink="instagram/"+o.id+".jpg";if(_this3.state.width<600){imgLink="instagram/Mobile/"+o.id+".jpg";}// console.log('imgLink' , imgLink);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-wrapper-img-instagram',onClick:function onClick(){console.log('obj_id:',obj_id);_this3.openModel2(obj_id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:imgLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-wrapper-publish-by'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'ac-publish-by'},'@',obj_publishBy)));// });
});// console.log('instagramHtml2' , instagramHtml2);
galleryHtml=galleryHtml.map(function(o,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i},o);});}relatedGaleryHtml=this.state.relatedGalery.map(function(o,i){var link='/Pages/Gallery/'+o.cityId;if(o.cityId!==galleryId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["f" /* GallerSideBarItem */],{key:i,title:o.title,link:link,img:'gallery/'+'/ctg/'+o.cityId+'.jpg'});}});finatlHtmlToRender=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'post-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-75'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-100'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,this.state.cityName),this.state.galleryId==='yp'?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["o" /* ResponsiveYouTubeIframe */],{vidId:this.state.videoId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},galleryHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-25 sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* HomeTitle */],null,'GALERIE'),relatedGaleryHtml,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'show_more button',href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+'Pages/Gallery'},'MUESTRA TODAS >>'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})));}var currentInstagramUrl='https://www.instagram.com/'+this.state.instagramUserName+'/';var currentInstagramImgUrl="instagram/"+this.state.instagramId+".jpg";var currentInstagramLikeUrl='https://www.instagram.com/p/'+this.state.instagramId+'/';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"page align-center page-Gallery inner-post gallery-"+this.state.galleryId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Components_Menu_Menu__["a" /* default */],null),cover,finatlHtmlToRender,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactjs_popup__["a" /* default */],{open:this.state.open,closeOnDocumentClick:true,onClose:this.closeModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'close',onClick:this.closeModal},'\xD7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:bigImgPath}))),this.state.isLoader===true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-wrapper-loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Components_Loader_Loader__["a" /* default */],null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactjs_popup__["a" /* default */],{open:this.state.isInstaOpen,closeOnDocumentClick:true,onClose:this.closeModal2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'close',onClick:this.closeModal2},'\xD7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userImgInstagram'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:currentInstagramImgUrl})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'user-info-instagram'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:currentInstagramUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'userProfileImgWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.state.instagramUserImg})),'@',this.state.instagramUserName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'instagramCaption'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.state.instagramCaption!=null?Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["h" /* limitText */])(this.state.instagramCaption,130):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',href:currentInstagramLikeUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'like-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["j" /* Img */],{desktopImg:"like.png"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Components_Footer_Footer__["a" /* default */],null));}}]);return GalleryTA;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(GalleryTA));

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_reactjs_popup__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_Menu_Menu__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_Footer_Footer__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Gallery_css__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Gallery_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Gallery_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GalleryJA=function(_Component){_inherits(GalleryJA,_Component);function GalleryJA(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GalleryJA);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GalleryJA.__proto__||Object.getPrototypeOf(GalleryJA)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0,open:false,id:null},_this.openModal=function(id){_this.setState({open:true,id:id});},_this.closeModal=function(){_this.setState({open:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GalleryJA,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_4__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];_this2.setState({jerusalemWeather:weather.jerusalem.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.telaviv.water_temp});});window.addEventListener("resize",this.updateDimensions);}},{key:'render',value:function render(){var _this3=this;var count=26;var gallery=[];for(var i=1;i<=count;i++){gallery.push({id:i});};var galleryHtml=gallery.map(function(o,i){var cssClass='col col-30';if(i%3===0){cssClass+=" first ";}var imgPath="gallery/JA/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,onClick:function onClick(){_this3.openModal(o.id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:imgPath}));});var bigImgPath="gallery/JA/big/"+this.state.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page align-center page-Gallery inner-post'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'post-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["h" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-75'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["i" /* HomeTitle */],null,'JERUSAL\xC9N'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-html-wrapper'},galleryHtml))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_reactjs_popup__["a" /* default */],{open:this.state.open,closeOnDocumentClick:true,onClose:this.closeModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'modal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'close',onClick:this.closeModal},'\xD7'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* Img */],{desktopImg:bigImgPath})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_Footer_Footer__["a" /* default */],null));}}]);return GalleryJA;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(GalleryJA));

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.6e58f178.js